 export const cidsRaw = String.raw`
 A00.0 Cólera devida a Vibrio cholerae 01, biótipo cholerae
A00.1 Cólera devida a Vibrio cholerae 01, biótipo El Tor
A00.9 Cólera não especificada
A01.0 Febre tifóide
A01.1 Febre paratifóide A
A01.2 Febre paratifóide B
A01.3 Febre paratifóide C
A01.4 Febre paratifóide não especificada
A02.0 Enterite por salmonela
A02.1 Septicemia por salmonela
A02.2+Infecções localizadas por salmonela
A02.8 Outras infecções especificadas por salmonela
A02.9 Infecção não especificada por salmonela
A03.0 Shiguelose devida a Shigella dysenteriae
A03.1 Shiguelose devida a Shigella flexneri
A03.2 Shiguelose devida a Shigella boydii
A03.3 Shiguelose devida a Shigella sonnei
A03.8 Outras shigueloses
A03.9 Shiguelose não especificada
A04.0 Infecção por Escherichia coli enteropatogênica
A04.1 Infecção por Escherichia coli enterotoxigênica
A04.2 Infecção por Escherichia coli enteroinvasiva
A04.3 Infecção por Escherichia coli enterohemorrágica
A04.4 Outras infecções intestinais por Escherichia coli
A04.5 Enterite por Campylobacter
A04.6 Enterite devida a Yersinia enterocolítica
A04.7 Enterocolite devida a Clostridium difficile
A04.8 Outras infecções bacterianas intestinais especificadas
Livros Grátis
http://www.livrosgratis.com.br
Milhares de livros grátis para download.
A04.9 Infecção intestinal bacteriana não especificada
A05.0 Intoxicação alimentar estafilocócica
A05.1 Botulismo
A05.2 Intoxicação alimentar devida a Clostridium perfringens [Clostridium welchii]
A05.3 Intoxicação alimentar devida a Vibrio parahemolyticus
A05.4 Intoxicação alimentar devida a Bacillus cereus
A05.8 Outras intoxicações alimentares bacterianas especificadas
A05.9 Intoxicação alimentar bacteriana não especificada
A06.0 Disenteria amebiana aguda
A06.1 Amebíase intestinal crônica
A06.2 Colite amebiana não­disentérica
A06.3 Ameboma intestinal
A06.4 Abscesso amebiano do fígado
A06.5+Abscesso amebiano do pulmão (J99.8*)
A06.6+Abscesso amebiano do cérebro (G07*)
A06.7 Amebíase cutânea
A06.8 Infecção amebiana de outras localizações
A06.9 Amebíase não especificada
A07.0 Balantidíase
A07.1 Giardíase [lamblíase]
A07.2 Criptosporidiose
A07.3 Isosporíase
A07.8 Outras doenças intestinais especificadas por protozoários
A07.9 Doença intestinal não especificada por protozoários
A08.0 Enterite por rotavírus
A08.1 Gastroenteropatia aguda pelo agente de Norwalk
A08.2 Enterite por adenovírus
A08.3 Outras enterites virais
A08.4 Infecção intestinal devida a vírus não especificado
A08.5 Outras infecções intestinais especificadas
A09 Diarréia e gastroenterite de origem infecciosa presumível
A15.0 Tuberculose pulmonar, com confirmação por exame microscópio da expectoração, com ou sem
cultura
A15.1 Tuberculose pulmonar, com confirmação somente por cultura
A15.2 Tuberculose pulmonar, com confirmação histológica
A15.3 Tuberculose pulmonar, com confirmação por meio não especificado
A15.4 Tuberculose dos gânglios intratorácicos, com confirmação bacteriológica e histológica
A15.5 Tuberculose da laringe, da traquéia e dos brônquios, com confirmação bacteriológica e
histológica
A15.6 Pleuris tuberculoso, com confirmação bacteriológica e histológica
A15.7 Tuberculose primária das vias respiratórias, com confirmação bacteriológica e histológica
A15.8 Outras formas de tuberculose das vias respiratórias, com confirmação bacteriológica e
histológica
A15.9 Tuberculose não especificada das vias respiratórias, com confirmação bacteriológica e
histológica
A16.0 Tuberculose pulmonar com exames bacteriológico e histológico negativos
A16.1 Tuberculose pulmonar, sem realização de exame bacteriológico ou histológico
A16.2 Tuberculose pulmonar, sem menção de confirmação bacteriológica ou histológica
A16.3 Tuberculose dos gânglios intratorácicos, sem menção de confirmação bacteriológica ou
histológica
A16.4 Tuberculose da laringe, da traquéia e dos brônquios, sem menção de confirmação bacteriológica
ou histológica
A16.5 Pleurisia tuberculosa, sem menção de confirmação bacteriológica ou histológica
A16.7 Tuberculosa respiratória primária sem menção de confirmação bacteriológica ou histológica
A16.8 Outras formas de tuberculose das vias respiratórias, sem menção de confirmação bacteriológica
ou histológica
A16.9 Tuberculose respiratória, não especificada, sem menção de confirmação bacteriológica ou
histológica
A17.0+Meningite tuberculosa (G01*)
A17.1+Tuberculoma meníngeo (G07*)
A17.8+Outras tuberculoses do sistema nervoso
A17.9+Tuberculose não especificada do sistema nervoso (G99.8*)
A18.0+Tuberculose óssea e das articulações
A18.1 Tuberculose do aparelho geniturinário
A18.2 Linfadenopatia tuberculosa periférica
A18.3 Tuberculose do intestino, do peritônio e dos gânglios mesentéricos
A18.4 Tuberculose de pele e do tecido celular subcutâneo
A18.5+Tuberculose do olho
A18.6+Tuberculose do ouvido
A18.7+Tuberculose das supra­renais (E35.1*)
A18.8+Tuberculose de outros órgãos especificados
A19.0 Tuberculose miliar aguda de localização única e especificada
A19.1 Tuberculose miliar aguda de múltiplas localizações
A19.2 Tuberculose miliar aguda não especificada
A19.8 Outras tuberculoses miliares
A19.9 Tuberculose miliar não especificada
A20.0 Peste bubônica
A20.1 Peste celulocutânea
A20.2 Peste pneumônica
A20.3 Peste meníngea
A20.7 Peste septicêmica
A20.8 Outras formas de peste
A20.9 Peste, forma não especificada
A21.0 Tularemia ulceroglandular
A21.1 Tularemia oculoglandular
A21.2 Tularemia pulmonar
A21.3 Tularemia gastrointestinal
A21.7 Tularemia generalizada
A21.8 Outras formas de tularemia
A21.9 Tularemia, forma não especificada
A22.0 Carbúnculo cutâneo
A22.1 Carbúnculo pulmonar
A22.2 Carbúnculo gastrointestinal
A22.7 Septicemia carbunculosa
A22.8 Outras formas de carbúnculo
A22.9 Carbúnculo, forma não especificada
A23.0 Brucelose por Brucella melitensis
A23.1 Brucelose por Brucella abortus
A23.2 Brucelose por Brucella suis
A23.3 Brucelose por Brucella canis
A23.8 Outras bruceloses
A23.9 Brucelose não especificada
A24.0 Mormo
A24.1 Melioidose aguda e fulminante
A24.2 Melioidose subaguda e crônica
A24.3 Outras melioidoses
A24.4 Melioidose não especificada
A25.0 Espirilose
A25.1 Estreptobacilose
A25.9 Febre transmitida por mordedura de rato, tipo não especificado
A26.0 Erisipelóide cutâneo
A26.7 Septicemia por Erysipelothrix
A26.8 Outras formas de erisipelóide
A26.9 Erisipelóide não especificado
A27.0 Leptopirose icterohemorrágica
A27.8 Outras formas de leptospirose
A27.9 Leptospirose não especificada
A28.0 Pasteurelose
A28.1 Doença por arranhadura do gato
A28.2 Yersiniose extra­intestinal
A28.8 Outras doenças bacterianas zoonóticas especificadas não classificadas em outra parte
A28.9 Doença bacteriana zoonótica não especificada
A30.0 Hanseníase [lepra] indeterminada
A30.1 Hanseníase [lepra] tuberculóide
A30.2 Hanseníase [lepra] tuberculóide borderline
A30.3 Hanseníase [lepra] dimorfa
A30.4 Hanseníase [lepra] lepromatosa borderline
A30.5 Hanseníase [lepra] lepromatosa
A30.8 Outras formas de hanseníase [lepra]
A30.9 Hanseníase [lepra] não especificada
A31.0 Infecção pulmonar micobacteriana
A31.1 Infecção cutânea micobacteriana
A31.8 Outras infecções micobacterianas
A31.9 Infecção micobacteriana não especificada
A32.0 Listeriose cutânea
A32.1+Meningite e meningoencefalite por listéria
A32.7 Septicemia listeriótica
A32.8 Outras formas de listeriose
A32.9 Listeriose não especificada
A33 Tétano do recém­nascido [neonatal]
A34 Tétano obstétrico
A35 Outros tipos de tétano
A36.0 Difteria faríngea
A36.1 Difteria nasofaríngea
A36.2 Difteria laríngea
A36.3 Difteria cutânea
A36.8 Outras formas de difteria
A36.9 Difteria não especificada
A37.0 Coqueluche por Bordetella pertussis
A37.1 Coqueluche por Bordetella parapertussis
A37.8 Coqueluche por outras espécies da Bordetella
A37.9 Coqueluche não especificada
A38 Escarlatina
A39.0+Meningite meningocócica (G01*)
A39.1+Síndrome de Waterhouse­Friderichsen (E35.1*)
A39.2 Meningococcemia aguda
A39.3 Meningococcemia crônica
A39.4 Meningococcemia não especificada
A39.5+Cardite por meningococos
A39.8 Outras infecções por meningococos
A39.9 Infecção meningocócica não especificada
A40.0 Septicemia por Streptococcus do grupo A
A40.1 Septicemia por Streptococcus do grupo B
A40.2 Septicemia por Streptococcus do grupo D
A40.3 Septicemia por Streptococcus pneumonia
A40.8 Outras septicemias estreptocócicas
A40.9 Septicemia estreptocócica não especificada
A41.0 Septicemia por Staphylococcus aureus
A41.1 Septicemia por outros estafilococos especificados
A41.2 Septicemia por estafilococos não especificados
A41.3 Septicemia por Haemophilus influenzae
A41.4 Septicemia por anaeróbios
A41.5 Septicemia por outros microorganismos gram­negativos
A41.8 Outras septicemias especificadas
A41.9 Septicemia não especificada
A42.0 Actinomicose pulmonar
A42.1 Actinomicose abdominal
A42.2 Actinomicose cervicofacial
A42.7 Septicemia actinomicótica
A42.8 Outras formas de actinomicose
A42.9 Actinomicose não especificada
A43.0 Nocardiose pulmonar
A43.1 Nocardiose cutânea
A43.8 Outras formas de nocardiose
A43.9 Nocardiose não especificada
A44.0 Bartonelose sistêmica
A44.1 Bartonelose cutânea e cutâneo­mucosa
A44.8 Outras formas de bartonelose
A44.9 Bartonelose não especificada
A46 Erisipela
A48.0 Gangrena gasosa
A48.1 Doença dos legionários
A48.2 Doença dos legionários não­pneumônica [febre de Pontiac]
A48.3 Síndrome do choque tóxico
A48.4 Febre purpúrica do Brasil
A48.8 Outras doenças bacterianas especificadas
A49.0 Infecção estafilocócica não especificada
A49.1 Infecção estreptocócica não especificada
A49.2 Infecção por Haemophilus influenzae não especificada
A49.3 Infecção por Mycoplasma não especificada
A49.8 Outras infecções bacterianas de localização não especificada
A49.9 Infecção bacteriana não especificada
A50.0 Sífilis congênita precoce sintomática
A50.1 Sífilis congênita precoce, forma latente
A50.2 Sífilis congênita precoce não especificada
A50.3 Oculopatia sifilítica congênita tardia
A50.4 Neurossífilis congênita tardia [neurossífilis juvenil]
A50.5 Outras formas tardias e sintomáticas da sífilis congênita
A50.6 Sífilis congênita tardia latente
A50.7 Sífilis congênita tardia não especificada
A50.9 Sífilis congênita não especificada
A51.0 Sífilis genital primária
A51.1 Sífilis anal primária
A51.2 Sífilis primária de outras localizações
A51.3 Sífilis secundária da pele e das mucosas
A51.4 Outras formas de sífilis secundária
A51.5 Sífilis precoce latente
A51.9 Sífilis precoce não especificada
A52.0+Sífilis cardiovascular
A52.1 Neurossífilis sintomática
A52.2 Neurossífilis assintomática
A52.3 Neurossífilis não especificada
A52.7 Outras formas de sífilis tardia sintomática
A52.8 Sífilis tardia latente
A52.9 Sífilis tardia não especificada
A53.0 Sífilis latente, não especificada se recente ou tardia
A53.9 Sífilis não especificada
A54.0 Infecção gonocócica do trato geniturinário inferior, sem abscesso periuretral ou das glândulas
acessórias
A54.1 Infecção gonocócica do trato geniturinário inferior, com abscesso periuretral ou das glândulas
acessórias
A54.2+Pelviperitonite gonocócica e outras infecções geniturinárias gonocócicas
A54.3 Infecção gonocócica do olho
A54.4+Infecção gonocócica do sistema músculo­esquelético
A54.5 Faringite gonocócica
A54.6 Infecção gonocócica do ânus ou do reto
A54.8 Outras infecções gonocócicas
A54.9 Infecção gonocócica não especificada
A55 Linfogranuloma (venéreo) por clamídia
A56.0 Infecções por clamídias do trato geniturinário inferior
A56.1+Infecção por clamídias, pelviperitonial e de outros órgãos geniturinários
A56.2 Infecção por clamídias do trato geniturinário, localização não especificada
A56.3 Infecção do ânus e do reto por clamídias
A56.4 Infecção da faringe por clamídias
A56.8 Infecção por clamídias transmitida por via sexual, de outras localizações
A57 Cancro mole
A58 Granuloma inguinal
A59.0 Tricomoníase urogenital
A59.8 Outras localizações de tricomoníase
A59.9 Tricomoníase não especificada
A60.0 Infecção dos órgãos genitais e do trato geniturinário pelo vírus do herpes
A60.1 Infecção da margem cutânea do ânus e do reto pelo vírus do herpes
A60.9 Infecção anogenital não especificada pelo vírus do herpes
A63.0 Verrugas anogenitais (venéreas)
A63.8 Outras doenças especificadas de transmissão predominantemente sexual
A64 Doenças sexualmente transmitidas, não especificadas
A65 Sífilis não­venérea
A66.0 Lesões iniciais da bouba
A66.1 Papilomas múltiplos e bouba plantar úmida (cravo de bouba)
A66.2 Outras lesões cutâneas precoces da bouba
A66.3 Hiperceratose devida a bouba
A66.4 Gomas e úlceras devidas à bouba
A66.5 Gangosa
A66.6 Lesões osteoarticulares devidas à bouba
A66.7 Outras manifestações da bouba
A66.8 Bouba latente
A66.9 Bouba não especificada
A67.0 Lesões primárias da pinta
A67.1 Lesões intermediárias da pinta
A67.2 Lesões tardias da pinta
A67.3 Lesões mistas da pinta
A67.9 Pinta não especificada
A68.0 Febre recorrente transmitida por piolhos
A68.1 Febre recorrente transmitida por carrapatos
A68.9 Febre recorrente não especificada
A69.0 Estomatite ulcerativa necrotizante
A69.1 Outras infecções de Vincent
A69.2 Doença de Lyme
A69.8 Outras infecções especificadas por espiroquetas
A69.9 Infecção por espiroqueta, não especificada
A70 Infecções causadas por Clamídia psittaci
A71.0 Fase inicial do tracoma
A71.1 Fase ativa do tracoma
A71.9 Tracoma não especificado
A74.0+Conjuntivite causada por clamídias (H13.1*)
A74.8 Outras doenças causadas por clamídias
A74.9 Infecção causada por clamídias não especificada
A75.0 Tifo epidêmico transmitido por piolhos devido a Rickettsia prowazekii
A75.1 Tifo recrudescente [doença de Brill]
A75.2 Tifo por Rickettsia typhi
A75.3 Tifo por Rickettsia tsutsugamuchi
A75.9 Tifo não especificado
A77.0 Febre maculosa por Rickettsia richettsii
A77.1 Febre maculosa por Rickettsia conorii
A77.2 Febre maculosa devida à Rickettsia siberica
A77.3 Febre maculosa devida à Rickettsia australis
A77.8 Outras febres maculosas
A77.9 Febre maculosa não especificada
A78 Febre Q
A79.0 Febre das trincheiras
A79.1 Rickettsiose variceliforme devida à Rickettsia akari
A79.8 Outros tipos de rickettsioses especificadas
A79.9 Rickettsiose não especificada
A80.0 Poliomielite paralítica aguda, associada ao vírus vacinal
A80.1 Poliomielite paralítica aguda, vírus selvagem importado
A80.2 Poliomielite paralítica aguda, vírus selvagem indígena
A80.3 Poliomielites paralíticas agudas, outras e não especificadas
A80.4 Poliomielite aguda não­paralítica
A80.9 Poliomielite aguda não especificada
A81.0 Doença de Creutzfeldt­Jakob
A81.1 Panencefalite esclerosante subaguda
A81.2 Leucoencefalopatia multifocal progressiva
A81.8 Outras infecções por vírus atípico do sistema nervoso central
A81.9 Infecção não especificada do sistema nervosos central por vírus atípico
A82.0 Raiva silvestre
A82.1 Raiva urbana
A82.9 Raiva não especificada
A83.0 Encefalite japonesa
A83.1 Encefalite eqüina ocidental
A83.2 Encefalite eqüina oriental
A83.3 Encefalite de St. Louis
A83.4 Encefalite australiana
A83.5 Encefalite da Califórnia
A83.6 Doença pelo vírus de Rocio
A83.8 Outras encefalites por vírus transmitidas por mosquitos
A83.9 Encefalite não especificada por vírus transmitida por mosquitos
A84.0 Encefalite da taiga [encefalite vernoestival russa]
A84.1 Encefalite da Europa Central transmitida por carrapatos
A84.8 Outras encefalites por vírus transmitidas por carrapatos
A84.9 Encefalite não especificada por vírus transmitida por carrapatos
A85.0+Encefalite por enterovírus (G05.1*)
A85.1+Encefalite por adenovírus (G05.1*)
A85.2 Encefalite por vírus transmitido por artrópodes, não especificada
A85.8 Outras encefalites virais especificadas
A86 Encefalite viral, não especificada
A87.0+Meningite por enterovírus (G02.0*)
A87.1+Meningite por adenovírus (G02.0*)
A87.2 Coriomeningite linfocitária
A87.8 Outras meningites virais
A87.9 Meningite viral não especificada
A88.0 Febre exantemática por enterovírus [exantema de Boston]
A88.1 Vertigem epidêmica
A88.8 Outras infecções virais especificadas do sistema nervoso central
A89 Infecções virais não especificadas do sistema nervoso central
A90 Dengue [dengue clássico]
A91 Febre hemorrágica devida ao vírus do dengue
A92.0 Febre de Chikungunya
A92.1 Febre de O'nyong­nyong
A92.2 Febre eqüina venezuelana
A92.3 Febre por vírus West Nile
A92.4 Febre do vale do Rift
A92.8 Outras febres virais especificadas transmitidas por mosquitos
A92.9 Febre viral transmitida por mosquitos, não especificada
A93.0 Febre de Oropouche
A93.1 Febre por flebótomos
A93.2 Febre do Colorado transmitida por carrapatos
A93.8 Outras febres virais especificadas transmitidas por artrópodes
A94 Febre viral transmitida por artrópodes, não especificada
A95.0 Febre amarela silvestre
A95.1 Febre amarela urbana
A95.9 Febre amarela não especificada
A96.0 Febre hemorrágica de Junin
A96.1 Febre hemorrágica de Machupo
A96.2 Febre de Lassa
A96.8 Outras febres hemorrágicas por arenavírus
A96.9 Febre hemorrágica por arenavírus, não especificada
A98.0 Febre hemorrágica da Criméia (do Congo)
A98.1 Febre hemorrágica de Omsk
A98.2 Doença da floresta de Kyasanur
A98.3 Doença de Marburg
A98.4 Doença pelo vírus Ebola
A98.5 Febre hemorrágica com síndrome renal
A98.8 Outras febres hemorrágicas especificadas por vírus
A99 Febres hemorrágicas virais não especificadas
B00.0 Eczema herpético
B00.1 Dermatite vesicular devido ao vírus do herpes
B00.2 Gengivoestomatite e faringoamigdalite devida ao vírus do herpes
B00.3+Meningite devida ao vírus do herpes (G02.0*)
B00.4+Encefalite devida ao vírus do herpes (G05.1*)
B00.5+Afecções oculares devidas ao vírus do herpes
B00.7 Doença disseminada devida ao vírus do herpes
B00.8 Outras formas de infecção devida ao vírus do herpes
B00.9 Infecção não especificada devida ao vírus do herpes
B01.0+Meningite por varicela (G02.0*)
B01.1+Encefalite por varicela (G05.1*)
B01.2+Pneumopatia varicelosa (J17.1*)
B01.8 Varicela com outras complicações
B01.9 Varicela sem complicação
B02.0+Encefalite pelo vírus do herpes zoster (G05.1*)
B02.1+Meningite pelo vírus do herpes zoster (G02.0*)
B02.2+Herpes zoster acompanhado de outras manifestações neurológicas
B02.3+Herpes zoster oftálmico
B02.7 Herpes zoster disseminado
B02.8 Herpes zoster com outras complicações
B02.9 Herpes zoster sem complicação
B03 Varíola
B04 Varíola dos macacos [Monkeypox]
B05.0+Sarampo complicado por encefalite (G05.1*)
B05.1+Sarampo complicado por meningite (G02.0*)
B05.2+Sarampo complicado por pneumonia (J17.1*)
B05.3+Sarampo complicado por otite média (H67.1*)
B05.4 Sarampo com complicações intestinais
B05.8 Sarampo com outras complicações
B05.9 Sarampo sem complicação
B06.0+Rubéola com complicações neurológicas
B06.8 Rubéola com outras complicações
B06.9 Rubéola sem complicação
B07 Verrugas de origem viral
B08.0 Outras infecções por ortopoxvírus
B08.1 Molusco contagioso
B08.2 Exantema súbito [sexta doença]
B08.3 Eritema infeccioso [quinta doença]
B08.4 Estomatite vesicular devida a enterovírus com exantema
B08.5 Faringite vesicular devida a enterovírus
B08.8 Outras infecções virais especificadas caracterizadas por lesões de pele e das membranas
mucosas
B09 Infecção viral não especificada caracterizada por lesões da pele e membranas mucosas
B15.0 Hepatite A com coma hepático
B15.9 Hepatite A sem coma hepático
B16.0 Hepatite aguda B com agente Delta (co­infecção), com coma hepático
B16.1 Hepatite aguda B com agente Delta, (co­infecção), sem coma hepático
B16.2 Hepatite aguda B sem agente Delta, com coma hepático
B16.9 Hepatite aguda B sem agente Delta e sem coma hepático
B17.0 (Super)infecção Delta aguda de portador de hepatite B
B17.1 Hepatite aguda C
B17.2 Hepatite aguda E
B17.8 Outras hepatites virais agudas especificadas
B18.0 Hepatite viral crônica B com agente Delta
B18.1 Hepatite crônica viral B sem agente Delta
B18.2 Hepatite viral crônica C
B18.8 Outras hepatites crônicas virais
B18.9 Hepatite viral crônica não especificada
B19.0 Hepatite viral, não especificada, com coma
B19.9 Hepatite viral, não especificada, sem coma
B20.0 Doença pelo HIV resultando em infecções micobacterianas
B20.1 Doença pelo HIV resultando em outras infecções bacterianas
B20.2 Doença pelo HIV resultando em doença citomegálica
B20.3 Doença pelo HIV resultando em outras infecções virais
B20.4 Doença pelo HIV resultando em candidíase
B20.5 Doença pelo HIV resultando em outras micoses
B20.6 Doença pelo HIV resultando em pneumonia por Pneumocystis carinii
B20.7 Doença pelo HIV resultando em infecções múltiplas
B20.8 Doença pelo HIV resultando em outras doenças infecciosas e parasitárias
B20.9 Doença pelo HIV resultando em doença infecciosa ou parasitária não especificada
B21.0 Doença pelo HIV resultando em sarcoma de Kaposi
B21.1 Doença pelo HIV resultando em linfoma de Burkitt
B21.2 Doença pelo HIV resultando em outros tipos de linfoma não­Hodgkin
B21.3 Doença pelo HIV resultando em outras neoplasias malignas dos tecidos linfático, hematopoético
e correlatos
B21.7 Doença pelo HIV resultando em múltiplas neoplasias malignas
B21.8 Doença pelo HIV resultando em outras neoplasias malignas
B21.9 Doença pelo HIV resultando em neoplasia maligna não especificada
B22.0 Doença pelo HIV resultando em encefalopatia
B22.1 Doença pelo HIV resultando em pneumonite intersticial linfática
B22.2 Doença pelo HIV resultando em síndrome de emaciação
B22.7 Doença pelo HIV resultando em doenças múltiplas classificadas em outra parte
B23.0 Síndrome de infecção aguda pelo HIV
B23.1 Doença pelo HIV resultando em linfadenopatias generalizadas (persistentes)
B23.2 Doença pelo HIV resultando em anomalias hematológicas e imunológicas não classificadas em
outra parte
B23.8 Doença pelo HIV resultando em outra afecções especificadas
B24 Doença pelo vírus da imunodeficiência humana [HIV] não especificada
B25.0+Pneumonite por citomegalovírus (J17.1*)
B25.1+Hepatite por citomegalovírus (K77.0*)
B25.2+Pancreatite por citomegalovírus (K87.1*)
B25.8 Outras doenças por citomegalovírus
B25.9 Doença não especificada por citomegalovírus
B26.0+Orquite por caxumba [parotidite epidêmica] (N51.1*)
B26.1+Meningite por caxumba [parotidite epidêmica] (G02.0*)
B26.2+Encefalite por caxumba [parotidite epidêmica] (G05.1*)
B26.3+Pancreatite por caxumba [parotidite epidêmica] (K87.1*)
B26.8 Caxumba [parotidite epidêmica] com outras complicações
B26.9 Caxumba [parotidite epidêmica] sem complicações
B27.0 Mononucleose pelo vírus herpes gama
B27.1 Mononucleose por citomegalovírus
B27.8 Outras mononucleoses infecciosas
B27.9 Mononucleose infecciosa não especificada
B30.0+Ceratoconjuntivite devida a adenovírus (H19.2*)
B30.1+Conjuntivite devida a adenovírus (H13.1*)
B30.2 Faringoconjuntivite viral
B30.3+Conjuntivite hemorrágica aguda endêmica (por enterovírus) (H13.1*)
B30.8+Outras conjuntivites virais (H13.1*)
B30.9 Conjuntivite viral não especificada
B33.0 Mialgia epidêmica
B33.1 Doença de Ross River
B33.2 Cardite viral
B33.3 Infecção por retrovírus não classificada em outra parte
B33.8 Outras doenças especificadas por vírus
B34.0 Infecção por adenovírus, não especificada
B34.1 Infecção por enterovírus, não especificada
B34.2 Infecção por coronavírus, não especificada
B34.3 Infecção por parvovírus, não especificada
B34.4 Infecção por papovavírus, não especificada
B34.8 Outras infecções por vírus de localização não especificada
B34.9 Infecção viral não especificada
B35.0 Tinha da barba e do couro cabeludo
B35.1 Tinha das unhas
B35.2 Tinha da mão
B35.3 Tinha dos pés
B35.4 Tinha do corpo
B35.5 Tinha imbricada
B35.6 Tinea cruris
B35.8 Outras dermatofitoses
B35.9 Dermatofitose não especificada
B36.0 Pitiríase versicolor
B36.1 Tinha negra
B36.2 Piedra branca
B36.3 Piedra negra
B36.8 Outras micoses superficiais especificadas
B36.9 Micose superficial não especificada
B37.0 Estomatite por Candida
B37.1 Candidíase pulmonar
B37.2 Candidíase da pele e das unhas
B37.3+Candidíase da vulva e da vagina (N77.1+)
B37.4+Candidíase de outras localizações urogenitais
B37.5+Meningite por Candida (G02.1*)
B37.6+Endocardite por Candida (I39.8*)
B37.7 Septicemia por Candida
B37.8 Candidíase de outras localizações
B37.9 Candidíase não especificada
B38.0 Coccidioidomicose pulmonar aguda
B38.1 Coccidioidomicose pulmonar crônica
B38.2 Coccidioidomicose pulmonar não especificada
B38.3 Coccidioidomicose cutânea
B38.4+Meningite por coccidioidomicose (G02.1*)
B38.7 Coccidioidomicose disseminada
B38.8 Outras formas de coccidioidomicose
B38.9 Coccidioidomicose não especificada
B39.0 Histoplasmose pulmonar aguda por Histoplasma capsulatum
B39.1 Histoplasmose pulmonar crônica por Histoplasma capsulatum
B39.2 Histoplasmose pulmonar não especificada por Histoplasma capsulatum
B39.3 Histoplasmose disseminada por Histoplasma capsulatum
B39.4 Histoplasmose não especificada por Histoplasma capsulatum
B39.5 Histoplasmose por Histoplasma duboisii
B39.9 Histoplasmose não especificada
B40.0 Blastomicose pulmonar aguda
B40.1 Blastomicose pulmonar crônica
B40.2 Blastomicose pulmonar não especificada
B40.3 Blastomicose cutânea
B40.7 Blastomicose disseminada
B40.8 Outras formas de blastomicose
B40.9 Blastomicose não especificada
B41.0 Paracoccidioidomicose pulmonar
B41.7 Paracoccidioidomicose disseminada
B41.8 Outras formas de paracoccidioidomicose
B41.9 Paracoccidioidomicose não especificada
B42.0+Esporotricose pulmonar (J99.8*)
B42.1 Esporotricose linfocutânea
B42.7 Esporotricose disseminada
B42.8 Outras formas de esporotricose
B42.9 Esporotricose não especificada
B43.0 Cromomicose cutânea
B43.1 Abscesso cerebral feomicótico
B43.2 Abscesso e cisto feomicótico subcutâneos
B43.8 Outras formas de cromomicose
B43.9 Cromomicose não especificada
B44.0 Aspergilose pulmonar invasiva
B44.1 Outras aspergiloses pulmonares
B44.2 Aspergilose amigdaliana
B44.7 Aspergilose disseminada
B44.8 Outras formas de Aspergilose
B44.9 Aspergilose não especificada
B45.0 Criptococose pulmonar
B45.1 Criptococose cerebral
B45.2 Criptococose cutânea
B45.3 Criptococose óssea
B45.7 Criptococose disseminada
B45.8 Outras formas de criptococose
B45.9 Criptococose não especificada
B46.0 Mucormicose pulmonar
B46.1 Mucormicose rinocerebral
B46.2 Mucormicose gastrointestinal
B46.3 Mucormicose cutânea
B46.4 Mucormicose disseminada
B46.5 Mucormicose não especificada
B46.8 Outras zigomicoses
B46.9 Zigomicose não especificada
B47.0 Eumicetoma
B47.1 Actinomicetoma
B47.9 Micetoma não especificado
B48.0 Lobomicose
B48.1 Rinosporidiose
B48.2 Alesqueriose
B48.3 Geotricose
B48.4 Penicilose
B48.7 Micoses oportunistas
B48.8 Outras micoses especificadas
B49 Micose não especificada
B50.0 Malária por Plasmodium falciparum com complicações cerebrais
B50.1 Outras formas graves e complicadas de malária por Plasmodium falciparum
B50.9 Malária não especificada por Plasmodium falciparum
B51.0 Malária por Plasmodium vivax com rotura do baço
B51.8 Malária por Plasmodium vivax com outras complicações
B51.9 Malária por Plasmodium vivax sem complicações
B52.0 Malária por Plasmodium malariae com nefropatia
B52.8 Malária por Plasmodium malariae com outras complicações
B52.9 Malária por Plasmodium malariae sem complicações
B53.0 Malária por Plasmodium ovale
B53.1 Malária por plasmódios de macacos
B53.8 Outras formas de malárias com confirmação parasitológica, não classificadas em outra parte
B54 Malária não especificada
B55.0 Leishmaniose visceral
B55.1 Leishmaniose cutânea
B55.2 Leishmaniose cutâneo­mucosa
B55.9 Leishmaniose não especificada
B56.0 Tripanossomíase por Trypanosoma gambiense
B56.1 Tripanossomíase por Trypanosoma rhodesiense
B56.9 Tripanossomíase africana não especificada
B57.0+Forma aguda da doença de Chagas, com comprometimento cardíaco (I41.2*, I98.1*)
B57.1 Forma aguda da doença de Chagas, sem comprometimento cardíaco
B57.2+Doença de Chagas (crônica) com comprometimento cardíaco (I41.2*, I98.1*)
B57.3 Doença de Chagas (crônica) com comprometimento do aparelho digestivo
B57.4 Doença de Chagas (crônica) com comprometimento do sistema nervoso
B57.5 Doença de Chagas (crônica) com comprometimento de outros órgãos
B58.0+Oculopatia por Toxoplasma
B58.1+Hepatite por Toxoplasma (K77.0*)
B58.2+Meningoencefalite por Toxoplasma (G05.2*)
B58.3+Toxoplasmose pulmonar (J17.3*)
B58.8+Toxoplasmose com comprometimento de outros órgãos
B58.9 Toxoplasmose não especificada
B59 Pneumocistose
B60.0 Babesiose
B60.1 Acantamebíase
B60.2 Naegleríase
B60.8 Outras doenças especificadas devidas a protozoários
B64 Doença não especificada devida a protozoários
B65.0 Esquistossomose devida ao Schistosoma haematobium [esquistossomose urinária]
B65.1 Esquistossomose devida ao Schistosoma mansoni [esquistossomose intestinal]
B65.2 Esquistossomose devida ao Schistosoma japonicum
B65.3 Dermatite por cercárias
B65.8 Outras esquistossomoses
B65.9 Esquistossomose não especificada
B66.0 Opistorquíase
B66.1 Clonorquíase
B66.2 Dicrocelíase
B66.3 Fasciolíase
B66.4 Paragonimíase
B66.5 Fasciolopsíase
B66.8 Outras infestações por trematódeos especificados
B66.9 Infecção não especificada por trematódeo
B67.0 Infestação hepática por Echinococcus granulosus
B67.1 Infestação pulmonar por Echinococcus granulosus
B67.2 Infestação óssea por Echinococcus granulosus
B67.3 Infestações por Echinmococcus granulosus, outras e de localizações múltiplas
B67.4 Infestação não especificada por Echinococcus granulosus
B67.5 Infestação hepática por Echinococcus multilocularis
B67.6 Infecções por Echinococcus multilocularis, outras e de localizações múltiplas
B67.7 Infestação não especificada por Echinococcus multilocularis
B67.8 Infestação hepática não especificada, por Echinococcus
B67.9 Infestações por Echinococcus, outras e as não especificadas
B68.0 Infestação por Taenia solium
B68.1 Infestação por Taenia saginata
B68.9 Infestação não especificada por Taenia
B69.0 Cisticercose do sistema nervoso central
B69.1 Cisticercose do olho
B69.8 Cisticercose de outras localizações
B69.9 Cisticercose não especificada
B70.0 Difilobotríase
B70.1 Esparganose
B71.0 Infestação por Hymenolepis
B71.1 Infestação por Dipylidium
B71.8 Outras infestações especificadas por cestóides
B71.9 Infestação não especificada por cestóides
B72 Dracontíase
B73 Oncocercose
B74.0 Filariose por Wuchereria bancrofti
B74.1 Filariose por Brugia malayi
B74.2 Filariose por Brugia timori
B74.3 Loaíase
B74.4 Mansonelose
B74.8 Outras filarioses
B74.9 Filariose não especificada
B75 Triquinose
B76.0 Ancilostomose
B76.1 Necatoríase
B76.8 Outras ancilostomíases
B76.9 Ancilostomíase não especificada
B77.0 Ascaridíase com complicações intestinais
B77.8 Ascaridíase com outras complicações
B77.9 Ascaridíase não especificada
B78.0 Estrongiloidíase intestinal
B78.1 Estrongiloidíase cutânea
B78.7 Estrongiloidíase disseminada
B78.9 Estrongiloidíase não especificada
B79 Tricuríase
B80 Oxiuríase
B81.0 Anisaquíase
B81.1 Capilaríase intestinal
B81.2 Tricostrongilose
B81.3 Angiostrongiloidose intestinal
B81.4 Helmintíases intestinais mistas
B81.8 Outras helmintíases intestinais especificadas
B82.0 Helmintíase intestinal não especificada
B82.9 Parasitose intestinal não especificada
B83.0 Larva migrans visceral
B83.1 Gnatostomíase
B83.2 Angrostrongiloidose devida a Parastrongylus cantonensis
B83.3 Singamose
B83.4 Hirudiníase interna
B83.8 Outras helmintíases especificadas
B83.9 Helmintíase não especificada
B85.0 Pediculose devida a Pediculus humanus capitis
B85.1 Pediculose devida a Pediculus humanus corporis
B85.2 Pediculose não especificada
B85.3 Ftiríase
B85.4 Pediculose e ftiríase mista
B86 Escabiose [sarna]
B87.0 Miíase cutânea
B87.1 Miíase das feridas
B87.2 Miíase ocular
B87.3 Miíase nasofaríngea
B87.4 Miíase auricular
B87.8 Miíase de outras localizações
B87.9 Miíase não especificada
B88.0 Outras acaríases
B88.1 Tungíase [infestação pela pulga da areia]
B88.2 Outras infestações por artrópodos
B88.3 Hirudiníase externa
B88.8 Outras infestações especificadas
B88.9 Infestação não especificada
B89 Doença parasitária não especificada
B90.0 Seqüelas de tuberculose do sistema nervoso central
B90.1 Seqüelas de tuberculose geniturinária
B90.2 Seqüelas de tuberculose óssea e das articulações
B90.8 Seqüelas de tuberculose de outros órgãos
B90.9 Seqüelas de tuberculose das vias respiratórias e de órgãos não especificados
B91 Seqüelas de poliomielite
B92 Seqüelas de hanseníase [lepra]
B94.0 Seqüelas de tracoma
B94.1 Seqüelas de encefalite viral
B94.2 Seqüelas de hepatite viral
B94.8 Seqüelas de outras doenças infecciosas e parasitárias especificadas
B94.9 Seqüelas de doença infecciosa ou parasitária não especificada
B95.0 Estreptococo do grupo A, como causa de doenças classificadas em outros capítulos
B95.1 Estreptococo do grupo B, como causa de doenças classificadas em outros capítulos
B95.2 Estreptococo do grupo D, como causa de doenças classificadas em outros capítulos
B95.3 Streptococcus pneumoniae, como causa de doenças classificadas em outros capítulos
B95.4 Outros estreptococos, como causa de doenças classificadas em outros capítulos
B95.5 Estreptococo não especificado, como causa de doenças classificadas em outros capítulos
B95.6 Staphylococcus aureus, como causa de doenças classificadas em outros capítulos
B95.7 Outros estafilococos como causa de doenças classificadas em outros capítulos
B95.8 Estafilococo não especificado, como causa de doenças classificadas em outros capítulos
B96.0 Mycoplasma pneumoniae [M. pneumoniae], como causa de doenças classificadas em outros
capítulos
B96.1 Klebsiella pneumoniae [M. pneumoniae], como causa de doenças classificadas em outros
capítulos
B96.2 Escherichia coli [E. Coli], como causa de doenças classificadas em outros capítulos
B96.3 Haemophilus influenzae [H. influenzae], como causa de doenças classificadas em outros
capítulos
B96.4 Proteus (mirabilis) (morganii), como causa de doenças classificadas em outros capítulos
B96.5 Pseudomonas (aeruginosa) (mallei) (pseudomallei), como causa de doenças classificadas em
outros capítulos
B96.6 Bacillus fragilis [B. fragilis], como causa de doenças classificadas em outros capítulos
B96.7 Clostridium perfringens [C. perfringens], como causa de doenças classificadas em outros
capítulos
B96.8 Outros agentes bacterianos especificados, como causa de doenças classificadas em outros
capítulos
B97.0 Adenovírus, como causa de doenças classificadas em outros capítulos
B97.1 Enterovírus, como causa de doenças classificadas em outros capítulos
B97.2 Coronavírus, como causa de doenças classificadas em outros capítulos
B97.3 Retrovírus, como causa de doenças classificadas em outros capítulos
B97.4 Vírus sincicial respiratório, como causa de doenças classificadas em outros capítulos
B97.5 Reovírus, como causa de doenças classificadas em outros capítulos
B97.6 Parvovírus, como causa de doenças classificadas em outros capítulos
B97.7 Papilomavírus, como causa de doenças classificadas em outros capítulos
B97.8 Outros agentes virais, como causa de doenças classificadas em outros capítulos
B99 Doenças infecciosas, outras e as não especificadas
C00.0 Lábio superior externo
C00.1 Lábio inferior externo
C00.2 Lábio externo, não especificado
C00.3 Lábio superior, face interna
C00.4 Lábio inferior, face interna
C00.5 Lábio, sem especificação, face interna
C00.6 Comissura labial
C00.8 Lesão invasiva do lábio
C00.9 Lábio, não especificado
C01 Neoplasia maligna da base da língua
C02.0 Face dorsal da língua
C02.1 Borda da língua
C02.2 Face ventral da língua
C02.3 Dois terços anteriores da língua, parte não especificada
C02.4 Amígdala lingual
C02.8 Lesão invasiva da língua
C02.9 Língua, não especificada
C03.0 Gengiva superior
C03.1 Gengiva inferior
C03.9 Gengiva, não especificada
C04.0 Assoalho anterior da boca
C04.1 Assoalho lateral da boca
C04.8 Lesão invasiva do assoalho da boca
C04.9 Assoalho da boca, não especificado
C05.0 Pálato duro
C05.1 Pálato mole
C05.2 Úvula
C05.8 Lesão invasiva do pálato
C05.9 Pálato não especificado
C06.0 Mucosa oral
C06.1 Vestíbulo da boca
C06.2 Área retromolar
C06.8 Lesão invasiva de outras partes e de partes não especificadas da boca
C06.9 Boca, não especificada
C07 Neoplasia maligna da glândula parótida
C08.0 Glândula submandibular
C08.1 Glândula sublingual
C08.8 Lesão invasiva de glândulas salivares maiores
C08.9 Glândula salivar maior, não especificada
C09.0 Fossa amigdaliana
C09.1 Pilar amigdaliano (anterior) (posterior)
C09.8 Lesão invasiva da amígdala
C09.9 Amígdala, não especificada
C10.0 Valécula
C10.1 Face anterior da epiglote
C10.2 Parede lateral da orofaringe
C10.3 Parede posterior da orofaringe
C10.4 Fenda branquial
C10.8 Lesão invasiva da orofaringe
C10.9 Orofaringe, não especificada
C11.0 Parede superior da nasofaringe
C11.1 Parede posterior da nasofaringe
C11.2 Parede lateral da nasofaringe
C11.3 Parede anterior da nasofaringe
C11.8 Lesão invasiva da nasofaringe
C11.9 Nasofaringe, não especificada
C12 Neoplasia maligna do seio piriforme
C13.0 Região pós­cricóidea
C13.1 Prega ariepiglótica, face hipofaríngea
C13.2 Parede posterior da hipofaringe
C13.8 Lesão invasiva da hipofaringe
C13.9 Hipofaringe, não especificada
C14.0 Faringe, não especificada
C14.1
C14.2 Anel de Waldeyer
C14.8 Lesão invasiva do lábio, cavidade oral e faringe
C15.0 Porção cervical do esôfago (esôfago cervical)
C15.1 Porção torácica do esôfago (esôfago torácico)
C15.2 Porção abdominal do esôfago (esôfago abdominal)
C15.3 Terço superior do esôfago
C15.4 Terço médio do esôfago
C15.5 Terço inferior do esôfago
C15.8 Lesão invasiva do esôfago
C15.9 Esôfago, não especificado
C16.0 Cárdia
C16.1 Fundo do estômago
C16.2 Corpo do estômago
C16.3 Antro pilórico
C16.4 Piloro
C16.5 Pequena curvatura do estômago, não especificada
C16.6 Grande curvatura do estômago, não especificada
C16.8 Lesão invasiva do estômago
C16.9 Estômago, não especificado
C17.0 Duodeno
C17.1 Jejuno
C17.2 Íleo
C17.3 Divertículo de Meckel
C17.8 Lesão invasiva do intestino delgado
C17.9 Intestino delgado, não especificado
C18.0 Ceco
C18.1 Apêndice (vermiforme)
C18.2 Cólon ascendente
C18.3 Flexura (ângulo) hepática(o)
C18.4 Cólon transverso
C18.5 Flexura (ângulo) esplênica(o)
C18.6 Cólon descendente
C18.7 Cólon sigmóide
C18.8 Lesão invasiva do cólon
C18.9 Cólon, não especificado
C19 Neoplasia maligna da junção retossigmóide
C20 Neoplasia maligna do reto
C21.0 Ânus, não especificado
C21.1 Canal anal
C21.2 Zona cloacogênica
C21.8 Lesão invasiva do reto, ânus e do canal anal
C22.0 Carcinoma de células hepáticas
C22.1 Carcinoma de vias biliares intra­hepáticas
C22.2 Hepatoblastoma
C22.3 Angiossarcoma do fígado
C22.4 Outros sarcomas do fígado
C22.7 Outros carcinomas especificados do fígado
C22.9 Neoplasia maligna do fígado, não especificada
C23 Neoplasia maligna da vesícula biliar
C24.0 Vias biliares extra­hepáticas
C24.1 Ampola de Vater
C24.8 Lesão invasiva das vias biliares
C24.9 Via biliar, não especificada
C25.0 Cabeça do pâncreas
C25.1 Corpo do pâncreas
C25.2 Cauda do pâncreas
C25.3 Canal pancreático
C25.4 Pâncreas endócrino
C25.7 Neoplasia maligna de outras partes do pâncreas
C25.8 Lesão invasiva do pâncreas
C25.9 Pâncreas, não especificado
C26.0 Trato intestinal, parte não especificada
C26.1 Baço
C26.8 Lesão invasiva do aparelho digestivo
C26.9 Localizações mal definidas dentro do aparelho digestivo
C30.0 Cavidade nasal
C30.1 Ouvido médio
C31.0 Seio maxilar
C31.1 Seio etmoidal
C31.2 Seio frontal
C31.3 Seio esfenoidal
C31.8 Lesão invasiva dos seios da face
C31.9 Seio da face, não especificado
C32.0 Glote
C32.1 Região supraglótica
C32.2 Região subglótica
C32.3 Cartilagens da laringe
C32.8 Lesão invasiva da laringe
C32.9 Laringe não especificada
C33 Neoplasia maligna da traquéia
C34.0 Brônquio principal
C34.1 Lobo superior, brônquio ou pulmão
C34.2 Lobo médio, brônquio ou pulmão
C34.3 Lobo inferior, brônquio ou pulmão
C34.8 Lesão invasiva dos brônquios e dos pulmões
C34.9 Brônquios ou pulmões, não especificado
C37 Neoplasia maligna do timo
C38.0 Coração
C38.1 Mediastino anterior
C38.2 Mediastino posterior
C38.3 Mediastino, porção não especificada
C38.4 Pleura
C38.8 Lesão invasiva do coração, mediastino e pleura
C39.0 Trato respiratório superior, porção não especificada
C39.8 Lesão invasiva do aparelho respiratório e dos órgãos intratorácicos
C39.9 Localizações mal definidas do aparelho respiratório
C40.0 Omoplata [escápula] e ossos longos dos membros superiores
C40.1 Ossos curtos dos membros superiores
C40.2 Ossos longos dos membros inferiores
C40.3 Ossos curtos dos membros inferiores
C40.8 Lesão invasiva dos ossos e cartilagens articulares dos membros
C40.9 Ossos e cartilagens articulares de membro não especificado
C41.0 Ossos do crânio e da face
C41.1 Mandíbula
C41.2 Coluna vertebral
C41.3 Costelas, esterno e clavícula
C41.4 Ossos da pelve, sacro e cóccix
C41.8 Lesão invasiva dos ossos e das cartilagens articulares
C41.9 Ossos e cartilagens articulares
C43.0 Melanoma maligno do lábio
C43.1 Melanoma maligno da pálpebra, incluindo as comissuras palpebrais
C43.2 Melanoma maligno da orelha e do conduto auditivo externo
C43.3 Melanoma maligno de outras partes e partes não especificadas da face
C43.4 Melanoma maligno do couro cabeludo e do pescoço
C43.5 Melanoma maligno do tronco
C43.6 Melanoma maligno do membro superior, incluindo ombro
C43.7 Melanoma maligno do membro inferior, incluindo quadril
C43.8 Melanoma maligno invasivo da pele
C43.9 Melanoma maligno de pele, não especificado
C44.0 Pele do lábio
C44.1 Pele da pálpebra, incluindo o canto
C44.2 Pele da orelha e do conduto auditivo externo
C44.3 Pele de outras partes e de partes não especificadas da face
C44.4 Pele do couro cabeludo e do pescoço
C44.5 Pele do tronco
C44.6 Pele do membro superior, incluindo ombro
C44.7 Pele do membro inferior, incluindo quadril
C44.8 Lesão invasiva da pele
C44.9 Neoplasia maligna da pele
C45.0 Mesotelioma da pleura
C45.1 Mesotelioma do peritônio
C45.2 Mesotelioma do pericárdio
C45.7 Mesotelioma de outras localizações
C45.9 Mesotelioma, não especificado
C46.0 Sarcoma de Kaposi da pele
C46.1 Sarcoma de Kaposi de tecidos moles
C46.2 Sarcoma de Kaposi do palato
C46.3 Sarcoma de Kaposi dos gânglios linfáticos
C46.7 Sarcoma de Kaposi de outras localizações
C46.8 Sarcoma de Kaposi de múltiplos órgãos
C46.9 Sarcoma de Kaposi, não especificado
C47.0 Nervos periféricos da cabeça, face e pescoço
C47.1 Nervos periféricos dos membros superiores, incluindo ombro
C47.2 Nervos periféricos dos membros inferiores, incluindo quadril
C47.3 Nervos periféricos do tórax
C47.4 Nervos periféricos do abdome
C47.5 Nervos periféricos da pelve
C47.6 Nervos periféricos do tronco
C47.8 Lesão invasiva dos nervos periféricos e do sistema nervoso autônomo
C47.9 Nervos periféricos e sistema nervoso autônomo
C48.0 Retroperitônio
C48.1 Partes especificadas do peritônio
C48.2 Peritônio
C48.8 Lesão invasiva dos tecidos moles do retroperitônio e do peritônio
C49.0 Tecido conjuntivo e tecidos moles da cabeça, face e pescoço
C49.1 Tecido conjuntivo e tecidos moles dos membros superiores, incluindo ombro
C49.2 Tecido conjuntivo e tecidos moles dos membros inferiores, incluindo quadril
C49.3 Tecido conjuntivo e tecidos moles do tórax
C49.4 Tecido conjuntivo e tecidos moles do abdome
C49.5 Tecido conjuntivo e tecidos moles da pelve
C49.6 Tecido conjuntivo e tecidos moles do tronco
C49.8 Lesão invasiva do tecido conjuntivo e dos tecidos moles
C49.9 Neoplasia maligna do tecido conjuntivo e tecidos moles
C50.0 Mamilo e aréola
C50.1 Porção central da mama
C50.2 Quadrante superior interno da mama
C50.3 Quadrante inferior interno da mama
C50.4 Quadrante superior externo da mama
C50.5 Quadrante inferior externo da mama
C50.6 Porção axilar da mama
C50.8 Lesão invasiva da mama
C50.9 Mama, não especificada
C51.0 Grandes lábios
C51.1 Pequenos lábios
C51.2 Clitóris
C51.8 Lesão invasiva da vulva
C51.9 Vulva, não especificada
C52 Neoplasia maligna da vagina
C53.0 Endocérvix
C53.1 Exocérvix
C53.8 Lesão invasiva do colo do útero
C53.9 Colo do útero, não especificado
C54.0 Istmo do útero
C54.1 Endométrio
C54.2 Miométrio
C54.3 Fundo do útero
C54.8 Lesão invasiva do corpo do útero
C54.9 Corpo do útero, não especificado
C55 Neoplasia maligna do útero, porção não especificada
C56 Neoplasia maligna do ovário
C57.0 Trompa de Falópio
C57.1 Ligamento largo
C57.2 Ligamento redondo
C57.3 Paramétrio
C57.4 Anexos uterinos
C57.7 Outras partes especificadas dos órgãos genitais femininos
C57.8 Lesão invasiva dos órgãos genitais femininos
C57.9 Órgão genital feminino, não especificado
C58 Neoplasia maligna da placenta
C60.0 Prepúcio
C60.1 Glande
C60.2 Corpo do pênis
C60.8 Lesão invasiva do pênis
C60.9 Pênis, não especificado
C61 Neoplasia maligna da próstata
C62.0 Testículo criptorquídico
C62.1 Testículo tópico
C62.9 Testículo, sem outras especificações
C63.0 Epidídimo
C63.1 Cordão espermático
C63.2 Escroto
C63.7 Outros órgãos genitais masculinos especificados
C63.8 Lesão invasiva dos órgãos genitais masculinos
C63.9 Órgão genital masculino, não especificado
C64 Neoplasia maligna do rim, exceto pelve renal
C65 Neoplasia maligna da pelve renal
C66 Neoplasia maligna dos ureteres
C67.0 Trígono da bexiga
C67.1 Cúpula da bexiga
C67.2 Parede lateral da bexiga
C67.3 Parede anterior da bexiga
C67.4 Parede posterior da bexiga
C67.5 Colo da bexiga
C67.6 Orifício uretérico
C67.7 Úraco
C67.8 Lesão invasiva da bexiga
C67.9 Bexiga, sem outra especificações
C68.0 Uretra
C68.1 Glândula parauretral
C68.8 Lesão invasiva dos órgãos urinários
C68.9 Órgão urinário, não especificado
C69.0 Conjuntiva
C69.1 Córnea
C69.2 Retina
C69.3 Coróide
C69.4 Corpo ciliar
C69.5 Glândula e canal lacrimal
C69.6 Órbita
C69.8 Lesão invasiva do olho e anexos
C69.9 Olho, não especificado
C70.0 Meninges cerebrais
C70.1 Meninges espinhais
C70.9 Meninge, não especificada
C71.0 Cérebro, exceto lobos e ventrículos
C71.1 Lobo frontal
C71.2 Lobo temporal
C71.3 Lobo parietal
C71.4 Lobo occipital
C71.5 Ventrículo cerebral
C71.6 Cerebelo
C71.7 Tronco cerebral
C71.8 Lesão invasiva do encéfalo
C71.9 Encéfalo, não especificado
C72.0 Medula espinhal
C72.1 Cauda eqüina
C72.2 Nervo olfativo
C72.3 Nervo óptico
C72.4 Nervo acústico
C72.5 Outros nervos cranianos e os não especificados
C72.8 Lesão invasiva do encéfalo e de outras partes do sistema nervoso central
C72.9 Sistema nervoso central, não especificado
C73 Neoplasia maligna da glândula tireóide
C74.0 Córtex da supra­renal
C74.1 Medula da supra­renal
C74.9 Glândula supra­renal, não especificada
C75.0 Glândula paratireóide
C75.1 Glândula hipófise (pituitária)
C75.2 Conduto craniofaríngeo
C75.3 Glândula pineal
C75.4 Corpo carotídeo
C75.5 Corpo aórtico e outros paragânglios
C75.8 Comprometimento pluriglandular, sem outra especificação
C75.9 Glândula endócrina
C76.0 Cabeça, face e pescoço
C76.1 Tórax
C76.2 Abdome
C76.3 Pelve
C76.4 Membro superior
C76.5 Membro inferior
C76.7 Outras localizações mal definidas
C76.8 Lesão invasiva de outras localizações e das mal definidas
C77.0 Gânglios linfáticos da cabeça, face e pescoço
C77.1 Gânglios linfáticos intratorácicos
C77.2 Gânglios linfáticos intra­abdominais
C77.3 Gânglios linfáticos axilares e dos membros superiores
C77.4 Gânglios linfáticos inguinais e dos membros inferiores
C77.5 Gânglios linfáticos intrapélvicos
C77.8 Gânglios linfáticos de múltiplas regiões
C77.9 Gânglio linfático não especificado
C78.0 Neoplasia maligna secundária dos pulmões
C78.1 Neoplasia maligna secundária do mediastino
C78.2 Neoplasia maligna secundária da pleura
C78.3 Neoplasia maligna secundária de outros órgãos respiratórios e não especificados
C78.4 Neoplasia maligna secundária do intestino delgado
C78.5 Neoplasia maligna secundária do intestino grosso e do reto
C78.6 Neoplasia maligna secundária do retroperitônio e do peritônio
C78.7 Neoplasia maligna secundária do fígado
C78.8 Neoplasia maligna secundária de outros órgãos digestivos e não especificados
C79.0 Neoplasia maligna secundária do rim e da pelve renal
C79.1 Neoplasia maligna secundária da bexiga, de outro órgão urinário e não especificado
C79.2 Neoplasia maligna secundária da pele
C79.3 Neoplasia maligna secundária do encéfalo e das meninges cerebrais
C79.4 Neoplasia maligna secundária de outras partes do sistema nervoso e não especificadas
C79.5 Neoplasia maligna secundária dos ossos e da medula óssea
C79.6 Neoplasia maligna secundária do ovário
C79.7 Neoplasia maligna secundária das glândulas supra­renais (adrenais)
C79.8 Neoplasia maligna secundária de outra localização especificada
C80 Neoplasia maligna, sem especificação de localização
C81.0 Predominância linfocítica
C81.1 Esclerose nodular
C81.2 Celularidade mista
C81.3 Depleção linfocítica
C81.7 Outra forma da doença de Hodgkin
C81.9 Doença de Hodgkin, não especificada
C82.0 Pequenas células clivadas, folicular
C82.1 Misto, de pequenas e grandes células clivadas, folicular
C82.2 Grandes células, folicular
C82.7 Outros tipos de linfoma não­Hodgkin, folicular
C82.9 Linfoma não­Hodgkin, folicular, não especificado
C83.0 Pequenas células (difuso)
C83.1 Pequenas células clivadas (difuso)
C83.2 Misto, de pequenas e grandes células (difuso)
C83.3 Grandes células (difuso)
C83.4 Imunoblástico (difuso)
C83.5 Linfoblástico (difuso)
C83.6 Indiferenciado (difuso)
C83.7 Tumor de Burkitt
C83.8 Outros tipos de linfoma não­Hodgkin difuso
C83.9 Linfoma não­Hodgkin difuso, não especificado
C84.0 Micose fungóide
C84.1 Doença de Sézary
C84.2 Linfoma da zona T
C84.3 Linfoma linfoepitelióide
C84.4 Linfoma de células T, periférico
C84.5 Outros linfomas de células T e os não especificados
C85.0 Linfossarcoma
C85.1 Linfoma de células B, não especificado
C85.7 Outros tipos especificados de linfoma não­Hodgkin
C85.9 Linfoma não­Hodgkin de tipo não especificado
C88.0 Macroglobulinemia de Waldenström
C88.1 Doença de cadeia pesada alfa
C88.2 Doença de cadeia pesada gama
C88.3 Doença imunoproliferativa do intestino delgado
C88.7 Outras doenças imunoproliferativas malignas
C88.9 Doença imunoproliferativa maligna, não especificada
C90.0 Mieloma múltiplo
C90.1 Leucemia plasmocitária
C90.2 Plasmocitoma extramedular
C91.0 Leucemia linfoblástica aguda
C91.1 Leucemia linfocítica crônica
C91.2 Leucemia linfocítica subaguda
C91.3 Leucemia pró­linfocítica
C91.4 Leucemia de células pilosas
C91.5 Leucemia de células T do adulto
C91.7 Outras leucemias linfóides
C91.9 Leucemia linfóide não especificada
C92.0 Leucemia mielóide aguda
C92.1 Leucemia mielóide crônica
C92.2 Leucemia mielóide subaguda
C92.3 Sarcoma mielóide
C92.4 Leucemia pró­mielocítica aguda
C92.5 Leucemia mielomonocítica aguda
C92.7 Outras leucemias mielóides
C92.9 Leucemia mielóide, não especificada
C93.0 Leucemia monocítica aguda
C93.1 Leucemia monocítica crônica
C93.2 Leucemia monocítica subaguda
C93.7 Outras leucemias monocíticas
C93.9 Leucemia monocítica, não especificada
C94.0 Eritremia e eritroleucemia agudas
C94.1 Eritremia crônica
C94.2 Leucemia megacarioblástica aguda
C94.3 Leucemia de mastócitos
C94.4 Panmielose aguda
C94.5 Mielofibrose aguda
C94.7 Outras leucemias especificadas
C95.0 Leucemia aguda de tipo celular não especificado
C95.1 Leucemia crônica de tipo celular não especificado
C95.2 Leucemia subaguda de tipo celular não especificado
C95.7 Outras leucemias de tipo celular não especificado
C95.9 Leucemia não especificada
C96.0 Doença de Letterer­Siwe
C96.1 Histiocitose maligna
C96.2 Tumor maligno de mastócitos
C96.3 Linfoma histiocítico verdadeiro
C96.7 Outras neoplasias malignas especificadas dos tecidos linfático, hematopoético e tecidos
correlatos
C96.9 Neoplasia maligna dos tecidos linfático, hematopoético e tecidos correlatos, não especificada
C97 Neoplasias malignas de localizações múltiplas independentes (primárias)
D00.0 Lábios, cavidade oral e faringe
D00.1 Esôfago
D00.2 Estômago
D01.0 Cólon
D01.1 Junção retossigmoídea
D01.2 Reto
D01.3 Ânus e canal anal
D01.4 Outras partes do intestino e as não especificadas
D01.5 Fígado, vesícula biliar e vias biliares
D01.7 Outros órgãos especificados do aparelho digestivo
D01.9 Órgãos digestivos, não especificado
D02.0 Laringe
D02.1 Traquéia
D02.2 Brônquios e pulmões
D02.3 Outras partes do aparelho respiratório
D02.9 Aparelho respiratório, não especificado
D03.0 Melanoma in situ do lábio
D03.1 Melanoma in situ da pálpebra, incluindo o canto
D03.2 Melanoma in situ da orelha e do conduto auditivo externo
D03.3 Melanoma in situ de outras partes, e de partes não especificadas da face
D03.4 Melanoma in situ do couro cabeludo e do pescoço
D03.5 Melanoma in situ do tronco
D03.6 Melanoma in situ dos membros superiores, incluindo ombro
D03.7 Melanoma in situ dos membros inferiores, incluindo quadril
D03.8 Melanoma in situ de outras localizações
D03.9 Melanoma in situ, não especificado
D04.0 Pele do lábio
D04.1 Pele da pálpebra, incluindo o canto
D04.2 Pele da orelha e do conduto auditivo externo
D04.3 Pele de outras partes e de partes não especificadas da face
D04.4 Pele do couro cabeludo e do pescoço
D04.5 Pele do tronco
D04.6 Pele dos membros superiores, incluindo ombro
D04.7 Pele dos membros inferiores, incluindo quadril
D04.8 Pele de outras localizações
D04.9 Pele, não especificada
D05.0 Carcinoma lobular in situ
D05.1 Carcinoma intraductal in situ
D05.7 Outros carcinomas in situ
D05.9 Carcinoma in situ da mama, não especificado
D06.0 Endocérvix
D06.1 Exocérvix
D06.7 Outras partes do colo do útero
D06.9 Colo do útero, não especificado
D07.0 Endométrio
D07.1 Vulva
D07.2 Vagina
D07.3 Outros órgãos genitais femininos e os não especificados
D07.4 Pênis
D07.5 Próstata
D07.6 Outros órgãos genitais masculinos e os não especificados
D09.0 Bexiga
D09.1 Outros órgãos urinários e os não especificados
D09.2 Olho
D09.3 Tireóide e de outras glândulas endócrinas
D09.7 Carcinoma in situ de outras localizações especificadas
D09.9 Carcinoma in situ, não especificado
D10.0 Lábios
D10.1 Língua
D10.2 Assoalho da boca
D10.3 Outras partes da boca e as não especificadas
D10.4 Amígdala
D10.5 Outras partes da orofaringe
D10.6 Nasofaringe
D10.7 Hipofaringe
D10.9 Faringe, não especificada
D11.0 Glândula parótida
D11.7 Outras glândulas salivares maiores
D11.9 Glândula salivar maior, não especificada
D12.0 Ceco
D12.1 Apêndice (vermiforme)
D12.2 Cólon ascendente
D12.3 Cólon transverso
D12.4 Cólon descendente
D12.5 Cólon sigmóide
D12.6 Cólon, não especificada
D12.7 Junção retossigmóide
D12.8 Reto
D12.9 Canal anal e ânus
D13.0 Esôfago
D13.1 Estômago
D13.2 Duodeno
D13.3 Outras partes e partes não especificadas do intestino delgado
D13.4 Fígado
D13.5 Vias biliares extra­hepáticas
D13.6 Pâncreas
D13.7 Pâncreas endócrino
D13.9 Localizações mal definidas do aparelho digestivo
D14.0 Ouvido médio, cavidade nasal e seios paranasais
D14.1 Laringe
D14.2 Traquéia
D14.3 Brônquios e pulmão
D14.4 Aparelho respiratório, não especificado
D15.0 Timo
D15.1 Coração
D15.2 Mediastino
D15.7 Outros órgãos intratorácicos especificados
D15.9 Órgão intratorácico, não especificado
D16.0 Omoplata [escápula] e ossos longos dos membros superiores
D16.1 Ossos curtos dos membros superiores
D16.2 Ossos longos dos membros inferiores
D16.3 Ossos curtos dos membros inferiores
D16.4 Ossos do crânio e da face
D16.5 Osso da mandíbula
D16.6 Coluna vertebral
D16.7 Costelas, do esterno e da clavícula
D16.8 Ossos pélvicos, sacro e cóccix
D16.9 Osso e cartilagem articular, não especificado
D17.0 Neoplasia lipomatosa benigna da pele e do tecido subcutâneo da cabeça, face e pescoço
D17.1 Neoplasia lipomatosa benigna da pele e tecido subcutâneo do tronco
D17.2 Neoplasia lipomatosa benigna da pele e tecido subcutâneo dos membros
D17.3 Neoplasia lipomatosa benigna da pele e tecido subcutâneo de outras localizações e de
localizações não especificadas
D17.4 Neoplasia lipomatosa benigna de órgãos intratorácicos
D17.5 Neoplasia lipomatosa benigna de órgãos intra­abdominais
D17.6 Neoplasia lipomatosa benigna do cordão espermático
D17.7 Neoplasia lipomatosa benigna de outras localizações
D17.9 Neoplasia lipomatosa benigna de localização não especificada
D18.0 Hemangioma de qualquer localização
D18.1 Linfangioma de qualquer localização
D19.0 Tecido mesotelial da pleura
D19.1 Tecido mesotelial do peritônio
D19.7 Tecido mesotelial de outras localizações
D19.9 Tecido mesotelial, não especificado
D20.0 Retroperitônio
D20.1 Peritônio
D21.0 Tecido conjuntivo e outros tecidos moles da cabeça, face e pescoço
D21.1 Tecido conjuntivo e outros tecidos moles dos membros superiores, incluindo ombro
D21.2 Tecido conjuntivo e outros tecidos moles dos membros inferiores, incluindo quadril
D21.3 Tecido conjuntivo e outros tecidos moles do tórax
D21.4 Tecido conjuntivo e outros tecidos moles do abdome
D21.5 Tecido conjuntivo e outros tecidos moles da pelve
D21.6 Tecido conjuntivo e outros tecidos moles do tronco, não especificado
D21.9 Tecido conjuntivo e outros tecidos moles, sem outra especificação
D22.0 Nevo melanocítico do lábio
D22.1 Nevo melanocítico da pálpebra, incluindo o canto
D22.2 Nevo melanocítico da orelha e do conduto auditivo externo
D22.3 Nevo melanocítico de outras partes e de partes não especificadas da face
D22.4 Nevo melanocítico do couro cabeludo e do pescoço
D22.5 Nevo melanocítico do tronco
D22.6 Nevo melanocítico dos membros superiores, incluindo ombro
D22.7 Nevo melanocítico dos membros inferiores, incluindo quadril
D22.9 Nevo melanocítico, não especificado
D23.0 Pele dos lábios
D23.1 Pele da pálpebra, incluindo o canto
D23.2 Pele da orelha e do conduto auditivo externo
D23.3 Pele de outras partes e de partes não especificadas da face
D23.4 Pele do couro cabeludo e do pescoço
D23.5 Pele do tronco
D23.6 Pele dos membros superiores, incluindo o ombro
D23.7 Pele dos membros inferiores, incluindo o quadril
D23.9 Pele, não especificada
D24 Neoplasia benigna da mama
D25.0 Leiomioma submucoso do útero
D25.1 Leiomioma intramural do útero
D25.2 Leiomioma subseroso do útero
D25.9 Leiomioma do útero, não especificado
D26.0 Colo do útero
D26.1 Corpo do útero
D26.7 Outras partes do útero
D26.9 Útero, não especificado
D27 Neoplasia benigna do ovário
D28.0 Vulva
D28.1 Vagina
D28.2 Trompas e ligamentos uterinos
D28.7 Outros órgãos genitais femininos especificados
D28.9 Órgão genital feminino, não especificado
D29.0 Pênis
D29.1 Próstata
D29.2 Testículos
D29.3 Epidídimo
D29.4 Escroto
D29.7 Outros órgãos genitais masculinos
D29.9 Órgão genital masculino, não especificado
D30.0 Rim
D30.1 Pelve renal
D30.2 Ureter
D30.3 Bexiga
D30.4 Uretra
D30.7 Outros órgãos urinários
D30.9 Órgão urinário, não especificado
D31.0 Conjuntiva
D31.1 Córnea
D31.2 Retina
D31.3 Coróide
D31.4 Corpo ciliar
D31.5 Glândulas e dos canais lacrimais
D31.6 Órbita, não especificada
D31.9 Olho, não especificado
D32.0 Meninges cerebrais
D32.1 Meninges espinhais
D32.9 Meninges, não especificada
D33.0 Encéfalo, supratentorial
D33.1 Encéfalo, infratentorial
D33.2 Encéfalo, não especificado
D33.3 Nervos cranianos
D33.4 Medula espinhal
D33.7 Outras partes especificadas do sistema nervoso central
D33.9 Sistema nervoso central, não especificado
D34 Neoplasia benigna da glândula tireóide
D35.0 Glândula supra­renal (adrenal)
D35.1 Glândula paratireóide
D35.2 Glândula hipófise (pituitária)
D35.3 Conduto craniofaríngeo
D35.4 Glândula pineal
D35.5 Corpo carotídeo
D35.6 Corpos aórticos e outros paragânglios
D35.7 Outras glândulas endócrinas especificadas
D35.8 Comprometimento pluriglandular
D35.9 Glândula endócrina, não especificada
D36.0 Gânglios linfáticos (linfonodos)
D36.1 Nervos periféricos e sistema nervoso autônomo
D36.7 Outras localizações especificadas
D36.9 Neoplasia benigna de localização não especificada
D37.0 Lábio, cavidade oral e faringe
D37.1 Estômago
D37.2 Intestino delgado
D37.3 Apêndice
D37.4 Cólons
D37.5 Reto
D37.6 Fígado, vesícula biliar e vias biliares
D37.7 Outros órgãos digestivos
D37.9 Órgão digestivo, não especificado
D38.0 Laringe
D38.1 Traquéia, brônquios e pulmão
D38.2 Pleura
D38.3 Mediastino
D38.4 Timo
D38.5 Outros órgãos respiratórios
D38.6 Órgão respiratório, não especificado
D39.0 Útero
D39.1 Ovário
D39.2 Placenta
D39.7 Outros órgãos genitais femininos
D39.9 Órgão genital feminino não especificado
D40.0 Próstata
D40.1 Testículo
D40.7 Outros órgãos genitais masculinos
D40.9 Órgão genital masculino, não especificado
D41.0 Rim
D41.1 Pelve renal
D41.2 Ureter
D41.3 Uretra
D41.4 Bexiga
D41.7 Outros órgãos urinários
D41.9 Órgão urinário, não especificado
D42.0 Meninges cerebrais
D42.1 Meninges espinhais
D42.9 Meninges não especificadas
D43.0 Encéfalo, supratentorial
D43.1 Encéfalo, infratentorial
D43.2 Encéfalo, não especificado
D43.3 Nervos cranianos
D43.4 Medula espinhal
D43.7 Outras partes do sistema nervoso central
D43.9 Sistema nervoso central, não especificado
D44.0 Glândula tireóide
D44.1 Glândula supra­renal (adrenal)
D44.2 Glândula paratireóide
D44.3 Glândula hipófise (pituitária)
D44.4 Conduto craniofaríngeo
D44.5 Glândula pineal
D44.6 Corpo carotídeo
D44.7 Corpos aórticos e outros paragânglios
D44.8 Comprometimento pluriglandular
D44.9 Glândula endócrina, não especificada
D45 Policitemia vera
D46.0 Anemia refratária sem sideroblastos
D46.1 Anemia refratária com sideroblastos
D46.2 Anemia refratária com excesso de blastos
D46.3 Anemia refratária com excesso de blastos com transformação
D46.4 Anemia refratária, não especificada
D46.7 Outras síndromes mielodisplásicas
D46.9 Síndrome mielodisplásica, não especificada
D47.0 Tumores de comportamento incerto ou desconhecido de mastócitos e células histiocíticas
D47.1 Doença mieloproliferativa crônica
D47.2 Gamopatia monoclonal
D47.3 Trombocitemia essencial (hemorrágica)
D47.7 Outras neoplasias especificadas de comportamento incerto ou desconhecido dos tecidos
linfático, hematopoético e tecidos relacionados
D47.9 Neoplasia de comportamento incerto ou desconhecido dos tecidos linfático, hematopoético e
tecidos correlatos, não especificada
D48.0 Ossos e cartilagens articulares
D48.1 Tecido conjuntivo e outros tecidos moles
D48.2 Nervos periféricos e do sistema nervoso periférico
D48.3 Retroperitônio
D48.4 Peritônio
D48.5 Pele
D48.6 Mama
D48.7 Outras localizações especificadas
D48.9 Neoplasia de comportamento incerto ou desconhecido sem outra especificação
D50.0 Anemia por deficiência de ferro secundária à perda de sangue (crônica)
D50.1 Disfagia sideropênica
D50.8 Outras anemias por deficiência de ferro
D50.9 Anemia por deficiência de ferro não especificada
D51.0 Anemia por deficiência de vitamina B12 devida à deficiência de fator intrínseco
D51.1 Anemia por deficiência de vitamina B12 devida à má­absorção seletiva de vitamina B12 com
proteinúria
D51.2 Deficiência de transcobalamina II
D51.3 Outras anemias por deficiência de vitamina B12 na dieta
D51.8 Outras anemias por deficiência de vitamina B12
D51.9 Anemia por deficiência de vitamina B12 não especificada
D52.0 Anemia por deficiência de folato na dieta
D52.1 Anemia por deficiência de folato induzida por drogas
D52.8 Outras anemias por deficiência de folato
D52.9 Anemia por deficiência de folato não especificada
D53.0 Anemia por deficiência de proteínas
D53.1 Outras anemias megaloblásticas não classificadas em outras partes
D53.2 Anemia escorbútica
D53.8 Outras anemias nutricionais especificadas
D53.9 Anemia nutricional não especificada
D55.0 Anemia devida à deficiência de glicose­6­fosfato­desidrogenase [G­6­PD]
D55.1 Anemia devida a outros transtornos do metabolismo do glutation
D55.2 Anemia devida a transtornos das enzimas glicolíticas
D55.3 Anemia devida a transtornos do metabolismo de nucleotídios
D55.8 Outras anemias devidas a transtornos enzimáticos
D55.9 Anemia devida a transtorno enzimático não especificada
D56.0 Talassemia alfa
D56.1 Talassemia beta
D56.2 Talassemia delta­beta
D56.3 Estigma talassêmico
D56.4 Persistência hereditária de hemoglobina fetal
D56.8 Outras talassemias
D56.9 Talassemia não especificada
D57.0 Anemia falciforme com crise
D57.1 Anemia falciforme sem crise
D57.2 Transtornos falciformes heterozigóticos duplos
D57.3 Estigma falciforme
D57.8 Outros transtornos falciformes
D58.0 Esferocitose hereditária
D58.1 Eliptocitose hereditária
D58.2 Outras hemoglobinopatias
D58.8 Outras anemias hemolíticas hereditárias especificadas
D58.9 Anemia hemolítica hereditária não especificada
D59.0 Anemia hemolítica auto­imune induzida por droga
D59.1 Outras anemias hemolíticas auto­imunes
D59.2 Anemia hemolítica não­auto­imune induzida por drogas
D59.3 Síndrome hemolítico­urêmica
D59.4 Outras anemias hemolíticas não­autoimunes
D59.5 Hemoglobinúria paroxística noturna [Marchiafava­Micheli]
D59.6 Hemoglobinúria devida à hemólise por outras causas externas
D59.8 Outras anemias hemolíticas adquiridas
D59.9 Anemia hemolítica adquirida não especificada
D60.0 Aplasia pura adquirida crônica da série vermelha
D60.1 Aplasia pura adquirida transitória da série vermelha
D60.8 Outras aplasias puras adquiridas da série vermelha
D60.9 Aplasia pura adquirida, não especificada, da série vermelha
D61.0 Anemia aplástica constitucional
D61.1 Anemia aplástica induzida por drogas
D61.2 Anemia aplástica devida a outros agentes externos
D61.3 Anemia aplástica idiopática
D61.8 Outras anemias aplásticas especificadas
D61.9 Anemia aplástica não especificada
D62 Anemia aguda pós­hemorrágica
D63.0*Anemia em neoplasias (C00­D48+)
D63.8*Anemia em outras doenças classificadas em outra parte
D64.0 Anemia sideroblástica hereditária
D64.1 Anemia sideroblástica secundária a doença
D64.2 Anemia sideroblástica secundária ao uso de drogas e a toxinas
D64.3 Outras anemias sideroblásticas
D64.4 Anemia diseritropoética congênita
D64.8 Outras anemias especificadas
D64.9 Anemia não especificada
D65 Coagulação intravascular disseminada [síndrome de desfibrinação]
D66 Deficiência hereditária do fator VIII
D67 Deficiência hereditária do fator IX
D68.0 Doença de Von Willebrand
D68.1 Deficiência hereditária de fator XI
D68.2 Deficiência hereditária de outros fatores de coagulação
D68.3 Transtorno hemorrágico devido a anticoagulantes circulantes
D68.4 Deficiência adquirida de fator de coagulação
D68.8 Outros defeitos especificados da coagulação
D68.9 Defeito de coagulação não especificado
D69.0 Púrpura alérgica
D69.1 Defeitos qualitativos das plaquetas
D69.2 Outras púrpuras não­trombocitopênicas
D69.3 Púrpura trombocitopênica idiopática
D69.4 Outra trombocitopenia primária
D69.5 Trombocitopenia secundária
D69.6 Trombocitopenia não especificada
D69.8 Outras afecções hemorrágicas especificadas
D69.9 Afecção hemorrágica não especificada
D70 Agranulocitose
D71 Transtornos funcionais dos neutrófilos polimorfonucleares
D72.0 Anomalias genéticas dos leucócitos
D72.1 Eosinofilia
D72.8 Outros transtornos especificados dos glóbulos brancos
D72.9 Transtornos não especificados dos glóbulos brancos
D73.0 Hipoesplenismo
D73.1 Hiperesplenismo
D73.2 Esplenomegalia congestiva crônica
D73.3 Abscesso do baço
D73.4 Cisto do baço
D73.5 Infarto do baço
D73.8 Outras doenças do baço
D73.9 Doença não especificada do baço
D74.0 Metemoglobinemia congênita
D74.8 Outras metemoglobinemias
D74.9 Metemoglobinemia não especificada
D75.0 Eritrocitose familiar
D75.1 Policitemia secundária
D75.2 Trombocitose essencial
D75.8 Outras doenças especificadas do sangue e dos órgãos hematopoéticos
D75.9 Doença não especificada do sangue e dos órgãos hematopoéticos
D76.0 Histiocitose das células de Langerhans não classificadas em outra parte
D76.1 Linfohistiocitose hemofagocítica
D76.2 Síndrome hematofagocítica associada à infecção
D76.3 Outras síndromes histiocíticas
D77 *Outros transtornos do sangue e dos órgãos hematopoéticos em doenças classificadas em outra
parte
D80.0 Hipogamaglobulinemia hereditária
D80.1 Hipogamaglobulinemia não familiar
D80.2 Deficiência seletiva de imunoglobulina A [IgA]
D80.3 Deficiência seletiva de subclasses de imunoglobulina G [IgG]
D80.4 Deficiência seletiva de imunoglobulina M [IgM]
D80.5 Imunodeficiência com aumento de imunoglobulina M [IgM]
D80.6 Deficiência de anticorpos com imunoglobulinas próximas do normal ou com
hiperimunoglobulinemia
D80.7 Hipogamaglobulinemia transitória da infância
D80.8 Outras imunodeficiências com predominância de defeitos de anticorpos
D80.9 Imunodeficiência não especificada com predominância de defeitos de anticorpos
D81.0 Imunodeficiência combinada grave [SCID] com disgenesia reticular
D81.1 Imunodeficiência combinada grave [SCID] com números baixos de células T e B
D81.2 Imunodeficiência combinada grave [SCID] com números baixos ou normais de células B
D81.3 Deficiência de adenosina­deaminase [ADA]
D81.4 Síndrome de Nezelof
D81.5 Deficiência de purina­nucleosídeo fosforilase [PNP]
D81.6 Deficiência major classe I do complexo de histocompatibilidade
D81.7 Deficiência major classe II do complexo de histocompatibilidade
D81.8 Outras deficiências imunitárias combinadas
D81.9 Deficiências imunitárias combinadas não especificadas
D82.0 Síndrome de Wiskott­Aldrich
D82.1 Síndrome de Di George
D82.2 Imunodeficiência com encurtamento de membros
D82.3 Imunodeficiência que se segue à resposta hereditária defeituosa ao vírus de Epstein­Barr (EB)
D82.4 Síndrome da hiperimunoglobulina E [IgE]
D82.8 Imunodeficiências associadas com outros defeitos "major" especificados
D82.9 Imunodeficiência associada com defeitos "major" não especificados
D83.0 Imunodeficiência comum variável com predominância de anormalidades do número e da função
das células B
D83.1 Imunodeficiência comum variável com predominância de transtornos imunorregulatórios de
células T
D83.2 Imunodeficiência comum variável com auto­anticorpos às células B ou T
D83.8 Outras imunodeficiências comuns variáveis
D83.9 Imunodeficiência comum variável não especificada
D84.0 Defeito do antígeno­1 da função de linfócito [LFA­1]
D84.1 Defeitos no sistema complemento
D84.8 Outras imunodeficiências especificadas
D84.9 Imunodeficiência não especificada
D86.0 Sarcoidose do pulmão
D86.1 Sarcoidose dos gânglios linfáticos
D86.2 Sarcoidose do pulmão com sarcoidose dos gânglios linfáticos
D86.3 Sarcoidose da pele
D86.8 Sarcoidose de outros locais especificados e locais combinados
D86.9 Sarcoidose não especificada
D89.0 Hipergamaglobulinemia policlonal
D89.1 Crioglobulinemia
D89.2 Hipergamaglobulinemia não especificada
D89.8 Outros transtornos especificados que comprometem o mecanismo imunitário não classificados
em outra parte
D89.9 Transtornos não especificados que comprometem o mecanismo imunitário
E00.0 Síndrome da deficiência congênita de iodo do tipo neurológico
E00.1 Síndrome da deficiência congênita de iodo do tipo mixedematoso
E00.2 Síndrome da deficiência congênita de iodo do tipo misto
E00.9 Síndrome da deficiência congênita de iodo, não especificada
E01.0 Bócio (endêmico) difuso por deficiência de iodo
E01.1 Bócio (endêmico) multinodular por deficiência de iodo
E01.2 Bócio (endêmico) não especificado, por deficiência de iodo
E01.8 Outros transtornos tireoidianos e afecções associadas, relacionados com a deficiência de iodo
E02 Hipotireoidismo subclínico por deficiência de iodo
E03.0 Hipotireoidismo congênito com bócio difuso
E03.1 Hipotireoidismo congênito sem bócio
E03.2 Hipotireoidismo devido a medicamentos e outras substâncias exógenas
E03.3 Hipotireoidismo pós­infeccioso
E03.4 Atrofia (adquirida) da tireóide
E03.5 Coma mixedematoso
E03.8 Outros hipotireoidismos especificados
E03.9 Hipotireoidismo não especificado
E04.0 Bócio não­tóxico difuso
E04.1 Bócio não­tóxico uninodular
E04.2 Bócio não­tóxico multinodular
E04.8 Outro bócio não­tóxico especificado
E04.9 Bócio não­tóxico, não especificado
E05.0 Tireotoxicose com bócio difuso
E05.1 Tireotoxicose com bócio tóxico uninodular
E05.2 Tireotoxicose com bócio tóxico multinodular
E05.3 Tireotoxicose causada por tecido tireoidiano ectópico
E05.4 Tireotoxicose factícia
E05.5 Crise ou "tempestade" tireotóxica
E05.8 Outras tireotoxicoses
E05.9 Tireotoxicose não especificada
E06.0 Tireoidite aguda
E06.1 Tireoidite subaguda
E06.2 Tireoidite crônica com tireotoxicose transitória
E06.3 Tireoidite auto­imune
E06.4 Tireoidite induzida por droga
E06.5 Outras tireoidites crônicas
E06.9 Tireoidite não especificada
E07.0 Hipersecreção de calcitonina
E07.1 Bócio disormonogênico
E07.8 Outros transtornos especificados da tireóide
E07.9 Transtorno não especificado da tireóide
E10.0 Diabetes mellitus insulino­dependente ­ com coma
E10.1 Diabetes mellitus insulino­dependente ­ com cetoacidose
E10.2+Diabetes mellitus insulino­dependente ­ com complicações renais
E10.3+Diabetes mellitus insulino­dependente ­ com complicações oftálmicas
E10.4+Diabetes mellitus insulino­dependente ­ com complicações neurológicas
E10.5 Diabetes mellitus insulino­dependente ­ com complicações circulatórias periféricas
E10.6 Diabetes mellitus insulino­dependente ­ com outras complicações especificadas
E10.7 Diabetes mellitus insulino­dependente ­ com complicações múltiplas
E10.8 Diabetes mellitus insulino­dependente ­ com complicações não especificadas
E10.9 Diabetes mellitus insulino­dependente ­ sem complicações
E11.0 Diabetes mellitus não­insulino­dependente ­ com coma
E11.1 Diabetes mellitus não­insulino­dependente ­ com cetoacidose
E11.2+Diabetes mellitus não­insulino­dependente ­ com complicações renais
E11.3+Diabetes mellitus não­insulino­dependente ­ com complicações oftálmicas
E11.4+Diabetes mellitus não­insulino­dependente ­ com complicações neurológicas
E11.5 Diabetes mellitus não­insulino­dependente ­ com complicações circulatórias periféricas
E11.6 Diabetes mellitus não­insulino­dependente ­ com outras complicações especificadas
E11.7 Diabetes mellitus não­insulino­dependente ­ com complicações múltiplas
E11.8 Diabetes mellitus não­insulino­dependente ­ com complicações não especificadas
E11.9 Diabetes mellitus não­insulino­dependente ­ sem complicações
E12.0 Diabetes mellitus relacionado com a desnutrição ­ com coma
E12.1 Diabetes mellitus relacionado com a desnutrição ­ com cetoacidose
E12.2+Diabetes mellitus relacionado com a desnutrição ­ com complicações renais
E12.3+Diabetes mellitus relacionado com a desnutrição ­ com complicações oftálmicas
E12.4+Diabetes mellitus relacionado com a desnutrição ­ com complicações neurológicas
E12.5 Diabetes mellitus relacionado com a desnutrição ­ com complicações circulatórias periféricas
E12.6 Diabetes mellitus relacionado com a desnutrição ­ com outras complicações especificadas
E12.7 Diabetes mellitus relacionado com a desnutrição ­ com complicações múltiplas
E12.8 Diabetes mellitus relacionado com a desnutrição ­ com complicações não especificadas
E12.9 Diabetes mellitus relacionado com a desnutrição ­ sem complicações
E13.0 Outros tipos especificados de diabetes mellitus ­ com coma
E13.1 Outros tipos especificados de diabetes mellitus ­ com cetoacidose
E13.2+Outros tipos especificados de diabetes mellitus ­ com complicações renais
E13.3+Outros tipos especificados de diabetes mellitus ­ com complicações oftálmicas
E13.4+Outros tipos especificados de diabetes mellitus ­ com complicações neurológicas
E13.5 Outros tipos especificados de diabetes mellitus ­ com complicações circulatórias periféricas
E13.6 Outros tipos especificados de diabetes mellitus ­ com outras complicações especificadas
E13.7 Outros tipos especificados de diabetes mellitus ­ com complicações múltiplas
E13.8 Outros tipos especificados de diabetes mellitus ­ com complicações não especificadas
E13.9 Outros tipos especificados de diabetes mellitus ­ sem complicações
E14.0 Diabetes mellitus não especificado ­ com coma
E14.1 Diabetes mellitus não especificado ­ com cetoacidose
E14.2+Diabetes mellitus não especificado ­ com complicações renais
E14.3+Diabetes mellitus não especificado ­ com complicações oftálmicas
E14.4+Diabetes mellitus não especificado ­ com complicações neurológicas
E14.5 Diabetes mellitus não especificado ­ com complicações circulatórias periféricas
E14.6 Diabetes mellitus não especificado ­ com outras complicações especificadas
E14.7 Diabetes mellitus não especificado ­ com complicações múltiplas
E14.8 Diabetes mellitus não especificado ­ com complicações não especificadas
E14.9 Diabetes mellitus não especificado ­ sem complicações
E15 Coma hipoglicêmico não­diabético
E16.0 Hipoglicemia induzida por droga sem coma
E16.1 Outra hipoglicemia
E16.2 Hipoglicemia não especificada
E16.3 Aumento da secreção de glucagon
E16.4 Secreção anormal de gastrina
E16.8 Outros transtornos especificados da secreção pancreática interna
E16.9 Transtorno não especificado da secreção pancreática interna
E20.0 Hipoparatireoidismo idiopático
E20.1 Pseudohipoparatireoidismo
E20.8 Outro hipoparatireoidismo
E20.9 Hipoparatireoidismo não especificado
E21.0 Hiperparatireoidismo primário
E21.1 Hiperparatireoidismo secundário não classificado em outra parte
E21.2 Outro hiperparatireoidismo
E21.3 Hiperparatireoidismo não especificado
E21.4 Outros transtornos especificados da glândula paratireóide
E21.5 Transtorno não especificado da glândula paratireóide
E22.0 Acromegalia e gigantismo hipofisário
E22.1 Hiperprolactinemia
E22.2 Síndrome da secreção inadequada de hormônio antidiurético
E22.8 Outras hiperfunções da hipófise
E22.9 Hiperfunção não especificada da hipófise
E23.0 Hipopituitarismo
E23.1 Hipopituitarismo induzido por droga
E23.2 Diabetes insípido
E23.3 Disfunção hipotalâmica não classificada em outra parte
E23.6 Outros transtornos da hipófise
E23.7 Transtorno não especificado da hipófise
E24.0 Síndrome de Cushing dependente da hipófise
E24.1 Síndrome de Nelson
E24.2 Síndrome de Cushing induzida por droga
E24.3 Síndrome do ACTH ectópico
E24.4 Síndrome de pseudo­Cushing induzida pelo álcool
E24.8 Outra síndrome de Cushing
E24.9 Síndrome de Cushing não especificada
E25.0 Transtornos adrenogenitais congênitos associados à deficiência enzimática
E25.8 Outros transtornos adrenogenitais
E25.9 Transtorno adrenogenital não especificado
E26.0 Hiperaldosteronismo primário
E26.1 Hiperaldosteronismo secundário
E26.8 Outro hiperaldosteronismo
E26.9 Hiperaldosteronismo não especificado
E27.0 Outros excessos de atividade adrenocortical
E27.1 Insuficiência adrenocortical primária
E27.2 Crise addisoniana
E27.3 Insuficiência adrenocortical induzida por drogas
E27.4 Outras insuficiências adrenocorticais e as não especificadas
E27.5 Hiperfunção adrenomedular
E27.8 Outros transtornos especificados da supra­renal
E27.9 Transtorno não especificado da supra­renal
E28.0 Excesso de estrógeno
E28.1 Excesso de andrógenos
E28.2 Síndrome do ovário policístico
E28.3 Insuficiência ovariana primária
E28.8 Outra disfunção ovariana
E28.9 Disfunção ovariana não especificada
E29.0 Hiperfunção testicular
E29.1 Hipofunção testicular
E29.8 Outra disfunção testicular
E29.9 Disfunção testicular não especificada
E30.0 Puberdade retardada
E30.1 Puberdade precoce
E30.8 Outros transtornos da puberdade
E30.9 Transtorno não especificado da puberdade
E31.0 Insuficiência poliglandular auto­imune
E31.1 Hiperfunção poliglandular
E31.8 Outra disfunção poliglandular
E31.9 Disfunção poliglandular não especificada
E32.0 Hiperplasia persistente do timo
E32.1 Abscesso do timo
E32.8 Outras doenças do timo
E32.9 Doença do timo não especificada
E34.0 Síndrome carcinóide
E34.1 Outra hipersecreção de hormônios intestinais
E34.2 Secreção hormonal ectópica, não classificada em outra parte
E34.3 Nanismo, não classificado em outra parte
E34.4 Alta estatura constitucional
E34.5 Síndrome de resistência a andrógenos
E34.8 Outros transtornos endócrinos especificados
E34.9 Transtorno endócrino não especificado
E35.0*Transtornos da glândula tireóide em doenças classificadas em outra parte
E35.1*Transtornos das supra­renais em doenças classificadas em outra parte
E35.8*Transtornos de outras glândulas endócrinas em doenças classificadas em outra parte
E40 Kwashiorkor
E41 Marasmo nutricional
E42 Kwashiorkor marasmático
E43 Desnutrição protéico­calórica grave não especificada
E44.0 Desnutrição protéico­calórica moderada
E44.1 Desnutrição protéico­calórica leve
E45 Atraso do desenvolvimento devido à desnutrição protéico­calórica
E46 Desnutrição protéico­calórica não especificada
E50.0 Deficiência de vitamina A com xerose conjuntival
E50.1 Deficiência de vitamina A com mancha de Bitot e xerose conjuntival
E50.2 Deficiência de vitamina A com xerose da córnea
E50.3 Deficiência de vitamina A com ulceração e xerose da córnea
E50.4 Deficiência de vitamina A com ceratomalácia
E50.5 Deficiência de vitamina A com cegueira noturna
E50.6 Deficiência de vitamina A com cicatrizes xeroftálmicas da córnea
E50.7 Outras manifestações oculares devidas a deficiência de vitamina A
E50.8 Outras manifestações devidas a deficiência de vitamina A
E50.9 Deficiência não especificada de vitamina A
E51.1 Beribéri
E51.2 Encefalopatia de Wernicke
E51.8 Outras manifestações da deficiência de tiamina
E51.9 Deficiência não especificada de tiamina
E52 Deficiência de niacina [pelagra]
E53.0 Deficiência de riboflavina
E53.1 Deficiência de piridoxina
E53.8 Deficiência de outras vitaminas especificadas do grupo B
E53.9 Deficiência não especificada de vitamina B
E54 Deficiência de ácido ascórbico
E55.0 Raquitismo ativo
E55.9 Deficiência não especificada de vitamina D
E56.0 Deficiência de vitamina E
E56.1 Deficiência de vitamina K
E56.8 Deficiência de outras vitaminas
E56.9 Deficiência vitamínica não especificada
E58 Deficiência de cálcio da dieta
E59 Deficiência de selênio da dieta
E60 Deficiência de zinco da dieta
E61.0 Deficiência de cobre
E61.1 Deficiência de ferro
E61.2 Deficiência de magnésio
E61.3 Deficiência de manganês
E61.4 Deficiência de cromo
E61.5 Deficiência de molibdênio
E61.6 Deficiência de vanádio
E61.7 Deficiência de múltiplos elementos nutrientes
E61.8 Deficiência de outros elementos nutrientes especificados
E61.9 Deficiência de elementos nutrientes não especificados
E63.0 Deficiência de ácido graxo essencial
E63.1 Desequilíbrio de constituintes da ingestão de alimentos
E63.8 Outras deficiências nutricionais especificadas
E63.9 Deficiência nutricional não especificada
E64.0 Seqüelas de desnutrição protéico­calórica
E64.1 Seqüelas da deficiência de vitamina A
E64.2 Seqüelas da deficiência de vitamina C
E64.3 Seqüelas do raquitismo
E64.8 Seqüelas de outras deficiências nutricionais
E64.9 Seqüelas de deficiência nutricional não especificada
E65 Adiposidade localizada
E66.0 Obesidade devida a excesso de calorias
E66.1 Obesidade induzida por drogas
E66.2 Obesidade extrema com hipoventilação alveolar
E66.8 Outra obesidade
E66.9 Obesidade não especificada
E67.0 Hipervitaminose A
E67.1 Hipercarotenemia
E67.2 Síndrome de megavitamina B6
E67.3 Hipervitaminose D
E67.8 Outras formas especificadas de hiperalimentação
E68 Seqüelas de hiperalimentação
E70.0 Fenilcetonúria clássica
E70.1 Outras hiperfenilalaninemias
E70.2 Distúrbios do metabolismo da tirosina
E70.3 Albinismo
E70.8 Outros distúrbios do metabolismo de aminoácidos aromáticos
E70.9 Distúrbio não especificado do metabolismo de aminoácidos aromáticos
E71.0 Doença da urina em xarope de ácer (ou bordo) (Maple­syrup urine disease)
E71.1 Outros distúrbios do metabolismo de aminoácidos de cadeia ramificada
E71.2 Distúrbio não especificado do metabolismo de aminoácidos de cadeia ramificada
E71.3 Distúrbios do metabolismo de ácidos graxos
E72.0 Distúrbios do transporte de aminoácidos
E72.1 Distúrbios do metabolismo dos aminoácidos que contêm enxofre
E72.2 Distúrbios do metabolismo do ciclo da uréia
E72.3 Distúrbios do metabolismo da lisina e da hidroxilisina
E72.4 Distúrbios do metabolismo da ornitina
E72.5 Distúrbios do metabolismo da glicina
E72.8 Outros distúrbios especificados do metabolismo dos aminoácidos
E72.9 Distúrbio não especificado do metabolismo dos aminoácidos
E73.0 Deficiência congênita de lactase
E73.1 Deficiência secundária de lactase
E73.8 Outras intolerâncias à lactose
E73.9 Intolerância à lactose, não especificada
E74.0 Doença de depósito de glicogênio
E74.1 Distúrbios do metabolismo da frutose
E74.2 Distúrbios do metabolismo da galactose
E74.3 Outros distúrbios da absorção intestinal de carboidratos
E74.4 Distúrbios do metabolismo do piruvato e da gliconeogênese
E74.8 Outros distúrbios especificados do metabolismo de carboidratos
E74.9 Distúrbio não especificado do metabolismo de carboidratos
E75.0 Gangliosidose GM2
E75.1 Outras gangliosidoses
E75.2 Outras esfingolipidoses
E75.3 Esfingolipidose não especificada
E75.4 Lipofuscinose neuronal ceróide
E75.5 Outros distúrbios do depósito de lípides
E75.6 Distúrbio não especificado do depósito de lípides
E76.0 Mucopolissacaridose do tipo I
E76.1 Mucopolissacaridose do tipo II
E76.2 Outras mucopolissacaridoses
E76.3 Mucopolissacaridose não especificada
E76.8 Outros distúrbios do metabolismo do glicosaminoglicano
E76.9 Distúrbio não especificado do metabolismo do glicosaminoglicano
E77.0 Defeitos na modificação pós­translacional de enzimas lisossômicas
E77.1 Defeitos na degradação das glicoproteínas
E77.8 Outros distúrbios do metabolismo de glicoproteínas
E77.9 Distúrbio não especificado do metabolismo de glicoproteínas
E78.0 Hipercolesterolemia pura
E78.1 Hipergliceridemia pura
E78.2 Hiperlipidemia mista
E78.3 Hiperquilomicronemia
E78.4 Outras hiperlipidemias
E78.5 Hiperlipidemia não especificada
E78.6 Deficiências de lipoproteínas
E78.8 Outros distúrbios do metabolismo de lipoproteínas
E78.9 Distúrbio não especificado do metabolismo de lipoproteínas
E79.0 Hiperuricemia sem sinais de artrite inflamatória e de doença com tofos
E79.1 Síndrome de Lesch­Nyhan
E79.8 Outros distúrbios do metabolismo da purina e pirimidina
E79.9 Distúrbio não especificado do metabolismo da purina e pirimidina
E80.0 Porfiria hereditária eritropoética
E80.1 Porfiria cutânea tardia
E80.2 Outras porfirias
E80.3 Defeitos da catalase e da peroxidase
E80.4 Síndrome de Gilbert
E80.5 Síndrome da Crigler­Najjar
E80.6 Outros distúrbios do metabolismo da bilirrubina
E80.7 Distúrbio não especificado do metabolismo da bilirrubina
E83.0 Distúrbios do metabolismo do cobre
E83.1 Doença do metabolismo do ferro
E83.2 Distúrbios do metabolismo do zinco
E83.3 Distúrbios do metabolismo do fósforo
E83.4 Distúrbios do metabolismo do magnésio
E83.5 Distúrbios do metabolismo do cálcio
E83.8 Outros distúrbios do metabolismo mineral
E83.9 Distúrbio não especificado do metabolismo mineral
E84.0 Fibrose cística com manifestações pulmonares
E84.1 Fibrose cística com manifestações intestinais
E84.8 Fibrose cística com outras manifestações
E84.9 Fibrose cística não especificada
E85.0 Amiloidose heredofamiliar não­neuropática
E85.1 Amiloidose heredofamiliar neuropática
E85.2 Amiloidose heredofamiliar não especificada
E85.3 Amiloidose sistêmica secundária
E85.4 Amiloidose limitada a órgãos
E85.8 Outras amiloidoses
E85.9 Amiloidose não especificada
E86 Depleção de volume
E87.0 Hiperosmolaridade e hipernatremia
E87.1 Hiposmolaridade e hiponatremia
E87.2 Acidose
E87.3 Alcalose
E87.4 Distúrbio misto do equilíbrio ácido­básico
E87.5 Hiperpotassemia
E87.6 Hipopotassemia
E87.7 Sobrecarga de líquidos
E87.8 Outros transtornos do equilíbrio hidroeletrolítico não classificados em outra parte
E88.0 Distúrbios do metabolismo das proteínas plasmáticas não classificados em outra parte
E88.1 Lipodistrofia não classificada em outra parte
E88.2 Lipomatose não classificada em outra parte
E88.8 Outros distúrbios especificados do metabolismo
E88.9 Distúrbio metabólico não especificado
E89.0 Hipotireoidismo pós­procedimento
E89.1 Hipoinsulinemia pós­procedimento
E89.2 Hipoparatireoidismo pós­procedimento
E89.3 Hipopituitarismo pós­procedimento
E89.4 Insuficiência ovariana pós­procedimento
E89.5 Hipofunção testicular pós­procedimento
E89.6 Hipofunção adrenocortical(­medular) pós­procedimento
E89.8 Outros transtornos endócrinos e metabólicos pós­procedimento
E89.9 Transtornos endócrinos e metabólicos não especificados pós­procedimento
E90 *Transtornos nutricionais e metabólicos em doenças classificadas em outra parte
F00.0*Demência na doença de Alzheimer de início precoce (G30.0+)
F00.1*Demência na doença de Alzheimer de início tardio (G30.1+)
F00.2*Demência na doença de Alzheimer, forma atípica ou mista (G30.8+)
F00.9*Demência não especificada na doença de Alzheimer (G30.9+)
F01.0 Demência vascular de início agudo
F01.1 Demência por infartos múltiplos
F01.2 Demência vascular subcortical
F01.3 Demência vascular mista, cortical e subcortical
F01.8 Outra demência vascular
F01.9 Demência vascular não especificada
F02.0*Demência da doença de Pick (G31.0+)
F02.1*Demência na doença de Creutzfeldt­Jakob (A81.0+)
F02.2*Demência na doença de Huntington (G10+)
F02.3*Demência na doença de Parkinson (G20+)
F02.4*Demência na doença do vírus da imunodeficiência humana [HIV] (B22.0+)
F02.8*Demência em outras doenças especificadas classificadas em outra parte
F03 Demência não especificada
F04 Síndrome amnésica orgânica não induzida pelo álcool ou por outras substâncias psicoativas
F05.0 Delirium não superposto a uma demência, assim descrito
F05.1 Delirium superposto a uma demência
F05.8 Outro delirium
F05.9 Delirium não especificado
F06.0 Alucinose orgânica
F06.1 Estado catatônico orgânico
F06.2 Transtorno delirante orgânico [tipo esquizofrênico]
F06.3 Transtornos do humor [afetivos] orgânicos
F06.4 Transtornos da ansiedade orgânicos
F06.5 Transtorno dissociativo orgânico
F06.6 Transtorno de labilidade emocional [astênico] orgânico
F06.7 Transtorno cognitivo leve
F06.8 Outros transtornos mentais especificados devidos a uma lesão e disfunção cerebral e a uma
doença física
F06.9 Transtorno mental não especificado devido a uma lesão e disfunção cerebral e a uma doença
física
F07.0 Transtorno orgânico da personalidade
F07.1 Síndrome pós­encefalítica
F07.2 Síndrome pós­traumática
F07.8 Outros transtornos orgânicos da personalidade e do comportamento devidos a doença cerebral,
lesão e disfunção
F07.9 Transtorno orgânico não especificado da personalidade e do comportamento devido a doença
cerebral, lesão e disfunção
F09 Transtorno mental orgânico ou sintomático não especificado
F10.0 Transtornos mentais e comportamentais devidos ao uso de álcool ­ intoxicação aguda
F10.1 Transtornos mentais e comportamentais devidos ao uso de álcool ­ uso nocivo para a saúde
F10.2 Transtornos mentais e comportamentais devidos ao uso de álcool ­ síndrome de dependência
F10.3 Transtornos mentais e comportamentais devidos ao uso de álcool ­ síndrome [estado] de
abstinência
F10.4 Transtornos mentais e comportamentais devidos ao uso de álcool ­ síndrome de abstinência com
delirium
F10.5 Transtornos mentais e comportamentais devidos ao uso de álcool ­ transtorno psicótico
F10.6 Transtornos mentais e comportamentais devidos ao uso de álcool ­ síndrome amnésica
F10.7 Transtornos mentais e comportamentais devidos ao uso de álcool ­ transtorno psicótico residual
ou de instalação tardia
F10.8 Transtornos mentais e comportamentais devidos ao uso de álcool ­ outros transtornos mentais
ou comportamentais
F10.9 Transtornos mentais e comportamentais devidos ao uso de álcool ­ transtorno mental ou
comportamental não especificado
F11.0 Transtornos mentais e comportamentais devidos ao uso de opiáceos ­ intoxicação aguda
F11.1 Transtornos mentais e comportamentais devidos ao uso de opiáceos ­ uso nocivo para a saúde
F11.2 Transtornos mentais e comportamentais devidos ao uso de opiáceos ­ síndrome de dependência
F11.3 Transtornos mentais e comportamentais devidos ao uso de opiáceos ­ síndrome [estado] de
abstinência
F11.4 Transtornos mentais e comportamentais devidos ao uso de opiáceos ­ síndrome de abstinência
com delirium
F11.5 Transtornos mentais e comportamentais devidos ao uso de opiáceos ­ transtorno psicótico
F11.6 Transtornos mentais e comportamentais devidos ao uso de opiáceos ­ síndrome amnésica
F11.7 Transtornos mentais e comportamentais devidos ao uso de opiáceos ­ transtorno psicótico
residual ou de instalação tardia
F11.8 Transtornos mentais e comportamentais devidos ao uso de opiáceos ­ outros transtornos mentais
ou comportamentais
F11.9 Transtornos mentais e comportamentais devidos ao uso de opiáceos ­ transtorno mental ou
comportamental não especificado
F12.0 Transtornos mentais e comportamentais devidos ao uso de canabinóides ­ intoxicação aguda
F12.1 Transtornos mentais e comportamentais devidos ao uso de canabinóides ­ uso nocivo para a
saúde
F12.2 Transtornos mentais e comportamentais devidos ao uso de canabinóides ­ síndrome de
dependência
F12.3 Transtornos mentais e comportamentais devidos ao uso de canabinóides ­ síndrome [estado] de
abstinência
F12.4 Transtornos mentais e comportamentais devidos ao uso de canabinóides ­ síndrome de
abstinência com delirium
F12.5 Transtornos mentais e comportamentais devidos ao uso de canabinóides ­ transtorno psicótico
F12.6 Transtornos mentais e comportamentais devidos ao uso de canabinóides ­ síndrome amnésica
F12.7 Transtornos mentais e comportamentais devidos ao uso de canabinóides ­ transtorno psicótico
residual ou de instalação tardia
F12.8 Transtornos mentais e comportamentais devidos ao uso de canabinóides ­ outros transtornos
mentais ou comportamentais
F12.9 Transtornos mentais e comportamentais devidos ao uso de canabinóides ­ transtorno mental ou
comportamental não especificado
F13.0 Transtornos mentais e comportamentais devidos ao uso de sedativos e hipnóticos ­ intoxicação
aguda
F13.1 Transtornos mentais e comportamentais devidos ao uso de sedativos e hipnóticos ­ uso nocivo
para a saúde
F13.2 Transtornos mentais e comportamentais devidos ao uso de sedativos e hipnóticos ­ síndrome de
dependência
F13.3 Transtornos mentais e comportamentais devidos ao uso de sedativos e hipnóticos ­ síndrome
[estado] de abstinência
F13.4 Transtornos mentais e comportamentais devidos ao uso de sedativos e hipnóticos ­ síndrome de
abstinência com delirium
F13.5 Transtornos mentais e comportamentais devidos ao uso de sedativos e hipnóticos ­ transtorno
psicótico
F13.6 Transtornos mentais e comportamentais devidos ao uso de sedativos e hipnóticos ­ síndrome
amnésica
F13.7 Transtornos mentais e comportamentais devidos ao uso de sedativos e hipnóticos ­ transtorno
psicótico residual ou de instalação tardia
F13.8 Transtornos mentais e comportamentais devidos ao uso de sedativos e hipnóticos ­ outros
transtornos mentais ou comportamentais
F13.9 Transtornos mentais e comportamentais devidos ao uso de sedativos e hipnóticos ­ transtorno
mental ou comportamental não especificado
F14.0 Transtornos mentais e comportamentais devidos ao uso da cocaína ­ intoxicação aguda
F14.1 Transtornos mentais e comportamentais devidos ao uso da cocaína ­ uso nocivo para a saúde
F14.2 Transtornos mentais e comportamentais devidos ao uso da cocaína ­ síndrome de dependência
F14.3 Transtornos mentais e comportamentais devidos ao uso da cocaína ­ síndrome [estado] de
abstinência
F14.4 Transtornos mentais e comportamentais devidos ao uso da cocaína ­ síndrome de abstinência
com delirium
F14.5 Transtornos mentais e comportamentais devidos ao uso da cocaína ­ transtorno psicótico
F14.6 Transtornos mentais e comportamentais devidos ao uso da cocaína ­ síndrome amnésica
F14.7 Transtornos mentais e comportamentais devidos ao uso da cocaína ­ transtorno psicótico
residual ou de instalação tardia
F14.8 Transtornos mentais e comportamentais devidos ao uso da cocaína ­ outros transtornos mentais
ou comportamentais
F14.9 Transtornos mentais e comportamentais devidos ao uso da cocaína ­ transtorno mental ou
comportamental não especificado
F15.0 Transtornos mentais e comportamentais devidos ao uso de outros estimulantes, inclusive a
cafeína ­ intoxicação aguda
F15.1 Transtornos mentais e comportamentais devidos ao uso de outros estimulantes, inclusive a
cafeína ­ uso nocivo para a saúde
F15.2 Transtornos mentais e comportamentais devidos ao uso de outros estimulantes, inclusive a
cafeína ­ síndrome de dependência
F15.3 Transtornos mentais e comportamentais devidos ao uso de outros estimulantes, inclusive a
cafeína ­ síndrome [estado] de abstinência
F15.4 Transtornos mentais e comportamentais devidos ao uso de outros estimulantes, inclusive a
cafeína ­ síndrome de abstinência com delirium
F15.5 Transtornos mentais e comportamentais devidos ao uso de outros estimulantes, inclusive a
cafeína ­ transtorno psicótico
F15.6 Transtornos mentais e comportamentais devidos ao uso de outros estimulantes, inclusive a
cafeína ­ síndrome amnésica
F15.7 Transtornos mentais e comportamentais devidos ao uso de outros estimulantes, inclusive a
cafeína ­ transtorno psicótico residual ou de instalação tardia
F15.8 Transtornos mentais e comportamentais devidos ao uso de outros estimulantes, inclusive a
cafeína ­ outros transtornos mentais ou comportamentais
F15.9 Transtornos mentais e comportamentais devidos ao uso de outros estimulantes, inclusive a
cafeína ­ transtorno mental ou comportamental não especificado
F16.0 Transtornos mentais e comportamentais devidos ao uso de alucinógenos ­ intoxicação aguda
F16.1 Transtornos mentais e comportamentais devidos ao uso de alucinógenos ­ uso nocivo para a
saúde
F16.2 Transtornos mentais e comportamentais devidos ao uso de alucinógenos ­ síndrome de
dependência
F16.3 Transtornos mentais e comportamentais devidos ao uso de alucinógenos ­ síndrome [estado] de
abstinência
F16.4 Transtornos mentais e comportamentais devidos ao uso de alucinógenos ­ síndrome de
abstinência com delirium
F16.5 Transtornos mentais e comportamentais devidos ao uso de alucinógenos ­ transtorno psicótico
F16.6 Transtornos mentais e comportamentais devidos ao uso de alucinógenos ­ síndrome amnésica
F16.7 Transtornos mentais e comportamentais devidos ao uso de alucinógenos ­ transtorno psicótico
residual ou de instalação tardia
F16.8 Transtornos mentais e comportamentais devidos ao uso de alucinógenos ­ outros transtornos
mentais ou comportamentais
F16.9 Transtornos mentais e comportamentais devidos ao uso de alucinógenos ­ transtorno mental ou
comportamental não especificado
F17.0 Transtornos mentais e comportamentais devidos ao uso de fumo ­ intoxicação aguda
F17.1 Transtornos mentais e comportamentais devidos ao uso de fumo ­ uso nocivo para a saúde
F17.2 Transtornos mentais e comportamentais devidos ao uso de fumo ­ síndrome de dependência
F17.3 Transtornos mentais e comportamentais devidos ao uso de fumo ­ síndrome [estado] de
abstinência
F17.4 Transtornos mentais e comportamentais devidos ao uso de fumo ­ síndrome de abstinência com
delirium
F17.5 Transtornos mentais e comportamentais devidos ao uso de fumo ­ transtorno psicótico
F17.6 Transtornos mentais e comportamentais devidos ao uso de fumo ­ síndrome amnésica
F17.7 Transtornos mentais e comportamentais devidos ao uso de fumo ­ transtorno psicótico residual
ou de instalação tardia
F17.8 Transtornos mentais e comportamentais devidos ao uso de fumo ­ outros transtornos mentais ou
comportamentais
F17.9 Transtornos mentais e comportamentais devidos ao uso de fumo ­ transtorno mental ou
comportamental não especificado
F18.0 Transtornos mentais e comportamentais devidos ao uso de solventes voláteis ­ intoxicação
aguda
F18.1 Transtornos mentais e comportamentais devidos ao uso de solventes voláteis ­ uso nocivo para a
saúde
F18.2 Transtornos mentais e comportamentais devidos ao uso de solventes voláteis ­ síndrome de
dependência
F18.3 Transtornos mentais e comportamentais devidos ao uso de solventes voláteis ­ síndrome
[estado] de abstinência
F18.4 Transtornos mentais e comportamentais devidos ao uso de solventes voláteis ­ síndrome de
abstinência com delirium
F18.5 Transtornos mentais e comportamentais devidos ao uso de solventes voláteis ­ transtorno
psicótico
F18.6 Transtornos mentais e comportamentais devidos ao uso de solventes voláteis ­ síndrome
amnésica
F18.7 Transtornos mentais e comportamentais devidos ao uso de solventes voláteis ­ transtorno
psicótico residual ou de instalação tardia
F18.8 Transtornos mentais e comportamentais devidos ao uso de solventes voláteis ­ outros
transtornos mentais ou comportamentais
F18.9 Transtornos mentais e comportamentais devidos ao uso de solventes voláteis ­ transtorno mental
ou comportamental não especificado
F19.0 Transtornos mentais e comportamentais devidos ao uso de múltiplas drogas e ao uso de outras
substâncias psicoativas ­ intoxicação aguda
F19.1 Transtornos mentais e comportamentais devidos ao uso de múltiplas drogas e ao uso de outras
substâncias psicoativas ­ uso nocivo para a saúde
F19.2 Transtornos mentais e comportamentais devidos ao uso de múltiplas drogas e ao uso de outras
substâncias psicoativas ­ síndrome de dependência
F19.3 Transtornos mentais e comportamentais devidos ao uso de múltiplas drogas e ao uso de outras
substâncias psicoativas ­ síndrome [estado] de abstinência
F19.4 Transtornos mentais e comportamentais devidos ao uso de múltiplas drogas e ao uso de outras
substâncias psicoativas ­ síndrome de abstinência com delirium
F19.5 Transtornos mentais e comportamentais devidos ao uso de múltiplas drogas e ao uso de outras
substâncias psicoativas ­ transtorno psicótico
F19.6 Transtornos mentais e comportamentais devidos ao uso de múltiplas drogas e ao uso de outras
substâncias psicoativas ­ síndrome amnésica
F19.7 Transtornos mentais e comportamentais devidos ao uso de múltiplas drogas e ao uso de outras
substâncias psicoativas ­ transtorno psicótico residual ou de instalação tardia
F19.8 Transtornos mentais e comportamentais devidos ao uso de múltiplas drogas e ao uso de outras
substâncias psicoativas ­ outros transtornos mentais ou comportamentais
F19.9 Transtornos mentais e comportamentais devidos ao uso de múltiplas drogas e ao uso de outras
substâncias psicoativas ­ transtorno mental ou comportamental não especificado
F20.0 Esquizofrenia paranóide
F20.1 Esquizofrenia hebefrênica
F20.2 Esquizofrenia catatônica
F20.3 Esquizofrenia indiferenciada
F20.4 Depressão pós­esquizofrênica
F20.5 Esquizofrenia residual
F20.6 Esquizofrenia simples
F20.8 Outras esquizofrenias
F20.9 Esquizofrenia não especificada
F21 Transtorno esquizotípico
F22.0 Transtorno delirante
F22.8 Outros transtornos delirantes persistentes
F22.9 Transtorno delirante persistente não especificado
F23.0 Transtorno psicótico agudo polimorfo, sem sintomas esquizofrênicos
F23.1 Transtorno psicótico agudo polimorfo, com sintomas esquizofrênicos
F23.2 Transtorno psicótico agudo de tipo esquizofrênico (schizophrenia­like)
F23.3 Outros transtornos psicóticos agudos, essencialmente delirantes
F23.8 Outros transtornos psicóticos agudos e transitórios
F23.9 Transtorno psicótico agudo e transitório não especificado
F24 Transtorno delirante induzido
F25.0 Transtorno esquizoafetivo do tipo maníaco
F25.1 Transtorno esquizoafetivo do tipo depressivo
F25.2 Transtorno esquizoafetivo do tipo misto
F25.8 Outros transtornos esquizoafetivos
F25.9 Transtorno esquizoafetivo não especificado
F28 Outros transtornos psicóticos não­orgânicos
F29 Psicose não­orgânica não especificada
F30.0 Hipomania
F30.1 Mania sem sintomas psicóticos
F30.2 Mania com sintomas psicóticos
F30.8 Outros episódios maníacos
F30.9 Episódio maníaco não especificado
F31.0 Transtorno afetivo bipolar, episódio atual hipomaníaco
F31.1 Transtorno afetivo bipolar, episódio atual maníaco sem sintomas psicóticos
F31.2 Transtorno afetivo bipolar, episódio atual maníaco com sintomas psicóticos
F31.3 Transtorno afetivo bipolar, episódio atual depressivo leve ou moderado
F31.4 Transtorno afetivo bipolar, episódio atual depressivo grave sem sintomas psicóticos
F31.5 Transtorno afetivo bipolar, episódio atual depressivo grave com sintomas psicóticos
F31.6 Transtorno afetivo bipolar, episódio atual misto
F31.7 Transtorno afetivo bipolar, atualmente em remissão
F31.8 Outros transtornos afetivos bipolares
F31.9 Transtorno afetivo bipolar não especificado
F32.0 Episódio depressivo leve
F32.1 Episódio depressivo moderado
F32.2 Episódio depressivo grave sem sintomas psicóticos
F32.3 Episódio depressivo grave com sintomas psicóticos
F32.8 Outros episódios depressivos
F32.9 Episódio depressivo não especificado
F33.0 Transtorno depressivo recorrente, episódio atual leve
F33.1 Transtorno depressivo recorrente, episódio atual moderado
F33.2 Transtorno depressivo recorrente, episódio atual grave sem sintomas psicóticos
F33.3 Transtorno depressivo recorrente, episódio atual grave com sintomas psicóticos
F33.4 Transtorno depressivo recorrente, atualmente em remissão
F33.8 Outros transtornos depressivos recorrentes
F33.9 Transtorno depressivo recorrente sem especificação
F34.0 Ciclotimia
F34.1 Distimia
F34.8 Outros transtornos do humor [afetivos] persistentes
F34.9 Transtorno do humor [afetivo] persistente não especificado
F38.0 Outros transtornos do humor [afetivos] isolados
F38.1 Outros transtornos do humor [afetivos] recorrentes
F38.8 Outros transtornos especificados do humor [afetivos]
F39 Transtorno do humor [afetivo] não especificado
F40.0 Agorafobia
F40.1 Fobias sociais
F40.2 Fobias específicas (isoladas)
F40.8 Outros transtornos fóbico­ansiosos
F40.9 Transtorno fóbico­ansioso não especificado
F41.0 Transtorno de pânico [ansiedade paroxística episódica]
F41.1 Ansiedade generalizada
F41.2 Transtorno misto ansioso e depressivo
F41.3 Outros transtornos ansiosos mistos
F41.8 Outros transtornos ansiosos especificados
F41.9 Transtorno ansioso não especificado
F42.0 Com predominância de idéias ou de ruminações obsessivas
F42.1 Com predominância de comportamentos compulsivos [rituais obsessivos]
F42.2 Forma mista, com idéias obsessivas e comportamentos compulsivos
F42.8 Outros transtornos obsessivo­compulsivos
F42.9 Transtorno obsessivo­compulsivo não especificado
F43.0 Reação aguda ao "stress"
F43.1 Estado de "stress" pós­traumático
F43.2 Transtornos de adaptação
F43.8 Outras reações ao "stress" grave
F43.9 Reação não especificada a um "stress" grave
F44.0 Amnésia dissociativa
F44.1 Fuga dissociativa
F44.2 Estupor dissociativo
F44.3 Estados de transe e de possessão
F44.4 Transtornos dissociativos do movimento
F44.5 Convulsões dissociativas
F44.6 Anestesia e perda sensorial dissociativas
F44.7 Transtorno dissociativo misto [de conversão]
F44.8 Outros transtornos dissociativos [de conversão]
F44.9 Transtorno dissociativo [de conversão] não especificado
F45.0 Transtorno de somatização
F45.1 Transtorno somatoforme indiferenciado
F45.2 Transtorno hipocondríaco
F45.3 Transtorno neurovegetativo somatoforme
F45.4 Transtorno doloroso somatoforme persistente
F45.8 Outros transtornos somatoformes
F45.9 Transtorno somatoforme não especificado
F48.0 Neurastenia
F48.1 Síndrome de despersonalização­desrealização
F48.8 Outros transtornos neuróticos especificados
F48.9 Transtorno neurótico não especificado
F50.0 Anorexia nervosa
F50.1 Anorexia nervosa atípica
F50.2 Bulimia nervosa
F50.3 Bulimia nervosa atípica
F50.4 Hiperfagia associada a outros distúrbios psicológicos
F50.5 Vômitos associados a outros distúrbios psicológicos
F50.8 Outros transtornos da alimentação
F50.9 Transtorno de alimentação não especificado
F51.0 Insônia não­orgânica
F51.1 Hipersonia não­orgânica
F51.2 Transtorno do ciclo vigília­sono devido a fatores não­orgânicos
F51.3 Sonambulismo
F51.4 Terrores noturnos
F51.5 Pesadelos
F51.8 Outros transtornos do sono devidos a fatores não­orgânicos
F51.9 Transtorno do sono devido a fatores não­orgânicos não especificados
F52.0 Ausência ou perda do desejo sexual
F52.1 Aversão sexual e ausência de prazer sexual
F52.2 Falha de resposta genital
F52.3 Disfunção orgásmica
F52.4 Ejaculação precoce
F52.5 Vaginismo não­orgânico
F52.6 Dispareunia não­orgânica
F52.7 Apetite sexual excessivo
F52.8 Outras disfunções sexuais não devidas a transtorno ou à doença orgânica
F52.9 Disfunção sexual não devida a transtorno ou à doença orgânica, não especificada
F53.0 Transtornos mentais e comportamentais leves associados ao puerpério não classificados em
outra parte
F53.1 Transtornos mentais e comportamentais graves associados ao puerpério não classificados em
outra parte
F53.8 Outros transtornos mentais e comportamentais associados ao puerpério não classificados em
outra parte
F53.9 Transtorno mental e comportamental associado ao puerpério, não especificado
F54 Fatores psicológicos ou comportamentais associados a doença ou a transtornos classificados em
outra parte
F55 Abuso de substâncias que não produzem dependência
F59 Síndromes comportamentais associados a transtornos das funções fisiológicas e a fatores
físicos, não especificadas
F60.0 Personalidade paranóica
F60.1 Personalidade esquizóide
F60.2 Personalidade dissocial
F60.3 Transtorno de personalidade com instabilidade emocional
F60.4 Personalidade histriônica
F60.5 Personalidade anancástica
F60.6 Personalidade ansiosa [esquiva]
F60.7 Personalidade dependente
F60.8 Outros transtornos específicos da personalidade
F60.9 Transtorno não especificado da personalidade
F61 Transtornos mistos da personalidade e outros transtornos da personalidade
F62.0 Modificação duradoura da personalidade após uma experiência catastrófica
F62.1 Modificação duradoura da personalidade após doença psiquiátrica
F62.8 Outras modificações duradouras da personalidade
F62.9 Modificação duradoura da personalidade, não especificada
F63.0 Jogo patológico
F63.1 Piromania
F63.2 Roubo patológico [cleptomania]
F63.3 Tricotilomania
F63.8 Outros transtornos dos hábitos e dos impulsos
F63.9 Transtorno dos hábitos e impulsos, não especificado
F64.0 Transexualismo
F64.1 Travestismo bivalente
F64.2 Transtorno de identidade sexual na infância
F64.8 Outros transtornos da identidade sexual
F64.9 Transtorno não especificado da identidade sexual
F65.0 Fetichismo
F65.1 Travestismo fetichista
F65.2 Exibicionismo
F65.3 Voyeurismo
F65.4 Pedofilia
F65.5 Sadomasoquismo
F65.6 Transtornos múltiplos da preferência sexual
F65.8 Outros transtornos da preferência sexual
F65.9 Transtorno da preferência sexual, não especificado
F66.0 Transtorno da maturação sexual
F66.1 Orientação sexual egodistônica
F66.2 Transtorno do relacionamento sexual
F66.8 Outros transtornos do desenvolvimento psicossexual
F66.9 Transtorno do desenvolvimento sexual, não especificado
F68.0 Sintomas físicos aumentados por fatores psicológicos
F68.1 Produção deliberada ou simulação de sintomas ou de incapacidades, físicas ou psicológicas
[transtorno factício]
F68.8 Outros transtornos especificados da personalidade e do comportamento do adulto
F69 Transtorno da personalidade e do comportamento do adulto, não especificado
F70.0 Retardo mental leve ­ menção de ausência de ou de comprometimento mínimo do
comportamento
F70.1 Retardo mental leve ­ comprometimento significativo do comportamento, requerendo vigilância
ou tratamento
F70.8 Retardo mental leve ­ outros comprometimentos do comportamento
F70.9 Retardo mental leve ­ sem menção de comprometimento do comportamento
F71.0 Retardo mental moderado ­ menção de ausência de ou de comprometimento mínimo do
comportamento
F71.1 Retardo mental moderado ­ comprometimento significativo do comportamento, requerendo
vigilância ou tratamento
F71.8 Retardo mental moderado ­ outros comprometimentos do comportamento
F71.9 Retardo mental moderado ­ sem menção de comprometimento do comportamento
F72.0 Retardo mental grave ­ menção de ausência de ou de comprometimento mínimo do
comportamento
F72.1 Retardo mental grave ­ comprometimento significativo do comportamento, requerendo vigilância
ou tratamento
F72.8 Retardo mental grave ­ outros comprometimentos do comportamento
F72.9 Retardo mental grave ­ sem menção de comprometimento do comportamento
F73.0 Retardo mental profundo ­ menção de ausência de ou de comprometimento mínimo do
comportamento
F73.1 Retardo mental profundo ­ comprometimento significativo do comportamento, requerendo
vigilância ou tratamento
F73.8 Retardo mental profundo ­ outros comprometimentos do comportamento
F73.9 Retardo mental profundo ­ sem menção de comprometimento do comportamento
F78.0 Outro retardo mental ­ menção de ausência de ou de comprometimento mínimo do
comportamento
F78.1 Outro retardo mental ­ comprometimento significativo do comportamento, requerendo vigilância
ou tratamento
F78.8 Outro retardo mental ­ outros comprometimentos do comportamento
F78.9 Outro retardo mental ­ sem menção de comprometimento do comportamento
F79.0 Retardo mental não especificado ­ menção de ausência de ou de comprometimento mínimo do
comportamento
F79.1 Retardo mental não especificado ­ comprometimento significativo do comportamento,
requerendo vigilância ou tratamento
F79.8 Retardo mental não especificado ­ outros comprometimentos do comportamento
F79.9 Retardo mental não especificado ­ sem menção de comprometimento do comportamento
F80.0 Transtorno específico da articulação da fala
F80.1 Transtorno expressivo de linguagem
F80.2 Transtorno receptivo da linguagem
F80.3 Afasia adquirida com epilepsia [síndrome de Landau­Kleffner]
F80.8 Outros transtornos de desenvolvimento da fala ou da linguagem
F80.9 Transtorno não especificado do desenvolvimento da fala ou da linguagem
F81.0 Transtorno específico de leitura
F81.1 Transtorno específico da soletração
F81.2 Transtorno específico da habilidade em aritmética
F81.3 Transtorno misto de habilidades escolares
F81.8 Outros transtornos do desenvolvimento das habilidades escolares
F81.9 Transtorno não especificado do desenvolvimento das habilidades escolares
F82 Transtorno específico do desenvolvimento motor
F83 Transtornos específicos misto do desenvolvimento
F84.0 Autismo infantil
F84.1 Autismo atípico
F84.2 Síndrome de Rett
F84.3 Outro transtorno desintegrativo da infância
F84.4 Transtorno com hipercinesia associada a retardo mental e a movimentos estereotipados
F84.5 Síndrome de Asperger
F84.8 Outros transtornos globais do desenvolvimento
F84.9 Transtornos globais não especificados do desenvolvimento
F88 Outros transtornos do desenvolvimento psicológico
F89 Transtorno do desenvolvimento psicológico não especificado
F90.0 Distúrbios da atividade e da atenção
F90.1 Transtorno hipercinético de conduta
F90.8 Outros transtornos hipercinéticos
F90.9 Transtorno hipercinético não especificado
F91.0 Distúrbio de conduta restrito ao contexto familiar
F91.1 Distúrbio de conduta não­socializado
F91.2 Distúrbio de conduta do tipo socializado
F91.3 Distúrbio desafiador e de oposição
F91.8 Outros transtornos de conduta
F91.9 Transtorno de conduta não especificado
F92.0 Distúrbio depressivo de conduta
F92.8 Outros transtornos mistos da conduta e das emoções
F92.9 Transtorno misto da conduta e das emoções não especificado
F93.0 Transtorno ligado à angústia de separação
F93.1 Transtorno fóbico ansioso da infância
F93.2 Distúrbio de ansiedade social da infância
F93.3 Transtorno de rivalidade entre irmãos
F93.8 Outros transtornos emocionais da infância
F93.9 Transtorno emocional da infância não especificado
F94.0 Mutismo eletivo
F94.1 Distúrbio reativo de vinculação da infância
F94.2 Transtorno de fixação da infância, com desinibição
F94.8 Outros transtornos do funcionamento social na infância
F94.9 Transtorno do funcionamento social da infância não especificado
F95.0 Tique transitório
F95.1 Tique motor ou vocal crônico
F95.2 Tiques vocais e motores múltiplos combinados [doença de Gilles de la Tourette]
F95.8 Outros tiques
F95.9 Tique não especificado
F98.0 Enurese de origem não­orgânica
F98.1 Encoprese de origem não­orgânica
F98.2 Transtorno de alimentação na infância
F98.3 Pica do lactente ou da criança
F98.4 Estereotipias motoras
F98.5 Gagueira [tartamudez]
F98.6 Linguagem precipitada
F98.8 Outros transtornos comportamentais e emocionais especificados com início habitualmente na
infância ou adolescência
F98.9 Transtornos comportamentais e emocionais não especificados com início habitualmente na
infância ou adolescência
F99 Transtorno mental não especificado em outra parte
G00.0 Meningite por Haemophilus
G00.1 Meningite pneumocócica
G00.2 Meningite estreptocócica
G00.3 Meningite estafilocócica
G00.8 Outras meningites bacterianas
G00.9 Meningite bacteriana não especificada
G01 *Meningite em doenças bacterianas classificadas em outra parte
G02.0*Meningite em doenças virais classificadas em outra parte
G02.1*Meningite em micoses
G02.8*Meningite em outras doenças infecciosas e parasitárias classificadas em outra parte
G03.0 Meningite não­piogênica
G03.1 Meningite crônica
G03.2 Meningite recorrente benigna [Mollaret]
G03.8 Meningite devida a outras causas especificadas
G03.9 Meningite não especificada
G04.0 Encefalite aguda disseminada
G04.1 Paraplegia espástica tropical
G04.2 Meningoencefalite e meningomielite bacterianas não classificadas em outra parte
G04.8 Outras encefalites, mielites e encefalomielites
G04.9 Encefalite, mielite e encefalomielite não especificada
G05.0*Encefalite, mielite e encefalomielite em doenças bacterianas classificadas em outra parte
G05.1*Encefalite, mielite e encefalomielite em doenças virais classificadas em outra parte
G05.2*Encefalite, mielite e encefalomielite em outras doenças infecciosas e parasitárias classificadas
em outra parte
G05.8*Encefalite, mielite e encefalomielite em outras doenças classificadas em outra parte
G06.0 Abscesso e granuloma intracranianos
G06.1 Abscesso e granuloma intra­raquidianos
G06.2 Abscesso extradural e subdural não especificados
G07 *Abscesso e granuloma intracranianos e intraspinais em doenças classificadas em outra parte
G08 Flebite e tromboflebite intracranianas e intra­raquidianas
G09 Seqüelas de doenças inflamatórias do sistema nervoso central
G10 Doença de Huntington
G11.0 Ataxia congênita não­progressiva
G11.1 Ataxia cerebelar de início precoce
G11.2 Ataxia cerebelar de início tardio
G11.3 Ataxia cerebelar com déficit na reparação do DNA
G11.4 Paraplegia espástica hereditária
G11.8 Outras ataxias hereditárias
G11.9 Ataxia hereditária não especificada
G12.0 Atrofia muscular espinal infantil tipo I [Werdnig­Hoffman]
G12.1 Outras atrofias musculares espinais hereditárias
G12.2 Doença do neurônio motor
G12.8 Outras atrofias musculares espinais e síndromes musculares correlatas
G12.9 Atrofia muscular espinal não especificada
G13.0*Neuromiopatia e neuropatia paraneoplásicas
G13.1*Outra atrofia sistêmica que afeta primariamente o sistema nervoso central em doenças
neoplásicas
G13.2*Atrofia sistêmica que afeta primariamente o sistema nervoso central no mixedema (E00.1+,
E03.­+)
G13.8*Atrofia sistêmica que afeta primariamente o sistema nervoso central em outras doenças
classificadas em outra parte
G20 Doença de Parkinson
G21.0 Síndrome maligna dos neurolépticos
G21.1 Outras formas de parkinsonismo secundário induzido por drogas
G21.2 Parkinsonismo secundário devido a outros agentes externos
G21.3 Parkinsonismo pós­encefalítico
G21.8 Outras formas de parkinsonismo secundário
G21.9 Parkinsonismo secundário não especificado
G22 *Parkinsonismo em doenças classificadas em outra parte
G23.0 Doença de Hallervorden­Spatz
G23.1 Oftalmoplegia supranuclear progressiva [Steele­Richardson­Olszewski]
G23.2 Degeneração estrionígrica
G23.8 Outras doenças degenerativas especificadas dos gânglios da base
G23.9 Doença degenerativa dos gânglios da base, não especificada
G24.0 Distonia induzida por drogas
G24.1 Distonia familiar idiopática
G24.2 Distonia não­familiar idiopática
G24.3 Torcicolo espasmódico
G24.4 Distonia orofacial idiopática
G24.5 Blefaroespasmo
G24.8 Outras distonias
G24.9 Distonia não especificada
G25.0 Tremor essencial
G25.1 Tremor induzido por drogas
G25.2 Outras formas especificadas de tremor
G25.3 Mioclonia
G25.4 Coréia induzida por droga
G25.5 Outras formas de coréia
G25.6 Tiques induzidos por droga e outros tipos de origem orgânica
G25.8 Outras doenças extrapiramidais e transtornos dos movimentos, especificados
G25.9 Doenças extrapiramidais e transtornos dos movimentos, não especificados
G26 *Doenças extrapiramidais e transtornos dos movimentos em doenças classificadas em outra
parte
G30.0 Doença de Alzheimer de início precoce
G30.1 Doença de Alzheimer de início tardio
G30.8 Outras formas de doença de Alzheimer
G30.9 Doença de Alzheimer não especificada
G31.0 Atrofia cerebral circunscrita
G31.1 Degeneração cerebral senil, não classificadas em outra parte
G31.2 Degeneração do sistema nervoso devida ao álcool
G31.8 Outras doenças degenerativas especificadas do sistema nervoso
G31.9 Doença degenerativa do sistema nervoso, não especificada
G32.0*Degeneração combinada subaguda da medula espinal em doenças classificadas em outra parte
G32.8*Outros transtornos degenerativos especificados do sistema nervoso em doenças classificadas
em outra parte
G35 Esclerose múltipla
G36.0 Neuromielite óptica [doença de Devic]
G36.1 Leucoencefalite hemorrágica aguda e subaguda [Hurst]
G36.8 Outras desmielinizações disseminadas agudas especificadas
G36.9 Desmielinização disseminada aguda não especificada
G37.0 Esclerose difusa
G37.1 Desmielinização central do corpo caloso
G37.2 Mielinólise central da ponte
G37.3 Mielite transversa aguda em doenças desmielinizantes do sistema nervoso central
G37.4 Mielite subaguda necrótica
G37.5 Esclerose concêntrica [Baló]
G37.8 Outras doenças desmielinizantes especificadas do sistema nervoso central
G37.9 Doença desmielinizante do sistema nervoso central, não especificada
G40.0 Epilepsia e síndromes epilépticas idiopáticas definidas por sua localização (focal) (parcial) com
crises de início focal
G40.1 Epilepsia e síndromes epilépticas sintomáticas definidas por sua localização (focal) (parcial) com
crises parciais simples
G40.2 Epilepsia e síndromes epilépticas sintomáticas definidas por sua localização (focal) (parcial) com
crises parciais complexas
G40.3 Epilepsia e síndromes epilépticas generalizadas idiopáticas
G40.4 Outras epilepsias e síndromes epilépticas generalizadas
G40.5 Síndromes epilépticas especiais
G40.6 Crise de grande mal, não especificada (com ou sem pequeno mal)
G40.7 Pequeno mal não especificado, sem crises de grande mal
G40.8 Outras epilepsias
G40.9 Epilepsia, não especificada
G41.0 Estado de grande mal epiléptico
G41.1 Estado de pequeno mal epiléptico
G41.2 Estado de mal epiléptico parcial complexo
G41.8 Outros estados de mal epiléptico
G41.9 Estado de mal epiléptico, não especificado
G43.0 Enxaqueca sem aura [enxaqueca comum]
G43.1 Enxaqueca com aura [enxaqueca clássica]
G43.2 Estado de mal enxaquecoso
G43.3 Enxaqueca complicada
G43.8 Outras formas de enxaqueca
G43.9 Enxaqueca, sem especificação
G44.0 Síndrome de "cluster­headache"
G44.1 Cefaléia vascular, não classificada em outra parte
G44.2 Cefaléia tensional
G44.3 Cefaléia crônica pós­traumática
G44.4 Cefaléia induzida por drogas, não classificada em outra parte
G44.8 Outras síndromes de cefaléia especificadas
G45.0 Síndrome da artéria vértebro­basilar
G45.1 Síndrome da artéria carotídea (hemisférica)
G45.2 Síndrome das artérias pré­cerebrais, múltiplas e bilaterais
G45.3 Amaurose fugaz
G45.4 Amnésia global transitória
G45.8 Outros acidentes isquêmicos cerebrais transitórios e síndromes correlatas
G45.9 Isquemia cerebral transitória não especificada
G46.0*Síndrome da artéria cerebral média (I66.0+)
G46.1*Síndrome da artéria cerebral anterior (I66.1+)
G46.2*Síndrome da artéria cerebral posterior (I66.2+)
G46.3*Síndromes vasculares do tronco cerebral (I60­I67+)
G46.4*Síndrome vascular cerebelar (I60­I67+)
G46.5*Síndrome lacunar motora pura (I60­I67+)
G46.6*Síndrome lacunar sensorial pura (I60­I67+)
G46.7*Outras síndromes lacunares (I60­I67+)
G46.8*Outras síndromes vasculares cerebrais em doenças cerebrovasculares (I60­I67+)
G47.0 Distúrbios do início e da manutenção do sono [insônias]
G47.1 Distúrbios do sono por sonolência excessiva [hipersonia]
G47.2 Distúrbios do ciclo vigília­sono
G47.3 Apnéia de sono
G47.4 Narcolepsia e cataplexia
G47.8 Outros distúrbios do sono
G47.9 Distúrbio do sono, não especificado
G50.0 Nevralgia do trigêmeo
G50.1 Dor facial atípica
G50.8 Outros transtornos do nervo trigêmeo
G50.9 Transtorno não especificado do nervo trigêmeo
G51.0 Paralisia de Bell
G51.1 Ganglionite geniculada
G51.2 Síndrome de Melkersson
G51.3 Espasmo hemifacial clônico
G51.4 Mioquimia facial
G51.8 Outros transtornos do nervo facial
G51.9 Transtorno não especificado do nervo facial
G52.0 Transtornos do nervo olfatório
G52.1 Transtornos do nervo glossofaríngeo
G52.2 Transtornos do nervo vago
G52.3 Transtornos do nervo hipoglosso
G52.7 Transtornos de múltiplos nervos cranianos
G52.8 Transtornos de outros nervos cranianos especificados
G52.9 Transtorno de nervo craniano não especificado
G53.0*Nevralgia pós­zoster (B02.2+)
G53.1*Paralisias de múltiplos nervos cranianos em doenças infecciosas e parasitárias classificadas em
outra parte (A00­B99+)
G53.2*Paralisias de múltiplos nervos cranianos na sarcoidose (D86.8+)
G53.3*Paralisias de múltiplos nervos cranianos em doenças neoplásicas (C00­D48+)
G53.8*Outros transtornos de nervos cranianos em outras doenças classificadas em outra parte
G54.0 Transtornos do plexo braquial
G54.1 Transtornos do plexo lombossacral
G54.2 Transtornos das raízes cervicais não classificadas em outra parte
G54.3 Transtornos das raízes torácicas não classificadas em outra parte
G54.4 Transtornos das raízes lombossacras não classificadas em outra parte
G54.5 Amiotrofia nevrálgica
G54.6 Síndrome dolorosa do membro fantasma
G54.7 Síndrome do membro fantasma sem manifestação dolorosa
G54.8 Outros transtornos das raízes e dos plexos nervosos
G54.9 Transtorno não especificado das raízes e dos plexos nervosos
G55.0*Compressões das raízes e dos plexos nervosos em doenças neoplásicas (C00­D48+)
G55.1*Compressões das raízes e dos plexos nervosos em transtornos dos discos intervertebrais (M50­
M51+)
G55.2*Compressões das raízes e dos plexos nervosos na espondilose (M47.­+)
G55.3*Compressões das raízes e dos plexos nervosos em outras dorsopatias (M45­M46+, M48.­+,
M53­M54+)
G55.8*Compressões das raízes e dos plexos nervosos em outras doenças classificadas em outra parte
G56.0 Síndrome do túnel do carpo
G56.1 Outras lesões do nervo mediano
G56.2 Lesões do nervo cubital [ulnar]
G56.3 Lesão do nervo radial
G56.4 Causalgia
G56.8 Outras mononeuropatias dos membros superiores
G56.9 Mononeuropatia dos membros superiores, não especificada
G57.0 Lesão do nervo ciático
G57.1 Meralgia parestésica
G57.2 Lesão do nervo femoral
G57.3 Lesão do nervo poplíteo lateral
G57.4 Lesão do nervo poplíteo medial
G57.5 Síndrome do túnel do tarso
G57.6 Lesão do nervo plantar
G57.8 Outras mononeuropatias dos membros inferiores
G57.9 Mononeuropatia dos membros inferiores, não especificada
G58.0 Neuropatia intercostal
G58.7 Mononeurite múltipla
G58.8 Outras mononeuropatias especificadas
G58.9 Mononeuropatia não especificada
G59.0*Mononeuropatia diabética (E10­E14+ com quarto caractere comum .4)
G59.8*Outras mononeuropatias em doenças classificadas em outra parte
G60.0 Neuropatia hereditária motora e sensorial
G60.1 Doença de Refsum
G60.2 Neuropatia associada a ataxia hereditária
G60.3 Neuropatia progressiva idiopática
G60.8 Outras neuropatias hereditárias e idiopáticas
G60.9 Neuropatia hereditária e idiopática não especificada
G61.0 Síndrome de Guillain­Barré
G61.1 Neuropatia sérica
G61.8 Outras polineuropatias inflamatórias
G61.9 Polineuropatia inflamatória não especificada
G62.0 Polineuropatia induzida por drogas
G62.1 Polineuropatia alcoólica
G62.2 Polineuropatia devida a outros agentes tóxicos
G62.8 Outras polineuropatias especificadas
G62.9 Polineuropatia não especificada
G63.0*Polineuropatia em doenças infecciosas e parasitárias classificadas em outra parte
G63.1*Polineuropatia em doenças neoplásicas (C00­D48+)
G63.2*Polineuropatia diabética (E10­E14+ com quarto caractere comum .4)
G63.3*Polineuropatia em outras doenças endócrinas e metabólicas (E00­E07+, E15­E16+, E20­E34+,
E70­E89+)
G63.4*Polineuropatia em deficiências nutricionais (E40­E64+)
G63.5*Polineuropatia em doenças sistêmicas do tecido conjuntivo (M30­M35+)
G63.6*Polineuropatia em outros transtornos osteomusculares (M00­M25+, M40­M96+)
G63.8*Polineuropatia em outras doenças classificadas em outra parte
G64 Outros transtornos do sistema nervoso periférico
G70.0 Miastenia gravis
G70.1 Transtornos mioneurais tóxicos
G70.2 Miastenia congênita e do desenvolvimento
G70.8 Outros transtornos mioneurais especificados
G70.9 Transtorno mioneural não especificado
G71.0 Distrofia muscular
G71.1 Transtornos miotônicos
G71.2 Miopatias congênitas
G71.3 Miopatia mitocondrial não classificada em outra parte
G71.8 Outros transtornos primários dos músculos
G71.9 Transtorno muscular primário não especificado
G72.0 Miopatia induzida por drogas
G72.1 Miopatia alcoólica
G72.2 Miopatia devida a outros agentes tóxicos
G72.3 Paralisia periódica
G72.4 Miopatia inflamatória não classificada em outra parte
G72.8 Outras miopatias especificadas
G72.9 Miopatia não especificada
G73.0*Síndromes miastênicas em doenças endócrinas
G73.1*Síndrome de Eaton­Lambert (C80+)
G73.2*Outras síndromes miastênicas em doenças neoplásicas (C00­D48+)
G73.3*Síndromes miastênicas em outras doenças classificadas em outra parte
G73.4*Miopatia em doenças infecciosas e parasitárias classificadas em outra parte
G73.5*Miopatia em doenças endócrinas
G73.6*Miopatia em doenças metabólicas
G73.7*Miopatia em outras doenças classificadas em outra parte
G80.0 Paralisia cerebral espástica
G80.1 Diplegia espástica
G80.2 Hemiplegia infantil
G80.3 Paralisia cerebral discinética
G80.4 Paralisia cerebral atáxica
G80.8 Outras formas de paralisia cerebral infantil
G80.9 Paralisia cerebral infantil não especificada
G81.0 Hemiplegia flácida
G81.1 Hemiplegia espástica
G81.9 Hemiplegia não especificada
G82.0 Paraplegia flácida
G82.1 Paraplegia espástica
G82.2 Paraplegia não especificada
G82.3 Tetraplegia flácida
G82.4 Tetraplegia espástica
G82.5 Tetraplegia não especificada
G83.0 Diplegia dos membros superiores
G83.1 Monoplegia do membro inferior
G83.2 Monoplegia do membro superior
G83.3 Monoplegia não especificada
G83.4 Síndrome da cauda eqüina
G83.8 Outras síndromes paralíticas especificadas
G83.9 Síndrome paralítica não especificada
G90.0 Neuropatia autonômica periférica idiopática
G90.1 Disautonomia familiar [Síndrome de Riley­Day]
G90.2 Síndrome de Horner
G90.3 Degeneração multissistêmica
G90.8 Outros transtornos do sistema nervoso autônomo
G90.9 Transtorno não especificado do sistema nervoso autônomo
G91.0 Hidrocefalia comunicante
G91.1 Hidrocefalia obstrutiva
G91.2 Hidrocefalia de pressão normal
G91.3 Hidrocefalia pós­traumática não especificada
G91.8 Outras formas de hidrocefalia
G91.9 Hidrocefalia não especificada
G92 Encefalopatia tóxica
G93.0 Cistos cerebrais
G93.1 Lesão encefálica anóxica, não classificada em outra parte
G93.2 Hipertensão intracraniana benigna
G93.3 Síndrome da fadiga pós­viral
G93.4 Encefalopatia não especificada
G93.5 Compressão do encéfalo
G93.6 Edema cerebral
G93.7 Síndrome de Reye
G93.8 Outros transtornos especificados do encéfalo
G93.9 Transtorno não especificado do encéfalo
G94.0*Hidrocefalia em doenças infecciosas e parasitárias classificadas em outra parte (A00­B99+)
G94.1*Hidrocefalia em doenças neoplásicas (C00­D48+)
G94.2*Hidrocefalia em outras doenças classificadas em outra parte
G94.8*Outros transtornos encefálicos especificados em doenças classificadas em outra parte
G95.0 Siringomielia e siringobulbia
G95.1 Mielopatias vasculares
G95.2 Compressão não especificada de medula espinal
G95.8 Outras doenças especificadas da medula espinal
G95.9 Doença não especificada da medula espinal
G96.0 Fístula liquórica
G96.1 Transtornos das meninges não classificados em outra parte
G96.8 Outros transtornos especificados do sistema nervoso central
G96.9 Transtorno não especificado do sistema nervoso central
G97.0 Perda de líquor resultante de punção espinal
G97.1 Outra reação à punção espinal e lombar
G97.2 Hipotensão intracraniana conseqüente à derivação ventricular
G97.8 Outros transtornos pós­procedimento do sistema nervoso
G97.9 Transtorno pós­procedimento do sistema nervoso, não especificado
G98 Outras transtornos do sistema nervoso não classificados em outra parte
G99.0*Neuropatia autonômica em doenças endócrinas e metabólicas
G99.1*Outros transtornos do sistema nervoso autônomo em doenças classificadas em outra parte
G99.2*Mielopatia em doenças classificadas em outra parte
G99.8*Outros transtornos especificados do sistema nervoso em doenças classificadas em outra parte
H00.0 Hordéolo e outras inflamações profundas das pálpebras
H00.1 Calázio
H01.0 Blefarite
H01.1 Dermatoses não infecciosas da pálpebra
H01.8 Outras inflamações especificadas da pálpebra
H01.9 Inflamação não especificada da pálpebra
H02.0 Entrópio e triquíase da pálpebra
H02.1 Ectrópio da pálpebra
H02.2 Lagoftalmo
H02.3 Blefarocalásia
H02.4 Ptose da pálpebra
H02.5 Outros transtornos que afetam a função da pálpebra
H02.6 Xantelasma da pálpebra
H02.7 Outros transtornos degenerativos da pálpebra e da área periocular
H02.8 Outros transtornos especificados das pálpebras
H02.9 Transtorno não especificado da pálpebra
H03.0*Infestação parasitária da pálpebra em doenças classificadas em outra parte
H03.1*Comprometimento da pálpebra em outras doenças infecciosas classificadas em outra parte
H03.8*Comprometimento da pálpebra em outras doenças classificadas em outras partes
H04.0 Dacrioadenite
H04.1 Outros transtornos da glândula lacrimal
H04.2 Epífora
H04.3 Inflamação aguda e não especificada dos canais lacrimais
H04.4 Inflamação crônica dos canais lacrimais
H04.5 Estenose e insuficiência dos canais lacrimais
H04.6 Outras alterações nos canais lacrimais
H04.8 Outros transtornos do aparelho lacrimal
H04.9 Transtorno não especificado do aparelho lacrimal
H05.0 Inflamação aguda da órbita
H05.1 Transtornos inflamatórios crônicos da órbita
H05.2 Afecções exoftálmicas
H05.3 Deformidade da órbita
H05.4 Enoftalmia
H05.5 Corpo estranho (antigo) retido conseqüente a ferimento perfurante da órbita
H05.8 Outros transtornos da órbita
H05.9 Transtorno não especificado da órbita
H06.0*Transtornos do aparelho lacrimal em doenças classificadas em outra parte
H06.1*Infestação parasitária da órbita em doenças classificadas em outra parte
H06.2*Exoftalmo distireoídeo (E05.­+)
H06.3*Outros transtornos da órbita em doenças classificadas em outra parte
H10.0 Conjuntivite mucopurulenta
H10.1 Conjuntivite aguda atópica
H10.2 Outras conjuntivites agudas
H10.3 Conjuntivite aguda não especificada
H10.4 Conjuntivite crônica
H10.5 Blefaroconjuntivite
H10.8 Outras conjuntivites
H10.9 Conjuntivite não especificada
H11.0 Pterígio
H11.1 Degenerações e depósitos da conjuntiva
H11.2 Cicatrizes da conjuntiva
H11.3 Hemorragia conjuntival
H11.4 Outros transtornos vasculares e cistos conjuntivais
H11.8 Outros transtornos especificados da conjuntiva
H11.9 Transtorno não especificado da conjuntiva
H13.0*Infestação por filárias na conjuntiva (B74.­+)
H13.1*Conjuntivite em doenças infecciosas e parasitárias classificadas em outra parte
H13.2*Conjuntivite em outras doenças classificadas em outra parte
H13.3*Penfigóide ocular (L12.­+)
H13.8*Outros transtornos da conjuntiva em doença classificadas em outra parte
H15.0 Esclerite
H15.1 Episclerite
H15.8 Outros transtornos da esclerótica
H15.9 Transtorno não especificado da esclerótica
H16.0 Úlcera de córnea
H16.1 Outras ceratites superficiais sem conjuntivite
H16.2 Ceratoconjuntivite
H16.3 Ceratites intersticial e profunda
H16.4 Neovascularização da córnea
H16.8 Outras ceratites
H16.9 Ceratite não especificada
H17.0 Leucoma aderente
H17.1 Outra opacidade central da córnea
H17.8 Outras cicatrizes e opacidades da córnea
H17.9 Cicatriz e opacidade não especificadas da córnea
H18.0 Pigmentações e depósitos da córnea
H18.1 Ceratopatia bolhosa
H18.2 Outros edemas da córnea
H18.3 Alterações nas membranas da córnea
H18.4 Degenerações da córnea
H18.5 Distrofias hereditárias da córnea
H18.6 Ceratocone
H18.7 Outras deformidades da córnea
H18.8 Outros transtornos especificados da córnea
H18.9 Transtorno não especificado da córnea
H19.0*Esclerite e episclerite em doenças classificadas em outra parte
H19.1*Ceratite e ceratoconjuntivite pelo vírus do herpes simples (B00.5+)
H19.2*Ceratite e ceratoconjuntivite em outras doenças infecciosas e parasitárias classificadas em outra
parte
H19.3*Ceratite e ceratoconjuntivite em outras doenças classificadas em outra parte
H19.8*Outros transtornos de esclerótica e da córnea em doenças classificadas em outra parte
H20.0 Iridociclite aguda e subaguda
H20.1 Iridociclite crônica
H20.2 Iridociclite induzida pelo cristalino
H20.8 Outras iridociclites
H20.9 Iridociclite não especificada
H21.0 Hifema
H21.1 Outros transtornos vasculares da íris e do corpo ciliar
H21.2 Degenerações da íris e do corpo ciliar
H21.3 Cistos da íris, do corpo ciliar e da câmara anterior
H21.4 Membranas pupilares
H21.5 Outras aderências e roturas da íris e do corpo ciliar
H21.8 Outros transtornos especificados da íris e do corpo ciliar
H21.9 Transtorno não especificado da íris e do corpo ciliar
H22.0*Iridociclite em doenças infecciosas e parasitárias classificadas em outra parte
H22.1*Iridociclite em outras doenças classificadas em outra parte
H22.8*Outros transtornos da íris e do corpo ciliar em doenças classificadas em outra parte
H25.0 Catarata senil incipiente
H25.1 Catarata senil nuclear
H25.2 Catarata senil tipo Morgagni
H25.8 Outras cataratas senis
H25.9 Catarata senil não especificada
H26.0 Catarata infantil, juvenil e pré­senil
H26.1 Catarata traumática
H26.2 Catarata complicada
H26.3 Catarata induzida por drogas
H26.4 Pós­catarata
H26.8 Outras cataratas especificadas
H26.9 Catarata não especificada
H27.0 Afacia
H27.1 Deslocamento do cristalino
H27.8 Outros transtornos especificados do cristalino
H27.9 Transtorno não especificado do cristalino
H28.0*Catarata diabética (E10­E14+ com quarto caractere comum .3)
H28.1*Catarata em outras doenças endócrinas, nutricionais e metabólicas
H28.2*Catarata em outras doenças classificadas em outra parte
H28.8*Outros transtorno do cristalino em doenças classificadas em outra parte
H30.0 Inflamação coriorretiniana focal
H30.1 Inflamação corrorretiniana disseminada
H30.2 Ciclite posterior
H30.8 Outras inflamações coriorretinianas
H30.9 Inflamação não especificada da coróide e da retina
H31.0 Cicatrizes coriorretinianas
H31.1 Degeneração da coróide
H31.2 Distrofia hereditária da coróide
H31.3 Hemorragia e rotura da coróide
H31.4 Descolamento da coróide
H31.8 Outros transtornos especificados da coróide
H31.9 Transtorno não especificado da coróide
H32.0*Inflamação coriorretiniana em doenças infecciosas e parasitárias classificadas em outra parte
H32.8*Outros transtornos coriorretinianos em doenças classificadas em outra parte
H33.0 Descolamento da retina com defeito retiniano
H33.1 Retinosquise e cistos da retina
H33.2 Descolamento seroso da retina
H33.3 Defeitos da retina sem descolamento
H33.4 Descolamento da retina por tração
H33.5 Outros descolamentos da retina
H34.0 Oclusão arterial retiniana transitória
H34.1 Oclusão da artéria retiniana central
H34.2 Outras oclusões da artéria retiniana
H34.8 Outras oclusões vasculares retinianas
H34.9 Oclusão vascular retiniana não especificada
H35.0 Retinopatias de fundo e alterações vasculares da retina
H35.1 Retinopatia da prematuridade
H35.2 Outras retinopatias proliferativas
H35.3 Degeneração da mácula e do pólo posterior
H35.4 Degenerações periféricas da retina
H35.5 Distrofias hereditárias da retina
H35.6 Hemorragia retiniana
H35.7 Separação das camadas da retina
H35.8 Outros transtornos especificados da retina
H35.9 Transtorno da retina não especificado
H36.0*Retinopatia diabética (E10­E14+ com quarto caractere comum .3)
H36.8*Outros transtornos retinianos em doenças classificadas em outra parte
H40.0 Suspeita de glaucoma
H40.1 Glaucoma primário de ângulo aberto
H40.2 Glaucoma primário de ângulo fechado
H40.3 Glaucoma secundário a traumatismo ocular
H40.4 Glaucoma secundário a inflamação ocular
H40.5 Glaucoma secundário a outros transtornos do olho
H40.6 Glaucoma secundário a drogas
H40.8 Outro glaucoma
H40.9 Glaucoma não especificado
H42.0*Glaucoma em doenças endócrinas, nutricionais e metabólicas classificadas em outra parte
H42.8*Glaucoma em outras doenças classificadas em outra parte
H43.0 Prolapso do humor vítreo
H43.1 Hemorragia do humor vítreo
H43.2 Depósitos cristalinos no humor vítreo
H43.3 Outras opacidades do vítreo
H43.8 Outros transtornos do humor vítreo
H43.9 Transtorno não especificado do humor vítreo
H44.0 Endoftalmite purulenta
H44.1 Outras endoftalmites
H44.2 Miopia degenerativa
H44.3 Outros transtornos degenerativos do globo ocular
H44.4 Hipotonia do olho
H44.5 Afecções degenerativas do globo ocular
H44.6 Corpo estranho retido (antigo) intra­ocular de natureza magnética
H44.7 Corpo estranho retido (antigo) intra­ocular de natureza não­magnética
H44.8 Outros transtornos do globo ocular
H44.9 Transtorno não especificado do globo ocular
H45.0*Hemorragia vítrea em doenças classificadas em outra parte
H45.1*Endoftalmite em doenças classificadas em outra parte
H45.8*Outros transtornos do humor vítreo e do globo ocular em doenças classificadas em outra parte
H46 Neurite óptica
H47.0 Transtornos do nervo óptico não classificados em outra parte
H47.1 Papiledema não especificado
H47.2 Atrofia óptica
H47.3 Outros transtornos do disco óptico
H47.4 Transtornos do quiasma óptico
H47.5 Transtornos de outras vias ópticas
H47.6 Transtornos do córtex visual
H47.7 Transtornos não especificados das vias ópticas
H48.0*Atrofia óptica em doenças classificadas em outra parte
H48.1*Neurite retrobulbar em doenças classificadas em outra parte
H48.8*Outros transtornos do nervo óptico e das vias ópticas em doenças classificadas em outra parte
H49.0 Paralisia do terceiro par [oculomotor]
H49.1 Paralisia do quarto par [troclear]
H49.2 Paralisia do sexto par [abducente]
H49.3 Oftalmoplegia total (externa)
H49.4 Oftalmoplegia externa progressiva
H49.8 Outros estrabismos paralíticos
H49.9 Estrabismo paralítico não especificado
H50.0 Estrabismo convergente concomitante
H50.1 Estrabismo divergente concomitante
H50.2 Estrabismo vertical
H50.3 Heterotropia intermitente
H50.4 Outras heterotropias e as não especificadas
H50.5 Heteroforia
H50.6 Estrabismo mecânico
H50.8 Outros estrabismos especificados
H50.9 Estrabismo não especificado
H51.0 Paralisia do olhar conjugado
H51.1 Insuficiência ou excesso de convergência
H51.2 Oftalmoplegia internuclear
H51.8 Outros transtornos especificados do movimento binocular
H51.9 Transtorno não especificado do movimento binocular
H52.0 Hipermetropia
H52.1 Miopia
H52.2 Astigmatismo
H52.3 Anisometropia e aniseiconia
H52.4 Presbiopia
H52.5 Transtornos da acomodação
H52.6 Outros transtornos da refração
H52.7 Transtorno não especificado da refração
H53.0 Ambliopia por anopsia
H53.1 Distúrbios visuais subjetivos
H53.2 Diplopia
H53.3 Outros transtornos da visão binocular
H53.4 Defeitos do campo visual
H53.5 Deficiências da visão cromática
H53.6 Cegueira noturna
H53.8 Outros distúrbios visuais
H53.9 Distúrbio visual não especificado
H54.0 Cegueira, ambos os olhos
H54.1 Cegueira em um olho e visão subnormal em outro
H54.2 Visão subnormal de ambos os olhos
H54.3 Perda não qualificada da visão em ambos os olhos
H54.4 Cegueira em um olho
H54.5 Visão subnormal em um olho
H54.6 Perda não qualificada da visão em um olho
H54.7 Perda não especificada da visão
H55 Nistagmo e outros movimentos irregulares do olho
H57.0 Anomalias da função pupilar
H57.1 Dor ocular
H57.8 Outros transtornos especificados do olho e anexos
H57.9 Transtorno não especificado do olho e anexos
H58.0*Anomalias da função pupilar em doenças classificadas em outra parte
H58.1*Distúrbios visuais em doenças classificadas em outra parte
H58.8*Outros transtornos especificados do olho e anexos em doenças classificadas em outra parte
H59.0 Síndrome vítrea subseqüente a cirurgia de catarata
H59.8 Outros transtornos do olho e anexos pós­procedimentos
H59.9 Transtorno não especificado do olho e anexos pós­procedimento
H60.0 Abscesso do ouvido externo
H60.1 Celulite do ouvido externo
H60.2 Otite externa maligna
H60.3 Outras otites externas infecciosas
H60.4 Colesteatoma do ouvido externo
H60.5 Otite externa aguda não­infecciosa
H60.8 Outras otites externas
H60.9 Otite externa não especificada
H61.0 Pericondrite do pavilhão da orelha
H61.1 Transtornos não­infecciosos do pavilhão da orelha
H61.2 Cerume impactado
H61.3 Estenose adquirida do conduto auditivo externo
H61.8 Outros transtornos especificados do ouvido externo
H61.9 Transtorno não especificado do ouvido externo
H62.0*Otite externa em doenças bacterianas classificadas em outra parte
H62.1*Otite externa em doenças virais classificadas em outra parte
H62.2*Otite externa em micoses
H62.3*Otite externa em outras doenças infecciosas e parasitárias classificadas em outra parte
H62.4*Otite externa em outras doenças classificadas em outra parte
H62.8*Outros transtornos do ouvido externo em doenças classificadas em outra parte
H65.0 Otite média aguda serosa
H65.1 Outras otites médias agudas não­supurativas
H65.2 Otite média serosa crônica
H65.3 Otite média mucóide crônica
H65.4 Outras otites médias crônicas não­supurativas
H65.9 Otite média não­supurativa, não especificada
H66.0 Otite média aguda supurativa
H66.1 Otite média tubotimpânica supurativa crônica
H66.2 Otite média ático­antral supurativa crônica
H66.3 Outras otites médias supurativas crônicas
H66.4 Otite média supurativa não especificada
H66.9 Otite média não especificada
H67.0*Otite média em doenças bacterianas classificadas em outra parte
H67.1*Otite média em doenças virais classificadas em outra parte
H67.8*Otite média em outras doenças classificadas em outra parte
H68.0 Salpingite da trompa de Eustáquio
H68.1 Obstrução da trompa de Eustáquio
H69.0 Trompa de Eustáquio aberta (patente) (patulosa)
H69.8 Outros transtornos especificados da trompa de Eustáquio
H69.9 Transtorno não especificado da trompa de Eustáquio
H70.0 Mastoidite aguda
H70.1 Mastoidite crônica
H70.2 Petrosite
H70.8 Outras mastoidites e afecções relacionadas com a mastoidite
H70.9 Mastoidite não especificada
H71 Colesteatoma do ouvido médio
H72.0 Perfuração central da membrana do tímpano
H72.1 Perfuração ática da membrana do tímpano
H72.2 Outras perfurações marginais da membrana do tímpano
H72.8 Outras perfurações da membrana do tímpano
H72.9 Perfuração não especificada da membrana do tímpano
H73.0 Miringite aguda
H73.1 Miringite crônica
H73.8 Outros transtornos especificados da membrana do tímpano
H73.9 Transtorno não especificado da membrana do tímpano
H74.0 Timpanosclerose
H74.1 Doença adesiva do ouvido médio
H74.2 Descontinuidade e deslocamento dos ossículos do ouvido
H74.3 Outras anormalidades adquiridas dos ossículos do ouvido
H74.4 Pólipo do ouvido médio
H74.8 Outros transtornos especificados do ouvido médio e da mastóide
H74.9 Transtorno não especificado do ouvido médio e da mastóide
H75.0*Mastoidite em doenças infecciosas e parasitárias classificadas em outra parte
H75.8*Outros transtornos especificados do ouvido médio e da mastóide em doenças classificadas em
outra parte
H80.0 Otosclerose que compromete a janela oval, não­obliterante
H80.1 Otosclerose que compromete a janela oval, obliterante
H80.2 Otosclerose da cóclea
H80.8 Outras otoscleroses
H80.9 Otosclerose não especificada
H81.0 Doença de Ménière
H81.1 Vertigem paroxística benigna
H81.2 Neuronite vestibular
H81.3 Outras vertigens periféricas
H81.4 Vertigem de origem central
H81.8 Outros transtornos da função vestibular
H81.9 Transtornos não especificados da função vestibular
H82 *Síndromes vertiginosas em doenças classificadas em outra parte
H83.0 Labirintite
H83.1 Fístula do labirinto
H83.2 Disfunção do labirinto
H83.3 Efeitos do ruído sobre o ouvido interno
H83.8 Outros transtornos especificados do ouvido interno
H83.9 Transtorno não especificado do ouvido interno
H90.0 Perda de audição bilateral devida a transtorno de condução
H90.1 Perda de audição unilateral por transtorno de condução, sem restrição de audição contralateral
H90.2 Perda não especificada de audição devida a transtorno de condução
H90.3 Perda de audição bilateral neuro­sensorial
H90.4 Perda de audição unilateral neuro­sensorial, sem restrição de audição contralateral
H90.5 Perda de audição neuro­sensorial não especificada
H90.6 Perda de audição bilateral mista, de condução e neuro­sensorial
H90.7 Perda de audição unilateral mista, de condução e neuro­sensorial, sem restrição de audição
contralateral
H90.8 Perda de audição mista, de condução e neuro­sensorial, não especificada
H91.0 Perda de audição ototóxica
H91.1 Presbiacusia
H91.2 Perda de audição súbita idiopática
H91.3 Surdo­mudez não classificada em outra parte
H91.8 Outras perdas de audição especificadas
H91.9 Perda não especificada de audição
H92.0 Otalgia
H92.1 Otorréia
H92.2 Otorragia
H93.0 Transtornos degenerativos e vasculares do ouvido
H93.1 Tinnitus
H93.2 Outras percepções auditivas anormais
H93.3 Transtornos do nervo acústico
H93.8 Outros transtornos especificados do ouvido
H93.9 Transtorno não especificado do ouvido
H94.0*Neurite acústica em doenças infecciosas e parasitárias classificadas em outra parte
H94.8*Outros transtornos especificados do ouvido em doenças classificadas em outra parte
H95.0 Colesteatoma recorrente da cavidade pós­mastoidectomia
H95.1 Outros transtornos conseqüentes à mastoidectomia
H95.8 Outros transtornos do ouvido e da apófise mastóide pós­procedimento
H95.9 Transtorno não especificado do ouvido e da apófise mastóide pós­procedimento
I00 Febre reumática sem menção de comprometimento do coração
I01.0 Pericardite reumática aguda
I01.1 Endocardite reumática aguda
I01.2 Miocardite reumática aguda
I01.8 Outras formas de doença cardíaca reumática aguda
I01.9 Doença cardíaca reumática aguda não especificada
I02.0 Coréia reumática com comprometimento cardíaco
I02.9 Coréia reumática sem comprometimento cardíaco
I05.0 Estenose mitral
I05.1 Insuficiência mitral reumática
I05.2 Estenose mitral com insuficiência
I05.8 Outras doenças da valva mitral
I05.9 Doença não especificada da valva mitral
I06.0 Estenose aórtica reumática
I06.1 Insuficiência aórtica reumática
I06.2 Estenose aórtica reumática com insuficiência
I06.8 Outras doenças reumáticas da valva aórtica
I06.9 Doença reumática da valva aórtica, não especificada
I07.0 Estenose tricúspide
I07.1 Insuficiência tricúspide
I07.2 Estenose tricúspide com insuficiência
I07.8 Outras doenças da valva tricúspide
I07.9 Doença não especificada da valva tricúspide
I08.0 Transtornos de valvas mitral e aórtica
I08.1 Transtornos de ambas as valvas mitral e tricúspide
I08.2 Transtornos de ambas as valvas aórtica e tricúspide
I08.3 Transtornos das valvas mitral, aórtica e tricúspide
I08.8 Outras doenças de múltiplas valvas
I08.9 Doença não especificada de múltiplas valvas
I09.0 Miocardite reumática
I09.1 Doenças reumáticas do endocárdio, valva não especificada
I09.2 Pericardite reumática crônica
I09.8 Outras doenças reumáticas especificadas do coração
I09.9 Doença cardíaca reumática não especificada
I10 Hipertensão essencial (primária)
I11.0 Doença cardíaca hipertensiva com insuficiência cardíaca (congestiva)
I11.9 Doença cardíaca hipertensiva sem insuficiência cardíaca (congestiva)
I12.0 Doença renal hipertensiva com insuficiência renal
I12.9 Doença renal hipertensiva sem insuficiência renal
I13.0 Doença cardíaca e renal hipertensiva com insuficiência cardíaca (congestiva)
I13.1 Doença cardíaca e renal hipertensiva com insuficiência renal
I13.2 Doença cardíaca e renal hipertensiva com insuficiência cardíaca (congestiva) e insuficiência renal
I13.9 Doença cardíaca e renal hipertensiva, não especificada
I15.0 Hipertensão renovascular
I15.1 Hipertensão secundária a outras afecções renais
I15.2 Hipertensão secundária a afecções endócrinas
I15.8 Outras formas de hipertensão secundária
I15.9 Hipertensão secundária, não especificada
I20.0 Angina instável
I20.1 Angina pectoris com espasmo documentado
I20.8 Outras formas de angina pectoris
I20.9 Angina pectoris, não especificada
I21.0 Infarto agudo transmural da parede anterior do miocárdio
I21.1 Infarto agudo transmural da parede inferior do miocárdio
I21.2 Infarto agudo transmural do miocárdio de outras localizações
I21.3 Infarto agudo transmural do miocárdio, de localização não especificada
I21.4 Infarto agudo subendocárdico do miocárdio
I21.9 Infarto agudo do miocárdio não especificado
I22.0 Infarto do miocárdio recorrente da parede anterior
I22.1 Infarto do miocárdio recorrente da parede inferior
I22.8 Infarto do miocárdio recorrente de outras localizações
I22.9 Infarto do miocárdio recorrente de localização não especificada
I23.0 Hemopericárdio como complicação atual subseqüente ao infarto agudo do miocárdio
I23.1 Comunicação interatrial como complicação atual subseqüente ao infarto agudo do miocárdio
I23.2 Comunicação interventricular como complicação atual subseqüente ao infarto agudo do
miocárdio
I23.3 Ruptura da parede do coração sem ocorrência de hemopericárdio como complicação atual
subseqüente ao infarto agudo do miocárdio
I23.4 Ruptura de cordoalhas tendíneas como complicação atual subseqüente ao infarto agudo do
miocárdio
I23.5 Ruptura de músculos papilares como complicação atual subseqüente ao infarto agudo do
miocárdio
I23.6 Trombose de átrio, aurícula e ventrículo como complicação atual subseqüente ao infarto agudo
do miocárdio
I23.8 Outras complicações atuais subseqüentes ao infarto agudo do miocárdio
I24.0 Trombose coronária que não resulta em infarto do miocárdio
I24.1 Síndrome de Dressler
I24.8 Outras formas de doença isquêmica aguda do coração
I24.9 Doença isquêmica aguda do coração não especificada
I25.0 Doença cardiovascular aterosclerótica, descrita desta maneira
I25.1 Doença aterosclerótica do coração
I25.2 Infarto antigo do miocárdio
I25.3 Aneurisma cardíaco
I25.4 Aneurisma de artéria coronária
I25.5 Miocardiopatia isquêmica
I25.6 Isquemia miocárdica silenciosa
I25.8 Outras formas de doença isquêmica crônica do coração
I25.9 Doença isquêmica crônica do coração não especificada
I26.0 Embolia pulmonar com menção de cor pulmonale agudo
I26.9 Embolia pulmonar sem menção de cor pulmonale agudo
I27.0 Hipertensão pulmonar primária
I27.1 Cardiopatia cifoescoliótica
I27.8 Outras doenças pulmonares do coração especificadas
I27.9 Cardiopatia pulmonar não especificada
I28.0 Fístula arteriovenosa de vasos pulmonares
I28.1 Aneurisma da artéria pulmonar
I28.8 Outras doenças especificadas dos vasos pulmonares
I28.9 Doença não especificada dos vasos pulmonares
I30.0 Pericardite aguda idiopática não específica
I30.1 Pericardite infecciosa
I30.8 Outras formas de pericardite aguda
I30.9 Pericardite aguda não especificada
I31.0 Pericardite adesiva crônica
I31.1 Pericardite constritiva crônica
I31.2 Hemopericárdio não classificado em outra parte
I31.3 Derrame pericárdico (não­inflamatório)
I31.8 Outras doenças especificadas do pericárdio
I31.9 Doença não especificada do pericárdio
I32.0*Pericardite em doenças bacterianas classificadas em outra parte
I32.1*Pericardite em outras doenças infecciosas e parasitárias classificadas em outra parte
I32.8*Pericardite em outras doenças classificadas em outra parte
I33.0 Endocardite infecciosa aguda e subaguda
I33.9 Endocardite aguda não especificada
I34.0 Insuficiência (da valva) mitral
I34.1 Prolapso (da valva) mitral
I34.2 Estenose (da valva) mitral, não­reumática
I34.8 Outros transtornos não­reumáticos da valva mitral
I34.9 Transtornos não­reumáticos da valva mitral, não especificados
I35.0 Estenose (da valva) aórtica
I35.1 Insuficiência (da valva) aórtica
I35.2 Estenose (da valva) aórtica com insuficiência
I35.8 Outros transtornos da valva aórtica
I35.9 Transtornos não especificados da valva aórtica
I36.0 Estenose (da valva) tricúspide não­reumática
I36.1 Insuficiência (da valva) tricúspide não­reumática
I36.2 Estenose (da valva) tricúspide com insuficiência, não­reumática
I36.8 Outros transtornos não­reumáticos da valva tricúspide
I36.9 Transtornos não­reumáticos da valva tricúspide, não especificados
I37.0 Estenose da valva pulmonar
I37.1 Insuficiência da valva pulmonar
I37.2 Estenose da valva pulmonar com insuficiência
I37.8 Outros transtornos da valva pulmonar
I37.9 Transtornos não especificados da valva pulmonar
I38 Endocardite de valva não especificada
I39.0*Transtornos da valva mitral em doenças classificadas em outra parte
I39.1*Transtornos da valva aórtica em doenças classificadas em outra parte
I39.2*Transtornos da valva tricúspide em doenças classificadas em outra parte
I39.3*Transtornos da valva pulmonar em doenças classificadas em outra parte
I39.4*Transtornos de múltiplas valvas em doenças classificadas em outra parte
I39.8*Endocardite, de valva não especificada, em doenças classificadas em outra parte
I40.0 Miocardite infecciosa
I40.1 Miocardite isolada
I40.8 Outras miocardites agudas
I40.9 Miocardite aguda não especificada
I41.0*Miocardite em doenças bacterianas classificadas em outra parte
I41.1*Miocardite em doenças virais classificadas em outra parte
I41.2*Miocardite em outras doenças infecciosas e parasitárias classificadas em outra parte
I41.8*Miocardite em outras doenças classificadas em outra parte
I42.0 Cardiomiopatia dilatada
I42.1 Cardiomiopatia obstrutiva hipertrófica
I42.2 Outras cardiomiopatias hipertróficas
I42.3 Doença endomiocárdica (eosinofílica)
I42.4 Fibroelastose endocárdica
I42.5 Outras cardiomiopatias restritivas
I42.6 Cardiomiopatia alcoólica
I42.7 Cardiomiopatia devida a drogas e outros agentes externos
I42.8 Outras cardiomiopatias
I42.9 Cardiomiopatia não especificada
I43.0*Cardiomiopatia em doenças infecciosas e parasitárias classificadas em outra parte
I43.1*Cardiomiopatia em doenças metabólicas
I43.2*Cardiomiopatia em doenças nutricionais
I43.8*Cardiomiopatia em outras doenças classificadas em outra parte
I44.0 Bloqueio atrioventricular de primeiro grau
I44.1 Bloqueio atrioventricular de segundo grau
I44.2 Bloqueio atrioventricular total
I44.3 Outras formas de bloqueio atrioventricular e as não especificadas
I44.4 Bloqueio do fascículo anterior esquerdo
I44.5 Bloqueio do fascículo posterior esquerdo
I44.6 Outras formas de bloqueio fascicular e as não especificadas
I44.7 Bloqueio de ramo esquerdo não especificado
I45.0 Bloqueio fascicular direito
I45.1 Outras formas de bloqueio de ramo direito e as não especificadas
I45.2 Bloqueio bifascicular
I45.3 Bloqueio trifascicular
I45.4 Bloqueio intraventricular não específico
I45.5 Outras formas especificadas de bloqueio cardíaco
I45.6 Síndrome de pré­excitação
I45.8 Outros transtornos especificados da condução
I45.9 Transtorno de condução não especificado
I46.0 Parada cardíaca com ressuscitação bem sucedida
I46.1 Morte súbita (de origem) cardíaca, descrita desta forma
I46.9 Parada cardíaca não especificada
I47.0 Arritmia ventricular por reentrada
I47.1 Taquicardia supraventricular
I47.2 Taquicardia ventricular
I47.9 Taquicardia paroxística não especificada
I48 "Flutter" e fibrilação atrial
I49.0 Flutter e fibrilação ventricular
I49.1 Despolarização atrial prematura
I49.2 Despolarização juncional prematura
I49.3 Despolarização ventricular prematura
I49.4 Outras formas de despolarização prematura e as não especificadas
I49.5 Síndrome do nó sinusal
I49.8 Outras arritmias cardíacas especificadas
I49.9 Arritmia cardíaca não especificada
I50.0 Insuficiência cardíaca congestiva
I50.1 Insuficiência ventricular esquerda
I50.9 Insuficiência cardíaca não especificada
I51.0 Defeito adquirido de septo cardíaco
I51.1 Ruptura de cordoalha tendínea, não classificada em outra parte
I51.2 Ruptura de músculo papilar, não classificada em outra parte
I51.3 Trombose intracardíaca, não classificada em outra parte
I51.4 Miocardite não especificada
I51.5 Degeneração miocárdica
I51.6 Doença cardiovascular não especificada
I51.7 Cardiomegalia
I51.8 Outras doenças mal definidas do coração
I51.9 Doença não especificada do coração
I52.0*Outras afecções cardíacas em doenças bacterianas classificadas em outra parte
I52.1*Outras afecções cardíacas em outras doenças infecciosas e parasitárias classificadas em outra
parte
I52.8*Outras afecções cardíacas em outras doenças classificadas em outra parte
I60.0 Hemorragia subaracnóide proveniente do sifão e da bifurcação da carótida
I60.1 Hemorragia subaracnóide proveniente da artéria cerebral média
I60.2 Hemorragia subaracnóide proveniente da artéria comunicante anterior
I60.3 Hemorragia subaracnóide proveniente da artéria comunicante posterior
I60.4 Hemorragia subaracnóide proveniente da artéria basilar
I60.5 Hemorragia subaracnóide proveniente da artéria vertebral
I60.6 Hemorragia subaracnóide proveniente de outras artérias intracranianas
I60.7 Hemorragia subaracnóide proveniente de artéria intracraniana não especificada
I60.8 Outras hemorragias subaracnóides
I60.9 Hemorragia subaracnóide não especificada
I61.0 Hemorragia intracerebral hemisférica subcortical
I61.1 Hemorragia intracerebral hemisférica cortical
I61.2 Hemorragia intracerebral hemisférica não especificada
I61.3 Hemorragia intracerebral do tronco cerebral
I61.4 Hemorragia intracerebral cerebelar
I61.5 Hemorragia intracerebral intraventricular
I61.6 Hemorragia intracerebral de múltiplas localizações
I61.8 Outras hemorragias intracerebrais
I61.9 Hemorragia intracerebral não especificada
I62.0 Hemorragia subdural (aguda) (não­traumática)
I62.1 Hemorragia extradural não­traumática
I62.9 Hemorragia intracraniana (não­traumática) não especificada
I63.0 Infarto cerebral devido a trombose de artérias pré­cerebrais
I63.1 Infarto cerebral devido a embolia de artérias pré­cerebrais
I63.2 Infarto cerebral devido a oclusão ou estenose não especificadas de artérias pré­cerebrais
I63.3 Infarto cerebral devido a trombose de artérias cerebrais
I63.4 Infarto cerebral devido a embolia de artérias cerebrais
I63.5 Infarto cerebral devido a oclusão ou estenose não especificadas de artérias cerebrais
I63.6 Infarto cerebral devido a trombose venosa cerebral não­piogênica
I63.8 Outros infartos cerebrais
I63.9 Infarto cerebral não especificado
I64 Acidente vascular cerebral, não especificado como hemorrágico ou isquêmico
I65.0 Oclusão e estenose da artéria vertebral
I65.1 Oclusão e estenose da artéria basilar
I65.2 Oclusão e estenose da artéria carótida
I65.3 Oclusão e estenose de artérias pré­cerebrais múltiplas e bilaterais
I65.8 Oclusão e estenose de outra artéria pré­cerebral
I65.9 Oclusão e estenose de artérias pré­cerebrais não especificadas
I66.0 Oclusão e estenose da artéria cerebral média
I66.1 Oclusão e estenose da artéria cerebral anterior
I66.2 Oclusão e estenose da artéria cerebral posterior
I66.3 Oclusão e estenose de artérias cerebelares
I66.4 Oclusão e estenose de artérias cerebrais, múltiplas e bilaterais
I66.8 Oclusão e estenose de outra artéria cerebral
I66.9 Oclusão e estenose de artéria cerebral não especificada
I67.0 Dissecção de artérias cerebrais, sem ruptura
I67.1 Aneurisma cerebral não­roto
I67.2 Aterosclerose cerebral
I67.3 Lencoencefalopatia vascular progressiva
I67.4 Encefalopatia hipertensiva
I67.5 Doença de Moyamoya
I67.6 Trombose não­piogênica do sistema venoso intracraniano
I67.7 Arterite cerebral não classificada em outra parte
I67.8 Outras doenças cerebrovasculares especificadas
I67.9 Doença cerebrovascular não especificada
I68.0*Angiopatia cerebral amiloidótica (E85.­+)
I68.1*Arterite cerebral em doenças infecciosas e parasitárias
I68.2*Arterite cerebral em outras doenças classificadas em outra parte
I68.8*Outros transtornos cerebrovasculares em doenças classificadas em outra parte
I69.0 Seqüelas de hemorragia subaracnoídea
I69.1 Seqüelas de hemorragia intracerebral
I69.2 Seqüelas de outras hemorragias intracranianas não traumáticas
I69.3 Seqüelas de infarto cerebral
I69.4 Seqüelas de acidente vascular cerebral não especificado como hemorrágico ou isquêmico
I69.8 Seqüelas de outras doenças cerebrovasculares e das não especificadas
I70.0 Aterosclerose da aorta
I70.1 Aterosclerose da artéria renal
I70.2 Aterosclerose das artérias das extremidades
I70.8 Aterosclerose de outras artérias
I70.9 Aterosclerose generalizada e a não especificada
I71.0 Aneurisma dissecante da aorta [qualquer porção]
I71.1 Aneurisma da aorta torácica, roto
I71.2 Aneurisma da aorta torácica, sem menção de ruptura
I71.3 Aneurisma da aorta abdominal, roto
I71.4 Aneurisma da aorta abdominal, sem menção de ruptura
I71.5 Aneurisma da aorta tóraco­abdominal, roto
I71.6 Aneurisma da aorta toráco­abdominal, sem menção de ruptura
I71.8 Aneurisma da aorta de localização não especificada, roto
I71.9 Aneurisma aórtico de localização não especificada, sem menção de ruptura
I72.0 Aneurisma da artéria carótida
I72.1 Aneurisma de artéria dos membros superiores
I72.2 Aneurisma da artéria renal
I72.3 Aneurisma de artéria ilíaca
I72.4 Aneurisma de artéria dos membros inferiores
I72.8 Aneurisma de outras artérias especificadas
I72.9 Aneurisma de localização não especificada
I73.0 Síndrome de Raynaud
I73.1 Tromboangeíte obliterante [doença de Buerger]
I73.8 Outras doenças vasculares periféricas especificadas
I73.9 Doenças vasculares periféricas não especificada
I74.0 Embolia e trombose da aorta abdominal
I74.1 Embolia e trombose de outras porções da aorta e das não especificadas
I74.2 Embolia e trombose de artérias dos membros superiores
I74.3 Embolia e trombose de artérias dos membros inferiores
I74.4 Embolia e trombose de artérias dos membros não especificadas
I74.5 Embolia e trombose da artéria ilíaca
I74.8 Embolia e trombose de outras artérias
I74.9 Embolia e trombose de artéria não especificada
I77.0 Fístula arteriovenosa adquirida
I77.1 Estenose de artéria
I77.2 Ruptura de artéria
I77.3 Displasia fibromuscular arterial
I77.4 Síndrome de compressão da artéria celíaca
I77.5 Necrose de artéria
I77.6 Arterite não especificada
I77.8 Outras afecções especificadas das artérias e das arteríolas
I77.9 Afecções de artérias e arteríolas, não especificadas
I78.0 Telangiectasia hemorrágica hereditária
I78.1 Nevo não­neoplásico
I78.8 Outras doenças dos capilares
I78.9 Doenças não especificadas dos capilares
I79.0*Aneurisma da aorta em doenças classificadas em outra parte
I79.1*Aortite em doenças classificadas em outra parte
I79.2*Angiopatia periférica em doenças classificadas em outra parte
I79.8*Outros transtornos das artérias, das arteríolas e dos capilares em doenças classificadas em
outra parte
I80.0 Flebite e tromboflebite dos vasos superficiais dos membros inferiores
I80.1 Flebite e tromboflebite da veia femural
I80.2 Flebite e tromboflebite de outros vasos profundos dos membros inferiores
I80.3 Flebite e tromboflebite dos membros inferiores, não especificada
I80.8 Flebite e tromboflebite de outras localizações
I80.9 Flebite e tromboflebite de localização não especificada
I81 Trombose da veia porta
I82.0 Síndrome de Budd­Chiari
I82.1 Tromboflebite migratória
I82.2 Embolia e trombose de veia cava
I82.3 Embolia e trombose de veia renal
I82.8 Embolia e trombose de outras veias especificadas
I82.9 Embolia e trombose venosas de veia não especificada
I83.0 Varizes dos membros inferiores com úlcera
I83.1 Varizes dos membros inferiores com inflamação
I83.2 Varizes dos membros inferiores com úlcera e inflamação
I83.9 Varizes dos membros inferiores sem úlcera ou inflamação
I84.0 Hemorróidas internas trombosadas
I84.1 Hemorróidas internas com outras complicações
I84.2 Hemorróidas internas sem complicações
I84.3 Hemorróidas externas trombosadas
I84.4 Hemorróidas externas com outras complicações
I84.5 Hemorróidas externas sem complicação
I84.6 Plicomas hemorroidários residuais
I84.7 Hemorróidas trombosadas, não especificadas
I84.8 Hemorróidas não especificadas com outras complicações
I84.9 Hemorróidas sem complicações, não especificadas
I85.0 Varizes esofagianas sangrantes
I85.9 Varizes esofagianas sem sangramento
I86.0 Varizes sublinguais
I86.1 Varizes escrotais
I86.2 Varizes pélvicas
I86.3 Varizes da vulva
I86.4 Varizes gástricas
I86.8 Varizes de outras localizações especificadas
I87.0 Síndrome pós­flebite
I87.1 Compressão venosa
I87.2 Insuficiência venosa (crônica) (periférica)
I87.8 Outros transtornos venosos especificados
I87.9 Transtorno venoso não especificado
I88.0 Linfadenite mesentérica não específica
I88.1 Linfadenite crônica, exceto a mesentérica
I88.8 Outras linfadenites inespecíficas
I88.9 Linfadenite não especificada
I89.0 Linfedema não classificado em outra parte
I89.1 Linfangite
I89.8 Outros transtornos não­infecciosos, especificados, dos vasos linfáticos e dos gânglios linfáticos
I89.9 Transtornos não­infecciosos dos vasos linfáticos e dos gânglios linfáticos, não especificados
I95.0 Hipotensão idiopática
I95.1 Hipotensão ortostática
I95.2 Hipotensão devida a drogas
I95.8 Outros tipos de hipotensão
I95.9 Hipotensão não especificada
I97.0 Síndrome pós­cardiotomia
I97.1 Outros distúrbios funcionais subseqüentes à cirurgia cardíaca
I97.2 Síndrome do linfedema pós­mastectomia
I97.8 Outros transtornos do aparelho circulatório subseqüentes a procedimentos não classificados em
outra parte
I97.9 Transtornos do aparelho circulatório, subseqüentes a procedimento não especificado
I98.0*Sífilis cardiovascular
I98.1*Transtornos cardiovasculares em outras doenças infecciosas e parasitárias classificadas em
outra parte
I98.2*Varizes esofagianas em doenças classificadas em outra parte
I98.8*Outros transtornos especificados do aparelho circulatório em doenças classificadas em outra
parte
I99 Outros transtornos do aparelho circulatório e os não especificados
J00 Nasofaringite aguda [resfriado comum]
J01.0 Sinusite maxilar aguda
J01.1 Sinusite frontal aguda
J01.2 Sinusite etmoidal aguda
J01.3 Sinusite esfenoidal aguda
J01.4 Pansinusite aguda
J01.8 Outras sinusites agudas
J01.9 Sinusite aguda não especificada
J02.0 Faringite estreptocócica
J02.8 Faringite aguda devida a outros microorganismos especificados
J02.9 Faringite aguda não especificada
J03.0 Amigdalite estreptocócica
J03.8 Amigdalite aguda devida a outros microorganismos especificados
J03.9 Amigdalite aguda não especificada
J04.0 Laringite aguda
J04.1 Traqueíte aguda
J04.2 Laringotraqueíte aguda
J05.0 Laringite obstrutiva aguda [crupe]
J05.1 Epiglotite aguda
J06.0 Laringofaringite aguda
J06.8 Outras infecções agudas das vias aéreas superiores de localizações múltiplas
J06.9 Infecção aguda das vias aéreas superiores não especificada
J10.0 Influenza com pneumonia devida ao vírus da influenza [gripe] identificado
J10.1 Influenza com outras manifestações respiratórias, devida a vírus da influenza [gripe] identificado
J10.8 Influenza com outras manifestações, devida a vírus da influenza [gripe] identificado
J11.0 Influenza [gripe] com pneumonia, devida a vírus não identificado
J11.1 Influenza [gripe] com outras manifestações respiratórias, devida a vírus não identificado
J11.8 Influenza [gripe] com outras manifestações, devida a vírus não identificado
J12.0 Pneumonia devida a adenovírus
J12.1 Pneumonia devida a vírus respiratório sincicial
J12.2 Pneumonia devida à parainfluenza
J12.8 Outras pneumonias virais
J12.9 Pneumonia viral não especificada
J13 Pneumonia devida a Streptococcus pneumoniae
J14 Pneumonia devida a Haemophilus infuenzae
J15.0 Pneumonia devida à Klebsiella pneumoniae
J15.1 Pneumonia devida a Pseudomonas
J15.2 Pneumonia devida a Staphylococcus
J15.3 Pneumonia devida a Streptococcus do grupo B
J15.4 Pneumonia devida a outros estreptococos
J15.5 Pneumonia devida a Escherichia coli
J15.6 Pneumonia devida a outras bactérias aeróbicas gram­negativas
J15.7 Pneumonia devida a Mycoplasma pneumoniae
J15.8 Outras pneumonias bacterianas
J15.9 Pneumonia bacteriana não especificada
J16.0 Pneumonia devida a clamídias
J16.8 Pneumonia devida a outros microorganismos infecciosos especificados
J17.0*Pneumonia em doenças bacterianas classificadas em outra parte
J17.1*Pneumonia em doenças virais classificadas em outra parte
J17.2*Pneumonia em micoses classificadas em outra parte
J17.3*Pneumonia em doenças parasitárias classificadas em outra parte
J17.8*Pneumonia em outras doenças classificadas em outra parte
J18.0 Broncopneumonia não especificada
J18.1 Pneumonia lobar não especificada
J18.2 Pneumonia hipostática não especificada
J18.8 Outras pneumonias devidas a microorganismos não especificados
J18.9 Pneumonia não especificada
J20.0 Bronquite aguda devida a Mycoplasma pneumoniae
J20.1 Bronquite aguda devida a Haemophilus influenzae
J20.2 Bronquite aguda devida a estreptococos
J20.3 Bronquite aguda devida a vírus Coxsackie
J20.4 Bronquite aguda devida a vírus parainfluenza
J20.5 Bronquite aguda devida a vírus sincicial respiratório
J20.6 Bronquite aguda devida a rinovírus
J20.7 Bronquite aguda devida a echovírus
J20.8 Bronquite aguda devida a outros microorganismos especificados
J20.9 Bronquite aguda não especificada
J21.0 Bronquiolite aguda devida a vírus sincicial respiratório
J21.8 Bronquiolite aguda devida a outros microorganismos especificados
J21.9 Bronquite aguda não especificada
J22 Infecções agudas não especificada das vias aéreas inferiores
J30.0 Rinite vasomotora
J30.1 Rinite alérgica devida a pólen
J30.2 Outras rinites alérgicas sazonais
J30.3 Outras rinites alérgicas
J30.4 Rinite alérgica não especificada
J31.0 Rinite crônica
J31.1 Nasofaringite crônica
J31.2 Faringite crônica
J32.0 Sinusite maxilar crônica
J32.1 Sinusite frontal crônica
J32.2 Sinusite etmoidal crônica
J32.3 Sinusite esfenoidal crônica
J32.4 Pansinusite crônica
J32.8 Outras sinusites crônicas
J32.9 Sinusite crônica não especificada
J33.0 Pólipo da cavidade nasal
J33.1 Degeneração polipóide do seio paranasal
J33.8 Outros pólipos do seio paranasal
J33.9 Pólipo nasal não especificado
J34.0 Abscesso, furúnculo e antraz do nariz
J34.1 Cisto e mucocele do nariz e do seio paranasal
J34.2 Desvio do septo nasal
J34.3 Hipertrofia dos cornetos nasais
J34.8 Outros transtornos especificados do nariz e dos seios paranasais
J35.0 Amigdalite crônica
J35.1 Hipertrofia das amígdalas
J35.2 Hipertrofia das adenóides
J35.3 Hipertrofia das amígdalas com hipertrofia das adenóides
J35.8 Outras doenças crônicas das amígdalas e das adenóides
J35.9 Doenças das amígdalas e das adenóides não especificadas
J36 Abscesso periamigdaliano
J37.0 Laringite crônica
J37.1 Laringotraqueíte crônica
J38.0 Paralisia das cordas vocais e da laringe
J38.1 Pólipo das cordas vocais e da laringe
J38.2 Nódulos das cordas vocais
J38.3 Outras doenças das cordas vocais
J38.4 Edema da laringe
J38.5 Espasmo da laringe
J38.6 Estenose da laringe
J38.7 Outras doenças da laringe
J39.0 Abscesso retrofaríngeo e parafaríngeo
J39.1 Outros abscessos da faringe
J39.2 Outras doenças da faringe
J39.3 Reação de hipersensibilidade das vias aéreas superiores de localização não especificada
J39.8 Outras doenças especificadas das vias aéreas superiores
J39.9 Doença não especificada das vias aéreas superiores
J40 Bronquite não especificada como aguda ou crônica
J41.0 Bronquite crônica simples
J41.1 Bronquite crônica mucopurulenta
J41.8 Bronquite crônica mista, simples e mucopurulenta
J42 Bronquite crônica não especificada
J43.0 Síndrome de MacLeod
J43.1 Enfisema panlobular
J43.2 Enfisema centrolobular
J43.8 Outras formas de enfisema
J43.9 Enfisema não especificado
J44.0 Doença pulmonar obstrutiva crônica com infecção respiratória aguda do trato respiratório inferior
J44.1 Doença pulmonar obstrutiva crônica com exacerbação aguda não especificada
J44.8 Outras formas especificadas de doença pulmonar obstrutiva crônica
J44.9 Doença pulmonar obstrutiva crônica não especificada
J45.0 Asma predominantemente alérgica
J45.1 Asma não­alérgica
J45.8 Asma mista
J45.9 Asma não especificada
J46 Estado de mal asmático
J47 Bronquectasia
J60 Pneumoconiose dos mineiros de carvão
J61 Pneumoconiose devida a amianto [asbesto] e outras fibras minerais
J62.0 Pneumoconiose devida a pó de talco
J62.8 Pneumoconiose devida a outras poeiras que contenham sílica
J63.0 Aluminose (do pulmão)
J63.1 Fibrose (do pulmão) causada por bauxita
J63.2 Beriliose
J63.3 Fibrose (do pulmão) causada por grafite
J63.4 Siderose
J63.5 Estanose
J63.8 Pneumoconiose devida a outras poeira inorgânicas especificados
J64 Pneumoconiose não especificada
J65 Pneumoconiose associada com tuberculose
J66.0 Bissinose
J66.1 Doença dos cardadores de linho
J66.2 Canabinose
J66.8 Doenças das vias aéreas devida a outras poeiras orgânicas específicas
J67.0 Pulmão de fazendeiro
J67.1 Bagaçose
J67.2 Pulmão dos criadores de pássaros
J67.3 Suberose
J67.4 Pulmão dos trabalhadores do malte
J67.5 Pulmão dos que trabalham com cogumelos
J67.6 Pulmão dos cortadores de casca do bordo
J67.7 Doença pulmonar devida aos sistemas de ar condicionado e de umidificação do ar
J67.8 Pneumonites de hipersensibilidade, devidas a outras poeiras orgânicas
J67.9 Pneumonite de hipersensibilidade devida a poeira orgânica não especificada
J68.0 Bronquite e pneumonite devida a produtos químicos, gases, fumaças e vapores
J68.1 Edema pulmonar agudo devido a produtos químicos, gases, fumaças e vapores
J68.2 Inflamação das vias aéreas superiores devida a produtos químicos, gases, fumaças e vapores,
não classificada em outra parte
J68.3 Outras afecções respiratórias agudas e subagudas devidas a produtos químicos, gases, fumaças
e vapores
J68.4 Afecções respiratórias crônicas devidas a produtos químicos, gases, fumaças e vapores
J68.8 Outras afecções respiratórias devida a produtos químicos, gases, fumaças e vapores
J68.9 Afecção respiratória não especificada devida a produtos químicos, gases, fumaça e vapores
J69.0 Pneumonite devida a alimento ou vômito
J69.1 Pneumonite devida a óleos e essências
J69.8 Pneumonite devida a outros sólidos e líquidos
J70.0 Manifestações pulmonares agudas devidas à radiação
J70.1 Manifestações pulmonares crônicas e outras, devidas a radiação
J70.2 Transtornos pulmonares intersticiais agudos, induzidos por droga
J70.3 Transtornos pulmonares intersticiais crônicos induzidos por droga
J70.4 Transtornos pulmonar intersticial não especificado induzido por droga
J70.8 Afecções respiratórias devidas a outros agentes externos especificados
J70.9 Afecções respiratórias devidas a agentes externos não especificados
J80 Síndrome do desconforto respiratório do adulto
J81 Edema pulmonar, não especificado de outra forma
J82 Eosinofilia pulmonar, não classificada em outra parte
J84.0 Afecções alveolares e parieto­alveolares
J84.1 Outras doenças pulmonares intersticiais com fibrose
J84.8 Outras doenças pulmonares intersticiais especificadas
J84.9 Doença pulmonar intersticial não especificadas
J85.0 Gangrena e necrose do pulmão
J85.1 Abscesso do pulmão com pneumonia
J85.2 Abscesso do pulmão sem pneumonia
J85.3 Abscesso do mediastino
J86.0 Piotórax com fístula
J86.9 Piotórax sem fístula
J90 Derrame pleural não classificado em outra parte
J91 *Derrame pleural em afecções classificadas em outra parte
J92.0 Placas pleurais com presença de amianto [asbesto]
J92.9 Placas pleurais cem presença de amianto [asbesto]
J93.0 Pneumotórax de tensão, espontâneo
J93.1 Outras formas de pneumotórax espontâneo
J93.8 Outros tipos de pneumotórax, especificados
J93.9 Pneumotórax não especificado
J94.0 Derrame quiloso ou quiliforme
J94.1 Fibrotórax
J94.2 Hemotórax
J94.8 Outras afecções pleurais especificadas
J94.9 Afecção pleural não especificada
J95.0 Mau funcionamento de traqueostomia
J95.1 Insuficiência pulmonar aguda subsequente a cirurgia torácica
J95.2 Insuficiência pulmonar aguda subsequente a cirurgia não torácica
J95.3 Insuficiência pulmonar crônica pós­cirúrgica
J95.4 Síndrome de Mendelson
J95.5 Estenose subglótica pós­procedimento
J95.8 Outros transtornos respiratórios pós­procedimentos
J95.9 Transtornos respiratórios pós­procedimentos não especificados
J96.0 Insuficiência respiratória aguda
J96.1 Insuficiência respiratória crônica
J96.9 Insuficiência respiratória não especificada
J98.0 Outras doenças dos brônquios não classificadas em outra parte
J98.1 Colapso pulmonar
J98.2 Enfisema intersticial
J98.3 Enfisema compensatório
J98.4 Outros transtornos pulmonares
J98.5 Doenças do mediastino não classificadas em outra parte
J98.6 Transtornos do diafragma
J98.8 Outros transtornos respiratórios especificados
J98.9 Transtorno respiratório não especificados
J99.0*Doença pulmonar reumatóide (M05.1+)
J99.1*Transtornos respiratórios em outras doenças sistêmicas do tecido conjuntivo classificadas em
outra parte
J99.8*Transtornos respiratórios em outras doenças classificadas em outra parte
K00.0 Anodontia
K00.1 Dentes supranumerários
K00.2 Anomalias do tamanho e da forma dos dentes
K00.3 Dentes manchados
K00.4 Distúrbios na formação dos dentes
K00.5 Anomalias hereditárias da estrutura dentária não classificadas em outra parte
K00.6 Distúrbios da erupção dentária
K00.7 Síndrome da erupção dentária
K00.8 Outros distúrbios do desenvolvimento dos dentes
K00.9 Distúrbio não especificado do desenvolvimento dentário
K01.0 Dentes inclusos
K01.1 Dentes impactados
K02.0 Cáries limitadas ao esmalte
K02.1 Cáries da dentina
K02.2 Cárie do cemento
K02.3 Cáries dentárias estáveis
K02.4 Odontoclasia
K02.8 Outras cáries dentárias
K02.9 Cárie dentária, sem outra especificação
K03.0 Atrito dentário excessivo
K03.1 Abrasão dentária
K03.2 Erosão dentária
K03.3 Reabsorção patológica dos dentes
K03.4 Hipercementose
K03.5 Ancilose dentária
K03.6 Depósitos nos dentes
K03.7 Alterações pós­eruptivas da cor dos tecidos duros dos dentes
K03.8 Outras doenças especificadas dos tecidos duros dos dentes
K03.9 Doença dos tecidos duros dos dentes, não especificada
K04.0 Pulpite
K04.1 Necrose da polpa
K04.2 Degeneração da polpa
K04.3 Formação anormal de tecidos duros na polpa
K04.4 Periodontite apical aguda de origem pulpar
K04.5 Periodontite apical crônica
K04.6 Abscesso periapical com fístula
K04.7 Abscesso periapical sem fístula
K04.8 Cisto radicular
K04.9 Outras doenças da polpa e dos tecidos periapicais e as não especificadas
K05.0 Gengivite aguda
K05.1 Gengivite crônica
K05.2 Periodontite aguda
K05.3 Periodontite crônica
K05.4 Periodontose
K05.5 Outras doenças periodontais
K05.6 Doença periodontal, sem outra especificação
K06.0 Retração gengival
K06.1 Hiperplasia gengival
K06.2 Lesões da gengiva e do rebordo alveolar sem dentes, associadas a traumatismos
K06.8 Outros transtornos especificados da gengiva e do rebordo alveolar sem dentes
K06.9 Transtorno da gengiva e do rebordo alveolar sem dentes sem outra especificação
K07.0 Anomalias importantes (major) do tamanho da mandíbula
K07.1 Anomalias da relação entre a mandíbula com a base do crânio
K07.2 Anomalias da relação entre as arcadas dentárias
K07.3 Anomalias da posição dos dentes
K07.4 Maloclusão, não especificada
K07.5 Anormalidades dentofaciais funcionais
K07.6 Transtornos da articulação temporomandibular
K07.8 Outras anomalias dentofaciais
K07.9 Anomalia dentofacial, sem outra especificação
K08.0 Exfoliação dos dentes devida a causas sistêmicas
K08.1 Perda de dentes devida a acidente, extração ou a doenças periodontais localizadas
K08.2 Atrofia do rebordo alveolar sem dentes
K08.3 Raiz dentária retida
K08.8 Outros transtornos especificados dos dentes e das estruturas de sustentação
K08.9 Transtorno dos dentes e de suas estruturas de sustentação, sem outra especificação
K09.0 Cistos odontogênicos de desenvolvimento
K09.1 Cistos de desenvolvimento (não­odontogênicos) da região bucal
K09.2 Outros cistos das mandíbulas
K09.8 Outros cistos da região oral não classificados em outra parte
K09.9 Cistos da região oral, sem outras especificações
K10.0 Transtornos do desenvolvimento dos maxilares
K10.1 Granuloma central de células gigantes
K10.2 Afecções inflamatórias dos maxilares
K10.3 Alveolite maxilar
K10.8 Outras doenças especificadas dos maxilares
K10.9 Doença dos maxilares, sem outra especificação
K11.0 Atrofia de glândula salivar
K11.1 Hipertrofia de glândula salivar
K11.2 Sialadenite
K11.3 Abscesso de glândula salivar
K11.4 Fístula de glândula salivar
K11.5 Sialolitíase
K11.6 Mucocele de glândula salivar
K11.7 Alterações da secreção salivar
K11.8 Outras doenças das glândulas salivares
K11.9 Doença de glândula salivar, sem outra especificação
K12.0 Aftas bucais recidivantes
K12.1 Outras formas de estomatite
K12.2 Celulite e abscesso da boca
K13.0 Doenças dos lábios
K13.1 Mordedura da mucosa das bochechas e dos lábios
K13.2 Leucoplasia e outras afecções do epitélio oral, inclusive da língua
K13.3 Leucoplasia pilosa
K13.4 Lesões granulomatosas e granulomatóides da mucosa oral
K13.5 Fibrose oral submucosa
K13.6 Hiperplasia irritativa da mucosa oral
K13.7 Outras lesões e as não especificadas da mucosa oral
K14.0 Glossite
K14.1 Língua geográfica
K14.2 Glossite rombóide mediana
K14.3 Hipertrofia das papilas linguais
K14.4 Atrofia das papilas linguais
K14.5 Língua escrotal
K14.6 Glossodínia
K14.8 Outras doenças da língua
K14.9 Doença da língua, sem outra especificação
K20 Esofagite
K21.0 Doença de refluxo gastroesofágico com esofagite
K21.9 Doença de refluxo gastroesofágico sem esofagite
K22.0 Acalásia do cárdia
K22.1 Úlcera do esôfago
K22.2 Obstrução do esôfago
K22.3 Perfuração do esôfago
K22.4 Discinesia do esôfago
K22.5 Divertículo do esôfago adquirido
K22.6 Síndrome da laceração hemorrágica gastroesofágica
K22.8 Outras doenças especificadas do esôfago
K22.9 Doença do esôfago, sem outra especificação
K23.0*Esofagite tuberculosa (A18.8+)
K23.1*Megaesôfago na doença de Chagas (B57.3+)
K23.8*Transtornos do esôfago em outras doenças classificadas em outra parte
K25.0 Úlcera gástrica ­ aguda com hemorragia
K25.1 Úlcera gástrica ­ aguda com perfuração
K25.2 Úlcera gástrica ­ aguda com hemorragia e perfuração
K25.3 Úlcera gástrica ­ aguda sem hemorragia ou perfuração
K25.4 Úlcera gástrica ­ crônica ou não especificada com hemorragia
K25.5 Úlcera gástrica ­ crônica ou não especificada com perfuração
K25.6 Úlcera gástrica ­ crônica ou não especificada com hemorragia e perfuração
K25.7 Úlcera gástrica ­ crônica sem hemorragia ou perfuração
K25.9 Úlcera gástrica ­ não especificada como aguda ou crônica, sem hemorragia ou perfuração
K26.0 Úlcera duodenal ­ aguda com hemorragia
K26.1 Úlcera duodenal ­ aguda com perfuração
K26.2 Úlcera duodenal ­ aguda com hemorragia e perfuração
K26.3 Úlcera duodenal ­ aguda sem hemorragia ou perfuração
K26.4 Úlcera duodenal ­ crônica ou não especificada com hemorragia
K26.5 Úlcera duodenal ­ crônica ou não especificada com perfuração
K26.6 Úlcera duodenal ­ crônica ou não especificada com hemorragia e perfuração
K26.7 Úlcera duodenal ­ crônica sem hemorragia ou perfuração
K26.9 Úlcera duodenal ­ não especificada como aguda ou crônica, sem hemorragia ou perfuração
K27.0 Úlcera péptica de localização não especificada ­ aguda com hemorragia
K27.1 Úlcera péptica de localização não especificada ­ aguda com perfuração
K27.2 Úlcera péptica de localização não especificada ­ aguda com hemorragia e perfuração
K27.3 Úlcera péptica de localização não especificada ­ aguda sem hemorragia ou perfuração
K27.4 Úlcera péptica de localização não especificada ­ crônica ou não especificada com hemorragia
K27.5 Úlcera péptica de localização não especificada ­ crônica ou não especificada com perfuração
K27.6 Úlcera péptica de localização não especificada ­ crônica ou não especificada com hemorragia e
perfuração
K27.7 Úlcera péptica de localização não especificada ­ crônica sem hemorragia ou perfuração
K27.9 Úlcera péptica de localização não especificada ­ não especificada como aguda ou crônica, sem
hemorragia ou perfuração
K28.0 Úlcera gastrojejunal ­ aguda com hemorragia
K28.1 Úlcera gastrojejunal ­ aguda com perfuração
K28.2 Úlcera gastrojejunal ­ aguda com hemorragia e perfuração
K28.3 Úlcera gastrojejunal ­ aguda sem hemorragia ou perfuração
K28.4 Úlcera gastrojejunal ­ crônica ou não especificada com hemorragia
K28.5 Úlcera gastrojejunal ­ crônica ou não especificada com perfuração
K28.6 Úlcera gastrojejunal ­ crônica ou não especificada com hemorragia e perfuração
K28.7 Úlcera gastrojejunal ­ crônica sem hemorragia ou perfuração
K28.9 Úlcera gastrojejunal ­ não especificada como aguda ou crônica, sem hemorragia ou perfuração
K29.0 Gastrite hemorrágica aguda
K29.1 Outras gastrites agudas
K29.2 Gastrite alcoólica
K29.3 Gastrite superficial crônica
K29.4 Gastrite atrófica crônica
K29.5 Gastrite crônica, sem outra especificação
K29.6 Outras gastrites
K29.7 Gastrite não especificada
K29.8 Duodenite
K29.9 Gastroduodenite, sem outra especificação
K30 Dispepsia
K31.0 Dilatação aguda do estômago
K31.1 Estenose pilórica hipertrófica do adulto
K31.2 Estenose e estreitamento em ampulheta do estômago
K31.3 Espasmo do piloro não classificado em outra parte
K31.4 Divertículo gástrico
K31.5 Obstrução do duodeno
K31.6 Fístula do estômago e do duodeno
K31.7 Pólipo do estômago e do duodeno
K31.8 Outras doenças especificadas do estômago e do duodeno
K31.9 Doenças do estômago e do duodeno, sem outra especificação
K35.0 Apendicite aguda com peritonite generalizada
K35.1 Apendicite aguda com abscesso peritonial
K35.9 Apendicite aguda sem outra especificação
K36 Outras formas de apendicite
K37 Apendicite, sem outras especificações
K38.0 Hiperplasia do apêndice
K38.1 Concreções apendiculares
K38.2 Divertículo do apêndice
K38.3 Fístula do apêndice
K38.8 Outras doenças especificadas do apêndice
K38.9 Doença do apêndice, sem outra especificação
K40.0 Hérnia inguinal bilateral, com obstrução, sem gangrena
K40.1 Hérnia inguinal bilateral, com gangrena
K40.2 Hérnia inguinal bilateral, sem obstrução ou gangrena
K40.3 Hérnia inguinal unilateral ou não especificada, com obstrução sem gangrena
K40.4 Hérnia inguinal unilateral ou não especificada, com gangrena
K40.9 Hérnia inguinal unilateral ou não especificada, sem obstrução ou gangrena
K41.0 Hérnia femoral bilateral, com obstrução, sem gangrena
K41.1 Hérnia femoral bilateral, com gangrena
K41.2 Hérnia femoral bilateral, sem obstrução ou gangrena
K41.3 Hérnia femoral unilateral ou não especificada, com obstrução, sem gangrena
K41.4 Hérnia femoral unilateral ou não especificada, com gangrena
K41.9 Hérnia femoral unilateral ou não especificada, sem obstrução ou gangrena
K42.0 Hérnia umbilical com obstrução, sem gangrena
K42.1 Hérnia umbilical com gangrena
K42.9 Hérnia umbilical sem obstrução ou gangrena
K43.0 Hérnia ventral com obstrução, sem gangrena
K43.1 Hérnia ventral com gangrena
K43.9 Hérnia ventral sem obstrução ou gangrena
K44.0 Hérnia diafragmática com obstrução, sem gangrena
K44.1 Hérnia diafragmática com gangrena
K44.9 Hérnia diafragmática sem obstrução ou gangrena
K45.0 Outras hérnias abdominais especificadas, com obstrução, sem gangrena
K45.1 Outras hérnias abdominais especificadas, com gangrena
K45.8 Outras hérnias abdominais especificadas, sem obstrução ou gangrena
K46.0 Hérnia abdominal não especificada, com obstrução, sem gangrena
K46.1 Hérnia abdominal não especificada com gangrena
K46.9 Hérnia abdominal não especificada, sem obstrução ou gangrena
K50.0 Doença de Crohn do intestino delgado
K50.1 Doença de Crohn do intestino grosso
K50.8 Outra forma de doença de Crohn
K50.9 Doença de Crohn de localização não especificada
K51.0 Enterocolite ulcerativa (crônica)
K51.1 Ileocolite ulcerativa (crônica)
K51.2 Proctite ulcerativa (crônica)
K51.3 Retossigmoidite ulcerativa (crônica)
K51.4 Pseudopolipose do cólon
K51.5 Proctocolite mucosa
K51.8 Outras colites ulcerativas
K51.9 Colite ulcerativa, sem outra especificação
K52.0 Gastroenterite e colite devida à radiação
K52.1 Gastroenterite e colite tóxicas
K52.2 Gastroenterite e colite alérgicas ou ligadas à dieta
K52.8 Outras gastroenterites e colites especificadas, não­infecciosas
K52.9 Gastroenterite e colite não­infecciosas, não especificadas
K55.0 Transtornos vasculares agudos do intestino
K55.1 Transtornos vasculares crônicos do intestino
K55.2 Angiodisplasia do cólon
K55.8 Outros transtornos vasculares do intestino
K55.9 Transtorno vascular do intestino, sem outra especificação
K56.0 Íleo paralítico
K56.1 Intussuscepção
K56.2 Volvo
K56.3 Íleo biliar
K56.4 Outras obstruções do intestino
K56.5 Aderências intestinais (bridas) com obstrução
K56.6 Outras formas de obstrução intestinal, e as não especificadas
K56.7 Íleo, não especificado
K57.0 Doença diverticular do intestino delgado com perfuração e abscesso
K57.1 Doença diverticular do intestino delgado sem perfuração ou abscesso
K57.2 Doença diverticular do intestino grosso com perfuração e abscesso
K57.3 Doença diverticular do intestino grosso sem perfuração ou abscesso
K57.4 Doença diverticular concomitante dos intestinos delgado e grosso com perfuração e abscesso
K57.5 Doença diverticular concomitante dos intestinos delgado e grosso sem perfuração ou abscesso
K57.8 Doença diverticular do intestino, de localização não especificada, com perfuração e abscesso
K57.9 Doença diverticular do intestino, de localização não especificada, sem perfuração ou abscesso
K58.0 Síndrome do cólon irritável com diarréia
K58.9 Síndrome do cólon irritável sem diarréia
K59.0 Constipação
K59.1 Diarréia funcional
K59.2 Cólon neurogênico não classificado em outra parte
K59.3 Megacólon não classificado em outra parte
K59.4 Espasmo anal
K59.8 Outros transtornos funcionais especificados do intestino
K59.9 Transtorno intestinal funcional, não especificado
K60.0 Fissura anal aguda
K60.1 Fissura anal crônica
K60.2 Fissura anal, não especificada
K60.3 Fístula anal
K60.4 Fístula retal
K60.5 Fístula anorretal
K61.0 Abscesso anal
K61.1 Abscesso retal
K61.2 Abscesso anorretal
K61.3 Abscesso ísquio­retal
K61.4 Abscesso intra­esfincteriano
K62.0 Pólipo anal
K62.1 Pólipo retal
K62.2 Prolapso anal
K62.3 Prolapso retal
K62.4 Estenose do ânus e do reto
K62.5 Hemorragia do ânus e do reto
K62.6 Úlcera do ânus e do reto
K62.7 Proctite por radiação
K62.8 Outras doenças especificadas do ânus e do reto
K62.9 Doença do ânus e do reto, sem outra especificação
K63.0 Abscesso do intestino
K63.1 Perfuração do intestino (não­traumática)
K63.2 Fístula do intestino
K63.3 Úlcera do intestino
K63.4 Enteroptose
K63.5 Pólipo de cólon
K63.8 Outras doenças especificadas do intestino
K63.9 Doença do intestino, sem outra especificação
K65.0 Peritonite aguda
K65.8 Outras peritonites
K65.9 Peritonite, sem outras especificações
K66.0 Aderências peritoniais
K66.1 Hemoperitônio
K66.8 Outras afecções especificadas do peritônio
K66.9 Afecções do peritônio, sem outra especificação
K67.0*Peritonite por clamídias (A74.8+)
K67.1*Peritonite gonocócica (A54.8+)
K67.2*Peritonite sifilítica (A52.7+)
K67.3*Peritonite tuberculosa (A18.3+)
K67.8*Outras formas de comprometimento do peritônio em doenças infecciosas classificadas em outra
parte
K70.0 Fígado gorduroso alcoólico
K70.1 Hepatite alcoólica
K70.2 Fibrose e esclerose alcoólicas do fígado
K70.3 Cirrose hepática alcoólica
K70.4 Insuficiência hepática alcoólica
K70.9 Doença alcoólica do fígado, sem outra especificação
K71.0 Doença hepática tóxica com colestase
K71.1 Doença hepática tóxica com necrose hepática
K71.2 Doença hepática tóxica com hepatite aguda
K71.3 Doença hepática tóxica com hepatite crônica persistente
K71.4 Doença hepática tóxica com hepatite crônica lobular
K71.5 Doença hepática tóxica com hepatite crônica ativa
K71.6 Doença hepática tóxica com hepatite não classificada em outra parte
K71.7 Doença hepática tóxica com fibrose e cirrose hepáticas
K71.8 Doença hepática tóxica com outros transtornos do fígado
K71.9 Doença hepática tóxica, sem outra especificação
K72.0 Insuficiência hepática aguda e subaguda
K72.1 Insuficiência hepática crônica
K72.9 Insuficiência hepática, sem outras especificações
K73.0 Hepatite crônica persistente, não classificada em outra parte
K73.1 Hepatite crônica lobular, não classificada em outra parte
K73.2 Hepatite crônica ativa, não classificada em outra parte
K73.8 Outras hepatites crônicas não classificada em outra parte
K73.9 Hepatite crônica, sem outra especificação
K74.0 Fibrose hepática
K74.1 Esclerose hepática
K74.2 Fibrose hepática com esclerose hepática
K74.3 Cirrose biliar primária
K74.4 Cirrose biliar secundária
K74.5 Cirrose biliar, sem outra especificação
K74.6 Outras formas de cirrose hepática e as não especificadas
K75.0 Abscesso hepático
K75.1 Flebite da veia porta
K75.2 Hepatite reativa não­específica
K75.3 Hepatite granulomatosa não classificada em outra parte
K75.4 Hepatite autoimune
K75.8 Outras doenças hepáticas inflamatórias especificadas
K75.9 Doença hepática inflamatória, sem outra especificação
K76.0 Degeneração gordurosa do fígado não classificada em outra parte
K76.1 Congestão passiva crônica do fígado
K76.2 Necrose hemorrágica central do fígado
K76.3 Infarto do fígado
K76.4 Peliose hepática
K76.5 Doença hepática veno­oclusiva
K76.6 Hipertensão portal
K76.7 Síndrome hepatorrenal
K76.8 Outras doenças especificadas do fígado
K76.9 Doença hepática, sem outra especificação
K77.0*Transtornos hepáticos em doenças infecciosas e parasitárias classificadas em outra parte
K77.8*Transtornos hepáticos em outras doenças classificadas em outra parte
K80.0 Calculose da vesícula biliar com colicistite aguda
K80.1 Calculose da vesícula biliar com outras formas de colecistite
K80.2 Calculose da vesícula biliar sem colecistite
K80.3 Calculose de via biliar com colangite
K80.4 Calculose de via biliar com colecistite
K80.5 Calculose de via biliar sem colangite ou colecistite
K80.8 Outras colelitíases
K81.0 Colecistite aguda
K81.1 Colecistite crônica
K81.8 Outras colecistites
K81.9 Colecistite, sem outra especificação
K82.0 Obstrução da vesícula biliar
K82.1 Hidropsia da vesícula biliar
K82.2 Perfuração da vesícula biliar
K82.3 Fístula da vesícula biliar
K82.4 Colesterolose da vesícula biliar
K82.8 Outras doenças especificadas da vesícula biliar
K82.9 Doença da vesícula biliar, sem outra especificação
K83.0 Colangite
K83.1 Obstrução de via biliar
K83.2 Perfuração de via biliar
K83.3 Fístula de via biliar
K83.4 Espasmo do esfíncter de Oddi
K83.5 Cisto biliar
K83.8 Outras doenças especificadas das vias biliares
K83.9 Doença das vias biliares, sem outra especificação
K85 Pancreatite aguda
K86.0 Pancreatite crônica induzida por álcool
K86.1 Outras pancreatites crônicas
K86.2 Cisto do pâncreas
K86.3 Pseudocisto do pâncreas
K86.8 Outras doenças especificadas do pâncreas
K86.9 Doença do pâncreas, sem outra especificação
K87.0*Transtornos da vesícula biliar e das vias biliares em doenças classificadas em outra parte
K87.1*Transtornos do pâncreas em doenças classificadas em outra parte
K90.0 Doença celíaca
K90.1 Espru tropical
K90.2 Síndrome da alça cega não classificada em outra parte
K90.3 Esteatorréia pancreática
K90.4 Má­absorção devida a intolerância não classificada em outra parte
K90.8 Outras formas de má­absorção intestinal
K90.9 Má­absorção intestinal, sem outra especificação
K91.0 Vômitos pós­cirurgia gastrointestinal
K91.1 Síndromes pós­cirurgia gástrica
K91.2 Má­absorção pós­cirúrgica não classificada em outra parte
K91.3 Obstrução intestinal pós­operatória
K91.4 Mau funcionamento de colostomia e enterostomia
K91.5 Síndrome pós­colecistectomia
K91.8 Outros transtornos do aparelho digestivo, pós­cirúrgicos, não classificados em outra parte
K91.9 Transtorno do aparelho digestivo pós procedimento
K92.0 Hematêmese
K92.1 Melena
K92.2 Hemorragia gastrointestinal, sem outra especificação
K92.8 Outras doenças especificadas do aparelho digestivo
K92.9 Doença do aparelho digestivo, sem outra especificação
K93.0*Transtornos devido a tuberculose do intestino , do peritônio e dos gânglios do mesentério
(A18.3+)
K93.1*Megacólon na doença de Chagas (B57.3+)
K93.8*Transtornos de outros órgãos digestivos especificados em doenças classificadas em outra parte
L00 Síndrome da pele escaldada estafilocócica do recém­nascido
L01.0 Impetigo [qualquer localização] [qualquer microorganismo]
L01.1 Impetiginização de outras dermatoses
L02.0 Abscesso cutâneo, furúnculo e antraz da face
L02.1 Abscesso cutâneo, furúnculo e antraz do pescoço
L02.2 Abscesso cutâneo, furúnculo e antraz do tronco
L02.3 Abscesso cutâneo, furúnculo e antraz da nádega
L02.4 Abscesso cutâneo, furúnculo e antraz do(s) membro(s)
L02.8 Abscesso cutâneo, furúnculo e antraz de outras localizações
L02.9 Abscesso cutâneo, furúnculo e antraz de localização não especificada
L03.0 Celulite de dedos das mãos e dos pés
L03.1 Celulite de outras partes do(s) membro(s)
L03.2 Celulite da face
L03.3 Celulite do tronco
L03.8 Celulite de outros locais
L03.9 Celulite não especificada
L04.0 Linfadenite aguda de face, cabeça e pescoço
L04.1 Linfadenite aguda do tronco
L04.2 Linfadenite aguda de membro superior
L04.3 Linfadenite aguda de membro inferior
L04.8 Linfadenite aguda de outras localizações
L04.9 Linfadenite aguda de localização não especificada
L05.0 Cisto pilonidal com abscesso
L05.9 Cisto pilonidal sem abscesso
L08.0 Piodermite
L08.1 Eritrasma
L08.8 Outras infecções localizadas, especificadas, da pele e do tecido subcutâneo
L08.9 Infecção localizada da pele e do tecido subcutâneo, não especificada
L10.0 Pênfigo vulgar
L10.1 Pênfigo vegetante
L10.2 Pênfigo foliáceo
L10.3 Pênfigo brasileiro [fogo selvagem]
L10.4 Pênfigo eritematoso
L10.5 Pênfigo induzido por drogas
L10.8 Outras formas de pênfigo
L10.9 Pênfigo, não especificado
L11.0 Ceratose folicular adquirida
L11.1 Dermatose acantolítica transitória [Grover]
L11.8 Outras afecções acantolíticas especificadas
L11.9 Afecções acantolíticas não especificadas
L12.0 Penfigóide bolhoso
L12.1 Penfigóide cicatricial
L12.2 Doença bolhosa crônica da infância
L12.3 Epidermólise bolhosa adquirida
L12.8 Outras formas de penfigóide
L12.9 Penfigóide, não especificado
L13.0 Dermatite herpetiforme
L13.1 Dermatite pustular subcorneana
L13.8 Outras afecções bolhosas especificadas
L13.9 Doença bolhosa, não especificada
L14 *Afecções bolhosas em doenças classificadas em outra parte
L20.0 Prurigo de Besnier
L20.8 Outras dermatites atópicas
L20.9 Dermatite atópica, não especificada
L21.0 Seborréia do couro cabeludo
L21.1 Dermatite seborréica infantil
L21.8 Outras dermatites seborréicas
L21.9 Dermatite seborréica, não especificada
L22 Dermatite das fraldas
L23.0 Dermatite alérgica de contato devida a metais
L23.1 Dermatite alérgica de contato devida a adesivos
L23.2 Dermatite alérgica de contato devida a cosméticos
L23.3 Dermatite alérgica de contato devido a drogas em contato com a pele
L23.4 Dermatite alérgica de contato devida a corantes
L23.5 Dermatite alérgica de contato devida a outros produtos químicos
L23.6 Dermatite alérgica de contato devida a alimentos em contato com a pele
L23.7 Dermatite alérgica de contato devido a plantas, exceto alimentos
L23.8 Dermatite alérgica de contato devido a outros agentes
L23.9 Dermatite alérgica de contato, de causa não especificada
L24.0 Dermatite de contato por irritantes devida a detergentes
L24.1 Dermatite de contato por irritantes devido a óleos e gorduras
L24.2 Dermatite de contato por irritantes devida a solventes
L24.3 Dermatite de contato por irritantes devida a cosméticos
L24.4 Dermatite de contato por irritantes devida a drogas em contato com a pele
L24.5 Dermatite de contato por irritantes devida a outros produtos químicos
L24.6 Dermatite de contato por irritantes devida a alimentos em contato com a pele
L24.7 Dermatite de contato por irritantes devido a plantas, exceto alimentos
L24.8 Dermatite de contato por irritantes devido a outros agentes
L24.9 Dermatite de contato por irritantes, de causa não especificada
L25.0 Dermatite de contato não especificada devida a cosméticos
L25.1 Dermatite de contato não especificada devida a drogas em contato com a pele
L25.2 Dermatite de contato não especificada devida a corantes
L25.3 Dermatite de contato não especificada devida a outros produtos químicos
L25.4 Dermatite de contato não especificada devida a alimentos em contato com a pele
L25.5 Dermatite de contato não especificada devida a plantas, exceto alimentos
L25.8 Dermatite de contato não especificada devida a outros agentes
L25.9 Dermatite de contato não especificada, de causa não especificada
L26 Dermatite esfoliativa
L27.0 Erupção cutânea generalizada devida a drogas e medicamentos
L27.1 Erupção cutânea localizada devida a drogas e medicamentos
L27.2 Dermatite devida à ingestão de alimentos
L27.8 Dermatite devida a outras substâncias de uso interno
L27.9 Dermatite devida a substância não especificada de uso interno
L28.0 Líquen simples crônico
L28.1 Prurigo nodular
L28.2 Outras formas de prurigo
L29.0 Prurido anal
L29.1 Prurido escrotal
L29.2 Prurido vulvar
L29.3 Prurido anogenital, não especificado
L29.8 Outras formas de prurido
L29.9 Prurido não especificado
L30.0 Dermatite numular
L30.1 Disidrose [pompholyx]
L30.2 Autossensibilização cutânea
L30.3 Dermatite infectada
L30.4 Intertrigo eritematoso
L30.5 Pitiríase alba
L30.8 Outras dermatites especificadas
L30.9 Dermatite não especificada
L40.0 Psoríase vulgar
L40.1 Psoríase pustulosa generalizada
L40.2 Acrodermatite contínua
L40.3 Pustulose palmar e plantar
L40.4 Psoríase gutata
L40.5+Artropatia psoriásica (M07.0­.3*, M09.0*)
L40.8 Outras formas de psoríase
L40.9 Psoríase não especificada
L41.0 Pitiríase liquenóide e varioliforme aguda
L41.1 Pitiríase liquenóide crônica
L41.2 Papulose linfomatóide
L41.3 Parapsoríase de pequenas placas
L41.4 Parapsoríase de grandes placas
L41.5 Parapsoríase retiforme
L41.8 Outras parapsoríases
L41.9 Parapsoríase, não especificada
L42 Pitiríase rósea
L43.0 Líquen plano hipertrófico
L43.1 Líquen plano bolhoso
L43.2 Reação liquenóide a droga
L43.3 Líquen plano subagudo (ativo)
L43.8 Outras formas de líquen plano
L43.9 Líquen plano, não especificado
L44.0 Pitiríase rubra pilar
L44.1 Líquen nítido
L44.2 Líquen estriado
L44.3 Líquen rubro moniliforme
L44.4 Acrodermatite papular infantil [Síndrome de Gianotti­Crosti]
L44.8 Outras afecções pápulo­descamativas especificadas
L44.9 Afecções pápulo­descamativas, não especificadas
L45 *Afecções pápulo­descamativas em doenças classificadas em outra parte
L50.0 Urticária alérgica
L50.1 Urticária idiopática
L50.2 Urticária devida a frio e a calor
L50.3 Urticária dermatográfica
L50.4 Urticária vibratória
L50.5 Urticária colinérgica
L50.6 Urticária de contato
L50.8 Outras urticárias
L50.9 Urticária não especificada
L51.0 Eritema multiforme não bolhoso
L51.1 Eritema multiforme bolhoso
L51.2 Necrólise epidérmica tóxica [Síndrome de Lyell]
L51.8 Outras formas de eritema multiforme
L51.9 Eritema multiforme, não especificado
L52 Eritema nodoso
L53.0 Eritema tóxico
L53.1 Eritema anular centrífugo
L53.2 Eritema marginado
L53.3 Outras formas de eritema figurado crônico
L53.8 Outras afecções eritematosas especificadas
L53.9 Afecções eritematosas, não especificadas
L54.0*Eritema marginado na febre reumática aguda (I00+)
L54.8*Eritema em outras doenças classificadas em outra parte
L55.0 Queimadura solar de primeiro grau
L55.1 Queimadura solar de segundo grau
L55.2 Queimadura solar de terceiro grau
L55.8 Outras queimaduras solares
L55.9 Queimadura solar, não especificada
L56.0 Resposta fototóxica a drogas
L56.1 Resposta fotoalérgica a drogas
L56.2 Dermatite por fotocontato [dermatite do berloque]
L56.3 Urticária solar
L56.4 Erupção polimorfa à luz
L56.8 Outras alterações agudas especificadas da pele devidas a radiação ultravioleta
L56.9 Alterações agudas da pele devidas a radiação ultravioleta, não especificadas
L57.0 Ceratose actínica
L57.1 Reticulóide actínica
L57.2 Cútis romboidal da nuca
L57.3 Poiquilodermia de Civatte
L57.4 Cútis laxa senil
L57.5 Granuloma actínico
L57.8 Outras alterações da pele devidas a exposição crônica à radiação não­ionizante
L57.9 Alterações da pele devidas a exposição crônica a radiação não­ionizante, não especificadas
L58.0 Radiodermatite aguda
L58.1 Radiodermatite crônica
L58.9 Radiodermatite, não especificada
L59.0 Eritema devido ao calor ou ao fogo [dermatite ab igne]
L59.8 Outras afecções especificadas da pele e do tecido subcutâneo relacionadas com a radiação
L59.9 Afecções da pele e do tecido subcutâneo relacionadas com a radiação, não especificadas
L60.0 Unha encravada
L60.1 Onicólise
L60.2 Onicogrifose
L60.3 Distrofia ungueal
L60.4 Linhas de Beau
L60.5 Síndrome das unhas amareladas
L60.8 Outras afecções das unhas
L60.9 Afecções das unhas, não especificadas
L62.0*Paquidermoperiostose com unhas hipocráticas (em vidro de relógio) (M89.4+)
L62.8*Afecções das unhas em outras doenças classificadas em outra parte
L63.0 Alopécia total (capitis)
L63.1 Alopécia universal
L63.2 Ofíase
L63.8 Outras formas de alopécia areata
L63.9 Alopécia areata, não especificada
L64.0 Alopécia androgênica induzida por droga
L64.8 Outras alopécias androgênicas
L64.9 Alopécia androgênica, não especificada
L65.0 Eflúvio telógeno
L65.1 Eflúvio anágeno
L65.2 Alopécia mucinosa
L65.8 Outras formas, especificadas, não cicatriciais, de perda de cabelos ou pêlos
L65.9 Perda de cabelos ou pêlos não cicatriciais, não especificada
L66.0 Pseudopelada
L66.1 Líquen planopilar
L66.2 Foliculite descalvante
L66.3 Perifoliculite abscedante da cabeça
L66.4 Foliculite uleritematosa reticulada
L66.8 Outras formas de alopécia cicatricial
L66.9 Alopécia cicatricial, não especificada
L67.0 Tricorrexe nodosa
L67.1 Variações da cor dos cabelos ou pêlos
L67.8 Outras anormalidades da cor e do pedículo dos cabelos ou pêlos
L67.9 Anormalidades da cor e do pedículo dos cabelos e dos pêlos, não especificadas
L68.0 Hirsutismo
L68.1 Hipertricose lanuginosa adquirida
L68.2 Hipertricose localizada
L68.3 Politríquia
L68.8 Outras formas de hipertricose
L68.9 Hipertricose, não especificada
L70.0 Acne vulgar
L70.1 Acne conglobata
L70.2 Acne varioliforme
L70.3 Acne tropical
L70.4 Acne infantil
L70.5 Acne escoriada das mulheres jovens
L70.8 Outras formas de acne
L70.9 Acne, não especificada
L71.0 Dermatite perioral
L71.1 Rinofima
L71.8 Outras formas de rosácea
L71.9 Rosácea, não especificada
L72.0 Cisto epidérmico
L72.1 Cisto triquilemal
L72.2 Esteatocistoma múltiplo
L72.8 Outras formas de cistos foliculares da pele e do tecido subcutâneo
L72.9 Cisto folicular, não especificado da pele e do tecido subcutâneo
L73.0 Acne quelóide
L73.1 Pseudofoliculite da barba
L73.2 Hidradenite supurativa
L73.8 Outras afecções foliculares especificadas
L73.9 Afecções foliculares, não especificadas
L74.0 Miliária rubra
L74.1 Miliária cristalina
L74.2 Miliária profunda
L74.3 Miliária, não especificada
L74.4 Anidrose
L74.8 Outras afecções das glândulas sudoríparas écrinas
L74.9 Afecções das glândulas sudoríparas écrinas, não especificadas
L75.0 Bromidrose
L75.1 Cromidrose
L75.2 Miliária apócrina
L75.8 Outras afecções das glândulas sudoríparas apócrinas
L75.9 Afecções de glândulas sudoríparas apócrinas, não especificadas
L80 Vitiligo
L81.0 Hiperpigmentação pós­inflamatória
L81.1 Cloasma
L81.2 Sardas
L81.3 Manchas café­com­leite
L81.4 Outras formas de hiperpigmentação pela melanina
L81.5 Leucodermia não classificada em outra parte
L81.6 Outros transtornos ligados à diminuição da formação de melanina
L81.7 Dermatose purpúrica pigmentada
L81.8 Outros transtornos especificados da pigmentação
L81.9 Transtorno da pigmentação, não especificado
L82 Ceratose seborréica
L83 Acantose nigricans
L84 Calos e calosidades
L85.0 Ictiose adquirida
L85.1 Ceratose adquirida [ceratodermia] palmar e plantar
L85.2 Ceratose punctata (palmar e plantar)
L85.3 Xerose cutânea
L85.8 Outras formas de espessamento epidérmico
L85.9 Espessamento epidérmico, não especificado
L86 *Ceratodermia em doenças classificadas em outra parte
L87.0 Ceratose folicular e parafolicular penetrante na pele [Síndrome de Kyrle]
L87.1 Colagenose perfurante reativa
L87.2 Elastose perfurante serpiginosa
L87.8 Outros transtornos da eliminação transepidérmica
L87.9 Transtorno da eliminação transepidérmica, não especificado
L88 Piodermite gangrenosa
L89 Úlcera de decúbito
L90.0 Líquen escleroso e atrófico
L90.1 Anetodermia de Schweninger­Buzzi
L90.2 Anetodermia de Jadassohn­Pellizzari
L90.3 Atrofodermia de Pasini e Pierini
L90.4 Acrodermatite crônica atrófica
L90.5 Cicatrizes e fibrose cutânea
L90.6 Estrias atróficas
L90.8 Outras afecções atróficas da pele
L90.9 Afecções atróficas da pele, não especificadas
L91.0 Cicatriz quelóide
L91.8 Outras afecções hipertróficas da pele
L91.9 Afecções hipertróficas da pele, não especificadas
L92.0 Granuloma anular
L92.1 Necrobiose lipoídica não classificada em outra parte
L92.2 Granuloma facial [granuloma eosinófilo da pele]
L92.3 Granuloma de corpo estranho da pele e do tecido subcutâneo
L92.8 Outras afecções granulomatosas da pele e do tecido subcutâneo
L92.9 Afecções granulomatosas da pele e do tecido subcutâneo, não especificados
L93.0 Lúpus eritematoso discóide
L93.1 Lúpus eritematoso cutâneo subagudo
L93.2 Outras formas de lúpus eritematoso localizado
L94.0 Esclerodermia localizada [morféia]
L94.1 Esclerodermia linear
L94.2 Calcinose cutânea
L94.3 Esclerodactilia
L94.4 Pápulas de Gottron
L94.5 Poiquilodermia vascular atrófica
L94.6 Ainhum
L94.8 Outras afecções localizadas do tecido conjuntivo, especificadas
L94.9 Afecções localizadas do tecido conjuntivo, não especificadas
L95.0 Vasculite livedóide
L95.1 Eritema elevado diutino (duradouro)
L95.8 Outras vasculites limitadas a pele
L95.9 Vasculites limitadas a pele, não especificadas
L97 Úlcera dos membros inferiores não classificada em outra parte
L98.0 Granuloma piogênico
L98.1 Dermatite factícia
L98.2 Dermatose neutrofílica febril [Sweet]
L98.3 Celulite eosinofílica [Wells]
L98.4 Úlcera crônica da pele, não classificada em outra parte
L98.5 Mucinose da pele
L98.6 Outras afecções infiltrativas da pele e do tecido subcutâneo
L98.8 Outras afecções especificadas da pele e do tecido subcutâneo
L98.9 Afecções da pele e do tecido subcutâneo, não especificados
L99.0*Amiloidose cutânea (E85.­+)
L99.8*Outras afecções especificadas da pele e do tecido subcutâneo em doenças classificadas em
outra parte
M00.0 Artrite e pioliartrite estafilocócicas
M00.1 Artrite e poliartrite pneumocócicas
M00.2 Outras artrites e poliartrites estreptocócicas
M00.8 Artrite e poliartrite devidas a outro agente bacteriano especificado
M00.9 Artrite piogênica, não especificada
M01.0*Artrite meningocócica (A39.8+)
M01.1*Artrite tuberculosa (A18.0+)
M01.2*Artrite na doença de Lyme (A69.2+)
M01.3*Artrite em outras doenças bacterianas classificadas em outra parte
M01.4*Artrite na rubéola (B06.8+)
M01.5*Artrite em outras doenças virais classificadas em outra parte
M01.6*Artrite em micoses (B35­B49+)
M01.8*Artrite em outras doenças infecciosas e parasitárias classificadas em outra parte
M02.0 Artropatia pós­derivação intestinal
M02.1 Artropatia pós­desintérica
M02.2 Artropatia pós­imunização
M02.3 Doença de Reiter
M02.8 Outras artropatias reacionais
M02.9 Artropatia reacional não especificada
M03.0*Artrite pós­meningocócica (A39.8+)
M03.1*Artropatia pós­infecciosa na sífilis (A50.5+)
M03.2*Outras artropatias pós­infecciosas em doenças classificadas em outra parte
M03.6*Artropatia reacional em outras doenças classificadas em outra parte
M05.0 Síndrome de Felty
M05.1+Doença reumatóide do pulmão (J99.0*)
M05.2 Vasculite reumatóide
M05.3 Artrite reumatóide com comprometimento de outros órgãos e sistemas
M05.8 Outras artrites reumatóides soro­positivas
M05.9 Artrite reumatóide soro­positiva não especificada
M06.0 Artrite reumatóide soro­negativa
M06.1 Doença de Still do adulto
M06.2 Bursite reumatóide
M06.3 Nódulo reumatóide
M06.4 Poliartropatia inflamatória
M06.8 Outras artrites reumatóides especificadas
M06.9 Artrite reumatóide não especificada
M07.0*Artropatia psoriásica interfalangiana distal (L40.5+)
M07.1*Artrite mutilante (L40.5+)
M07.2*Espondilite psoriásica (L40.5+)
M07.3*Outras artropatias psoriásicas (L40.5+)
M07.4*Artropatia na doença de Crohn [enterite regional] (K50.­+)
M07.5*Artropatia na colite ulcerativa (K51.­+)
M07.6*Outras artropatias enteropáticas
M08.0 Artrite reumatóide juvenil
M08.1 Espondilite ancilosante juvenil
M08.2 Artrite juvenil com início sistêmico
M08.3 Poliartrite juvenil (soro­negativa)
M08.4 Artrite juvenil pauciarticular
M08.8 Outras artrites juvenis
M08.9 Artrite juvenil não especificada
M09.0*Artrite juvenil na psoríase (L40.5+)
M09.1*Artrite juvenil na doença de Chron [enterite regional] (K50.­+)
M09.2*Artrite juvenil na colite ulcerativa (K51.­+)
M09.8*Artrite juvenil em outras doenças classificadas em outra parte
M10.0 Gota idiopática
M10.1 Gota induzida por chumbo
M10.2 Gota induzida por drogas
M10.3 Gota devida à disfunção renal
M10.4 Outra gota secundária
M10.9 Gota, não especificada
M11.0 Doença por deposição de hidroxiapatita
M11.1 Condrocalcinose familiar
M11.2 Outras condrocalcinoses
M11.8 Outras artropatias especificadas por deposição de cristais
M11.9 Artropatia por deposição de cristais, não especificada
M12.0 Artropatia pós­reumática crônica [Jaccoud]
M12.1 Doença de Kashin­Beck
M12.2 Sinovite vilonodular (pigmentada)
M12.3 Reumatismo palindrômico
M12.4 Hidrartrose intermitente
M12.5 Artropatia traumática
M12.8 Outras artropatias específicas não classificadas em outra parte
M13.0 Poliartrite não especificada
M13.1 Monoartrites não classificadas em outra parte
M13.8 Outras artrites especificadas
M13.9 Artrite não especificada
M14.0*Artropatia gotosa devida a defeitos enzimáticos e a outras doenças hereditárias
M14.1*Artropatia por depósito de cristais em outras doenças metabólicas classificadas em outra parte
M14.2*Artropatia diabética (E10­E14+ com quarto caractere comum .6)
M14.3*Dermatoartrite lipóide (E78.8+)
M14.4*Artropatia na amiloidose (E85.­+)
M14.5*Artropatias em outras doenças endócrinas, nutricionais e metabólicas
M14.6*Artropatia neuropática
M14.8*Artropatias em outras doenças especificadas classificadas em outra parte
M15.0 (Osteo)artrose primária generalizada
M15.1 Nódulos de Heberden (com artropatia)
M15.2 Nódulos de Bouchard (com artropatia)
M15.3 Artrose múltipla secundária
M15.4 (Osteo)artrose erosiva
M15.8 Outras poliartroses
M15.9 Poliartrose não especificada
M16.0 Coxartrose primária bilateral
M16.1 Outras coxartroses primárias
M16.2 Coxartrose bilateral resultante de displasia
M16.3 Outras coxartroses displásicas
M16.4 Coxartrose bilateral pós­traumática
M16.5 Outras coxartroses pós­traumáticas
M16.6 Outras coxartroses secundárias bilaterais
M16.7 Outras coxartroses secundárias
M16.9 Coxartrose não especificada
M17.0 Gonartrose primária bilateral
M17.1 Outras gonartroses primárias
M17.2 Gonartrose pós­traumática bilateral
M17.3 Outras gonartroses pós­traumática
M17.4 Outras gonartroses secundárias bilaterais
M17.5 Outras gonartroses secundárias
M17.9 Gonartrose não especificada
M18.0 Artrose primária bilateral das primeiras articulações carpometacarpianas
M18.1 Outras artroses primárias da primeira articulação carpometacarpiana
M18.2 Artrose pós­traumática bilateral da primeira articulação carpometacarpiana
M18.3 Outras artroses pós­traumáticas da primeira articulação carpometacarpiana
M18.4 Outras cartroses secundárias bilaterais das primeiras articulações carpometacarpianas
M18.5 Outras artroses secundárias da primeira articulação carpometacarpiana
M18.9 Artrose não especificada da primeira articulação carpometacarpiana
M19.0 Artrose primária de outras articulações
M19.1 Artrose pós­traumática de outras articulações
M19.2 Outras artroses secundárias
M19.8 Outras artroses especificadas
M19.9 Artrose não especificada
M20.0 Deformidade(s) do(s) dedo(s) das mãos
M20.1 Hallux valgo (adquirido)
M20.2 Hallux rigidus
M20.3 Outra deformidade do hallux (adquirida)
M20.4 Dedo(s) do pé em malho (adquirido)
M20.5 Outras deformidades (adquiridas) do(s) dedo(s) dos pés
M20.6 Deformidade adquirida não especificada de dedo(s) do pé
M21.0 Deformidade em valgo não classificada em outra parte
M21.1 Deformidade em varo não classificada em outra parte
M21.2 Deformidade em flexão
M21.3 Mão (pulso) ou pé pendente (adquirido)
M21.4 Pé chato [pé plano] (adquirido)
M21.5 Mão e pé em garra e mão e pé tortos adquiridos
M21.6 Outras deformidades adquiridas do tornozelo e do pé
M21.7 Desigualdade (adquirida) do comprimento dos membros
M21.8 Outras deformidades adquiridas especificadas dos membros
M21.9 Deformidade adquirida não especificada de membro
M22.0 Deslocamento recidivante da rótula
M22.1 Subluxação recidivante da rótula
M22.2 Transtornos femuropatelares
M22.3 Outros desarranjos da rótula
M22.4 Condromalácia da rótula
M22.8 Outros transtornos da rótula
M22.9 Transtorno da rótula, não especificado
M23.0 Menisco cístico
M23.1 Menisco discóide (congênito)
M23.2 Transtorno do menisco devido à ruptura ou lesão antiga
M23.3 Outros transtornos do menisco
M23.4 Corpo flutuante no joelho
M23.5 Instabilidade crônica do joelho
M23.6 Outras rupturas espontâneas de ligamento(s) do joelho
M23.8 Outros transtornos internos do joelho
M23.9 Transtorno interno não especificado do joelho
M24.0 Corpo flutuante em articulação
M24.1 Outros transtornos das cartilagens articulares
M24.2 Transtornos de ligamentos
M24.3 Deslocamento e subluxação patológicas de articulação, não classificada em outra parte
M24.4 Deslocamento e subluxação de articulação recidivantes
M24.5 Contratura articular
M24.6 Ancilose articular
M24.7 Protusão do acetábulo
M24.8 Outros transtornos articulares específicos, não classificados em outra parte
M24.9 Desarranjo articular não especificado
M25.0 Hemartrose
M25.1 Fístula articular
M25.2 "Flail joint"
M25.3 Outras instabilidades articulares
M25.4 Derrame articular
M25.5 Dor articular
M25.6 Rigidez articular não classificada em outra parte
M25.7 Osteofito
M25.8 Outros transtornos articulares especificados
M25.9 Transtorno articular não especificado
M30.0 Poliarterite nodosa
M30.1 Poliarterite com comprometimento pulmonar [Churg­Strauss]
M30.2 Poliarterite juvenil
M30.3 Síndrome de linfonodos mucocutâneos [Kawasaki]
M30.8 Outras afecções comuns na poliarterite nodosa
M31.0 Angeíte de hipersensibilidade
M31.1 Microangiopatia trombótica
M31.2 Granuloma da linha média letal
M31.3 Granulomatose de Wegener
M31.4 Síndrome do arco aórtico [Takayasu]
M31.5 Arterite de células gigantes com polimialgia reumática
M31.6 Outras arterites de células gigantes
M31.8 Outras vasculopatias necrotizantes especificadas
M31.9 Vasculopatia necrotizante não especificada
M32.0 Lúpus eritematoso disseminado [sistêmico] induzido por drogas
M32.1+Lúpus eritematoso disseminado [sistêmico] com comprometimento de outros órgãos e sistemas
M32.8 Outras formas de lúpus eritematoso disseminado [sistêmico]
M32.9 Lúpus eritematoso disseminado [sistêmico] não especificado
M33.0 Dermatomiosite juvenil
M33.1 Outras dermatomiosites
M33.2 Polimiosite
M33.9 Dermatopolimiosite não especificada
M34.0 Esclerose sistêmica progressiva
M34.1 Síndrome CR(E)ST
M34.2 Esclerose sistêmica induzida por droga e substâncias químicas
M34.8 Outras formas de esclerose sistêmica
M34.9 Esclerose sistêmica não especificada
M35.0 Síndrome seca [Sjögren]
M35.1 Outras síndromes superpostas
M35.2 Doença de Behçet
M35.3 Polimialgia reumática
M35.4 Fasciíte (eosinofílica) difusa
M35.5 Fibroesclerose multifocal
M35.6 Paniculite recidivante [Weber­Christian]
M35.7 Síndrome de hipermobilidade
M35.8 Outro comprometimento sistêmico especificado do tecido conjuntivo
M35.9 Comprometimento sistêmico não especificado do tecido conjuntivo
M36.0*Dermato(poli)miosite em doenças neoplásicas (C00­D48+)
M36.1 Artropatia em doenças neoplásicas classificadas (C00­D48+)
M36.2*Artropatia hemofílica (D66­D68+)
M36.3*Artropatias em outras doenças hematológicas (D50­D76+)
M36.4*Artropatia associada a reações de hipersensibilidade classificadas em outra parte
M36.8*Doenças sistêmicas do tecido conjuntivo em outras doenças classificadas em outra parte
M40.0 Cifose postural
M40.1 Outras cifoses secundárias
M40.2 Outras cifoses e as não especificadas
M40.3 Síndrome da retificação da coluna vertebral
M40.4 Outras lordoses
M40.5 Lordose não especificada
M41.0 Escoliose idiopática infantil
M41.1 Escoliose idiopática juvenil
M41.2 Outras escolioses idiopáticas
M41.3 Escoliose toracogênica
M41.4 Escoliose neuromuscular
M41.5 Outras escolioses secundárias
M41.8 Outras formas de escoliose
M41.9 Escoliose não especificada
M42.0 Osteocondrose vertebral juvenil
M42.1 Osteocondrose vertebral do adulto
M42.9 Osteocondrose vertebral, não especificada
M43.0 Espondilólise
M43.1 Espondilolistese
M43.2 Outras fusões da coluna vertebral
M43.3 Subluxação atlanto­axial recidivante com mielopatia
M43.4 Outras subluxações atlanto­axiais recidivantes
M43.5 Outras subluxações vertebrais recidivantes
M43.6 Torcicolo
M43.8 Outras dorsopatias deformantes especificadas
M43.9 Dorsopatia deformante, não especificada
M45 Espondilite ancilosante
M46.0 Entesopatia vertebral
M46.1 Sacroileíte não classificada em outra parte
M46.2 Osteomielite das vértebras
M46.3 Infecção (piogênica) do disco intervertebral
M46.4 Discite não especificada
M46.5 Outras espondilopatias infecciosas
M46.8 Outras espondilopatias inflamatórias especificadas
M46.9 Espondilopatia inflamatória não especificada
M47.0+Síndromes de compressão da artéria espinhal anterior ou vertebral anterior (G99.2*)
M47.1 Outras espondiloses com mielopatia
M47.2 Outras espondiloses com radiculopatias
M47.8 Outras espondiloses
M47.9 Espondilose não especificada
M48.0 Estenose da coluna vertebral
M48.1 Hiperostose ancilosante [Forestier]
M48.2 "Kissing spine"
M48.3 Espondilopatia traumática
M48.4 Fratura de fadiga de vértebra
M48.5 Vértebra colapsada não classificada em outra parte
M48.8 Outras espondilopatias especificadas
M48.9 Espondilopatia não especificada
M49.0*Tuberculose da coluna vertebral (A18.0+)
M49.1*Espondilite por Brucella (A23.­+)
M49.2*Espondilite por enterobactérias (A01­A04+)
M49.3*Espondilopatia em outras doenças infeciosas e parasitárias classificadas em outra parte
M49.4*Espondilopatia neuropática
M49.5*Vértebra colapsada em doenças classificadas em outra parte
M49.8*Espondilopatia em outras doenças classificadas em outra parte
M50.0+Transtorno do disco cervical com mielopatia (G99.2*)
M50.1 Transtorno do disco cervical com radiculopatia
M50.2 Outro deslocamento de disco cervical
M50.3 Outra degeneração de disco cervical
M50.8 Outros transtornos de discos cervicais
M50.9 Transtorno não especificado de disco cervical
M51.0+Transtornos de discos lombares e de outros discos intervertebrais com mielopatia (G99.2*)
M51.1 Transtornos de discos lombares e de outros discos intervertebrais com radiculopatia
M51.2 Outros deslocamentos discais intervertebrais especificados
M51.3 Outra degeneração especificada de disco intervertebral
M51.4 Nódulos de Schmorl
M51.8 Outros transtornos especificados de discos intervertebrais
M51.9 Transtorno não especificado de disco intervertebral
M53.0 Síndrome cervicocraniana
M53.1 Síndrome cervicobraquial
M53.2 Instabilidades da coluna vertebral
M53.3 Transtornos sacroccígeos não classificados em outra parte
M53.8 Outras dorsopatias especificadas
M53.9 Dorsopatia não especificada
M54.0 Paniculite atingindo regiões do pescoço e do dorso
M54.1 Radiculopatia
M54.2 Cervicalgia
M54.3 Ciática
M54.4 Lumbago com ciática
M54.5 Dor lombar baixa
M54.6 Dor na coluna torácica
M54.8 Outra dorsalgia
M54.9 Dorsalgia não especificada
M60.0 Miosite infecciosa
M60.1 Miosite intersticial
M60.2 Granuloma de corpo estranho no tecido mole não classificado em outra parte
M60.8 Outras miosites
M60.9 Miosite não especificada
M61.0 Miosite ossificante traumática
M61.1 Miosite ossificante progressiva
M61.2 Calcificação e ossificação paralítica de músculo
M61.3 Calcificação e ossificação de músculo associadas com queimaduras
M61.4 Outra calcificação de músculo
M61.5 Outra ossificação de músculo
M61.9 Calcificação e ossificação de músculo não especificada
M62.0 Diástase de músculo
M62.1 Outras rupturas musculares (não­traumáticas)
M62.2 Infarto isquêmico do músculo
M62.3 Síndrome de imobilidade (paraplégica)
M62.4 Contratura de músculo
M62.5 Perda e atrofia muscular não classificadas em outra parte
M62.6 Distensão muscular
M62.8 Outros transtornos musculares especificados
M62.9 Transtorno muscular não especificado
M63.0*Miosite em doenças bacterianas classificadas em outra parte
M63.1*Miosite em doenças infecciosas causadas por protozoários e parasitas classificadas em outra
parte
M63.2*Miosite em outras doenças infecciosas classificadas em outra parte
M63.3*Miosite na sarcoidose (D86.8+)
M63.8*Outros transtornos musculares em doenças classificadas em outra parte
M65.0 Abscesso da bainha tendínea
M65.1 Outras (teno)sinovites infecciosas
M65.2 Tendinite calcificada
M65.3 Dedo em gatilho
M65.4 Tenossinovite estilóide radial [de Quervain]
M65.8 Outras sinovites e tenossinovites
M65.9 Sinovite e tenossinovite não especificadas
M66.0 Ruptura de cisto poplíteo
M66.1 Ruptura de sinóvia
M66.2 Ruptura espontânea de tendões extensores
M66.3 Ruptura espontânea de tendões flexores
M66.4 Ruptura espontânea de outros tendões
M66.5 Ruptura espontânea de tendões não especificados
M67.0 Tendão de Aquiles curto (adquirido)
M67.1 Outra contratura de tendão (bainha)
M67.2 Hipertrofia sinovial não classificada em outra parte
M67.3 Sinovite transitória
M67.4 Gânglios
M67.8 Outros transtornos especificados da sinóvia e do tendão
M67.9 Transtorno não especificado da sinóvia e do tendão
M68.0*Sinovite e tenossinovite em doenças bacterianas classificadas em outra parte
M68.8*Outros transtornos de sinóvias e de tendões em doenças classificadas em outra parte
M70.0 Sinovite crepitante crônica da mão e do punho
M70.1 Bursite da mão
M70.2 Bursite do olécrano
M70.3 Outras bursites do cotovelo
M70.4 Bursite pré­patelar
M70.5 Outras bursites do joelho
M70.6 Bursite trocantérica
M70.7 Outras bursites do quadril
M70.8 Outros transtornos dos tecidos moles relacionados com o uso, uso excessivo e pressão
M70.9 Transtorno não especificado dos tecidos moles relacionados com o uso, uso excessivo e
pressão
M71.0 Abscesso de bolsa sinovial
M71.1 Outras bursites infecciosas
M71.2 Cisto sinovial do espaço poplíteo [Baker]
M71.3 Outros cistos de bolsa sinovial
M71.4 Depósito de cálcio em bolsa sinovial
M71.5 Outras bursites não classificadas em outra parte
M71.8 Outras bursopatias especificadas
M71.9 Bursopatia não especificada
M72.0 Fibromatose de fáscia palmar [Dupuytren]
M72.1 Coxins interfalângicos (nó dos dedos)
M72.2 Fibromatose da fáscia plantar
M72.3 Fasciíte nodular
M72.4 Fibromatose pseudossarcomatosa
M72.5 Fasciíte não classificada em outra parte
M72.8 Outros transtornos fibroblásticos
M72.9 Transtorno fibroblástico não especificado
M73.0*Bursite gonocócica (A54.4+)
M73.1*Bursite sifilítica (A52.7+)
M73.8*Outros transtornos dos tecidos moles em outras doenças classificadas em outra parte
M75.0 Capsulite adesiva do ombro
M75.1 Síndrome do manguito rotador
M75.2 Tendinite bicepital
M75.3 Tendinite calcificante do ombro
M75.4 Síndrome de colisão do ombro
M75.5 Bursite do ombro
M75.8 Outras lesões do ombro
M75.9 Lesão não especificada do ombro
M76.0 Tendinite glútea
M76.1 Tendinite do psoas
M76.2 Esporão da crista ilíaca
M76.3 Síndrome da faixa iliotibial
M76.4 Bursite tibial colateral [Pellegrini­Stieda]
M76.5 Tendinite patelar
M76.6 Tendinite aquileana
M76.7 Tendinite do perôneo
M76.8 Outras entesopatias do membro inferior, excluindo o pé
M76.9 Entesopatia do membro inferior não especificada
M77.0 Epicondilite medial
M77.1 Epicondilite lateral
M77.2 Periartrite do punho
M77.3 Esporão do calcâneo
M77.4 Metatarsalgia
M77.5 Outra entesopatia do pé
M77.8 Outras entesopatias não classificadas em outra parte
M77.9 Entesopatia não especificada
M79.0 Reumatismo não especificado
M79.1 Mialgia
M79.2 Nevralgia e neurite não especificadas
M79.3 Paniculite não especificada
M79.4 Hipertrofia do coxim gorduroso (infrapatelar)
M79.5 Corpo estranho residual no tecido mole
M79.6 Dor em membro
M79.8 Outros transtornos especificados dos tecidos moles
M79.9 Transtorno dos tecidos moles não especificado
M80.0 Osteoporose pós­menopáusica com fratura patológica
M80.1 Osteoporose pós­ooforectomia com fratura patológica
M80.2 Osteoporose de desuso com fratura patológica
M80.3 Osteoporose por má­absorção pós­cirúrgica com fratura patológica
M80.4 Osteoporose induzida por drogas com fratura patológica
M80.5 Osteoporose idiopática com fratura patológica
M80.8 Outras osteoporoses com fratura patológica
M80.9 Osteoporose não especificada com fratura patológica
M81.0 Osteoporose pós­menopáusica
M81.1 Osteoporose pós­ooforectomia
M81.2 Osteoporose de desuso
M81.3 Osteoporose devida à má­absorção pós­cirúrgica
M81.4 Osteoporose induzida por drogas
M81.5 Osteoporose idiopática
M81.6 Osteoporose localizada [Lequesne]
M81.8 Outras osteoporoses
M81.9 Osteoporose não especificada
M82.0*Osteoporose na mielomatose múltipla (C90.0+)
M82.1*Osteoporose em distúrbios endócrinos (E00­E34+)
M82.8*Osteoporose em outras doenças classificadas em outra parte
M83.0 Osteomalácia puerperal
M83.1 Osteomalácia senil
M83.2 Osteomalácia do adulto devida a má­absorção
M83.3 Osteomalácia do adulto devido à desnutrição
M83.4 Doença óssea pelo alumínio
M83.5 Outras osteomalácias do adulto induzidas por drogas
M83.8 Outra osteomalácia do adulto
M83.9 Osteomalácia não especificada do adulto
M84.0 Defeito de consolidação da fratura
M84.1 Ausência de consolidação da fratura [pseudo­artrose]
M84.2 Atraso de consolidação de fratura
M84.3 Fratura de fadiga ("stress") não classificada em outra parte
M84.4 Fratura patológica não classificada em outra parte
M84.8 Outros transtornos da continuidade do osso
M84.9 Transtorno não especificado da continuidade do osso
M85.0 Displasia fibrosa (monostótica)
M85.1 Fluorose esquelética
M85.2 Hiperostose do crânio
M85.3 Osteíte condensante
M85.4 Cisto ósseo solitário
M85.5 Cisto ósseo aneurismático
M85.6 Outro cisto ósseo
M85.8 Outros transtornos especificados da densidade e da estrutura ósseas
M85.9 Transtorno não especificado da densidade e da estrutura ósseas
M86.0 Osteomielite aguda hematogênica
M86.1 Outra osteomielite aguda
M86.2 Osteomielite subaguda
M86.3 Osteomielite crônica multifocal
M86.4 Osteomielite crônica com seio drenante
M86.5 Outra osteomielite crônica hematogênica
M86.6 Outra osteomielite crônica
M86.8 Outra osteomielite
M86.9 Osteomielite não especificada
M87.0 Necrose asséptica idiopática do osso
M87.1 Osteonecrose devida a drogas
M87.2 Osteonecrose devida a traumatismo anterior
M87.3 Outras osteonecroses secundárias
M87.8 Outras osteonecroses
M87.9 Osteonecrose não especificada
M88.0 Doença de Paget do crânio
M88.8 Doença de Paget de outros ossos
M88.9 Doença de Paget de osso não especificado
M89.0 Algoneurodistrofia
M89.1 Parada de crescimento epifisário
M89.2 Outros transtornos do desenvolvimento e do crescimento ósseo
M89.3 Hipertrofia óssea
M89.4 Outras osteoartropatias hipertróficas
M89.5 Osteolise
M89.6 Osteopatia pós­poliomielite
M89.8 Outros transtornos especificados do osso
M89.9 Transtorno não especificado do osso
M90.0*Tuberculose óssea (A18.0+)
M90.1*Periostite em outras doenças infecciosas classificadas em outra parte
M90.2*Osteopatia em outras doenças infecciosas classificadas em outra parte
M90.3*Osteonecrose em "mal dos caixões" (T70.3+)
M90.4*Osteonecrose devida à hemoglobinopatia (D50­D64+)
M90.5*Osteonecrose em outras doenças classificadas em outra parte
M90.6*Osteíte deformante em doenças neoplásicas (C00­C48+)
M90.7*Fratura óssea em doenças neoplásicas (C00­C48+)
M90.8*Osteopatia em outras doenças classificadas em outra parte
M91.0 Osteocondrose juvenil da pelve
M91.1 Osteocondrose juvenil da cabeça do fêmur [Legg­Calvé­Perthes]
M91.2 Coxa plana
M91.3 Pseudocoxalgia
M91.8 Outras osteocondroses juvenis do quadril e da pelve
M91.9 Osteocondrose juvenil não especificada do quadril e da pelve
M92.0 Osteocondrose juvenil do úmero
M92.1 Osteocondrose juvenil do rádio e do cúbito [ulna]
M92.2 Osteocondrose juvenil da mão
M92.3 Outras osteocondroses juvenis do membro superior
M92.4 Osteocondrose juvenil da rótula [patela]
M92.5 Osteocondrose juvenil da tíbia e perônio [fíbula]
M92.6 Osteocondrose juvenil do tarso
M92.7 Osteocondrose juvenil do metatarso
M92.8 Outras osteocondroses juvenis especificadas
M92.9 Osteocondrose juvenil, não especificada
M93.0 Luxação (não­traumática) da epífise superior do fêmur
M93.1 Doença de Kienböck do adulto
M93.2 Osteocondrite dissecante
M93.8 Outras osteocondropatias, especificadas
M93.9 Osteocondropatias, não especificada
M94.0 Síndrome da junção condrocostal [Tietze]
M94.1 Policondrite recidivante
M94.2 Condromalácia
M94.3 Condrolise
M94.8 Outros transtornos especificados da cartilagem
M94.9 Transtornos não especificados da cartilagem
M95.0 Deformidade adquirida do nariz
M95.1 Orelha em couve­flor
M95.2 Outras deformidades adquiridas da cabeça
M95.3 Deformidade adquirida do pescoço
M95.4 Deformidade adquirida do tórax e das costelas
M95.5 Deformidade adquirida da pelve
M95.8 Outras deformidades adquiridas especificadas do sistema osteomuscular
M95.9 Deformidade adquirida do sistema osteomuscular não especificada
M96.0 Pseudo­artrose após fusão ou artrodese
M96.1 Síndrome pós­laminectomia não classificada em outra parte
M96.2 Cifose pós­radiação
M96.3 Cifose pós­laminectomia
M96.4 Lordose pós­cirúrgica
M96.5 Escoliose pós­radiação
M96.6 Fratura de osso subsequente a implante ortopédico, prótese articular ou placa óssea
M96.8 Outros transtornos osteomusculares pós­procedimentos
M96.9 Transtorno osteomuscular não especificado pós­procedimento
M99.0 Disfunção segmentar e somática
M99.1 Complexo de subluxação (vertebral)
M99.2 Estenose de subluxação do canal medular
M99.3 Estenose óssea do canal medular
M99.4 Estenose de tecido conjuntivo do canal medular
M99.5 Estenose de disco intervertebral do canal medular
M99.6 Estenose óssea e subluxação dos forames intervertebrais
M99.7 Estenose de tecido conjuntivo e do disco dos forames intervertebrais
M99.8 Outras lesões biomecânicas
M99.9 Lesão biomecânica não especificada
N00.0 Síndrome nefrítica aguda ­ anormalidade glomerular minor
N00.1 Síndrome nefrítica aguda ­ lesões glomerulares focais e segmentares
N00.2 Síndrome nefrítica aguda ­ glomerulonefrite membranosa difusa
N00.3 Síndrome nefrítica aguda ­ glomerulonefrite proliferativa mesangial difusa
N00.4 Síndrome nefrítica aguda ­ glomerulonefrite proliferativa endocapilar difusa
N00.5 Síndrome nefrítica aguda ­ glomerulonefrite mesangiocapilar difusa
N00.6 Síndrome nefrítica aguda ­ doença de depósito denso
N00.7 Síndrome nefrítica aguda ­ glomerulonefrite difusa em crescente
N00.8 Síndrome nefrítica aguda ­ outras
N00.9 Síndrome nefrítica aguda ­ não especificada
N01.0 Síndrome nefrítica rapidamente progressiva ­ anormalidade glomerular minor
N01.1 Síndrome nefrítica rapidamente progressiva ­ lesões glomerulares focais e segmentares
N01.2 Síndrome nefrítica rapidamente progressiva ­ glomerulonefrite membranosa difusa
N01.3 Síndrome nefrítica rapidamente progressiva ­ glomerulonefrite proliferativa mesangial difusa
N01.4 Síndrome nefrítica rapidamente progressiva ­ glomerulonefrite proliferativa endocapilar difusa
N01.5 Síndrome nefrítica rapidamente progressiva ­ glomerulonefrite mesangiocapilar difusa
N01.6 Síndrome nefrítica rapidamente progressiva ­ doença de depósito denso
N01.7 Síndrome nefrítica rapidamente progressiva ­ glomerulonefrite difusa em crescente
N01.8 Síndrome nefrítica rapidamente progressiva ­ outras
N01.9 Síndrome nefrítica rapidamente progressiva ­ não especificada
N02.0 Hematúria recidivante e persistente ­ anormalidade glomerular minor
N02.1 Hematúria recidivante e persistente ­ lesões glomerulares focais e segmentares
N02.2 Hematúria recidivante e persistente ­ glomerulonefrite membranosa difusa
N02.3 Hematúria recidivante e persistente ­ glomerulonefrite proliferativa mesangial difusa
N02.4 Hematúria recidivante e persistente ­ glomerulonefrite proliferativa endocapilar difusa
N02.5 Hematúria recidivante e persistente ­ glomerulonefrite mesangiocapilar difusa
N02.6 Hematúria recidivante e persistente ­ doença de depósito denso
N02.7 Hematúria recidivante e persistente ­ glomerulonefrite difusa em crescente
N02.8 Hematúria recidivante e persistente ­ outras
N02.9 Hematúria recidivante e persistente ­ não especificada
N03.0 Síndrome nefrítica crônica ­ anormalidade glomerular minor
N03.1 Síndrome nefrítica crônica ­ lesões glomerulares focais e segmentares
N03.2 Síndrome nefrítica crônica ­ glomerulonefrite membranosa difusa
N03.3 Síndrome nefrítica crônica ­ glomerulonefrite proliferativa mesangial difusa
N03.4 Síndrome nefrítica crônica ­ glomerulonefrite proliferativa endocapilar difusa
N03.5 Síndrome nefrítica crônica ­ glomerulonefrite mesangiocapilar difusa
N03.6 Síndrome nefrítica crônica ­ doença de depósito denso
N03.7 Síndrome nefrítica crônica ­ glomerulonefrite difusa em crescente
N03.8 Síndrome nefrítica crônica ­ outras
N03.9 Síndrome nefrítica crônica ­ não especificada
N04.0 Síndrome nefrótica ­ anormalidade glomerular minor
N04.1 Síndrome nefrótica ­ lesões glomerulares focais e segmentares
N04.2 Síndrome nefrótica ­ glomerulonefrite membranosa difusa
N04.3 Síndrome nefrótica ­ glomerulonefrite proliferativa mesangial difusa
N04.4 Síndrome nefrótica ­ glomerulonefrite proliferativa endocapilar difusa
N04.5 Síndrome nefrótica ­ glomerulonefrite mesangiocapilar difusa
N04.6 Síndrome nefrótica ­ doença de depósito denso
N04.7 Síndrome nefrótica ­ glomerulonefrite difusa em crescente
N04.8 Síndrome nefrótica ­ outras
N04.9 Síndrome nefrótica ­ não especificada
N05.0 Síndrome nefrítica não especificada ­ anormalidade glomerular minor
N05.1 Síndrome nefrítica não especificada ­ lesões glomerulares focais e segmentares
N05.2 Síndrome nefrítica não especificada ­ glomerulonefrite membranosa difusa
N05.3 Síndrome nefrítica não especificada ­ glomerulonefrite proliferativa mesangial difusa
N05.4 Síndrome nefrítica não especificada ­ glomerulonefrite proliferativa endocapilar difusa
N05.5 Síndrome nefrítica não especificada ­ glomerulonefrite mesangiocapilar difusa
N05.6 Síndrome nefrítica não especificada ­ doença de depósito denso
N05.7 Síndrome nefrítica não especificada ­ glomerulonefrite difusa em crescente
N05.8 Síndrome nefrítica não especificada ­ outras
N05.9 Síndrome nefrítica não especificada ­ não especificada
N06.0 Proteinúria isolada com lesão morfológica especificada ­ anormalidade glomerular minor
N06.1 Proteinúria isolada com lesão morfológica especificada ­ lesões glomerulares focais e
segmentares
N06.2 Proteinúria isolada com lesão morfológica especificada ­ glomerulonefrite membranosa difusa
N06.3 Proteinúria isolada com lesão morfológica especificada ­ glomerulonefrite proliferativa mesangial
difusa
N06.4 Proteinúria isolada com lesão morfológica especificada ­ glomerulonefrite proliferativa
endocapilar difusa
N06.5 Proteinúria isolada com lesão morfológica especificada ­ glomerulonefrite mesangiocapilar
difusa
N06.6 Proteinúria isolada com lesão morfológica especificada ­ doença de depósito denso
N06.7 Proteinúria isolada com lesão morfológica especificada ­ glomerulonefrite difusa em crescente
N06.8 Proteinúria isolada com lesão morfológica especificada ­ outras
N06.9 Proteinúria isolada com lesão morfológica especificada ­ não especificada
N07.0 Nefropatia hereditária não classificada em outra parte ­ anormalidade glomerular minor
N07.1 Nefropatia hereditária não classificada em outra parte ­ lesões glomerulares focais e
segmentares
N07.2 Nefropatia hereditária não classificada em outra parte ­ glomerulonefrite membranosa difusa
N07.3 Nefropatia hereditária não classificada em outra parte ­ glomerulonefrite proliferativa mesangial
difusa
N07.4 Nefropatia hereditária não classificada em outra parte ­ glomerulonefrite proliferativa endocapilar
difusa
N07.5 Nefropatia hereditária não classificada em outra parte ­ glomerulonefrite mesangiocapilar difusa
N07.6 Nefropatia hereditária não classificada em outra parte ­ doença de depósito denso
N07.7 Nefropatia hereditária não classificada em outra parte ­ glomerulonefrite difusa em crescente
N07.8 Nefropatia hereditária não classificada em outra parte ­ outras
N07.9 Nefropatia hereditária não classificada em outra parte ­ não especificada
N08.0*Transtornos glomerulares em doenças infecciosas e parasitárias classificadas em outra parte
N08.1*Transtornos glomerulares em doenças neoplásicas
N08.2*Transtornos glomerulares em doenças do sangue e transtornos imunitários
N08.3*Transtornos glomerulares no diabetes mellitus (E10­E14 com quarto caractere comum .2)
N08.4*Transtornos glomerulares em doenças endócrinas, nutricionais e metabólicas
N08.5*Transtornos glomerulares em doenças sistêmicas do tecido conjuntivo
N08.8*Transtornos glomerulares em outras doenças classificadas em outra parte
N10 Nefrite túbulo­intersticial aguda
N11.0 Pielonefrite não­obstrutiva crônica associada a refluxo
N11.1 Pielonefrite obstrutiva crônica
N11.8 Outras nefrites túbulo­intersticiais crônicas
N11.9 Nefrite túbulo­intersticial crônica não especificada
N12 Nefrite túbulo­intersticial não especificada se aguda ou crônica
N13.0 Hidronefrose com obstrução da junção uretero­pélvica
N13.1 Hidronefrose com estreitamento de ureter não classificada em outra parte
N13.2 Hidronefrose com obstrução por calculose renal e ureteral
N13.3 Outras hidronefroses e as não especificadas
N13.4 Hidroureter
N13.5 Torção e estreitamento do ureter sem hidronefrose
N13.6 Pionefrose
N13.7 Uropatia associada a refluxo vésico­ureteral
N13.8 Outras uropatias obstrutivas e por refluxo
N13.9 Uropatia obstrutiva e por refluxo não especificada
N14.0 Nefropatia induzida por analgésico
N14.1 Nefropatia induzida por outras drogas, medicamentos e substâncias biológicas
N14.2 Nefropatia induzida por drogas, medicamentos e substâncias biológicas não especificadas
N14.3 Nefropatia induzida por metais pesados
N14.4 Nefropatia tóxica não classificada em outra parte
N15.0 Nefropatia dos Bálcãs
N15.1 Abscesso renal e perinefrético
N15.8 Outras doenças renais túbulo­intersticiais especificadas
N15.9 Doença renal túbulo­intersticial não especificada
N16.0*Transtornos renais túbulo­intersticiais em doenças infecciosas e parasitárias classificadas em
outra parte
N16.1*Transtornos renais túbulo­intersticiais em doenças neoplásicas
N16.2*Transtornos renais túbulo­intersticiais em doenças do sangue e transtornos imunitários
N16.3*Transtornos renais túbulo­intersticiais em doenças metabólicas
N16.4*Transtornos renais túbulo­intersticiais em doenças do tecido conjuntivo
N16.5*Transtornos renais túbulo­intersticiais em rejeição a transplantes (T86.­+)
N16.8*Transtornos renais túbulo­intersticiais em outras doenças classificadas em outra parte
N17.0 Insuficiência renal aguda com necrose tubular
N17.1 Insuficiência renal aguda com necrose cortical aguda
N17.2 Insuficiência renal aguda com necrose medular
N17.8 Outro tipo de insuficiência renal aguda
N17.9 Insuficiência renal aguda não especificada
N18.0 Doença renal em estádio final
N18.8 Outra insuficiência renal crônica
N18.9 Insuficiência renal crônica não especificada
N19 Insuficiência renal não especificada
N20.0 Calculose do rim
N20.1 Calculose do ureter
N20.2 Calculose do rim com cálculo do ureter
N20.9 Calculose urinária, não especificada
N21.0 Calculose na bexiga
N21.1 Cálculo uretral
N21.8 Outros cálculos do trato urinário inferior
N21.9 Cálculo do trato urinário inferior, porção não especificada
N22.0*Cálculo urinário na esquistossomose [bilharziose] [schistosomíase] (B65.­+)
N22.8*Calculose do trato urinário em outras doenças classificadas em outra parte
N23 Cólica nefrética não especificada
N25.0 Osteodistrofia renal
N25.1 Diabetes insípido nefrogênico
N25.8 Outros transtornos resultantes de função renal tubular alterada
N25.9 Transtornos resultante de função tubular alterada
N26 Rim contraído, não especificado
N27.0 Hipoplasia renal unilateral
N27.1 Hipoplasia renal bilateral
N27.9 Hipoplasia renal não especificada
N28.0 Isquemia e infarto renal
N28.1 Cisto do rim, adquirido
N28.8 Outros transtornos especificados do rim e do ureter
N28.9 Transtorno não especificado do rim e do ureter
N29.0*Sífilis tardia renal (A52.7+)
N29.1*Outros transtornos do rim e do ureter em doenças infecciosas e parasitárias classificadas em
outra parte
N29.8*Outros transtornos do rim e do ureter em outras doenças classificadas em outra parte
N30.0 Cistite aguda
N30.1 Cistite intersticial (crônica)
N30.2 Outras cistites crônicas
N30.3 Trigonite
N30.4 Cistite por radiação
N30.8 Outras cistites
N30.9 Cistite, não especificada
N31.0 Bexiga neuropática não­inibida não classificada em outra parte
N31.1 Bexiga neuropática reflexa não classificada em outra parte
N31.2 Bexiga neuropática flácida não classificada em outra parte
N31.8 Outra disfunção neuromuscular da bexiga
N31.9 Disfunção neuromuscular não especificada da bexiga
N32.0 Obstrução do colo da bexiga
N32.1 Fístula êntero­vesical
N32.2 Fístula vesical não classificada em outra parte
N32.3 Divertículo da bexiga
N32.4 Ruptura da bexiga, não­traumática
N32.8 Outros transtornos especificados da bexiga
N32.9 Transtorno não especificado da bexiga
N33.0*Cistite tuberculosa (A18.1+)
N33.8*Transtornos da bexiga em outras doenças classificadas em outra parte
N34.0 Abscesso uretral
N34.1 Uretrites não específicas
N34.2 Outras uretrites
N34.3 Síndrome uretral, não especificada
N35.0 Estenose uretral pós­traumática
N35.1 Estenose uretral pós­infecciosa não classificada em outra parte
N35.8 Outra estenose (estreitamento) uretral
N35.9 Estenose (estreitamento) uretral não especificada(o)
N36.0 Fístula uretral
N36.1 Divertículo uretral
N36.2 Carúncula uretral
N36.3 Prolapso da mucosa uretral
N36.8 Outros transtornos especificados da uretra
N36.9 Transtorno não especificado da uretra
N37.0*Uretrite em doenças classificadas em outra parte
N37.8*Outros transtornos da uretra em doenças classificadas em outra parte
N39.0 Infecção do trato urinário de localização não especificada
N39.1 Proteinúria persistente não especificada
N39.2 Proteinúria ortostática não especificada
N39.3 Incontinência de tensão ("stress")
N39.4 Outras incontinências urinárias especificadas
N39.8 Outros transtornos especificados do aparelho urinário
N39.9 Transtornos não especificados do aparelho urinário
N40 Hiperplasia da próstata
N41.0 Prostatite aguda
N41.1 Prostatite crônica
N41.2 Abscesso da próstata
N41.3 Prostatocistite
N41.8 Outras doenças inflamatórias da próstata
N41.9 Doença inflamatória não especificada da próstata
N42.0 Cálculo da próstata
N42.1 Congestão e hemorragia da próstata
N42.2 Atrofia da próstata
N42.8 Outras afecções especificadas da próstata
N42.9 Afecção não especificada da próstata
N43.0 Hidrocele encistada
N43.1 Hidrocele infectada
N43.2 Outra hidrocele
N43.3 Hidrocele não especificada
N43.4 Espermatocele
N44 Torção do testículo
N45.0 Orquite, epididimite e epidídimo­orquite, com menção de abscesso
N45.9 Orquite, epididimite e epidídimo­orquite, sem menção de abscesso
N46 Infertilidade masculina
N47 Hipertrofia do prepúcio, fimose e parafimose
N48.0 Leucoplasia do pênis
N48.1 Balanopostite
N48.2 Outros transtornos inflamatórios do pênis
N48.3 Priapismo
N48.4 Impotência de origem orgânica
N48.5 Úlcera do pênis
N48.6 Balanite xerótica obliterante
N48.8 Outros transtornos especificados do pênis
N48.9 Transtorno não especificado do pênis
N49.0 Transtornos inflamatórios da vesícula seminal
N49.1 Transtornos inflamatórios do cordão espermático, túnica vaginal e vasos deferentes
N49.2 Transtorno inflamatório do escroto
N49.8 Transtornos inflamatórios de outros órgãos genitais masculinos especificados
N49.9 Transtorno inflamatório de órgão genital masculino, não especificado
N50.0 Atrofia do testículo
N50.1 Transtornos vasculares dos órgãos genitais masculinos
N50.8 Outros transtornos especificados dos órgãos genitais masculinos
N50.9 Transtorno não especificado dos órgãos genitais masculinos
N51.0*Transtornos da próstata em doenças classificadas em outra parte
N51.1*Transtornos do testículo e do epidídimo em doenças classificadas em outra parte
N51.2*Balanite em doenças classificadas em outra parte
N51.8*Outros transtornos dos órgãos genitais masculinos em doenças classificadas em outra parte
N60.0 Cisto solitário da mama
N60.1 Mastopatia cística difusa
N60.2 Fibroadenose da mama
N60.3 Fibrosclerose da mama
N60.4 Ectasia de dutos mamários
N60.8 Outras displasias mamárias benignas
N60.9 Displasia mamária benigna não especificada
N61 Transtornos inflamatórios da mama
N62 Hipertrofia da mama
N63 Nódulo mamário não especificado
N64.0 Fissura e fístula do mamilo
N64.1 Necrose gordurosa da mama
N64.2 Atrofia da mama
N64.3 Galactorréia não­associada ao parto
N64.4 Mastodinia
N64.5 Outros sintomas e sinais da mama
N64.8 Outros transtornos especificados da mama
N64.9 Transtorno da mama não especificado
N70.0 Salpingite e ooforite agudas
N70.1 Salpingite e ooforite crônicas
N70.9 Salpingite e ooforite não especificadas
N71.0 Doença inflamatória aguda do útero
N71.1 Doença inflamatória crônica do útero
N71.9 Doença inflamatória não especificada do útero
N72 Doença inflamatória do colo do útero
N73.0 Parametrite e celulite pélvicas agudas
N73.1 Parametrite e celulite pélvicas crônicas
N73.2 Parametrite e celulite pélvicas não especificadas
N73.3 Pelviperitonite aguda feminina
N73.4 Pelviperitonite crônica feminina
N73.5 Pelviperitonite não especificada feminina
N73.6 Aderências pelviperitonais femininas
N73.8 Outras doenças inflamatórias especificadas da pelve feminina
N73.9 Doença inflamatória não especificada da pelve feminina
N74.0*Tuberculose do colo do útero (A18.1+)
N74.1*Tuberculose da pelve feminina (A18.1+)
N74.2*Sífilis pélvica feminina (A51.4+, A52.7+)
N74.3*Infecção gonocócica pélvica feminina (A54.2+)
N74.4*Infecção pélvica feminina por clamídia (A56.1+)
N74.8*Inflamação pélvica feminina em outras doenças classificadas em outra parte
N75.0 Cisto da glândula de Bartholin
N75.1 Abscesso da glândula de Bartholin
N75.8 Outras doenças da glândula de Bartholin
N75.9 Doença não especificada da glândula de Bartholin
N76.0 Vaginite aguda
N76.1 Vaginite subaguda e crônica
N76.2 Vulvite aguda
N76.3 Vulvite subaguda e crônica
N76.4 Abscesso vulvar
N76.5 Ulceração vaginal
N76.6 Ulceração vulvar
N76.8 Outras inflamações especificadas da vagina e da vulva
N77.0*Ulceração da vulva em doenças infecciosas e parasitárias classificadas em outra parte
N77.1*Vaginite, vulvite e vulvovaginite em doenças infecciosas e parasitárias classificadas em outra
parte
N77.8*Ulceração e inflamação vulvovaginais em outras doenças classificadas em outra parte
N80.0 Endometriose do útero
N80.1 Endometriose do ovário
N80.2 Endometriose da trompa de Falópio
N80.3 Endometriose do peritônio pélvico
N80.4 Endometriose do septo retovaginal e da vagina
N80.5 Endometriose do intestino
N80.6 Endometriose em cicatriz cutânea
N80.8 Outra endometriose
N80.9 Endometriose não especificada
N81.0 Uretrocele feminina
N81.1 Cistocele
N81.2 Prolapso uterovaginal incompleto
N81.3 Prolapso uterovaginal completo
N81.4 Prolapso uterovaginal não especificado
N81.5 Enterocele vaginal
N81.6 Retocele
N81.8 Outro prolapso genital feminino
N81.9 Prolapso genital feminino não especificado
N82.0 Fístula vesicovaginal
N82.1 Outras fístulas do trato geniturinário feminino
N82.2 Fístula vagina­intestino delgado
N82.3 Fístula vagina­cólon
N82.4 Outras fístulas genito­intestinais femininas
N82.5 Fístula genitocutânea feminina
N82.8 Outras fístulas do trato genital feminino
N82.9 Fístulas não especificadas do trato genital feminino
N83.0 Cisto folicular do ovário
N83.1 Cisto do corpo lúteo
N83.2 Outros cistos ovarianos e os não especificados
N83.3 Atrofia adquirida do ovário e da trompa de Falópio
N83.4 Prolapso e hérnia do ovário e da trompa de Falópio
N83.5 Torção do ovário, do pedículo ovariano e da trompa de Falópio
N83.6 Hematossalpinge
N83.7 Hematoma do ligamento largo
N83.8 Outros transtornos não­inflamatórios do ovário, da trompa de Falópio e do ligamento largo
N83.9 Transtornos não­inflamatórios do ovário, da trompa de Falópio e do ligamento largo, não
especificados
N84.0 Pólipo do corpo do útero
N84.1 Pólipo do colo do útero
N84.2 Pólipo da vagina
N84.3 Pólipo da vulva
N84.8 Pólipo de outras partes do trato genital feminino
N84.9 Pólipo do trato genital feminino não especificado
N85.0 Hiperplasia glandular endometrial
N85.1 Hiperplasia adenomatosa endometrial
N85.2 Hipertrofia do útero
N85.3 Subinvolução do útero
N85.4 Posição anormal do útero
N85.5 Inversão do útero
N85.6 Sinéquias intra­uterinas
N85.7 Hematometra
N85.8 Outros transtornos não­inflamatórios especificados do útero
N85.9 Transtornos não­inflamatórios do útero, não especificados
N86 Erosão e ectrópio do colo do útero
N87.0 Displasia cervical leve
N87.1 Displasia cervical moderada
N87.2 Displasia cervical grave, não classificada em outra parte
N87.9 Displasia do colo do útero, não especificada
N88.0 Leucoplasia do colo do útero
N88.1 Laceração antiga do colo do útero
N88.2 Estreitamento e estenose do colo do útero
N88.3 Incompetência do colo do útero
N88.4 Alongamento hipertrófico do colo do útero
N88.8 Outros transtornos não­inflamatórios especificados do colo do útero
N88.9 Transtorno não­inflamatório e não especificado do colo do útero
N89.0 Displasia vaginal leve
N89.1 Displasia vaginal moderada
N89.2 Displasia vaginal grave, não classificada em outra parte
N89.3 Displasia da vagina, não especificada
N89.4 Leucoplasia da vagina
N89.5 Estreitamento e atresia da vagina
N89.6 Anel himenal apertado
N89.7 Hematocolpos
N89.8 Outros transtornos não­inflamatórios especificados da vagina
N89.9 Transtorno não­inflamatório da vagina, não especificado
N90.0 Displasia vulvar leve
N90.1 Displasia vulvar moderada
N90.2 Displasia vulvar grave, não classificada em outra parte
N90.3 Displasia de vulva, não especificada
N90.4 Leucoplasia de vulva
N90.5 Atrofia da vulva
N90.6 Hipertrofia da vulva
N90.7 Cisto vulvar
N90.8 Outros transtornos não­inflamatórios especificados da vulva e do períneo
N90.9 Transtorno não­inflamatório e não especificado da vulva e do períneo
N91.0 Amenorréia primária
N91.1 Amenorréia secundária
N91.2 Amenorréia, não especificada
N91.3 Oligomenorréia primária
N91.4 Oligomenorréia secundária
N91.5 Oligomenorréia, não especificada
N92.0 Menstruação excessiva e freqüente com ciclo regular
N92.1 Menstruação excessiva e freqüente com ciclo irregular
N92.2 Menstruação excessiva na puberdade
N92.3 Sangramento da ovulação
N92.4 Sangramento abundante na pré­menopausa
N92.5 Outros tipos especificados de irregularidade da menstruação
N92.6 Menstruação irregular, não especificada
N93.0 Sangramentos pós­coito ou de contato
N93.8 Outros sangramentos anormais especificados do útero e da vagina
N93.9 Sangramento anormal do útero ou da vagina, não especificado
N94.0 Ovulação dolorosa [Mittelschmerz]
N94.1 Dispareunia
N94.2 Vaginismo
N94.3 Síndrome de tensão pré­menstrual
N94.4 Dismenorréia primária
N94.5 Dismenorréia secundária
N94.6 Dismenorréia não especificada
N94.8 Outras afecções especificadas associadas com os órgãos genitais femininos e com o ciclo
menstrual
N94.9 Afecções não especificadas associadas com os órgãos genitais femininos e com o ciclo
menstrual
N95.0 Sangramento pós­menopausa
N95.1 Estado da menopausa e do climatério feminino
N95.2 Vaginite atrófica pós­menopausa
N95.3 Condições associadas com a menopausa artificial
N95.8 Outros transtornos especificados da menopausa e da perimenopausa
N95.9 Transtorno não especificado da menopausa e da perimenopausa
N96 Abortamento habitual
N97.0 Infertilidade feminina associada à anovulação
N97.1 Infertilidade feminina de origem tubária
N97.2 Infertilidade feminina de origem uterina
N97.3 Infertilidade feminina de origem cervical
N97.4 Infertilidade feminina associada à fatores do parceiro
N97.5 Infertilidade feminina de outra origem
N97.9 Infertilidade feminina não especificada
N98.0 Infecção associada à inseminação artificial
N98.1 Hiperestimulação dos ovários
N98.2 Complicações relacionadas com a tentativa de introdução do óvulo fecundado artificialmente (in
vitro)
N98.3 Complicações relacionadas com a tentativa de transferência do embrião
N98.8 Outras complicações associadas à fecundação artificial
N98.9 Complicações não especificadas associadas à fecundação artificial
N99.0 Insuficiência renal pós­procedimentos
N99.1 Estreitamento de uretra pós­procedimentos
N99.2 Aderências pós­operatórias da vagina
N99.3 Prolapso de cúpula de vagina pós­histerectomia
N99.4 Aderências do peritônio pélvico pós­procedimentos
N99.5 Mau funcionamento de abertura externa (estoma) do trato urinário
N99.8 Outros transtornos pós­procedimentos do aparelho geniturinário
N99.9 Transtorno pós­procedimento não especificado do aparelho geniturinário
O00.0 Gravidez abdominal
O00.1 Gravidez tubária
O00.2 Gravidez ovariana
O00.8 Outras formas de gravidez ectópica
O00.9 Gravidez ectópica, não especificada
O01.0 Mola hidatiforme clássica
O01.1 Mola hidatiforme incompleta ou parcial
O01.9 Mola hidatiforme não especificada
O02.0 Ovo claro e mola não­hidatiforme
O02.1 Aborto retido
O02.8 Outros produtos anormais da concepção especificados
O02.9 Produto anormal da concepção, não especificado
O03.0 Aborto espontâneo ­ incompleto, complicado por infecção do trato genital ou dos órgãos
pélvicos
O03.1 Aborto espontâneo ­ incompleto, complicado por hemorragia excessiva ou tardia
O03.2 Aborto espontâneo ­ incompleto, complicado por embolia
O03.3 Aborto espontâneo ­ incompleto, com outras complicações ou com complicações não
especificadas
O03.4 Aborto espontâneo ­ incompleto, sem complicações
O03.5 Aborto espontâneo ­ completo ou não especificado, complicado por infecções do trato genital ou
dos órgãos pélvicos
O03.6 Aborto espontâneo ­ completo ou não especificado, complicado por hemorragia excessiva ou
tardia
O03.7 Aborto espontâneo ­ completo ou não especificado, complicado por embolia
O03.8 Aborto espontâneo ­ completo ou não especificado, com outras complicações ou com
complicações não especificadas
O03.9 Aborto espontâneo ­ completo ou não especificado, sem complicações
O04.0 Aborto por razões médicas e legais ­ incompleto, complicado por infecção do trato genital ou
dos órgãos pélvicos
O04.1 Aborto por razões médicas e legais ­ incompleto, complicado por hemorragia excessiva ou tardia
O04.2 Aborto por razões médicas e legais ­ incompleto, complicado por embolia
O04.3 Aborto por razões médicas e legais ­ incompleto, com outras complicações ou com
complicações não especificadas
O04.4 Aborto por razões médicas e legais ­ incompleto, sem complicações
O04.5 Aborto por razões médicas e legais ­ completo ou não especificado, complicado por infecções
do trato genital ou dos órgãos pélvicos
O04.6 Aborto por razões médicas e legais ­ completo ou não especificado, complicado por hemorragia
excessiva ou tardia
O04.7 Aborto por razões médicas e legais ­ completo ou não especificado, complicado por embolia
O04.8 Aborto por razões médicas e legais ­ completo ou não especificado, com outras complicações
ou com complicações não especificadas
O04.9 Aborto por razões médicas e legais ­ completo ou não especificado, sem complicações
O05.0 Outros tipos de aborto ­ incompleto, complicado por infecção do trato genital ou dos órgãos
pélvicos
O05.1 Outros tipos de aborto ­ incompleto, complicado por hemorragia excessiva ou tardia
O05.2 Outros tipos de aborto ­ incompleto, complicado por embolia
O05.3 Outros tipos de aborto ­ incompleto, com outras complicações ou com complicações não
especificadas
O05.4 Outros tipos de aborto ­ incompleto, sem complicações
O05.5 Outros tipos de aborto ­ completo ou não especificado, complicado por infecções do trato genital
ou dos órgãos pélvicos
O05.6 Outros tipos de aborto ­ completo ou não especificado, complicado por hemorragia excessiva ou
tardia
O05.7 Outros tipos de aborto ­ completo ou não especificado, complicado por embolia
O05.8 Outros tipos de aborto ­ completo ou não especificado, com outras complicações ou com
complicações não especificadas
O05.9 Outros tipos de aborto ­ completo ou não especificado, sem complicações
O06.0 Aborto não especificado ­ incompleto, complicado por infecção do trato genital ou dos órgãos
pélvicos
O06.1 Aborto não especificado ­ incompleto, complicado por hemorragia excessiva ou tardia
O06.2 Aborto não especificado ­ incompleto, complicado por embolia
O06.3 Aborto não especificado ­ incompleto, com outras complicações ou com complicações não
especificadas
O06.4 Aborto não especificado ­ incompleto, sem complicações
O06.5 Aborto não especificado ­ completo ou não especificado, complicado por infecções do trato
genital ou dos órgãos pélvicos
O06.6 Aborto não especificado ­ completo ou não especificado, complicado por hemorragia excessiva
ou tardia
O06.7 Aborto não especificado ­ completo ou não especificado, complicado por embolia
O06.8 Aborto não especificado ­ completo ou não especificado, com outras complicações ou com
complicações não especificadas
O06.9 Aborto não especificado ­ completo ou não especificado, sem complicações
O07.0 Falha de aborto provocado por razões médicas, complicado por infecção do trato genital ou dos
órgãos pélvicos
O07.1 Falha de aborto provocado por razões médicas, complicado por hemorragia tardia ou excessiva
O07.2 Falha de aborto provocado por razões médicas, complicado por embolia
O07.3 Falha de aborto provocado por razões médicas, com outras complicações ou com complicações
não especificadas
O07.4 Falha de aborto provocado por razões médicas, sem complicações
O07.5 Outras formas, e as não especificadas, de falha na provocação de aborto, complicadas por
infecção do trato genital e por infecção dos órgãos pélvicos
O07.6 Outras formas, e as não especificadas, de falha na provocação de aborto, complicadas por
hemorragia tardia ou excessiva
O07.7 Outras formas, e as não especificadas, de falha na provocação de aborto, complicadas por
embolia
O07.8 Outras formas, e as não especificadas, de falha na provocação de aborto, com outras
complicações ou com complicações não especificadas
O07.9 Outras formas, e as não especificadas, de falha na provocação de aborto, sem complicação
O08.0 Infecção do trato genital e dos órgãos pélvicos conseqüente a aborto e gravidez ectópica e
molar
O08.1 Hemorragia tardia ou excessiva conseqüente a aborto e a gravidez ectópica e molar
O08.2 Embolia conseqüente a aborto e a gravidez ectópica e molar
O08.3 Choque conseqüente a aborto e a gravidez ectópica e molar
O08.4 Insuficiência renal conseqüente a aborto e a gravidez ectópica e molar
O08.5 Distúrbios metabólicos conseqüentes a aborto e a gravidez ectópica e molar
O08.6 Lesão a órgãos e a tecidos pélvicos conseqüentes a aborto e a gravidez ectópica e molar
O08.7 Outras complicações venosas conseqüentes a aborto e a gravidez ectópica e molar
O08.8 Outras complicações conseqüentes a aborto e a gravidez ectópica e molar
O08.9 Complicações conseqüentes a aborto e gravidez ectópica e molar, não especificadas
O10.0 Hipertensão essencial pré­existente complicando a gravidez, o parto e o puerpério
O10.1 Doença cardíaca hipertensiva pré­existente complicando a gravidez, o parto e o puerpério
O10.2 Doença renal hipertensiva pré­existente complicando a gravidez, o parto e o puerpério
O10.3 Doença cardíaca e renal hipertensiva pré­existente complicando a gravidez, o parto e o
puerpério
O10.4 Hipertensão secundária pré­existente complicando a gravidez, o parto e o puerpério
O10.9 Hipertensão pré­existente não especificada, complicando a gravidez, o parto e o puerpério
O11 Distúrbio hipertensivo pré­existente com proteinúria superposta
O12.0 Edema gestacional
O12.1 Proteinúria gestacional
O12.2 Edema gestacional com proteinúria
O13 Hipertensão gestacional [induzida pela gravidez] sem proteinúria significativa
O14.0 Pré­eclâmpsia moderada
O14.1 Pré­eclâmpsia grave
O14.9 Pré­eclâmpsia não especificada
O15.0 Eclâmpsia na gravidez
O15.1 Eclâmpsia no trabalho de parto
O15.2 Eclâmpsia no puerpério
O15.9 Eclâmpsia não especificada quanto ao período
O16 Hipertensão materna não especificada
O20.0 Ameaça de aborto
O20.8 Outras hemorragias do início da gravidez
O20.9 Hemorragia do início da gravidez, não especificada
O21.0 Hiperêmese gravídica leve
O21.1 Hiperêmese gravídica com distúrbio metabólico
O21.2 Vômitos tardios da gravidez
O21.8 Outras formas de vômitos complicando a gravidez
O21.9 Vômitos da gravidez, não especificados
O22.0 Varizes dos membros inferiores na gravidez
O22.1 Varizes genitais na gravidez
O22.2 Tromboflebite superficial na gravidez
O22.3 Flebotrombose profunda na gravidez
O22.4 Hemorróidas na gravidez
O22.5 Trombose venosa cerebral na gravidez
O22.8 Outras complicações venosas na gravidez
O22.9 Complicações venosas na gravidez, não especificadas
O23.0 Infecções do rim na gravidez
O23.1 Infecções da bexiga na gravidez
O23.2 Infecções da uretra na gravidez
O23.3 Infecções de outras partes do trato urinário na gravidez
O23.4 Infecção não especificada do trato urinário na gravidez
O23.5 Infecções do trato genital na gravidez
O23.9 Outras infecções e as não especificadas do trato urinário na gravidez
O24.0 Diabetes mellitus pré­existente, insulino­dependente
O24.1 Diabetes mellitus pré­existente, não­insulino­dependente
O24.2 Diabetes mellitus pré­existente, relacionado com a desnutrição
O24.3 Diabetes mellitus pré­existente, não especificado
O24.4 Diabetes mellitus que surge durante a gravidez
O24.9 Diabetes mellitus na gravidez, não especificado
O25 Desnutrição na gravidez
O26.0 Ganho excessivo de peso na gravidez
O26.1 Ganho de peso insuficiente na gravidez
O26.2 Assistência à gravidez por motivo de abortamento habitual
O26.3 Retenção de dispositivo intra­uterino contraceptivo (DIU) na gravidez
O26.4 Herpes gestacional
O26.5 Síndrome da hipotensão materna
O26.6 Transtornos do fígado na gravidez, no parto e no puerpério
O26.7 Subluxação da sínfise (púbica) na gravidez, parto e puerpério
O26.8 Outras afecções especificadas, ligadas a gravidez
O26.9 Afecções ligadas a gravidez, não especificadas
O28.0 Achados hematológicos anormais do rastreamento ["screening"] antenatal da mãe
O28.1 Achados bioquímicos anormais do rastreamento ["screening"] antenatal da mãe
O28.2 Achados citológicos anormais do rastreamento ["screening"] antenatal da mãe
O28.3 Achados ultrassonográficos anormais do rastreamento ["screening"] antenatal da mãe
O28.4 Achados radiológicos anormais do rastreamento ["screening"] antenatal da mãe
O28.5 Achados cromossômicos e genéticos anormais do rastreamento ["screening"] antenatal da mãe
O28.8 Outros achados anormais do rastreamento ["screening"] antenatal da mãe
O28.9 Achados anormais do rastreamento ["screening"] antenatal da mãe, não especificados
O29.0 Complicações pulmonares de anestesia administrada durante a gravidez
O29.1 Complicações cardíacas de anestesia administrada durante a gravidez
O29.2 Complicações relativas ao sistema nervoso central devidas a anestesia administrada durante a
gravidez
O29.3 Reação tóxica causada por anestesia local administrada durante a gravidez
O29.4 Cefaléia causada por anestesia raquidiana ou peridural administradas durante a gravidez
O29.5 Outras complicações de anestesia raquidiana ou peridural administradas durante a gravidez
O29.6 Falha ou dificuldade na entubação durante a gravidez
O29.8 Outras complicações de anestesia durante a gravidez
O29.9 Complicações de anestesia durante a gravidez, não especificadas
O30.0 Gravidez dupla
O30.1 Gravidez trigemelar
O30.2 Gravidez quadrigemelar
O30.8 Outras gestações múltiplas
O30.9 Gestação múltipla, não especificada
O31.0 Feto papiráceo
O31.1 Continuação da gravidez após aborto de um ou mais fetos
O31.2 Continuação da gravidez após a morte intra­uterina de um ou mais fetos
O31.8 Outras complicações específicas de gestação múltipla
O32.0 Assistência prestada à mãe por posição fetal instável
O32.1 Assistência prestada à mãe por apresentação pélvica
O32.2 Assistência prestada à mãe por posição fetal transversa e oblíqua
O32.3 Assistência prestada à mãe por apresentação de face, mento e fronte
O32.4 Assistência prestada à mãe por polo cefálico alto em gestação a termo
O32.5 Assistência prestada à mãe por gestação múltipla com apresentação anormal de um ou mais
fetos
O32.6 Assistência prestada à mãe por apresentação composta
O32.8 Assistência prestada à mãe por outras formas de apresentação anormal do feto
O32.9 Assistência prestada à mãe por apresentação anormal do feto, não especificada
O33.0 Assistência prestada à mãe por uma desproporção devida à deformidade da pelve óssea
materna
O33.1 Assistência prestada à mãe por uma desproporção devida à contração geral da pelve
O33.2 Assistência prestada à mãe por uma desproporção devida à contração do estreito superior da
pelve
O33.3 Assistência prestada à mãe por uma desproporção devida à contração do estreito inferior da
pelve
O33.4 Assistência prestada à mãe por uma desproporção de origem mista, materna e fetal
O33.5 Assistência prestada à mãe por uma desproporção devida a feto excepcionalmente grande
O33.6 Assistência prestada à mãe por uma desproporção devida a feto hidrocefálico
O33.7 Assistência prestada à mãe por uma desproporção devida a outras deformidades fetais
O33.8 Assistência prestada à mãe por uma desproporção de outra origem
O33.9 Assistência prestada à mãe por uma desproporção, não especificada
O34.0 Assistência à mãe por malformação congênita do útero
O34.1 Assistência prestada à mãe por tumor do corpo do útero
O34.2 Assistência prestada à mãe por cicatriz uterina devida a uma cirurgia anterior
O34.3 Assistência prestada à mãe por incompetência cervical
O34.4 Assistência prestada à mãe por outras anormalidades do colo do útero
O34.5 Assistência prestada à mãe por outras anormalidades do útero gravídico
O34.6 Assistência prestada à mãe por anormalidade da vagina
O34.7 Assistência prestada à mãe por anormalidade da vulva e do períneo
O34.8 Assistência prestada à mãe por outras anormalidades dos órgãos pélvicos
O34.9 Assistência prestada à mãe por anormalidade de órgãos pélvicos, não especificada
O35.0 Assistência prestada à mãe por malformação do sistema nervoso central do feto (suspeitada)
O35.1 Assistência prestada à mãe por anormalidade cromossômica (suspeitada) do feto
O35.2 Assistência prestada à mãe por doença hereditária (suspeitada) do feto
O35.3 Assistência prestada à mãe por lesão fetal (suspeitada) causada por doença viral materna
O35.4 Assistência prestada à mãe por lesão (suspeitada) causada ao feto por alcoolismo materno
O35.5 Assistência prestada à mãe por lesão fetal (suspeitada) causada por drogas
O35.6 Assistência prestada à mãe por lesão fetal (suspeitada) causada por radiação
O35.7 Assistência prestada à mãe por lesão fetal (suspeitada) causada por outros procedimentos
médicos
O35.8 Assistência prestada à mãe por outras anormalidades ou lesões fetais (suspeitadas)
O35.9 Assistência prestada à mãe por lesão ou anormalidade fetais (suspeitadas), não especificadas
O36.0 Assistência prestada à mãe por isoimunização Rh
O36.1 Assistência prestada à mãe por outros tipos de isoimunização
O36.2 Assistência prestada à mãe por hidropsia fetal
O36.3 Assistência prestada à mãe por sinais de hipóxia fetal
O36.4 Assistência prestada à mãe por morte intra­uterina
O36.5 Assistência prestada à mãe por insuficiência de crescimento fetal
O36.6 Assistência prestada à mãe por crescimento fetal excessivo
O36.7 Assistência prestada à mãe por feto viável em gravidez abdominal
O36.8 Assistência prestada à mãe por outros problemas fetais especificados
O36.9 Assistência prestada à mãe por problema fetal não especificado
O40 Polihidrâmnio
O41.0 Oligohidrâmnio
O41.1 Infecção do saco amniótico e das membranas
O41.8 Outros transtornos especificados do líquido amniótico e das membranas
O41.9 Transtornos do líquido amniótico e das membranas não especificados
O42.0 Ruptura prematura de membranas, com início do trabalho de parto dentro de 24 horas
O42.1 Ruptura prematura de membranas, com início do trabalho de parto depois das primeiras 24
horas
O42.2 Ruptura prematura de membranas, com trabalho de parto retardado por terapêutica
O42.9 Ruptura prematura de membranas, não especificada
O43.0 Síndromes de transfusão placentária
O43.1 Malformação da placenta
O43.8 Outros transtornos da placenta
O43.9 Transtorno da placenta, não especificado
O44.0 Placenta prévia especificada como sem hemorragia
O44.1 Placenta prévia com hemorragia
O45.0 Descolamento prematuro da placenta com deficiência de coagulação
O45.8 Outro descolamento prematuro da placenta
O45.9 Descolamento prematuro da placenta, não especificado
O46.0 Hemorragia anteparto com deficiência de coagulação
O46.8 Outra forma de hemorragia anteparto
O46.9 Hemorragia anteparto, não especificada
O47.0 Falso trabalho de parto antes de se completarem 37 semanas de gestação
O47.1 Falso trabalho de parto na 37ª semana completa ou depois dela
O47.9 Falso trabalho de parto, não especificado
O48 Gravidez prolongada
O60 Parto pré­termo
O61.0 Falha na indução médica do trabalho de parto
O61.1 Falha na indução instrumental do trabalho de parto
O61.8 Outras formas de falha na indução do trabalho de parto
O61.9 Falha na indução do trabalho de parto, não especificada
O62.0 Contrações iniciais inadequadas
O62.1 Inércia uterina secundária
O62.2 Outras formas de inércia uterina
O62.3 Trabalho de parto precipitado
O62.4 Contrações uterinas hipertônicas, incoordenadas ou prolongadas
O62.8 Outras anormalidades da contração uterina
O62.9 Anormalidades da contração uterina, não especificadas
O63.0 Prolongamento do primeiro período (dilatação)
O63.1 Prolongamento do segundo período (expulsão)
O63.2 Parto retardado do segundo gêmeo, do terceiro gêmeo etc
O63.9 Trabalho de parto prolongado, não especificado
O64.0 Obstrução do trabalho de parto devida à rotação incompleta do polo cefálico fetal
O64.1 Obstrução do trabalho de parto devida à apresentação pélvica
O64.2 Obstrução do trabalho de parto devida à apresentação de face
O64.3 Obstrução do trabalho de parto devida à apresentação de fronte
O64.4 Obstrução do trabalho de parto devida à apresentação de ombro
O64.5 Obstrução do trabalho de parto devida à apresentação complexa
O64.8 Obstrução do trabalho de parto devida a outras formas de má­apresentação e má­posição
O64.9 Obstrução do trabalho de parto devida a má­posição ou má­apresentação, não especificadas
O65.0 Obstrução do trabalho de parto devida a deformidade pélvica
O65.1 Obstrução do trabalho de parto devida à contração geral da pelve
O65.2 Obstrução do trabalho de parto devida à contração do estreito superior
O65.3 Obstrução do trabalho de parto devida à contração do estreito inferior ou da cavidade mediana
O65.4 Obstrução do trabalho de parto devida a desproporção feto­pélvica, não especificada
O65.5 Obstrução do trabalho de parto devida a anormalidade dos órgãos pélvicos maternos
O65.8 Obstrução do trabalho de parto devida a outras anormalidades pélvicas maternas
O65.9 Obstrução do trabalho de parto devida a anormalidades pélvicas maternas não especificadas
O66.0 Obstrução do trabalho de parto devido a distócia de ombro
O66.1 Obstrução do trabalho de parto por colisão de gêmeos
O66.2 Obstrução do trabalho de parto por feto excepcionalmente grande
O66.3 Obstrução do trabalho de parto devido a outras anormalidades do feto
O66.4 Falha de tentativa de trabalho de parto, não especificada
O66.5 Falha de aplicação de fórceps e vácuo­extrator, não especificada
O66.8 Outras formas de obstrução do trabalho de parto, especificadas
O66.9 Obstrução do trabalho de parto, não especificado
O67.0 Hemorragia intraparto com deficiência de coagulação
O67.8 Outras hemorragias intraparto
O67.9 Hemorragia intraparto não especificada
O68.0 Trabalho de parto e parto complicados por anormalidade da freqüência cardíaca fetal
O68.1 Trabalho de parto e parto complicados por mecônio no líquido amniótico
O68.2 Trabalho de parto e parto complicados por anormalidade na freqüência cardíaca fetal com
mecônio no líquido amniótico
O68.3 Trabalho de parto e parto complicados por evidências bioquímicas de sofrimento fetal
O68.8 Trabalho de parto e parto complicados por outras evidências de sofrimento fetal
O68.9 Trabalho de parto e parto complicados por sofrimento fetal, não especificado
O69.0 Trabalho de parto e parto complicados por prolapso do cordão
O69.1 Trabalho de parto e parto complicados por circular de cordão, com compressão
O69.2 Trabalho de parto e parto complicados por outros enovelamentos do cordão
O69.3 Trabalho de parto e parto complicados por cordão curto
O69.4 Trabalho de parto e parto complicados por vasa praevia
O69.5 Trabalho de parto e parto complicados por lesão vascular do cordão
O69.8 Trabalho de parto e parto complicados por outras complicações do cordão
O69.9 Trabalho de parto e parto complicados por complicações do cordão, não especificadas
O70.0 Laceração de períneo de primeiro grau durante o parto
O70.1 Laceração de períneo de segundo grau durante o parto
O70.2 Laceração de períneo de terceiro grau durante o parto
O70.3 Laceração de períneo de quarto grau durante o parto
O70.9 Laceração de períneo durante o parto, não especificada
O71.0 Ruptura do útero antes do início do trabalho de parto
O71.1 Ruptura do útero durante o trabalho de parto
O71.2 Inversão do útero pós­parto
O71.3 Laceração obstétrica do colo do útero
O71.4 Laceração vaginal alta isolada, de origem obstétrica
O71.5 Outras lesões obstétricas aos órgãos pélvicos
O71.6 Lesão obstétrica das articulações e dos ligamentos pélvicos
O71.7 Hematoma obstétrico da pelve
O71.8 Outros traumatismos obstétricos especificados
O71.9 Traumatismo obstétrico, não especificado
O72.0 Hemorragia do terceiro estágio
O72.1 Outras hemorragias do pós­parto imediato
O72.2 Hemorragias pós­parto, tardias e secundárias
O72.3 Deficiências de coagulação pós­parto
O73.0 Retenção da placenta sem hemorragia
O73.1 Retenção de partes da placenta ou das membranas, sem hemorragia
O74.0 Pneumonite aspirativa devida a anestesia durante o trabalho de parto e o parto
O74.1 Outras complicações pulmonares devidas a anestesia durante o trabalho de parto e no parto
O74.2 Complicações cardíacas devidas a anestesia durante o trabalho de parto e no parto
O74.3 Complicações do sistema nervoso central devidas a anestesia durante o trabalho de parto e no
parto
O74.4 Reação tóxica a anestesia local durante trabalho de parto e o parto
O74.5 Cefaléia pós­anestesia raquidiana e peridural, durante o trabalho de parto e parto
O74.6 Outras complicações de anestesia raquidiana ou peridural, durante o trabalho de parto e parto
O74.7 Falha ou dificuldade de entubação durante o trabalho de parto e parto
O74.8 Outras complicações de anestesia durante o trabalho de parto e parto
O74.9 Complicações de anestesia durante o trabalho de parto e parto, não especificadas
O75.0 Sofrimento materno durante o trabalho de parto e o parto
O75.1 Choque durante ou subseqüente ao trabalho de parto e o parto
O75.2 Febre durante o trabalho de parto não classificada em outra parte
O75.3 Outras infecções durante o trabalho de parto
O75.4 Outras complicações de procedimentos ou de cirurgia obstétrica
O75.5 Demora do parto após ruptura artificial das membranas
O75.6 Demora do parto após ruptura espontânea ou não especificada das membranas
O75.7 Parto vaginal subseqüente a cesariana anterior
O75.8 Outras complicações especificadas do trabalho de parto e do parto
O75.9 Complicações do trabalho de parto e do parto, não especificadas
O80.0 Parto espontâneo cefálico
O80.1 Parto espontâneo pélvico
O80.8 Outros tipos de parto único espontâneo
O80.9 Parto único espontâneo, não especificado
O81.0 Parto por fórceps baixo
O81.1 Parto por fórceps da cavidade mediana
O81.2 Fórceps da cavidade mediana com rotação
O81.3 Outros tipos de parto por fórceps e os não especificados
O81.4 Parto por vácuo­extrator
O81.5 Parto por combinação de fórceps e vácuo­extrator
O82.0 Parto por cesariana eletiva
O82.1 Parto por cesariana de emergência
O82.2 Parto por cesariana para histerectomia
O82.8 Outros tipos de parto único por cesariana
O82.9 Parto por cesariana, não especificada
O83.0 Extração pélvica
O83.1 Outros tipos de parto pélvico assistido
O83.2 Outras formas de parto com o auxílio de manipulação
O83.3 Parto de gravidez intra­abdominal com feto viável
O83.4 Cirurgia destrutiva para facilitar o parto
O83.8 Outros tipos especificados de parto único assistido
O83.9 Parto único assistido, não especificado
O84.0 Parto múltiplo, todos espontâneos
O84.1 Parto múltiplo, todos por fórceps ou vácuo­extrator
O84.2 Parto múltiplo, todos por cesariana
O84.8 Outro tipo de parto múltiplo
O84.9 Parto múltiplo, não especificado
O85 Infecção puerperal
O86.0 Infecção da incisão cirúrgica de origem obstétrica
O86.1 Outras infecções dos órgãos genitais subseqüentes ao parto
O86.2 Infecção das vias urinárias subseqüentes ao parto
O86.3 Outras infecções das vias genitourinárias subseqüentes ao parto
O86.4 Febre de origem desconhecida subseqüente ao parto
O86.8 Outras infecções puerperais especificadas
O87.0 Tromboflebite superficial no puerpério
O87.1 Tromboflebite profunda no puerpério
O87.2 Hemorróidas no puerpério
O87.3 Trombose venosa cerebral no puerpério
O87.8 Outras complicações venosas no puerpério
O87.9 Complicações venosas no puerpério, não especificadas
O88.0 Embolia gasosa de origem obstétrica
O88.1 Embolia amniótica
O88.2 Embolia obstétrica por coágulo de sangue
O88.3 Embolia séptica ou piêmica de origem obstétrica
O88.8 Outras embolias de origem obstétrica
O89.0 Complicações pulmonares da anestesia durante o puerpério
O89.1 Complicações cardíacas devidas a anestesia durante o puerpério
O89.2 Complicações relativas ao sistema nervoso central devidas a anestesia durante o puerpério
O89.3 Reação tóxica a uma anestesia local durante o puerpério
O89.4 Cefaléia provocada por uma anestesia raquidiana ou peridural, durante o puerpério
O89.5 Outras complicações de anestesia raquidiana ou peridural, durante o puerpério
O89.6 Falha na ou dificuldade de entubação, durante o puerpério
O89.8 Outras complicações da anestesia durante o puerpério
O89.9 Complicação devida a anestesia, durante o puerpério, não especificada
O90.0 Ruptura da incisão de cesariana
O90.1 Ruptura da incisão obstétrica, no períneo
O90.2 Hematoma da incisão obstétrica
O90.3 Cardiomiopatia no puerpério
O90.4 Insuficiência renal aguda do pós­parto
O90.5 Tireoidite do pós­parto
O90.8 Outras complicações do puerpério, não classificadas em outra parte
O90.9 Complicação do puerpério não especificada
O91.0 Infecção do mamilo associada ao parto
O91.1 Abscesso da mama associada ao parto
O91.2 Mastite não purulenta associada ao parto
O92.0 Mamilo retraído associado ao parto
O92.1 Fissuras do mamilo associadas ao parto
O92.2 Outras afecções da mama, e as não especificadas, associadas ao parto
O92.3 Agalactia
O92.4 Hipogalactia
O92.5 Suspensão da lactação
O92.6 Galactorréia
O92.7 Outros distúrbios da lactação e os não especificados
O95 Morte obstétrica de causa não especificada
O96 Morte, por qualquer causa obstétrica, que ocorre mais de 42 dias, mas menos de 1 ano, após o
parto
O97 Morte por seqüelas de causas obstétricas diretas
O98.0 Tuberculose complicando a gravidez, o parto e o puerpério
O98.1 Sífilis complicando a gravidez, o parto e o puerpério
O98.2 Gonorréia complicando a gravidez, o parto e o puerpério
O98.3 Outras infecções em que a via de transmissão é predominantemente sexual, complicando a
gravidez, o parto e o puerpério
O98.4 Hepatite viral complicando a gravidez, o parto e o puerpério
O98.5 Outras doenças virais complicando a gravidez, o parto e o puerpério
O98.6 Doenças causadas por protozoários complicando a gravidez, o parto e o puerpério
O98.8 Outras doenças infecciosas e parasitárias maternas complicando a gravidez, o parto e o
puerpério
O98.9 Doenças infecciosas e parasitárias maternas, não especificadas, complicando a gravidez, o
parto e o puerpério
O99.0 Anemia complicando a gravidez, o parto e o puerpério
O99.1 Outras doenças do sangue e dos órgãos hematopoéticos e alguns transtornos que
comprometem o sistema imunológico, complicando a gravidez, o parto e o puerpério
O99.2 Doenças endócrinas, nutricionais e metabólicas complicando a gravidez, o parto e o puerpério
O99.3 Transtornos mentais e doenças do sistema nervoso complicando a gravidez, o parto e o
puerpério
O99.4 Doenças do aparelho circulatório complicando a gravidez, o parto e o puerpério
O99.5 Doenças do aparelho respiratório complicando a gravidez, o parto e o puerpério
O99.6 Doenças do aparelho digestivo complicando a gravidez, o parto e o puerpério
O99.7 Doenças da pele e do tecido subcutâneo complicando a gravidez, o parto e o puerpério
O99.8 Outras doenças e afecções especificadas complicando a gravidez, o parto e o puerpério
P00.0 Feto e recém­nascido afetados por transtornos maternos hipertensivos
P00.1 Feto e recém­nascido afetados por doenças maternas renais e das vias urinárias
P00.2 Feto e recém­nascido afetados por doenças infecciosas e parasitárias da mãe
P00.3 Feto e recém­nascido afetados por outras doenças circulatórias e respiratórias maternas
P00.4 Feto e recém­nascido afetados por transtornos nutricionais maternos
P00.5 Feto e recém­nascido afetados por traumatismo materno
P00.6 Feto e recém­nascido afetados por intervenção cirúrgica na mãe
P00.7 Feto e recém­nascido afetados por outros procedimentos médicos na mãe, não classificados em
outra parte
P00.8 Feto e recém­nascido afetados por outras afecções maternas
P00.9 Feto e recém­nascido afetados por afecção materna não especificada
P01.0 Feto e recém­nascido afetados por incompetência do colo uterino
P01.1 Feto e recém­nascido afetados por ruptura prematura das membranas
P01.2 Feto e recém­nascido afetados por oligohidrâmnio
P01.3 Feto e recém­nascido afetados por polihidrâmnio
P01.4 Feto e recém­nascido afetados por gravidez ectópica
P01.5 Feto e recém­nascido afetados por gravidez múltipla
P01.6 Feto e recém­nascido afetados por morte materna
P01.7 Feto e recém­nascido afetados por apresentação anormal antes do trabalho de parto
P01.8 Feto e recém­nascido afetados por outras complicações maternas da gravidez
P01.9 Feto e recém­nascido afetados por afecções maternas da gravidez, não especificadas
P02.0 Feto e recém­nascido afetados por placenta prévia
P02.1 Feto e recém­nascido afetados por outras formas de descolamento da placenta e hemorragia
P02.2 Feto e recém­nascido afetados por outras anormalidades morfológicas e funcionais da placenta
e as não especificadas
P02.3 Feto e recém­nascido afetados por síndromes de transfusão placentária
P02.4 Feto e recém­nascido afetados por prolapso de cordão umbilical
P02.5 Feto e recém­nascido afetados por outras compressões do cordão umbilical
P02.6 Feto e recém­nascido afetados por outras afecções do cordão umbilical e as não especificadas
P02.7 Feto e recém­nascido afetados por corioamnionite
P02.8 Feto e recém­nascido afetados por outras anormalidades das membranas
P02.9 Feto e recém­nascido afetados por anormalidade não especificada das membranas
P03.0 Feto e recém­nascido afetados por parto e extração pélvicas
P03.1 Feto e recém­nascido afetados por outras apresentações anormais, má­posições e
desproporções durante o trabalho de parto e o parto
P03.2 Feto e recém­nascido afetados por parto por fórceps
P03.3 Feto e recém­nascido afetados por parto por vácuo­extrator [ventosa]
P03.4 Feto e recém­nascido afetados por parto por cesariana
P03.5 Feto e recém­nascido afetados por parto precipitado
P03.6 Feto e recém­nascido afetados por contrações uterinas anormais
P03.8 Feto e recém­nascido afetados por outras complicações especificadas do trabalho de parto e do
parto
P03.9 Feto e recém­nascido afetados por complicações não especificadas do trabalho de parto e do
parto
P04.0 Feto e recém­nascido afetados por anestesia e analgesia materna durante a gravidez, trabalho
de parto e parto
P04.1 Feto e recém­nascido afetados por outros medicamentos utilizados pela mãe
P04.2 Feto e recém­nascido afetados pelo uso de fumo pela mãe
P04.3 Feto e recém­nascido afetados pelo uso de álcool pela mãe
P04.4 Feto e recém­nascido afetados pelo uso de drogas que causam dependência pela mãe
P04.5 Feto e recém­nascido afetados por uso materno de substâncias químicas dos alimentos
P04.6 Feto e recém­nascido afetados pela exposição da mãe a substâncias químicas do meio
ambiente
P04.8 Feto e recém­nascido afetados por outras influências nocivas maternas
P04.9 Feto e recém­nascido afetados por influências nocivas maternas não especificadas
P05.0 Recém­nascido de baixo peso para a idade gestacional
P05.1 Pequeno para a idade gestacional
P05.2 Desnutrição fetal sem menção de peso e comprimento baixos para a idade gestacional
P05.9 Retardo não especificado do crescimento fetal
P07.0 Recém­nascido com peso muito baixo
P07.1 Outros recém­nascidos de peso baixo
P07.2 Imaturidade extrema
P07.3 Outros recém­nascidos de pré­termo
P08.0 Recém­nascido de tamanho excessivamente grande
P08.1 Outros recém­nascidos grandes para a idade gestacional
P08.2 Recém­nascido pós­termo, não­grande para a idade gestacional
P10.0 Hemorragia subdural devida a traumatismo de parto
P10.1 Hemorragia cerebral devida a traumatismo de parto
P10.2 Hemorragia intraventricular devida a traumatismo de parto
P10.3 Hemorragia subaracnoídea devida a traumatismo de parto
P10.4 Ruptura tentorial devida a traumatismo de parto
P10.8 Outras lacerações e hemorragias intracranianas devidas a traumatismo de parto
P10.9 Laceração e hemorragia intracranianas não especificadas devidas a traumatismo de parto
P11.0 Edema cerebral devido a traumatismo de parto
P11.1 Outras lesões cerebrais especificadas devidas a traumatismo de parto
P11.2 Lesão cerebral não especificada devida a traumatismo de parto
P11.3 Traumatismo de parto do nervo facial
P11.4 Traumatismo de parto de outros nervos cranianos
P11.5 Traumatismo de parto da coluna e da medula espinhal
P11.9 Traumatismo de parto não especificado do sistema nervoso central
P12.0 Céfalo­hematoma devido a traumatismo de parto
P12.1 "Chignon" devido a traumatismo de parto
P12.2 Hemorragia subaponeurótica epicraniana devida a traumatismo de parto
P12.3 Esmagamento do couro cabeludo devido a traumatismo de parto
P12.4 Lesão por monitorização do couro cabeludo do recém­nascido
P12.8 Outras lesões do couro cabeludo devidas a traumatismo de parto
P12.9 Lesão não especificada do couro cabeludo devida a traumatismo de parto
P13.0 Fratura de crânio devida a traumatismo de parto
P13.1 Outras lesões cranianas devidas a traumatismo de parto
P13.2 Lesão do fêmur devida a traumatismo de parto
P13.3 Lesão de outros ossos longos devida a traumatismo de parto
P13.4 Fratura da clavícula devida a traumatismo de parto
P13.8 Lesões de outras partes do esqueleto devidas a traumatismo de parto
P13.9 Lesões não especificadas do esqueleto devidas a traumatismo de parto
P14.0 Paralisia de Erb devida a traumatismo de parto
P14.1 Paralisia de Klumpke devida a traumatismo de parto
P14.2 Paralisia do nervo frênico devida a traumatismo de parto
P14.3 Outras lesões do plexo braquial devidas a traumatismo de parto
P14.8 Outras lesões de outras partes do sistema nervoso periférico devidas a traumatismo de parto
P14.9 Lesão não especificada do sistema nervoso periférico devida a traumatismo de parto
P15.0 Lesão do fígado devida a traumatismo de parto
P15.1 Lesão do baço devida a traumatismo de parto
P15.2 Lesão do esternomastóide devida a traumatismo de parto
P15.3 Lesão dos olhos devida a traumatismo de parto
P15.4 Lesão da face ao nascer
P15.5 Lesão dos órgãos genitais externos, devida a traumatismo de parto
P15.6 Necrose de gordura subcutânea devida a traumatismo de parto
P15.8 Outros traumatismos de parto especificados
P15.9 Traumatismo de parto não especificado
P20.0 Hipóxia intra­uterina diagnosticada antes do início do trabalho de parto
P20.1 Hipóxia intra­uterina diagnosticada durante o trabalho de parto e o parto
P20.9 Hipóxia intra­uterina não especificada
P21.0 Asfixia grave ao nascer
P21.1 Asfixia leve ou moderada ao nascer
P21.9 Asfixia ao nascer, não especificada
P22.0 Síndrome da angústia respiratória do recém­nascido
P22.1 Taquipnéia transitória do recém­nascido
P22.8 Outros desconfortos respiratórios do recém­nascido
P22.9 Desconforto respiratório não especificado do recém­nascido
P23.0 Pneumonia congênita devida a agente viral
P23.1 Pneumonia congênita devida a Clamídia
P23.2 Pneumonia congênita devida a estafilococo
P23.3 Pneumonia congênita devida a estreptococo do grupo B
P23.4 Pneumonia congênita devida a Escherichia coli
P23.5 Pneumonia congênita devida a Pseudomonas
P23.6 Pneumonia congênita devida a outros agentes bacterianos
P23.8 Pneumonia congênita devida a outros organismos
P23.9 Pneumonia congênita não especificada
P24.0 Aspiração neonatal de mecônio
P24.1 Aspiração neonatal de líquido amniótico e muco
P24.2 Aspiração neonatal de sangue
P24.3 Aspiração neonatal de leite e alimento regurgitados
P24.8 Outras síndromes de aspiração neonatais
P24.9 Síndrome de aspiração neonatal não especificada
P25.0 Enfisema intersticial originado no período perinatal
P25.1 Pneumotórax originado no período perinatal
P25.2 Pneumomediastino originado no período perinatal
P25.3 Pneumopericárdio originado no período perinatal
P25.8 Outras afecções relacionadas com o enfisema intersticial originadas no período perinatal
P26.0 Hemorragia traqueobrônquica originada no período perinatal
P26.1 Hemorragia pulmonar maciça originada no período perinatal
P26.8 Outras hemorragias pulmonares originadas no período perinatal
P26.9 Hemorragia pulmonar não especificada originada no período perinatal
P27.0 Síndrome de Wilson­Mikity
P27.1 Displasia broncopulmonar originada no período perinatal
P27.8 Outras doenças respiratórias crônicas originadas no período perinatal
P27.9 Doença respiratória crônica não especificada originada no período perinatal
P28.0 Atelectasia primária do recém­nascido
P28.1 Outras atelectasias do recém­nascido e as não especificadas
P28.2 Crises cianóticas do recém­nascido
P28.3 Apnéia primária do sono do recém­nascido
P28.4 Outras apnéias do recém­nascido
P28.5 Insuficiência respiratória do recém­nascido
P28.8 Outras afecções respiratórias especificadas do recém­nascido
P28.9 Afecção respiratória do recém­nascido, não especificada
P29.0 Insuficiência cardíaca neonatal
P29.1 Disritmia cardíaca neonatal
P29.2 Hipertensão neonatal
P29.3 Persistência da circulação fetal
P29.4 Isquemia miocárdica transitória do recém­nascido
P29.8 Outros transtornos cardiovasculares originados no período perinatal
P29.9 Transtornos cardiovasculares não especificados originados no período perinatal
P35.0 Síndrome da rubéola congênita
P35.1 Infecção congênita por citomegalovirus
P35.2 Infecção congênita por vírus do herpes [simples]
P35.3 Hepatite viral congênita
P35.8 Outras doenças virais congênitas
P35.9 Doença viral congênita não especificada
P36.0 Septicemia do recém­nascido devida a estreptococo do grupo B
P36.1 Septicemia do recém­nascido devida a outros estreptococos e aos não especificados
P36.2 Septicemia do recém­nascido devida ao Stafilococcus aureus
P36.3 Septicemia do recém­nascido devida a outros estafilococos e aos não especificados
P36.4 Septicemia do recém­nascido devida a Escherichia coli
P36.5 Septicemia do recém­nascido devida a anaeróbios
P36.8 Outras septicemias bacterianas do recém­nascido
P36.9 Septicemia bacteriana não especificada do recém­nascido
P37.0 Tuberculose congênita
P37.1 Toxoplasmose congênita
P37.2 Listeriose neonatal (disseminada)
P37.3 Malária falciparum congênita
P37.4 Outras malárias congênitas
P37.5 Candidíase neonatal
P37.8 Outras doenças infecciosas e parasitárias congênitas especificadas
P37.9 Doença infecciosa ou parasitária congênita não especificada
P38 Onfalite do recém­nascido com ou sem hemorragia leve
P39.0 Mastite infecciosa neonatal
P39.1 Conjuntivite e dacriocistite neonatais
P39.2 Infecção intra­amniótica do feto não classificada em outra parte
P39.3 Infecção neonatal do trato urinário
P39.4 Infecção neonatal da pele
P39.8 Outras infecções especificadas próprias do período perinatal
P39.9 Infecção própria do período perinatal não especificada
P50.0 Perda sangüínea fetal devida a vasa prévia
P50.1 Perda sangüínea fetal por ruptura do cordão
P50.2 Perda sangüínea fetal originada da placenta
P50.3 Hemorragia para a circulação do outro gêmeo
P50.4 Hemorragia para a circulação materna
P50.5 Perda sangüínea devido a secção do cordão umbilical do outro gemelar
P50.8 Outras perdas sangüíneas fetais
P50.9 Perda sangüínea fetal não especificada
P51.0 Hemorragia umbilical maciça do recém­nascido
P51.8 Outras hemorragias umbilicais do recém­nascido
P51.9 Hemorragia umbilical do recém­nascido, não especificada
P52.0 Hemorragia intraventricular (não­traumática) grau 1, do feto e do recém­nascido
P52.1 Hemorragia intraventricular (não­traumática) grau 2, do feto e do recém­nascido
P52.2 Hemorragia intraventricular (não­traumática) grau 3, do feto e do recém­nascido
P52.3 Hemorragia intraventricular (não­traumática) não especificada, do feto ou do recém­nascido
P52.4 Hemorragia intracerebral (não­traumática) do feto e do recém­nascido
P52.5 Hemorragia subaracnoídea (não­traumática) do feto e do recém­nascido
P52.6 Hemorragia cerebelar (não­traumática) e da fossa posterior do feto ou recém­nascido
P52.8 Outras hemorragias intracranianas (não­traumáticas) do feto e do recém­nascido
P52.9 Hemorragia intracraniana (não­traumática) do feto e do recém­nascido, não especificada
P53 Doença hemorrágica do feto e do recém­nascido
P54.0 Hematêmese neonatal
P54.1 Melena neonatal
P54.2 Hemorragia retal neonatal
P54.3 Outras hemorragias gastrointestinais do período neonatal
P54.4 Hemorragia supra­renal neonatal
P54.5 Hemorragia cutânea neonatal
P54.6 Hemorragia vaginal neonatal
P54.8 Outras hemorragias fetais e neonatais especificadas
P54.9 Hemorragia fetal e neonatal não especificada
P55.0 Isoimunização Rh do feto e do recém­nascido
P55.1 Isoimunização ABO do feto e do recém­nascido
P55.8 Outras doenças hemolíticas do feto e do recém­nascido
P55.9 Doença hemolítica não especificada do feto e do recém­nascido
P56.0 Hidropsia fetal devida à isoimunização
P56.9 Hidropsia fetal devida a outras doenças hemolíticas e às não especificadas
P57.0 Kernicterus devido à isoimunização
P57.8 Outros kernicterus especificados
P57.9 Kernicterus não especificado
P58.0 Icterícia neonatal devida a contusões
P58.1 Icterícia neonatal devida a sangramento
P58.2 Icterícia neonatal devida a infecção
P58.3 Icterícia neonatal devida a policitemia
P58.4 Icterícia neonatal devida a drogas ou toxinas transmitidas pela mãe ou administradas ao recémnascido
P58.5 Icterícia neonatal devida à deglutação de sangue materno
P58.8 Icterícia neonatal devida a outras hemólises excessivas especificadas
P58.9 Icterícia neonatal devida a hemólise excessiva não especificada
P59.0 Icterícia neonatal associada ao parto prematuro
P59.1 Síndrome da bile espessa
P59.2 Icterícia neonatal de outras lesões hepatocelulares e das não especificadas
P59.3 Icterícia neonatal devida a inibidores do leite materno
P59.8 Icterícia neonatal devida a outras causas especificadas
P59.9 Icterícia neonatal não especificada
P60 Coagulação intravascular disseminada do feto e do recém­nascido
P61.0 Trombocitopenia transitória neonatal
P61.1 Policitemia neonatal
P61.2 Anemia da prematuridade
P61.3 Anemia congênita por perda sangüínea fetal
P61.4 Outras anemias congênitas não classificada em outra parte
P61.5 Neutropenia transitória neonatal
P61.6 Outros transtornos transitórios de coagulação do período neonatal
P61.8 Outros transtornos hematológicos perinatais especificados
P61.9 Transtorno hematológico perinatal não especificado
P70.0 Síndrome do filho de mãe com diabetes gestacional
P70.1 Síndrome do filho de mãe diabética
P70.2 Diabetes mellitus neonatal
P70.3 Hipoglicemia neonatal iatrogênica
P70.4 Outras hipoglicemias neonatais
P70.8 Outros transtornos transitórios do metabolismo dos carboidratos do feto e do recém­nascido
P70.9 Transtorno transitório não especificado do metabolismo dos carboidratos do feto e do recémnascido
P71.0 Hipocalcemia do recém­nascido pelo uso de leite de vaca
P71.1 Outras hipocalcemias neonatais
P71.2 Hipomagnesemia neonatal
P71.3 Tetania neonatal sem deficiência de cálcio ou magnésio
P71.4 Hipoparatiroidismo neonatal transitório
P71.8 Outros transtornos transitórios do metabolismo do cálcio e do magnésio do período neonatal
P71.9 Transtornos transitórios não especificados do metabolismo do cálcio e do magnésio do período
neonatal
P72.0 Bócio neonatal, não classificado em outra parte
P72.1 Hipotireoidismo neonatal transitório
P72.2 Outros transtornos transitórios da função de tireóide não classificados em outra parte
P72.8 Outros transtornos endócrinos transitórios e especificados do período neonatal
P72.9 Transtorno endócrino neonatal transitório não especificado
P74.0 Acidose metabólica tardia do recém­nascido
P74.1 Desidratação do recém­nascido
P74.2 Distúrbios do equilíbrio de sódio do recém­nascido
P74.3 Distúrbios do equilíbrio de potássio do recém­nascido
P74.4 Outros distúrbios eletrolíticos transitórios do recém­nascido
P74.5 Tirosinemia transitória do recém­nascido
P74.8 Outros distúrbios metabólicos transitórios do recém­nascido
P74.9 Distúrbio metabólico transitório não especificado do recém­nascido
P75 *Íleo meconial (E84.1+)
P76.0 Síndrome da "rolha de mecônio"
P76.1 Íleo transitório do recém­nascido
P76.2 Obstrução intestinal devido a leite espesso
P76.8 Outras obstruções intestinais especificadas do recém­nascido
P76.9 Obstrução intestinal não especificada do recém­nascido
P77 Enterocolite necrotizante do feto e do recém­nascido
P78.0 Perfuração intestinal no período perinatal
P78.1 Outras peritonites neonatais
P78.2 Hematemese e melena devidas a deglutição de sangue materno
P78.3 Diarréia neonatal não­infecciosa
P78.8 Outros transtornos perinatais especificados do aparelho digestivo
P78.9 Transtorno perinatal não especificado do aparelho digestivo
P80.0 Síndrome de lesão pelo frio
P80.8 Outras hipotermias do recém­nascido
P80.9 Hipotermia não especificada do recém­nascido
P81.0 Hipertermia ambiental do recém­nascido
P81.8 Outros distúrbios especificados da regulação térmica do recém­nascido
P81.9 Distúrbio não especificado da regulação térmica do recém­nascido
P83.0 Esclerema neonatal
P83.1 Eritema tóxico neonatal
P83.2 Hidropsia fetal não­devida à doença hemolítica
P83.3 Outros edemas e os não especificados próprios do feto e do recém­nascido
P83.4 Intumescimento mamário do recém­nascido
P83.5 Hidrocele congênita
P83.6 Pólipo umbilical do recém­nascido
P83.8 Outras afecções especificadas do tegumento próprias do feto e do recém­nascido
P83.9 Afecção não especificada do tegumento própria do feto e do recém­nascido
P90 Convulsões do recém­nascido
P91.0 Isquemia cerebral neonatal
P91.1 Cistos periventriculares adquiridos do recém­nascido
P91.2 Leucomalácia cerebral neonatal
P91.3 Irritabilidade cerebral neonatal
P91.4 Depressão cerebral neonatal
P91.5 Coma neonatal
P91.8 Outros distúrbios especificados da função cerebral do recém­nascido
P91.9 Distúrbio não especificado da função cerebral do recém­nascido
P92.0 Vômitos no recém­nascido
P92.1 Regurgitação e ruminação no recém­nascido
P92.2 Alimentação vagarosa do recém­nascido
P92.3 Subalimentação do recém­nascido
P92.4 Hiperalimentação do recém­nascido
P92.5 Dificuldade neonatal na amamentação no peito
P92.8 Outros problemas de alimentação do recém­nascido
P92.9 Problema não especificado de alimentação do recém­nascido
P93 Reações e intoxicações devidas a drogas administradas ao feto e ao recém­nascido
P94.0 Miastenia grave neonatal transitória
P94.1 Hipertonia congênita
P94.2 Hipotonia congênita
P94.8 Outros transtornos do tônus muscular do recém­nascido
P94.9 Transtorno não especificado do tônus muscular do recém­nascido
P95 Morte fetal de causa não especificada
P96.0 Insuficiência renal congênita
P96.1 Sintomas de abstinência neonatal de drogas utilizadas pela mãe
P96.2 Sintomas de abstinência do uso de drogas terapêuticas no recém­nascido
P96.3 Suturas cranianas amplas no recém­nascido
P96.4 Interrupção de gravidez, afetando o feto e recém­nascido
P96.5 Complicações de procedimentos intra­uterinos não classificados em outra parte
P96.8 Outras afecções especificadas originadas no período perinatal
P96.9 Afecções originadas no período perinatal não especificadas
Q00.0 Anencefalia
Q00.1 Craniorraquisquise
Q00.2 Iniencefalia
Q01.0 Encefalocele frontal
Q01.1 Encefalocele nasofrontal
Q01.2 Encefalocele occipital
Q01.8 Encefalocele de outras localizações
Q01.9 Encefalocele não especificada
Q02 Microcefalia
Q03.0 Malformações do aqueduto de Sylvius
Q03.1 Atresia das fendas de Luschka e do forâmen de Magendie
Q03.8 Outra hidrocefalia congênita
Q03.9 Hidrocefalia congênita não especificada
Q04.0 Malformações congênitas do corpo caloso
Q04.1 Arrinencefalia
Q04.2 Holoprosencefalia
Q04.3 Outras deformidades por redução do encéfalo
Q04.4 Displasia do septo e das vias ópticas
Q04.5 Megalencefalia
Q04.6 Cistos cerebrais congênitos
Q04.8 Outras malformações congênitas especificadas do encéfalo
Q04.9 Malformação congênita não especificada do encéfalo
Q05.0 Espinha bífida cervical com hidrocefalia
Q05.1 Espinha bífida torácica com hidrocefalia
Q05.2 Espinha bífida lombar com hidrocefalia
Q05.3 Espinha bífida sacra com hidrocefalia
Q05.4 Espinha bífida não especificada, com hidrocefalia
Q05.5 Espinha bífida cervical, sem hidrocefalia
Q05.6 Espinha bífida torácica, sem hidrocefalia
Q05.7 Espinha bífida lombar, sem hidrocefalia
Q05.8 Espinha bífida sacra, sem hidrocefalia
Q05.9 Espinha bífida não especificada
Q06.0 Amielia
Q06.1 Hipoplasia e displasia da medula espinal
Q06.2 Diastematomielia
Q06.3 Outras malformações congênitas da cauda eqüina
Q06.4 Hidromielia
Q06.8 Outras malformações congênitas especificadas da medula espinal
Q06.9 Malformação congênita não especificada da medula espinal
Q07.0 Síndrome de Arnold­Chiari
Q07.8 Outras malformações congênitas especificadas do sistema nervoso
Q07.9 Malformação congênita não especificada do sistema nervoso
Q10.0 Ptose congênita
Q10.1 Ectrópio congênito
Q10.2 Entrópio congênito
Q10.3 Outras malformações congênitas das pálpebras
Q10.4 Ausência ou agenesia do aparelho lacrimal
Q10.5 Estenose ou estreitamento congênito do canal lacrimal
Q10.6 Outras malformações congênitas do aparelho lacrimal
Q10.7 Malformação congênita da órbita
Q11.0 Olho cístico
Q11.1 Outras formas de anoftalmia
Q11.2 Microftalmia
Q11.3 Macroftalmia
Q12.0 Catarata congênita
Q12.1 Luxação congênita do cristalino
Q12.2 Coloboma do cristalino
Q12.3 Afaquia congênita
Q12.4 Esferofaquia
Q12.8 Outras malformações congênitas do cristalino
Q12.9 Malformação congênita não especificada do cristalino
Q13.0 Coloboma da íris
Q13.1 Ausência de íris
Q13.2 Outras malformações congênitas da íris
Q13.3 Opacidade congênita da córnea
Q13.4 Outras malformações congênitas da córnea
Q13.5 Esclerótica azul
Q13.8 Outras malformações congênitas da câmara anterior do olho
Q13.9 Malformação congênita não especificada da câmara anterior do olho
Q14.0 Malformação congênita do humor vítreo
Q14.1 Malformação congênita da retina
Q14.2 Malformação congênita do disco óptico
Q14.3 Malformação congênita da coróide
Q14.8 Outras malformações congênitas da câmara posterior do olho
Q14.9 Malformação congênita não especificada da câmara posterior do olho
Q15.0 Glaucoma congênito
Q15.8 Outras malformações congênitas especificadas do olho
Q15.9 Malformação congênita não especificada do olho
Q16.0 Ausência congênita do pavilhão auricular [orelha]
Q16.1 Ausência, atresia e estreitamento congênitos do conduto auditivo (externo)
Q16.2 Ausência da trompa de Eustáquio
Q16.3 Malformação congênita dos ossículos do ouvido
Q16.4 Outras malformações congênitas do ouvido médio
Q16.5 Malformação congênita do ouvido interno
Q16.9 Malformação congênita do ouvido não especificada causando comprometimento da audição
Q17.0 Pavilhão supranumerário
Q17.1 Macrotia
Q17.2 Microtia
Q17.3 Outras deformidades da orelha
Q17.4 Anomalia de posição da orelha
Q17.5 Orelhas proeminentes
Q17.8 Outras malformações congênitas especificadas da orelha
Q17.9 Malformação congênita não especificada da orelha
Q18.0 Seio, fístula e cisto de origem branquial
Q18.1 Seio, fístula e cisto pré­auricular
Q18.2 Outras malformações da fenda branquial
Q18.3 Pescoço alado
Q18.4 Macrostomia
Q18.5 Microstomia
Q18.6 Macroqueilia
Q18.7 Microqueilia
Q18.8 Outras malformações congênitas especificadas da face e do pescoço
Q18.9 Malformação congênita não especificada da face e do pescoço
Q20.0 Tronco arterial comum
Q20.1 Ventrículo direito com dupla via de saída
Q20.2 Ventrículo esquerdo com dupla via de saída
Q20.3 Comunicação ventrículo­atrial discordante
Q20.4 Ventrículo com dupla via de entrada
Q20.5 Comunicação átrio­ventricular discordante
Q20.6 Isomerismo dos apêndices atriais
Q20.8 Outras malformações congênitas das câmaras e das comunicações cardíacas
Q20.9 Malformação congênita não especificada das câmaras e das comunicações cardíacas
Q21.0 Comunicação interventricular
Q21.1 Comunicação interatrial
Q21.2 Comunicação atrioventricular
Q21.3 Tetralogia de Fallot
Q21.4 Comunicação aortopulmonar
Q21.8 Outras malformações congênitas dos septos cardíacos
Q21.9 Malformação congênita não especificada de septo cardíaco
Q22.0 Atresia da valva pulmonar
Q22.1 Estenose congênita da valva pulmonar
Q22.2 Insuficiência congênita da valva pulmonar
Q22.3 Outras malformações congênitas da valva pulmonar
Q22.4 Estenose congênita da valva tricúspide
Q22.5 Anomalia de Ebstein
Q22.6 Síndrome do coração direito hipoplásico
Q22.8 Outras malformações congênitas da valva tricúspide
Q22.9 Malformação congênita não especificada da valva tricúspide
Q23.0 Estenose congênita da valva aórtica
Q23.1 Insuficiência congênita da valva aórtica
Q23.2 Estenose mitral congênita
Q23.3 Insuficiência mitral congênita
Q23.4 Síndrome do coração esquerdo hipoplásico
Q23.8 Outras malformações congênitas das valvas aórtica e mitral
Q23.9 Malformação congênita não especificada das valvas aórtica e mitral
Q24.0 Dextrocardia
Q24.1 Levocardia
Q24.2 Cor triatriatum
Q24.3 Estenose do infundíbulo pulmonar
Q24.4 Estenose subaórtica congênita
Q24.5 Malformações dos vasos coronários
Q24.6 Bloqueio congênito do coração
Q24.8 Outras malformações congênitas especificadas do coração
Q24.9 Malformação não especificada do coração
Q25.0 Permeabilidade do canal arterial
Q25.1 Coartação da aorta
Q25.2 Atresia da aorta
Q25.3 Estenose da aorta
Q25.4 Outras malformações congênitas da aorta
Q25.5 Atresia da artéria pulmonar
Q25.6 Estenose da artéria pulmonar
Q25.7 Outras malformações congênitas da artéria pulmonar
Q25.8 Outras malformações congênitas das grandes artérias
Q25.9 Malformação congênita não especificada das grandes artérias
Q26.0 Estenose congênita da veia cava
Q26.1 Persistência da veia cava superior esquerda
Q26.2 Comunicação venosa pulmonar anormal total
Q26.3 Comunicação venosa pulmonar anormal parcial
Q26.4 Comunicação venosa pulmonar anormal não especificado
Q26.5 Comunicação venosa portal anormal
Q26.6 Fístula entre a veia porta e a artéria hepática
Q26.8 Outras malformações congênitas das grandes veias
Q26.9 Malformação congênita não especificada de grande veia
Q27.0 Ausência congênita e hipoplasia da artéria umbilical
Q27.1 Estenose congênita da artéria renal
Q27.2 Outras malformações congênitas da artéria renal
Q27.3 Malformação artério­venosa periférica
Q27.4 Ectasia venosa (flebectasia) congênita
Q27.8 Outras malformações congênitas especificadas do sistema vascular periférico
Q27.9 Malformação congênita não especificada do sistema vascular periférico
Q28.0 Malformação arteriovenosa de vasos pré­cerebrais
Q28.1 Outras malformações dos vasos pré­cerebrais
Q28.2 Malformação arteriovenosa dos vasos cerebrais
Q28.3 Outras malformações dos vasos cerebrais
Q28.8 Outras malformações congênitas especificadas do aparelho circulatório
Q28.9 Malformação congênita não especificada do aparelho circulatório
Q30.0 Atresia das coanas
Q30.1 Agenesia ou hipoplasia do nariz
Q30.2 Fissura, entalhe ou fenda nasal
Q30.3 Perfuração congênita do septo nasal
Q30.8 Outras malformações congênitas do nariz
Q30.9 Malformação congênita não especificada do nariz
Q31.0 Pterígio da laringe
Q31.1 Estenose subglótica congênita
Q31.2 Hipoplasia da laringe
Q31.3 Laringocele
Q31.4 Estridor congênito da laringe
Q31.8 Outras malformações congênitas da laringe
Q31.9 Malformação congênita não especificada da laringe
Q32.0 Traqueomalácia congênita
Q32.1 Outras malformações congênitas da traquéia
Q32.2 Broncomalácia congênita
Q32.3 Estenose congênita dos brônquios
Q32.4 Outras malformações congênitas dos brônquios
Q33.0 Pulmão cístico congênito
Q33.1 Lobo pulmonar supranumerário
Q33.2 Seqüestro pulmonar
Q33.3 Agenesia do pulmão
Q33.4 Bronquectasia congênita
Q33.5 Tecido ectópico intrapulmonar
Q33.6 Hipoplasia e displasia do pulmão
Q33.8 Outras malformações congênitas do pulmão
Q33.9 Malformação congênita não especificada do pulmão
Q34.0 Anomalia da pleura
Q34.1 Cisto congênito do mediastino
Q34.8 Outras malformações congênitas especificadas do aparelho respiratório
Q34.9 Malformação congênita não especificada do aparelho respiratório
Q35.1 Fenda do pálato duro
Q35.3 Fenda do pálato mole
Q35.5 Fenda dos pálatos duro e mole
Q35.6 Fenda mediana do pálato
Q35.7 Fenda da úvula
Q35.9 Fenda palatina não especificada
Q36.0 Fenda labial bilateral
Q36.1 Fenda labial mediana
Q36.9 Fenda labial unilateral
Q37.0 Fenda do pálato duro com fenda labial bilateral
Q37.1 Fenda do pálato duro com fenda labial unilateral
Q37.2 Fenda do pálato mole com fenda labial bilateral
Q37.3 Fenda do pálato mole com fenda labial unilateral
Q37.4 Fenda dos pálatos duro e mole com fenda labial bilateral
Q37.5 Fenda dos pálatos duro e mole com fenda labial unilateral
Q37.8 Fenda do pálato com fenda labial bilateral, não especificada
Q37.9 Fenda do pálato com fenda labial unilateral, não especificada
Q38.0 Malformações congênitas dos lábios, não classificadas em outra parte
Q38.1 Anquiloglossia
Q38.2 Macroglossia
Q38.3 Outras malformações congênitas da língua
Q38.4 Malformações congênitas das glândulas e dutos salivares
Q38.5 Malformações congênitas do pálato não classificadas em outra parte
Q38.6 Outras malformações congênitas da boca
Q38.7 Bolsa faríngea
Q38.8 Outras malformações congênitas da faringe
Q39.0 Atresia de esôfago, sem fístula
Q39.1 Atresia de esôfago, com fístula traqueoesofágica
Q39.2 Fístula traqueoesofágica congênita, sem atresia
Q39.3 Estenose congênita e estreitamento congênito do esôfago
Q39.4 Pterígio do esôfago
Q39.5 Dilatação congênita do esôfago
Q39.6 Divertículo do esôfago
Q39.8 Outras malformações congênitas do esôfago
Q39.9 Malformação congênita não especificada do esôfago
Q40.0 Estenose hipertrófica congênita do piloro
Q40.1 Hérnia congênita de hiato
Q40.2 Outras malformações congênitas especificadas do estômago
Q40.3 Malformação congênita não especificada do estômago
Q40.8 Outras malformações congênitas especificadas do trato digestivo superior
Q40.9 Malformação congênita não especificada do trato digestivo superior
Q41.0 Ausência, atresia e estenose congênita do duodeno
Q41.1 Ausência, atresia e estenose congênita do jejuno
Q41.2 Ausência, atresia e estenose congênita do íleo
Q41.8 Ausência, atresia e estenose congênita de outras partes especificadas do intestino delgado
Q41.9 Ausência, atresia e estenose congênita do intestino delgado, sem especificação de localização
Q42.0 Ausência, atresia e estenose congênita do reto, com fístula
Q42.1 Ausência, atresia e estenose congênita do reto, sem fístula
Q42.2 Ausência, atresia e estenose congênita do ânus, com fístula
Q42.3 Ausência, atresia e estenose congênita do ânus, sem fístula
Q42.8 Ausência, atresia e estenose congênita de outras partes do cólon (intestino grosso)
Q42.9 Ausência, atresia e estenose congênita de partes não especificadas do cólon (intestino grosso)
Q43.0 Divertículo de Meckel
Q43.1 Doença de Hirschsprung
Q43.2 Outras transtornos funcionais congênitos do cólon
Q43.3 Malformações congênitas da fixação do intestino
Q43.4 Duplicação do intestino
Q43.5 Ânus ectópico
Q43.6 Fístula congênita do reto e do ânus
Q43.7 Persistência de cloaca
Q43.8 Outras malformações congênitas especificadas do intestino
Q43.9 Malformação congênita não especificada do intestino
Q44.0 Agenesia, aplasia e hipoplasia da vesícula biliar
Q44.1 Outras malformações congênitas da vesícula biliar
Q44.2 Atresia das vias biliares
Q44.3 Estenose e estreitamento congênitos das vias biliares
Q44.4 Cisto do colédoco
Q44.5 Outras malformações congênitas das vias biliares
Q44.6 Doença cística do fígado
Q44.7 Outras malformações congênitas do fígado
Q45.0 Agenesia, aplasia e hipoplasia do pâncreas
Q45.1 Pâncreas anular
Q45.2 Cisto pancreático congênito
Q45.3 Outras malformações congênitas do pâncreas e do duto pancreático
Q45.8 Outras malformações congênitas especificadas do aparelho digestivo
Q45.9 Malformação congênita não especificada do aparelho digestivo
Q50.0 Ausência congênita dos ovários
Q50.1 Cisto ovariano de desenvolvimento
Q50.2 Torsão congênita do ovário
Q50.3 Outras malformações congênitas do ovário
Q50.4 Cisto embrionário da trompa de Falópio
Q50.5 Cisto embrionário do ligamento largo
Q50.6 Outras malformações congênitas das trompas de Falópio e dos ligamentos largos
Q51.0 Agenesia e aplasia do útero
Q51.1 Útero duplo com duplicação do colo uterino e da vagina
Q51.2 Outra duplicação do útero
Q51.3 Útero bicórneo
Q51.4 Útero unicórneo
Q51.5 Agenesia e aplasia do colo do útero
Q51.6 Cisto embrionário do colo do útero
Q51.7 Fístula congênita útero­digestiva ou útero­urinária
Q51.8 Outras malformações congênitas do útero e do colo do útero
Q51.9 Malformação congênita não especificada do útero e do colo do útero SOE
Q52.0 Ausência congênita da vagina
Q52.1 Duplicação da vagina
Q52.2 Fístula reto­vaginal congênita
Q52.3 Imperfuração do hímen
Q52.4 Outras malformações congênitas da vagina
Q52.5 Fusão dos lábios vulvares
Q52.6 Malformação congênita do clitóris
Q52.7 Outras malformações congênitas da vulva
Q52.8 Outras malformações congênitas especificadas dos órgãos genitais femininos
Q52.9 Malformação congênita não especificada dos órgãos genitais femininos
Q53.0 Testículo ectópico
Q53.1 Testículo não­descido, unilateral
Q53.2 Testículo não­descido, bilateral
Q53.9 Testículo não­descido, não especificado
Q54.0 Hipospádia balânica
Q54.1 Hipospádia peniana
Q54.2 Hipospádia penoscrotal
Q54.3 Hipospádia perineal
Q54.4 Corda venérea congênita
Q54.8 Outras hipospádias
Q54.9 Hipospádia não especificada
Q55.0 Ausência e aplasia do testículo
Q55.1 Hipoplasia do(s) testículo(s) e do escroto
Q55.2 Outras malformações congênitas do(s) testículo(s) e do escroto
Q55.3 Atresia do canal deferente
Q55.4 Outras malformações congênitas do canal deferente, do epidídimo, das vesículas seminais e da
próstata
Q55.5 Ausência e aplasia congênitas do pênis
Q55.6 Outras malformações congênitas do pênis
Q55.8 Outras malformações congênitas especificadas dos órgãos genitais masculinos
Q55.9 Malformação congênita não especificada dos órgãos genitais masculinos
Q56.0 Hermafroditismo não classificado em outra parte
Q56.1 Pseudo­hermafroditismo masculino, não classificado em outra parte
Q56.2 Pseudo­hermafroditismo feminino, não classificado em outra parte
Q56.3 Pseudo­hermafroditismo não especificado
Q56.4 Sexo indeterminado, não especificado
Q60.0 Agenesia unilateral do rim
Q60.1 Agenesia bilateral do rim
Q60.2 Agenesia renal não especificada
Q60.3 Hipoplasia renal unilateral
Q60.4 Hipoplasia renal bilateral
Q60.5 Hipoplasia renal não especificada
Q60.6 Síndrome de Potter
Q61.0 Cisto congênito único do rim
Q61.1 Rim policístico, tipo infantil
Q61.2 Rim policístico, tipo adulto
Q61.3 Rim policístico não especificado
Q61.4 Displasia renal
Q61.5 Cisto medular do rim
Q61.8 Outras doenças císticas do rim
Q61.9 Doença cística não especificada do rim
Q62.0 Hidronefrose congênita
Q62.1 Atresia e estenose do ureter
Q62.2 Megaureter congênito
Q62.3 Outras anomalias obstrutivas da pelve renal e do ureter
Q62.4 Agenesia do ureter
Q62.5 Duplicação do ureter
Q62.6 Má­posição do ureter
Q62.7 Refluxo vésico­uretero­renal congênito
Q62.8 Outras malformações congênitas do ureter
Q63.0 Rim supranumerário
Q63.1 Rim lobulado, fundido ou em ferradura
Q63.2 Rim ectópico
Q63.3 Rim hiperplásico e gigante
Q63.8 Outras malformações congênitas especificadas do rim
Q63.9 Malformação congênita não especificada do rim
Q64.0 Epispádias
Q64.1 Extrofia vesical
Q64.2 Válvulas uretrais posteriores congênitas
Q64.3 Outras formas de atresia e de estenose de uretra e do colo da bexiga
Q64.4 Malformação do úraco
Q64.5 Ausência congênita da bexiga e da uretra
Q64.6 Divertículo congênito da bexiga
Q64.7 Outras malformações congênitas da bexiga e da uretra
Q64.8 Outras malformações congênitas especificadas do aparelho urinário
Q64.9 Malformação congênita não especificada do aparelho urinário
Q65.0 Luxação congênita unilateral do quadril
Q65.1 Luxação congênita bilateral do quadril
Q65.2 Luxação congênita não especificada do quadril
Q65.3 Subluxação congênita unilateral do quadril
Q65.4 Subluxação congênita bilateral do quadril
Q65.5 Subluxação congênita não especificada do quadril
Q65.6 Quadril instável
Q65.8 Outras deformidades congênitas do quadril
Q65.9 Deformidade congênita não especificada do quadril
Q66.0 Pé torto eqüinovaro
Q66.1 Pé torto calcaneovaro
Q66.2 Metatarso varo
Q66.3 Outras deformidades congênitas dos pés em varo
Q66.4 Pé torto calcaneovalgo
Q66.5 Pé chato congênito
Q66.6 Outras deformidades congênitas dos pés em valgo
Q66.7 Pé cavo
Q66.8 Outras deformidades congênitas do pé
Q66.9 Deformidade congênita não especificada do pé
Q67.0 Assimetria facial
Q67.1 Deformidade facial por compressão
Q67.2 Dolicocefalia
Q67.3 Plagiocefalia
Q67.4 Outras deformidades congênitas do crânio, da face e da mandíbula
Q67.5 Deformidades congênitas da coluna vertebral
Q67.6 Tórax escavado
Q67.7 Tórax carinado
Q67.8 Outras deformidades congênitas do tórax
Q68.0 Deformidade congênita do músculo esternocleidomastoideu
Q68.1 Deformidade congênita da mão
Q68.2 Deformidade congênita do joelho
Q68.3 Encurvamento congênito do fêmur
Q68.4 Encurvamento congênito da tíbia e da perônio [fíbula]
Q68.5 Encurvamento congênito de ossos longos não especificados do membro inferior
Q68.8 Outras deformidades osteomusculares congênitas
Q69.0 Dedo(s) da mão supranumerário(s)
Q69.1 Polegar(es) supranumerário(s)
Q69.2 Artelho(s) supranumerário(s)
Q69.9 Polidactilia não especificada
Q70.0 Coalescência dos dedos (dedos da mão fundidos)
Q70.1 Dedos palmados
Q70.2 Coalescência dos artelhos (artelhos fundidos)
Q70.3 Artelhos palmados
Q70.4 Polissindactilia
Q70.9 Sindactilia não especificada
Q71.0 Ausência congênita completa do(s) membro(s) superior(es)
Q71.1 Ausência congênita do braço e do antebraço, com mão presente
Q71.2 Ausência congênita do antebraço e da mão
Q71.3 Ausência congênita da mão e de dedo(s)
Q71.4 Defeito de redução longitudinal do rádio
Q71.5 Defeito de redução longitudinal do cúbito [ulna]
Q71.6 Mão em garra de lagosta
Q71.8 Outros defeitos de redução do membro superior
Q71.9 Defeito por redução do membro superior, não especificado
Q72.0 Ausência congênita completa do(s) membro(s) inferior(es)
Q72.1 Ausência congênita da coxa e da perna com pé presente
Q72.2 Ausência congênita da perna e do pé
Q72.3 Ausência congênita do pé e de artelho(s)
Q72.4 Defeito por redução longitudinal da tíbia
Q72.5 Defeito por redução longitudinal da tíbia
Q72.6 Defeito por redução longitudinal do perônio [fíbula]
Q72.7 Pé bífido
Q72.8 Outros defeitos por redução do(s) membro(s) inferior(es)
Q72.9 Defeito não especificado por redução do membro inferior
Q73.0 Ausência congênita de membro(s) não especificado(s)
Q73.1 Focomelia, membro(s) não especificado(s)
Q73.8 Outros defeitos por redução de membro(s) não especificado(s)
Q74.0 Outras malformações congênitas do(s) membro(s) superiores, inclusive da cintura escapular
Q74.1 Malformação congênita do joelho
Q74.2 Outras malformações congênitas do(s) membro(s) inferiores, inclusive da cintura pélvica
Q74.3 Artrogripose congênita múltipla
Q74.8 Outras malformações congênitas especificadas de membro(s)
Q74.9 Malformações congênitas não especificadas de membro(s)
Q75.0 Craniossinostose
Q75.1 Disostose craniofacial
Q75.2 Hipertelorismo
Q75.3 Macrocefalia
Q75.4 Disostose mandíbulo­facial
Q75.5 Disostose óculo­mandibular
Q75.8 Outras malformações congênitas especificadas dos ossos do crânio e da face
Q75.9 Malformação congênita não especificada dos ossos do crânio e da face
Q76.0 Espinha bífida oculta
Q76.1 Síndrome de Klippel­Feil
Q76.2 Espondilolistese congênita
Q76.3 Escoliose congênita devida à malformação óssea congênita
Q76.4 Outras malformações congênitas da coluna vertebral não­associadas com escoliose
Q76.5 Costela cervical
Q76.6 Outras malformações congênitas das costelas
Q76.7 Malformação congênita do esterno
Q76.8 Outras malformações congênitas dos ossos do tórax
Q76.9 Malformação congênita não especificada dos ossos do tórax
Q77.0 Acondrogenesia
Q77.1 Nanismo tanatofórico
Q77.2 Síndrome das costelas curtas
Q77.3 Condrodisplasia puntacta
Q77.4 Acondroplasia
Q77.5 Displasia diastrófica
Q77.6 Displasia condroectodérmica
Q77.7 Displasia espondiloepifisária
Q77.8 Outras osteocondrodisplasias com anomalias do crescimento dos ossos longos e da coluna
vertebral
Q77.9 Osteocondrodisplasia não especificada com anomalias do crescimento dos ossos longos e da
coluna vertebral
Q78.0 Osteogênese imperfeita
Q78.1 Displasia poliostótica fibrosa
Q78.2 Osteopetrose
Q78.3 Displasia diafisária progressiva
Q78.4 Encondromatose
Q78.5 Displasia metafisária
Q78.6 Exostoses congênitas múltiplas
Q78.8 Outras osteocondrodisplasias especificadas
Q78.9 Osteocondrodisplasia não especificada
Q79.0 Hérnia diafragmática congênita
Q79.1 Outras malformações congênitas do diafragma
Q79.2 Exonfalia
Q79.3 Gastrosquise
Q79.4 Síndrome do abdome em ameixa seca ("prune belly syndrome")
Q79.5 Outras malformações congênitas da parede abdominal
Q79.6 Síndrome de Ehlers­Danlos
Q79.8 Outras malformações congênitas do sistema osteomuscular
Q79.9 Malformação congênita não especificada do sistema osteomuscular
Q80.0 Ictiose vulgar
Q80.1 Ictiose ligada ao cromossomo X
Q80.2 Ictiose lamelar
Q80.3 Eritrodermia ictiosiforme bulhosa congênita
Q80.4 Feto arlequim
Q80.8 Outras ictioses congênitas
Q80.9 Ictiose congênita não especificada
Q81.0 Epidermólise bolhosa simples
Q81.1 Epidermólise bolhosa letal
Q81.2 Epidermólise bolhosa distrófica
Q81.8 Outras epidermólises bolhosas
Q81.9 Epidermólise bolhosa não especificada
Q82.0 Linfedema hereditário
Q82.1 Xeroderma pigmentoso
Q82.2 Mastocitose
Q82.3 Incontinentia pigmenti
Q82.4 Displasia ectodérmica (anidrótica)
Q82.5 Nevo não­neoplásico congênito
Q82.8 Outras malformações congênitas especificadas da pele
Q82.9 Malformação congênita não especificada da pele
Q83.0 Ausência congênita da mama com ausência do mamilo
Q83.1 Mama supranumerária
Q83.2 Ausência de mamilo
Q83.3 Mamilo acessório
Q83.8 Outras malformações congênitas da mama
Q83.9 Malformação congênita não especificada da mama
Q84.0 Alopécia congênita
Q84.1 Alterações morfológicas congênitas dos cabelos não classificadas em outra parte
Q84.2 Outras malformações congênitas dos cabelos
Q84.3 Anoníquia
Q84.4 Leuconíquia congênita
Q84.5 Hipertrofia e alargamento das unhas
Q84.6 Outras malformações congênitas das unhas
Q84.8 Outras malformações congênitas especificadas do tegumento
Q84.9 Malformação congênita não especificada do tegumento
Q85.0 Neurofibromatose (não­maligna)
Q85.1 Esclerose tuberosa
Q85.8 Outras facomatoses não classificadas em outra parte
Q85.9 Facomatose não especificada
Q86.0 Síndrome fetal alcoólico (dismórfico)
Q86.1 Síndrome fetal devida à hidantoína
Q86.2 Dismorfismo devido ao Warfarin
Q86.8 Outras síndromes com malformações congênitas devidas a causas exógenas conhecidas
Q87.0 Síndromes com malformações congênitas afetando predominantemente o aspecto da face
Q87.1 Síndromes com malformações congênitas associadas predominantemente com nanismo
Q87.2 Síndromes com malformações congênitas afetando predominantemente os membros
Q87.3 Síndromes com malformações congênitas com hipercrescimento precoce
Q87.4 Síndrome de Marfan
Q87.5 Outras síndromes com malformações congênitas com outras alterações do esqueleto
Q87.8 Outras síndromes com malformações congênitas especificadas, não classificadas em outra
parte
Q89.0 Malformações congênitas do baço
Q89.1 Malformações congênitas das supra­renais
Q89.2 Malformações congênitas de outras glândulas endócrinas
Q89.3 Situs inversus
Q89.4 Reunião de gêmeos
Q89.7 Malformações congênitas múltiplas, não classificadas em outra parte
Q89.8 Outras malformações congênitas especificadas
Q89.9 Malformações congênitas não especificadas
Q90.0 Trissomia 21, não­disjunção meiótica
Q90.1 Trissomia 21, mosaicismo (não­disjunção mitótica)
Q90.2 Trissomia 21, translocação
Q90.9 Síndrome de Down não especificada
Q91.0 Trissomia 18, não­disjunção meiótica
Q91.1 Trissomia 18, mosaicismo cromossômico (não­disjunção mitótica)
Q91.2 Trissomia 18, translocação
Q91.3 Síndrome de Edwards não especificada
Q91.4 Trissomia 13, não­disjunção meiótica
Q91.5 Trissomia 13, mosaicismo cromossômico (não­disjunção mitótica)
Q91.6 Trissomia 13, translocação
Q91.7 Síndrome de Patau não especificada
Q92.0 Trissomia de um cromossomo inteiro, não­disjunção meiótica
Q92.1 Trissomia de um cromossomo inteiro, mosaicismo cromossômico (não­disjunção mitótica)
Q92.2 Trissomia parcial major
Q92.3 Trissomia parcial minor
Q92.4 Duplicações vistas somente na prometáfase
Q92.5 Duplicação com outros rearranjos complexos
Q92.6 Cromossomos marcadores suplementares
Q92.7 Triploidia e poliploidia
Q92.8 Outras trissomias especificadas e trissomias parciais dos autossomos
Q92.9 Trissomia e trissomia parcial não especificada dos autossomos
Q93.0 Monossomia de cromossomo inteiro, não­disjunção meiótica
Q93.1 Monossomia de cromossomo inteiro, mosaicismo cromossômico (não­disjunção mitótica)
Q93.2 Cromossomo substituído por anel ou dicêntrico
Q93.3 Deleção do braço curto do cromossomo 4
Q93.4 Deleção do braço curto do cromossomo 5
Q93.5 Outras deleções parciais de cromossomo
Q93.6 Deleções vistas somente na prometáfase
Q93.7 Deleções com outros rearranjos complexos
Q93.8 Outras deleções dos autossomos
Q93.9 Deleções não especificadas dos autossomos
Q95.0 Translocação ou inserção equilibrada em sujeito normal
Q95.1 Inversão cromossômica em sujeito normal
Q95.2 Rearranjo autossômico equilibrado em sujeito anormal
Q95.3 Rearranjo sexual/autossômico equilibrado em sujeito anormal
Q95.4 Sujeito com marcador de heterocromatina
Q95.5 Sujeito com sítio autossômico frágil
Q95.8 Outros rearranjos e marcadores equilibrados
Q95.9 Rearranjos e marcadores equilibrados não especificados
Q96.0 Cariótipo 45, X
Q96.1 Cariótipo 46, X iso (Xq)
Q96.2 Cariótipo 46, X com cromossomo sexual anormal, salvo iso (Xq)
Q96.3 Mosaicismo cromossômico, 45, X/46, XX ou XY
Q96.4 Mosaicismo cromossômico, 45, X/outra(s) linhagens celular(es) com cromossomo sexual
anormal
Q96.8 Outras variantes da síndrome de Turner
Q96.9 Síndrome de Turner não especificada
Q97.0 Cariótipo 47, XXX
Q97.1 Mulher com mais de três cromossomos X
Q97.2 Mosaicismo cromossômico, linhagens com diversos números de cromossomos X
Q97.3 Mulher com cariótipo 46, XY
Q97.8 Outras anomalias especificadas dos cromossomos sexuais, fenótipo feminino
Q97.9 Anomalias não especificadas dos cromossomos sexuais, fenótipo feminino
Q98.0 Síndrome de Klinefelter, cariótipo 47, XXY
Q98.1 Síndrome de Klinefelter, homem com mais de dois cromossomos X
Q98.2 Síndrome de Klinefelter, homem com cariótipo 46, XX
Q98.3 Outro homem com cariótipo 46, XX
Q98.4 Síndrome de Klinefelter não especificada
Q98.5 Cariótipo 47, XYY
Q98.6 Homem com cromossomos sexuais de estrutura anormal
Q98.7 Homem com mosaicismo dos cromossomos sexuais
Q98.8 Outras anomalias especificadas dos cromossomos sexuais, fenótipo masculino
Q98.9 Anomalias não especificadas dos cromossomos sexuais, fenótipo masculino
Q99.0 Quimera 46, XX/46, XY
Q99.1 Hermafrodite verdadeiro 46, XX
Q99.2 Cromossomo X frágil
Q99.8 Outras anomalias cromossômicas especificadas
Q99.9 Anomalia cromossômica não especificada
R00.0 Taquicardia não especificada
R00.1 Bradicardia não especificada
R00.2 Palpitações
R00.8 Outras anormalidades e as não especificadas do batimento cardíaco
R01.0 Sopros cardíacos benignos ou inocentes
R01.1 Sopro cardíaco, não especificado
R01.2 Outros ruídos cardíacos
R02 Gangrena não classificada em outra parte
R03.0 Valor elevado da pressão arterial sem o diagnóstico de hipertensão
R03.1 Valor baixo da pressão arterial não específico
R04.0 Epistaxis
R04.1 Hemorragia da garganta
R04.2 Hemoptise
R04.8 Hemorragia de outras localizações das vias respiratórias
R04.9 Hemorragia não especificada das vias respiratórias
R05 Tosse
R06.0 Dispnéia
R06.1 Estridor
R06.2 Respiração ofegante
R06.3 Respiração periódica
R06.4 Hiperventilação
R06.5 Respiração pela boca
R06.6 Soluço
R06.7 Espirro
R06.8 Outras anormalidades e as não especificadas da respiração
R07.0 Dor de garganta
R07.1 Dor torácica ao respirar
R07.2 Dor precordial
R07.3 Outra dor torácica
R07.4 Dor torácica, não especificada
R09.0 Asfixia
R09.1 Pleurisia
R09.2 Parada respiratória
R09.3 Escarro anormal
R09.8 Outros sintomas e sinais especificados relativos aos aparelhos circulatório e respiratório
R10.0 Abdome agudo
R10.1 Dor localizada no abdome superior
R10.2 Dor pélvica e perineal
R10.3 Dor localizada em outras partes do abdome inferior
R10.4 Outras dores abdominais e as não especificadas
R11 Náusea e vômitos
R12 Pirose
R13 Disfagia
R14 Flatulência e afecções correlatas
R15 Incontinência fecal
R16.0 Hepatomegalia não classificada em outra parte
R16.1 Esplenomegalia não classificada em outra parte
R16.2 Hepatomegalia com esplenomegalia não classificada em outra parte
R17 Icterícia não especificada
R18 Ascite
R19.0 Massa, tumoração ou tumefação intra­abdominal e pélvica
R19.1 Ruídos hidroaéreos anormais
R19.2 Peristaltismo visível
R19.3 Rigidez abdominal
R19.4 Alteração do hábito intestinal
R19.5 Outras anormalidades fecais
R19.6 Halitose
R19.8 Outros sintomas e sinais especificados relativos ao aparelho digestivo e ao abdome
R20.0 Anestesia cutânea
R20.1 Hipoestesia cutânea
R20.2 Parestesias cutâneas
R20.3 Hiperestesia
R20.8 Outros distúrbios e os não especificadas da sensibilidade cutânea
R21 Eritema e outras erupções cutâneas não especificadas
R22.0 Tumefação, massa ou tumoração localizadas da cabeça
R22.1 Tumefação, massa ou tumoração localizadas do pescoço
R22.2 Tumefação, massa ou tumoração localizadas do tronco
R22.3 Tumefação, massa ou tumoração localizadas de membro superior
R22.4 Tumefação, massa ou tumoração localizadas no membro inferior
R22.7 Tumefação, massa ou tumoração localizadas de múltiplas localizações
R22.9 Tumefação, massa ou tumoração não especificadas, localizadas
R23.0 Cianose
R23.1 Palidez
R23.2 Rubor
R23.3 Equimoses espontâneas
R23.4 Alterações na textura da pele
R23.8 Outras alterações da pele e as não especificadas
R25.0 Movimentos anormais da cabeça
R25.1 Tremor não especificado
R25.2 Cãibras e espasmos
R25.3 Fasciculação
R25.8 Outros movimentos involuntários anormais e os não especificados
R26.0 Marcha atáxica
R26.1 Marcha paralítica
R26.2 Dificuldade para andar não classificada em outra parte
R26.8 Outras anormalidades da marcha e da mobilidade e as não especificadas
R27.0 Ataxia não especificada
R27.8 Outros distúrbios da coordenação e os não especificados
R29.0 Tetania
R29.1 Meningismo
R29.2 Reflexos anormais
R29.3 Postura anormal
R29.4 Quadril estalante
R29.8 Outros sintomas e sinais relativos aos sistemas nervoso e osteomuscular e os não especificados
R30.0 Disúria
R30.1 Tenesmo vesical
R30.9 Micção dolorosa, não especificada
R31 Hematúria não especificada
R32 Incontinência urinária não especificada
R33 Retenção urinária
R34 Anúria e oligúria
R35 Poliúria
R36 Secreção uretral
R39.0 Extravasamento de urina
R39.1 Outras dificuldades à micção
R39.2 Uremia extra­renal
R39.8 Outros sintomas e sinais relativos ao aparelho urinário e os não especificados
R40.0 Sonolência
R40.1 Estupor
R40.2 Coma não especificado
R41.0 Desorientação não especificada
R41.1 Amnésia anterógrada
R41.2 Amnésia retrógrada
R41.3 Outra amnésia
R41.8 Outros sintomas e sinais especificados relativos às funções cognitivas e à consciência
R42 Tontura e instabilidade
R43.0 Anosmia
R43.1 Parosmia
R43.2 Parageusia
R43.8 Outros distúrbios do olfato e do paladar e os não especificados
R44.0 Alucinações auditivas
R44.1 Alucinações visuais
R44.2 Outras alucinações
R44.3 Alucinações não especificadas
R44.8 Outros sintomas e sinais especificados relativos às sensações e percepções gerais
R45.0 Nervosismo
R45.1 Agitação e inquietação
R45.2 Tristeza
R45.3 Apatia e desinteresse
R45.4 Irritabilidade e mau humor
R45.5 Hostilidade
R45.6 Violência física
R45.7 Estado de choque emocional e tensão, não especificado
R45.8 Outros sintomas e sinais relativos ao estado emocional
R46.0 Baixo nível de higiene pessoal
R46.1 Aparência pessoal bizarra
R46.2 Comportamento estranho e inexplicável
R46.3 Hiperatividade
R46.4 Lentidão e baixa reatividade
R46.5 Personalidade suspeita e evasiva
R46.6 Inquietação e preocupação exageradas com acontecimentos "estressantes"
R46.7 Verborragia e pormenores circunstanciais mascarando o motivo da consulta
R46.8 Outros sintomas e sinais relativos à aparência e ao comportamento
R47.0 Disfasia e afasia
R47.1 Disartria e anartria
R47.8 Outros distúrbios da fala e os não especificados
R48.0 Dislexia e alexia
R48.1 Agnosia
R48.2 Apraxia
R48.8 Outras disfunções simbólicas e as não especificadas
R49.0 Disfonia
R49.1 Afonia
R49.2 Hipernasalidade e hiponasalidade
R49.8 Outros distúrbios da voz e os não especificados
R50.0 Febre com calafrios
R50.1 Febre persistente
R50.9 Febre não especificada
R51 Cefaléia
R52.0 Dor aguda
R52.1 Dor crônica intratável
R52.2 Outra dor crônica
R52.9 Dor não especificada
R53 Mal estar, fadiga
R54 Senilidade
R55 Síncope e colapso
R56.0 Convulsões febris
R56.8 Outras convulsões e as não especificadas
R57.0 Choque cardiogênico
R57.1 Choque hipovolêmico
R57.8 Outras formas de choque
R57.9 Choque não especificado
R58 Hemorragia não classificada em outra parte
R59.0 Aumento de volume localizado de gânglios linfáticos
R59.1 Aumento de volume generalizado de gânglios linfáticos
R59.9 Adenomegalia ou aumento de volume dos gânglios linfáticos, não especificado
R60.0 Edema localizado
R60.1 Edema generalizado
R60.9 Edema não especificado
R61.0 Hiperidrose localizada
R61.1 Hiperidrose generalizada
R61.9 Hiperidrose não especificada
R62.0 Retardo de maturação
R62.8 Outras formas de retardo do desenvolvimento fisiológico normal
R62.9 Retardo do desenvolvimento fisiológico normal, não especificado
R63.0 Anorexia
R63.1 Polidipsia
R63.2 Polifagia
R63.3 Dificuldades de alimentação e erros na administração de alimentos
R63.4 Perda de peso anormal
R63.5 Ganho de peso anormal
R63.8 Outros sintomas e sinais relativos a ingestão de alimentos e de líquidos
R64 Caquexia
R68.0 Hipotermia não associada à baixa temperatura ambiental
R68.1 Sintomas não específicos peculiares à infância
R68.2 Boca seca, não especificada
R68.3 Baqueteamento dos dedos
R68.8 Outros sintomas e sinais gerais especificados
R69 Causas desconhecidas e não especificadas de morbidade
R70.0 Velocidade de hemossedimentação elevada
R70.1 Viscosidade plasmática anormal
R71 Anormalidade das hemácias
R72 Anormalidade dos leucócitos não classificada em outra parte
R73.0 Teste de tolerância a glicose anormal
R73.9 Hiperglicemia não especificada
R74.0 Aumento dos níveis de transaminases e da desidrogenase lática (DHL)
R74.8 Níveis anormais de outras enzimas séricas
R74.9 Anormalidade dos níveis de enzimas séricas, não especificada
R75 Evidência laboratorial do vírus da imunodeficiência humana [HIV]
R76.0 Título aumentado de anticorpos
R76.1 Reação anormal ao teste da tuberculina
R76.2 Exame sorológico falso positivo para sífilis
R76.8 Outros achados imunológicos especificados anormais no soro
R76.9 Achado anormal de exame imunológico sérico, não especificado
R77.0 Anormalidade da albumina
R77.1 Anormalidade das globulinas
R77.2 Anormalidade da alfafetoproteína
R77.8 Outras anormalidades especificadas das proteínas plasmáticas
R77.9 Anormalidades de proteína plasmática, não especificadas
R78.0 Presença de álcool no sangue
R78.1 Presença de opiáceos no sangue
R78.2 Presença de cocaína no sangue
R78.3 Presença de alucinógeno no sangue
R78.4 Presença de outras drogas com potencial de causar dependência, no sangue
R78.5 Presença de droga psicotrópica no sangue
R78.6 Presença de agente esteróide no sangue
R78.7 Presença de nível anormal de metais pesados no sangue
R78.8 Presença de outras substâncias especificadas não normalmente encontradas no sangue
R78.9 Presença de substância não especificada normalmente não encontrada no sangue
R79.0 Anormalidade do nível de elementos minerais no sangue
R79.8 Outros achados anormais especificados de exames químicos do sangue
R79.9 Achado anormal de exame químico do sangue, não especificado
R80 Proteinúria isolada
R81 Glicosúria
R82.0 Quilúria
R82.1 Mioglobinúria
R82.2 Biliúria
R82.3 Hemoglobinúria
R82.4 Acetonúria
R82.5 Níveis urinários elevados de drogas, medicamentos e substâncias biológicas
R82.6 Níveis urinários anormais de substâncias cuja origem é essencialmente não­medicinal
R82.7 Achados anormais ao exame microbiológico da urina
R82.8 Achados anormais ao exame citológico e histológico da urina
R82.9 Outros achados anormais na urina e os não especificados
R83.0 Achados anormais no líquido cefalorraquidiano ­ nível enzimático anormal
R83.1 Achados anormais no líquido cefalorraquidiano ­ nível hormonal anormal
R83.2 Achados anormais no líquido cefalorraquidiano ­ nível anormal de outras drogas, medicamentos
e substâncias biológicas
R83.3 Achados anormais no líquido cefalorraquidiano ­ nível anormal de substâncias cuja origem é
essencialmente não medicinal
R83.4 Achados anormais no líquido cefalorraquidiano ­ achados imunológicos anormais
R83.5 Achados anormais no líquido cefalorraquidiano ­ achados microbiológicos anormais
R83.6 Achados anormais no líquido cefalorraquidiano ­ achados citológicos anormais
R83.7 Achados anormais no líquido cefalorraquidiano ­ achados histológicos anormais
R83.8 Achados anormais no líquido cefalorraquidiano ­ outros achados anormais
R83.9 Achados anormais no líquido cefalorraquidiano ­ achado anormal não especificado
R84.0 Achados anormais de material proveniente dos órgãos respiratórios e do tórax ­ nível enzimático
anormal
R84.1 Achados anormais de material proveniente dos órgãos respiratórios e do tórax ­ nível hormonal
anormal
R84.2 Achados anormais de material proveniente dos órgãos respiratórios e do tórax ­ nível anormal de
outras drogas, medicamentos e substâncias biológicas
R84.3 Achados anormais de material proveniente dos órgãos respiratórios e do tórax ­ nível anormal de
substâncias cuja origem é essencialmente não medicinal
R84.4 Achados anormais de material proveniente dos órgãos respiratórios e do tórax ­ achados
imunológicos anormais
R84.5 Achados anormais de material proveniente dos órgãos respiratórios e do tórax ­ achados
microbiológicos anormais
R84.6 Achados anormais de material proveniente dos órgãos respiratórios e do tórax ­ achados
citológicos anormais
R84.7 Achados anormais de material proveniente dos órgãos respiratórios e do tórax ­ achados
histológicos anormais
R84.8 Achados anormais de material proveniente dos órgãos respiratórios e do tórax ­ outros achados
anormais
R84.9 Achados anormais de material proveniente dos órgãos respiratórios e do tórax ­ achado anormal
não especificado
R85.0 Achados anormais de material proveniente dos órgãos digestivos e da cavidade abdominal ­
nível enzimático anormal
R85.1 Achados anormais de material proveniente dos órgãos digestivos e da cavidade abdominal ­
nível hormonal anormal
R85.2 Achados anormais de material proveniente dos órgãos digestivos e da cavidade abdominal ­
nível anormal de outras drogas, medicamentos e substâncias biológicas
R85.3 Achados anormais de material proveniente dos órgãos digestivos e da cavidade abdominal ­
nível anormal de substâncias cuja origem é essencialmente não medicinal
R85.4 Achados anormais de material proveniente dos órgãos digestivos e da cavidade abdominal ­
achados imunológicos anormais
R85.5 Achados anormais de material proveniente dos órgãos digestivos e da cavidade abdominal ­
achados microbiológicos anormais
R85.6 Achados anormais de material proveniente dos órgãos digestivos e da cavidade abdominal ­
achados citológicos anormais
R85.7 Achados anormais de material proveniente dos órgãos digestivos e da cavidade abdominal ­
achados histológicos anormais
R85.8 Achados anormais de material proveniente dos órgãos digestivos e da cavidade abdominal ­
outros achados anormais
R85.9 Achados anormais de material proveniente dos órgãos digestivos e da cavidade abdominal ­
achado anormal não especificado
R86.0 Achados anormais de material proveniente dos órgãos genitais masculinos ­ nível enzimático
anormal
R86.1 Achados anormais de material proveniente dos órgãos genitais masculinos ­ nível hormonal
anormal
R86.2 Achados anormais de material proveniente dos órgãos genitais masculinos ­ nível anormal de
outras drogas, medicamentos e substâncias biológicas
R86.3 Achados anormais de material proveniente dos órgãos genitais masculinos ­ nível anormal de
substâncias cuja origem é essencialmente não medicinal
R86.4 Achados anormais de material proveniente dos órgãos genitais masculinos ­ achados
imunológicos anormais
R86.5 Achados anormais de material proveniente dos órgãos genitais masculinos ­ achados
microbiológicos anormais
R86.6 Achados anormais de material proveniente dos órgãos genitais masculinos ­ achados citológicos
anormais
R86.7 Achados anormais de material proveniente dos órgãos genitais masculinos ­ achados
histológicos anormais
R86.8 Achados anormais de material proveniente dos órgãos genitais masculinos ­ outros achados
anormais
R86.9 Achados anormais de material proveniente dos órgãos genitais masculinos ­ achado anormal
não especificado
R87.0 Achados anormais de material proveniente dos órgãos genitais femininos ­ nível enzimático
anormal
R87.1 Achados anormais de material proveniente dos órgãos genitais femininos ­ nível hormonal
anormal
R87.2 Achados anormais de material proveniente dos órgãos genitais femininos ­ nível anormal de
outras drogas, medicamentos e substâncias biológicas
R87.3 Achados anormais de material proveniente dos órgãos genitais femininos ­ nível anormal de
substâncias cuja origem é essencialmente não medicinal
R87.4 Achados anormais de material proveniente dos órgãos genitais femininos ­ achados
imunológicos anormais
R87.5 Achados anormais de material proveniente dos órgãos genitais femininos ­ achados
microbiológicos anormais
R87.6 Achados anormais de material proveniente dos órgãos genitais femininos ­ achados citológicos
anormais
R87.7 Achados anormais de material proveniente dos órgãos genitais femininos ­ achados histológicos
anormais
R87.8 Achados anormais de material proveniente dos órgãos genitais femininos ­ outros achados
anormais
R87.9 Achados anormais de material proveniente dos órgãos genitais femininos ­ achado anormal não
especificado
R89.0 Achados anormais de material proveniente de outros órgãos, aparelhos, sistemas e tecidos ­
nível enzimático anormal
R89.1 Achados anormais de material proveniente de outros órgãos, aparelhos, sistemas e tecidos ­
nível hormonal anormal
R89.2 Achados anormais de material proveniente de outros órgãos, aparelhos, sistemas e tecidos ­
nível anormal de outras drogas, medicamentos e substâncias biológicas
R89.3 Achados anormais de material proveniente de outros órgãos, aparelhos, sistemas e tecidos ­
nível anormal de substâncias cuja origem é essencialmente não medicinal
R89.4 Achados anormais de material proveniente de outros órgãos, aparelhos, sistemas e tecidos ­
achados imunológicos anormais
R89.5 Achados anormais de material proveniente de outros órgãos, aparelhos, sistemas e tecidos ­
achados microbiológicos anormais
R89.6 Achados anormais de material proveniente de outros órgãos, aparelhos, sistemas e tecidos ­
achados citológicos anormais
R89.7 Achados anormais de material proveniente de outros órgãos, aparelhos, sistemas e tecidos ­
achados histológicos anormais
R89.8 Achados anormais de material proveniente de outros órgãos, aparelhos, sistemas e tecidos ­
outros achados anormais
R89.9 Achados anormais de material proveniente de outros órgãos, aparelhos, sistemas e tecidos ­
achado anormal não especificado
R90.0 Lesão intracraniana ocupando espaço
R90.8 Outros resultados anormais de exames para diagnóstico por imagem do sistema nervoso central
R91 Achados anormais, de exames para diagnóstico por imagem, do pulmão
R92 Achados anormais, de exames para diagnóstico por imagem, da mama
R93.0 Achados anormais de exames para diagnóstico por imagem do crânio e da cabeça não
classificados em outra parte
R93.1 Achados anormais de exames para diagnóstico por imagem do coração e da circulação
coronariana
R93.2 Achados anormais de exames para diagnóstico por imagem do fígado e das vias biliares
R93.3 Achados anormais de exames para diagnóstico por imagem de outras partes do tubo digestivo
R93.4 Achados anormais de exames para diagnóstico por imagem dos órgãos urinários
R93.5 Achados anormais de exames para diagnóstico por imagem de outras regiões do abdome,
incluindo o retroperitônio
R93.6 Achados anormais de exames para diagnóstico por imagem dos membros
R93.7 Achados anormais de exames para diagnóstico por imagem de outras partes do sistema
osteomuscular
R93.8 Achados anormais de exames diagnósticos por imagem de outras estruturas somáticas
especificadas
R94.0 Resultados anormais de estudos de função do sistema nervoso central
R94.1 Resultados anormais de estudos de função do sistema nervoso periférico e dos órgãos dos
sentidos
R94.2 Resultados anormais de estudos da função pulmonar
R94.3 Resultados anormais de estudos da função cardiovascular
R94.4 Resultados anormais de estudos de função renal
R94.5 Resultados anormais de estudos de função hepática
R94.6 Resultados anormais de estudos de função tireoidiana
R94.7 Resultados anormais de estudos de função de outras glândulas endócrinas
R94.8 Resultados anormais de estudos de função de outros órgãos, aparelhos e sistemas
R95 Síndrome da morte súbita na infância
R96.0 Morte instantânea
R96.1 Morte que ocorre em menos de 24 horas após o início dos sintomas, que não pode ser explicada
R98 Morte sem assistência
R99 Outras causas mal definidas e as não especificadas de mortalidade
S00.0 Traumatismo superficial do couro cabeludo
S00.1 Contusão da pálpebra e da região periocular
S00.2 Outros traumatismos superficiais da pálpebra e da região periocular
S00.3 Traumatismo superficial do nariz
S00.4 Traumatismo superficial do ouvido
S00.5 Traumatismo superficial dos lábios e da cavidade oral
S00.7 Traumatismos superficiais múltiplos da cabeça
S00.8 Traumatismo superficial de outras partes da cabeça
S00.9 Traumatismo superficial da cabeça, parte não especificada
S01.0 Ferimento do couro cabeludo
S01.1 Ferimento da pálpebra e da região periocular
S01.2 Ferimento do nariz
S01.3 Ferimento do ouvido
S01.4 Ferimento da bochecha e região têmporo­mandibular
S01.5 Ferimento do lábio e da cavidade oral
S01.7 Ferimentos múltiplos da cabeça
S01.8 Ferimento na cabeça, de outras localizações
S01.9 Ferimento na cabeça, parte não especificada
S02.0 Fratura da abóbada do crânio
S02.1 Fratura da base do crânio
S02.2 Fratura dos ossos nasais
S02.3 Fratura do assoalho orbital
S02.4 Fratura dos ossos malares e maxilares
S02.5 Fratura de dentes
S02.6 Fratura de mandíbula
S02.7 Fraturas múltiplas envolvendo os ossos do crânio e da face
S02.8 Outras fraturas do crânio e dos ossos da face
S02.9 Fratura do crânio ou dos ossos da face, parte não especificada
S03.0 Luxação do maxilar
S03.1 Luxação da cartilagem do septo nasal
S03.2 Luxação dentária
S03.3 Luxação de outras partes da cabeça e das não especificadas
S03.4 Entorse e distensão do maxilar
S03.5 Entorse e distensão da articulações e dos ligamentos de outras localizações e de localizações
não especificadas da cabeça
S04.0 Traumatismo do nervo e das vias ópticas
S04.1 Traumatismo do nervo oculomotor
S04.2 Traumatismo do nervo troclear
S04.3 Traumatismo do nervo trigêmeo
S04.4 Traumatismo do nervo abducente
S04.5 Traumatismo do nervo facial
S04.6 Traumatismo do nervo acústico
S04.7 Traumatismo do nervo acessório
S04.8 Traumatismo de outros nervos cranianos
S04.9 Traumatismo de nervo craniano não especificado
S05.0 Traumatismo da conjuntiva e abrasão da córnea sem menção de corpo estranho
S05.1 Contusão do globo ocular e dos tecidos da órbita
S05.2 Laceração e ruptura ocular com prolapso ou perda de tecido intra­ocular
S05.3 Laceração ocular sem prolapso ou perda de tecido intra­ocular
S05.4 Ferimento penetrante da órbita com ou sem corpo estranho
S05.5 Ferimento penetrante do globo ocular com corpo estranho
S05.6 Ferimento penetrante do globo ocular sem corpo estranho
S05.7 Avulsão do olho
S05.8 Outros traumatismos do olho e da órbita
S05.9 Traumatismo do olho e da órbita de parte não especificada
S06.0 Concussão cerebral
S06.1 Edema cerebral traumático
S06.2 Traumatismo cerebral difuso
S06.3 Traumatismo cerebral focal
S06.4 Hemorragia epidural
S06.5 Hemorragia subdural devida a traumatismo
S06.6 Hemorragia subaracnóide devida a traumatismo
S06.7 Traumatismo intracraniano com coma prolongado
S06.8 Outros traumatismos intracranianos
S06.9 Traumatismo intracraniano, não especificado
S07.0 Lesão por esmagamento da face
S07.1 Lesão por esmagamento do crânio
S07.8 Lesão por esmagamento de outras partes da cabeça
S07.9 Lesão por esmagamento da cabeça, parte não especificada
S08.0 Avulsão do couro cabeludo
S08.1 Amputação traumática da orelha
S08.8 Amputação traumática de outras partes da cabeça
S08.9 Amputação traumática de parte não especificada da cabeça
S09.0 Traumatismo dos vasos sangüíneos da cabeça não classificados em outra parte
S09.1 Traumatismo dos músculos e dos tendões da cabeça
S09.2 Ruptura traumática do tímpano
S09.7 Traumatismos múltiplos da cabeça
S09.8 Outros traumatismos especificados da cabeça
S09.9 Traumatismo não especificado da cabeça
S10.0 Contusão da garganta
S10.1 Outros traumatismos superficiais da garganta e os não especificados
S10.7 Traumatismos superficiais múltiplos do pescoço
S10.8 Traumatismo superficial de outras localizações do pescoço
S10.9 Traumatismo superficial do pescoço, parte não especificada
S11.0 Ferimento envolvendo a laringe e a traquéia
S11.1 Ferimento da glândula tireóide
S11.2 Ferimento envolvendo a faringe e o esôfago cervical
S11.7 Ferimentos múltiplos do pescoço
S11.8 Ferimentos de outras partes do pescoço
S11.9 Ferimentos do pescoço, parte não especificada
S12.0 Fratura da primeira vértebra cervical
S12.1 Fratura da segunda vértebra cervical
S12.2 Fratura de outras vértebras cervicais especificadas
S12.7 Fraturas múltiplas da coluna cervical
S12.8 Fratura de outras partes do pescoço
S12.9 Fratura do pescoço, parte não especificada
S13.0 Ruptura traumática de disco intervertebral cervical
S13.1 Luxação de vértebra cervical
S13.2 Luxação de outras partes do pescoço e das não especificadas
S13.3 Luxações múltiplas do pescoço
S13.4 Distensão e entorse da coluna cervical
S13.5 Distensão e entorse da região tireoidiana
S13.6 Distensão e entorse de articulações e de ligamentos de outras localizações e das não
especificadas do pescoço
S14.0 Concussão e edema da medula cervical
S14.1 Outros traumatismos e os não especificados da medula cervical
S14.2 Traumatismo da raiz nervosa da coluna cervical
S14.3 Traumatismo do plexo braquial
S14.4 Traumatismo dos nervos periféricos do pescoço
S14.5 Traumatismo dos nervos simpáticos do pescoço
S14.6 Traumatismo de outros nervos e dos não especificados do pescoço
S15.0 Traumatismo da artéria carótida
S15.1 Traumatismo da artéria vertebral
S15.2 Traumatismo da veia jugular externa
S15.3 Traumatismo da veia jugular interna
S15.7 Traumatismo de múltiplos vasos sangüíneos ao nível do pescoço
S15.8 Traumatismo de outros vasos sangüíneos ao nível do pescoço
S15.9 Traumatismo de vasos sangüíneos não especificados ao nível do pescoço
S16 Traumatismo de tendões e de músculos do pescoço
S17.0 Lesão por esmagamento da laringe e da traquéia
S17.8 Lesão por esmagamento de outras partes do pescoço
S17.9 Lesão por esmagamento do pescoço, parte não especificada
S18 Amputação traumática ao nível do pescoço
S19.7 Traumatismos múltiplos do pescoço
S19.8 Outros traumatismos especificados do pescoço
S19.9 Traumatismo não especificado do pescoço
S20.0 Contusão da mama
S20.1 Outros traumatismos superficiais da mama e os não especificados
S20.2 Contusão do tórax
S20.3 Outros traumatismos superficiais da parede anterior do tórax
S20.4 Outros traumatismos superficiais da parede posterior do tórax
S20.7 Traumatismos superficiais múltiplos do tórax
S20.8 Traumatismo superficial de outras partes especificadas do tórax e das não especificadas
S21.0 Ferimento da mama
S21.1 Ferimento da parede anterior do tórax
S21.2 Ferimento da parede posterior do tórax
S21.7 Ferimentos múltiplos da parede torácica
S21.8 Ferimento de outras partes do tórax
S21.9 Ferimento do tórax parte não especificada
S22.0 Fratura de vértebra torácica
S22.1 Fraturas múltiplas da coluna torácica
S22.2 Fratura do esterno
S22.3 Fratura de costela
S22.4 Fraturas múltiplas de costelas
S22.5 Tórax fundido (oscilante)
S22.8 Fraturas de outras partes dos ossos do tórax
S22.9 Fratura dos ossos do tórax, parte não especificada
S23.0 Ruptura traumática de disco intervertebral torácico
S23.1 Luxação de vértebra torácica
S23.2 Luxação de outras partes do tórax e das não especificadas
S23.3 Entorse e distensão da coluna torácica
S23.4 Entorse e distensão das costelas e do esterno
S23.5 Entorse e distensão de outras partes do tórax e de partes não especificadas
S24.0 Concussão e edema da medula espinhal torácica
S24.1 Outros traumatismos da medula espinhal torácica e os não especificados
S24.2 Traumatismo da raiz de nervo da coluna torácica
S24.3 Traumatismo de nervos periféricos do tórax
S24.4 Traumatismo de nervos simpáticos do tórax
S24.5 Traumatismo de outros nervos do tórax
S24.6 Traumatismo de nervo do tórax não especificado
S25.0 Traumatismo da aorta torácica
S25.1 Traumatismo da artéria subclávia ou inominada [braquiocefálica]
S25.2 Traumatismo da veia cava superior
S25.3 Traumatismo da veia subclávia ou inominada [braquiocefálica]
S25.4 Traumatismo de vasos sangüíneos pulmonares
S25.5 Traumatismo de vasos sangüíneos intercostais
S25.7 Traumatismo de múltiplos vasos sangüíneos do tórax
S25.8 Traumatismo de outros vasos sangüíneos do tórax
S25.9 Traumatismo de vaso sangüíneo não especificado do tórax
S26.0 Traumatismo do coração com hemopericárdio
S26.8 Outros traumatismos do coração
S26.9 Traumatismo do coração não especificado
S27.0 Pneumotórax traumático
S27.1 Hemotórax traumático
S27.2 Hemopneumotórax traumático
S27.3 Outros traumatismos do pulmão
S27.4 Traumatismo dos brônquios
S27.5 Traumatismo da traquéia torácica
S27.6 Traumatismo da pleura
S27.7 Traumatismos múltiplos de órgãos intratorácicos
S27.8 Traumatismo de outros órgãos intratorácicos especificados
S27.9 Traumatismo de órgão intratorácico não especificado
S28.0 Esmagamento do tórax
S28.1 Amputação traumática de parte do tórax
S29.0 Traumatismo de músculo e de tendão ao nível tóracico
S29.7 Traumatismos múltiplos do tórax
S29.8 Outros traumatismos especificados do tórax
S29.9 Traumatismo não especificado do tórax
S30.0 Contusão do dorso e da pelve
S30.1 Contusão da parede abdominal
S30.2 Contusão dos órgãos genitais externos
S30.7 Traumatismos superficiais múltiplos do abdome, do dorso e da pelve
S30.8 Outros traumatismos superficiais do abdome, do dorso e da pelve
S30.9 Traumatismo superficial de parte não especificada do abdome, do dorso e da pelve
S31.0 Ferimento do dorso e da pelve
S31.1 Ferimento da parede abdominal
S31.2 Ferimento do pênis
S31.3 Ferimento do escroto e do testículo
S31.4 Ferimento da vagina e da vulva
S31.5 Ferimento de outros órgãos genitais externos e os não especificados
S31.7 Ferimentos múltiplos do abdome, do dorso e da pelve
S31.8 Ferimento de outras partes e de partes não especificadas do abdome
S32.0 Fratura de vértebra lombar
S32.1 Fratura do sacro
S32.2 Fratura do cóccix
S32.3 Fratura do ílio
S32.4 Fratura do acetábulo
S32.5 Fratura do púbis
S32.7 Fraturas múltiplas de coluna lombar e da pelve
S32.8 Fratura de outras partes da coluna lombossacra e da pelve e de partes não especificadas
S33.0 Ruptura traumática do disco intervertebral lombar
S33.1 Luxação da vértebra lombar
S33.2 Luxação das articulações sacroilíaca e sacrococcígea
S33.3 Luxação de outras partes e das não especificadas da coluna lombar e da pelve
S33.4 Ruptura traumática da sínfise púbica
S33.5 Entorse e distensão da coluna lombar
S33.6 Entorse e distensão da articulação sacroilíaca
S33.7 Entorse e distensão de outras partes e das não especificadas da coluna lombar e da pelve
S34.0 Concussão e edema da medula lombar
S34.1 Outro traumatismo da medula lombar
S34.2 Traumatismo de raiz nervosa da medula lombar e sacra
S34.3 Traumatismo de cauda eqüina
S34.4 Traumatismo do plexo lombossacro
S34.5 Traumatismo de nervos simpáticos lombares, sacros e pélvicos
S34.6 Traumatismo do(s) nervo(s) periférico(s) do abdome, do dorso e da pelve
S34.8 Traumatismo de outros nervos e dos não especificados ao nível do abdome, do dorso e da pelve
S35.0 Traumatismo da aorta abdominal
S35.1 Traumatismo da veia cava inferior
S35.2 Traumatismo da artéria celíaca ou mesentérica
S35.3 Traumatismo da veia porta ou esplênica
S35.4 Traumatismo de vaso sangüíneo renal
S35.5 Traumatismo de vaso sangüíneo ilíaco
S35.7 Traumatismo de vasos múltiplos ao nível do abdome, do dorso e da pelve
S35.8 Traumatismo de outros vasos sangüíneos ao nível do abdome, do dorso e da pelve
S35.9 Traumatismo de vaso sangüíneo não especificado ao nível do abdome, do dorso e da pelve
S36.0 Traumatismo do baço
S36.1 Traumatismo do fígado ou da vesícula biliar
S36.2 Traumatismo do pâncreas
S36.3 Traumatismo do estômago
S36.4 Traumatismo do intestino delgado
S36.5 Traumatismo do cólon
S36.6 Traumatismo do reto
S36.7 Traumatismo de múltiplos órgãos intra­abdominais
S36.8 Traumatismo de outros órgãos intra­abdominais
S36.9 Traumatismo de órgão intra­abdominal não especificado
S37.0 Traumatismo do rim
S37.1 Traumatismo do ureter
S37.2 Traumatismo da bexiga
S37.3 Traumatismo da uretra
S37.4 Traumatismo do ovário
S37.5 Traumatismo da trompa de Falópio
S37.6 Traumatismo do útero
S37.7 Traumatismo de múltiplos órgãos pélvicos
S37.8 Traumatismo de outros órgãos pélvicos
S37.9 Traumatismo de órgão pélvico não especificado
S38.0 Lesão por esmagamento dos órgãos genitais externos
S38.1 Lesão por esmagamento de outras partes e de partes não especificadas do abdome, do dorso e
da pelve
S38.2 Amputação traumática de órgãos genitais externos
S38.3 Amputação traumática de outras partes e de partes não especificadas do abdome, do dorso e
da pelve
S39.0 Traumatismo de músculo e de tendão do abdome, do dorso e da pelve
S39.6 Traumatismo de órgão(s) intra­abdominal(is) com órgão(s) pélvico(s)
S39.7 Outros traumatismos múltiplos do abdome, do dorso e da pelve
S39.8 Outros traumatismos especificados do abdome, do dorso e da pelve
S39.9 Traumatismo não especificado do abdome, do dorso e da pelve
S40.0 Contusão do ombro e do braço
S40.7 Traumatismos superficiais múltiplos do ombro e do braço
S40.8 Outros traumatismos superficiais do ombro e do braço
S40.9 Traumatismo superficial não especificado do ombro e do braço
S41.0 Ferimento do ombro
S41.1 Ferimento do braço
S41.7 Ferimentos múltiplos do ombro e do braço
S41.8 Ferimento de outras partes e de partes não especificadas da cintura escapular
S42.0 Fratura da clavícula
S42.1 Fratura da omoplata [escápula]
S42.2 Fratura da extremidade superior do úmero
S42.3 Fratura da diáfise do úmero
S42.4 Fratura da extremidade inferior do úmero
S42.7 Fraturas múltiplas da clavícula, da omoplata [escápula] e do úmero
S42.8 Fratura de outras partes do ombro e do braço
S42.9 Fratura da cintura escapular, parte não especificada
S43.0 Luxação da articulação do ombro
S43.1 Luxação da articulação acromioclavicular
S43.2 Luxação da articulação esternoclavicular
S43.3 Luxação de outras partes e das não especificadas da cintura escapular
S43.4 Entorse e distensão de articulação do ombro
S43.5 Entorse e distensão da articulação acromioclavicular
S43.6 Entorse e distensão da articulação esternoclavicular
S43.7 Entorse e distensão de outras partes e de partes não especificadas da cintura escapular
S44.0 Traumatismo do nervo cubital [ulnar] ao nível do braço
S44.1 Traumatismo do nervo mediano ao nível do braço
S44.2 Traumatismo do nervo radial ao nível do braço
S44.3 Traumatismo do nervo axilar
S44.4 Traumatismo do nervo musculocutâneo
S44.6 Traumatismo do nervo sensitivo cutâneo ao nível do ombro e do braço
S44.7 Traumatismo de múltiplos nervos ao nível do ombro e do braço
S44.8 Traumatismo de outros nervos ao nível do ombro e do braço
S44.9 Traumatismo de nervo não especificado ao nível do ombro e do braço
S45.0 Traumatismo da artéria axilar
S45.1 Traumatismo da artéria braquial
S45.2 Traumatismo da veia axilar ou braquial
S45.3 Traumatismo de veia superficial ao nível do ombro e do braço
S45.7 Traumatismo de múltiplos vasos sangüíneos ao nível do ombro e do braço
S45.8 Traumatismo de outros vasos sangüíneos ao nível do ombro e do braço
S45.9 Traumatismo de vaso sangüíneo não especificado ao nível do ombro e do braço
S46.0 Traumatismo do tendão do manguito rotador do ombro
S46.1 Traumatismo do músculo e tendão da cabeça longa do bíceps
S46.2 Traumatismo do músculo e tendão de outras partes do bíceps
S46.3 Traumatismo do músculo e tendão do tríceps
S46.7 Traumatismo de múltiplos músculos e tendões ao nível do ombro e do braço
S46.8 Traumatismo de outros músculos e tendões ao nível do ombro e do braço
S46.9 Traumatismo de músculo e tendão não especificado ao nível do ombro e do braço
S47 Lesão por esmagamento do ombro e do braço
S48.0 Amputação traumática da articulação do ombro
S48.1 Amputação traumática de localização entre o ombro e o cotovelo
S48.9 Amputação traumática do ombro e do braço, de localização não especificada
S49.7 Traumatismos múltiplos do ombro e do braço
S49.8 Outros traumatismos especificados do ombro e do braço
S49.9 Traumatismo não especificado do ombro e do braço
S50.0 Contusão do cotovelo
S50.1 Contusão de outras partes e de partes não especificadas do antebraço
S50.7 Traumatismos superficiais múltiplos do antebraço
S50.8 Outros traumatismos superficiais do antebraço
S50.9 Traumatismo superficial do antebraço, não especificado
S51.0 Ferimento do cotovelo
S51.7 Ferimentos múltiplos do antebraço
S51.8 Ferimento de outras partes do antebraço
S51.9 Ferimento do antebraço, parte não especificado
S52.0 Fratura da extremidade superior do cúbito [ulna]
S52.1 Fratura da extremidade superior do rádio
S52.2 Fratura da diáfise do cúbito [ulna]
S52.3 Fratura da diáfise do rádio
S52.4 Fratura das diáfises do rádio e do cúbito [ulna]
S52.5 Fratura da extremidade distal do rádio
S52.6 Fratura da extremidade distal do rádio e do cúbito [ulna]
S52.7 Fraturas múltiplas do antebraço
S52.8 Fratura de outras partes do antebraço
S52.9 Fratura do antebraço, parte não especificada
S53.0 Luxação da cabeça do rádio
S53.1 Luxação do cotovelo, não especificada
S53.2 Ruptura traumática do ligamento colateral do rádio
S53.3 Ruptura traumática do ligamento colateral do cúbito [ulna]
S53.4 Entorse e distensão do cotovelo
S54.0 Traumatismo do nervo cubital [ulnar] ao nível do antebraço
S54.1 Traumatismo do nervo mediano ao nível do antebraço
S54.2 Traumatismo do nervo radial ao nível do antebraço
S54.3 Traumatismo do nervo cutâneo sensitivo ao nível do antebraço
S54.7 Traumatismo de múltiplos nervos ao nível do antebraço
S54.8 Traumatismo de outros nervos ao nível do antebraço
S54.9 Traumatismo de nervo não especificado ao nível do antebraço
S55.0 Traumatismo da artéria cubital [ulnar] ao nível do antebraço
S55.1 Traumatismo da artéria radial ao nível do antebraço
S55.2 Traumatismo de veia ao nível do antebraço
S55.7 Traumatismo de múltiplos vasos sangüíneos ao nível do antebraço
S55.8 Traumatismo de outros vasos sangüíneos ao nível do antebraço
S55.9 Traumatismo de vasos sangüíneos não especificados ao nível do antebraço
S56.0 Traumatismo do músculo flexor e tendão do polegar ao nível do antebraço
S56.1 Traumatismo do músculo flexor e tendão de outro(s) dedo(s) ao nível do antebraço
S56.2 Traumatismo de outro músculo flexor e tendão ao nível do antebraço
S56.3 Traumatismo dos músculos extensor ou abdutor e tendões do polegar ao nível do antebraço
S56.4 Traumatismo do músculo extensor e tendão de outro(s) dedo(s) ao nível do antebraço
S56.5 Traumatismo de outros músculos extensores e tendões ao nível do antebraço
S56.7 Traumatismo de músculos e tendões múltiplos ao nível do antebraço
S56.8 Traumatismo de outros músculos e tendões e dos não especificados ao nível do antebraço
S57.0 Lesão por esmagamento do cotovelo
S57.1 Lesão por esmagamento de outras partes do antebraço
S57.9 Lesão por esmagamento de parte não especificada do antebraço
S58.0 Amputação traumática ao nível do cotovelo
S58.1 Amputação traumática do antebraço entre o cotovelo e o punho
S58.9 Amputação traumática do antebraço, nível não especificado
S59.7 Traumatismos múltiplos do cotovelo
S59.8 Outros traumatismos especificados do antebraço
S59.9 Traumatismo não especificado do antebraço
S60.0 Contusão de dedo(s) sem lesão da unha
S60.1 Contusão de dedo(s) com lesão da unha
S60.2 Contusão de outras partes do punho e da mão
S60.7 Traumatismos superficiais múltiplos do punho e da mão
S60.8 Outros traumatismos superficiais do punho e da mão
S60.9 Traumatismo superficial não especificado do punho e da mão
S61.0 Ferimento de dedo(s) sem lesão da unha
S61.1 Ferimento de dedo(s) com lesão da unha
S61.7 Ferimentos múltiplos do punho e da mão
S61.8 Ferimento de outras partes do punho e da mão
S61.9 Ferimento do punho e da mão, parte não especificada
S62.0 Fratura do osso navicular [escafoíde] da mão
S62.1 Fratura de outro(s) osso(s) do carpo
S62.2 Fratura do primeiro metacarpiano
S62.3 Fratura de outros ossos do metacarpo
S62.4 Fraturas múltiplas de ossos metacarpianos
S62.5 Fratura do polegar
S62.6 Fratura de outros dedos
S62.7 Fraturas múltiplas de dedo(s)
S62.8 Fratura de outras partes e de partes não especificadas do punho e da mão
S63.0 Luxação do punho
S63.1 Luxação do dedo
S63.2 Luxações múltiplas dos dedos
S63.3 Ruptura traumática de ligamento(s) do punho e do carpo
S63.4 Ruptura traumática do ligamento do dedo nas articulações metacarpofalangianas e
interfalangianas
S63.5 Entorse e distensão do punho
S63.6 Entorse e distensão do(s) dedo(s)
S63.7 Entorse e distensão de outras partes e das não especificadas da mão
S64.0 Traumatismo do nervo cubital [ulnar] ao nível do punho e da mão
S64.1 Traumatismo do nervo mediano ao nível do punho e da mão
S64.2 Traumatismo do nervo radial ao nível do punho e da mão
S64.3 Traumatismo do nervo digital do polegar
S64.4 Traumatismo do nervo digital de outro dedo
S64.7 Traumatismo de múltiplos nervos ao nível de punho e da mão
S64.8 Traumatismo de outros nervos ao nível do punho e da mão
S64.9 Traumatismo de nervo não especificado ao nível do punho e da mão
S65.0 Traumatismo da artéria cubital [ulnar] ao nível do punho e da mão
S65.1 Traumatismo da artéria radial ao nível do punho e da mão
S65.2 Traumatismo do arco palmar superficial
S65.3 Traumatismo do arco palmar profundo
S65.4 Traumatismo de vaso(s) sangüíneo(s) do polegar
S65.5 Traumatismo de vaso(s) sangüíneo(s) de outro dedo
S65.7 Traumatismo de vasos sangüíneos múltiplos ao nível de punho e da mão
S65.8 Traumatismo de outros vasos sangüíneos ao nível do punho e de mão
S65.9 Traumatismo de vaso sangüíneo não especificado ao nível do punho e da mão
S66.0 Traumatismo do músculo flexor longo e tendão do polegar ao nível do punho e da mão
S66.1 Traumatismo do músculo flexor e tendão de outro dedo ao nível do punho e da mão
S66.2 Traumatismo do músculo extensor e tendão do polegar ao nível do punho e da mão
S66.3 Traumatismo do músculo extensor e tendão de outro dedo ao nível do punho e da mão
S66.4 Traumatismo do músculo intrínseco e tendão do polegar ao nível do punho e da mão
S66.5 Traumatismo do músculo intrínseco e tendão de outro dedo ao nível do punho e da mão
S66.6 Traumatismo de músculos flexores e tendões múltiplos ao nível do punho e da mão
S66.7 Traumatismo de músculos extensores e tendões múltiplos ao nível do punho e da mão
S66.8 Traumatismo de outros músculos e tendões ao nível do punho e da mão
S66.9 Traumatismo de músculo e tendão não especificado ao nível do punho e da mão
S67.0 Lesão por esmagamento do polegar e de outro(s) dedo(s)
S67.8 Lesão por esmagamento de outras partes e das não especificadas do punho e da mão
S68.0 Amputação traumática do polegar (completa) (parcial)
S68.1 Amputação traumática de um outro dedo apenas (completa) (parcial)
S68.2 Amputação traumática de dois ou mais dedos somente (completa) (parcial)
S68.3 Amputação traumática combinada de (partes de) dedo(s) associada a outras partes do punho e
da mão
S68.4 Amputação traumática da mão ao nível do punho
S68.8 Amputação traumática de outras partes do punho e da mão
S68.9 Amputação traumática do punho e da mão, nível não especificado
S69.7 Traumatismos múltiplos do punho e da mão
S69.8 Outros traumatismos especificados do punho e da mão
S69.9 Traumatismo não especificados do punho e da mão
S70.0 Contusão do quadril
S70.1 Contusão da coxa
S70.7 Traumatismos superficiais múltiplos do quadril e da coxa
S70.8 Outros traumatismos superficiais do quadril e da coxa
S70.9 Traumatismo superficial não especificado do quadril e da coxa
S71.0 Ferimento do quadril
S71.1 Ferimento da coxa
S71.7 Ferimentos múltiplos do quadril e da coxa
S71.8 Ferimentos de outras partes e das não especificadas da cintura pélvica
S72.0 Fratura do colo do fêmur
S72.1 Fratura pertrocantérica
S72.2 Fratura subtrocantérica
S72.3 Fratura da diáfise do fêmur
S72.4 Fratura da extremidade distal do fêmur
S72.7 Fraturas múltiplas do fêmur
S72.8 Fraturas de outras partes do fêmur
S72.9 Fratura do fêmur, parte não especificada
S73.0 Luxação da articulação do quadril
S73.1 Entorse e distensão do quadril
S74.0 Traumatismo do nervo ciático ao nível do quadril e da coxa
S74.1 Traumatismo do nervo femural ao nível do quadril e da coxa
S74.2 Traumatismo do nervo sensitivo cutâneo ao nível do quadril e da coxa
S74.7 Traumatismo de nervos múltiplos ao nível do quadril e da coxa
S74.8 Traumatismo de outros nervos ao nível do quadril e da coxa
S74.9 Traumatismo de nervo não especificado ao nível do quadril e da coxa
S75.0 Traumatismo da artéria femural
S75.1 Traumatismo da veia femural ao nível do quadril e da coxa
S75.2 Traumatismo da veia grande safena ao nível do quadril e da coxa
S75.7 Traumatismo de múltiplos vasos sangüíneos ao nível do quadril e da coxa
S75.8 Traumatismo de outros vaso sangüíneos ao nível do quadril e da coxa
S75.9 Traumatismo de vaso sangüíneo não especificado ao nível do quadril e da coxa
S76.0 Traumatismo do músculo e do tendão do quadril
S76.1 Traumatismo do músculo e do tendão do quadríceps
S76.2 Traumatismo do músculo e do tendão do adutor da coxa
S76.3 Traumatismo do músculo e do tendão dos músculos posteriores ao nível da coxa
S76.4 Traumatismo de outros músculos e tendões e os não especificados ao nível da coxa
S76.7 Traumatismo de múltiplos músculos e tendões ao nível do quadril e da coxa
S77.0 Lesão por esmagamento do quadril
S77.1 Lesão por esmagamento da coxa
S77.2 Lesão por esmagamento do quadril e da coxa
S78.0 Amputação traumática na articulação do quadril
S78.1 Amputação traumática localizada entre o joelho e o quadril
S78.9 Amputação traumática do quadril e coxa nível não especificado
S79.7 Traumatismos múltiplos do quadril e da coxa
S79.8 Outros traumatismos especificados do quadril e da coxa
S79.9 Traumatismo não especificado do quadril e da coxa
S80.0 Contusão do joelho
S80.1 Contusão de outras partes e de partes não especificadas da perna
S80.7 Traumatismos superficiais múltiplos da perna
S80.8 Outros traumatismos superficiais da perna
S80.9 Traumatismo superficial não especificado da perna
S81.0 Ferimento do joelho
S81.7 Ferimentos múltiplos da perna
S81.8 Ferimento de outras partes da perna
S81.9 Ferimento da perna, parte não especificada
S82.0 Fratura da rótula [patela]
S82.1 Fratura da extremidade proximal da tíbia
S82.2 Fratura da diáfise da tíbia
S82.3 Fratura da extremidade distal da tíbia
S82.4 Fratura do perônio [fíbula]
S82.5 Fratura do maléolo medial
S82.6 Fratura do maléolo lateral
S82.7 Fraturas múltiplas da perna
S82.8 Fratura de outras partes da perna
S82.9 Fratura da perna, parte não especificada
S83.0 Luxação da rótula [patela]
S83.1 Luxação do joelho
S83.2 Ruptura do menisco, atual
S83.3 Ruptura atual da cartilagem da articulação do joelho
S83.4 Entorse e distensão envolvendo ligamento colateral (peronial) (tibial) do joelho
S83.5 Entorse e distensão envolvendo ligamento cruzado (anterior) (posterior) do joelho
S83.6 Entorse e distensão de outras partes e das não especificadas do joelho
S83.7 Traumatismo de estruturas múltiplas do joelho
S84.0 Traumatismo do nervo tibial ao nível da perna
S84.1 Traumatismo do nervo peronial ao nível da perna
S84.2 Traumatismo do nervo cutâneo sensitivo ao nível da perna
S84.7 Traumatismo de múltiplos nervos ao nível da perna
S84.8 Traumatismo de outros nervos ao nível da perna
S84.9 Traumatismo de nervo não especificado ao nível da perna
S85.0 Traumatismo da artéria poplítea
S85.1 Traumatismo da artéria tibial (anterior) (posterior)
S85.2 Traumatismo da artéria peronial
S85.3 Traumatismo da veia grande safena ao nível da perna
S85.4 Traumatismo da veia safena menor ao nível da perna
S85.5 Traumatismo da veia poplítea
S85.7 Traumatismo de múltiplos vasos sangüíneos ao nível da perna
S85.8 Traumatismo de outros vasos sangüíneos ao nível da perna
S85.9 Traumatismo de vasos sangüíneos não especificados ao nível da perna
S86.0 Traumatismo do tendão de Aquiles
S86.1 Traumatismo de outro(s) músculo(s) e tendão(ões) do grupo muscular posterior ao nível da
perna
S86.2 Traumatismo do(s) músculo(s) e tendão(ões) do grupo muscular anterior ao nível da perna
S86.3 Traumatismo do(s) músculo(s) e tendão(ões) do grupo muscular peronial ao nível da perna
S86.7 Traumatismo de múltiplos músculos e tendões ao nível da perna
S86.8 Traumatismos de outros músculos e tendões ao nível da perna
S86.9 Traumatismo de músculo e de tendão não especificado ao nível da perna
S87.0 Traumatismo por esmagamento do joelho
S87.8 Traumatismo por esmagamento de outra parte e de partes não especificadas da perna
S88.0 Amputação traumática ao nível do joelho
S88.1 Amputação traumática entre o joelho e o tornozelo
S88.9 Amputação traumática da perna ao nível não especificado
S89.0 Traumatismos múltiplos da perna
S89.8 Outros traumatismos especificados da perna
S89.9 Traumatismo não especificado da perna
S90.0 Contusão do tornozelo
S90.1 Contusão de artelho sem lesão da unha
S90.2 Contusão de artelho(s) com lesão da unha
S90.3 Contusão de outras partes e partes não especificadas do pé
S90.7 Traumatismos superficiais múltiplos do tornozelo e do pé
S90.8 Outros traumatismos superficiais do tornozelo e do pé
S90.9 Traumatismo superficial do tornozelo e do pé, não especificado
S91.0 Ferimento do tornozelo
S91.1 Ferimento do(s) artelho(s) sem lesão da unha
S91.2 Ferimento do(s) artelho(s) com lesão da unha
S91.3 Ferimento de outras partes do pé
S91.7 Ferimentos múltiplos do tornozelo e do pé
S92.0 Fratura do calcâneo
S92.1 Fratura do astrágalo
S92.2 Fratura de outros ossos do tarso
S92.3 Fratura de ossos do metatarso
S92.4 Fratura do hálux
S92.5 Fratura de outro artelho
S92.7 Fraturas múltiplas do pé
S92.9 Fratura do pé não especificada
S93.0 Luxação da articulação do tornozelo
S93.1 Luxação do(s) artelho(s)
S93.2 Ruptura de ligamentos ao nível do tornozelo e do pé
S93.3 Luxação de outras partes e das não especificadas do pé
S93.4 Entorse e distensão do tornozelo
S93.5 Entorse e distensão do(s) artelho(s)
S93.6 Entorse e distensão de outras partes e de partes não especificadas do pé
S94.0 Traumatismo do nervo plantar externo (lateral)
S94.1 Traumatismo do nervo plantar interno (medial)
S94.2 Traumatismo nervo peronial [fibular] profundo ao nível do tornozelo e do pé
S94.3 Traumatismo do nervo sensitivo cutâneo ao nível do tornozelo e do pé
S94.7 Traumatismo de múltiplos nervos ao nível do tornozelo e do pé
S94.8 Traumatismo de outros nervos ao nível do tornozelo e do pé
S94.9 Traumatismo de nervo não especificado, ao nível do tornozelo e do pé
S95.0 Traumatismo da artéria dorsal do pé
S95.1 Traumatismo da artéria plantar do pé
S95.2 Traumatismo da veia dorsal do pé
S95.7 Traumatismo de múltiplos vasos sangüíneos ao nível do tornozelo e do pé
S95.8 Traumatismo de outros vasos sangüíneos ao nível do tornozelo e do pé
S95.9 Traumatismo de vaso sangüíneo não especificado ao nível do tornozelo e do pé
S96.0 Traumatismo do músculo e tendão do músculo flexor longo do(s) artelho(s) ao nível do tornozelo
e do pé
S96.1 Traumatismo do músculo e tendão do extensor longo do(s) artelho(s) ao nível do tornozelo e do
pé
S96.2 Traumatismo de músculo intrínseco e tendão ao nível do tornozelo e do pé
S96.7 Traumatismo de múltiplos músculos e tendões ao nível do tornozelo e do pé
S96.8 Traumatismo de outros tendões e músculos ao nível do tornozelo e do pé
S96.9 Traumatismo de músculo e tendão não especificados do tornozelo e do pé
S97.0 Lesão por esmagamento do tornozelo
S97.1 Lesão por esmagamento do(s) artelho(s)
S97.8 Lesão por esmagamento de outras partes do tornozelo e do pé
S98.0 Amputação traumática do pé ao nível do tornozelo
S98.1 Amputação traumática de apenas um artelho
S98.2 Amputação traumática de dois ou mais artelhos
S98.3 Amputação traumática de outras partes do pé
S98.4 Amputação traumática do pé ao nível não especificado
S99.7 Traumatismos múltiplos do tornozelo e do pé
S99.8 Outros traumatismos especificados do tornozelo e do pé
S99.9 Traumatismos não especificados do tornozelo e do pé
T00.0 Traumatismos superficiais envolvendo a cabeça com o pescoço
T00.1 Traumatismos superficiais envolvendo o tórax com o abdome, parte inferior do dorso e da pelve
T00.2 Traumatismos superficiais envolvendo regiões múltiplas do(s) membro(s) superior(es)
T00.3 Traumatismos superficiais envolvendo regiões múltiplas do(s) membro(s) inferior(es)
T00.6 Traumatismos superficiais envolvendo regiões múltiplas dos membros superiores com
membro(s) inferiores
T00.8 Traumatismos superficiais envolvendo outras combinações de regiões do corpo
T00.9 Traumatismos superficiais múltiplos não especificados
T01.0 Ferimentos envolvendo a cabeça com o pescoço
T01.1 Ferimentos envolvendo o tórax com o abdome, parte inferior do dorso e da pelve
T01.2 Ferimentos envolvendo regiões múltiplas do(s) membro(s) superior(es)
T01.3 Ferimentos envolvendo múltiplas regiões do(s) membro(s) inferior(es)
T01.6 Ferimentos envolvendo regiões múltiplas do(s) membro(s) superior(es) com membro(s)
inferior(es)
T01.8 Ferimentos envolvendo outras combinações de regiões do corpo
T01.9 Ferimentos múltiplos não especificados
T02.0 Fraturas envolvendo cabeça com pescoço
T02.1 Fraturas envolvendo tórax com parte inferior do dorso e da pelve
T02.2 Fraturas envolvendo regiões múltiplas de um membro superior
T02.3 Fraturas envolvendo regiões múltiplas de um membro inferior
T02.4 Fraturas envolvendo regiões múltiplas de ambos os membros superiores
T02.5 Fraturas envolvendo regiões múltiplas de ambos os membros inferiores
T02.6 Fraturas envolvendo regiões múltiplas do(s) membro(s) superior(es) com inferior(es)
T02.7 Fraturas envolvendo tórax com parte inferior do dorso e pelve com membro(s)
T02.8 Fraturas envolvendo outras combinações de regiões do corpo
T02.9 Fraturas múltiplas não especificadas
T03.0 Luxações, entorses e distensões envolvendo a cabeça com o pescoço
T03.1 Luxações, entorses e distensões envolvendo tórax com parte inferior do dorso e da pelve
T03.2 Luxações, entorses e distensões envolvendo regiões múltiplas de membro(s) superior(es)
T03.3 Luxações, entorses e distensões envolvendo regiões múltiplas do(s) membro(s) inferior(es)
T03.4 Luxações, entorses e distensões envolvendo regiões múltiplas dos membros superiores com
inferiores
T03.8 Luxações, entorses e distensões envolvendo outras combinações de regiões do corpo
T03.9 Luxações, entorses e distensões múltiplas, não especificadas
T04.0 Traumatismos por esmagamento envolvendo a cabeça com o pescoço
T04.1 Traumatismos por esmagamento envolvendo tórax com o abdome, parte inferior do dorso e da
pelve
T04.2 Traumatismos por esmagamento envolvendo regiões múltiplas do(s) membro(s) superior(es)
T04.3 Traumatismos por esmagamento envolvendo regiões múltiplas do(s) membro(s) inferior(es)
T04.4 Traumatismos por esmagamento envolvendo regiões múltiplas do(s) membro(s) superior(es)
com inferior(es)
T04.7 Traumatismo por esmagamento do tórax com abdome, parte inferior do dorso, pelve e
membro(s)
T04.8 Traumatismos por esmagamento envolvendo outras combinações de regiões do corpo
T04.9 Traumatismo múltiplos por esmagamento não especificados
T05.0 Amputação traumática de ambas as mãos
T05.1 Amputação traumática de uma mão e de um outro braço [qualquer nível, exceto mão]
T05.2 Amputação traumática de ambos os braços [qualquer nível]
T05.3 Amputação traumática de ambos os pés
T05.4 Amputação traumática de um pé e outra perna [qualquer nível, exceto pé]
T05.5 Amputação traumática de ambas as pernas [qualquer nível]
T05.6 Amputação traumática de membros superiores e inferiores, qualquer combinação [qualquer
nível]
T05.8 Amputações traumáticas envolvendo outras combinações de regiões do corpo
T05.9 Amputações traumáticas múltiplas não especificadas
T06.0 Traumatismos de cérebro e nervos cranianos com traumatismos de nervos e da medula espinhal
ao nível do pescoço
T06.1 Traumatismos de nervos e da medula espinhal envolvendo outras regiões múltiplas do corpo
T06.2 Traumatismos de nervos envolvendo regiões múltiplas do corpo
T06.3 Traumatismos de vasos sangüíneos envolvendo regiões múltiplas do corpo
T06.4 Traumatismos de músculos e de tendões envolvendo regiões múltiplas do corpo
T06.5 Traumatismos de órgãos intratorácicos com órgãos intra­abdominais e pélvicos
T06.8 Outros traumatismos especificados envolvendo regiões múltiplas do corpo
T07 Traumatismos múltiplos não especificados
T08 Fratura da coluna, nível não especificado
T09.0 Traumatismo superficial do tronco, nível não especificado
T09.1 Ferimento do tronco, nível não especificado
T09.2 Luxação, entorse e distensão de articulações e ligamentos não especificados do tronco
T09.3 Traumatismo de medula espinhal, nível não especificado
T09.4 Traumatismo de nervos, de raízes de nervos espinhais e de plexos não especificados do tronco
T09.5 Traumatismo de músculo e tendão não especificados do tronco
T09.6 Amputação traumática do tronco, nível não especificado
T09.8 Outros traumatismos especificados do tronco, nível não especificado
T09.9 Traumatismo não especificado do tronco, nível não especificado
T10 Fratura do membro superior, nível não especificado
T11.0 Traumatismo superficial do membro superior, nível não especificado
T11.1 Ferimento do membro superior, nível não especificado
T11.2 Luxação, entorse e distensão de articulação e ligamento não especificados do membro superior,
nível não especificado
T11.3 Traumatismo de nervo não especificado do membro superior, nível não especificado
T11.4 Traumatismo de vaso sangüíneo não especificado, do membro superior, nível não especificado
T11.5 Traumatismo de músculo e tendão não especificado do membro superior, nível não especificado
T11.6 Amputação traumática do membro superior, nível não especificado
T11.8 Outros traumatismos especificados do membro superior nível não especificado
T11.9 Traumatismo não especificado do membro superior nível não especificado
T12 Fratura do membro inferior, nível não especificado
T13.0 Traumatismo superficial de membro inferior, nível não especificado
T13.1 Ferimento de membro inferior, nível não especificado
T13.2 Luxação, entorse e distensão de articulação e ligamento não especificados de membro inferior,
nível não especificado
T13.3 Traumatismo de nervo não especificado de membro inferior, nível não especificado
T13.4 Traumatismo de vaso sangüíneo não especificado de membro inferior, nível não especificado
T13.5 Traumatismo de músculo e tendão não especificado de membro inferior, nível não especificado
T13.6 Amputação traumática de membro inferior, nível não especificado
T13.8 Outros traumatismos especificados de membro inferior, nível não especificado
T13.9 Traumatismo não especificado do membro inferior, nível não especificado
T14.0 Traumatismo superficial de região não especificada do corpo
T14.1 Ferimento de região não especificada do corpo
T14.2 Fratura de região não especificada do corpo
T14.3 Luxação, entorse e distensão de região não especificada do corpo
T14.4 Traumatismo de nervo(s) de região não especificada do corpo
T14.5 Traumatismo de vaso(s) sangüíneo(s) de região não especificada do corpo
T14.6 Traumatismo de músculos e tendões de região não especificada do corpo
T14.7 Traumatismo por esmagamento e amputação traumática de regiões não especificadas do corpo
T14.8 Outros traumatismos de região não especificada do corpo
T14.9 Traumatismo não especificado
T15.0 Corpo estranho na córnea
T15.1 Corpo estranho no saco conjuntival
T15.8 Corpo estranho em outros locais e em locais múltiplos da parte externa do olho
T15.9 Corpo estranho em parte não especificada da região externa do olho
T16 Corpo estranho no ouvido
T17.0 Corpo estranho no seio nasal
T17.1 Corpo estranho na narina
T17.2 Corpo estranho na faringe
T17.3 Corpo estranho na laringe
T17.4 Corpo estranho na traquéia
T17.5 Corpo estranho no brônquio
T17.8 Corpo estranho em outras partes e partes múltiplas do trato respiratório
T17.9 Corpo estranho no trato respiratório, parte não especificada
T18.0 Corpo estranho na boca
T18.1 Corpo estranho no esôfago
T18.2 Corpo estranho no estômago
T18.3 Corpo estranho no intestino delgado
T18.4 Corpo estranho no cólon
T18.5 Corpo estranho no ânus e reto
T18.8 Corpo estranho em outras partes e partes múltiplas do aparelho digestivo
T18.9 Corpo estranho em parte não especificada do aparelho digestivo
T19.0 Corpo estranho na uretra
T19.1 Corpo estranho na bexiga
T19.2 Corpo estranho na vulva e vagina
T19.3 Corpo estranho no útero [qualquer parte]
T19.8 Corpo estranho em outras partes e partes múltiplas do trato geniturinário
T19.9 Corpo estranho no trato geniturinário, parte não especificada
T20.0 Queimadura da cabeça e do pescoço, grau não especificado
T20.1 Queimadura de primeiro grau da cabeça e do pescoço
T20.2 Queimadura de segundo grau da cabeça e do pescoço
T20.3 Queimadura de terceiro grau da cabeça e do pescoço
T20.4 Corrosão da cabeça e do pescoço, grau não especificado
T20.5 Corrosão de primeiro grau da cabeça e do pescoço
T20.6 Corrosão de segundo grau da cabeça e do pescoço
T20.7 Corrosão de terceiro grau da cabeça e do pescoço
T21.0 Queimadura do tronco, grau não especificado
T21.1 Queimadura de primeiro grau do tronco
T21.2 Queimadura de segundo grau do tronco
T21.3 Queimadura de terceiro grau do tronco
T21.4 Corrosão do tronco, grau não especificado
T21.5 Corrosão de primeiro grau do tronco
T21.6 Corrosão de segundo grau do tronco
T21.7 Corrosão de terceiro grau do tronco
T22.0 Queimadura do ombro e do membro superior, exceto punho e mão, grau não especificado
T22.1 Queimadura de primeiro grau do ombro e do membro superior, exceto punho e mão
T22.2 Queimadura de segundo grau do ombro e do membro superior, exceto punho e mão
T22.3 Queimadura de terceiro grau do ombro e do membro superior, exceto punho e mão
T22.4 Corrosão do ombro e do membro superior, exceto punho e mão, grau não especificado
T22.5 Corrosão de primeiro grau do ombro e do membro superior, exceto punho e mão
T22.6 Corrosão de segundo grau do ombro e do membro superior, exceto punho e mão
T22.7 Corrosão de terceiro grau do ombro e do membro superior, exceto punho e mão
T23.0 Queimadura do punho e da mão, grau não especificado
T23.1 Queimadura de primeiro grau do punho e da mão
T23.2 Queimadura de segundo grau do punho e da mão
T23.3 Queimadura de terceiro grau do punho e da mão
T23.4 Corrosão do punho e da mão, grau não especificado
T23.5 Corrosão de primeiro grau do punho e da mão
T23.6 Corrosão de segundo grau do punho e da mão
T23.7 Corrosão de terceiro grau do punho e da mão
T24.0 Queimadura do quadril e membro inferior, exceto tornozelo e do pé, grau não especificado
T24.1 Queimadura de primeiro grau do quadril e do membro inferior, exceto tornozelo e do pé
T24.2 Queimadura de segundo grau do quadril e do membro inferior, exceto tornozelo e do pé
T24.3 Queimadura de terceiro grau do quadril e do membro inferior, exceto tornozelo e do pé
T24.4 Corrosão do quadril e do membro inferior, exceto tornozelo e do pé, grau não especificado
T24.5 Corrosão de primeiro grau do quadril e do membro inferior, exceto tornozelo e do pé
T24.6 Corrosão de segundo grau do quadril e do membro inferior, exceto tornozelo e do pé
T24.7 Corrosão de terceiro grau do quadril e do membro inferior, exceto tornozelo e do pé
T25.0 Queimadura do tornozelo e do pé, grau não especificado
T25.1 Queimadura de primeiro grau do tornozelo e do pé
T25.2 Queimadura de segundo grau do tornozelo e do pé
T25.3 Queimadura de terceiro grau do tornozelo e do pé
T25.4 Corrosão do tornozelo e do pé, grau não especificado
T25.5 Corrosão de primeiro grau do tornozelo e do pé
T25.6 Corrosão de segundo grau do tornozelo e do pé
T25.7 Corrosão de terceiro grau do tornozelo e do pé
T26.0 Queimadura da pálpebra e da região periocular
T26.1 Queimadura da córnea e do saco conjuntival
T26.2 Queimadura com resultante ruptura e destruição do globo ocular
T26.3 Queimadura de outras partes do olho e anexos
T26.4 Queimadura do olho e anexos, parte não especificada
T26.5 Corrosão da pálpebra e da região periocular
T26.6 Corrosão da córnea e do saco conjuntival
T26.7 Corrosão com resultante ruptura e destruição do globo ocular
T26.8 Corrosão de outras partes do olho e anexos
T26.9 Corrosão do olho e anexos, parte não especificada
T27.0 Queimadura da laringe e traquéia
T27.1 Queimadura da laringe, traquéia com pulmão
T27.2 Queimadura de outras partes do trato respiratório
T27.3 Queimadura do trato respiratório, parte não especificada
T27.4 Corrosão da laringe e traquéia
T27.5 Corrosão da laringe, traquéia com corrosão de pulmão
T27.6 Corrosão de outras partes do trato respiratório
T27.7 Corrosão do trato respiratório, parte não especificada
T28.0 Queimadura da boca e da faringe
T28.1 Queimadura do esôfago
T28.2 Queimadura de outras partes do trato alimentar
T28.3 Queimadura dos órgãos geniturinários internos
T28.4 Queimadura de outros órgãos internos e dos não especificados
T28.5 Corrosão da boca e faringe
T28.6 Corrosão do esôfago
T28.7 Corrosão de outras partes do trato alimentar
T28.8 Corrosão de órgãos geniturinários internos
T28.9 Corrosão de outros órgãos internos e dos não especificados
T29.0 Queimaduras múltiplas, grau não especificado
T29.1 Queimaduras múltiplas, sem mencionar queimadura(s) ultrapassando o primeiro grau
T29.2 Queimaduras múltiplas, sem mencionar queimadura(s) ultrapassando o segundo grau
T29.3 Queimaduras múltiplas, mencionando ao menos uma queimadura de terceiro grau
T29.4 Corrosões múltiplas, grau não especificado
T29.5 Corrosões múltiplas, sem mencionar corrosão(ões) ultrapassando o primeiro grau
T29.6 Corrosões múltiplas, sem mencionar corrosão(ões) ultrapassando o segundo grau
T29.7 Corrosões múltiplas, mencionado ao menos uma corrosão de terceiro grau
T30.0 Queimadura, parte do corpo não especificada, grau não especificado
T30.1 Queimadura de primeiro grau, parte do corpo não especificada
T30.2 Queimadura de segundo grau, parte do corpo não especificada
T30.3 Queimadura de terceiro grau, parte do corpo não especificada
T30.4 Corrosão, parte do corpo não especificada, grau não especificado
T30.5 Corrosão de primeiro grau, parte do corpo não especificada
T30.6 Corrosão de segundo grau, parte do corpo não especificada
T30.7 Corrosão de terceiro grau, parte do corpo não especificada
T31.0 Queimaduras envolvendo menos de 10% da superfície corporal
T31.1 Queimaduras envolvendo de 10 ­ 19% da superfície corporal
T31.2 Queimaduras envolvendo de 20 ­ 29% da superfície corporal
T31.3 Queimaduras envolvendo de 30 ­ 39% da superfície corporal
T31.4 Queimaduras envolvendo de 40 ­ 49% da superfície corporal
T31.5 Queimaduras envolvendo de 50 ­ 59% da superfície corporal
T31.6 Queimaduras envolvendo de 60 ­ 69% da superfície corporal
T31.7 Queimaduras envolvendo de 70 ­ 79% da superfície corporal
T31.8 Queimaduras envolvendo de 80 ­ 89% da superfície corporal
T31.9 Queimaduras envolvendo 90% ou mais da superfície corporal
T32.0 Corrosões envolvendo menos de 10% da superfície corporal
T32.1 Corrosões envolvendo 10 ­ 19% da superfície corporal
T32.2 Corrosões envolvendo 20 ­ 29% da superfície corporal
T32.3 Corrosões envolvendo 30 ­ 39% da superfície corporal
T32.4 Corrosões envolvendo 40 ­ 49% da superfície corporal
T32.5 Corrosões envolvendo 50 ­ 59% da superfície corporal
T32.6 Corrosões envolvendo 60 ­ 69% da superfície corporal
T32.7 Corrosões envolvendo 70 ­ 79% da superfície corporal
T32.8 Corrosões envolvendo 80 ­ 89% da superfície corporal
T32.9 Corrosões envolvendo 90% ou mais da superfície corporal
T33.0 Geladura superficial da cabeça
T33.1 Geladura superficial do pescoço
T33.2 Geladura superficial do tórax
T33.3 Geladura superficial da parede abdominal, parte inferior do dorso e da pelve
T33.4 Geladura superficial do braço
T33.5 Geladura superficial do punho e da mão
T33.6 Geladura superficial do quadril e da coxa
T33.7 Geladura superficial do joelho e da perna
T33.8 Geladura superficial do tornozelo e do pé
T33.9 Geladura superficial de outros locais e de locais não especificados
T34.0 Geladura, com necrose de tecidos, da cabeça
T34.1 Geladura, com necrose de tecidos, do pescoço
T34.2 Geladura, com necrose de tecidos, do tórax
T34.3 Geladura, com necrose de tecidos, da parede abdominal, parte inferior do dorso e da pelve
T34.4 Geladura, com necrose de tecidos, do braço
T34.5 Geladura, com necrose de tecidos, do punho e da mão
T34.6 Geladura, com necrose de tecidos, do quadril e da coxa
T34.7 Geladura, com necrose de tecidos, do joelho e da perna
T34.8 Geladura, com necrose de tecidos, do tornozelo e do pé
T34.9 Geladura, com necrose de tecidos, de localização não especificada
T35.0 Geladura superficial envolvendo múltiplas partes do corpo
T35.1 Geladura, com necrose de tecidos, de múltiplas partes do corpo
T35.2 Geladura, de grau não especificado, da cabeça e do pescoço
T35.3 Geladura, de grau não especificado, do tórax, abdome, parte inferior do dorso e da pelve
T35.4 Geladura, de grau não especificado, do membro superior
T35.5 Geladura, de grau não especificado, do membro inferior
T35.6 Geladura, de grau não especificado, de múltiplas partes do corpo
T35.7 Geladura, de grau não especificado, de localização não especificada
T36.0 Penicilinas
T36.1 Cefalosporinas e outras betalactaminas
T36.2 Grupo do cloranfenicol
T36.3 Macrolídios
T36.4 Tetraciclinas
T36.5 Aminoglicosídeos
T36.6 Rifamicinas
T36.7 Antibióticos antifúngicos administrados por via sistêmica
T36.8 Outros antibióticos sistêmicos
T36.9 Antibióticos sistêmicos não especificados
T37.0 Sulfonamidas
T37.1 Drogas antimicobacterianas
T37.2 Antimaláricos e drogas que atuam sobre outros protozoários do sangue
T37.3 Outros medicamentos antiprotozoários
T37.4 Anti­helmínticos
T37.5 Drogas antivirais
T37.8 Outros agentes antiinfecciosos e antiparasitários especificados
T37.9 Agentes antiinfecciosos e antiparasitários sistêmicos não especificados
T38.0 Glicocorticóides e análogos sintéticos
T38.1 Hormônios tireoidianos e seus derivados
T38.2 Medicamentos antitireoidianos
T38.3 Insulina e drogas hipoglicemiantes orais [antidiabéticos]
T38.4 Anticoncepcionais orais
T38.5 Outros estrógenos e progestágenos
T38.6 Antigonadotrofinas, antiestrógenos, antiandrógenos não classificados em outra parte
T38.7 Andrógenos e anabolizantes congêneres
T38.8 Outros hormônios e substitutos sintéticos, e os não especificados
T38.9 Outros antagonistas hormonais, e os não especificados
T39.0 Salicilatos
T39.1 Derivados do 4­aminofenol
T39.2 Derivados pirazolônicos
T39.3 Outros antiinflamatórios não esteróides
T39.4 Anti­reumáticos não classificados em outra parte
T39.8 Outros analgésicos não opiáceos e antipiréticos não classificados em outra parte
T39.9 Analgésico não­opiáceo, antipirético e anti­reumático, não especificados
T40.0 Ópio
T40.1 Heroína
T40.2 Outros opiáceos
T40.3 Metadona
T40.4 Outros narcóticos sintéticos
T40.5 Cocaína
T40.6 Outros narcóticos e os não especificados
T40.7 Cannabis (derivados)
T40.8 Lisergida [LSD]
T40.9 Outros psicodislépticos e os não especificados [alucinógenos]
T41.0 Anestésicos inalatórios
T41.1 Anestésicos intravenosos
T41.2 Outros anestésicos gerais e os não especificados
T41.3 Anestésicos locais
T41.4 Anestésico não especificado
T41.5 Gases terapêuticos
T42.0 Derivados da hidantoína
T42.1 Iminostilbenos
T42.2 Succinimidas e oxazolidinadionas
T42.3 Barbitúricos
T42.4 Benzodiazepinas
T42.5 Antiepiléticos em associação, não classificados em outra parte
T42.6 Outras drogas antiepilépticas e sedativos­hipnóticos
T42.7 Drogas antiepilépticos, sedativos­hipnóticos, não especificados
T42.8 Drogas antiparkinsonianos e outros depressores centrais do tônus muscular
T43.0 Antidepressivos tricíclicos e tetracíclicos
T43.1 Antidepressivos inibidores da monoaminooxidase (MAO)
T43.2 Outros antidepressivos e os não especificados
T43.3 Antipsicóticos e neurolépticos derivados da fenotiazina
T43.4 Neurolépticos do tipo butirofenona e tioxanteno
T43.5 Outros antipsicóticos e neurolépticos e os não especificados
T43.6 Psicoestimulantes que potencialmente podem provocar dependência
T43.8 Outras drogas psicotrópicas não classificadas em outra parte
T43.9 Droga psicotrópica não especificado
T44.0 Agentes anticolinesterase
T44.1 Outros agentes parassimpaticomiméticos [colinérgicos]
T44.2 Bloqueadores ganglionares não classificados em outra parte
T44.3 Outros parassimpaticolíticos [anticolinérgicos e antimuscarínicos] e espasmolíticos não
classificados em outra parte
T44.4 Agonistas principalmente alfa­adrenorreceptores não classificados em outra parte
T44.5 Agonistas principalmente beta­adrenorreceptores não classificados em outra parte
T44.6 Antagonistas alfa­adrenorreceptores não classificados em outra parte
T44.7 Antagonistas beta­adrenorreceptores não classificados em outra parte
T44.8 Bloqueadores neuronais adrenérgicos e de ação central, não classificados em outra parte
T44.9 Outras drogas que afetam principalmente o sistema nervoso autônomo e as não especificadas
T45.0 Drogas antialérgicas e antieméticas
T45.1 Drogas antineoplásicas e imunomupressoras
T45.2 Vitaminas, não classificadas em outra parte
T45.3 Enzimas, não classificadas em outra parte
T45.4 Ferro e seus compostos
T45.5 Anticoagulantes
T45.6 Drogas que afetam a fibrinólise
T45.7 Antagonistas de anticoagulantes, vitamina K e de outros fatores de coagulação
T45.8 Outras substâncias primariamente sistêmicas e hematológicas
T45.9 Substância essencialmente sistêmica e hematológica não especificada
T46.0 Glicosídeos estimulantes do coração e substâncias de ação semelhante
T46.1 Bloqueadores dos canais de cálcio
T46.2 Outras drogas antidisrítmicas não classificadas em outra parte
T46.3 Vasodilatadores coronarianos, não classificados em outra parte
T46.4 Inibidores da enzima de conversão da angiotensina
T46.5 Outras drogas anti­herpertensivas não classificadas em outra parte
T46.6 Drogas antihiperlipêmicas e antiarterioscleróticas
T46.7 Vasodilatadores periféricos
T46.8 Drogas antivaricosas, incluindo substâncias esclerosantes
T46.9 Outras substâncias e as não especificadas que agem essencialmente sobre o aparelho
circulatório
T47.0 Antagonistas dos receptores H2 da histamina
T47.1 Outros antiácidos e drogas que inibem a secreção gástrica
T47.2 Laxativos estimulantes
T47.3 Laxativos salinos e osmóticos
T47.4 Outros laxativos
T47.5 Digestivos
T47.6 Drogas antidiarréicas
T47.7 Eméticos
T47.8 Outras substâncias que atuam primariamente sobre o aparelho gastrintestinal
T47.9 Substância não especificada que atua primariamente sobre o aparelho gastrointestinal
T48.0 Drogas ocitócicas
T48.1 Relaxantes musculares esqueléticos [bloqueadores neuromusculares]
T48.2 Outras substâncias e as não especificadas que atuam sobre os músculos
T48.3 Antitussígenos
T48.4 Expectorantes
T48.5 Drogas anti­resfriado
T48.6 Antiasmáticos não classificados em outra parte
T48.7 Outras substâncias e as não especificadas que atuam primariamente sobre o aparelho
respiratório
T49.0 Antifúngicos, antiinfecciosos e antiinflamatórios de uso tópico, não classificados em outra parte
T49.1 Antipruriginosos
T49.2 Adstringentes e detergentes de uso local
T49.3 Emolientes, demulcentes e protetores
T49.4 Ceratolíticos, ceratoplásticos e outras drogas e preparados para o tratamento dos cabelos
T49.5 Drogas e preparações de uso oftalmológico
T49.6 Drogas e preparações de uso otorrinolaringológico
T49.7 Drogas dentárias de uso tópico
T49.8 Outras drogas de uso tópico
T49.9 Preparado de uso tópico, não especificado
T50.0 Mineralocorticóides e seus antagonistas
T50.1 Diuréticos de alça
T50.2 Inibidores da anidrase carbônica, benzotiazidas e outros diuréticos
T50.3 Produtos que agem sobre o equilíbrio eletrolítico, calórico e hídrico
T50.4 Drogas que agem sobre o metabolismo do ácido úrico
T50.5 Inibidores do apetite
T50.6 Antídotos e quelantes não classificados em outra parte
T50.7 Analépticos e antagonistas dos receptores de opiáceos
T50.8 Agentes de diagnóstico
T50.9 Outras drogas, medicamentos e substâncias biológicas e as não especificadas
T51.0 Etanol
T51.1 Metanol
T51.2 2­propanol
T51.3 Óleo de fusel
T51.8 Outros álcoois
T51.9 Álcool não especificado
T52.0 Derivados do petróleo
T52.1 Benzeno
T52.2 Homólogos do benzeno
T52.3 Glicóis
T52.4 Cetonas
T52.8 Outros solventes orgânicos
T52.9 Solvente orgânico não especificado
T53.0 Tetracloreto de carbono
T53.1 Clorofórmio
T53.2 Tricloroetileno
T53.3 Tetracloroetileno
T53.4 Diclorometano
T53.5 Clorofluorcarbono
T53.6 Outros derivados halogênicos de hidrocarbonetos alifáticos
T53.7 Derivados halogênicos de hidrocarbonetos aromáticos
T53.9 Derivados halogênicos de hidrocarbonetos alifáticos e aromáticos não especificados
T54.0 Fenol e homólogos do fenol
T54.1 Outros compostos corrosivos orgânicos
T54.2 Ácidos corrosivos e substâncias semelhantes
T54.3 Bases (álcalis) cáusticas(os) e substâncias semelhantes
T54.9 Substância corrosiva não especificada
T55 Efeito tóxico de sabões e detergentes
T56.0 Chumbo e seus compostos
T56.1 Mercúrio e seus compostos
T56.2 Cromo e seus compostos
T56.3 Cádmio e seus compostos
T56.4 Cobre e seus compostos
T56.5 Zinco e seus compostos
T56.6 Estanho e seus compostos
T56.7 Berilo e seus compostos
T56.8 Outros metais
T56.9 Metal, não especificado
T57.0 Arsênico e seus compostos
T57.1 Fósforo e seus compostos
T57.2 Manganês e seus compostos
T57.3 Cianeto de hidrogênio (ácido cianídrico)
T57.8 Outras substâncias inorgânicas especificadas
T57.9 Substância inorgânica não especificada
T58 Efeito tóxico de monóxido de carbono
T59.0 Óxidos de nitrogênio
T59.1 Dióxido de enxofre
T59.2 Formaldeído
T59.3 Gás lacrimogênio
T59.4 Cloro gasoso
T59.5 Fluoreto gasoso e ácido fluorídrico
T59.6 Ácido sulfídrico
T59.7 Dióxido de carbono
T59.8 Outros gases, fumaças e vapores especificados
T59.9 Gases, fumaças e vapores não especificados
T60.0 Inseticidas organofosforados e carbamatos
T60.1 Inseticidas halogenados
T60.2 Outros inseticidas
T60.3 Herbicidas e fungicidas
T60.4 Rodenticidas
T60.8 Outros pesticidas
T60.9 Pesticida não especificado
T61.0 Intoxicação pelo peixe ciguatera
T61.1 Intoxicação por peixes escombrídeos
T61.2 Outras intoxicações por peixes e mariscos
T61.8 Efeito tóxico de outros frutos do mar
T61.9 Efeito tóxico de frutos do mar não especificados
T62.0 Ingestão de cogumelos
T62.1 Ingestão de frutos
T62.2 Ingestão de outras (partes de) plantas
T62.8 Outras substâncias nocivas ingeridas como alimento
T62.9 Substâncias nocivas ingeridas como alimento, não especificadas
T63.0 Veneno de serpente
T63.1 Veneno de outros répteis
T63.2 Veneno de escorpião
T63.3 Veneno de aranha
T63.4 Veneno de outros artrópodes
T63.5 Contato com peixe
T63.6 Contato com outros animais marinhos
T63.8 Contato com outros animais venenosos
T63.9 Contato com animal venenoso não especificado
T64 Efeito tóxico da aflatoxina e de outras micotoxinas contaminantes de alimentos
T65.0 Cianetos
T65.1 Estricnina e seus sais
T65.2 Tabaco e da nicotina
T65.3 Nitroderivados e aminoderivados do benzeno e seus homólogos
T65.4 Dissulfeto de carbono
T65.5 Nitroglicerina e outros ácidos e ésteres nítricos
T65.6 Tinturas e corantes, não classificadas em outra parte
T65.8 Outras substâncias especificadas
T65.9 Substância não especificada
T66 Efeitos não especificados de radiação
T67.0 Golpe de calor e insolação
T67.1 Síncope devida ao calor
T67.2 Cãibras devidas ao calor
T67.3 Exaustão devida ao calor e à perda hídrica
T67.4 Exaustão devida ao calor e à perda de sal
T67.5 Exaustão devida ao calor, sem especificação
T67.6 Fadiga transitória devida ao calor
T67.7 Edema devido ao calor
T67.8 Outros efeitos do calor e da luz
T67.9 Efeito do calor e da luz não especificado
T68 Hipotermia
T69.0 Mão e pé de imersão
T69.1 Congelamento [chilblains]
T69.8 Outros efeitos especificados de temperatura reduzida
T69.9 Efeito não especificado de temperatura reduzida
T70.0 Otite barotraumática
T70.1 Sinusite barotraumática
T70.2 Outros efeitos das grandes altitude e os não especificados
T70.3 Mal dos caixões [doença de descompressão]
T70.4 Efeito dos fluidos em alta pressão
T70.8 Outros efeitos da pressão atmosférica ou da pressão da água
T70.9 Efeitos não especificados da pressão atmosférica ou da pressão da água
T71 Asfixia
T73.0 Efeitos da fome
T73.1 Efeitos da sede
T73.2 Exaustão devida às intempéries
T73.3 Exaustão devido a um esforço intenso
T73.8 Outros efeitos de privação
T73.9 Efeito não especificado de privação
T74.0 Abandono
T74.1 Sevícias físicas
T74.2 Abuso sexual
T74.3 Abuso psicológico
T74.8 Outras síndromes especificadas de maus tratos
T74.9 Síndrome não especificada de maus tratos
T75.0 Efeitos do raio
T75.1 Afogamento e submersão não mortal
T75.2 Efeitos da vibração
T75.3 Doença causada pelo movimento
T75.4 Efeitos da corrente elétrica
T75.8 Outros efeitos especificados de causas externas
T78.0 Choque anafilático devido à intolerância alimentar
T78.1 Outras reações de intolerância alimentar não classificadas em outra parte
T78.2 Choque anafilático não especificado
T78.3 Edema angioneurótico
T78.4 Alergia não especificada
T78.8 Outros efeitos adversos não classificados em outra parte
T78.9 Efeito adverso não especificado
T79.0 Embolia gasosa (traumática)
T79.1 Embolia gordurosa (traumática)
T79.2 Hemorragia traumática secundária e recidivante
T79.3 Infecção pós­traumática de ferimento não classificada em outra parte
T79.4 Choque traumático
T79.5 Anúria traumática
T79.6 Isquemia muscular traumática
T79.7 Enfisema subcutâneo de origem traumática
T79.8 Outras complicações precoces de traumatismo
T79.9 Complicação precoce não especificada de traumatismo
T80.0 Embolia aérea subseqüentes à infusão, transfusão e injeção terapêutica
T80.1 Complicações vasculares subseqüentes à infusão, transfusão e injeção terapêutica
T80.2 Infecções subseqüentes à infusão, transfusão e injeção terapêutica
T80.3 Reação de incompatibilidade ABO
T80.4 Reação de incompatibilidade Rh
T80.5 Choque anafilático devido a soro
T80.6 Outras reações ao soro
T80.8 Outras complicações subseqüentes à infusão, transfusão e injeção terapêutica
T80.9 Complicação não especificada subseqüente à infusão, transfusão e injeção terapêutica
T81.0 Hemorragia e hematoma complicando procedimento não classificado em outra parte
T81.1 Choque durante ou resultante de procedimento não classificado em outra parte
T81.2 Perfuração e laceração acidentais durante um procedimento não classificado em outra parte
T81.3 Deiscência de ferida cirúrgica não classificada em outra parte
T81.4 Infecção subseqüente a procedimento não classificada em outra parte
T81.5 Corpo estranho deixado acidentalmente em cavidade corporal ou em ferida operatória
subseqüente a procedimento
T81.6 Reação aguda à substância estranha deixada acidentalmente durante um procedimento
T81.7 Complicações vasculares subseqüentes a um procedimento não classificado em outra parte
T81.8 Outras complicações de procedimentos não classificadas em outra parte
T81.9 Complicação não especificada de procedimento
T82.0 Complicação mecânica de prótese valvular cardíaca
T82.1 Complicação mecânica de dispositivo eletrônico cardíaco
T82.2 Complicação mecânica de enxerto de ponte coronária e implantes de valvas
T82.3 Complicações mecânicas de outros enxertos vasculares
T82.4 Complicação mecânica de cateter vascular de diálise
T82.5 Complicações mecânicas de outros dispositivos e implantes cardiovasculares
T82.6 Infecção e reação inflamatórias devidas à prótese valvular cardíaca
T82.7 Infecção e reação inflamatórias devidas a outros dispositivos, implantes e enxertos cardíacos e
vasculares
T82.8 Outras complicações de dispositivos protéticos, implantes e enxertos cardíacos e vasculares
T82.9 Complicações não especificada de dispositivo protético, implante e enxerto cardíacos e
vasculares
T83.0 Complicação mecânica de cateter (de demora) urinário
T83.1 Complicação mecânica de outros dispositivos e implantes urinários
T83.2 Complicação mecânica de enxerto de órgão urinário
T83.3 Complicação mecânica de dispositivo intra­uterino (anticoncepcional)
T83.4 Complicação mecânica de outros dispositivos protéticos, implantes e enxertos do trato genital
T83.5 Infecção e reação inflamatória devidas à dispositivo protético, implante e enxerto no aparelho
urinário
T83.6 Infecção e reação inflamatória devidas à dispositivo protético, implante e enxerto no trato genital
T83.8 Outras complicações de dispositivos protéticos, implantes e enxertos geniturinários
T83.9 Complicação não especificada de prótese, implante e enxerto geniturinários
T84.0 Complicação mecânica de prótese articular interna
T84.1 Complicação mecânica de dispositivo de fixação interna de ossos dos membros
T84.2 Complicação mecânica de dispositivo de fixação interna de outros ossos
T84.3 Complicação mecânica de outros dispositivos, implantes e enxertos ósseos
T84.4 Complicação mecânica de outros dispositivos, implantes e enxertos ortopédicos internos
T84.5 Infecção e reação inflamatória devidas à prótese articular interna
T84.6 Infecção e reação inflamatória devidas a dispositivo de fixação interna [qualquer local]
T84.7 Infecção e reação inflamatória devidas a outros dispositivos protéticos, implantes e enxertos
ortopédicos internos
T84.8 Outras complicações de dispositivos protéticos, implantes e enxertos ortopédicos internos
T84.9 Complicação não especificada de dispositivo protético, implante e enxerto ortopédicos internos
T85.0 Complicação mecânica de shunt ventricular (comunicação) intracraniano
T85.1 Complicação mecânica de estimulador eletrônico implantado no sistema nervoso
T85.2 Complicação mecânica de lente intraocular
T85.3 Complicações mecânicas de outros dispositivos protéticos, implantes e enxertos oculares
T85.4 Complicação mecânica de prótese e implante mamários
T85.5 Complicação mecânica de dispositivos protéticos, implante e enxerto gastrointestinais
T85.6 Complicação mecânica de outros dispositivos protéticos, implantes e enxertos internos
especificados
T85.7 Infecção e reação inflamatória devida a outros dispositivos protéticos, implantes e enxertos
internos
T85.8 Outras complicações de dispositivos protéticos, implantes e enxertos internos não classificados
em outra parte
T85.9 Complicação não especificada de outros dispositivos protéticos, implantes e enxertos internos
T86.0 Rejeição a transplante de medula óssea
T86.1 Falência ou rejeição de transplante de rim
T86.2 Falência ou rejeição de transplante de coração
T86.3 Falência ou rejeição de transplante duplo de coração e pulmão
T86.4 Falência ou rejeição de transplante de fígado
T86.8 Outra insuficiência ou rejeição de outros órgãos ou tecidos transplantados
T86.9 Falência e rejeição a transplante de órgão ou tecido não especificado
T87.0 Complicações de reimplante (de parte) de extremidade superior
T87.1 Complicações de reimplante (de parte) de extremidade inferior
T87.2 Complicações de outras partes reimplantadas do corpo
T87.3 Neuroma de coto da amputação
T87.4 Infecção de coto da amputação
T87.5 Necrose do coto da amputação
T87.6 Outras complicações e as não especificadas do coto de amputação
T88.0 Infecção subseqüente à imunização
T88.1 Outras complicações subseqüentes à imunização não classificadas em outra parte
T88.2 Choque devido à anestesia
T88.3 Hipertermia maligna devida à anestesia
T88.4 Entubação falha ou difícil
T88.5 Outras complicações de anestesia
T88.6 Choque anafilático devido a efeito adverso de droga ou medicamento corretos e administrados
de maneira apropriada
T88.7 Efeito adverso não especificado de droga ou medicamento
T88.8 Outras complicações de cuidados médicos e cirúrgicos especificados não classificados em outra
parte
T88.9 Complicação não especificada de cuidados médicos e cirúrgicos
T90.0 Seqüelas de traumatismo superficial da cabeça
T90.1 Seqüelas de ferimento da cabeça
T90.2 Seqüelas de fratura de crânio e de ossos da face
T90.3 Seqüelas de traumatismo de nervos cranianos
T90.4 Seqüelas de traumatismo do olho e da órbita
T90.5 Seqüelas de traumatismo intracraniano
T90.8 Seqüelas de outros traumatismos especificados da cabeça
T90.9 Seqüelas de traumatismo não especificado da cabeça
T91.0 Seqüelas de traumatismo superficial e ferimento do pescoço e do tronco
T91.1 Seqüelas de fratura de coluna vertebral
T91.2 Seqüelas de outra fratura do tórax e da pelve
T91.3 Seqüelas de traumatismo de medula espinhal
T91.4 Seqüelas de traumatismo de órgãos intratorácicos
T91.5 Seqüelas de traumatismo de órgãos intra­abdominais e órgãos pélvicos
T91.8 Seqüelas de outros traumatismos especificados do pescoço e do tronco
T91.9 Seqüelas de traumatismo não especificado do pescoço e do tronco
T92.0 Seqüelas de ferimento do membro superior
T92.1 Seqüelas de fratura do braço
T92.2 Seqüelas de fratura ao nível do punho e da mão
T92.3 Seqüelas de luxação, entorse e distensão do membro superior
T92.4 Seqüelas de traumatismo de nervo de membro superior
T92.5 Seqüelas de traumatismo de músculo e tendão do membro superior
T92.6 Seqüelas de esmagamento e amputação traumática do membro superior
T92.8 Seqüelas de outros traumatismos especificados do membro superior
T92.9 Seqüelas de traumatismo não especificado do membro superior
T93.0 Seqüelas de ferimento do membro inferior
T93.1 Seqüelas de fratura do fêmur
T93.2 Seqüelas de outras fraturas do membro inferior
T93.3 Seqüelas de luxação, entorse e distensão do membro inferior
T93.4 Seqüelas de traumatismo de nervo do membro inferior
T93.5 Seqüelas de traumatismo de músculo e tendão do membro inferior
T93.6 Seqüelas de esmagamento e amputação traumática do membro inferior
T93.8 Seqüelas de outros traumatismos especificados do membro inferior
T93.9 Seqüelas de traumatismo não especificado do membro inferior
T94.0 Seqüelas de traumatismos envolvendo regiões múltiplas do corpo
T94.1 Seqüelas de traumatismos não especificados por regiões do corpo
T95.0 Seqüelas de queimadura, corrosão e geladura da cabeça e pescoço
T95.1 Seqüelas de queimadura, corrosão e geladura do tronco
T95.2 Seqüelas de queimadura, corrosão e geladura do membro superior
T95.3 Seqüelas de queimadura, corrosão e geladura do membro inferior
T95.4 Seqüelas de queimadura e corrosão classificável só de acordo com a extensão da área corporal
envolvida
T95.8 Seqüelas de outra queimadura, corrosões e geladuras especificadas
T95.9 Seqüelas de queimadura, corrosão e geladura de local não especificado
T96 Seqüelas de intoxicação por drogas, medicamentos e substâncias biológicas
T97 Seqüelas de efeitos tóxicos de substâncias de origem predominantemente não­medicinal
T98.0 Seqüelas dos efeitos da penetração de corpo estranho através de orifício natural
T98.1 Seqüelas em outros efeitos de causas externas e os não especificados
T98.2 Seqüelas de algumas complicações precoces de traumatismos
T98.3 Seqüelas de complicações dos cuidados médicos e cirúrgicos não classificados em outra parte
V01.0 Outros dispositivos (aparelhos) associados a incidentes adversos e os não especificados ­
acidente não­de­trânsito
V01.1 Outros dispositivos (aparelhos) associados a incidentes adversos e os não especificados ­
acidente de trânsito
V01.9 Outros dispositivos (aparelhos) associados a incidentes adversos e os não especificados ­
acidente não especificado se de trânsito ou não de trânsito
V02.0 Pedestre traumatizado em colisão com um veículo a motor de duas ou três rodas ­ acidente nãode­trânsito
V02.1 Pedestre traumatizado em colisão com um veículo a motor de duas ou três rodas ­ acidente de
trânsito
V02.9 Pedestre traumatizado em colisão com um veículo a motor de duas ou três rodas ­ acidente não
especificado se de trânsito ou não de trânsito
V03.0 Pedestre traumatizado em colisão com um automóvel [carro], "pick up" ou caminhonete ­
acidente não­de­trânsito
V03.1 Pedestre traumatizado em colisão com um automóvel [carro], "pick up" ou caminhonete ­
acidente de trânsito
V03.9 Pedestre traumatizado em colisão com um automóvel [carro], "pick up" ou caminhonete ­
acidente não especificado se de trânsito ou não de trânsito
V04.0 Pedestre traumatizado em colisão com um veículo de transporte pesado ou com um ônibus ­
acidente não­de­trânsito
V04.1 Pedestre traumatizado em colisão com um veículo de transporte pesado ou com um ônibus ­
acidente de trânsito
V04.9 Pedestre traumatizado em colisão com um veículo de transporte pesado ou com um ônibus ­
acidente não especificado se de trânsito ou não de trânsito
V05.0 Pedestre traumatizado em colisão com trem [comboio] ou um veículo ferroviário ­ acidente nãode­trânsito
V05.1 Pedestre traumatizado em colisão com trem [comboio] ou um veículo ferroviário ­ acidente de
trânsito
V05.9 Pedestre traumatizado em colisão com trem [comboio] ou um veículo ferroviário ­ acidente não
especificado se de trânsito ou não de trânsito
V06.0 Pedestre traumatizado em colisão com outro veículo não­motorizado ­ acidente não­de­trânsito
V06.1 Pedestre traumatizado em colisão com outro veículo não­motorizado ­ acidente de trânsito
V06.9 Pedestre traumatizado em colisão com outro veículo não­motorizado ­ acidente não especificado
se de trânsito ou não de trânsito
V09.0 Pedestre traumatizado em um acidente não­de­trânsito, envolvendo outros veículos a motor e os
não especificados
V09.1 Pedestre traumatizado em um acidente não­de­trânsito não especificado
V09.2 Pedestre traumatizado em um acidente de trânsito envolvendo outros veículos e os não
especificados, a motor
V09.3 Pedestre traumatizado em um acidente de trânsito não especificado
V09.9 Pedestre traumatizado em um acidente de transporte não especificado
V10.0 Ciclista traumatizado em colisão com um pedestre ou um animal ­ condutor traumatizado em
acidente não­de­trânsito
V10.1 Ciclista traumatizado em colisão com um pedestre ou um animal ­ passageiro traumatizado em
acidente não­de­trânsito
V10.2 Ciclista traumatizado em colisão com um pedestre ou um animal ­ ciclista não especificado
traumatizado em acidente não­de­trânsito
V10.3 Ciclista traumatizado em colisão com um pedestre ou um animal ­ pessoa traumatizada ao subir
ou descer do veículo
V10.4 Ciclista traumatizado em colisão com um pedestre ou um animal ­ condutor traumatizado em um
acidente de trânsito
V10.5 Ciclista traumatizado em colisão com um pedestre ou um animal ­ passageiro traumatizado em
um acidente de trânsito
V10.9 Ciclista traumatizado em colisão com um pedestre ou um animal ­ ciclista não especificado
traumatizado em um acidente de trânsito
V11.0 Ciclista traumatizado em colisão com outro veículo a pedal ­ condutor traumatizado em acidente
não­de­trânsito
V11.1 Ciclista traumatizado em colisão com outro veículo a pedal ­ passageiro traumatizado em
acidente não­de­trânsito
V11.2 Ciclista traumatizado em colisão com outro veículo a pedal ­ ciclista não especificado
traumatizado em acidente não­de­trânsito
V11.3 Ciclista traumatizado em colisão com outro veículo a pedal ­ pessoa traumatizada ao subir ou
descer do veículo
V11.4 Ciclista traumatizado em colisão com outro veículo a pedal ­ condutor traumatizado em um
acidente de trânsito
V11.5 Ciclista traumatizado em colisão com outro veículo a pedal ­ passageiro traumatizado em um
acidente de trânsito
V11.9 Ciclista traumatizado em colisão com outro veículo a pedal ­ ciclista não especificado
traumatizado em um acidente de trânsito
V12.0 Ciclista traumatizado em colisão com um veículo a motor de duas ou três rodas ­ condutor
traumatizado em acidente não­de­trânsito
V12.1 Ciclista traumatizado em colisão com um veículo a motor de duas ou três rodas ­ passageiro
traumatizado em acidente não­de­trânsito
V12.2 Ciclista traumatizado em colisão com um veículo a motor de duas ou três rodas ­ ciclista não
especificado traumatizado em acidente não­de­trânsito
V12.3 Ciclista traumatizado em colisão com um veículo a motor de duas ou três rodas ­ pessoa
traumatizada ao subir ou descer do veículo
V12.4 Ciclista traumatizado em colisão com um veículo a motor de duas ou três rodas ­ condutor
traumatizado em um acidente de trânsito
V12.5 Ciclista traumatizado em colisão com um veículo a motor de duas ou três rodas ­ passageiro
traumatizado em um acidente de trânsito
V12.9 Ciclista traumatizado em colisão com um veículo a motor de duas ou três rodas ­ ciclista não
especificado traumatizado em um acidente de trânsito
V13.0 Ciclista traumatizado em colisão com um automóvel, "pick up" ou caminhonete ­ condutor
traumatizado em acidente não­de­trânsito
V13.1 Ciclista traumatizado em colisão com um automóvel, "pick up" ou caminhonete ­ passageiro
traumatizado em acidente não­de­trânsito
V13.2 Ciclista traumatizado em colisão com um automóvel, "pick up" ou caminhonete ­ ciclista não
especificado traumatizado em acidente não­de­trânsito
V13.3 Ciclista traumatizado em colisão com um automóvel, "pick up" ou caminhonete ­ pessoa
traumatizada ao subir ou descer do veículo
V13.4 Ciclista traumatizado em colisão com um automóvel, "pick up" ou caminhonete ­ condutor
traumatizado em um acidente de trânsito
V13.5 Ciclista traumatizado em colisão com um automóvel, "pick up" ou caminhonete ­ passageiro
traumatizado em um acidente de trânsito
V13.9 Ciclista traumatizado em colisão com um automóvel, "pick up" ou caminhonete ­ ciclista não
especificado traumatizado em um acidente de trânsito
V14.0 Ciclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus ­ condutor
traumatizado em acidente não­de­trânsito
V14.1 Ciclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus ­
passageiro traumatizado em acidente não­de­trânsito
V14.2 Ciclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus ­ ciclista
não especificado traumatizado em acidente não­de­trânsito
V14.3 Ciclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus ­ pessoa
traumatizada ao subir ou descer do veículo
V14.4 Ciclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus ­ condutor
traumatizado em um acidente de trânsito
V14.5 Ciclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus ­
passageiro traumatizado em um acidente de trânsito
V14.9 Ciclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus ­ ciclista
não especificado traumatizado em um acidente de trânsito
V15.0 Ciclista traumatizado em colisão com um trem ou um veículo ferroviário ­ condutor traumatizado
em acidente não­de­trânsito
V15.1 Ciclista traumatizado em colisão com um trem ou um veículo ferroviário ­ passageiro
traumatizado em acidente não­de­trânsito
V15.2 Ciclista traumatizado em colisão com um trem ou um veículo ferroviário ­ ciclista não
especificado traumatizado em acidente não­de­trânsito
V15.3 Ciclista traumatizado em colisão com um trem ou um veículo ferroviário ­ pessoa traumatizada
ao subir ou descer do veículo
V15.4 Ciclista traumatizado em colisão com um trem ou um veículo ferroviário ­ condutor traumatizado
em um acidente de trânsito
V15.5 Ciclista traumatizado em colisão com um trem ou um veículo ferroviário ­ passageiro
traumatizado em um acidente de trânsito
V15.9 Ciclista traumatizado em colisão com um trem ou um veículo ferroviário ­ ciclista não
especificado traumatizado em um acidente de trânsito
V16.0 Ciclista traumatizado em colisão com outro veículo não­motorizado ­ condutor traumatizado em
acidente não­de­trânsito
V16.1 Ciclista traumatizado em colisão com outro veículo não­motorizado ­ passageiro traumatizado
em acidente não­de­trânsito
V16.2 Ciclista traumatizado em colisão com outro veículo não­motorizado ­ ciclista não especificado
traumatizado em acidente não­de­trânsito
V16.3 Ciclista traumatizado em colisão com outro veículo não­motorizado ­ pessoa traumatizada ao
subir ou descer do veículo
V16.4 Ciclista traumatizado em colisão com outro veículo não­motorizado ­ condutor traumatizado em
um acidente de trânsito
V16.5 Ciclista traumatizado em colisão com outro veículo não­motorizado ­ passageiro traumatizado
em um acidente de trânsito
V16.9 Ciclista traumatizado em colisão com outro veículo não­motorizado ­ ciclista não especificado
traumatizado em um acidente de trânsito
V17.0 Ciclista traumatizado em colisão com um objeto fixo ou parado ­ condutor traumatizado em
acidente não­de­trânsito
V17.1 Ciclista traumatizado em colisão com um objeto fixo ou parado ­ passageiro traumatizado em
acidente não­de­trânsito
V17.2 Ciclista traumatizado em colisão com um objeto fixo ou parado ­ ciclista não especificado
traumatizado em acidente não­de­trânsito
V17.3 Ciclista traumatizado em colisão com um objeto fixo ou parado ­ pessoa traumatizada ao subir ou
descer do veículo
V17.4 Ciclista traumatizado em colisão com um objeto fixo ou parado ­ condutor traumatizado em um
acidente de trânsito
V17.5 Ciclista traumatizado em colisão com um objeto fixo ou parado ­ passageiro traumatizado em um
acidente de trânsito
V17.9 Ciclista traumatizado em colisão com um objeto fixo ou parado ­ ciclista não especificado
traumatizado em um acidente de trânsito
V18.0 Ciclista traumatizado em um acidente de transporte sem colisão ­ condutor traumatizado em
acidente não­de­trânsito
V18.1 Ciclista traumatizado em um acidente de transporte sem colisão ­ passageiro traumatizado em
acidente não­de­trânsito
V18.2 Ciclista traumatizado em um acidente de transporte sem colisão ­ ciclista não especificado
traumatizado em acidente não­de­trânsito
V18.3 Ciclista traumatizado em um acidente de transporte sem colisão ­ pessoa traumatizada ao subir
ou descer do veículo
V18.4 Ciclista traumatizado em um acidente de transporte sem colisão ­ condutor traumatizado em um
acidente de trânsito
V18.5 Ciclista traumatizado em um acidente de transporte sem colisão ­ passageiro traumatizado em
um acidente de trânsito
V18.9 Ciclista traumatizado em um acidente de transporte sem colisão ­ ciclista não especificado
traumatizado em um acidente de trânsito
V19.0 Condutor traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente não­de­trânsito
V19.1 Passageiro traumatizado em colisão com outro veículos e com veículos não especificados, a
motor, em um acidente não­de­trânsito
V19.2 Ciclista não especificado traumatizado em colisão com outros veículos e com veículos não
especificados, a motor, em um acidente não­de­trânsito
V19.3 Ciclista [qualquer] traumatizado em um acidente não especificado e não­de­trânsito
V19.4 Condutor traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente de trânsito
V19.5 Passageiro traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente de trânsito
V19.6 Ciclista não especificado traumatizado em colisão com outros veículos e com veículos não
especificados, a motor, em um acidente de trânsito
V19.8 Ciclista [qualquer] traumatizado em outros acidentes de transporte especificados
V19.9 Ciclista [qualquer] traumatizado em um acidente de trânsito não especificado
V20.0 Motociclista traumatizado em colisão com um pedestre ou um animal ­ condutor traumatizado
em acidente não­de­trânsito
V20.1 Motociclista traumatizado em colisão com um pedestre ou um animal ­ passageiro traumatizado
em acidente não­de­trânsito
V20.2 Motociclista traumatizado em colisão com um pedestre ou um animal ­ motociclista não
especificado traumatizado em acidente não­de­trânsito
V20.3 Motociclista traumatizado em colisão com um pedestre ou um animal ­ pessoa traumatizado ao
subir ou descer do veículo
V20.4 Motociclista traumatizado em colisão com um pedestre ou um animal ­ condutor traumatizado
em um acidente de trânsito
V20.5 Motociclista traumatizado em colisão com um pedestre ou um animal ­ passageiro traumatizado
em um acidente de trânsito
V20.9 Motociclista traumatizado em colisão com um pedestre ou um animal ­ motociclista não
especificado traumatizado em um acidente de trânsito
V21.0 Motociclista traumatizado em colisão com um veículo a pedal ­ condutor traumatizado em
acidente não­de­trânsito
V21.1 Motociclista traumatizado em colisão com um veículo a pedal ­ passageiro traumatizado em
acidente não­de­trânsito
V21.2 Motociclista traumatizado em colisão com um veículo a pedal ­ motociclista não especificado
traumatizado em acidente não­de­trânsito
V21.3 Motociclista traumatizado em colisão com um veículo a pedal ­ pessoa traumatizado ao subir ou
descer do veículo
V21.4 Motociclista traumatizado em colisão com um veículo a pedal ­ condutor traumatizado em um
acidente de trânsito
V21.5 Motociclista traumatizado em colisão com um veículo a pedal ­ passageiro traumatizado em um
acidente de trânsito
V21.9 Motociclista traumatizado em colisão com um veículo a pedal ­ motociclista não especificado
traumatizado em um acidente de trânsito
V22.0 Motociclista traumatizado em colisão com um veículo a motor de duas ou três rodas ­ condutor
traumatizado em acidente não­de­trânsito
V22.1 Motociclista traumatizado em colisão com um veículo a motor de duas ou três rodas ­ passageiro
traumatizado em acidente não­de­trânsito
V22.2 Motociclista traumatizado em colisão com um veículo a motor de duas ou três rodas ­
motociclista não especificado traumatizado em acidente não­de­trânsito
V22.3 Motociclista traumatizado em colisão com um veículo a motor de duas ou três rodas ­ pessoa
traumatizado ao subir ou descer do veículo
V22.4 Motociclista traumatizado em colisão com um veículo a motor de duas ou três rodas ­ condutor
traumatizado em um acidente de trânsito
V22.5 Motociclista traumatizado em colisão com um veículo a motor de duas ou três rodas ­ passageiro
traumatizado em um acidente de trânsito
V22.9 Motociclista traumatizado em colisão com um veículo a motor de duas ou três rodas ­
motociclista não especificado traumatizado em um acidente de trânsito
V23.0 Motociclista traumatizado em colisão com um automóvel [carro], "pick up" ou caminhonete ­
condutor traumatizado em acidente não­de­trânsito
V23.1 Motociclista traumatizado em colisão com um automóvel [carro], "pick up" ou caminhonete ­
passageiro traumatizado em acidente não­de­trânsito
V23.2 Motociclista traumatizado em colisão com um automóvel [carro], "pick up" ou caminhonete ­
motociclista não especificado traumatizado em acidente não­de­trânsito
V23.3 Motociclista traumatizado em colisão com um automóvel [carro], "pick up" ou caminhonete ­
pessoa traumatizado ao subir ou descer do veículo
V23.4 Motociclista traumatizado em colisão com um automóvel [carro], "pick up" ou caminhonete ­
condutor traumatizado em um acidente de trânsito
V23.5 Motociclista traumatizado em colisão com um automóvel [carro], "pick up" ou caminhonete ­
passageiro traumatizado em um acidente de trânsito
V23.9 Motociclista traumatizado em colisão com um automóvel [carro], "pick up" ou caminhonete ­
motociclista não especificado traumatizado em um acidente de trânsito
V24.0 Motociclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus ­
condutor traumatizado em acidente não­de­trânsito
V24.1 Motociclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus ­
passageiro traumatizado em acidente não­de­trânsito
V24.2 Motociclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus ­
motociclista não especificado traumatizado em acidente não­de­trânsito
V24.3 Motociclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus ­
pessoa traumatizado ao subir ou descer do veículo
V24.4 Motociclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus ­
condutor traumatizado em um acidente de trânsito
V24.5 Motociclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus ­
passageiro traumatizado em um acidente de trânsito
V24.9 Motociclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus ­
motociclista não especificado traumatizado em um acidente de trânsito
V25.0 Motociclista traumatizado em colisão com um trem ou um veículo ferroviário ­ condutor
traumatizado em acidente não­de­trânsito
V25.1 Motorista traumatizado em colisão com um trem ou um veículo ferroviário ­ passageiro
traumatizado em acidente não­de­trânsito
V25.2 Motorista traumatizado em colisão com um trem ou um veículo ferroviário ­ motociclista não
especificado traumatizado em acidente não­de­trânsito
V25.3 Motorista traumatizado em colisão com um trem ou um veículo ferroviário ­ pessoa traumatizado
ao subir ou descer do veículo
V25.4 Motorista traumatizado em colisão com um trem ou um veículo ferroviário ­ condutor
traumatizado em um acidente de trânsito
V25.5 Motorista traumatizado em colisão com um trem ou um veículo ferroviário ­ passageiro
traumatizado em um acidente de trânsito
V25.9 Motorista traumatizado em colisão com um trem ou um veículo ferroviário ­ motociclista não
especificado traumatizado em um acidente de trânsito
V26.0 Motociclista traumatizado em colisão com outro veículo não­motorizado ­ condutor traumatizado
em acidente não­de­trânsito
V26.1 Motociclista traumatizado em colisão com outro veículo não­motorizado ­ passageiro
traumatizado em acidente não­de­trânsito
V26.2 Motociclista traumatizado em colisão com outro veículo não­motorizado ­ motociclista não
especificado traumatizado em acidente não­de­trânsito
V26.3 Motociclista traumatizado em colisão com outro veículo não­motorizado ­ pessoa traumatizado
ao subir ou descer do veículo
V26.4 Motociclista traumatizado em colisão com outro veículo não­motorizado ­ condutor traumatizado
em um acidente de trânsito
V26.5 Motociclista traumatizado em colisão com outro veículo não­motorizado ­ passageiro
traumatizado em um acidente de trânsito
V26.9 Motociclista traumatizado em colisão com outro veículo não­motorizado ­ motociclista não
especificado traumatizado em um acidente de trânsito
V27.0 Motociclista traumatizado em colisão com um objeto fixo ou parado ­ condutor traumatizado em
acidente não­de­trânsito
V27.1 Motociclista traumatizado em colisão com um objeto fixo ou parado ­ passageiro traumatizado em
acidente não­de­trânsito
V27.2 Motociclista traumatizado em colisão com um objeto fixo ou parado ­ motociclista não
especificado traumatizado em acidente não­de­trânsito
V27.3 Motociclista traumatizado em colisão com um objeto fixo ou parado ­ pessoa traumatizado ao
subir ou descer do veículo
V27.4 Motociclista traumatizado em colisão com um objeto fixo ou parado ­ condutor traumatizado em
um acidente de trânsito
V27.5 Motociclista traumatizado em colisão com um objeto fixo ou parado ­ passageiro traumatizado
em um acidente de trânsito
V27.9 Motociclista traumatizado em colisão com um objeto fixo ou parado ­ motociclista não
especificado traumatizado em um acidente de trânsito
V28.0 Motociclista traumatizado em um acidente de transporte sem colisão ­ condutor traumatizado em
acidente não­de­trânsito
V28.1 Motociclista traumatizado em um acidente de transporte sem colisão ­ passageiro traumatizado
em acidente não­de­trânsito
V28.2 Motociclista traumatizado em um acidente de transporte sem colisão ­ motociclista não
especificado traumatizado em acidente não­de­trânsito
V28.3 Motociclista traumatizado em um acidente de transporte sem colisão ­ pessoa traumatizado ao
subir ou descer do veículo
V28.4 Motociclista traumatizado em um acidente de transporte sem colisão ­ condutor traumatizado em
um acidente de trânsito
V28.5 Motociclista traumatizado em um acidente de transporte sem colisão ­ passageiro traumatizado
em um acidente de trânsito
V28.9 Motociclista traumatizado em um acidente de transporte sem colisão ­ motociclista não
especificado traumatizado em um acidente de trânsito
V29.0 Condutor traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente não­de­trânsito
V29.1 Passageiro traumatizado em colisão com outros veículos com veículos não especificados, a
motor, em um acidente não­de­trânsito
V29.2 Motociclista não especificado traumatizado em colisão com outros veículos e com veículos não
especificados, a motor, em um acidente não­de­trânsito
V29.3 Motociclista [qualquer] traumatizado em um acidente não especificado, não­de­trânsito
V29.4 Condutor traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente de trânsito
V29.5 Passageiro traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente de trânsito
V29.6 Motociclista não especificado traumatizado em colisão com outros veículos e com veículos não
especificados, a motor em um acidente de trânsito
V29.8 Motociclista [qualquer] traumatizado em outros acidentes de transporte especificados
V29.9 Motociclista [qualquer] traumatizado em um acidente de trânsito não especificado
V30.0 Ocupante de um triciclo motorizado traumatizado em colisão com um pedestre ou um animal ­
condutor traumatizado em acidente não­de­trânsito
V30.1 Ocupante de um triciclo motorizado traumatizado em colisão com um pedestre ou um animal ­
passageiro traumatizado em acidente não­de­trânsito
V30.2 Ocupante de um triciclo motorizado traumatizado em colisão com um pedestre ou um animal ­
pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V30.3 Ocupante de um triciclo motorizado traumatizado em colisão com um pedestre ou um animal ­
ocupante não especificado de um triciclo motorizado traumatizado em acidente não­de­trânsito
V30.4 Ocupante de um triciclo motorizado traumatizado em colisão com um pedestre ou um animal ­
pessoa traumatizada ao subir ou descer do veículo
V30.5 Ocupante de um triciclo motorizado traumatizado em colisão com um pedestre ou um animal ­
condutor traumatizado em um acidente de trânsito
V30.6 Ocupante de um triciclo motorizado traumatizado em colisão com um pedestre ou um animal ­
passageiro traumatizado em um acidente de trânsito
V30.7 Ocupante de um triciclo motorizado traumatizado em colisão com um pedestre ou um animal ­
pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V30.9 Ocupante de um triciclo motorizado traumatizado em colisão com um pedestre ou um animal ­
ocupante não especificado de um triciclo motorizado traumatizado em um acidente de trânsito
V31.0 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo a pedal ­ condutor
traumatizado em acidente não­de­trânsito
V31.1 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo a pedal ­
passageiro traumatizado em acidente não­de­trânsito
V31.2 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo a pedal ­ pessoa
viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V31.3 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo a pedal ­ ocupante
não especificado de um triciclo motorizado traumatizado em acidente não­de­trânsito
V31.4 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo a pedal ­ pessoa
traumatizada ao subir ou descer do veículo
V31.5 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo a pedal ­ condutor
traumatizado em um acidente de trânsito
V31.6 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo a pedal ­
passageiro traumatizado em um acidente de trânsito
V31.7 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo a pedal ­ pessoa
viajando no exterior do veículo traumatizada em um acidente de trânsito
V31.9 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo a pedal ­ ocupante
não especificado de um triciclo motorizado traumatizado em um acidente de trânsito
V32.0 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ condutor traumatizado em acidente não­de­trânsito
V32.1 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ passageiro traumatizado em acidente não­de­trânsito
V32.2 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V32.3 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ ocupante não especificado de um triciclo motorizado traumatizado em acidente não­de­
trânsito
V32.4 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ pessoa traumatizada ao subir ou descer do veículo
V32.5 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ condutor traumatizado em um acidente de trânsito
V32.6 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ passageiro traumatizado em um acidente de trânsito
V32.7 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V32.9 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ ocupante não especificado de um triciclo motorizado traumatizado em um acidente de
trânsito
V33.0 Ocupante de um triciclo motorizado traumatizado em colisão com um automóvel, "pick up" ou
caminhonete ­ condutor traumatizado em acidente não­de­trânsito
V33.1 Ocupante de um triciclo motorizado traumatizado em colisão com um automóvel, "pick up" ou
caminhonete ­ passageiro traumatizado em acidente não­de­trânsito
V33.2 Ocupante de um triciclo motorizado traumatizado em colisão com um automóvel, "pick up" ou
caminhonete ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V33.3 Ocupante de um triciclo motorizado traumatizado em colisão com um automóvel, "pick up" ou
caminhonete ­ ocupante não especificado de um triciclo motorizado traumatizado em acidente não­detrânsito
V33.4 Ocupante de um triciclo motorizado traumatizado em colisão com um automóvel, "pick up" ou
caminhonete ­ pessoa traumatizada ao subir ou descer do veículo
V33.5 Ocupante de um triciclo motorizado traumatizado em colisão com um automóvel, "pick up" ou
caminhonete ­ condutor traumatizado em um acidente de trânsito
V33.6 Ocupante de um triciclo motorizado traumatizado em colisão com um automóvel, "pick up" ou
caminhonete ­ passageiro traumatizado em um acidente de trânsito
V33.7 Ocupante de um triciclo motorizado traumatizado em colisão com um automóvel, "pick up" ou
caminhonete ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V33.9 Ocupante de um triciclo motorizado traumatizado em colisão com um automóvel, "pick up" ou
caminhonete ­ ocupante não especificado de um triciclo motorizado traumatizado em um acidente de
trânsito
V34.0 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ condutor traumatizado em acidente não­de­trânsito
V34.1 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ passageiro traumatizado em acidente não­de­trânsito
V34.2 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­detrânsito
V34.3 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ ocupante não especificado de um triciclo motorizado traumatizado em acidente
não­de­trânsito
V34.4 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ pessoa traumatizada ao subir ou descer do veículo
V34.5 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ condutor traumatizado em um acidente de trânsito
V34.6 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ passageiro traumatizado em um acidente de trânsito
V34.7 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V34.9 Ocupante de um triciclo motorizado traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ ocupante não especificado de um triciclo motorizado traumatizado em um
acidente de trânsito
V35.0 Ocupante de um triciclo motorizado traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ condutor traumatizado em acidente não­de­trânsito
V35.1 Ocupante de um triciclo motorizado traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ passageiro traumatizado em acidente não­de­trânsito
V35.2 Ocupante de um triciclo motorizado traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­detrânsito
V35.3 Ocupante de um triciclo motorizado traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ ocupante não especificado de um triciclo motorizado traumatizado em acidente
não­de­trânsito
V35.4 Ocupante de um triciclo motorizado traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ pessoa traumatizada ao subir ou descer do veículo
V35.5 Ocupante de um triciclo motorizado traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ condutor traumatizado em um acidente de trânsito
V35.6 Ocupante de um triciclo motorizado traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ passageiro traumatizado em um acidente de trânsito
V35.7 Ocupante de um triciclo motorizado traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V35.9 Ocupante de um triciclo motorizado traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ ocupante não especificado de um triciclo motorizado traumatizado em um acidente
de trânsito
V36.0 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo não­motorizado ­
condutor traumatizado em acidente não­de­trânsito
V36.1 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo não­motorizado ­
passageiro traumatizado em acidente não­de­trânsito
V36.2 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo não­motorizado ­
pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V36.3 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo não­motorizado ­
ocupante não especificado de um triciclo motorizado traumatizado em acidente não­de­trânsito
V36.4 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo não­motorizado ­
pessoa traumatizada ao subir ou descer do veículo
V36.5 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo não­motorizado ­
condutor traumatizado em um acidente de trânsito
V36.6 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo não­motorizado ­
passageiro traumatizado em um acidente de trânsito
V36.7 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo não­motorizado ­
pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V36.9 Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo não­motorizado ­
ocupante não especificado de um triciclo motorizado traumatizado em um acidente de trânsito
V37.0 Ocupante de um triciclo motorizado traumatizado em colisão com um objeto fixo ou parado ­
condutor traumatizado em acidente não­de­trânsito
V37.1 Ocupante de um triciclo motorizado traumatizado em colisão com um objeto fixo ou parado ­
passageiro traumatizado em acidente não­de­trânsito
V37.2 Ocupante de um triciclo motorizado traumatizado em colisão com um objeto fixo ou parado ­
pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V37.3 Ocupante de um triciclo motorizado traumatizado em colisão com um objeto fixo ou parado ­
ocupante não especificado de um triciclo motorizado traumatizado em acidente não­de­trânsito
V37.4 Ocupante de um triciclo motorizado traumatizado em colisão com um objeto fixo ou parado ­
pessoa traumatizada ao subir ou descer do veículo
V37.5 Ocupante de um triciclo motorizado traumatizado em colisão com um objeto fixo ou parado ­
condutor traumatizado em um acidente de trânsito
V37.6 Ocupante de um triciclo motorizado traumatizado em colisão com um objeto fixo ou parado ­
passageiro traumatizado em um acidente de trânsito
V37.7 Ocupante de um triciclo motorizado traumatizado em colisão com um objeto fixo ou parado ­
pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V37.9 Ocupante de um triciclo motorizado traumatizado em colisão com um objeto fixo ou parado ­
ocupante não especificado de um triciclo motorizado traumatizado em um acidente de trânsito
V38.0 Ocupante de um triciclo motorizado traumatizado em um acidente de transporte sem colisão ­
condutor traumatizado em acidente não­de­trânsito
V38.1 Ocupante de um triciclo motorizado traumatizado em um acidente de transporte sem colisão ­
passageiro traumatizado em acidente não­de­trânsito
V38.2 Ocupante de um triciclo motorizado traumatizado em um acidente de transporte sem colisão ­
pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V38.3 Ocupante de um triciclo motorizado traumatizado em um acidente de transporte sem colisão ­
ocupante não especificado de um triciclo motorizado traumatizado em acidente não­de­trânsito
V38.4 Ocupante de um triciclo motorizado traumatizado em um acidente de transporte sem colisão ­
pessoa traumatizada ao subir ou descer do veículo
V38.5 Ocupante de um triciclo motorizado traumatizado em um acidente de transporte sem colisão ­
condutor traumatizado em um acidente de trânsito
V38.6 Ocupante de um triciclo motorizado traumatizado em um acidente de transporte sem colisão ­
passageiro traumatizado em um acidente de trânsito
V38.7 Ocupante de um triciclo motorizado traumatizado em um acidente de transporte sem colisão ­
pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V38.9 Ocupante de um triciclo motorizado traumatizado em um acidente de transporte sem colisão ­
ocupante não especificado de um triciclo motorizado traumatizado em um acidente de trânsito
V39.0 Condutor traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente não­de­trânsito
V39.1 Passageiro traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente não­de­trânsito
V39.2 Ocupante não especificado de um triciclo motorizado traumatizado em colisão com outros
veículos e com veículos não especificados, a motor, em um acidente não­de­trânsito
V39.3 Ocupante [qualquer] de um triciclo motorizado traumatizado em um acidente não especificado e
não­de­trânsito
V39.4 Condutor traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente de trânsito
V39.5 Passageiro traumatizado em colisão outros veículos e com veículos não especificados, a motor,
em um acidente de trânsito
V39.6 Ocupante não especificado de um triciclo motorizado traumatizado em colisão com outros
veículos e com veículos não especificados, a motor, em um acidente de trânsito
V39.8 Ocupante [qualquer] de um triciclo motorizado traumatizado em outros acidentes de trânsito
especificados
V39.9 Ocupante [qualquer] de um triciclo motorizado, traumatizado em acidente de trânsito não
especificado
V40.0 Ocupante de um automóvel [carro] traumatizado em colisão com um pedestre ou um animal ­
condutor [motorista] traumatizado em um acidente não­de­trânsito
V40.1 Ocupante de um automóvel [carro] traumatizado em colisão com um pedestre ou um animal ­
passageiro traumatizado em um acidente não­de­trânsito
V40.2 Ocupante de um automóvel [carro] traumatizado em colisão com um pedestre ou um animal ­
pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V40.3 Ocupante de um automóvel [carro] traumatizado em colisão com um pedestre ou um animal ­
ocupante não especificado de um automóvel [carro] traumatizado em um acidente não­de­trânsito
V40.4 Ocupante de um automóvel [carro] traumatizado em colisão com um pedestre ou um animal ­
pessoa traumatizada ao subir ou descer do veículo
V40.5 Ocupante de um automóvel [carro] traumatizado em colisão com um pedestre ou um animal ­
condutor [motorista] traumatizado em um acidente de trânsito
V40.6 Ocupante de um automóvel [carro] traumatizado em colisão com um pedestre ou um animal ­
passageiro traumatizado em um acidente de trânsito
V40.7 Ocupante de um automóvel [carro] traumatizado em colisão com um pedestre ou um animal ­
pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V40.9 Ocupante de um automóvel [carro] traumatizado em colisão com um pedestre ou um animal ­
ocupante não especificado de um automóvel [carro] traumatizado em um acidente de trânsito
V41.0 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo a pedal ­ condutor
[motorista] traumatizado em um acidente não­de­trânsito
V41.1 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo a pedal ­ passageiro
traumatizado em um acidente não­de­trânsito
V41.2 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo a pedal ­ pessoa
viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V41.3 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo a pedal ­ ocupante
não especificado de um automóvel [carro] traumatizado em um acidente não­de­trânsito
V41.4 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo a pedal ­ pessoa
traumatizada ao subir ou descer do veículo
V41.5 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo a pedal ­ condutor
[motorista] traumatizado em um acidente de trânsito
V41.6 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo a pedal ­ passageiro
traumatizado em um acidente de trânsito
V41.7 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo a pedal ­ pessoa
viajando no exterior do veículo traumatizada em um acidente de trânsito
V41.9 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo a pedal ­ ocupante
não especificado de um automóvel [carro] traumatizado em um acidente de trânsito
V42.0 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V42.1 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ passageiro traumatizado em um acidente não­de­trânsito
V42.2 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V42.3 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ ocupante não especificado de um automóvel [carro] traumatizado em um acidente nãode­trânsito
V42.4 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ pessoa traumatizada ao subir ou descer do veículo
V42.5 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ condutor [motorista] traumatizado em um acidente de trânsito
V42.6 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ passageiro traumatizado em um acidente de trânsito
V42.7 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V42.9 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo a motor de duas
ou três rodas ­ ocupante não especificado de um automóvel [carro] traumatizado em um acidente de
trânsito
V43.0 Ocupante de um automóvel [carro] traumatizado em colisão com um automóvel [carro], "pick up"
ou caminhonete ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V43.1 Ocupante de um automóvel [carro] traumatizado em colisão com um automóvel [carro], "pick up"
ou caminhonete ­ passageiro traumatizado em um acidente não­de­trânsito
V43.2 Ocupante de um automóvel [carro] traumatizado em colisão com um automóvel [carro], "pick up"
ou caminhonete ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V43.3 Ocupante de um automóvel [carro] traumatizado em colisão com um automóvel [carro], "pick up"
ou caminhonete ­ ocupante não especificado de um automóvel [carro] traumatizado em um acidente
não­de­trânsito
V43.4 Ocupante de um automóvel [carro] traumatizado em colisão com um automóvel [carro], "pick up"
ou caminhonete ­ pessoa traumatizada ao subir ou descer do veículo
V43.5 Ocupante de um automóvel [carro] traumatizado em colisão com um automóvel [carro], "pick up"
ou caminhonete ­ condutor [motorista] traumatizado em um acidente de trânsito
V43.6 Ocupante de um automóvel [carro] traumatizado em colisão com um automóvel [carro], "pick up"
ou caminhonete ­ passageiro traumatizado em um acidente de trânsito
V43.7 Ocupante de um automóvel [carro] traumatizado em colisão com um automóvel [carro], "pick up"
ou caminhonete ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V43.9 Ocupante de um automóvel [carro] traumatizado em colisão com um automóvel [carro], "pick up"
ou caminhonete ­ ocupante não especificado de um automóvel [carro] traumatizado em um acidente de
trânsito
V44.0 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V44.1 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ passageiro traumatizado em um acidente não­de­trânsito
V44.2 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­detrânsito
V44.3 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ ocupante não especificado de um automóvel [carro] traumatizado em um
acidente não­de­trânsito
V44.4 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ pessoa traumatizada ao subir ou descer do veículo
V44.5 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ condutor [motorista] traumatizado em um acidente de trânsito
V44.6 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ passageiro traumatizado em um acidente de trânsito
V44.7 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V44.9 Ocupante de um automóvel [carro] traumatizado em colisão com um veículo de transporte
pesado ou um ônibus ­ ocupante não especificado de um automóvel [carro] traumatizado em um
acidente de trânsito
V45.0 Ocupante de um automóvel [carro] traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V45.1 Ocupante de um automóvel [carro] traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ passageiro traumatizado em um acidente não­de­trânsito
V45.2 Ocupante de um automóvel [carro] traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­detrânsito
V45.3 Ocupante de um automóvel [carro] traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ ocupante não especificado de um automóvel [carro] traumatizado em um acidente
não­de­trânsito
V45.4 Ocupante de um automóvel [carro] traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ pessoa traumatizada ao subir ou descer do veículo
V45.5 Ocupante de um automóvel [carro] traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ condutor [motorista] traumatizado em um acidente de trânsito
V45.6 Ocupante de um automóvel [carro] traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ passageiro traumatizado em um acidente de trânsito
V45.7 Ocupante de um automóvel [carro] traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V45.9 Ocupante de um automóvel [carro] traumatizado em colisão com um trem [comboio] ou um
veículo ferroviário ­ ocupante não especificado de um automóvel [carro] traumatizado em um acidente
de trânsito
V46.0 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo não­motorizado ­
condutor [motorista] traumatizado em um acidente não­de­trânsito
V46.1 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo não­motorizado ­
passageiro traumatizado em um acidente não­de­trânsito
V46.2 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo não­motorizado ­
pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V46.3 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo não­motorizado ­
ocupante não especificado de um automóvel [carro] traumatizado em um acidente não­de­trânsito
V46.4 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo não­motorizado ­
pessoa traumatizada ao subir ou descer do veículo
V46.5 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo não­motorizado ­
condutor [motorista] traumatizado em um acidente de trânsito
V46.6 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo não­motorizado ­
passageiro traumatizado em um acidente de trânsito
V46.7 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo não­motorizado ­
pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V46.9 Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo não­motorizado ­
ocupante não especificado de um automóvel [carro] traumatizado em um acidente de trânsito
V47.0 Ocupante de um automóvel [carro] traumatizado em colisão com um objeto fixo ou parado ­
condutor [motorista] traumatizado em um acidente não­de­trânsito
V47.1 Ocupante de um automóvel [carro] traumatizado em colisão com um objeto fixo ou parado ­
passageiro traumatizado em um acidente não­de­trânsito
V47.2 Ocupante de um automóvel [carro] traumatizado em colisão com um objeto fixo ou parado ­
pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V47.3 Ocupante de um automóvel [carro] traumatizado em colisão com um objeto fixo ou parado ­
ocupante não especificado de um automóvel [carro] traumatizado em um acidente não­de­trânsito
V47.4 Ocupante de um automóvel [carro] traumatizado em colisão com um objeto fixo ou parado ­
pessoa traumatizada ao subir ou descer do veículo
V47.5 Ocupante de um automóvel [carro] traumatizado em colisão com um objeto fixo ou parado ­
condutor [motorista] traumatizado em um acidente de trânsito
V47.6 Ocupante de um automóvel [carro] traumatizado em colisão com um objeto fixo ou parado ­
passageiro traumatizado em um acidente de trânsito
V47.7 Ocupante de um automóvel [carro] traumatizado em colisão com um objeto fixo ou parado ­
pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V47.9 Ocupante de um automóvel [carro] traumatizado em colisão com um objeto fixo ou parado ­
ocupante não especificado de um automóvel [carro] traumatizado em um acidente de trânsito
V48.0 Ocupante de um automóvel [carro] traumatizado em um acidente de transporte sem colisão ­
condutor [motorista] traumatizado em um acidente não­de­trânsito
V48.1 Ocupante de um automóvel [carro] traumatizado em um acidente de transporte sem colisão ­
passageiro traumatizado em um acidente não­de­trânsito
V48.2 Ocupante de um automóvel [carro] traumatizado em um acidente de transporte sem colisão ­
pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V48.3 Ocupante de um automóvel [carro] traumatizado em um acidente de transporte sem colisão ­
ocupante não especificado de um automóvel [carro] traumatizado em um acidente não­de­trânsito
V48.4 Ocupante de um automóvel [carro] traumatizado em um acidente de transporte sem colisão ­
pessoa traumatizada ao subir ou descer do veículo
V48.5 Ocupante de um automóvel [carro] traumatizado em um acidente de transporte sem colisão ­
condutor [motorista] traumatizado em um acidente de trânsito
V48.6 Ocupante de um automóvel [carro] traumatizado em um acidente de transporte sem colisão ­
passageiro traumatizado em um acidente de trânsito
V48.7 Ocupante de um automóvel [carro] traumatizado em um acidente de transporte sem colisão ­
pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V48.9 Ocupante de um automóvel [carro] traumatizado em um acidente de transporte sem colisão ­
ocupante não especificado de um automóvel [carro] traumatizado em um acidente de trânsito
V49.0 Condutor [motorista] traumatizado em colisão com outros veículos e com veículos não
especificados, a motor em um acidente não­de­trânsito
V49.1 Passageiro traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente não­de­trânsito
V49.2 Ocupante não especificado de um automóvel [carro] traumatizado em colisão com outros
veículos e com veículos não especificados, a motor, em um acidente não­de­trânsito
V49.3 Ocupante [qualquer] de um automóvel [carro] traumatizado em um acidente não especificado e
não­de­trânsito
V49.4 Condutor [motorista] traumatizado em colisão com outros veículos e com veículos não
especificados, a motor, em um acidente de trânsito
V49.5 Passageiro traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente de trânsito
V49.6 Ocupante não especificado de um automóvel [carro] traumatizado em colisão com outros
veículos e com veículos não especificados, a motor, em um acidente de trânsito
V49.8 Ocupante [qualquer] de um automóvel [carro] traumatizado em outros acidentes de transporte
especificados
V49.9 Ocupante [qualquer] de um automóvel [carro], traumatizado em um acidente de trânsito não
especificado
V50.0 Ocupante de uma caminhonete traumatizado em colisão com um pedestre ou um animal ­
condutor [motorista] traumatizado em um acidente não­de­trânsito
V50.1 Ocupante de uma caminhonete traumatizado em colisão com um pedestre ou um animal ­
passageiro traumatizado em um acidente não­de­trânsito
V50.2 Ocupante de uma caminhonete traumatizado em colisão com um pedestre ou um animal ­
pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V50.3 Ocupante de uma caminhonete traumatizado em colisão com um pedestre ou um animal ­
ocupante não especificado de uma caminhonete traumatizado em um acidente não­de­trânsito
V50.4 Ocupante de uma caminhonete traumatizado em colisão com um pedestre ou um animal ­
pessoa traumatizado ao subir ou descer do veículo
V50.5 Ocupante de uma caminhonete traumatizado em colisão com um pedestre ou um animal ­
condutor [motorista] traumatizado em um acidente de trânsito
V50.6 Ocupante de uma caminhonete traumatizado em colisão com um pedestre ou um animal ­
passageiro traumatizado em um acidente de trânsito
V50.7 Ocupante de uma caminhonete traumatizado em colisão com um pedestre ou um animal ­
pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V50.9 Ocupante de uma caminhonete traumatizado em colisão com um pedestre ou um animal ­
ocupante não especificado de uma caminhonete traumatizado em um acidente de trânsito
V51.0 Ocupante de uma caminhonete traumatizado em colisão com um veículo a pedal ­ condutor
[motorista] traumatizado em um acidente não­de­trânsito
V51.1 Ocupante de uma caminhonete traumatizado em colisão com um veículo a pedal ­ passageiro
traumatizado em um acidente não­de­trânsito
V51.2 Ocupante de uma caminhonete traumatizado em colisão com um veículo a pedal ­ pessoa
viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V51.3 Ocupante de uma caminhonete traumatizado em colisão com um veículo a pedal ­ ocupante não
especificado de uma caminhonete traumatizado em um acidente não­de­trânsito
V51.4 Ocupante de uma caminhonete traumatizado em colisão com um veículo a pedal ­ pessoa
traumatizado ao subir ou descer do veículo
V51.5 Ocupante de uma caminhonete traumatizado em colisão com um veículo a pedal ­ condutor
[motorista] traumatizado em um acidente de trânsito
V51.6 Ocupante de uma caminhonete traumatizado em colisão com um veículo a pedal ­ passageiro
traumatizado em um acidente de trânsito
V51.7 Ocupante de uma caminhonete traumatizado em colisão com um veículo a pedal ­ pessoa
viajando no exterior do veículo traumatizada em um acidente de trânsito
V51.9 Ocupante de uma caminhonete traumatizado em colisão com um veículo a pedal ­ ocupante não
especificado de uma caminhonete traumatizado em um acidente de trânsito
V52.0 Ocupante de uma caminhonete traumatizado em colisão com veículo a motor de duas ou três
rodas ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V52.1 Ocupante de uma caminhonete traumatizado em colisão com veículo a motor de duas ou três
rodas ­ passageiro traumatizado em um acidente não­de­trânsito
V52.2 Ocupante de uma caminhonete traumatizado em colisão com veículo a motor de duas ou três
rodas ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V52.3 Ocupante de uma caminhonete traumatizado em colisão com veículo a motor de duas ou três
rodas ­ ocupante não especificado de uma caminhonete traumatizado em um acidente não­de­trânsito
V52.4 Ocupante de uma caminhonete traumatizado em colisão com veículo a motor de duas ou três
rodas ­ pessoa traumatizado ao subir ou descer do veículo
V52.5 Ocupante de uma caminhonete traumatizado em colisão com veículo a motor de duas ou três
rodas ­ condutor [motorista] traumatizado em um acidente de trânsito
V52.6 Ocupante de uma caminhonete traumatizado em colisão com veículo a motor de duas ou três
rodas ­ passageiro traumatizado em um acidente de trânsito
V52.7 Ocupante de uma caminhonete traumatizado em colisão com veículo a motor de duas ou três
rodas ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V52.9 Ocupante de uma caminhonete traumatizado em colisão com veículo a motor de duas ou três
rodas ­ ocupante não especificado de uma caminhonete traumatizado em um acidente de trânsito
V53.0 Ocupante de uma caminhonete traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V53.1 Ocupante de uma caminhonete traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ passageiro traumatizado em um acidente não­de­trânsito
V53.2 Ocupante de uma caminhonete traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V53.3 Ocupante de uma caminhonete traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ ocupante não especificado de uma caminhonete traumatizado em um acidente não­detrânsito
V53.4 Ocupante de uma caminhonete traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ pessoa traumatizado ao subir ou descer do veículo
V53.5 Ocupante de uma caminhonete traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ condutor [motorista] traumatizado em um acidente de trânsito
V53.6 Ocupante de uma caminhonete traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ passageiro traumatizado em um acidente de trânsito
V53.7 Ocupante de uma caminhonete traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V53.9 Ocupante de uma caminhonete traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ ocupante não especificado de uma caminhonete traumatizado em um acidente de
trânsito
V54.0 Ocupante de uma caminhonete traumatizado em colisão com um veículo de transporte pesado
ou um ônibus ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V54.1 Ocupante de uma caminhonete traumatizado em colisão com um veículo de transporte pesado
ou um ônibus ­ passageiro traumatizado em um acidente não­de­trânsito
V54.2 Ocupante de uma caminhonete traumatizado em colisão com um veículo de transporte pesado
ou um ônibus ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V54.3 Ocupante de uma caminhonete traumatizado em colisão com um veículo de transporte pesado
ou um ônibus ­ ocupante não especificado de uma caminhonete traumatizado em um acidente não­detrânsito
V54.4 Ocupante de uma caminhonete traumatizado em colisão com um veículo de transporte pesado
ou um ônibus ­ pessoa traumatizado ao subir ou descer do veículo
V54.5 Ocupante de uma caminhonete traumatizado em colisão com um veículo de transporte pesado
ou um ônibus ­ condutor [motorista] traumatizado em um acidente de trânsito
V54.6 Ocupante de uma caminhonete traumatizado em colisão com um veículo de transporte pesado
ou um ônibus ­ passageiro traumatizado em um acidente de trânsito
V54.7 Ocupante de uma caminhonete traumatizado em colisão com um veículo de transporte pesado
ou um ônibus ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V54.9 Ocupante de uma caminhonete traumatizado em colisão com um veículo de transporte pesado
ou um ônibus ­ ocupante não especificado de uma caminhonete traumatizado em um acidente de
trânsito
V55.0 Ocupante de uma caminhonete traumatizado em colisão com um trem [comboio] ou veículo
ferroviário ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V55.1 Ocupante de uma caminhonete traumatizado em colisão com um trem [comboio] ou veículo
ferroviário ­ passageiro traumatizado em um acidente não­de­trânsito
V55.2 Ocupante de uma caminhonete traumatizado em colisão com um trem [comboio] ou veículo
ferroviário ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V55.3 Ocupante de uma caminhonete traumatizado em colisão com um trem [comboio] ou veículo
ferroviário ­ ocupante não especificado de uma caminhonete traumatizado em um acidente não­detrânsito
V55.4 Ocupante de uma caminhonete traumatizado em colisão com um trem [comboio] ou veículo
ferroviário ­ pessoa traumatizado ao subir ou descer do veículo
V55.5 Ocupante de uma caminhonete traumatizado em colisão com um trem [comboio] ou veículo
ferroviário ­ condutor [motorista] traumatizado em um acidente de trânsito
V55.6 Ocupante de uma caminhonete traumatizado em colisão com um trem [comboio] ou veículo
ferroviário ­ passageiro traumatizado em um acidente de trânsito
V55.7 Ocupante de uma caminhonete traumatizado em colisão com um trem [comboio] ou veículo
ferroviário ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V55.9 Ocupante de uma caminhonete traumatizado em colisão com um trem [comboio] ou veículo
ferroviário ­ ocupante não especificado de uma caminhonete traumatizado em um acidente de trânsito
V56.0 Ocupante de uma caminhonete traumatizado em colisão com outro veículo não­motorizado ­
condutor [motorista] traumatizado em um acidente não­de­trânsito
V56.1 Ocupante de uma caminhonete traumatizado em colisão com outro veículo não­motorizado ­
passageiro traumatizado em um acidente não­de­trânsito
V56.2 Ocupante de uma caminhonete traumatizado em colisão com outro veículo não­motorizado ­
pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V56.3 Ocupante de uma caminhonete traumatizado em colisão com outro veículo não­motorizado ­
ocupante não especificado de uma caminhonete traumatizado em um acidente não­de­trânsito
V56.4 Ocupante de uma caminhonete traumatizado em colisão com outro veículo não­motorizado ­
pessoa traumatizado ao subir ou descer do veículo
V56.5 Ocupante de uma caminhonete traumatizado em colisão com outro veículo não­motorizado ­
condutor [motorista] traumatizado em um acidente de trânsito
V56.6 Ocupante de uma caminhonete traumatizado em colisão com outro veículo não­motorizado ­
passageiro traumatizado em um acidente de trânsito
V56.7 Ocupante de uma caminhonete traumatizado em colisão com outro veículo não­motorizado ­
pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V56.9 Ocupante de uma caminhonete traumatizado em colisão com outro veículo não­motorizado ­
ocupante não especificado de uma caminhonete traumatizado em um acidente de trânsito
V57.0 Ocupante de uma caminhonete traumatizado em colisão com um objeto fixo ou parado ­
condutor [motorista] traumatizado em um acidente não­de­trânsito
V57.1 Ocupante de uma caminhonete traumatizado em colisão com um objeto fixo ou parado ­
passageiro traumatizado em um acidente não­de­trânsito
V57.2 Ocupante de uma caminhonete traumatizado em colisão com um objeto fixo ou parado ­ pessoa
viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V57.3 Ocupante de uma caminhonete traumatizado em colisão com um objeto fixo ou parado ­
ocupante não especificado de uma caminhonete traumatizado em um acidente não­de­trânsito
V57.4 Ocupante de uma caminhonete traumatizado em colisão com um objeto fixo ou parado ­ pessoa
traumatizado ao subir ou descer do veículo
V57.5 Ocupante de uma caminhonete traumatizado em colisão com um objeto fixo ou parado ­
condutor [motorista] traumatizado em um acidente de trânsito
V57.6 Ocupante de uma caminhonete traumatizado em colisão com um objeto fixo ou parado ­
passageiro traumatizado em um acidente de trânsito
V57.7 Ocupante de uma caminhonete traumatizado em colisão com um objeto fixo ou parado ­ pessoa
viajando no exterior do veículo traumatizada em um acidente de trânsito
V57.9 Ocupante de uma caminhonete traumatizado em colisão com um objeto fixo ou parado ­
ocupante não especificado de uma caminhonete traumatizado em um acidente de trânsito
V58.0 Ocupante de uma caminhonete traumatizado em um acidente de transporte sem colisão ­
condutor [motorista] traumatizado em um acidente não­de­trânsito
V58.1 Ocupante de uma caminhonete traumatizado em um acidente de transporte sem colisão ­
passageiro traumatizado em um acidente não­de­trânsito
V58.2 Ocupante de uma caminhonete traumatizado em um acidente de transporte sem colisão ­
pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V58.3 Ocupante de uma caminhonete traumatizado em um acidente de transporte sem colisão ­
ocupante não especificado de uma caminhonete traumatizado em um acidente não­de­trânsito
V58.4 Ocupante de uma caminhonete traumatizado em um acidente de transporte sem colisão ­
pessoa traumatizado ao subir ou descer do veículo
V58.5 Ocupante de uma caminhonete traumatizado em um acidente de transporte sem colisão ­
condutor [motorista] traumatizado em um acidente de trânsito
V58.6 Ocupante de uma caminhonete traumatizado em um acidente de transporte sem colisão ­
passageiro traumatizado em um acidente de trânsito
V58.7 Ocupante de uma caminhonete traumatizado em um acidente de transporte sem colisão ­
pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V58.9 Ocupante de uma caminhonete traumatizado em um acidente de transporte sem colisão ­
ocupante não especificado de uma caminhonete traumatizado em um acidente de trânsito
V59.0 Condutor [motorista] traumatizado em colisão com outros veículos e com veículos não
especificados, a motor, em um acidente não­de­trânsito
V59.1 Passageiro traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente não­de­trânsito
V59.2 Ocupante não especificado de uma caminhonete traumatizado em colisão com outros veículos e
com veículos não especificados, a motor, em um acidente não­de­trânsito
V59.3 Ocupante [qualquer] de uma caminhonete traumatizado em um acidente não especificado e nãode­trânsito
V59.4 Condutor [motorista] traumatizado em colisão com outros veículos e com veículos não
especificados, a motor, em um acidente de trânsito
V59.5 Passageiro de uma caminhonete traumatizado em colisão com outros veículos e com veículos
não especificados, a motor, em um acidente de trânsito
V59.6 Ocupante não especificado de uma caminhonete traumatizado em colisão com outros veículos e
com veículos não especificados, a motor, em um acidente de trânsito
V59.8 Ocupante [qualquer] de uma caminhonete traumatizado em outros acidentes de transporte
especificados
V59.9 Ocupante [qualquer] de uma caminhonete traumatizado em um acidente de trânsito não
especificado
V60.0 Ocupante de um veículo de transporte pesado traumatizado em colisão com um pedestre ou um
animal ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V60.1 Ocupante de um veículo de transporte pesado traumatizado em colisão com um pedestre ou um
animal ­ passageiro traumatizado em um acidente não­de­trânsito
V60.2 Ocupante de um veículo de transporte pesado traumatizado em colisão com um pedestre ou um
animal ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V60.3 Ocupante de um veículo de transporte pesado traumatizado em colisão com um pedestre ou um
animal ­ ocupante não especificado de um veículo de transporte pesado traumatizado em um acidente
não­de­trânsito
V60.4 Ocupante de um veículo de transporte pesado traumatizado em colisão com um pedestre ou um
animal ­ pessoa traumatizado ao subir ou descer do veículo
V60.5 Ocupante de um veículo de transporte pesado traumatizado em colisão com um pedestre ou um
animal ­ condutor [motorista] traumatizado em um acidente de trânsito
V60.6 Ocupante de um veículo de transporte pesado traumatizado em colisão com um pedestre ou um
animal ­ passageiro traumatizado em um acidente de trânsito
V60.7 Ocupante de um veículo de transporte pesado traumatizado em colisão com um pedestre ou um
animal ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V60.9 Ocupante de um veículo de transporte pesado traumatizado em colisão com um pedestre ou um
animal ­ ocupante não especificado de um veículo de transporte pesado traumatizado em um acidente
de trânsito
V61.0 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a pedal ­
condutor [motorista] traumatizado em um acidente não­de­trânsito
V61.1 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a pedal ­
passageiro traumatizado em um acidente não­de­trânsito
V61.2 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a pedal ­
pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V61.3 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a pedal ­
ocupante não especificado de um veículo de transporte pesado traumatizado em um acidente não­detrânsito
V61.4 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a pedal ­
pessoa traumatizado ao subir ou descer do veículo
V61.5 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a pedal ­
condutor [motorista] traumatizado em um acidente de trânsito
V61.6 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a pedal ­
passageiro traumatizado em um acidente de trânsito
V61.7 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a pedal ­
pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V61.9 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a pedal ­
ocupante não especificado de um veículo de transporte pesado traumatizado em um acidente de
trânsito
V62.0 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a motor
de duas ou três rodas ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V62.1 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a motor
de duas ou três rodas ­ passageiro traumatizado em um acidente não­de­trânsito
V62.2 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a motor
de duas ou três rodas ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­detrânsito
V62.3 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a motor
de duas ou três rodas ­ ocupante não especificado de um veículo de transporte pesado traumatizado
em um acidente não­de­trânsito
V62.4 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a motor
de duas ou três rodas ­ pessoa traumatizado ao subir ou descer do veículo
V62.5 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a motor
de duas ou três rodas ­ condutor [motorista] traumatizado em um acidente de trânsito
V62.6 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a motor
de duas ou três rodas ­ passageiro traumatizado em um acidente de trânsito
V62.7 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a motor
de duas ou três rodas ­ pessoa viajando no exterior do veículo traumatizada em um acidente de
trânsito
V62.9 Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a motor
de duas ou três rodas ­ ocupante não especificado de um veículo de transporte pesado traumatizado
em um acidente de trânsito
V63.0 Ocupante de um veículo de transporte pesado traumatizado em colisão com um automóvel
[carro] ou uma caminhonete ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V63.1 Ocupante de um veículo de transporte pesado traumatizado em colisão com um automóvel
[carro] ou uma caminhonete ­ passageiro traumatizado em um acidente não­de­trânsito
V63.2 Ocupante de um veículo de transporte pesado traumatizado em colisão com um automóvel
[carro] ou uma caminhonete ­ pessoa viajando no exterior do veículo traumatizada em um acidente
não­de­trânsito
V63.3 Ocupante de um veículo de transporte pesado traumatizado em colisão com um automóvel
[carro] ou uma caminhonete ­ ocupante não especificado de um veículo de transporte pesado
traumatizado em um acidente não­de­trânsito
V63.4 Ocupante de um veículo de transporte pesado traumatizado em colisão com um automóvel
[carro] ou uma caminhonete ­ pessoa traumatizado ao subir ou descer do veículo
V63.5 Ocupante de um veículo de transporte pesado traumatizado em colisão com um automóvel
[carro] ou uma caminhonete ­ condutor [motorista] traumatizado em um acidente de trânsito
V63.6 Ocupante de um veículo de transporte pesado traumatizado em colisão com um automóvel
[carro] ou uma caminhonete ­ passageiro traumatizado em um acidente de trânsito
V63.7 Ocupante de um veículo de transporte pesado traumatizado em colisão com um automóvel
[carro] ou uma caminhonete ­ pessoa viajando no exterior do veículo traumatizada em um acidente de
trânsito
V63.9 Ocupante de um veículo de transporte pesado traumatizado em colisão com um automóvel
[carro] ou uma caminhonete ­ ocupante não especificado de um veículo de transporte pesado
traumatizado em um acidente de trânsito
V64.0 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo de
transporte pesado ou um ônibus ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V64.1 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo de
transporte pesado ou um ônibus ­ passageiro traumatizado em um acidente não­de­trânsito
V64.2 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo de
transporte pesado ou um ônibus ­ pessoa viajando no exterior do veículo traumatizada em um acidente
não­de­trânsito
V64.3 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo de
transporte pesado ou um ônibus ­ ocupante não especificado de um veículo de transporte pesado
traumatizado em um acidente não­de­trânsito
V64.4 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo de
transporte pesado ou um ônibus ­ pessoa traumatizado ao subir ou descer do veículo
V64.5 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo de
transporte pesado ou um ônibus ­ condutor [motorista] traumatizado em um acidente de trânsito
V64.6 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo de
transporte pesado ou um ônibus ­ passageiro traumatizado em um acidente de trânsito
V64.7 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo de
transporte pesado ou um ônibus ­ pessoa viajando no exterior do veículo traumatizada em um acidente
de trânsito
V64.9 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo de
transporte pesado ou um ônibus ­ ocupante não especificado de um veículo de transporte pesado
traumatizado em um acidente de trânsito
V65.0 Ocupante de um veículo de transporte pesado traumatizado em colisão com um trem [comboio]
ou um veículo ferroviário ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V65.1 Ocupante de um veículo de transporte pesado traumatizado em colisão com um trem [comboio]
ou um veículo ferroviário ­ passageiro traumatizado em um acidente não­de­trânsito
V65.2 Ocupante de um veículo de transporte pesado traumatizado em colisão com um trem [comboio]
ou um veículo ferroviário ­ pessoa viajando no exterior do veículo traumatizada em um acidente nãode­trânsito
V65.3 Ocupante de um veículo de transporte pesado traumatizado em colisão com um trem [comboio]
ou um veículo ferroviário ­ ocupante não especificado de um veículo de transporte pesado
traumatizado em um acidente não­de­trânsito
V65.4 Ocupante de um veículo de transporte pesado traumatizado em colisão com um trem [comboio]
ou um veículo ferroviário ­ pessoa traumatizado ao subir ou descer do veículo
V65.5 Ocupante de um veículo de transporte pesado traumatizado em colisão com um trem [comboio]
ou um veículo ferroviário ­ condutor [motorista] traumatizado em um acidente de trânsito
V65.6 Ocupante de um veículo de transporte pesado traumatizado em colisão com um trem [comboio]
ou um veículo ferroviário ­ passageiro traumatizado em um acidente de trânsito
V65.7 Ocupante de um veículo de transporte pesado traumatizado em colisão com um trem [comboio]
ou um veículo ferroviário ­ pessoa viajando no exterior do veículo traumatizada em um acidente de
trânsito
V65.9 Ocupante de um veículo de transporte pesado traumatizado em colisão com um trem [comboio]
ou um veículo ferroviário ­ ocupante não especificado de um veículo de transporte pesado
traumatizado em um acidente de trânsito
V66.0 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo
não­motorizado ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V66.1 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo
não­motorizado ­ passageiro traumatizado em um acidente não­de­trânsito
V66.2 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo
não­motorizado ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V66.3 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo
não­motorizado ­ ocupante não especificado de um veículo de transporte pesado traumatizado em um
acidente não­de­trânsito
V66.4 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo
não­motorizado ­ pessoa traumatizado ao subir ou descer do veículo
V66.5 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo
não­motorizado ­ condutor [motorista] traumatizado em um acidente de trânsito
V66.6 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo
não­motorizado ­ passageiro traumatizado em um acidente de trânsito
V66.7 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo
não­motorizado ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V66.9 Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo
não­motorizado ­ ocupante não especificado de um veículo de transporte pesado traumatizado em um
acidente de trânsito
V67.0 Ocupante de um veículo de transporte pesado traumatizado em colisão com um objeto fixo ou
parado ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V67.1 Ocupante de um veículo de transporte pesado traumatizado em colisão com um objeto fixo ou
parado ­ passageiro traumatizado em um acidente não­de­trânsito
V67.2 Ocupante de um veículo de transporte pesado traumatizado em colisão com um objeto fixo ou
parado ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V67.3 Ocupante de um veículo de transporte pesado traumatizado em colisão com um objeto fixo ou
parado ­ ocupante não especificado de um veículo de transporte pesado traumatizado em um acidente
não­de­trânsito
V67.4 Ocupante de um veículo de transporte pesado traumatizado em colisão com um objeto fixo ou
parado ­ pessoa traumatizado ao subir ou descer do veículo
V67.5 Ocupante de um veículo de transporte pesado traumatizado em colisão com um objeto fixo ou
parado ­ condutor [motorista] traumatizado em um acidente de trânsito
V67.6 Ocupante de um veículo de transporte pesado traumatizado em colisão com um objeto fixo ou
parado ­ passageiro traumatizado em um acidente de trânsito
V67.7 Ocupante de um veículo de transporte pesado traumatizado em colisão com um objeto fixo ou
parado ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V67.9 Ocupante de um veículo de transporte pesado traumatizado em colisão com um objeto fixo ou
parado ­ ocupante não especificado de um veículo de transporte pesado traumatizado em um acidente
de trânsito
V68.0 Ocupante de um veículo de transporte pesado traumatizado em um acidente de transporte sem
colisão ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V68.1 Ocupante de um veículo de transporte pesado traumatizado em um acidente de transporte sem
colisão ­ passageiro traumatizado em um acidente não­de­trânsito
V68.2 Ocupante de um veículo de transporte pesado traumatizado em um acidente de transporte sem
colisão ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V68.3 Ocupante de um veículo de transporte pesado traumatizado em um acidente de transporte sem
colisão ­ ocupante não especificado de um veículo de transporte pesado traumatizado em um acidente
não­de­trânsito
V68.4 Ocupante de um veículo de transporte pesado traumatizado em um acidente de transporte sem
colisão ­ pessoa traumatizado ao subir ou descer do veículo
V68.5 Ocupante de um veículo de transporte pesado traumatizado em um acidente de transporte sem
colisão ­ condutor [motorista] traumatizado em um acidente de trânsito
V68.6 Ocupante de um veículo de transporte pesado traumatizado em um acidente de transporte sem
colisão ­ passageiro traumatizado em um acidente de trânsito
V68.7 Ocupante de um veículo de transporte pesado traumatizado em um acidente de transporte sem
colisão ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V68.9 Ocupante de um veículo de transporte pesado traumatizado em um acidente de transporte sem
colisão ­ ocupante não especificado de um veículo de transporte pesado traumatizado em um acidente
de trânsito
V69.0 Condutor [motorista] traumatizado em colisão com outros veículos e com veículos não
especificados, a motor, em um acidente não­de­trânsito
V69.1 Passageiro traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente não­de­trânsito
V69.2 Ocupante não especificado de um veículo de transporte pesado traumatizado em colisão com
outros veículos e com veículos não especificados, a motor, em um acidente não­de­trânsito
V69.3 Ocupante [qualquer] de um veículo de transporte pesado traumatizado em um acidente não
especificado e não­de­trânsito
V69.4 Condutor [motorista] traumatizado em colisão com outros veículos e com veículos não
especificados, a motor, em um acidente de trânsito
V69.5 Passageiro traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente de trânsito
V69.6 Ocupante não especificado de um veículo de transporte pesado traumatizado em colisão com
outros veículos e com veículos não especificados, a motor, em um acidente de trânsito
V69.8 Ocupante [qualquer] de um veículo de transporte pesado traumatizado em outros acidentes de
transporte especificados
V69.9 Ocupante [qualquer] de um veículo de transporte pesado traumatizado em um acidente de
trânsito não especificado
V70.0 Ocupante de um ônibus traumatizado em colisão com um pedestre ou um animal ­ condutor
[motorista] traumatizado em um acidente não­de­trânsito
V70.1 Ocupante de um ônibus traumatizado em colisão com um pedestre ou um animal ­ passageiro
traumatizado em um acidente não­de­trânsito
V70.2 Ocupante de um ônibus traumatizado em colisão com um pedestre ou um animal ­ pessoa
viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V70.3 Ocupante de um ônibus traumatizado em colisão com um pedestre ou um animal ­ ocupante não
especificado de um ônibus traumatizado em um acidente não­de­trânsito
V70.4 Ocupante de um ônibus traumatizado em colisão com um pedestre ou um animal ­ pessoa
traumatizado ao subir ou descer do veículo
V70.5 Ocupante de um ônibus traumatizado em colisão com um pedestre ou um animal ­ condutor
[motorista] traumatizado em um acidente de trânsito
V70.6 Ocupante de um ônibus traumatizado em colisão com um pedestre ou um animal ­ passageiro
traumatizado em um acidente de trânsito
V70.7 Ocupante de um ônibus traumatizado em colisão com um pedestre ou um animal ­ pessoa
viajando no exterior do veículo traumatizada em um acidente de trânsito
V70.9 Ocupante de um ônibus traumatizado em colisão com um pedestre ou um animal ­ ocupante não
especificado de um ônibus traumatizado em um acidente de trânsito
V71.0 Ocupante de um ônibus traumatizado em colisão com um veículo a pedal ­ condutor [motorista]
traumatizado em um acidente não­de­trânsito
V71.1 Ocupante de um ônibus traumatizado em colisão com um veículo a pedal ­ passageiro
traumatizado em um acidente não­de­trânsito
V71.2 Ocupante de um ônibus traumatizado em colisão com um veículo a pedal ­ pessoa viajando no
exterior do veículo traumatizada em um acidente não­de­trânsito
V71.3 Ocupante de um ônibus traumatizado em colisão com um veículo a pedal ­ ocupante não
especificado de um ônibus traumatizado em um acidente não­de­trânsito
V71.4 Ocupante de um ônibus traumatizado em colisão com um veículo a pedal ­ pessoa traumatizado
ao subir ou descer do veículo
V71.5 Ocupante de um ônibus traumatizado em colisão com um veículo a pedal ­ condutor [motorista]
traumatizado em um acidente de trânsito
V71.6 Ocupante de um ônibus traumatizado em colisão com um veículo a pedal ­ passageiro
traumatizado em um acidente de trânsito
V71.7 Ocupante de um ônibus traumatizado em colisão com um veículo a pedal ­ pessoa viajando no
exterior do veículo traumatizada em um acidente de trânsito
V71.9 Ocupante de um ônibus traumatizado em colisão com um veículo a pedal ­ ocupante não
especificado de um ônibus traumatizado em um acidente de trânsito
V72.0 Ocupante de um ônibus traumatizado em colisão com um outro veículo a motor de duas ou três
rodas ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V72.1 Ocupante de um ônibus traumatizado em colisão com um outro veículo a motor de duas ou três
rodas ­ passageiro traumatizado em um acidente não­de­trânsito
V72.2 Ocupante de um ônibus traumatizado em colisão com um outro veículo a motor de duas ou três
rodas ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V72.3 Ocupante de um ônibus traumatizado em colisão com um outro veículo a motor de duas ou três
rodas ­ ocupante não especificado de um ônibus traumatizado em um acidente não­de­trânsito
V72.4 Ocupante de um ônibus traumatizado em colisão com um outro veículo a motor de duas ou três
rodas ­ pessoa traumatizado ao subir ou descer do veículo
V72.5 Ocupante de um ônibus traumatizado em colisão com um outro veículo a motor de duas ou três
rodas ­ condutor [motorista] traumatizado em um acidente de trânsito
V72.6 Ocupante de um ônibus traumatizado em colisão com um outro veículo a motor de duas ou três
rodas ­ passageiro traumatizado em um acidente de trânsito
V72.7 Ocupante de um ônibus traumatizado em colisão com um outro veículo a motor de duas ou três
rodas ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V72.9 Ocupante de um ônibus traumatizado em colisão com um outro veículo a motor de duas ou três
rodas ­ ocupante não especificado de um ônibus traumatizado em um acidente de trânsito
V73.0 Ocupante de um ônibus traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V73.1 Ocupante de um ônibus traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ passageiro traumatizado em um acidente não­de­trânsito
V73.2 Ocupante de um ônibus traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V73.3 Ocupante de um ônibus traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ ocupante não especificado de um ônibus traumatizado em um acidente não­de­trânsito
V73.4 Ocupante de um ônibus traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ pessoa traumatizado ao subir ou descer do veículo
V73.5 Ocupante de um ônibus traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ condutor [motorista] traumatizado em um acidente de trânsito
V73.6 Ocupante de um ônibus traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ passageiro traumatizado em um acidente de trânsito
V73.7 Ocupante de um ônibus traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V73.9 Ocupante de um ônibus traumatizado em colisão com um automóvel [carro] ou uma
caminhonete ­ ocupante não especificado de um ônibus traumatizado em um acidente de trânsito
V74.0 Ocupante de um ônibus traumatizado em colisão com um veículo de transporte pesado ou um
ônibus ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V74.1 Ocupante de um ônibus traumatizado em colisão com um veículo de transporte pesado ou um
ônibus ­ passageiro traumatizado em um acidente não­de­trânsito
V74.2 Ocupante de um ônibus traumatizado em colisão com um veículo de transporte pesado ou um
ônibus ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V74.3 Ocupante de um ônibus traumatizado em colisão com um veículo de transporte pesado ou um
ônibus ­ ocupante não especificado de um ônibus traumatizado em um acidente não­de­trânsito
V74.4 Ocupante de um ônibus traumatizado em colisão com um veículo de transporte pesado ou um
ônibus ­ pessoa traumatizado ao subir ou descer do veículo
V74.5 Ocupante de um ônibus traumatizado em colisão com um veículo de transporte pesado ou um
ônibus ­ condutor [motorista] traumatizado em um acidente de trânsito
V74.6 Ocupante de um ônibus traumatizado em colisão com um veículo de transporte pesado ou um
ônibus ­ passageiro traumatizado em um acidente de trânsito
V74.7 Ocupante de um ônibus traumatizado em colisão com um veículo de transporte pesado ou um
ônibus ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V74.9 Ocupante de um ônibus traumatizado em colisão com um veículo de transporte pesado ou um
ônibus ­ ocupante não especificado de um ônibus traumatizado em um acidente de trânsito
V75.0 Ocupante de um ônibus traumatizado em colisão com um trem [comboio] ou um veículo
ferroviário ­ condutor [motorista] traumatizado em um acidente não­de­trânsito
V75.1 Ocupante de um ônibus traumatizado em colisão com um trem [comboio] ou um veículo
ferroviário ­ passageiro traumatizado em um acidente não­de­trânsito
V75.2 Ocupante de um ônibus traumatizado em colisão com um trem [comboio] ou um veículo
ferroviário ­ pessoa viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V75.3 Ocupante de um ônibus traumatizado em colisão com um trem [comboio] ou um veículo
ferroviário ­ ocupante não especificado de um ônibus traumatizado em um acidente não­de­trânsito
V75.4 Ocupante de um ônibus traumatizado em colisão com um trem [comboio] ou um veículo
ferroviário ­ pessoa traumatizado ao subir ou descer do veículo
V75.5 Ocupante de um ônibus traumatizado em colisão com um trem [comboio] ou um veículo
ferroviário ­ condutor [motorista] traumatizado em um acidente de trânsito
V75.6 Ocupante de um ônibus traumatizado em colisão com um trem [comboio] ou um veículo
ferroviário ­ passageiro traumatizado em um acidente de trânsito
V75.7 Ocupante de um ônibus traumatizado em colisão com um trem [comboio] ou um veículo
ferroviário ­ pessoa viajando no exterior do veículo traumatizada em um acidente de trânsito
V75.9 Ocupante de um ônibus traumatizado em colisão com um trem [comboio] ou um veículo
ferroviário ­ ocupante não especificado de um ônibus traumatizado em um acidente de trânsito
V76.0 Ocupante de um ônibus traumatizado em colisão com outro veículo não­motorizado ­ condutor
[motorista] traumatizado em um acidente não­de­trânsito
V76.1 Ocupante de um ônibus traumatizado em colisão com outro veículo não­motorizado ­ passageiro
traumatizado em um acidente não­de­trânsito
V76.2 Ocupante de um ônibus traumatizado em colisão com outro veículo não­motorizado ­ pessoa
viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V76.3 Ocupante de um ônibus traumatizado em colisão com outro veículo não­motorizado ­ ocupante
não especificado de um ônibus traumatizado em um acidente não­de­trânsito
V76.4 Ocupante de um ônibus traumatizado em colisão com outro veículo não­motorizado ­ pessoa
traumatizado ao subir ou descer do veículo
V76.5 Ocupante de um ônibus traumatizado em colisão com outro veículo não­motorizado ­ condutor
[motorista] traumatizado em um acidente de trânsito
V76.6 Ocupante de um ônibus traumatizado em colisão com outro veículo não­motorizado ­ passageiro
traumatizado em um acidente de trânsito
V76.7 Ocupante de um ônibus traumatizado em colisão com outro veículo não­motorizado ­ pessoa
viajando no exterior do veículo traumatizada em um acidente de trânsito
V76.9 Ocupante de um ônibus traumatizado em colisão com outro veículo não­motorizado ­ ocupante
não especificado de um ônibus traumatizado em um acidente de trânsito
V77.0 Ocupante de um ônibus traumatizado em colisão com um objeto fixo ou parado ­ condutor
[motorista] traumatizado em um acidente não­de­trânsito
V77.1 Ocupante de um ônibus traumatizado em colisão com um objeto fixo ou parado ­ passageiro
traumatizado em um acidente não­de­trânsito
V77.2 Ocupante de um ônibus traumatizado em colisão com um objeto fixo ou parado ­ pessoa
viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V77.3 Ocupante de um ônibus traumatizado em colisão com um objeto fixo ou parado ­ ocupante não
especificado de um ônibus traumatizado em um acidente não­de­trânsito
V77.4 Ocupante de um ônibus traumatizado em colisão com um objeto fixo ou parado ­ pessoa
traumatizado ao subir ou descer do veículo
V77.5 Ocupante de um ônibus traumatizado em colisão com um objeto fixo ou parado ­ condutor
[motorista] traumatizado em um acidente de trânsito
V77.6 Ocupante de um ônibus traumatizado em colisão com um objeto fixo ou parado ­ passageiro
traumatizado em um acidente de trânsito
V77.7 Ocupante de um ônibus traumatizado em colisão com um objeto fixo ou parado ­ pessoa
viajando no exterior do veículo traumatizada em um acidente de trânsito
V77.9 Ocupante de um ônibus traumatizado em colisão com um objeto fixo ou parado ­ ocupante não
especificado de um ônibus traumatizado em um acidente de trânsito
V78.0 Ocupante de um ônibus traumatizado em um acidente de transporte sem colisão ­ condutor
[motorista] traumatizado em um acidente não­de­trânsito
V78.1 Ocupante de um ônibus traumatizado em um acidente de transporte sem colisão ­ passageiro
traumatizado em um acidente não­de­trânsito
V78.2 Ocupante de um ônibus traumatizado em um acidente de transporte sem colisão ­ pessoa
viajando no exterior do veículo traumatizada em um acidente não­de­trânsito
V78.3 Ocupante de um ônibus traumatizado em um acidente de transporte sem colisão ­ ocupante não
especificado de um ônibus traumatizado em um acidente não­de­trânsito
V78.4 Ocupante de um ônibus traumatizado em um acidente de transporte sem colisão ­ pessoa
traumatizado ao subir ou descer do veículo
V78.5 Ocupante de um ônibus traumatizado em um acidente de transporte sem colisão ­ condutor
[motorista] traumatizado em um acidente de trânsito
V78.6 Ocupante de um ônibus traumatizado em um acidente de transporte sem colisão ­ passageiro
traumatizado em um acidente de trânsito
V78.7 Ocupante de um ônibus traumatizado em um acidente de transporte sem colisão ­ pessoa
viajando no exterior do veículo traumatizada em um acidente de trânsito
V78.9 Ocupante de um ônibus traumatizado em um acidente de transporte sem colisão ­ ocupante não
especificado de um ônibus traumatizado em um acidente de trânsito
V79.0 Condutor [motorista] traumatizado em colisão com outros veículos e com veículos não
especificados, a motor, em um acidente não­de­trânsito
V79.1 Passageiro traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente não­de­trânsito
V79.2 Ocupante não especificado de um ônibus traumatizado em colisão com outros veículos e com
um veículos não especificados, a motor, em um acidente não­de­trânsito
V79.3 Ocupante [qualquer] de um ônibus traumatizado em um acidente não­de­trânsito
V79.4 Condutor [motorista] traumatizado em colisão com outros veículos e com veículos não
especificados, a motor, em um acidente de trânsito
V79.5 Passageiro traumatizado em colisão com outros veículos e com veículos não especificados, a
motor, em um acidente de trânsito
V79.6 Ocupante não especificado de um ônibus traumatizado em colisão com um outros veículos e
com um veículos não especificados, a motor, em um acidente de trânsito
V79.8 Ocupante [ qualquer] de um ônibus traumatizado em outros acidentes de transporte
especificados
V79.9 Ocupante [qualquer] de um ônibus traumatizado em um acidente de trânsito não especificado
V80.0 Queda ou ejeção de uma pessoa montada em animal ou ocupante de um veículo a tração
animal em um acidente sem colisão
V80.1 Pessoa montada em animal ou ocupante de um veículo a tração animal traumatizado em colisão
com um pedestre ou um animal
V80.2 Pessoa montada em animal ou ocupante de um veículo a tração animal traumatizado em colisão
com um veículo a pedal
V80.3 Pessoa montada em animal ou ocupante de um veículo a tração animal traumatizado em colisão
com um veículo a motor de duas ou três rodas
V80.4 Pessoa montada em animal ou ocupante de um veículo a tração animal traumatizado em colisão
com um automóvel [carro], uma caminhonete, um veículo de transporte pesado ou um ônibus
V80.5 Pessoa montada em animal ou ocupante de um veículo a tração animal traumatizado em colisão
com um outro veículo a motor especificado
V80.6 Pessoa montada em animal ou ocupante de um veículo a tração animal traumatizado em colisão
com um trem [comboio] ou um veículo ferroviário
V80.7 Pessoa montada em animal ou ocupante de um veículo a tração animal traumatizado em colisão
com um outro veículo não­motorizado
V80.8 Pessoa montada em animal ou ocupante de um veículo a tração animal traumatizado em colisão
com um objeto fixo ou parado
V80.9 Pessoa montada em animal ou ocupante de um veículo a tração animal traumatizado em outros
acidentes de transporte e em acidentes de transporte não especificados
V81.0 Ocupante de um trem [comboio] ou de um veículo ferroviário traumatizado em colisão com um
veículo a motor em um acidente não­de­trânsito
V81.1 Ocupante de um trem [comboio] ou de um veículo ferroviário traumatizado em colisão com um
veículo a motor em um acidente de trânsito
V81.2 Ocupante de um trem [comboio] ou de um veículo ferroviário traumatizado em colisão com ou
atingido por material rodante
V81.3 Ocupante de um trem [comboio] ou de um veículo ferroviário traumatizado em colisão com outro
objeto
V81.4 Pessoa traumatizada ao subir ou descer de um trem [comboio] ou de um veículo ferroviário
V81.5 Ocupante de um trem [comboio] ou de um veículo ferroviário traumatizado devido a uma queda
no interior dos mesmos
V81.6 Ocupante de um trem [comboio] ou de um veículo ferroviário traumatizado devido a uma queda
do trem ou do veículo ferroviário
V81.7 Ocupante de um trem [comboio] ou de um veículo ferroviário traumatizado em razão de um
descarrilhamento sem colisão antecedente
V81.8 Ocupante de um trem [comboio] ou de um veículo ferroviário traumatizado em outro acidente
ferroviário especificado
V81.9 Ocupante de um trem [comboio] ou de um veículo ferroviário traumatizado em um acidente
ferroviário não especificado
V82.0 Ocupante de um bonde [carro elétrico] traumatizado em uma colisão com um veículo a motor em
um acidente não­de­trânsito
V82.1 Ocupante de um bonde [carro elétrico] traumatizado em uma colisão com um veículo a motor em
um acidente de trânsito
V82.2 Ocupante de um bonde [carro elétrico] traumatizado em uma colisão com ou atingido por
material rodante
V82.3 Ocupante de um bonde [carro elétrico] traumatizado em uma colisão com outro objeto
V82.4 Pessoa traumatizada ao subir ou descer de um bonde [carro elétrico]
V82.5 Ocupante de um bonde [carro elétrico] traumatizado devido a uma queda no interior do mesmo
V82.6 Ocupante de um bonde [carro elétrico] traumatizado devido a uma queda do mesmo
V82.7 Ocupante de um bonde [carro elétrico] traumatizado devido a um descarrilhamento sem colisão
antecedente
V82.8 Ocupante de um bonde [carro elétrico] traumatizado em outros acidentes de transporte
especificados
V82.9 Ocupante de um bonde [carro elétrico] traumatizado em um acidente de trânsito não
especificado
V83.0 Condutor [motorista] de um veículo especial a motor usado principalmente em áreas industrias
traumatizado em um acidente de trânsito
V83.1 Passageiro de um veículo especial a motor usado principalmente em áreas industriais
traumatizado em um acidente de trânsito
V83.2 Pessoa viajando no exterior de um veículo especial a motor usado principalmente em áreas
industriais traumatizado em um acidente de trânsito
V83.3 Ocupante não especificado de um veículo especial a motor usado principalmente em áreas
industriais traumatizado em um acidente de trânsito
V83.4 Pessoa traumatizada ao subir ou descer de um veículo especial a motor usado principalmente
em áreas industriais
V83.5 Condutor [motorista] de um veículo especial a motor usado principalmente em áreas industrias
traumatizado em um acidente não­de­trânsito
V83.6 Passageiro de um veículo especial a motor usado principalmente em áreas industriais
traumatizado em um acidente não­de­trânsito
V83.7 Pessoa viajando no exterior de um veículo especial a motor usado principalmente em áreas
industriais traumatizado em um acidente não­de­trânsito
V83.9 Ocupante não especificado de um veículo especial a motor usado principalmente em áreas
industriais traumatizado em um acidente não­de­trânsito
V84.0 Condutor [motorista] de um veículo especial a motor de uso essencialmente agrícola
traumatizado em um acidente de trânsito
V84.1 Passageiro de um veículo especial a motor de uso essencialmente agrícola traumatizado em um
acidente de trânsito
V84.2 Pessoa viajando no exterior de um veículo especial a motor de uso essencialmente agrícola
traumatizado em um acidente de trânsito
V84.3 Ocupante não especificado de um veículo especial a motor de uso essencialmente agrícola
traumatizado em um acidente de trânsito
V84.4 Pessoa traumatizado ao subir ou descer de um veículo especial a motor de uso essencialmente
agrícola
V84.5 Condutor [motorista] de um veículo especial a motor de uso essencialmente agrícola
traumatizado em um acidente não­de­trânsito
V84.6 Passageiro de um veículo especial a motor de uso essencialmente agrícola traumatizado em um
acidente não­de­trânsito
V84.7 Pessoa viajando no exterior de um veículo especial a motor de uso essencialmente agrícola
traumatizado em um acidente não­de­trânsito
V84.9 Ocupante não especificado de um veículo especial a motor de uso essencialmente agrícola
traumatizada em um acidente não­de­trânsito
V85.0 Condutor [motorista] de um veículo a motor especial de construções traumatizado em um
acidente de trânsito
V85.1 Passageiro de um veículo a motor especial de construções traumatizado em um acidente de
trânsito
V85.2 Pessoa viajando no exterior de um veículo a motor especial de construções traumatizado em um
acidente de trânsito
V85.3 Ocupante não especificado de um veículo a motor especial de construções traumatizado em um
acidente de trânsito
V85.4 Pessoa traumatizada ao subir ou descer de um veículo a motor especial de construções
V85.5 Condutor [motorista] de um veículo a motor especial de construções traumatizado em um
acidente não­de­trânsito
V85.6 Passageiro de um veículo a motor especial de construções traumatizado em um acidente nãode­trânsito
V85.7 Pessoa viajando no exterior de um veículo a motor especial de construções traumatizado em um
acidente não­de­trânsito
V85.9 Ocupante não especificado de um veículo a motor especial de construções traumatizado em um
acidente não­de­trânsito
V86.0 Condutor [motorista] de um veículo especial para qualquer terreno ou de outro veículo a motor
projetado essencialmente para uso não em via pública, traumatizado em um acidente de trânsito
V86.1 Passageiro de um veículo especial para qualquer terreno ou de outro veículo a motor projetado
essencialmente para uso não em via pública, traumatizado em um acidente de trânsito
V86.2 Pessoa viajando no exterior de um veículo especial para qualquer terreno ou de outro veículo a
motor projetado essencialmente para uso não em via pública, traumatizado em um acidente de trânsito
V86.3 Ocupante não especificado de um veículo especial para qualquer terreno ou de outro veículo a
motor projetado essencialmente para uso não em via pública traumatizado em um acidente de trânsito
V86.4 Pessoa traumatizada ao subir ou descer de um veículo especial para qualquer terreno ou de
outro veículo a motor projetado essencialmente para uso não em via pública
V86.5 Condutor [motorista] de um veículo especial para qualquer terreno ou de outro veículo a motor
projetado essencialmente para uso não em via pública traumatizado em um acidente não­de­trânsito
V86.6 Passageiro de um veículo especial para qualquer terreno ou de outro veículo a motor projetado
essencialmente para uso não em via pública traumatizado em um acidente não­de­trânsito
V86.7 Pessoa viajando no exterior de um veículo especial para qualquer terreno ou de outro veículo a
motor projetado essencialmente para uso não em via pública traumatizado em um acidente não­detrânsito
V86.9 Ocupante não especificado de um veículo especial para qualquer terreno ou de outro veículo a
motor projetado essencialmente para uso não em via pública traumatizado em um acidente não­detrânsito
V87.0 Pessoa traumatizada em uma colisão entre um automóvel [carro] e um veículo a motor de duas
ou três rodas (acidente de trânsito)
V87.1 Pessoa traumatizada em uma colisão entre outro veículo a motor e um veículo a motor de duas
ou três rodas (acidente de trânsito)
V87.2 Pessoa traumatizada em uma colisão entre um automóvel [carro] e uma caminhonete (acidente
de trânsito)
V87.3 Pessoa traumatizada em uma colisão entre um automóvel [carro] e um ônibus (acidente de
trânsito)
V87.4 Pessoa traumatizada em uma colisão entre um automóvel [carro] e um veículo de transporte
pesado (acidente de trânsito)
V87.5 Pessoa traumatizada em uma colisão entre um veículo de transporte pesado e um ônibus
(acidente de trânsito)
V87.6 Pessoa traumatizada em uma colisão entre um trem ou um veículo ferroviário e um automóvel
[carro] (acidente de trânsito)
V87.7 Pessoa traumatizada em uma colisão entre outros veículos a motor especificados (acidente de
trânsito)
V87.8 Pessoa traumatizada em outros acidentes de transporte especificados com veículo a motor, sem
colisão (acidente de trânsito)
V87.9 Pessoa traumatizada em outros acidentes de transporte especificados (com colisão) (sem
colisão) envolvendo um veículo não­motorizado (acidente de trânsito)
V88.0 Pessoa traumatizada em uma colisão entre um automóvel [carro] e um veículo a motor de duas
ou três rodas, não­de­trânsito
V88.1 Pessoa traumatizada em uma colisão entre outro veículo a motor e um veículo a motor de duas
ou três rodas, não­de­trânsito
V88.2 Pessoa traumatizada em uma colisão entre um automóvel [carro] e uma caminhonete, não­detrânsito
V88.3 Pessoa traumatizada em uma colisão entre um automóvel [carro] e um ônibus, não­de­trânsito
V88.4 Pessoa traumatizada em uma colisão entre um automóvel [carro] e um veículo de transporte
pesado, não­de­trânsito
V88.5 Pessoa traumatizada em uma colisão entre um veículo de transporte pesado e um ônibus, não­
de­trânsito
V88.6 Pessoa traumatizada em uma colisão entre um trem ou um veículo ferroviário e um automóvel
[carro], não­de­trânsito
V88.7 Pessoa traumatizada em uma colisão entre outros veículos a motor especificados, não­detrânsito
V88.8 Pessoa traumatizada em outros acidentes de transporte especificados, com um veículo a motor,
sem colisão, não­de­trânsito
V88.9 Pessoa traumatizada em outros acidente de transporte especificados (com colisão) (sem
colisão), envolvendo um veículo não­motorizado, não­de­trânsito
V89.0 Pessoa traumatizada em um acidente com um veículo a motor não especificado, não­de­trânsito
V89.1 Pessoa traumatizada em um acidente com veículo não­motorizado, não especificado, não­detrânsito
V89.2 Pessoa traumatizada em um acidente de trânsito com um veículo a motor não especificado
V89.3 Pessoa traumatizado em um acidente de trânsito com um veículo não­motorizado, não
especificado
V89.9 Pessoa traumatizada em um acidente com um veículo não especificado
V90.0 Acidente com embarcação causando afogamento e submersão ­ navio mercante
V90.1 Acidente com embarcação causando afogamento e submersão ­ navio de passageiros
V90.2 Acidente com embarcação causando afogamento e submersão ­ barco de pesca
V90.3 Acidente com embarcação causando afogamento e submersão ­ outras embarcações a motor:
V90.4 Acidente com embarcação causando afogamento e submersão ­ barco a vela
V90.5 Acidente com embarcação causando afogamento e submersão ­ caiaque ou canoa
V90.6 Acidente com embarcação causando afogamento e submersão ­ bote inflável (sem motor)
V90.7 Acidente com embarcação causando afogamento e submersão ­ esqui aquático
V90.8 Acidente com embarcação causando afogamento e submersão ­ outras embarcações sem motor
V90.9 Acidente com embarcação causando afogamento e submersão ­ embarcação não especificada
V91.0 Acidente com embarcação causando outro tipo de traumatismo ­ navio mercante
V91.1 Acidente com embarcação causando outro tipo de traumatismo ­ navio de passageiros
V91.2 Acidente com embarcação causando outro tipo de traumatismo ­ barco de pesca
V91.3 Acidente com embarcação causando outro tipo de traumatismo ­ outras embarcações a motor:
V91.4 Acidente com embarcação causando outro tipo de traumatismo ­ barco a vela
V91.5 Acidente com embarcação causando outro tipo de traumatismo ­ caiaque ou canoa
V91.6 Acidente com embarcação causando outro tipo de traumatismo ­ bote inflável (sem motor)
V91.7 Acidente com embarcação causando outro tipo de traumatismo ­ esqui aquático
V91.8 Acidente com embarcação causando outro tipo de traumatismo ­ outras embarcações sem motor
V91.9 Acidente com embarcação causando outro tipo de traumatismo ­ embarcação não especificada
V92.0 Afogamento e submersão relacionados com transporte por água sem acidente com a
embarcação ­ navio mercante
V92.1 Afogamento e submersão relacionados com transporte por água sem acidente com a
embarcação ­ navio de passageiros
V92.2 Afogamento e submersão relacionados com transporte por água sem acidente com a
embarcação ­ barco de pesca
V92.3 Afogamento e submersão relacionados com transporte por água sem acidente com a
embarcação ­ outras embarcações a motor:
V92.4 Afogamento e submersão relacionados com transporte por água sem acidente com a
embarcação ­ barco a vela
V92.5 Afogamento e submersão relacionados com transporte por água sem acidente com a
embarcação ­ caiaque ou canoa
V92.6 Afogamento e submersão relacionados com transporte por água sem acidente com a
embarcação ­ bote inflável (sem motor)
V92.7 Afogamento e submersão relacionados com transporte por água sem acidente com a
embarcação ­ esqui aquático
V92.8 Afogamento e submersão relacionados com transporte por água sem acidente com a
embarcação ­ outras embarcações sem motor
V92.9 Afogamento e submersão relacionados com transporte por água sem acidente com a
embarcação ­ embarcação não especificada
V93.0 Acidente a bordo de uma embarcação, sem acidente da embarcação e não causando
afogamento ou submersão ­ navio mercante
V93.1 Acidente a bordo de uma embarcação, sem acidente da embarcação e não causando
afogamento ou submersão ­ navio de passageiros
V93.2 Acidente a bordo de uma embarcação, sem acidente da embarcação e não causando
afogamento ou submersão ­ barco de pesca
V93.3 Acidente a bordo de uma embarcação, sem acidente da embarcação e não causando
afogamento ou submersão ­ outras embarcações a motor:
V93.4 Acidente a bordo de uma embarcação, sem acidente da embarcação e não causando
afogamento ou submersão ­ barco a vela
V93.5 Acidente a bordo de uma embarcação, sem acidente da embarcação e não causando
afogamento ou submersão ­ caiaque ou canoa
V93.6 Acidente a bordo de uma embarcação, sem acidente da embarcação e não causando
afogamento ou submersão ­ bote inflável (sem motor)
V93.7 Acidente a bordo de uma embarcação, sem acidente da embarcação e não causando
afogamento ou submersão ­ esqui aquático
V93.8 Acidente a bordo de uma embarcação, sem acidente da embarcação e não causando
afogamento ou submersão ­ outras embarcações sem motor
V93.9 Acidente a bordo de uma embarcação, sem acidente da embarcação e não causando
afogamento ou submersão ­ embarcação não especificada
V94.0 Outros acidentes de transporte por água e os não especificados ­ navio mercante
V94.1 Outros acidentes de transporte por água e os não especificados ­ navio de passageiros
V94.2 Outros acidentes de transporte por água e os não especificados ­ barco de pesca
V94.3 Outros acidentes de transporte por água e os não especificados ­ outras embarcações a motor:
V94.4 Outros acidentes de transporte por água e os não especificados ­ barco a vela
V94.5 Outros acidentes de transporte por água e os não especificados ­ caiaque ou canoa
V94.6 Outros acidentes de transporte por água e os não especificados ­ bote inflável (sem motor)
V94.7 Outros acidentes de transporte por água e os não especificados ­ esqui aquático
V94.8 Outros acidentes de transporte por água e os não especificados ­ outras embarcações sem
motor
V94.9 Outros acidentes de transporte por água e os não especificados ­ embarcação não especificada
V95.0 Acidente de helicóptero causando traumatismo a ocupante
V95.1 Acidente de planador motorizado e ultraleve causando traumatismo a ocupante
V95.2 Acidente de outra aeronave de asa fixa de uso particular causando traumatismo a ocupante
V95.3 Acidente de aeronave de asa fixa de uso comercial causando traumatismo a ocupante
V95.4 Acidente de nave espacial causando traumatismo a ocupante
V95.8 Outros acidente de aeronaves causando traumatismo a ocupante
V95.9 Acidente de aeronave não especificada causando traumatismo a ocupante
V96.0 Acidente de balão causando traumatismo a ocupante
V96.1 Acidente de asa delta causando traumatismo a ocupante
V96.2 Acidente de planador (não­motorizado) causando traumatismo a ocupante
V96.8 Outros acidentes de aeronaves não­motorizadas causando traumatismo a ocupante
V96.9 Acidente não especificado de aeronave não­motorizada causando traumatismo a ocupante
V97.0 Ocupante de uma aeronave traumatizado em outros acidentes de transporte aéreo especificados
V97.1 Pessoa traumatizada ao embarcar em ou desembarcar de uma aeronave
V97.2 Paraquedista traumatizado em acidente de transporte aéreo
V97.3 Pessoa em terra traumatizada em acidente de transporte aéreo
V97.8 Outros acidentes de transporte aéreo não classificados em outra parte
V98 Outros acidentes de transporte especificados
V99 Acidente de transporte não especificado
W00.0 Queda no mesmo nível envolvendo gelo e neve ­ residência
W00.1 Queda no mesmo nível envolvendo gelo e neve ­ habitação coletiva
W00.2 Queda no mesmo nível envolvendo gelo e neve ­ escolas, outras instituições e áreas de
administração pública
W00.3 Queda no mesmo nível envolvendo gelo e neve ­ área para a prática de esportes e atletismo
W00.4 Queda no mesmo nível envolvendo gelo e neve ­ rua e estrada
W00.5 Queda no mesmo nível envolvendo gelo e neve ­ áreas de comércio e de serviços
W00.6 Queda no mesmo nível envolvendo gelo e neve ­ áreas industriais e em construção
W00.7 Queda no mesmo nível envolvendo gelo e neve ­ fazenda
W00.8 Queda no mesmo nível envolvendo gelo e neve ­ outros locais especificados
W00.9 Queda no mesmo nível envolvendo gelo e neve ­ local não especificado
W01.0 Queda no mesmo nível por escorregão, tropeção ou passos em falsos [traspés] ­ residência
W01.1 Queda no mesmo nível por escorregão, tropeção ou passos em falsos [traspés] ­ habitação
coletiva
W01.2 Queda no mesmo nível por escorregão, tropeção ou passos em falsos [traspés] ­ escolas,
outras instituições e áreas de administração pública
W01.3 Queda no mesmo nível por escorregão, tropeção ou passos em falsos [traspés] ­ área para a
prática de esportes e atletismo
W01.4 Queda no mesmo nível por escorregão, tropeção ou passos em falsos [traspés] ­ rua e estrada
W01.5 Queda no mesmo nível por escorregão, tropeção ou passos em falsos [traspés] ­ áreas de
comércio e de serviços
W01.6 Queda no mesmo nível por escorregão, tropeção ou passos em falsos [traspés] ­ áreas
industriais e em construção
W01.7 Queda no mesmo nível por escorregão, tropeção ou passos em falsos [traspés] ­ fazenda
W01.8 Queda no mesmo nível por escorregão, tropeção ou passos em falsos [traspés] ­ outros locais
especificados
W01.9 Queda no mesmo nível por escorregão, tropeção ou passos em falsos [traspés] ­ local não
especificado
W02.0 Queda envolvendo patins de rodas ou para gelo, esqui ou pranchas de rodas ­ residência
W02.1 Queda envolvendo patins de rodas ou para gelo, esqui ou pranchas de rodas ­ habitação
coletiva
W02.2 Queda envolvendo patins de rodas ou para gelo, esqui ou pranchas de rodas ­ escolas, outras
instituições e áreas de administração pública
W02.3 Queda envolvendo patins de rodas ou para gelo, esqui ou pranchas de rodas ­ área para a
prática de esportes e atletismo
W02.4 Queda envolvendo patins de rodas ou para gelo, esqui ou pranchas de rodas ­ rua e estrada
W02.5 Queda envolvendo patins de rodas ou para gelo, esqui ou pranchas de rodas ­ áreas de
comércio e de serviços
W02.6 Queda envolvendo patins de rodas ou para gelo, esqui ou pranchas de rodas ­ áreas industriais
e em construção
W02.7 Queda envolvendo patins de rodas ou para gelo, esqui ou pranchas de rodas ­ fazenda
W02.8 Queda envolvendo patins de rodas ou para gelo, esqui ou pranchas de rodas ­ outros locais
especificados
W02.9 Queda envolvendo patins de rodas ou para gelo, esqui ou pranchas de rodas ­ local não
especificado
W03.0 Outras quedas no mesmo nível por colisão com ou empurrão por outra pessoa ­ residência
W03.1 Outras quedas no mesmo nível por colisão com ou empurrão por outra pessoa ­ habitação
coletiva
W03.2 Outras quedas no mesmo nível por colisão com ou empurrão por outra pessoa ­ escolas, outras
instituições e áreas de administração pública
W03.3 Outras quedas no mesmo nível por colisão com ou empurrão por outra pessoa ­ área para a
prática de esportes e atletismo
W03.4 Outras quedas no mesmo nível por colisão com ou empurrão por outra pessoa ­ rua e estrada
W03.5 Outras quedas no mesmo nível por colisão com ou empurrão por outra pessoa ­ áreas de
comércio e de serviços
W03.6 Outras quedas no mesmo nível por colisão com ou empurrão por outra pessoa ­ áreas
industriais e em construção
W03.7 Outras quedas no mesmo nível por colisão com ou empurrão por outra pessoa ­ fazenda
W03.8 Outras quedas no mesmo nível por colisão com ou empurrão por outra pessoa ­ outros locais
especificados
W03.9 Outras quedas no mesmo nível por colisão com ou empurrão por outra pessoa ­ local não
especificado
W04.0 Queda, enquanto estava sendo carregado ou apoiado por outra(s) pessoa(s) ­ residência
W04.1 Queda, enquanto estava sendo carregado ou apoiado por outra(s) pessoa(s) ­ habitação
coletiva
W04.2 Queda, enquanto estava sendo carregado ou apoiado por outra(s) pessoa(s) ­ escolas, outras
instituições e áreas de administração pública
W04.3 Queda, enquanto estava sendo carregado ou apoiado por outra(s) pessoa(s) ­ área para a
prática de esportes e atletismo
W04.4 Queda, enquanto estava sendo carregado ou apoiado por outra(s) pessoa(s) ­ rua e estrada
W04.5 Queda, enquanto estava sendo carregado ou apoiado por outra(s) pessoa(s) ­ áreas de
comércio e de serviços
W04.6 Queda, enquanto estava sendo carregado ou apoiado por outra(s) pessoa(s) ­ áreas industriais
e em construção
W04.7 Queda, enquanto estava sendo carregado ou apoiado por outra(s) pessoa(s) ­ fazenda
W04.8 Queda, enquanto estava sendo carregado ou apoiado por outra(s) pessoa(s) ­ outros locais
especificados
W04.9 Queda, enquanto estava sendo carregado ou apoiado por outra(s) pessoa(s) ­ local não
especificado
W05.0 Queda envolvendo uma cadeira de rodas ­ residência
W05.1 Queda envolvendo uma cadeira de rodas ­ habitação coletiva
W05.2 Queda envolvendo uma cadeira de rodas ­ escolas, outras instituições e áreas de administração
pública
W05.3 Queda envolvendo uma cadeira de rodas ­ área para a prática de esportes e atletismo
W05.4 Queda envolvendo uma cadeira de rodas ­ rua e estrada
W05.5 Queda envolvendo uma cadeira de rodas ­ áreas de comércio e de serviços
W05.6 Queda envolvendo uma cadeira de rodas ­ áreas industriais e em construção
W05.7 Queda envolvendo uma cadeira de rodas ­ fazenda
W05.8 Queda envolvendo uma cadeira de rodas ­ outros locais especificados
W05.9 Queda envolvendo uma cadeira de rodas ­ local não especificado
W06.0 Queda de um leito ­ residência
W06.1 Queda de um leito ­ habitação coletiva
W06.2 Queda de um leito ­ escolas, outras instituições e áreas de administração pública
W06.3 Queda de um leito ­ área para a prática de esportes e atletismo
W06.4 Queda de um leito ­ rua e estrada
W06.5 Queda de um leito ­ áreas de comércio e de serviços
W06.6 Queda de um leito ­ áreas industriais e em construção
W06.7 Queda de um leito ­ fazenda
W06.8 Queda de um leito ­ outros locais especificados
W06.9 Queda de um leito ­ local não especificado
W07.0 Queda de uma cadeira ­ residência
W07.1 Queda de uma cadeira ­ habitação coletiva
W07.2 Queda de uma cadeira ­ escolas, outras instituições e áreas de administração pública
W07.3 Queda de uma cadeira ­ área para a prática de esportes e atletismo
W07.4 Queda de uma cadeira ­ rua e estrada
W07.5 Queda de uma cadeira ­ áreas de comércio e de serviços
W07.6 Queda de uma cadeira ­ áreas industriais e em construção
W07.7 Queda de uma cadeira ­ fazenda
W07.8 Queda de uma cadeira ­ outros locais especificados
W07.9 Queda de uma cadeira ­ local não especificado
W08.0 Queda de outro tipo de mobília ­ residência
W08.1 Queda de outro tipo de mobília ­ habitação coletiva
W08.2 Queda de outro tipo de mobília ­ escolas, outras instituições e áreas de administração pública
W08.3 Queda de outro tipo de mobília ­ área para a prática de esportes e atletismo
W08.4 Queda de outro tipo de mobília ­ rua e estrada
W08.5 Queda de outro tipo de mobília ­ áreas de comércio e de serviços
W08.6 Queda de outro tipo de mobília ­ áreas industriais e em construção
W08.7 Queda de outro tipo de mobília ­ fazenda
W08.8 Queda de outro tipo de mobília ­ outros locais especificados
W08.9 Queda de outro tipo de mobília ­ local não especificado
W09.0 Queda envolvendo equipamento de "playground" ­ residência
W09.1 Queda envolvendo equipamento de "playground" ­ habitação coletiva
W09.2 Queda envolvendo equipamento de "playground" ­ escolas, outras instituições e áreas de
administração pública
W09.3 Queda envolvendo equipamento de "playground" ­ área para a prática de esportes e atletismo
W09.4 Queda envolvendo equipamento de "playground" ­ rua e estrada
W09.5 Queda envolvendo equipamento de "playground" ­ áreas de comércio e de serviços
W09.6 Queda envolvendo equipamento de "playground" ­ áreas industriais e em construção
W09.7 Queda envolvendo equipamento de "playground" ­ fazenda
W09.8 Queda envolvendo equipamento de "playground" ­ outros locais especificados
W09.9 Queda envolvendo equipamento de "playground" ­ local não especificado
W10.0 Queda em ou de escadas ou degraus ­ residência
W10.1 Queda em ou de escadas ou degraus ­ habitação coletiva
W10.2 Queda em ou de escadas ou degraus ­ escolas, outras instituições e áreas de administração
pública
W10.3 Queda em ou de escadas ou degraus ­ área para a prática de esportes e atletismo
W10.4 Queda em ou de escadas ou degraus ­ rua e estrada
W10.5 Queda em ou de escadas ou degraus ­ áreas de comércio e de serviços
W10.6 Queda em ou de escadas ou degraus ­ áreas industriais e em construção
W10.7 Queda em ou de escadas ou degraus ­ fazenda
W10.8 Queda em ou de escadas ou degraus ­ outros locais especificados
W10.9 Queda em ou de escadas ou degraus ­ local não especificado
W11.0 Queda em ou de escadas de mão ­ residência
W11.1 Queda em ou de escadas de mão ­ habitação coletiva
W11.2 Queda em ou de escadas de mão ­ escolas, outras instituições e áreas de administração pública
W11.3 Queda em ou de escadas de mão ­ área para a prática de esportes e atletismo
W11.4 Queda em ou de escadas de mão ­ rua e estrada
W11.5 Queda em ou de escadas de mão ­ áreas de comércio e de serviços
W11.6 Queda em ou de escadas de mão ­ áreas industriais e em construção
W11.7 Queda em ou de escadas de mão ­ fazenda
W11.8 Queda em ou de escadas de mão ­ outros locais especificados
W11.9 Queda em ou de escadas de mão ­ local não especificado
W12.0 Queda em ou de um andaime ­ residência
W12.1 Queda em ou de um andaime ­ habitação coletiva
W12.2 Queda em ou de um andaime ­ escolas, outras instituições e áreas de administração pública
W12.3 Queda em ou de um andaime ­ área para a prática de esportes e atletismo
W12.4 Queda em ou de um andaime ­ rua e estrada
W12.5 Queda em ou de um andaime ­ áreas de comércio e de serviços
W12.6 Queda em ou de um andaime ­ áreas industriais e em construção
W12.7 Queda em ou de um andaime ­ fazenda
W12.8 Queda em ou de um andaime ­ outros locais especificados
W12.9 Queda em ou de um andaime ­ local não especificado
W13.0 Queda de ou para fora de edifícios ou outras estruturas ­ residência
W13.1 Queda de ou para fora de edifícios ou outras estruturas ­ habitação coletiva
W13.2 Queda de ou para fora de edifícios ou outras estruturas ­ escolas, outras instituições e áreas de
administração pública
W13.3 Queda de ou para fora de edifícios ou outras estruturas ­ área para a prática de esportes e
atletismo
W13.4 Queda de ou para fora de edifícios ou outras estruturas ­ rua e estrada
W13.5 Queda de ou para fora de edifícios ou outras estruturas ­ áreas de comércio e de serviços
W13.6 Queda de ou para fora de edifícios ou outras estruturas ­ áreas industriais e em construção
W13.7 Queda de ou para fora de edifícios ou outras estruturas ­ fazenda
W13.8 Queda de ou para fora de edifícios ou outras estruturas ­ outros locais especificados
W13.9 Queda de ou para fora de edifícios ou outras estruturas ­ local não especificado
W14.0 Queda de árvore ­ residência
W14.1 Queda de árvore ­ habitação coletiva
W14.2 Queda de árvore ­ escolas, outras instituições e áreas de administração pública
W14.3 Queda de árvore ­ área para a prática de esportes e atletismo
W14.4 Queda de árvore ­ rua e estrada
W14.5 Queda de árvore ­ áreas de comércio e de serviços
W14.6 Queda de árvore ­ áreas industriais e em construção
W14.7 Queda de árvore ­ fazenda
W14.8 Queda de árvore ­ outros locais especificados
W14.9 Queda de árvore ­ local não especificado
W15.0 Queda de penhasco ­ residência
W15.1 Queda de penhasco ­ habitação coletiva
W15.2 Queda de penhasco ­ escolas, outras instituições e áreas de administração pública
W15.3 Queda de penhasco ­ área para a prática de esportes e atletismo
W15.4 Queda de penhasco ­ rua e estrada
W15.5 Queda de penhasco ­ áreas de comércio e de serviços
W15.6 Queda de penhasco ­ áreas industriais e em construção
W15.7 Queda de penhasco ­ fazenda
W15.8 Queda de penhasco ­ outros locais especificados
W15.9 Queda de penhasco ­ local não especificado
W16.0 Mergulho ou pulo na água causando outro traumatismo que não afogamento ou submersão ­
residência
W16.1 Mergulho ou pulo na água causando outro traumatismo que não afogamento ou submersão ­
habitação coletiva
W16.2 Mergulho ou pulo na água causando outro traumatismo que não afogamento ou submersão ­
escolas, outras instituições e áreas de administração pública
W16.3 Mergulho ou pulo na água causando outro traumatismo que não afogamento ou submersão ­
área para a prática de esportes e atletismo
W16.4 Mergulho ou pulo na água causando outro traumatismo que não afogamento ou submersão ­
rua e estrada
W16.5 Mergulho ou pulo na água causando outro traumatismo que não afogamento ou submersão ­
áreas de comércio e de serviços
W16.6 Mergulho ou pulo na água causando outro traumatismo que não afogamento ou submersão ­
áreas industriais e em construção
W16.7 Mergulho ou pulo na água causando outro traumatismo que não afogamento ou submersão ­
fazenda
W16.8 Mergulho ou pulo na água causando outro traumatismo que não afogamento ou submersão ­
outros locais especificados
W16.9 Mergulho ou pulo na água causando outro traumatismo que não afogamento ou submersão ­
local não especificado
W17.0 Outras quedas de um nível a outro ­ residência
W17.1 Outras quedas de um nível a outro ­ habitação coletiva
W17.2 Outras quedas de um nível a outro ­ escolas, outras instituições e áreas de administração
pública
W17.3 Outras quedas de um nível a outro ­ área para a prática de esportes e atletismo
W17.4 Outras quedas de um nível a outro ­ rua e estrada
W17.5 Outras quedas de um nível a outro ­ áreas de comércio e de serviços
W17.6 Outras quedas de um nível a outro ­ áreas industriais e em construção
W17.7 Outras quedas de um nível a outro ­ fazenda
W17.8 Outras quedas de um nível a outro ­ outros locais especificados
W17.9 Outras quedas de um nível a outro ­ local não especificado
W18.0 Outras quedas no mesmo nível ­ residência
W18.1 Outras quedas no mesmo nível ­ habitação coletiva
W18.2 Outras quedas no mesmo nível ­ escolas, outras instituições e áreas de administração pública
W18.3 Outras quedas no mesmo nível ­ área para a prática de esportes e atletismo
W18.4 Outras quedas no mesmo nível ­ rua e estrada
W18.5 Outras quedas no mesmo nível ­ áreas de comércio e de serviços
W18.6 Outras quedas no mesmo nível ­ áreas industriais e em construção
W18.7 Outras quedas no mesmo nível ­ fazenda
W18.8 Outras quedas no mesmo nível ­ outros locais especificados
W18.9 Outras quedas no mesmo nível ­ local não especificado
W19.0 Queda sem especificação ­ residência
W19.1 Queda sem especificação ­ habitação coletiva
W19.2 Queda sem especificação ­ escolas, outras instituições e áreas de administração pública
W19.3 Queda sem especificação ­ área para a prática de esportes e atletismo
W19.4 Queda sem especificação ­ rua e estrada
W19.5 Queda sem especificação ­ áreas de comércio e de serviços
W19.6 Queda sem especificação ­ áreas industriais e em construção
W19.7 Queda sem especificação ­ fazenda
W19.8 Queda sem especificação ­ outros locais especificados
W19.9 Queda sem especificação ­ local não especificado
W20.0 Impacto causado por objeto lançado, projetado ou em queda ­ residência
W20.1 Impacto causado por objeto lançado, projetado ou em queda ­ habitação coletiva
W20.2 Impacto causado por objeto lançado, projetado ou em queda ­ escolas, outras instituições e
áreas de administração pública
W20.3 Impacto causado por objeto lançado, projetado ou em queda ­ área para a prática de esportes e
atletismo
W20.4 Impacto causado por objeto lançado, projetado ou em queda ­ rua e estrada
W20.5 Impacto causado por objeto lançado, projetado ou em queda ­ áreas de comércio e de serviços
W20.6 Impacto causado por objeto lançado, projetado ou em queda ­ áreas industriais e em
construção
W20.7 Impacto causado por objeto lançado, projetado ou em queda ­ fazenda
W20.8 Impacto causado por objeto lançado, projetado ou em queda ­ outros locais especificados
W20.9 Impacto causado por objeto lançado, projetado ou em queda ­ local não especificado
W21.0 Impacto acidental ativo ou passivo causado por equipamento esportivo ­ residência
W21.1 Impacto acidental ativo ou passivo causado por equipamento esportivo ­ habitação coletiva
W21.2 Impacto acidental ativo ou passivo causado por equipamento esportivo ­ escolas, outras
instituições e áreas de administração pública
W21.3 Impacto acidental ativo ou passivo causado por equipamento esportivo ­ área para a prática de
esportes e atletismo
W21.4 Impacto acidental ativo ou passivo causado por equipamento esportivo ­ rua e estrada
W21.5 Impacto acidental ativo ou passivo causado por equipamento esportivo ­ áreas de comércio e de
serviços
W21.6 Impacto acidental ativo ou passivo causado por equipamento esportivo ­ áreas industriais e em
construção
W21.7 Impacto acidental ativo ou passivo causado por equipamento esportivo ­ fazenda
W21.8 Impacto acidental ativo ou passivo causado por equipamento esportivo ­ outros locais
especificados
W21.9 Impacto acidental ativo ou passivo causado por equipamento esportivo ­ local não especificado
W22.0 Impacto acidental ativo ou passivo causado por outros objetos ­ residência
W22.1 Impacto acidental ativo ou passivo causado por outros objetos ­ habitação coletiva
W22.2 Impacto acidental ativo ou passivo causado por outros objetos ­ escolas, outras instituições e
áreas de administração pública
W22.3 Impacto acidental ativo ou passivo causado por outros objetos ­ área para a prática de esportes
e atletismo
W22.4 Impacto acidental ativo ou passivo causado por outros objetos ­ rua e estrada
W22.5 Impacto acidental ativo ou passivo causado por outros objetos ­ áreas de comércio e de
serviços
W22.6 Impacto acidental ativo ou passivo causado por outros objetos ­ áreas industriais e em
construção
W22.7 Impacto acidental ativo ou passivo causado por outros objetos ­ fazenda
W22.8 Impacto acidental ativo ou passivo causado por outros objetos ­ outros locais especificados
W22.9 Impacto acidental ativo ou passivo causado por outros objetos ­ local não especificado
W23.0 Apertado, colhido, comprimido ou esmagado dentro de ou entre objetos ­ residência
W23.1 Apertado, colhido, comprimido ou esmagado dentro de ou entre objetos ­ habitação coletiva
W23.2 Apertado, colhido, comprimido ou esmagado dentro de ou entre objetos ­ escolas, outras
instituições e áreas de administração pública
W23.3 Apertado, colhido, comprimido ou esmagado dentro de ou entre objetos ­ área para a prática de
esportes e atletismo
W23.4 Apertado, colhido, comprimido ou esmagado dentro de ou entre objetos ­ rua e estrada
W23.5 Apertado, colhido, comprimido ou esmagado dentro de ou entre objetos ­ áreas de comércio e
de serviços
W23.6 Apertado, colhido, comprimido ou esmagado dentro de ou entre objetos ­ áreas industriais e em
construção
W23.7 Apertado, colhido, comprimido ou esmagado dentro de ou entre objetos ­ fazenda
W23.8 Apertado, colhido, comprimido ou esmagado dentro de ou entre objetos ­ outros locais
especificados
W23.9 Apertado, colhido, comprimido ou esmagado dentro de ou entre objetos ­ local não especificado
W24.0 Contato com elevadores e instrumentos de transmissão, não classificados em outra parte ­
residência
W24.1 Contato com elevadores e instrumentos de transmissão, não classificados em outra parte ­
habitação coletiva
W24.2 Contato com elevadores e instrumentos de transmissão, não classificados em outra parte ­
escolas, outras instituições e áreas de administração pública
W24.3 Contato com elevadores e instrumentos de transmissão, não classificados em outra parte ­ área
para a prática de esportes e atletismo
W24.4 Contato com elevadores e instrumentos de transmissão, não classificados em outra parte ­ rua
e estrada
W24.5 Contato com elevadores e instrumentos de transmissão, não classificados em outra parte ­
áreas de comércio e de serviços
W24.6 Contato com elevadores e instrumentos de transmissão, não classificados em outra parte ­
áreas industriais e em construção
W24.7 Contato com elevadores e instrumentos de transmissão, não classificados em outra parte ­
fazenda
W24.8 Contato com elevadores e instrumentos de transmissão, não classificados em outra parte ­
outros locais especificados
W24.9 Contato com elevadores e instrumentos de transmissão, não classificados em outra parte ­ local
não especificado
W25.0 Contato com vidro cortante ­ residência
W25.1 Contato com vidro cortante ­ habitação coletiva
W25.2 Contato com vidro cortante ­ escolas, outras instituições e áreas de administração pública
W25.3 Contato com vidro cortante ­ área para a prática de esportes e atletismo
W25.4 Contato com vidro cortante ­ rua e estrada
W25.5 Contato com vidro cortante ­ áreas de comércio e de serviços
W25.6 Contato com vidro cortante ­ áreas industriais e em construção
W25.7 Contato com vidro cortante ­ fazenda
W25.8 Contato com vidro cortante ­ outros locais especificados
W25.9 Contato com vidro cortante ­ local não especificado
W26.0 Contato com faca, espada e punhal ­ residência
W26.1 Contato com faca, espada e punhal ­ habitação coletiva
W26.2 Contato com faca, espada e punhal ­ escolas, outras instituições e áreas de administração
pública
W26.3 Contato com faca, espada e punhal ­ área para a prática de esportes e atletismo
W26.4 Contato com faca, espada e punhal ­ rua e estrada
W26.5 Contato com faca, espada e punhal ­ áreas de comércio e de serviços
W26.6 Contato com faca, espada e punhal ­ áreas industriais e em construção
W26.7 Contato com faca, espada e punhal ­ fazenda
W26.8 Contato com faca, espada e punhal ­ outros locais especificados
W26.9 Contato com faca, espada e punhal ­ local não especificado
W27.0 Contato com ferramentas manuais sem motor ­ residência
W27.1 Contato com ferramentas manuais sem motor ­ habitação coletiva
W27.2 Contato com ferramentas manuais sem motor ­ escolas, outras instituições e áreas de
administração pública
W27.3 Contato com ferramentas manuais sem motor ­ área para a prática de esportes e atletismo
W27.4 Contato com ferramentas manuais sem motor ­ rua e estrada
W27.5 Contato com ferramentas manuais sem motor ­ áreas de comércio e de serviços
W27.6 Contato com ferramentas manuais sem motor ­ áreas industriais e em construção
W27.7 Contato com ferramentas manuais sem motor ­ fazenda
W27.8 Contato com ferramentas manuais sem motor ­ outros locais especificados
W27.9 Contato com ferramentas manuais sem motor ­ local não especificado
W28.0 Contato com segadeira motorizada para cortar ou aparar a grama ­ residência
W28.1 Contato com segadeira motorizada para cortar ou aparar a grama ­ habitação coletiva
W28.2 Contato com segadeira motorizada para cortar ou aparar a grama ­ escolas, outras instituições
e áreas de administração pública
W28.3 Contato com segadeira motorizada para cortar ou aparar a grama ­ área para a prática de
esportes e atletismo
W28.4 Contato com segadeira motorizada para cortar ou aparar a grama ­ rua e estrada
W28.5 Contato com segadeira motorizada para cortar ou aparar a grama ­ áreas de comércio e de
serviços
W28.6 Contato com segadeira motorizada para cortar ou aparar a grama ­ áreas industriais e em
construção
W28.7 Contato com segadeira motorizada para cortar ou aparar a grama ­ fazenda
W28.8 Contato com segadeira motorizada para cortar ou aparar a grama ­ outros locais especificados
W28.9 Contato com segadeira motorizada para cortar ou aparar a grama ­ local não especificado
W29.0 Contato com outros utensílios manuais e aparelhos domésticos equipados com motor ­
residência
W29.1 Contato com outros utensílios manuais e aparelhos domésticos equipados com motor ­
habitação coletiva
W29.2 Contato com outros utensílios manuais e aparelhos domésticos equipados com motor ­ escolas,
outras instituições e áreas de administração pública
W29.3 Contato com outros utensílios manuais e aparelhos domésticos equipados com motor ­ área
para a prática de esportes e atletismo
W29.4 Contato com outros utensílios manuais e aparelhos domésticos equipados com motor ­ rua e
estrada
W29.5 Contato com outros utensílios manuais e aparelhos domésticos equipados com motor ­ áreas
de comércio e de serviços
W29.6 Contato com outros utensílios manuais e aparelhos domésticos equipados com motor ­ áreas
industriais e em construção
W29.7 Contato com outros utensílios manuais e aparelhos domésticos equipados com motor ­ fazenda
W29.8 Contato com outros utensílios manuais e aparelhos domésticos equipados com motor ­ outros
locais especificados
W29.9 Contato com outros utensílios manuais e aparelhos domésticos equipados com motor ­ local
não especificado
W30.0 Contato com maquinaria agrícola ­ residência
W30.1 Contato com maquinaria agrícola ­ habitação coletiva
W30.2 Contato com maquinaria agrícola ­ escolas, outras instituições e áreas de administração pública
W30.3 Contato com maquinaria agrícola ­ área para a prática de esportes e atletismo
W30.4 Contato com maquinaria agrícola ­ rua e estrada
W30.5 Contato com maquinaria agrícola ­ áreas de comércio e de serviços
W30.6 Contato com maquinaria agrícola ­ áreas industriais e em construção
W30.7 Contato com maquinaria agrícola ­ fazenda
W30.8 Contato com maquinaria agrícola ­ outros locais especificados
W30.9 Contato com maquinaria agrícola ­ local não especificado
W31.0 Contato com outras máquinas e com as não especificadas ­ residência
W31.1 Contato com outras máquinas e com as não especificadas ­ habitação coletiva
W31.2 Contato com outras máquinas e com as não especificadas ­ escolas, outras instituições e áreas
de administração pública
W31.3 Contato com outras máquinas e com as não especificadas ­ área para a prática de esportes e
atletismo
W31.4 Contato com outras máquinas e com as não especificadas ­ rua e estrada
W31.5 Contato com outras máquinas e com as não especificadas ­ áreas de comércio e de serviços
W31.6 Contato com outras máquinas e com as não especificadas ­ áreas industriais e em construção
W31.7 Contato com outras máquinas e com as não especificadas ­ fazenda
W31.8 Contato com outras máquinas e com as não especificadas ­ outros locais especificados
W31.9 Contato com outras máquinas e com as não especificadas ­ local não especificado
W32.0 Projétil de revólver ­ residência
W32.1 Projétil de revólver ­ habitação coletiva
W32.2 Projétil de revólver ­ escolas, outras instituições e áreas de administração pública
W32.3 Projétil de revólver ­ área para a prática de esportes e atletismo
W32.4 Projétil de revólver ­ rua e estrada
W32.5 Projétil de revólver ­ áreas de comércio e de serviços
W32.6 Projétil de revólver ­ áreas industriais e em construção
W32.7 Projétil de revólver ­ fazenda
W32.8 Projétil de revólver ­ outros locais especificados
W32.9 Projétil de revólver ­ local não especificado
W33.0 Rifle, espingarda e armas de fogo de maior tamanho ­ residência
W33.1 Rifle, espingarda e armas de fogo de maior tamanho ­ habitação coletiva
W33.2 Rifle, espingarda e armas de fogo de maior tamanho ­ escolas, outras instituições e áreas de
administração pública
W33.3 Rifle, espingarda e armas de fogo de maior tamanho ­ área para a prática de esportes e
atletismo
W33.4 Rifle, espingarda e armas de fogo de maior tamanho ­ rua e estrada
W33.5 Rifle, espingarda e armas de fogo de maior tamanho ­ áreas de comércio e de serviços
W33.6 Rifle, espingarda e armas de fogo de maior tamanho ­ áreas industriais e em construção
W33.7 Rifle, espingarda e armas de fogo de maior tamanho ­ fazenda
W33.8 Rifle, espingarda e armas de fogo de maior tamanho ­ outros locais especificados
W33.9 Rifle, espingarda e armas de fogo de maior tamanho ­ local não especificado
W34.0 Projéteis de outras armas de fogo e das não especificadas ­ residência
W34.1 Projéteis de outras armas de fogo e das não especificadas ­ habitação coletiva
W34.2 Projéteis de outras armas de fogo e das não especificadas ­ escolas, outras instituições e áreas
de administração pública
W34.3 Projéteis de outras armas de fogo e das não especificadas ­ área para a prática de esportes e
atletismo
W34.4 Projéteis de outras armas de fogo e das não especificadas ­ rua e estrada
W34.5 Projéteis de outras armas de fogo e das não especificadas ­ áreas de comércio e de serviços
W34.6 Projéteis de outras armas de fogo e das não especificadas ­ áreas industriais e em construção
W34.7 Projéteis de outras armas de fogo e das não especificadas ­ fazenda
W34.8 Projéteis de outras armas de fogo e das não especificadas ­ outros locais especificados
W34.9 Projéteis de outras armas de fogo e das não especificadas ­ local não especificado
W35.0 Explosão ou ruptura de caldeira ­ residência
W35.1 Explosão ou ruptura de caldeira ­ habitação coletiva
W35.2 Explosão ou ruptura de caldeira ­ escolas, outras instituições e áreas de administração pública
W35.3 Explosão ou ruptura de caldeira ­ área para a prática de esportes e atletismo
W35.4 Explosão ou ruptura de caldeira ­ rua e estrada
W35.5 Explosão ou ruptura de caldeira ­ áreas de comércio e de serviços
W35.6 Explosão ou ruptura de caldeira ­ áreas industriais e em construção
W35.7 Explosão ou ruptura de caldeira ­ fazenda
W35.8 Explosão ou ruptura de caldeira ­ outros locais especificados
W35.9 Explosão ou ruptura de caldeira ­ local não especificado
W36.0 Explosão ou ruptura de cilindro de gás ­ residência
W36.1 Explosão ou ruptura de cilindro de gás ­ habitação coletiva
W36.2 Explosão ou ruptura de cilindro de gás ­ escolas, outras instituições e áreas de administração
pública
W36.3 Explosão ou ruptura de cilindro de gás ­ área para a prática de esportes e atletismo
W36.4 Explosão ou ruptura de cilindro de gás ­ rua e estrada
W36.5 Explosão ou ruptura de cilindro de gás ­ áreas de comércio e de serviços
W36.6 Explosão ou ruptura de cilindro de gás ­ áreas industriais e em construção
W36.7 Explosão ou ruptura de cilindro de gás ­ fazenda
W36.8 Explosão ou ruptura de cilindro de gás ­ outros locais especificados
W36.9 Explosão ou ruptura de cilindro de gás ­ local não especificado
W37.0 Explosão ou ruptura de pneumático, tubulação ou mangueira, pressurizados ­ residência
W37.1 Explosão ou ruptura de pneumático, tubulação ou mangueira, pressurizados ­ habitação coletiva
W37.2 Explosão ou ruptura de pneumático, tubulação ou mangueira, pressurizados ­ escolas, outras
instituições e áreas de administração pública
W37.3 Explosão ou ruptura de pneumático, tubulação ou mangueira, pressurizados ­ área para a
prática de esportes e atletismo
W37.4 Explosão ou ruptura de pneumático, tubulação ou mangueira, pressurizados ­ rua e estrada
W37.5 Explosão ou ruptura de pneumático, tubulação ou mangueira, pressurizados ­ áreas de
comércio e de serviços
W37.6 Explosão ou ruptura de pneumático, tubulação ou mangueira, pressurizados ­ áreas industriais e
em construção
W37.7 Explosão ou ruptura de pneumático, tubulação ou mangueira, pressurizados ­ fazenda
W37.8 Explosão ou ruptura de pneumático, tubulação ou mangueira, pressurizados ­ outros locais
especificados
W37.9 Explosão ou ruptura de pneumático, tubulação ou mangueira, pressurizados ­ local não
especificado
W38.0 Explosão ou ruptura de outros aparelhos pressurizados especificados ­ residência
W38.1 Explosão ou ruptura de outros aparelhos pressurizados especificados ­ habitação coletiva
W38.2 Explosão ou ruptura de outros aparelhos pressurizados especificados ­ escolas, outras
instituições e áreas de administração pública
W38.3 Explosão ou ruptura de outros aparelhos pressurizados especificados ­ área para a prática de
esportes e atletismo
W38.4 Explosão ou ruptura de outros aparelhos pressurizados especificados ­ rua e estrada
W38.5 Explosão ou ruptura de outros aparelhos pressurizados especificados ­ áreas de comércio e de
serviços
W38.6 Explosão ou ruptura de outros aparelhos pressurizados especificados ­ áreas industriais e em
construção
W38.7 Explosão ou ruptura de outros aparelhos pressurizados especificados ­ fazenda
W38.8 Explosão ou ruptura de outros aparelhos pressurizados especificados ­ outros locais
especificados
W38.9 Explosão ou ruptura de outros aparelhos pressurizados especificados ­ local não especificado
W39.0 Queima de fogos de artifício ­ residência
W39.1 Queima de fogos de artifício ­ habitação coletiva
W39.2 Queima de fogos de artifício ­ escolas, outras instituições e áreas de administração pública
W39.3 Queima de fogos de artifício ­ área para a prática de esportes e atletismo
W39.4 Queima de fogos de artifício ­ rua e estrada
W39.5 Queima de fogos de artifício ­ áreas de comércio e de serviços
W39.6 Queima de fogos de artifício ­ áreas industriais e em construção
W39.7 Queima de fogos de artifício ­ fazenda
W39.8 Queima de fogos de artifício ­ outros locais especificados
W39.9 Queima de fogos de artifício ­ local não especificado
W40.0 Explosão de outros materiais ­ residência
W40.1 Explosão de outros materiais ­ habitação coletiva
W40.2 Explosão de outros materiais ­ escolas, outras instituições e áreas de administração pública
W40.3 Explosão de outros materiais ­ área para a prática de esportes e atletismo
W40.4 Explosão de outros materiais ­ rua e estrada
W40.5 Explosão de outros materiais ­ áreas de comércio e de serviços
W40.6 Explosão de outros materiais ­ áreas industriais e em construção
W40.7 Explosão de outros materiais ­ fazenda
W40.8 Explosão de outros materiais ­ outros locais especificados
W40.9 Explosão de outros materiais ­ local não especificado
W41.0 Exposição a um jato de alta pressão ­ residência
W41.1 Exposição a um jato de alta pressão ­ habitação coletiva
W41.2 Exposição a um jato de alta pressão ­ escolas, outras instituições e áreas de administração
pública
W41.3 Exposição a um jato de alta pressão ­ área para a prática de esportes e atletismo
W41.4 Exposição a um jato de alta pressão ­ rua e estrada
W41.5 Exposição a um jato de alta pressão ­ áreas de comércio e de serviços
W41.6 Exposição a um jato de alta pressão ­ áreas industriais e em construção
W41.7 Exposição a um jato de alta pressão ­ fazenda
W41.8 Exposição a um jato de alta pressão ­ outros locais especificados
W41.9 Exposição a um jato de alta pressão ­ local não especificado
W42.0 Exposição ao ruído ­ residência
W42.1 Exposição ao ruído ­ habitação coletiva
W42.2 Exposição ao ruído ­ escolas, outras instituições e áreas de administração pública
W42.3 Exposição ao ruído ­ área para a prática de esportes e atletismo
W42.4 Exposição ao ruído ­ rua e estrada
W42.5 Exposição ao ruído ­ áreas de comércio e de serviços
W42.6 Exposição ao ruído ­ áreas industriais e em construção
W42.7 Exposição ao ruído ­ fazenda
W42.8 Exposição ao ruído ­ outros locais especificados
W42.9 Exposição ao ruído ­ local não especificado
W43.0 Exposição à vibração ­ residência
W43.1 Exposição à vibração ­ habitação coletiva
W43.2 Exposição à vibração ­ escolas, outras instituições e áreas de administração pública
W43.3 Exposição à vibração ­ área para a prática de esportes e atletismo
W43.4 Exposição à vibração ­ rua e estrada
W43.5 Exposição à vibração ­ áreas de comércio e de serviços
W43.6 Exposição à vibração ­ áreas industriais e em construção
W43.7 Exposição à vibração ­ fazenda
W43.8 Exposição à vibração ­ outros locais especificados
W43.9 Exposição à vibração ­ local não especificado
W44.0 Penetração de corpo estranho no ou através de olho ou orifício natural ­ residência
W44.1 Penetração de corpo estranho no ou através de olho ou orifício natural ­ habitação coletiva
W44.2 Penetração de corpo estranho no ou através de olho ou orifício natural ­ escolas, outras
instituições e áreas de administração pública
W44.3 Penetração de corpo estranho no ou através de olho ou orifício natural ­ área para a prática de
esportes e atletismo
W44.4 Penetração de corpo estranho no ou através de olho ou orifício natural ­ rua e estrada
W44.5 Penetração de corpo estranho no ou através de olho ou orifício natural ­ áreas de comércio e de
serviços
W44.6 Penetração de corpo estranho no ou através de olho ou orifício natural ­ áreas industriais e em
construção
W44.7 Penetração de corpo estranho no ou através de olho ou orifício natural ­ fazenda
W44.8 Penetração de corpo estranho no ou através de olho ou orifício natural ­ outros locais
especificados
W44.9 Penetração de corpo estranho no ou através de olho ou orifício natural ­ local não especificado
W45.0 Penetração de corpo ou objeto estranho através da pele ­ residência
W45.1 Penetração de corpo ou objeto estranho através da pele ­ habitação coletiva
W45.2 Penetração de corpo ou objeto estranho através da pele ­ escolas, outras instituições e áreas de
administração pública
W45.3 Penetração de corpo ou objeto estranho através da pele ­ área para a prática de esportes e
atletismo
W45.4 Penetração de corpo ou objeto estranho através da pele ­ rua e estrada
W45.5 Penetração de corpo ou objeto estranho através da pele ­ áreas de comércio e de serviços
W45.6 Penetração de corpo ou objeto estranho através da pele ­ áreas industriais e em construção
W45.7 Penetração de corpo ou objeto estranho através da pele ­ fazenda
W45.8 Penetração de corpo ou objeto estranho através da pele ­ outros locais especificados
W45.9 Penetração de corpo ou objeto estranho através da pele ­ local não especificado
W49.0 Exposição a outras forças mecânicas inanimadas e às não especificadas ­ residência
W49.1 Exposição a outras forças mecânicas inanimadas e às não especificadas ­ habitação coletiva
W49.2 Exposição a outras forças mecânicas inanimadas e às não especificadas ­ escolas, outras
instituições e áreas de administração pública
W49.3 Exposição a outras forças mecânicas inanimadas e às não especificadas ­ área para a prática
de esportes e atletismo
W49.4 Exposição a outras forças mecânicas inanimadas e às não especificadas ­ rua e estrada
W49.5 Exposição a outras forças mecânicas inanimadas e às não especificadas ­ áreas de comércio e
de serviços
W49.6 Exposição a outras forças mecânicas inanimadas e às não especificadas ­ áreas industriais e
em construção
W49.7 Exposição a outras forças mecânicas inanimadas e às não especificadas ­ fazenda
W49.8 Exposição a outras forças mecânicas inanimadas e às não especificadas ­ outros locais
especificados
W49.9 Exposição a outras forças mecânicas inanimadas e às não especificadas ­ local não
especificado
W50.0 Golpe, pancada, pontapé, mordedura ou escoriação infligidos por outra pessoa ­ residência
W50.1 Golpe, pancada, pontapé, mordedura ou escoriação infligidos por outra pessoa ­ habitação
coletiva
W50.2 Golpe, pancada, pontapé, mordedura ou escoriação infligidos por outra pessoa ­ escolas, outras
instituições e áreas de administração pública
W50.3 Golpe, pancada, pontapé, mordedura ou escoriação infligidos por outra pessoa ­ área para a
prática de esportes e atletismo
W50.4 Golpe, pancada, pontapé, mordedura ou escoriação infligidos por outra pessoa ­ rua e estrada
W50.5 Golpe, pancada, pontapé, mordedura ou escoriação infligidos por outra pessoa ­ áreas de
comércio e de serviços
W50.6 Golpe, pancada, pontapé, mordedura ou escoriação infligidos por outra pessoa ­ áreas
industriais e em construção
W50.7 Golpe, pancada, pontapé, mordedura ou escoriação infligidos por outra pessoa ­ fazenda
W50.8 Golpe, pancada, pontapé, mordedura ou escoriação infligidos por outra pessoa ­ outros locais
especificados
W50.9 Golpe, pancada, pontapé, mordedura ou escoriação infligidos por outra pessoa ­ local não
especificado
W51.0 Colisão entre duas pessoas ­ residência
W51.1 Colisão entre duas pessoas ­ habitação coletiva
W51.2 Colisão entre duas pessoas ­ escolas, outras instituições e áreas de administração pública
W51.3 Colisão entre duas pessoas ­ área para a prática de esportes e atletismo
W51.4 Colisão entre duas pessoas ­ rua e estrada
W51.5 Colisão entre duas pessoas ­ áreas de comércio e de serviços
W51.6 Colisão entre duas pessoas ­ áreas industriais e em construção
W51.7 Colisão entre duas pessoas ­ fazenda
W51.8 Colisão entre duas pessoas ­ outros locais especificados
W51.9 Colisão entre duas pessoas ­ local não especificado
W52.0 Esmagado, empurrado ou pisoteado por multidão ou debandada em massa de pessoas ­
residência
W52.1 Esmagado, empurrado ou pisoteado por multidão ou debandada em massa de pessoas ­
habitação coletiva
W52.2 Esmagado, empurrado ou pisoteado por multidão ou debandada em massa de pessoas ­
escolas, outras instituições e áreas de administração pública
W52.3 Esmagado, empurrado ou pisoteado por multidão ou debandada em massa de pessoas ­ área
para a prática de esportes e atletismo
W52.4 Esmagado, empurrado ou pisoteado por multidão ou debandada em massa de pessoas ­ rua e
estrada
W52.5 Esmagado, empurrado ou pisoteado por multidão ou debandada em massa de pessoas ­ áreas
de comércio e de serviços
W52.6 Esmagado, empurrado ou pisoteado por multidão ou debandada em massa de pessoas ­ áreas
industriais e em construção
W52.7 Esmagado, empurrado ou pisoteado por multidão ou debandada em massa de pessoas ­
fazenda
W52.8 Esmagado, empurrado ou pisoteado por multidão ou debandada em massa de pessoas ­ outros
locais especificados
W52.9 Esmagado, empurrado ou pisoteado por multidão ou debandada em massa de pessoas ­ local
não especificado
W53.0 Mordedura de rato ­ residência
W53.1 Mordedura de rato ­ habitação coletiva
W53.2 Mordedura de rato ­ escolas, outras instituições e áreas de administração pública
W53.3 Mordedura de rato ­ área para a prática de esportes e atletismo
W53.4 Mordedura de rato ­ rua e estrada
W53.5 Mordedura de rato ­ áreas de comércio e de serviços
W53.6 Mordedura de rato ­ áreas industriais e em construção
W53.7 Mordedura de rato ­ fazenda
W53.8 Mordedura de rato ­ outros locais especificados
W53.9 Mordedura de rato ­ local não especificado
W54.0 Mordedura ou golpe provocado por cão ­ residência
W54.1 Mordedura ou golpe provocado por cão ­ habitação coletiva
W54.2 Mordedura ou golpe provocado por cão ­ escolas, outras instituições e áreas de administração
pública
W54.3 Mordedura ou golpe provocado por cão ­ área para a prática de esportes e atletismo
W54.4 Mordedura ou golpe provocado por cão ­ rua e estrada
W54.5 Mordedura ou golpe provocado por cão ­ áreas de comércio e de serviços
W54.6 Mordedura ou golpe provocado por cão ­ áreas industriais e em construção
W54.7 Mordedura ou golpe provocado por cão ­ fazenda
W54.8 Mordedura ou golpe provocado por cão ­ outros locais especificados
W54.9 Mordedura ou golpe provocado por cão ­ local não especificado
W55.0 Mordedura ou golpe provocado por outros animais mamíferos ­ residência
W55.1 Mordedura ou golpe provocado por outros animais mamíferos ­ habitação coletiva
W55.2 Mordedura ou golpe provocado por outros animais mamíferos ­ escolas, outras instituições e
áreas de administração pública
W55.3 Mordedura ou golpe provocado por outros animais mamíferos ­ área para a prática de esportes
e atletismo
W55.4 Mordedura ou golpe provocado por outros animais mamíferos ­ rua e estrada
W55.5 Mordedura ou golpe provocado por outros animais mamíferos ­ áreas de comércio e de serviços
W55.6 Mordedura ou golpe provocado por outros animais mamíferos ­ áreas industriais e em
construção
W55.7 Mordedura ou golpe provocado por outros animais mamíferos ­ fazenda
W55.8 Mordedura ou golpe provocado por outros animais mamíferos ­ outros locais especificados
W55.9 Mordedura ou golpe provocado por outros animais mamíferos ­ local não especificado
W56.0 Contato com animais marinhos ­ residência
W56.1 Contato com animais marinhos ­ habitação coletiva
W56.2 Contato com animais marinhos ­ escolas, outras instituições e áreas de administração pública
W56.3 Contato com animais marinhos ­ área para a prática de esportes e atletismo
W56.4 Contato com animais marinhos ­ rua e estrada
W56.5 Contato com animais marinhos ­ áreas de comércio e de serviços
W56.6 Contato com animais marinhos ­ áreas industriais e em construção
W56.7 Contato com animais marinhos ­ fazenda
W56.8 Contato com animais marinhos ­ outros locais especificados
W56.9 Contato com animais marinhos ­ local não especificado
W57.0 Mordeduras e picadas de inseto e de outros artrópodes, não­venenosos ­ residência
W57.1 Mordeduras e picadas de inseto e de outros artrópodes, não­venenosos ­ habitação coletiva
W57.2 Mordeduras e picadas de inseto e de outros artrópodes, não­venenosos ­ escolas, outras
instituições e áreas de administração pública
W57.3 Mordeduras e picadas de inseto e de outros artrópodes, não­venenosos ­ área para a prática de
esportes e atletismo
W57.4 Mordeduras e picadas de inseto e de outros artrópodes, não­venenosos ­ rua e estrada
W57.5 Mordeduras e picadas de inseto e de outros artrópodes, não­venenosos ­ áreas de comércio e
de serviços
W57.6 Mordeduras e picadas de inseto e de outros artrópodes, não­venenosos ­ áreas industriais e em
construção
W57.7 Mordeduras e picadas de inseto e de outros artrópodes, não­venenosos ­ fazenda
W57.8 Mordeduras e picadas de inseto e de outros artrópodes, não­venenosos ­ outros locais
especificados
W57.9 Mordeduras e picadas de inseto e de outros artrópodes, não­venenosos ­ local não especificado
W58.0 Mordedura ou golpe provocado por crocodilo ou aligator ­ residência
W58.1 Mordedura ou golpe provocado por crocodilo ou aligator ­ habitação coletiva
W58.2 Mordedura ou golpe provocado por crocodilo ou aligator ­ escolas, outras instituições e áreas de
administração pública
W58.3 Mordedura ou golpe provocado por crocodilo ou aligator ­ área para a prática de esportes e
atletismo
W58.4 Mordedura ou golpe provocado por crocodilo ou aligator ­ rua e estrada
W58.5 Mordedura ou golpe provocado por crocodilo ou aligator ­ áreas de comércio e de serviços
W58.6 Mordedura ou golpe provocado por crocodilo ou aligator ­ áreas industriais e em construção
W58.7 Mordedura ou golpe provocado por crocodilo ou aligator ­ fazenda
W58.8 Mordedura ou golpe provocado por crocodilo ou aligator ­ outros locais especificados
W58.9 Mordedura ou golpe provocado por crocodilo ou aligator ­ local não especificado
W59.0 Mordedura ou esmagamento provocado por outros répteis ­ residência
W59.1 Mordedura ou esmagamento provocado por outros répteis ­ habitação coletiva
W59.2 Mordedura ou esmagamento provocado por outros répteis ­ escolas, outras instituições e áreas
de administração pública
W59.3 Mordedura ou esmagamento provocado por outros répteis ­ área para a prática de esportes e
atletismo
W59.4 Mordedura ou esmagamento provocado por outros répteis ­ rua e estrada
W59.5 Mordedura ou esmagamento provocado por outros répteis ­ áreas de comércio e de serviços
W59.6 Mordedura ou esmagamento provocado por outros répteis ­ áreas industriais e em construção
W59.7 Mordedura ou esmagamento provocado por outros répteis ­ fazenda
W59.8 Mordedura ou esmagamento provocado por outros répteis ­ outros locais especificados
W59.9 Mordedura ou esmagamento provocado por outros répteis ­ local não especificado
W60.0 Contato com espinhos de plantas ou com folhas aguçadas ­ residência
W60.1 Contato com espinhos de plantas ou com folhas aguçadas ­ habitação coletiva
W60.2 Contato com espinhos de plantas ou com folhas aguçadas ­ escolas, outras instituições e áreas
de administração pública
W60.3 Contato com espinhos de plantas ou com folhas aguçadas ­ área para a prática de esportes e
atletismo
W60.4 Contato com espinhos de plantas ou com folhas aguçadas ­ rua e estrada
W60.5 Contato com espinhos de plantas ou com folhas aguçadas ­ áreas de comércio e de serviços
W60.6 Contato com espinhos de plantas ou com folhas aguçadas ­ áreas industriais e em construção
W60.7 Contato com espinhos de plantas ou com folhas aguçadas ­ fazenda
W60.8 Contato com espinhos de plantas ou com folhas aguçadas ­ outros locais especificados
W60.9 Contato com espinhos de plantas ou com folhas aguçadas ­ local não especificado
W64.0 Exposição a outras forças mecânicas animadas e às não especificadas ­ residência
W64.1 Exposição a outras forças mecânicas animadas e às não especificadas ­ habitação coletiva
W64.2 Exposição a outras forças mecânicas animadas e às não especificadas ­ escolas, outras
instituições e áreas de administração pública
W64.3 Exposição a outras forças mecânicas animadas e às não especificadas ­ área para a prática de
esportes e atletismo
W64.4 Exposição a outras forças mecânicas animadas e às não especificadas ­ rua e estrada
W64.5 Exposição a outras forças mecânicas animadas e às não especificadas ­ áreas de comércio e
de serviços
W64.6 Exposição a outras forças mecânicas animadas e às não especificadas ­ áreas industriais e em
construção
W64.7 Exposição a outras forças mecânicas animadas e às não especificadas ­ fazenda
W64.8 Exposição a outras forças mecânicas animadas e às não especificadas ­ outros locais
especificados
W64.9 Exposição a outras forças mecânicas animadas e às não especificadas ­ local não especificado
W65.0 Afogamento e submersão durante banho em banheira ­ residência
W65.1 Afogamento e submersão durante banho em banheira ­ habitação coletiva
W65.2 Afogamento e submersão durante banho em banheira ­ escolas, outras instituições e áreas de
administração pública
W65.3 Afogamento e submersão durante banho em banheira ­ área para a prática de esportes e
atletismo
W65.4 Afogamento e submersão durante banho em banheira ­ rua e estrada
W65.5 Afogamento e submersão durante banho em banheira ­ áreas de comércio e de serviços
W65.6 Afogamento e submersão durante banho em banheira ­ áreas industriais e em construção
W65.7 Afogamento e submersão durante banho em banheira ­ fazenda
W65.8 Afogamento e submersão durante banho em banheira ­ outros locais especificados
W65.9 Afogamento e submersão durante banho em banheira ­ local não especificado
W66.0 Afogamento e submersão consecutiva a queda dentro de uma banheira ­ residência
W66.1 Afogamento e submersão consecutiva a queda dentro de uma banheira ­ habitação coletiva
W66.2 Afogamento e submersão consecutiva a queda dentro de uma banheira ­ escolas, outras
instituições e áreas de administração pública
W66.3 Afogamento e submersão consecutiva a queda dentro de uma banheira ­ área para a prática de
esportes e atletismo
W66.4 Afogamento e submersão consecutiva a queda dentro de uma banheira ­ rua e estrada
W66.5 Afogamento e submersão consecutiva a queda dentro de uma banheira ­ áreas de comércio e
de serviços
W66.6 Afogamento e submersão consecutiva a queda dentro de uma banheira ­ áreas industriais e em
construção
W66.7 Afogamento e submersão consecutiva a queda dentro de uma banheira ­ fazenda
W66.8 Afogamento e submersão consecutiva a queda dentro de uma banheira ­ outros locais
especificados
W66.9 Afogamento e submersão consecutiva a queda dentro de uma banheira ­ local não especificado
W67.0 Afogamento e submersão em piscina ­ residência
W67.1 Afogamento e submersão em piscina ­ habitação coletiva
W67.2 Afogamento e submersão em piscina ­ escolas, outras instituições e áreas de administração
pública
W67.3 Afogamento e submersão em piscina ­ área para a prática de esportes e atletismo
W67.4 Afogamento e submersão em piscina ­ rua e estrada
W67.5 Afogamento e submersão em piscina ­ áreas de comércio e de serviços
W67.6 Afogamento e submersão em piscina ­ áreas industriais e em construção
W67.7 Afogamento e submersão em piscina ­ fazenda
W67.8 Afogamento e submersão em piscina ­ outros locais especificados
W67.9 Afogamento e submersão em piscina ­ local não especificado
W68.0 Afogamento e submersão conseqüente a queda dentro de uma piscina ­ residência
W68.1 Afogamento e submersão conseqüente a queda dentro de uma piscina ­ habitação coletiva
W68.2 Afogamento e submersão conseqüente a queda dentro de uma piscina ­ escolas, outras
instituições e áreas de administração pública
W68.3 Afogamento e submersão conseqüente a queda dentro de uma piscina ­ área para a prática de
esportes e atletismo
W68.4 Afogamento e submersão conseqüente a queda dentro de uma piscina ­ rua e estrada
W68.5 Afogamento e submersão conseqüente a queda dentro de uma piscina ­ áreas de comércio e
de serviços
W68.6 Afogamento e submersão conseqüente a queda dentro de uma piscina ­ áreas industriais e em
construção
W68.7 Afogamento e submersão conseqüente a queda dentro de uma piscina ­ fazenda
W68.8 Afogamento e submersão conseqüente a queda dentro de uma piscina ­ outros locais
especificados
W68.9 Afogamento e submersão conseqüente a queda dentro de uma piscina ­ local não especificado
W69.0 Afogamento e submersão em águas naturais ­ residência
W69.1 Afogamento e submersão em águas naturais ­ habitação coletiva
W69.2 Afogamento e submersão em águas naturais ­ escolas, outras instituições e áreas de
administração pública
W69.3 Afogamento e submersão em águas naturais ­ área para a prática de esportes e atletismo
W69.4 Afogamento e submersão em águas naturais ­ rua e estrada
W69.5 Afogamento e submersão em águas naturais ­ áreas de comércio e de serviços
W69.6 Afogamento e submersão em águas naturais ­ áreas industriais e em construção
W69.7 Afogamento e submersão em águas naturais ­ fazenda
W69.8 Afogamento e submersão em águas naturais ­ outros locais especificados
W69.9 Afogamento e submersão em águas naturais ­ local não especificado
W70.0 Afogamento e submersão conseqüentes a queda dentro de águas naturais ­ residência
W70.1 Afogamento e submersão conseqüentes a queda dentro de águas naturais ­ habitação coletiva
W70.2 Afogamento e submersão conseqüentes a queda dentro de águas naturais ­ escolas, outras
instituições e áreas de administração pública
W70.3 Afogamento e submersão conseqüentes a queda dentro de águas naturais ­ área para a prática
de esportes e atletismo
W70.4 Afogamento e submersão conseqüentes a queda dentro de águas naturais ­ rua e estrada
W70.5 Afogamento e submersão conseqüentes a queda dentro de águas naturais ­ áreas de comércio
e de serviços
W70.6 Afogamento e submersão conseqüentes a queda dentro de águas naturais ­ áreas industriais e
em construção
W70.7 Afogamento e submersão conseqüentes a queda dentro de águas naturais ­ fazenda
W70.8 Afogamento e submersão conseqüentes a queda dentro de águas naturais ­ outros locais
especificados
W70.9 Afogamento e submersão conseqüentes a queda dentro de águas naturais ­ local não
especificado
W73.0 Outros afogamentos e submersão especificados ­ residência
W73.1 Outros afogamentos e submersão especificados ­ habitação coletiva
W73.2 Outros afogamentos e submersão especificados ­ escolas, outras instituições e áreas de
administração pública
W73.3 Outros afogamentos e submersão especificados ­ área para a prática de esportes e atletismo
W73.4 Outros afogamentos e submersão especificados ­ rua e estrada
W73.5 Outros afogamentos e submersão especificados ­ áreas de comércio e de serviços
W73.6 Outros afogamentos e submersão especificados ­ áreas industriais e em construção
W73.7 Outros afogamentos e submersão especificados ­ fazenda
W73.8 Outros afogamentos e submersão especificados ­ outros locais especificados
W73.9 Outros afogamentos e submersão especificados ­ local não especificado
W74.0 Afogamento e submersão não especificados ­ residência
W74.1 Afogamento e submersão não especificados ­ habitação coletiva
W74.2 Afogamento e submersão não especificados ­ escolas, outras instituições e áreas de
administração pública
W74.3 Afogamento e submersão não especificados ­ área para a prática de esportes e atletismo
W74.4 Afogamento e submersão não especificados ­ rua e estrada
W74.5 Afogamento e submersão não especificados ­ áreas de comércio e de serviços
W74.6 Afogamento e submersão não especificados ­ áreas industriais e em construção
W74.7 Afogamento e submersão não especificados ­ fazenda
W74.8 Afogamento e submersão não especificados ­ outros locais especificados
W74.9 Afogamento e submersão não especificados ­ local não especificado
W75.0 Sufocação e estrangulamento acidental na cama ­ residência
W75.1 Sufocação e estrangulamento acidental na cama ­ habitação coletiva
W75.2 Sufocação e estrangulamento acidental na cama ­ escolas, outras instituições e áreas de
administração pública
W75.3 Sufocação e estrangulamento acidental na cama ­ área para a prática de esportes e atletismo
W75.4 Sufocação e estrangulamento acidental na cama ­ rua e estrada
W75.5 Sufocação e estrangulamento acidental na cama ­ áreas de comércio e de serviços
W75.6 Sufocação e estrangulamento acidental na cama ­ áreas industriais e em construção
W75.7 Sufocação e estrangulamento acidental na cama ­ fazenda
W75.8 Sufocação e estrangulamento acidental na cama ­ outros locais especificados
W75.9 Sufocação e estrangulamento acidental na cama ­ local não especificado
W76.0 Outro enforcamento e estrangulamento acidental ­ residência
W76.1 Outro enforcamento e estrangulamento acidental ­ habitação coletiva
W76.2 Outro enforcamento e estrangulamento acidental ­ escolas, outras instituições e áreas de
administração pública
W76.3 Outro enforcamento e estrangulamento acidental ­ área para a prática de esportes e atletismo
W76.4 Outro enforcamento e estrangulamento acidental ­ rua e estrada
W76.5 Outro enforcamento e estrangulamento acidental ­ áreas de comércio e de serviços
W76.6 Outro enforcamento e estrangulamento acidental ­ áreas industriais e em construção
W76.7 Outro enforcamento e estrangulamento acidental ­ fazenda
W76.8 Outro enforcamento e estrangulamento acidental ­ outros locais especificados
W76.9 Outro enforcamento e estrangulamento acidental ­ local não especificado
W77.0 Risco a respiração devido a desmoronamento, queda de terra e de outras substâncias ­
residência
W77.1 Risco a respiração devido a desmoronamento, queda de terra e de outras substâncias ­
habitação coletiva
W77.2 Risco a respiração devido a desmoronamento, queda de terra e de outras substâncias ­ escolas,
outras instituições e áreas de administração pública
W77.3 Risco a respiração devido a desmoronamento, queda de terra e de outras substâncias ­ área
para a prática de esportes e atletismo
W77.4 Risco a respiração devido a desmoronamento, queda de terra e de outras substâncias ­ rua e
estrada
W77.5 Risco a respiração devido a desmoronamento, queda de terra e de outras substâncias ­ áreas
de comércio e de serviços
W77.6 Risco a respiração devido a desmoronamento, queda de terra e de outras substâncias ­ áreas
industriais e em construção
W77.7 Risco a respiração devido a desmoronamento, queda de terra e de outras substâncias ­ fazenda
W77.8 Risco a respiração devido a desmoronamento, queda de terra e de outras substâncias ­ outros
locais especificados
W77.9 Risco a respiração devido a desmoronamento, queda de terra e de outras substâncias ­ local
não especificado
W78.0 Inalação do conteúdo gástrico ­ residência
W78.1 Inalação do conteúdo gástrico ­ habitação coletiva
W78.2 Inalação do conteúdo gástrico ­ escolas, outras instituições e áreas de administração pública
W78.3 Inalação do conteúdo gástrico ­ área para a prática de esportes e atletismo
W78.4 Inalação do conteúdo gástrico ­ rua e estrada
W78.5 Inalação do conteúdo gástrico ­ áreas de comércio e de serviços
W78.6 Inalação do conteúdo gástrico ­ áreas industriais e em construção
W78.7 Inalação do conteúdo gástrico ­ fazenda
W78.8 Inalação do conteúdo gástrico ­ outros locais especificados
W78.9 Inalação do conteúdo gástrico ­ local não especificado
W79.0 Inalação e ingestão de alimentos causando obstrução do trato respiratório ­ residência
W79.1 Inalação e ingestão de alimentos causando obstrução do trato respiratório ­ habitação coletiva
W79.2 Inalação e ingestão de alimentos causando obstrução do trato respiratório ­ escolas, outras
instituições e áreas de administração pública
W79.3 Inalação e ingestão de alimentos causando obstrução do trato respiratório ­ área para a prática
de esportes e atletismo
W79.4 Inalação e ingestão de alimentos causando obstrução do trato respiratório ­ rua e estrada
W79.5 Inalação e ingestão de alimentos causando obstrução do trato respiratório ­ áreas de comércio
e de serviços
W79.6 Inalação e ingestão de alimentos causando obstrução do trato respiratório ­ áreas industriais e
em construção
W79.7 Inalação e ingestão de alimentos causando obstrução do trato respiratório ­ fazenda
W79.8 Inalação e ingestão de alimentos causando obstrução do trato respiratório ­ outros locais
especificados
W79.9 Inalação e ingestão de alimentos causando obstrução do trato respiratório ­ local não
especificado
W80.0 Inalação e ingestão de outros objetos causando obstrução do trato respiratório ­ residência
W80.1 Inalação e ingestão de outros objetos causando obstrução do trato respiratório ­ habitação
coletiva
W80.2 Inalação e ingestão de outros objetos causando obstrução do trato respiratório ­ escolas, outras
instituições e áreas de administração pública
W80.3 Inalação e ingestão de outros objetos causando obstrução do trato respiratório ­ área para a
prática de esportes e atletismo
W80.4 Inalação e ingestão de outros objetos causando obstrução do trato respiratório ­ rua e estrada
W80.5 Inalação e ingestão de outros objetos causando obstrução do trato respiratório ­ áreas de
comércio e de serviços
W80.6 Inalação e ingestão de outros objetos causando obstrução do trato respiratório ­ áreas
industriais e em construção
W80.7 Inalação e ingestão de outros objetos causando obstrução do trato respiratório ­ fazenda
W80.8 Inalação e ingestão de outros objetos causando obstrução do trato respiratório ­ outros locais
especificados
W80.9 Inalação e ingestão de outros objetos causando obstrução do trato respiratório ­ local não
especificado
W81.0 Confinado ou aprisionado em um ambiente pobre em oxigênio ­ residência
W81.1 Confinado ou aprisionado em um ambiente pobre em oxigênio ­ habitação coletiva
W81.2 Confinado ou aprisionado em um ambiente pobre em oxigênio ­ escolas, outras instituições e
áreas de administração pública
W81.3 Confinado ou aprisionado em um ambiente pobre em oxigênio ­ área para a prática de esportes
e atletismo
W81.4 Confinado ou aprisionado em um ambiente pobre em oxigênio ­ rua e estrada
W81.5 Confinado ou aprisionado em um ambiente pobre em oxigênio ­ áreas de comércio e de
serviços
W81.6 Confinado ou aprisionado em um ambiente pobre em oxigênio ­ áreas industriais e em
construção
W81.7 Confinado ou aprisionado em um ambiente pobre em oxigênio ­ fazenda
W81.8 Confinado ou aprisionado em um ambiente pobre em oxigênio ­ outros locais especificados
W81.9 Confinado ou aprisionado em um ambiente pobre em oxigênio ­ local não especificado
W83.0 Outros riscos especificados à respiração ­ residência
W83.1 Outros riscos especificados à respiração ­ habitação coletiva
W83.2 Outros riscos especificados à respiração ­ escolas, outras instituições e áreas de administração
pública
W83.3 Outros riscos especificados à respiração ­ área para a prática de esportes e atletismo
W83.4 Outros riscos especificados à respiração ­ rua e estrada
W83.5 Outros riscos especificados à respiração ­ áreas de comércio e de serviços
W83.6 Outros riscos especificados à respiração ­ áreas industriais e em construção
W83.7 Outros riscos especificados à respiração ­ fazenda
W83.8 Outros riscos especificados à respiração ­ outros locais especificados
W83.9 Outros riscos especificados à respiração ­ local não especificado
W84.0 Riscos não especificados à respiração ­ residência
W84.1 Riscos não especificados à respiração ­ habitação coletiva
W84.2 Riscos não especificados à respiração ­ escolas, outras instituições e áreas de administração
pública
W84.3 Riscos não especificados à respiração ­ área para a prática de esportes e atletismo
W84.4 Riscos não especificados à respiração ­ rua e estrada
W84.5 Riscos não especificados à respiração ­ áreas de comércio e de serviços
W84.6 Riscos não especificados à respiração ­ áreas industriais e em construção
W84.7 Riscos não especificados à respiração ­ fazenda
W84.8 Riscos não especificados à respiração ­ outros locais especificados
W84.9 Riscos não especificados à respiração ­ local não especificado
W85.0 Exposição a linhas de transmissão de corrente elétrica ­ residência
W85.1 Exposição a linhas de transmissão de corrente elétrica ­ habitação coletiva
W85.2 Exposição a linhas de transmissão de corrente elétrica ­ escolas, outras instituições e áreas de
administração pública
W85.3 Exposição a linhas de transmissão de corrente elétrica ­ área para a prática de esportes e
atletismo
W85.4 Exposição a linhas de transmissão de corrente elétrica ­ rua e estrada
W85.5 Exposição a linhas de transmissão de corrente elétrica ­ áreas de comércio e de serviços
W85.6 Exposição a linhas de transmissão de corrente elétrica ­ áreas industriais e em construção
W85.7 Exposição a linhas de transmissão de corrente elétrica ­ fazenda
W85.8 Exposição a linhas de transmissão de corrente elétrica ­ outros locais especificados
W85.9 Exposição a linhas de transmissão de corrente elétrica ­ local não especificado
W86.0 Exposição a outra corrente elétrica especificada ­ residência
W86.1 Exposição a outra corrente elétrica especificada ­ habitação coletiva
W86.2 Exposição a outra corrente elétrica especificada ­ escolas, outras instituições e áreas de
administração pública
W86.3 Exposição a outra corrente elétrica especificada ­ área para a prática de esportes e atletismo
W86.4 Exposição a outra corrente elétrica especificada ­ rua e estrada
W86.5 Exposição a outra corrente elétrica especificada ­ áreas de comércio e de serviços
W86.6 Exposição a outra corrente elétrica especificada ­ áreas industriais e em construção
W86.7 Exposição a outra corrente elétrica especificada ­ fazenda
W86.8 Exposição a outra corrente elétrica especificada ­ outros locais especificados
W86.9 Exposição a outra corrente elétrica especificada ­ local não especificado
W87.0 Exposição a corrente elétrica não especificada ­ residência
W87.1 Exposição a corrente elétrica não especificada ­ habitação coletiva
W87.2 Exposição a corrente elétrica não especificada ­ escolas, outras instituições e áreas de
administração pública
W87.3 Exposição a corrente elétrica não especificada ­ área para a prática de esportes e atletismo
W87.4 Exposição a corrente elétrica não especificada ­ rua e estrada
W87.5 Exposição a corrente elétrica não especificada ­ áreas de comércio e de serviços
W87.6 Exposição a corrente elétrica não especificada ­ áreas industriais e em construção
W87.7 Exposição a corrente elétrica não especificada ­ fazenda
W87.8 Exposição a corrente elétrica não especificada ­ outros locais especificados
W87.9 Exposição a corrente elétrica não especificada ­ local não especificado
W88.0 Exposição a radiação ionizante ­ residência
W88.1 Exposição a radiação ionizante ­ habitação coletiva
W88.2 Exposição a radiação ionizante ­ escolas, outras instituições e áreas de administração pública
W88.3 Exposição a radiação ionizante ­ área para a prática de esportes e atletismo
W88.4 Exposição a radiação ionizante ­ rua e estrada
W88.5 Exposição a radiação ionizante ­ áreas de comércio e de serviços
W88.6 Exposição a radiação ionizante ­ áreas industriais e em construção
W88.7 Exposição a radiação ionizante ­ fazenda
W88.8 Exposição a radiação ionizante ­ outros locais especificados
W88.9 Exposição a radiação ionizante ­ local não especificado
W89.0 Exposição a fontes luminosas artificiais visíveis ou à luz ultravioleta ­ residência
W89.1 Exposição a fontes luminosas artificiais visíveis ou à luz ultravioleta ­ habitação coletiva
W89.2 Exposição a fontes luminosas artificiais visíveis ou à luz ultravioleta ­ escolas, outras instituições
e áreas de administração pública
W89.3 Exposição a fontes luminosas artificiais visíveis ou à luz ultravioleta ­ área para a prática de
esportes e atletismo
W89.4 Exposição a fontes luminosas artificiais visíveis ou à luz ultravioleta ­ rua e estrada
W89.5 Exposição a fontes luminosas artificiais visíveis ou à luz ultravioleta ­ áreas de comércio e de
serviços
W89.6 Exposição a fontes luminosas artificiais visíveis ou à luz ultravioleta ­ áreas industriais e em
construção
W89.7 Exposição a fontes luminosas artificiais visíveis ou à luz ultravioleta ­ fazenda
W89.8 Exposição a fontes luminosas artificiais visíveis ou à luz ultravioleta ­ outros locais especificados
W89.9 Exposição a fontes luminosas artificiais visíveis ou à luz ultravioleta ­ local não especificado
W90.0 Exposição a outros tipos de radiação não­ionizante ­ residência
W90.1 Exposição a outros tipos de radiação não­ionizante ­ habitação coletiva
W90.2 Exposição a outros tipos de radiação não­ionizante ­ escolas, outras instituições e áreas de
administração pública
W90.3 Exposição a outros tipos de radiação não­ionizante ­ área para a prática de esportes e atletismo
W90.4 Exposição a outros tipos de radiação não­ionizante ­ rua e estrada
W90.5 Exposição a outros tipos de radiação não­ionizante ­ áreas de comércio e de serviços
W90.6 Exposição a outros tipos de radiação não­ionizante ­ áreas industriais e em construção
W90.7 Exposição a outros tipos de radiação não­ionizante ­ fazenda
W90.8 Exposição a outros tipos de radiação não­ionizante ­ outros locais especificados
W90.9 Exposição a outros tipos de radiação não­ionizante ­ local não especificado
W91.0 Exposição a tipo não especificado de radiação ­ residência
W91.1 Exposição a tipo não especificado de radiação ­ habitação coletiva
W91.2 Exposição a tipo não especificado de radiação ­ escolas, outras instituições e áreas de
administração pública
W91.3 Exposição a tipo não especificado de radiação ­ área para a prática de esportes e atletismo
W91.4 Exposição a tipo não especificado de radiação ­ rua e estrada
W91.5 Exposição a tipo não especificado de radiação ­ áreas de comércio e de serviços
W91.6 Exposição a tipo não especificado de radiação ­ áreas industriais e em construção
W91.7 Exposição a tipo não especificado de radiação ­ fazenda
W91.8 Exposição a tipo não especificado de radiação ­ outros locais especificados
W91.9 Exposição a tipo não especificado de radiação ­ local não especificado
W92.0 Exposição a um calor excessivo de origem artificial ­ residência
W92.1 Exposição a um calor excessivo de origem artificial ­ habitação coletiva
W92.2 Exposição a um calor excessivo de origem artificial ­ escolas, outras instituições e áreas de
administração pública
W92.3 Exposição a um calor excessivo de origem artificial ­ área para a prática de esportes e atletismo
W92.4 Exposição a um calor excessivo de origem artificial ­ rua e estrada
W92.5 Exposição a um calor excessivo de origem artificial ­ áreas de comércio e de serviços
W92.6 Exposição a um calor excessivo de origem artificial ­ áreas industriais e em construção
W92.7 Exposição a um calor excessivo de origem artificial ­ fazenda
W92.8 Exposição a um calor excessivo de origem artificial ­ outros locais especificados
W92.9 Exposição a um calor excessivo de origem artificial ­ local não especificado
W93.0 Exposição a um frio excessivo de origem artificial ­ residência
W93.1 Exposição a um frio excessivo de origem artificial ­ habitação coletiva
W93.2 Exposição a um frio excessivo de origem artificial ­ escolas, outras instituições e áreas de
administração pública
W93.3 Exposição a um frio excessivo de origem artificial ­ área para a prática de esportes e atletismo
W93.4 Exposição a um frio excessivo de origem artificial ­ rua e estrada
W93.5 Exposição a um frio excessivo de origem artificial ­ áreas de comércio e de serviços
W93.6 Exposição a um frio excessivo de origem artificial ­ áreas industriais e em construção
W93.7 Exposição a um frio excessivo de origem artificial ­ fazenda
W93.8 Exposição a um frio excessivo de origem artificial ­ outros locais especificados
W93.9 Exposição a um frio excessivo de origem artificial ­ local não especificado
W94.0 Exposição a alta, baixa e a variações da pressão atmosférica ­ residência
W94.1 Exposição a alta, baixa e a variações da pressão atmosférica ­ habitação coletiva
W94.2 Exposição a alta, baixa e a variações da pressão atmosférica ­ escolas, outras instituições e
áreas de administração pública
W94.3 Exposição a alta, baixa e a variações da pressão atmosférica ­ área para a prática de esportes
e atletismo
W94.4 Exposição a alta, baixa e a variações da pressão atmosférica ­ rua e estrada
W94.5 Exposição a alta, baixa e a variações da pressão atmosférica ­ áreas de comércio e de serviços
W94.6 Exposição a alta, baixa e a variações da pressão atmosférica ­ áreas industriais e em
construção
W94.7 Exposição a alta, baixa e a variações da pressão atmosférica ­ fazenda
W94.8 Exposição a alta, baixa e a variações da pressão atmosférica ­ outros locais especificados
W94.9 Exposição a alta, baixa e a variações da pressão atmosférica ­ local não especificado
W99.0 Exposição a outros fatores ambientais artificiais e aos não especificados ­ residência
W99.1 Exposição a outros fatores ambientais artificiais e aos não especificados ­ habitação coletiva
W99.2 Exposição a outros fatores ambientais artificiais e aos não especificados ­ escolas, outras
instituições e áreas de administração pública
W99.3 Exposição a outros fatores ambientais artificiais e aos não especificados ­ área para a prática
de esportes e atletismo
W99.4 Exposição a outros fatores ambientais artificiais e aos não especificados ­ rua e estrada
W99.5 Exposição a outros fatores ambientais artificiais e aos não especificados ­ áreas de comércio e
de serviços
W99.6 Exposição a outros fatores ambientais artificiais e aos não especificados ­ áreas industriais e
em construção
W99.7 Exposição a outros fatores ambientais artificiais e aos não especificados ­ fazenda
W99.8 Exposição a outros fatores ambientais artificiais e aos não especificados ­ outros locais
especificados
W99.9 Exposição a outros fatores ambientais artificiais e aos não especificados ­ local não
especificado
X00.0 Exposição a fogo não­controlado em um edifício ou outro tipo de construção ­ residência
X00.1 Exposição a fogo não­controlado em um edifício ou outro tipo de construção ­ habitação coletiva
X00.2 Exposição a fogo não­controlado em um edifício ou outro tipo de construção ­ escolas, outras
instituições e áreas de administração pública
X00.3 Exposição a fogo não­controlado em um edifício ou outro tipo de construção ­ área para a
prática de esportes e atletismo
X00.4 Exposição a fogo não­controlado em um edifício ou outro tipo de construção ­ rua e estrada
X00.5 Exposição a fogo não­controlado em um edifício ou outro tipo de construção ­ áreas de comércio
e de serviços
X00.6 Exposição a fogo não­controlado em um edifício ou outro tipo de construção ­ áreas industriais e
em construção
X00.7 Exposição a fogo não­controlado em um edifício ou outro tipo de construção ­ fazenda
X00.8 Exposição a fogo não­controlado em um edifício ou outro tipo de construção ­ outros locais
especificados
X00.9 Exposição a fogo não­controlado em um edifício ou outro tipo de construção ­ local não
especificado
X01.0 Exposição a fogo não­controlado fora de um edifício ou de outro tipo de construção ­ residência
X01.1 Exposição a fogo não­controlado fora de um edifício ou de outro tipo de construção ­ habitação
coletiva
X01.2 Exposição a fogo não­controlado fora de um edifício ou de outro tipo de construção ­ escolas,
outras instituições e áreas de administração pública
X01.3 Exposição a fogo não­controlado fora de um edifício ou de outro tipo de construção ­ área para a
prática de esportes e atletismo
X01.4 Exposição a fogo não­controlado fora de um edifício ou de outro tipo de construção ­ rua e
estrada
X01.5 Exposição a fogo não­controlado fora de um edifício ou de outro tipo de construção ­ áreas de
comércio e de serviços
X01.6 Exposição a fogo não­controlado fora de um edifício ou de outro tipo de construção ­ áreas
industriais e em construção
X01.7 Exposição a fogo não­controlado fora de um edifício ou de outro tipo de construção ­ fazenda
X01.8 Exposição a fogo não­controlado fora de um edifício ou de outro tipo de construção ­ outros
locais especificados
X01.9 Exposição a fogo não­controlado fora de um edifício ou de outro tipo de construção ­ local não
especificado
X02.0 Exposição a fogo controlado em um edifício ou outro tipo de construção ­ residência
X02.1 Exposição a fogo controlado em um edifício ou outro tipo de construção ­ habitação coletiva
X02.2 Exposição a fogo controlado em um edifício ou outro tipo de construção ­ escolas, outras
instituições e áreas de administração pública
X02.3 Exposição a fogo controlado em um edifício ou outro tipo de construção ­ área para a prática de
esportes e atletismo
X02.4 Exposição a fogo controlado em um edifício ou outro tipo de construção ­ rua e estrada
X02.5 Exposição a fogo controlado em um edifício ou outro tipo de construção ­ áreas de comércio e
de serviços
X02.6 Exposição a fogo controlado em um edifício ou outro tipo de construção ­ áreas industriais e em
construção
X02.7 Exposição a fogo controlado em um edifício ou outro tipo de construção ­ fazenda
X02.8 Exposição a fogo controlado em um edifício ou outro tipo de construção ­ outros locais
especificados
X02.9 Exposição a fogo controlado em um edifício ou outro tipo de construção ­ local não especificado
X03.0 Exposição a fogo controlado fora de um edifício ou de outro tipo de construção ­ residência
X03.1 Exposição a fogo controlado fora de um edifício ou de outro tipo de construção ­ habitação
coletiva
X03.2 Exposição a fogo controlado fora de um edifício ou de outro tipo de construção ­ escolas, outras
instituições e áreas de administração pública
X03.3 Exposição a fogo controlado fora de um edifício ou de outro tipo de construção ­ área para a
prática de esportes e atletismo
X03.4 Exposição a fogo controlado fora de um edifício ou de outro tipo de construção ­ rua e estrada
X03.5 Exposição a fogo controlado fora de um edifício ou de outro tipo de construção ­ áreas de
comércio e de serviços
X03.6 Exposição a fogo controlado fora de um edifício ou de outro tipo de construção ­ áreas
industriais e em construção
X03.7 Exposição a fogo controlado fora de um edifício ou de outro tipo de construção ­ fazenda
X03.8 Exposição a fogo controlado fora de um edifício ou de outro tipo de construção ­ outros locais
especificados
X03.9 Exposição a fogo controlado fora de um edifício ou de outro tipo de construção ­ local não
especificado
X04.0 Exposição a combustão de substância muito inflamável ­ residência
X04.1 Exposição a combustão de substância muito inflamável ­ habitação coletiva
X04.2 Exposição a combustão de substância muito inflamável ­ escolas, outras instituições e áreas de
administração pública
X04.3 Exposição a combustão de substância muito inflamável ­ área para a prática de esportes e
atletismo
X04.4 Exposição a combustão de substância muito inflamável ­ rua e estrada
X04.5 Exposição a combustão de substância muito inflamável ­ áreas de comércio e de serviços
X04.6 Exposição a combustão de substância muito inflamável ­ áreas industriais e em construção
X04.7 Exposição a combustão de substância muito inflamável ­ fazenda
X04.8 Exposição a combustão de substância muito inflamável ­ outros locais especificados
X04.9 Exposição a combustão de substância muito inflamável ­ local não especificado
X05.0 Exposição a combustão de roupa de dormir ­ residência
X05.1 Exposição a combustão de roupa de dormir ­ habitação coletiva
X05.2 Exposição a combustão de roupa de dormir ­ escolas, outras instituições e áreas de
administração pública
X05.3 Exposição a combustão de roupa de dormir ­ área para a prática de esportes e atletismo
X05.4 Exposição a combustão de roupa de dormir ­ rua e estrada
X05.5 Exposição a combustão de roupa de dormir ­ áreas de comércio e de serviços
X05.6 Exposição a combustão de roupa de dormir ­ áreas industriais e em construção
X05.7 Exposição a combustão de roupa de dormir ­ fazenda
X05.8 Exposição a combustão de roupa de dormir ­ outros locais especificados
X05.9 Exposição a combustão de roupa de dormir ­ local não especificado
X06.0 Exposição a combustão de outro tipo de roupa ou de acessórios ­ residência
X06.1 Exposição a combustão de outro tipo de roupa ou de acessórios ­ habitação coletiva
X06.2 Exposição a combustão de outro tipo de roupa ou de acessórios ­ escolas, outras instituições e
áreas de administração pública
X06.3 Exposição a combustão de outro tipo de roupa ou de acessórios ­ área para a prática de
esportes e atletismo
X06.4 Exposição a combustão de outro tipo de roupa ou de acessórios ­ rua e estrada
X06.5 Exposição a combustão de outro tipo de roupa ou de acessórios ­ áreas de comércio e de
serviços
X06.6 Exposição a combustão de outro tipo de roupa ou de acessórios ­ áreas industriais e em
construção
X06.7 Exposição a combustão de outro tipo de roupa ou de acessórios ­ fazenda
X06.8 Exposição a combustão de outro tipo de roupa ou de acessórios ­ outros locais especificados
X06.9 Exposição a combustão de outro tipo de roupa ou de acessórios ­ local não especificado
X08.0 Exposição a outro tipo especificado de fumaças, fogo ou chamas ­ residência
X08.1 Exposição a outro tipo especificado de fumaças, fogo ou chamas ­ habitação coletiva
X08.2 Exposição a outro tipo especificado de fumaças, fogo ou chamas ­ escolas, outras instituições e
áreas de administração pública
X08.3 Exposição a outro tipo especificado de fumaças, fogo ou chamas ­ área para a prática de
esportes e atletismo
X08.4 Exposição a outro tipo especificado de fumaças, fogo ou chamas ­ rua e estrada
X08.5 Exposição a outro tipo especificado de fumaças, fogo ou chamas ­ áreas de comércio e de
serviços
X08.6 Exposição a outro tipo especificado de fumaças, fogo ou chamas ­ áreas industriais e em
construção
X08.7 Exposição a outro tipo especificado de fumaças, fogo ou chamas ­ fazenda
X08.8 Exposição a outro tipo especificado de fumaças, fogo ou chamas ­ outros locais especificados
X08.9 Exposição a outro tipo especificado de fumaças, fogo ou chamas ­ local não especificado
X09.0 Exposição a tipo não especificado de fumaças, fogo ou chamas ­ residência
X09.1 Exposição a tipo não especificado de fumaças, fogo ou chamas ­ habitação coletiva
X09.2 Exposição a tipo não especificado de fumaças, fogo ou chamas ­ escolas, outras instituições e
áreas de administração pública
X09.3 Exposição a tipo não especificado de fumaças, fogo ou chamas ­ área para a prática de
esportes e atletismo
X09.4 Exposição a tipo não especificado de fumaças, fogo ou chamas ­ rua e estrada
X09.5 Exposição a tipo não especificado de fumaças, fogo ou chamas ­ áreas de comércio e de
serviços
X09.6 Exposição a tipo não especificado de fumaças, fogo ou chamas ­ áreas industriais e em
construção
X09.7 Exposição a tipo não especificado de fumaças, fogo ou chamas ­ fazenda
X09.8 Exposição a tipo não especificado de fumaças, fogo ou chamas ­ outros locais especificados
X09.9 Exposição a tipo não especificado de fumaças, fogo ou chamas ­ local não especificado
X10.0 Contato com bebidas, alimentos, gordura e óleo de cozinha quentes ­ residência
X10.1 Contato com bebidas, alimentos, gordura e óleo de cozinha quentes ­ habitação coletiva
X10.2 Contato com bebidas, alimentos, gordura e óleo de cozinha quentes ­ escolas, outras instituições
e áreas de administração pública
X10.3 Contato com bebidas, alimentos, gordura e óleo de cozinha quentes ­ área para a prática de
esportes e atletismo
X10.4 Contato com bebidas, alimentos, gordura e óleo de cozinha quentes ­ rua e estrada
X10.5 Contato com bebidas, alimentos, gordura e óleo de cozinha quentes ­ áreas de comércio e de
serviços
X10.6 Contato com bebidas, alimentos, gordura e óleo de cozinha quentes ­ áreas industriais e em
construção
X10.7 Contato com bebidas, alimentos, gordura e óleo de cozinha quentes ­ fazenda
X10.8 Contato com bebidas, alimentos, gordura e óleo de cozinha quentes ­ outros locais especificados
X10.9 Contato com bebidas, alimentos, gordura e óleo de cozinha quentes ­ local não especificado
X11.0 Contato com água corrente quente de torneira ­ residência
X11.1 Contato com água corrente quente de torneira ­ habitação coletiva
X11.2 Contato com água corrente quente de torneira ­ escolas, outras instituições e áreas de
administração pública
X11.3 Contato com água corrente quente de torneira ­ área para a prática de esportes e atletismo
X11.4 Contato com água corrente quente de torneira ­ rua e estrada
X11.5 Contato com água corrente quente de torneira ­ áreas de comércio e de serviços
X11.6 Contato com água corrente quente de torneira ­ áreas industriais e em construção
X11.7 Contato com água corrente quente de torneira ­ fazenda
X11.8 Contato com água corrente quente de torneira ­ outros locais especificados
X11.9 Contato com água corrente quente de torneira ­ local não especificado
X12.0 Contato com outros líquidos quentes ­ residência
X12.1 Contato com outros líquidos quentes ­ habitação coletiva
X12.2 Contato com outros líquidos quentes ­ escolas, outras instituições e áreas de administração
pública
X12.3 Contato com outros líquidos quentes ­ área para a prática de esportes e atletismo
X12.4 Contato com outros líquidos quentes ­ rua e estrada
X12.5 Contato com outros líquidos quentes ­ áreas de comércio e de serviços
X12.6 Contato com outros líquidos quentes ­ áreas industriais e em construção
X12.7 Contato com outros líquidos quentes ­ fazenda
X12.8 Contato com outros líquidos quentes ­ outros locais especificados
X12.9 Contato com outros líquidos quentes ­ local não especificado
X13.0 Contato com vapor d'água e com vapores quentes ­ residência
X13.1 Contato com vapor d'água e com vapores quentes ­ habitação coletiva
X13.2 Contato com vapor d'água e com vapores quentes ­ escolas, outras instituições e áreas de
administração pública
X13.3 Contato com vapor d'água e com vapores quentes ­ área para a prática de esportes e atletismo
X13.4 Contato com vapor d'água e com vapores quentes ­ rua e estrada
X13.5 Contato com vapor d'água e com vapores quentes ­ áreas de comércio e de serviços
X13.6 Contato com vapor d'água e com vapores quentes ­ áreas industriais e em construção
X13.7 Contato com vapor d'água e com vapores quentes ­ fazenda
X13.8 Contato com vapor d'água e com vapores quentes ­ outros locais especificados
X13.9 Contato com vapor d'água e com vapores quentes ­ local não especificado
X14.0 Contato com ar e gases quentes ­ residência
X14.1 Contato com ar e gases quentes ­ habitação coletiva
X14.2 Contato com ar e gases quentes ­ escolas, outras instituições e áreas de administração pública
X14.3 Contato com ar e gases quentes ­ área para a prática de esportes e atletismo
X14.4 Contato com ar e gases quentes ­ rua e estrada
X14.5 Contato com ar e gases quentes ­ áreas de comércio e de serviços
X14.6 Contato com ar e gases quentes ­ áreas industriais e em construção
X14.7 Contato com ar e gases quentes ­ fazenda
X14.8 Contato com ar e gases quentes ­ outros locais especificados
X14.9 Contato com ar e gases quentes ­ local não especificado
X15.0 Contato com aparelhos domésticos quentes ­ residência
X15.1 Contato com aparelhos domésticos quentes ­ habitação coletiva
X15.2 Contato com aparelhos domésticos quentes ­ escolas, outras instituições e áreas de
administração pública
X15.3 Contato com aparelhos domésticos quentes ­ área para a prática de esportes e atletismo
X15.4 Contato com aparelhos domésticos quentes ­ rua e estrada
X15.5 Contato com aparelhos domésticos quentes ­ áreas de comércio e de serviços
X15.6 Contato com aparelhos domésticos quentes ­ áreas industriais e em construção
X15.7 Contato com aparelhos domésticos quentes ­ fazenda
X15.8 Contato com aparelhos domésticos quentes ­ outros locais especificados
X15.9 Contato com aparelhos domésticos quentes ­ local não especificado
X16.0 Contato com aquecedores, radiadores e tubulação ­ residência
X16.1 Contato com aquecedores, radiadores e tubulação ­ habitação coletiva
X16.2 Contato com aquecedores, radiadores e tubulação ­ escolas, outras instituições e áreas de
administração pública
X16.3 Contato com aquecedores, radiadores e tubulação ­ área para a prática de esportes e atletismo
X16.4 Contato com aquecedores, radiadores e tubulação ­ rua e estrada
X16.5 Contato com aquecedores, radiadores e tubulação ­ áreas de comércio e de serviços
X16.6 Contato com aquecedores, radiadores e tubulação ­ áreas industriais e em construção
X16.7 Contato com aquecedores, radiadores e tubulação ­ fazenda
X16.8 Contato com aquecedores, radiadores e tubulação ­ outros locais especificados
X16.9 Contato com aquecedores, radiadores e tubulação ­ local não especificado
X17.0 Contato com motores, máquinas e ferramentas quentes ­ residência
X17.1 Contato com motores, máquinas e ferramentas quentes ­ habitação coletiva
X17.2 Contato com motores, máquinas e ferramentas quentes ­ escolas, outras instituições e áreas de
administração pública
X17.3 Contato com motores, máquinas e ferramentas quentes ­ área para a prática de esportes e
atletismo
X17.4 Contato com motores, máquinas e ferramentas quentes ­ rua e estrada
X17.5 Contato com motores, máquinas e ferramentas quentes ­ áreas de comércio e de serviços
X17.6 Contato com motores, máquinas e ferramentas quentes ­ áreas industriais e em construção
X17.7 Contato com motores, máquinas e ferramentas quentes ­ fazenda
X17.8 Contato com motores, máquinas e ferramentas quentes ­ outros locais especificados
X17.9 Contato com motores, máquinas e ferramentas quentes ­ local não especificado
X18.0 Contato com outros metais quentes ­ residência
X18.1 Contato com outros metais quentes ­ habitação coletiva
X18.2 Contato com outros metais quentes ­ escolas, outras instituições e áreas de administração
pública
X18.3 Contato com outros metais quentes ­ área para a prática de esportes e atletismo
X18.4 Contato com outros metais quentes ­ rua e estrada
X18.5 Contato com outros metais quentes ­ áreas de comércio e de serviços
X18.6 Contato com outros metais quentes ­ áreas industriais e em construção
X18.7 Contato com outros metais quentes ­ fazenda
X18.8 Contato com outros metais quentes ­ outros locais especificados
X18.9 Contato com outros metais quentes ­ local não especificado
X19.0 Contato com outras fontes de calor ou com substâncias quentes não especificados ­ residência
X19.1 Contato com outras fontes de calor ou com substâncias quentes não especificados ­ habitação
coletiva
X19.2 Contato com outras fontes de calor ou com substâncias quentes não especificados ­ escolas,
outras instituições e áreas de administração pública
X19.3 Contato com outras fontes de calor ou com substâncias quentes não especificados ­ área para a
prática de esportes e atletismo
X19.4 Contato com outras fontes de calor ou com substâncias quentes não especificados ­ rua e
estrada
X19.5 Contato com outras fontes de calor ou com substâncias quentes não especificados ­ áreas de
comércio e de serviços
X19.6 Contato com outras fontes de calor ou com substâncias quentes não especificados ­ áreas
industriais e em construção
X19.7 Contato com outras fontes de calor ou com substâncias quentes não especificados ­ fazenda
X19.8 Contato com outras fontes de calor ou com substâncias quentes não especificados ­ outros
locais especificados
X19.9 Contato com outras fontes de calor ou com substâncias quentes não especificados ­ local não
especificado
X20.0 Contato com serpentes e lagartos venenosos ­ residência
X20.1 Contato com serpentes e lagartos venenosos ­ habitação coletiva
X20.2 Contato com serpentes e lagartos venenosos ­ escolas, outras instituições e áreas de
administração pública
X20.3 Contato com serpentes e lagartos venenosos ­ área para a prática de esportes e atletismo
X20.4 Contato com serpentes e lagartos venenosos ­ rua e estrada
X20.5 Contato com serpentes e lagartos venenosos ­ áreas de comércio e de serviços
X20.6 Contato com serpentes e lagartos venenosos ­ áreas industriais e em construção
X20.7 Contato com serpentes e lagartos venenosos ­ fazenda
X20.8 Contato com serpentes e lagartos venenosos ­ outros locais especificados
X20.9 Contato com serpentes e lagartos venenosos ­ local não especificado
X21.0 Contato com aranhas venenosas ­ residência
X21.1 Contato com aranhas venenosas ­ habitação coletiva
X21.2 Contato com aranhas venenosas ­ escolas, outras instituições e áreas de administração pública
X21.3 Contato com aranhas venenosas ­ área para a prática de esportes e atletismo
X21.4 Contato com aranhas venenosas ­ rua e estrada
X21.5 Contato com aranhas venenosas ­ áreas de comércio e de serviços
X21.6 Contato com aranhas venenosas ­ áreas industriais e em construção
X21.7 Contato com aranhas venenosas ­ fazenda
X21.8 Contato com aranhas venenosas ­ outros locais especificados
X21.9 Contato com aranhas venenosas ­ local não especificado
X22.0 Contato com escorpiões ­ residência
X22.1 Contato com escorpiões ­ habitação coletiva
X22.2 Contato com escorpiões ­ escolas, outras instituições e áreas de administração pública
X22.3 Contato com escorpiões ­ área para a prática de esportes e atletismo
X22.4 Contato com escorpiões ­ rua e estrada
X22.5 Contato com escorpiões ­ áreas de comércio e de serviços
X22.6 Contato com escorpiões ­ áreas industriais e em construção
X22.7 Contato com escorpiões ­ fazenda
X22.8 Contato com escorpiões ­ outros locais especificados
X22.9 Contato com escorpiões ­ local não especificado
X23.0 Contato com abelhas, vespas e vespões ­ residência
X23.1 Contato com abelhas, vespas e vespões ­ habitação coletiva
X23.2 Contato com abelhas, vespas e vespões ­ escolas, outras instituições e áreas de administração
pública
X23.3 Contato com abelhas, vespas e vespões ­ área para a prática de esportes e atletismo
X23.4 Contato com abelhas, vespas e vespões ­ rua e estrada
X23.5 Contato com abelhas, vespas e vespões ­ áreas de comércio e de serviços
X23.6 Contato com abelhas, vespas e vespões ­ áreas industriais e em construção
X23.7 Contato com abelhas, vespas e vespões ­ fazenda
X23.8 Contato com abelhas, vespas e vespões ­ outros locais especificados
X23.9 Contato com abelhas, vespas e vespões ­ local não especificado
X24.0 Contato com centopéias e miriápodes venenosas (tropicais) ­ residência
X24.1 Contato com centopéias e miriápodes venenosas (tropicais) ­ habitação coletiva
X24.2 Contato com centopéias e miriápodes venenosas (tropicais) ­ escolas, outras instituições e áreas
de administração pública
X24.3 Contato com centopéias e miriápodes venenosas (tropicais) ­ área para a prática de esportes e
atletismo
X24.4 Contato com centopéias e miriápodes venenosas (tropicais) ­ rua e estrada
X24.5 Contato com centopéias e miriápodes venenosas (tropicais) ­ áreas de comércio e de serviços
X24.6 Contato com centopéias e miriápodes venenosas (tropicais) ­ áreas industriais e em construção
X24.7 Contato com centopéias e miriápodes venenosas (tropicais) ­ fazenda
X24.8 Contato com centopéias e miriápodes venenosas (tropicais) ­ outros locais especificados
X24.9 Contato com centopéias e miriápodes venenosas (tropicais) ­ local não especificado
X25.0 Contato com outros artrópodes venenosos especificados ­ residência
X25.1 Contato com outros artrópodes venenosos especificados ­ habitação coletiva
X25.2 Contato com outros artrópodes venenosos especificados ­ escolas, outras instituições e áreas
de administração pública
X25.3 Contato com outros artrópodes venenosos especificados ­ área para a prática de esportes e
atletismo
X25.4 Contato com outros artrópodes venenosos especificados ­ rua e estrada
X25.5 Contato com outros artrópodes venenosos especificados ­ áreas de comércio e de serviços
X25.6 Contato com outros artrópodes venenosos especificados ­ áreas industriais e em construção
X25.7 Contato com outros artrópodes venenosos especificados ­ fazenda
X25.8 Contato com outros artrópodes venenosos especificados ­ outros locais especificados
X25.9 Contato com outros artrópodes venenosos especificados ­ local não especificado
X26.0 Contato com animais e plantas marinhos venenosos ­ residência
X26.1 Contato com animais e plantas marinhos venenosos ­ habitação coletiva
X26.2 Contato com animais e plantas marinhos venenosos ­ escolas, outras instituições e áreas de
administração pública
X26.3 Contato com animais e plantas marinhos venenosos ­ área para a prática de esportes e
atletismo
X26.4 Contato com animais e plantas marinhos venenosos ­ rua e estrada
X26.5 Contato com animais e plantas marinhos venenosos ­ áreas de comércio e de serviços
X26.6 Contato com animais e plantas marinhos venenosos ­ áreas industriais e em construção
X26.7 Contato com animais e plantas marinhos venenosos ­ fazenda
X26.8 Contato com animais e plantas marinhos venenosos ­ outros locais especificados
X26.9 Contato com animais e plantas marinhos venenosos ­ local não especificado
X27.0 Contato com outros animais venenosos especificados ­ residência
X27.1 Contato com outros animais venenosos especificados ­ habitação coletiva
X27.2 Contato com outros animais venenosos especificados ­ escolas, outras instituições e áreas de
administração pública
X27.3 Contato com outros animais venenosos especificados ­ área para a prática de esportes e
atletismo
X27.4 Contato com outros animais venenosos especificados ­ rua e estrada
X27.5 Contato com outros animais venenosos especificados ­ áreas de comércio e de serviços
X27.6 Contato com outros animais venenosos especificados ­ áreas industriais e em construção
X27.7 Contato com outros animais venenosos especificados ­ fazenda
X27.8 Contato com outros animais venenosos especificados ­ outros locais especificados
X27.9 Contato com outros animais venenosos especificados ­ local não especificado
X28.0 Contato com outras plantas venenosas especificadas ­ residência
X28.1 Contato com outras plantas venenosas especificadas ­ habitação coletiva
X28.2 Contato com outras plantas venenosas especificadas ­ escolas, outras instituições e áreas de
administração pública
X28.3 Contato com outras plantas venenosas especificadas ­ área para a prática de esportes e
atletismo
X28.4 Contato com outras plantas venenosas especificadas ­ rua e estrada
X28.5 Contato com outras plantas venenosas especificadas ­ áreas de comércio e de serviços
X28.6 Contato com outras plantas venenosas especificadas ­ áreas industriais e em construção
X28.7 Contato com outras plantas venenosas especificadas ­ fazenda
X28.8 Contato com outras plantas venenosas especificadas ­ outros locais especificados
X28.9 Contato com outras plantas venenosas especificadas ­ local não especificado
X29.0 Contato com animais ou plantas venenosos, sem especificação ­ residência
X29.1 Contato com animais ou plantas venenosos, sem especificação ­ habitação coletiva
X29.2 Contato com animais ou plantas venenosos, sem especificação ­ escolas, outras instituições e
áreas de administração pública
X29.3 Contato com animais ou plantas venenosos, sem especificação ­ área para a prática de esportes
e atletismo
X29.4 Contato com animais ou plantas venenosos, sem especificação ­ rua e estrada
X29.5 Contato com animais ou plantas venenosos, sem especificação ­ áreas de comércio e de
serviços
X29.6 Contato com animais ou plantas venenosos, sem especificação ­ áreas industriais e em
construção
X29.7 Contato com animais ou plantas venenosos, sem especificação ­ fazenda
X29.8 Contato com animais ou plantas venenosos, sem especificação ­ outros locais especificados
X29.9 Contato com animais ou plantas venenosos, sem especificação ­ local não especificado
X30.0 Exposição a calor natural excessivo ­ residência
X30.1 Exposição a calor natural excessivo ­ habitação coletiva
X30.2 Exposição a calor natural excessivo ­ escolas, outras instituições e áreas de administração
pública
X30.3 Exposição a calor natural excessivo ­ área para a prática de esportes e atletismo
X30.4 Exposição a calor natural excessivo ­ rua e estrada
X30.5 Exposição a calor natural excessivo ­ áreas de comércio e de serviços
X30.6 Exposição a calor natural excessivo ­ áreas industriais e em construção
X30.7 Exposição a calor natural excessivo ­ fazenda
X30.8 Exposição a calor natural excessivo ­ outros locais especificados
X30.9 Exposição a calor natural excessivo ­ local não especificado
X31.0 Exposição a frio natural excessivo ­ residência
X31.1 Exposição a frio natural excessivo ­ habitação coletiva
X31.2 Exposição a frio natural excessivo ­ escolas, outras instituições e áreas de administração pública
X31.3 Exposição a frio natural excessivo ­ área para a prática de esportes e atletismo
X31.4 Exposição a frio natural excessivo ­ rua e estrada
X31.5 Exposição a frio natural excessivo ­ áreas de comércio e de serviços
X31.6 Exposição a frio natural excessivo ­ áreas industriais e em construção
X31.7 Exposição a frio natural excessivo ­ fazenda
X31.8 Exposição a frio natural excessivo ­ outros locais especificados
X31.9 Exposição a frio natural excessivo ­ local não especificado
X32.0 Exposição à luz solar ­ residência
X32.1 Exposição à luz solar ­ habitação coletiva
X32.2 Exposição à luz solar ­ escolas, outras instituições e áreas de administração pública
X32.3 Exposição à luz solar ­ área para a prática de esportes e atletismo
X32.4 Exposição à luz solar ­ rua e estrada
X32.5 Exposição à luz solar ­ áreas de comércio e de serviços
X32.6 Exposição à luz solar ­ áreas industriais e em construção
X32.7 Exposição à luz solar ­ fazenda
X32.8 Exposição à luz solar ­ outros locais especificados
X32.9 Exposição à luz solar ­ local não especificado
X33.0 Vítima de raio ­ residência
X33.1 Vítima de raio ­ habitação coletiva
X33.2 Vítima de raio ­ escolas, outras instituições e áreas de administração pública
X33.3 Vítima de raio ­ área para a prática de esportes e atletismo
X33.4 Vítima de raio ­ rua e estrada
X33.5 Vítima de raio ­ áreas de comércio e de serviços
X33.6 Vítima de raio ­ áreas industriais e em construção
X33.7 Vítima de raio ­ fazenda
X33.8 Vítima de raio ­ outros locais especificados
X33.9 Vítima de raio ­ local não especificado
X34.0 Vítima de terremoto ­ residência
X34.1 Vítima de terremoto ­ habitação coletiva
X34.2 Vítima de terremoto ­ escolas, outras instituições e áreas de administração pública
X34.3 Vítima de terremoto ­ área para a prática de esportes e atletismo
X34.4 Vítima de terremoto ­ rua e estrada
X34.5 Vítima de terremoto ­ áreas de comércio e de serviços
X34.6 Vítima de terremoto ­ áreas industriais e em construção
X34.7 Vítima de terremoto ­ fazenda
X34.8 Vítima de terremoto ­ outros locais especificados
X34.9 Vítima de terremoto ­ local não especificado
X35.0 Vítima de erupção vulcânica ­ residência
X35.1 Vítima de erupção vulcânica ­ habitação coletiva
X35.2 Vítima de erupção vulcânica ­ escolas, outras instituições e áreas de administração pública
X35.3 Vítima de erupção vulcânica ­ área para a prática de esportes e atletismo
X35.4 Vítima de erupção vulcânica ­ rua e estrada
X35.5 Vítima de erupção vulcânica ­ áreas de comércio e de serviços
X35.6 Vítima de erupção vulcânica ­ áreas industriais e em construção
X35.7 Vítima de erupção vulcânica ­ fazenda
X35.8 Vítima de erupção vulcânica ­ outros locais especificados
X35.9 Vítima de erupção vulcânica ­ local não especificado
X36.0 Vítima de avalanche, desabamento de terra e outros movimentos da superfície terrestre ­
residência
X36.1 Vítima de avalanche, desabamento de terra e outros movimentos da superfície terrestre ­
habitação coletiva
X36.2 Vítima de avalanche, desabamento de terra e outros movimentos da superfície terrestre ­
escolas, outras instituições e áreas de administração pública
X36.3 Vítima de avalanche, desabamento de terra e outros movimentos da superfície terrestre ­ área
para a prática de esportes e atletismo
X36.4 Vítima de avalanche, desabamento de terra e outros movimentos da superfície terrestre ­ rua e
estrada
X36.5 Vítima de avalanche, desabamento de terra e outros movimentos da superfície terrestre ­ áreas
de comércio e de serviços
X36.6 Vítima de avalanche, desabamento de terra e outros movimentos da superfície terrestre ­ áreas
industriais e em construção
X36.7 Vítima de avalanche, desabamento de terra e outros movimentos da superfície terrestre ­
fazenda
X36.8 Vítima de avalanche, desabamento de terra e outros movimentos da superfície terrestre ­ outros
locais especificados
X36.9 Vítima de avalanche, desabamento de terra e outros movimentos da superfície terrestre ­ local
não especificado
X37.0 Vítima de tempestade cataclísmica ­ residência
X37.1 Vítima de tempestade cataclísmica ­ habitação coletiva
X37.2 Vítima de tempestade cataclísmica ­ escolas, outras instituições e áreas de administração
pública
X37.3 Vítima de tempestade cataclísmica ­ área para a prática de esportes e atletismo
X37.4 Vítima de tempestade cataclísmica ­ rua e estrada
X37.5 Vítima de tempestade cataclísmica ­ áreas de comércio e de serviços
X37.6 Vítima de tempestade cataclísmica ­ áreas industriais e em construção
X37.7 Vítima de tempestade cataclísmica ­ fazenda
X37.8 Vítima de tempestade cataclísmica ­ outros locais especificados
X37.9 Vítima de tempestade cataclísmica ­ local não especificado
X38.0 Vítima de inundação ­ residência
X38.1 Vítima de inundação ­ habitação coletiva
X38.2 Vítima de inundação ­ escolas, outras instituições e áreas de administração pública
X38.3 Vítima de inundação ­ área para a prática de esportes e atletismo
X38.4 Vítima de inundação ­ rua e estrada
X38.5 Vítima de inundação ­ áreas de comércio e de serviços
X38.6 Vítima de inundação ­ áreas industriais e em construção
X38.7 Vítima de inundação ­ fazenda
X38.8 Vítima de inundação ­ outros locais especificados
X38.9 Vítima de inundação ­ local não especificado
X39.0 Exposição a outras forças da natureza e às não especificadas ­ residência
X39.1 Exposição a outras forças da natureza e às não especificadas ­ habitação coletiva
X39.2 Exposição a outras forças da natureza e às não especificadas ­ escolas, outras instituições e
áreas de administração pública
X39.3 Exposição a outras forças da natureza e às não especificadas ­ área para a prática de esportes
e atletismo
X39.4 Exposição a outras forças da natureza e às não especificadas ­ rua e estrada
X39.5 Exposição a outras forças da natureza e às não especificadas ­ áreas de comércio e de serviços
X39.6 Exposição a outras forças da natureza e às não especificadas ­ áreas industriais e em
construção
X39.7 Exposição a outras forças da natureza e às não especificadas ­ fazenda
X39.8 Exposição a outras forças da natureza e às não especificadas ­ outros locais especificados
X39.9 Exposição a outras forças da natureza e às não especificadas ­ local não especificado
X40.0 Envenenamento [intoxicação] acidental por e exposição a analgésicos, antipiréticos e antireumáticos, não­opiáceos ­ residência
X40.1 Envenenamento [intoxicação] acidental por e exposição a analgésicos, antipiréticos e antireumáticos, não­opiáceos ­ habitação coletiva
X40.2 Envenenamento [intoxicação] acidental por e exposição a analgésicos, antipiréticos e antireumáticos, não­opiáceos ­ escolas, outras instituições e áreas de administração pública
X40.3 Envenenamento [intoxicação] acidental por e exposição a analgésicos, antipiréticos e antireumáticos, não­opiáceos ­ área para a prática de esportes e atletismo
X40.4 Envenenamento [intoxicação] acidental por e exposição a analgésicos, antipiréticos e antireumáticos, não­opiáceos ­ rua e estrada
X40.5 Envenenamento [intoxicação] acidental por e exposição a analgésicos, antipiréticos e antireumáticos, não­opiáceos ­ áreas de comércio e de serviços
X40.6 Envenenamento [intoxicação] acidental por e exposição a analgésicos, antipiréticos e antireumáticos, não­opiáceos ­ áreas industriais e em construção
X40.7 Envenenamento [intoxicação] acidental por e exposição a analgésicos, antipiréticos e antireumáticos, não­opiáceos ­ fazenda
X40.8 Envenenamento [intoxicação] acidental por e exposição a analgésicos, antipiréticos e antireumáticos, não­opiáceos ­ outros locais especificados
X40.9 Envenenamento [intoxicação] acidental por e exposição a analgésicos, antipiréticos e antireumáticos, não­opiáceos ­ local não especificado
X41.0 Envenenamento [intoxicação] acidental por e exposição a anticonvulsivantes [antiepilépticos],
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificadas em outra parte ­ residência
X41.1 Envenenamento [intoxicação] acidental por e exposição a anticonvulsivantes [antiepilépticos],
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificadas em outra parte ­ habitação
coletiva
X41.2 Envenenamento [intoxicação] acidental por e exposição a anticonvulsivantes [antiepilépticos],
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificadas em outra parte ­ escolas,
outras instituições e áreas de administração pública
X41.3 Envenenamento [intoxicação] acidental por e exposição a anticonvulsivantes [antiepilépticos],
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificadas em outra parte ­ área para a
prática de esportes e atletismo
X41.4 Envenenamento [intoxicação] acidental por e exposição a anticonvulsivantes [antiepilépticos],
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificadas em outra parte ­ rua e
estrada
X41.5 Envenenamento [intoxicação] acidental por e exposição a anticonvulsivantes [antiepilépticos],
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificadas em outra parte ­ áreas de
comércio e de serviços
X41.6 Envenenamento [intoxicação] acidental por e exposição a anticonvulsivantes [antiepilépticos],
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificadas em outra parte ­ áreas
industriais e em construção
X41.7 Envenenamento [intoxicação] acidental por e exposição a anticonvulsivantes [antiepilépticos],
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificadas em outra parte ­ fazenda
X41.8 Envenenamento [intoxicação] acidental por e exposição a anticonvulsivantes [antiepilépticos],
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificadas em outra parte ­ outros
locais especificados
X41.9 Envenenamento [intoxicação] acidental por e exposição a anticonvulsivantes [antiepilépticos],
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificadas em outra parte ­ local não
especificado
X42.0 Envenenamento [intoxicação] acidental por e exposição a narcóticos e psicodislépticos
[alucinógenos] não classificados em outra parte ­ residência
X42.1 Envenenamento [intoxicação] acidental por e exposição a narcóticos e psicodislépticos
[alucinógenos] não classificados em outra parte ­ habitação coletiva
X42.2 Envenenamento [intoxicação] acidental por e exposição a narcóticos e psicodislépticos
[alucinógenos] não classificados em outra parte ­ escolas, outras instituições e áreas de administração
pública
X42.3 Envenenamento [intoxicação] acidental por e exposição a narcóticos e psicodislépticos
[alucinógenos] não classificados em outra parte ­ área para a prática de esportes e atletismo
X42.4 Envenenamento [intoxicação] acidental por e exposição a narcóticos e psicodislépticos
[alucinógenos] não classificados em outra parte ­ rua e estrada
X42.5 Envenenamento [intoxicação] acidental por e exposição a narcóticos e psicodislépticos
[alucinógenos] não classificados em outra parte ­ áreas de comércio e de serviços
X42.6 Envenenamento [intoxicação] acidental por e exposição a narcóticos e psicodislépticos
[alucinógenos] não classificados em outra parte ­ áreas industriais e em construção
X42.7 Envenenamento [intoxicação] acidental por e exposição a narcóticos e psicodislépticos
[alucinógenos] não classificados em outra parte ­ fazenda
X42.8 Envenenamento [intoxicação] acidental por e exposição a narcóticos e psicodislépticos
[alucinógenos] não classificados em outra parte ­ outros locais especificados
X42.9 Envenenamento [intoxicação] acidental por e exposição a narcóticos e psicodislépticos
[alucinógenos] não classificados em outra parte ­ local não especificado
X43.0 Envenenamento [intoxicação] acidental por e exposição a outras substâncias farmacológicas de
ação sobre o sistema nervoso autônomo ­ residência
X43.1 Envenenamento [intoxicação] acidental por e exposição a outras substâncias farmacológicas de
ação sobre o sistema nervoso autônomo ­ habitação coletiva
X43.2 Envenenamento [intoxicação] acidental por e exposição a outras substâncias farmacológicas de
ação sobre o sistema nervoso autônomo ­ escolas, outras instituições e áreas de administração pública
X43.3 Envenenamento [intoxicação] acidental por e exposição a outras substâncias farmacológicas de
ação sobre o sistema nervoso autônomo ­ área para a prática de esportes e atletismo
X43.4 Envenenamento [intoxicação] acidental por e exposição a outras substâncias farmacológicas de
ação sobre o sistema nervoso autônomo ­ rua e estrada
X43.5 Envenenamento [intoxicação] acidental por e exposição a outras substâncias farmacológicas de
ação sobre o sistema nervoso autônomo ­ áreas de comércio e de serviços
X43.6 Envenenamento [intoxicação] acidental por e exposição a outras substâncias farmacológicas de
ação sobre o sistema nervoso autônomo ­ áreas industriais e em construção
X43.7 Envenenamento [intoxicação] acidental por e exposição a outras substâncias farmacológicas de
ação sobre o sistema nervoso autônomo ­ fazenda
X43.8 Envenenamento [intoxicação] acidental por e exposição a outras substâncias farmacológicas de
ação sobre o sistema nervoso autônomo ­ outros locais especificados
X43.9 Envenenamento [intoxicação] acidental por e exposição a outras substâncias farmacológicas de
ação sobre o sistema nervoso autônomo ­ local não especificado
X44.0 Envenenamento [intoxicação] acidental por e exposição a outras drogas, medicamentos e
substâncias biológicas não especificadas ­ residência
X44.1 Envenenamento [intoxicação] acidental por e exposição a outras drogas, medicamentos e
substâncias biológicas não especificadas ­ habitação coletiva
X44.2 Envenenamento [intoxicação] acidental por e exposição a outras drogas, medicamentos e
substâncias biológicas não especificadas ­ escolas, outras instituições e áreas de administração
pública
X44.3 Envenenamento [intoxicação] acidental por e exposição a outras drogas, medicamentos e
substâncias biológicas não especificadas ­ área para a prática de esportes e atletismo
X44.4 Envenenamento [intoxicação] acidental por e exposição a outras drogas, medicamentos e
substâncias biológicas não especificadas ­ rua e estrada
X44.5 Envenenamento [intoxicação] acidental por e exposição a outras drogas, medicamentos e
substâncias biológicas não especificadas ­ áreas de comércio e de serviços
X44.6 Envenenamento [intoxicação] acidental por e exposição a outras drogas, medicamentos e
substâncias biológicas não especificadas ­ áreas industriais e em construção
X44.7 Envenenamento [intoxicação] acidental por e exposição a outras drogas, medicamentos e
substâncias biológicas não especificadas ­ fazenda
X44.8 Envenenamento [intoxicação] acidental por e exposição a outras drogas, medicamentos e
substâncias biológicas não especificadas ­ outros locais especificados
X44.9 Envenenamento [intoxicação] acidental por e exposição a outras drogas, medicamentos e
substâncias biológicas não especificadas ­ local não especificado
X45.0 Envenenamento [intoxicação] acidental por e exposição ao álcool ­ residência
X45.1 Envenenamento [intoxicação] acidental por e exposição ao álcool ­ habitação coletiva
X45.2 Envenenamento [intoxicação] acidental por e exposição ao álcool ­ escolas, outras instituições e
áreas de administração pública
X45.3 Envenenamento [intoxicação] acidental por e exposição ao álcool ­ área para a prática de
esportes e atletismo
X45.4 Envenenamento [intoxicação] acidental por e exposição ao álcool ­ rua e estrada
X45.5 Envenenamento [intoxicação] acidental por e exposição ao álcool ­ áreas de comércio e de
serviços
X45.6 Envenenamento [intoxicação] acidental por e exposição ao álcool ­ áreas industriais e em
construção
X45.7 Envenenamento [intoxicação] acidental por e exposição ao álcool ­ fazenda
X45.8 Envenenamento [intoxicação] acidental por e exposição ao álcool ­ outros locais especificados
X45.9 Envenenamento [intoxicação] acidental por e exposição ao álcool ­ local não especificado
X46.0 Envenenamento [intoxicação] acidental por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores ­ residência
X46.1 Envenenamento [intoxicação] acidental por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores ­ habitação coletiva
X46.2 Envenenamento [intoxicação] acidental por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores ­ escolas, outras instituições e áreas de administração pública
X46.3 Envenenamento [intoxicação] acidental por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores ­ área para a prática de esportes e atletismo
X46.4 Envenenamento [intoxicação] acidental por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores ­ rua e estrada
X46.5 Envenenamento [intoxicação] acidental por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores ­ áreas de comércio e de serviços
X46.6 Envenenamento [intoxicação] acidental por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores ­ áreas industriais e em construção
X46.7 Envenenamento [intoxicação] acidental por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores ­ fazenda
X46.8 Envenenamento [intoxicação] acidental por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores ­ outros locais especificados
X46.9 Envenenamento [intoxicação] acidental por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores ­ local não especificado
X47.0 Intoxicação acidental por e exposição a outros gases e vapores ­ residência
X47.1 Intoxicação acidental por e exposição a outros gases e vapores ­ habitação coletiva
X47.2 Intoxicação acidental por e exposição a outros gases e vapores ­ escolas, outras instituições e
áreas de administração pública
X47.3 Intoxicação acidental por e exposição a outros gases e vapores ­ área para a prática de esportes
e atletismo
X47.4 Intoxicação acidental por e exposição a outros gases e vapores ­ rua e estrada
X47.5 Intoxicação acidental por e exposição a outros gases e vapores ­ áreas de comércio e de
serviços
X47.6 Intoxicação acidental por e exposição a outros gases e vapores ­ áreas industriais e em
construção
X47.7 Intoxicação acidental por e exposição a outros gases e vapores ­ fazenda
X47.8 Intoxicação acidental por e exposição a outros gases e vapores ­ outros locais especificados
X47.9 Intoxicação acidental por e exposição a outros gases e vapores ­ local não especificado
X48.0 Envenenamento [intoxicação] acidental por e exposição a pesticidas ­ residência
X48.1 Envenenamento [intoxicação] acidental por e exposição a pesticidas ­ habitação coletiva
X48.2 Envenenamento [intoxicação] acidental por e exposição a pesticidas ­ escolas, outras
instituições e áreas de administração pública
X48.3 Envenenamento [intoxicação] acidental por e exposição a pesticidas ­ área para a prática de
esportes e atletismo
X48.4 Envenenamento [intoxicação] acidental por e exposição a pesticidas ­ rua e estrada
X48.5 Envenenamento [intoxicação] acidental por e exposição a pesticidas ­ áreas de comércio e de
serviços
X48.6 Envenenamento [intoxicação] acidental por e exposição a pesticidas ­ áreas industriais e em
construção
X48.7 Envenenamento [intoxicação] acidental por e exposição a pesticidas ­ fazenda
X48.8 Envenenamento [intoxicação] acidental por e exposição a pesticidas ­ outros locais
especificados
X48.9 Envenenamento [intoxicação] acidental por e exposição a pesticidas ­ local não especificado
X49.0 Envenenamento [intoxicação] acidental por e exposição a outras substâncias químicas nocivas e
às não especificadas ­ residência
X49.1 Envenenamento [intoxicação] acidental por e exposição a outras substâncias químicas nocivas e
às não especificadas ­ habitação coletiva
X49.2 Envenenamento [intoxicação] acidental por e exposição a outras substâncias químicas nocivas e
às não especificadas ­ escolas, outras instituições e áreas de administração pública
X49.3 Envenenamento [intoxicação] acidental por e exposição a outras substâncias químicas nocivas e
às não especificadas ­ área para a prática de esportes e atletismo
X49.4 Envenenamento [intoxicação] acidental por e exposição a outras substâncias químicas nocivas e
às não especificadas ­ rua e estrada
X49.5 Envenenamento [intoxicação] acidental por e exposição a outras substâncias químicas nocivas e
às não especificadas ­ áreas de comércio e de serviços
X49.6 Envenenamento [intoxicação] acidental por e exposição a outras substâncias químicas nocivas e
às não especificadas ­ áreas industriais e em construção
X49.7 Envenenamento [intoxicação] acidental por e exposição a outras substâncias químicas nocivas e
às não especificadas ­ fazenda
X49.8 Envenenamento [intoxicação] acidental por e exposição a outras substâncias químicas nocivas e
às não especificadas ­ outros locais especificados
X49.9 Envenenamento [intoxicação] acidental por e exposição a outras substâncias químicas nocivas e
às não especificadas ­ local não especificado
X50.0 Excesso de exercícios e movimentos vigorosos ou repetitivos ­ residência
X50.1 Excesso de exercícios e movimentos vigorosos ou repetitivos ­ habitação coletiva
X50.2 Excesso de exercícios e movimentos vigorosos ou repetitivos ­ escolas, outras instituições e
áreas de administração pública
X50.3 Excesso de exercícios e movimentos vigorosos ou repetitivos ­ área para a prática de esportes e
atletismo
X50.4 Excesso de exercícios e movimentos vigorosos ou repetitivos ­ rua e estrada
X50.5 Excesso de exercícios e movimentos vigorosos ou repetitivos ­ áreas de comércio e de serviços
X50.6 Excesso de exercícios e movimentos vigorosos ou repetitivos ­ áreas industriais e em construção
X50.7 Excesso de exercícios e movimentos vigorosos ou repetitivos ­ fazenda
X50.8 Excesso de exercícios e movimentos vigorosos ou repetitivos ­ outros locais especificados
X50.9 Excesso de exercícios e movimentos vigorosos ou repetitivos ­ local não especificado
X51.0 Viagem e movimento ­ residência
X51.1 Viagem e movimento ­ habitação coletiva
X51.2 Viagem e movimento ­ escolas, outras instituições e áreas de administração pública
X51.3 Viagem e movimento ­ área para a prática de esportes e atletismo
X51.4 Viagem e movimento ­ rua e estrada
X51.5 Viagem e movimento ­ áreas de comércio e de serviços
X51.6 Viagem e movimento ­ áreas industriais e em construção
X51.7 Viagem e movimento ­ fazenda
X51.8 Viagem e movimento ­ outros locais especificados
X51.9 Viagem e movimento ­ local não especificado
X52.0 Estadia prolongada em ambiente agravitacional ­ residência
X52.1 Estadia prolongada em ambiente agravitacional ­ habitação coletiva
X52.2 Estadia prolongada em ambiente agravitacional ­ escolas, outras instituições e áreas de
administração pública
X52.3 Estadia prolongada em ambiente agravitacional ­ área para a prática de esportes e atletismo
X52.4 Estadia prolongada em ambiente agravitacional ­ rua e estrada
X52.5 Estadia prolongada em ambiente agravitacional ­ áreas de comércio e de serviços
X52.6 Estadia prolongada em ambiente agravitacional ­ áreas industriais e em construção
X52.7 Estadia prolongada em ambiente agravitacional ­ fazenda
X52.8 Estadia prolongada em ambiente agravitacional ­ outros locais especificados
X52.9 Estadia prolongada em ambiente agravitacional ­ local não especificado
X53.0 Falta de alimento ­ residência
X53.1 Falta de alimento ­ habitação coletiva
X53.2 Falta de alimento ­ escolas, outras instituições e áreas de administração pública
X53.3 Falta de alimento ­ área para a prática de esportes e atletismo
X53.4 Falta de alimento ­ rua e estrada
X53.5 Falta de alimento ­ áreas de comércio e de serviços
X53.6 Falta de alimento ­ áreas industriais e em construção
X53.7 Falta de alimento ­ fazenda
X53.8 Falta de alimento ­ outros locais especificados
X53.9 Falta de alimento ­ local não especificado
X54.0 Falta de água ­ residência
X54.1 Falta de água ­ habitação coletiva
X54.2 Falta de água ­ escolas, outras instituições e áreas de administração pública
X54.3 Falta de água ­ área para a prática de esportes e atletismo
X54.4 Falta de água ­ rua e estrada
X54.5 Falta de água ­ áreas de comércio e de serviços
X54.6 Falta de água ­ áreas industriais e em construção
X54.7 Falta de água ­ fazenda
X54.8 Falta de água ­ outros locais especificados
X54.9 Falta de água ­ local não especificado
X57.0 Privação não especificada ­ residência
X57.1 Privação não especificada ­ habitação coletiva
X57.2 Privação não especificada ­ escolas, outras instituições e áreas de administração pública
X57.3 Privação não especificada ­ área para a prática de esportes e atletismo
X57.4 Privação não especificada ­ rua e estrada
X57.5 Privação não especificada ­ áreas de comércio e de serviços
X57.6 Privação não especificada ­ áreas industriais e em construção
X57.7 Privação não especificada ­ fazenda
X57.8 Privação não especificada ­ outros locais especificados
X57.9 Privação não especificada ­ local não especificado
X58.0 Exposição a outros fatores especificados ­ residência
X58.1 Exposição a outros fatores especificados ­ habitação coletiva
X58.2 Exposição a outros fatores especificados ­ escolas, outras instituições e áreas de administração
pública
X58.3 Exposição a outros fatores especificados ­ área para a prática de esportes e atletismo
X58.4 Exposição a outros fatores especificados ­ rua e estrada
X58.5 Exposição a outros fatores especificados ­ áreas de comércio e de serviços
X58.6 Exposição a outros fatores especificados ­ áreas industriais e em construção
X58.7 Exposição a outros fatores especificados ­ fazenda
X58.8 Exposição a outros fatores especificados ­ outros locais especificados
X58.9 Exposição a outros fatores especificados ­ local não especificado
X59.0 Exposição a fatores não especificados ­ residência
X59.1 Exposição a fatores não especificados ­ habitação coletiva
X59.2 Exposição a fatores não especificados ­ escolas, outras instituições e áreas de administração
pública
X59.3 Exposição a fatores não especificados ­ área para a prática de esportes e atletismo
X59.4 Exposição a fatores não especificados ­ rua e estrada
X59.5 Exposição a fatores não especificados ­ áreas de comércio e de serviços
X59.6 Exposição a fatores não especificados ­ áreas industriais e em construção
X59.7 Exposição a fatores não especificados ­ fazenda
X59.8 Exposição a fatores não especificados ­ outros locais especificados
X59.9 Exposição a fatores não especificados ­ local não especificado
X60.0 Auto­intoxicação por e exposição, intencional, a analgésicos, antipiréticos e anti­reumáticos,
não­opiáceos ­ residência
X60.1 Auto­intoxicação por e exposição, intencional, a analgésicos, antipiréticos e anti­reumáticos, nãoopiáceos ­ habitação coletiva
X60.2 Auto­intoxicação por e exposição, intencional, a analgésicos, antipiréticos e anti­reumáticos,
não­opiáceos ­ escolas, outras instituições e áreas de administração pública
X60.3 Auto­intoxicação por e exposição, intencional, a analgésicos, antipiréticos e anti­reumáticos,
não­opiáceos ­ área para a prática de esportes e atletismo
X60.4 Auto­intoxicação por e exposição, intencional, a analgésicos, antipiréticos e anti­reumáticos,
não­opiáceos ­ rua e estrada
X60.5 Auto­intoxicação por e exposição, intencional, a analgésicos, antipiréticos e anti­reumáticos,
não­opiáceos ­ áreas de comércio e de serviços
X60.6 Auto­intoxicação por e exposição, intencional, a analgésicos, antipiréticos e anti­reumáticos,
não­opiáceos ­ áreas industriais e em construção
X60.7 Auto­intoxicação por e exposição, intencional, a analgésicos, antipiréticos e anti­reumáticos,
não­opiáceos ­ fazenda
X60.8 Auto­intoxicação por e exposição, intencional, a analgésicos, antipiréticos e anti­reumáticos,
não­opiáceos ­ outros locais especificados
X60.9 Auto­intoxicação por e exposição, intencional, a analgésicos, antipiréticos e anti­reumáticos,
não­opiáceos ­ local não especificado
X61.0 Auto­intoxicação por e exposição, intencional, a drogas anticonvulsivantes [antiepilépticos]
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte ­ residência
X61.1 Auto­intoxicação por e exposição, intencional, a drogas anticonvulsivantes [antiepilépticos]
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte ­ habitação
coletiva
X61.2 Auto­intoxicação por e exposição, intencional, a drogas anticonvulsivantes [antiepilépticos]
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte ­ escolas,
outras instituições e áreas de administração pública
X61.3 Auto­intoxicação por e exposição, intencional, a drogas anticonvulsivantes [antiepilépticos]
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte ­ área para a
prática de esportes e atletismo
X61.4 Auto­intoxicação por e exposição, intencional, a drogas anticonvulsivantes [antiepilépticos]
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte ­ rua e
estrada
X61.5 Auto­intoxicação por e exposição, intencional, a drogas anticonvulsivantes [antiepilépticos]
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte ­ áreas de
comércio e de serviços
X61.6 Auto­intoxicação por e exposição, intencional, a drogas anticonvulsivantes [antiepilépticos]
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte ­ áreas
industriais e em construção
X61.7 Auto­intoxicação por e exposição, intencional, a drogas anticonvulsivantes [antiepilépticos]
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte ­ fazenda
X61.8 Auto­intoxicação por e exposição, intencional, a drogas anticonvulsivantes [antiepilépticos]
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte ­ outros
locais especificados
X61.9 Auto­intoxicação por e exposição, intencional, a drogas anticonvulsivantes [antiepilépticos]
sedativos, hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte ­ local não
especificado
X62.0 Auto­intoxicação por e exposição, intencional, a narcóticos e psicodislépticos [alucinógenos] não
classificados em outra parte ­ residência
X62.1 Auto­intoxicação por e exposição, intencional, a narcóticos e psicodislépticos [alucinógenos] não
classificados em outra parte ­ habitação coletiva
X62.2 Auto­intoxicação por e exposição, intencional, a narcóticos e psicodislépticos [alucinógenos] não
classificados em outra parte ­ escolas, outras instituições e áreas de administração pública
X62.3 Auto­intoxicação por e exposição, intencional, a narcóticos e psicodislépticos [alucinógenos] não
classificados em outra parte ­ área para a prática de esportes e atletismo
X62.4 Auto­intoxicação por e exposição, intencional, a narcóticos e psicodislépticos [alucinógenos] não
classificados em outra parte ­ rua e estrada
X62.5 Auto­intoxicação por e exposição, intencional, a narcóticos e psicodislépticos [alucinógenos] não
classificados em outra parte ­ áreas de comércio e de serviços
X62.6 Auto­intoxicação por e exposição, intencional, a narcóticos e psicodislépticos [alucinógenos] não
classificados em outra parte ­ áreas industriais e em construção
X62.7 Auto­intoxicação por e exposição, intencional, a narcóticos e psicodislépticos [alucinógenos] não
classificados em outra parte ­ fazenda
X62.8 Auto­intoxicação por e exposição, intencional, a narcóticos e psicodislépticos [alucinógenos] não
classificados em outra parte ­ outros locais especificados
X62.9 Auto­intoxicação por e exposição, intencional, a narcóticos e psicodislépticos [alucinógenos] não
classificados em outra parte ­ local não especificado
X63.0 Auto­intoxicação por e exposição, intencional, a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo ­ residência
X63.1 Auto­intoxicação por e exposição, intencional, a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo ­ habitação coletiva
X63.2 Auto­intoxicação por e exposição, intencional, a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo ­ escolas, outras instituições e áreas de administração pública
X63.3 Auto­intoxicação por e exposição, intencional, a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo ­ área para a prática de esportes e atletismo
X63.4 Auto­intoxicação por e exposição, intencional, a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo ­ rua e estrada
X63.5 Auto­intoxicação por e exposição, intencional, a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo ­ áreas de comércio e de serviços
X63.6 Auto­intoxicação por e exposição, intencional, a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo ­ áreas industriais e em construção
X63.7 Auto­intoxicação por e exposição, intencional, a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo ­ fazenda
X63.8 Auto­intoxicação por e exposição, intencional, a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo ­ outros locais especificados
X63.9 Auto­intoxicação por e exposição, intencional, a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo ­ local não especificado
X64.0 Auto­intoxicação por e exposição, intencional, a outras drogas, medicamentos e substâncias
biológicas e às não especificadas ­ residência
X64.1 Auto­intoxicação por e exposição, intencional, a outras drogas, medicamentos e substâncias
biológicas e às não especificadas ­ habitação coletiva
X64.2 Auto­intoxicação por e exposição, intencional, a outras drogas, medicamentos e substâncias
biológicas e às não especificadas ­ escolas, outras instituições e áreas de administração pública
X64.3 Auto­intoxicação por e exposição, intencional, a outras drogas, medicamentos e substâncias
biológicas e às não especificadas ­ área para a prática de esportes e atletismo
X64.4 Auto­intoxicação por e exposição, intencional, a outras drogas, medicamentos e substâncias
biológicas e às não especificadas ­ rua e estrada
X64.5 Auto­intoxicação por e exposição, intencional, a outras drogas, medicamentos e substâncias
biológicas e às não especificadas ­ áreas de comércio e de serviços
X64.6 Auto­intoxicação por e exposição, intencional, a outras drogas, medicamentos e substâncias
biológicas e às não especificadas ­ áreas industriais e em construção
X64.7 Auto­intoxicação por e exposição, intencional, a outras drogas, medicamentos e substâncias
biológicas e às não especificadas ­ fazenda
X64.8 Auto­intoxicação por e exposição, intencional, a outras drogas, medicamentos e substâncias
biológicas e às não especificadas ­ outros locais especificados
X64.9 Auto­intoxicação por e exposição, intencional, a outras drogas, medicamentos e substâncias
biológicas e às não especificadas ­ local não especificado
X65.0 Auto­intoxicação voluntária por álcool ­ residência
X65.1 Auto­intoxicação voluntária por álcool ­ habitação coletiva
X65.2 Auto­intoxicação voluntária por álcool ­ escolas, outras instituições e áreas de administração
pública
X65.3 Auto­intoxicação voluntária por álcool ­ área para a prática de esportes e atletismo
X65.4 Auto­intoxicação voluntária por álcool ­ rua e estrada
X65.5 Auto­intoxicação voluntária por álcool ­ áreas de comércio e de serviços
X65.6 Auto­intoxicação voluntária por álcool ­ áreas industriais e em construção
X65.7 Auto­intoxicação voluntária por álcool ­ fazenda
X65.8 Auto­intoxicação voluntária por álcool ­ outros locais especificados
X65.9 Auto­intoxicação voluntária por álcool ­ local não especificado
X66.0 Auto­intoxicação intencional por solventes orgânicos, hidrocarbonetos halogenados e seus
vapores ­ residência
X66.1 Auto­intoxicação intencional por solventes orgânicos, hidrocarbonetos halogenados e seus
vapores ­ habitação coletiva
X66.2 Auto­intoxicação intencional por solventes orgânicos, hidrocarbonetos halogenados e seus
vapores ­ escolas, outras instituições e áreas de administração pública
X66.3 Auto­intoxicação intencional por solventes orgânicos, hidrocarbonetos halogenados e seus
vapores ­ área para a prática de esportes e atletismo
X66.4 Auto­intoxicação intencional por solventes orgânicos, hidrocarbonetos halogenados e seus
vapores ­ rua e estrada
X66.5 Auto­intoxicação intencional por solventes orgânicos, hidrocarbonetos halogenados e seus
vapores ­ áreas de comércio e de serviços
X66.6 Auto­intoxicação intencional por solventes orgânicos, hidrocarbonetos halogenados e seus
vapores ­ áreas industriais e em construção
X66.7 Auto­intoxicação intencional por solventes orgânicos, hidrocarbonetos halogenados e seus
vapores ­ fazenda
X66.8 Auto­intoxicação intencional por solventes orgânicos, hidrocarbonetos halogenados e seus
vapores ­ outros locais especificados
X66.9 Auto­intoxicação intencional por solventes orgânicos, hidrocarbonetos halogenados e seus
vapores ­ local não especificado
X67.0 Auto­intoxicação intencional por outros gases e vapores ­ residência
X67.1 Auto­intoxicação intencional por outros gases e vapores ­ habitação coletiva
X67.2 Auto­intoxicação intencional por outros gases e vapores ­ escolas, outras instituições e áreas de
administração pública
X67.3 Auto­intoxicação intencional por outros gases e vapores ­ área para a prática de esportes e
atletismo
X67.4 Auto­intoxicação intencional por outros gases e vapores ­ rua e estrada
X67.5 Auto­intoxicação intencional por outros gases e vapores ­ áreas de comércio e de serviços
X67.6 Auto­intoxicação intencional por outros gases e vapores ­ áreas industriais e em construção
X67.7 Auto­intoxicação intencional por outros gases e vapores ­ fazenda
X67.8 Auto­intoxicação intencional por outros gases e vapores ­ outros locais especificados
X67.9 Auto­intoxicação intencional por outros gases e vapores ­ local não especificado
X68.0 Auto­intoxicação por e exposição, intencional, a pesticidas ­ residência
X68.1 Auto­intoxicação por e exposição, intencional, a pesticidas ­ habitação coletiva
X68.2 Auto­intoxicação por e exposição, intencional, a pesticidas ­ escolas, outras instituições e áreas
de administração pública
X68.3 Auto­intoxicação por e exposição, intencional, a pesticidas ­ área para a prática de esportes e
atletismo
X68.4 Auto­intoxicação por e exposição, intencional, a pesticidas ­ rua e estrada
X68.5 Auto­intoxicação por e exposição, intencional, a pesticidas ­ áreas de comércio e de serviços
X68.6 Auto­intoxicação por e exposição, intencional, a pesticidas ­ áreas industriais e em construção
X68.7 Auto­intoxicação por e exposição, intencional, a pesticidas ­ fazenda
X68.8 Auto­intoxicação por e exposição, intencional, a pesticidas ­ outros locais especificados
X68.9 Auto­intoxicação por e exposição, intencional, a pesticidas ­ local não especificado
X69.0 Auto­intoxicação por e exposição, intencional, a outros produtos químicos e substâncias nocivas
não especificadas ­ residência
X69.1 Auto­intoxicação por e exposição, intencional, a outros produtos químicos e substâncias nocivas
não especificadas ­ habitação coletiva
X69.2 Auto­intoxicação por e exposição, intencional, a outros produtos químicos e substâncias nocivas
não especificadas ­ escolas, outras instituições e áreas de administração pública
X69.3 Auto­intoxicação por e exposição, intencional, a outros produtos químicos e substâncias nocivas
não especificadas ­ área para a prática de esportes e atletismo
X69.4 Auto­intoxicação por e exposição, intencional, a outros produtos químicos e substâncias nocivas
não especificadas ­ rua e estrada
X69.5 Auto­intoxicação por e exposição, intencional, a outros produtos químicos e substâncias nocivas
não especificadas ­ áreas de comércio e de serviços
X69.6 Auto­intoxicação por e exposição, intencional, a outros produtos químicos e substâncias nocivas
não especificadas ­ áreas industriais e em construção
X69.7 Auto­intoxicação por e exposição, intencional, a outros produtos químicos e substâncias nocivas
não especificadas ­ fazenda
X69.8 Auto­intoxicação por e exposição, intencional, a outros produtos químicos e substâncias nocivas
não especificadas ­ outros locais especificados
X69.9 Auto­intoxicação por e exposição, intencional, a outros produtos químicos e substâncias nocivas
não especificadas ­ local não especificado
X70.0 Lesão autoprovocada intencionalmente por enforcamento, estrangulamento e sufocação ­
residência
X70.1 Lesão autoprovocada intencionalmente por enforcamento, estrangulamento e sufocação ­
habitação coletiva
X70.2 Lesão autoprovocada intencionalmente por enforcamento, estrangulamento e sufocação ­
escolas, outras instituições e áreas de administração pública
X70.3 Lesão autoprovocada intencionalmente por enforcamento, estrangulamento e sufocação ­ área
para a prática de esportes e atletismo
X70.4 Lesão autoprovocada intencionalmente por enforcamento, estrangulamento e sufocação ­ rua e
estrada
X70.5 Lesão autoprovocada intencionalmente por enforcamento, estrangulamento e sufocação ­ áreas
de comércio e de serviços
X70.6 Lesão autoprovocada intencionalmente por enforcamento, estrangulamento e sufocação ­ áreas
industriais e em construção
X70.7 Lesão autoprovocada intencionalmente por enforcamento, estrangulamento e sufocação ­
fazenda
X70.8 Lesão autoprovocada intencionalmente por enforcamento, estrangulamento e sufocação ­ outros
locais especificados
X70.9 Lesão autoprovocada intencionalmente por enforcamento, estrangulamento e sufocação ­ local
não especificado
X71.0 Lesão autoprovocada intencionalmente por afogamento e submersão ­ residência
X71.1 Lesão autoprovocada intencionalmente por afogamento e submersão ­ habitação coletiva
X71.2 Lesão autoprovocada intencionalmente por afogamento e submersão ­ escolas, outras
instituições e áreas de administração pública
X71.3 Lesão autoprovocada intencionalmente por afogamento e submersão ­ área para a prática de
esportes e atletismo
X71.4 Lesão autoprovocada intencionalmente por afogamento e submersão ­ rua e estrada
X71.5 Lesão autoprovocada intencionalmente por afogamento e submersão ­ áreas de comércio e de
serviços
X71.6 Lesão autoprovocada intencionalmente por afogamento e submersão ­ áreas industriais e em
construção
X71.7 Lesão autoprovocada intencionalmente por afogamento e submersão ­ fazenda
X71.8 Lesão autoprovocada intencionalmente por afogamento e submersão ­ outros locais
especificados
X71.9 Lesão autoprovocada intencionalmente por afogamento e submersão ­ local não especificado
X72.0 Lesão autoprovocada intencionalmente por disparo de arma de fogo de mão ­ residência
X72.1 Lesão autoprovocada intencionalmente por disparo de arma de fogo de mão ­ habitação coletiva
X72.2 Lesão autoprovocada intencionalmente por disparo de arma de fogo de mão ­ escolas, outras
instituições e áreas de administração pública
X72.3 Lesão autoprovocada intencionalmente por disparo de arma de fogo de mão ­ área para a
prática de esportes e atletismo
X72.4 Lesão autoprovocada intencionalmente por disparo de arma de fogo de mão ­ rua e estrada
X72.5 Lesão autoprovocada intencionalmente por disparo de arma de fogo de mão ­ áreas de comércio
e de serviços
X72.6 Lesão autoprovocada intencionalmente por disparo de arma de fogo de mão ­ áreas industriais e
em construção
X72.7 Lesão autoprovocada intencionalmente por disparo de arma de fogo de mão ­ fazenda
X72.8 Lesão autoprovocada intencionalmente por disparo de arma de fogo de mão ­ outros locais
especificados
X72.9 Lesão autoprovocada intencionalmente por disparo de arma de fogo de mão ­ local não
especificado
X73.0 Lesão autoprovocada intencionalmente por disparo de espingarda, carabina, ou arma de fogo de
maior calibre ­ residência
X73.1 Lesão autoprovocada intencionalmente por disparo de espingarda, carabina, ou arma de fogo de
maior calibre ­ habitação coletiva
X73.2 Lesão autoprovocada intencionalmente por disparo de espingarda, carabina, ou arma de fogo de
maior calibre ­ escolas, outras instituições e áreas de administração pública
X73.3 Lesão autoprovocada intencionalmente por disparo de espingarda, carabina, ou arma de fogo de
maior calibre ­ área para a prática de esportes e atletismo
X73.4 Lesão autoprovocada intencionalmente por disparo de espingarda, carabina, ou arma de fogo de
maior calibre ­ rua e estrada
X73.5 Lesão autoprovocada intencionalmente por disparo de espingarda, carabina, ou arma de fogo de
maior calibre ­ áreas de comércio e de serviços
X73.6 Lesão autoprovocada intencionalmente por disparo de espingarda, carabina, ou arma de fogo de
maior calibre ­ áreas industriais e em construção
X73.7 Lesão autoprovocada intencionalmente por disparo de espingarda, carabina, ou arma de fogo de
maior calibre ­ fazenda
X73.8 Lesão autoprovocada intencionalmente por disparo de espingarda, carabina, ou arma de fogo de
maior calibre ­ outros locais especificados
X73.9 Lesão autoprovocada intencionalmente por disparo de espingarda, carabina, ou arma de fogo de
maior calibre ­ local não especificado
X74.0 Lesão autoprovocada intencionalmente por disparo de outra arma de fogo e de arma de fogo
não especificada ­ residência
X74.1 Lesão autoprovocada intencionalmente por disparo de outra arma de fogo e de arma de fogo não
especificada ­ habitação coletiva
X74.2 Lesão autoprovocada intencionalmente por disparo de outra arma de fogo e de arma de fogo
não especificada ­ escolas, outras instituições e áreas de administração pública
X74.3 Lesão autoprovocada intencionalmente por disparo de outra arma de fogo e de arma de fogo
não especificada ­ área para a prática de esportes e atletismo
X74.4 Lesão autoprovocada intencionalmente por disparo de outra arma de fogo e de arma de fogo
não especificada ­ rua e estrada
X74.5 Lesão autoprovocada intencionalmente por disparo de outra arma de fogo e de arma de fogo
não especificada ­ áreas de comércio e de serviços
X74.6 Lesão autoprovocada intencionalmente por disparo de outra arma de fogo e de arma de fogo
não especificada ­ áreas industriais e em construção
X74.7 Lesão autoprovocada intencionalmente por disparo de outra arma de fogo e de arma de fogo
não especificada ­ fazenda
X74.8 Lesão autoprovocada intencionalmente por disparo de outra arma de fogo e de arma de fogo
não especificada ­ outros locais especificados
X74.9 Lesão autoprovocada intencionalmente por disparo de outra arma de fogo e de arma de fogo
não especificada ­ local não especificado
X75.0 Lesão autoprovocada intencionalmente por dispositivos explosivos ­ residência
X75.1 Lesão autoprovocada intencionalmente por dispositivos explosivos ­ habitação coletiva
X75.2 Lesão autoprovocada intencionalmente por dispositivos explosivos ­ escolas, outras instituições
e áreas de administração pública
X75.3 Lesão autoprovocada intencionalmente por dispositivos explosivos ­ área para a prática de
esportes e atletismo
X75.4 Lesão autoprovocada intencionalmente por dispositivos explosivos ­ rua e estrada
X75.5 Lesão autoprovocada intencionalmente por dispositivos explosivos ­ áreas de comércio e de
serviços
X75.6 Lesão autoprovocada intencionalmente por dispositivos explosivos ­ áreas industriais e em
construção
X75.7 Lesão autoprovocada intencionalmente por dispositivos explosivos ­ fazenda
X75.8 Lesão autoprovocada intencionalmente por dispositivos explosivos ­ outros locais especificados
X75.9 Lesão autoprovocada intencionalmente por dispositivos explosivos ­ local não especificado
X76.0 Lesão autoprovocada intencionalmente pela fumaça, pelo fogo e por chamas ­ residência
X76.1 Lesão autoprovocada intencionalmente pela fumaça, pelo fogo e por chamas ­ habitação coletiva
X76.2 Lesão autoprovocada intencionalmente pela fumaça, pelo fogo e por chamas ­ escolas, outras
instituições e áreas de administração pública
X76.3 Lesão autoprovocada intencionalmente pela fumaça, pelo fogo e por chamas ­ área para a
prática de esportes e atletismo
X76.4 Lesão autoprovocada intencionalmente pela fumaça, pelo fogo e por chamas ­ rua e estrada
X76.5 Lesão autoprovocada intencionalmente pela fumaça, pelo fogo e por chamas ­ áreas de
comércio e de serviços
X76.6 Lesão autoprovocada intencionalmente pela fumaça, pelo fogo e por chamas ­ áreas industriais
e em construção
X76.7 Lesão autoprovocada intencionalmente pela fumaça, pelo fogo e por chamas ­ fazenda
X76.8 Lesão autoprovocada intencionalmente pela fumaça, pelo fogo e por chamas ­ outros locais
especificados
X76.9 Lesão autoprovocada intencionalmente pela fumaça, pelo fogo e por chamas ­ local não
especificado
X77.0 Lesão autoprovocada intencionalmente por vapor de água, gases ou objetos quentes ­
residência
X77.1 Lesão autoprovocada intencionalmente por vapor de água, gases ou objetos quentes ­ habitação
coletiva
X77.2 Lesão autoprovocada intencionalmente por vapor de água, gases ou objetos quentes ­ escolas,
outras instituições e áreas de administração pública
X77.3 Lesão autoprovocada intencionalmente por vapor de água, gases ou objetos quentes ­ área para
a prática de esportes e atletismo
X77.4 Lesão autoprovocada intencionalmente por vapor de água, gases ou objetos quentes ­ rua e
estrada
X77.5 Lesão autoprovocada intencionalmente por vapor de água, gases ou objetos quentes ­ áreas de
comércio e de serviços
X77.6 Lesão autoprovocada intencionalmente por vapor de água, gases ou objetos quentes ­ áreas
industriais e em construção
X77.7 Lesão autoprovocada intencionalmente por vapor de água, gases ou objetos quentes ­ fazenda
X77.8 Lesão autoprovocada intencionalmente por vapor de água, gases ou objetos quentes ­ outros
locais especificados
X77.9 Lesão autoprovocada intencionalmente por vapor de água, gases ou objetos quentes ­ local não
especificado
X78.0 Lesão autoprovocada intencionalmente por objeto cortante ou penetrante ­ residência
X78.1 Lesão autoprovocada intencionalmente por objeto cortante ou penetrante ­ habitação coletiva
X78.2 Lesão autoprovocada intencionalmente por objeto cortante ou penetrante ­ escolas, outras
instituições e áreas de administração pública
X78.3 Lesão autoprovocada intencionalmente por objeto cortante ou penetrante ­ área para a prática
de esportes e atletismo
X78.4 Lesão autoprovocada intencionalmente por objeto cortante ou penetrante ­ rua e estrada
X78.5 Lesão autoprovocada intencionalmente por objeto cortante ou penetrante ­ áreas de comércio e
de serviços
X78.6 Lesão autoprovocada intencionalmente por objeto cortante ou penetrante ­ áreas industriais e
em construção
X78.7 Lesão autoprovocada intencionalmente por objeto cortante ou penetrante ­ fazenda
X78.8 Lesão autoprovocada intencionalmente por objeto cortante ou penetrante ­ outros locais
especificados
X78.9 Lesão autoprovocada intencionalmente por objeto cortante ou penetrante ­ local não
especificado
X79.0 Lesão autoprovocada intencionalmente por objeto contundente ­ residência
X79.1 Lesão autoprovocada intencionalmente por objeto contundente ­ habitação coletiva
X79.2 Lesão autoprovocada intencionalmente por objeto contundente ­ escolas, outras instituições e
áreas de administração pública
X79.3 Lesão autoprovocada intencionalmente por objeto contundente ­ área para a prática de esportes
e atletismo
X79.4 Lesão autoprovocada intencionalmente por objeto contundente ­ rua e estrada
X79.5 Lesão autoprovocada intencionalmente por objeto contundente ­ áreas de comércio e de
serviços
X79.6 Lesão autoprovocada intencionalmente por objeto contundente ­ áreas industriais e em
construção
X79.7 Lesão autoprovocada intencionalmente por objeto contundente ­ fazenda
X79.8 Lesão autoprovocada intencionalmente por objeto contundente ­ outros locais especificados
X79.9 Lesão autoprovocada intencionalmente por objeto contundente ­ local não especificado
X80.0 Lesão autoprovocada intencionalmente por precipitação de um lugar elevado ­ residência
X80.1 Lesão autoprovocada intencionalmente por precipitação de um lugar elevado ­ habitação coletiva
X80.2 Lesão autoprovocada intencionalmente por precipitação de um lugar elevado ­ escolas, outras
instituições e áreas de administração pública
X80.3 Lesão autoprovocada intencionalmente por precipitação de um lugar elevado ­ área para a
prática de esportes e atletismo
X80.4 Lesão autoprovocada intencionalmente por precipitação de um lugar elevado ­ rua e estrada
X80.5 Lesão autoprovocada intencionalmente por precipitação de um lugar elevado ­ áreas de
comércio e de serviços
X80.6 Lesão autoprovocada intencionalmente por precipitação de um lugar elevado ­ áreas industriais
e em construção
X80.7 Lesão autoprovocada intencionalmente por precipitação de um lugar elevado ­ fazenda
X80.8 Lesão autoprovocada intencionalmente por precipitação de um lugar elevado ­ outros locais
especificados
X80.9 Lesão autoprovocada intencionalmente por precipitação de um lugar elevado ­ local não
especificado
X81.0 Lesão autoprovocada intencionalmente por precipitação ou permanência diante de um objeto em
movimento ­ residência
X81.1 Lesão autoprovocada intencionalmente por precipitação ou permanência diante de um objeto em
movimento ­ habitação coletiva
X81.2 Lesão autoprovocada intencionalmente por precipitação ou permanência diante de um objeto em
movimento ­ escolas, outras instituições e áreas de administração pública
X81.3 Lesão autoprovocada intencionalmente por precipitação ou permanência diante de um objeto em
movimento ­ área para a prática de esportes e atletismo
X81.4 Lesão autoprovocada intencionalmente por precipitação ou permanência diante de um objeto em
movimento ­ rua e estrada
X81.5 Lesão autoprovocada intencionalmente por precipitação ou permanência diante de um objeto em
movimento ­ áreas de comércio e de serviços
X81.6 Lesão autoprovocada intencionalmente por precipitação ou permanência diante de um objeto em
movimento ­ áreas industriais e em construção
X81.7 Lesão autoprovocada intencionalmente por precipitação ou permanência diante de um objeto em
movimento ­ fazenda
X81.8 Lesão autoprovocada intencionalmente por precipitação ou permanência diante de um objeto em
movimento ­ outros locais especificados
X81.9 Lesão autoprovocada intencionalmente por precipitação ou permanência diante de um objeto em
movimento ­ local não especificado
X82.0 Lesão autoprovocada intencionalmente por impacto de um veículo a motor ­ residência
X82.1 Lesão autoprovocada intencionalmente por impacto de um veículo a motor ­ habitação coletiva
X82.2 Lesão autoprovocada intencionalmente por impacto de um veículo a motor ­ escolas, outras
instituições e áreas de administração pública
X82.3 Lesão autoprovocada intencionalmente por impacto de um veículo a motor ­ área para a prática
de esportes e atletismo
X82.4 Lesão autoprovocada intencionalmente por impacto de um veículo a motor ­ rua e estrada
X82.5 Lesão autoprovocada intencionalmente por impacto de um veículo a motor ­ áreas de comércio e
de serviços
X82.6 Lesão autoprovocada intencionalmente por impacto de um veículo a motor ­ áreas industriais e
em construção
X82.7 Lesão autoprovocada intencionalmente por impacto de um veículo a motor ­ fazenda
X82.8 Lesão autoprovocada intencionalmente por impacto de um veículo a motor ­ outros locais
especificados
X82.9 Lesão autoprovocada intencionalmente por impacto de um veículo a motor ­ local não
especificado
X83.0 Lesão autoprovocada intencionalmente por outros meios especificados ­ residência
X83.1 Lesão autoprovocada intencionalmente por outros meios especificados ­ habitação coletiva
X83.2 Lesão autoprovocada intencionalmente por outros meios especificados ­ escolas, outras
instituições e áreas de administração pública
X83.3 Lesão autoprovocada intencionalmente por outros meios especificados ­ área para a prática de
esportes e atletismo
X83.4 Lesão autoprovocada intencionalmente por outros meios especificados ­ rua e estrada
X83.5 Lesão autoprovocada intencionalmente por outros meios especificados ­ áreas de comércio e de
serviços
X83.6 Lesão autoprovocada intencionalmente por outros meios especificados ­ áreas industriais e em
construção
X83.7 Lesão autoprovocada intencionalmente por outros meios especificados ­ fazenda
X83.8 Lesão autoprovocada intencionalmente por outros meios especificados ­ outros locais
especificados
X83.9 Lesão autoprovocada intencionalmente por outros meios especificados ­ local não especificado
X84.0 Lesão autoprovocada intencionalmente por meios não especificados ­ residência
X84.1 Lesão autoprovocada intencionalmente por meios não especificados ­ habitação coletiva
X84.2 Lesão autoprovocada intencionalmente por meios não especificados ­ escolas, outras
instituições e áreas de administração pública
X84.3 Lesão autoprovocada intencionalmente por meios não especificados ­ área para a prática de
esportes e atletismo
X84.4 Lesão autoprovocada intencionalmente por meios não especificados ­ rua e estrada
X84.5 Lesão autoprovocada intencionalmente por meios não especificados ­ áreas de comércio e de
serviços
X84.6 Lesão autoprovocada intencionalmente por meios não especificados ­ áreas industriais e em
construção
X84.7 Lesão autoprovocada intencionalmente por meios não especificados ­ fazenda
X84.8 Lesão autoprovocada intencionalmente por meios não especificados ­ outros locais
especificados
X84.9 Lesão autoprovocada intencionalmente por meios não especificados ­ local não especificado
X85.0 Agressão por meio de drogas, medicamentos e substâncias biológicas ­ residência
X85.1 Agressão por meio de drogas, medicamentos e substâncias biológicas ­ habitação coletiva
X85.2 Agressão por meio de drogas, medicamentos e substâncias biológicas ­ escolas, outras
instituições e áreas de administração pública
X85.3 Agressão por meio de drogas, medicamentos e substâncias biológicas ­ área para a prática de
esportes e atletismo
X85.4 Agressão por meio de drogas, medicamentos e substâncias biológicas ­ rua e estrada
X85.5 Agressão por meio de drogas, medicamentos e substâncias biológicas ­ áreas de comércio e de
serviços
X85.6 Agressão por meio de drogas, medicamentos e substâncias biológicas ­ áreas industriais e em
construção
X85.7 Agressão por meio de drogas, medicamentos e substâncias biológicas ­ fazenda
X85.8 Agressão por meio de drogas, medicamentos e substâncias biológicas ­ outros locais
especificados
X85.9 Agressão por meio de drogas, medicamentos e substâncias biológicas ­ local não especificado
X86.0 Agressão por meio de substâncias corrosivas ­ residência
X86.1 Agressão por meio de substâncias corrosivas ­ habitação coletiva
X86.2 Agressão por meio de substâncias corrosivas ­ escolas, outras instituições e áreas de
administração pública
X86.3 Agressão por meio de substâncias corrosivas ­ área para a prática de esportes e atletismo
X86.4 Agressão por meio de substâncias corrosivas ­ rua e estrada
X86.5 Agressão por meio de substâncias corrosivas ­ áreas de comércio e de serviços
X86.6 Agressão por meio de substâncias corrosivas ­ áreas industriais e em construção
X86.7 Agressão por meio de substâncias corrosivas ­ fazenda
X86.8 Agressão por meio de substâncias corrosivas ­ outros locais especificados
X86.9 Agressão por meio de substâncias corrosivas ­ local não especificado
X87.0 Agressão por pesticidas ­ residência
X87.1 Agressão por pesticidas ­ habitação coletiva
X87.2 Agressão por pesticidas ­ escolas, outras instituições e áreas de administração pública
X87.3 Agressão por pesticidas ­ área para a prática de esportes e atletismo
X87.4 Agressão por pesticidas ­ rua e estrada
X87.5 Agressão por pesticidas ­ áreas de comércio e de serviços
X87.6 Agressão por pesticidas ­ áreas industriais e em construção
X87.7 Agressão por pesticidas ­ fazenda
X87.8 Agressão por pesticidas ­ outros locais especificados
X87.9 Agressão por pesticidas ­ local não especificado
X88.0 Agressão por meio de gases e vapores ­ residência
X88.1 Agressão por meio de gases e vapores ­ habitação coletiva
X88.2 Agressão por meio de gases e vapores ­ escolas, outras instituições e áreas de administração
pública
X88.3 Agressão por meio de gases e vapores ­ área para a prática de esportes e atletismo
X88.4 Agressão por meio de gases e vapores ­ rua e estrada
X88.5 Agressão por meio de gases e vapores ­ áreas de comércio e de serviços
X88.6 Agressão por meio de gases e vapores ­ áreas industriais e em construção
X88.7 Agressão por meio de gases e vapores ­ fazenda
X88.8 Agressão por meio de gases e vapores ­ outros locais especificados
X88.9 Agressão por meio de gases e vapores ­ local não especificado
X89.0 Agressão por meio de outros produtos químicos e substâncias nocivas especificados ­
residência
X89.1 Agressão por meio de outros produtos químicos e substâncias nocivas especificados ­ habitação
coletiva
X89.2 Agressão por meio de outros produtos químicos e substâncias nocivas especificados ­ escolas,
outras instituições e áreas de administração pública
X89.3 Agressão por meio de outros produtos químicos e substâncias nocivas especificados ­ área para
a prática de esportes e atletismo
X89.4 Agressão por meio de outros produtos químicos e substâncias nocivas especificados ­ rua e
estrada
X89.5 Agressão por meio de outros produtos químicos e substâncias nocivas especificados ­ áreas de
comércio e de serviços
X89.6 Agressão por meio de outros produtos químicos e substâncias nocivas especificados ­ áreas
industriais e em construção
X89.7 Agressão por meio de outros produtos químicos e substâncias nocivas especificados ­ fazenda
X89.8 Agressão por meio de outros produtos químicos e substâncias nocivas especificados ­ outros
locais especificados
X89.9 Agressão por meio de outros produtos químicos e substâncias nocivas especificados ­ local não
especificado
X90.0 Agressão por meio de produtos químicos e substâncias nocivas não especificados ­ residência
X90.1 Agressão por meio de produtos químicos e substâncias nocivas não especificados ­ habitação
coletiva
X90.2 Agressão por meio de produtos químicos e substâncias nocivas não especificados ­ escolas,
outras instituições e áreas de administração pública
X90.3 Agressão por meio de produtos químicos e substâncias nocivas não especificados ­ área para a
prática de esportes e atletismo
X90.4 Agressão por meio de produtos químicos e substâncias nocivas não especificados ­ rua e
estrada
X90.5 Agressão por meio de produtos químicos e substâncias nocivas não especificados ­ áreas de
comércio e de serviços
X90.6 Agressão por meio de produtos químicos e substâncias nocivas não especificados ­ áreas
industriais e em construção
X90.7 Agressão por meio de produtos químicos e substâncias nocivas não especificados ­ fazenda
X90.8 Agressão por meio de produtos químicos e substâncias nocivas não especificados ­ outros
locais especificados
X90.9 Agressão por meio de produtos químicos e substâncias nocivas não especificados ­ local não
especificado
X91.0 Agressão por meio de enforcamento, estrangulamento e sufocação ­ residência
X91.1 Agressão por meio de enforcamento, estrangulamento e sufocação ­ habitação coletiva
X91.2 Agressão por meio de enforcamento, estrangulamento e sufocação ­ escolas, outras instituições
e áreas de administração pública
X91.3 Agressão por meio de enforcamento, estrangulamento e sufocação ­ área para a prática de
esportes e atletismo
X91.4 Agressão por meio de enforcamento, estrangulamento e sufocação ­ rua e estrada
X91.5 Agressão por meio de enforcamento, estrangulamento e sufocação ­ áreas de comércio e de
serviços
X91.6 Agressão por meio de enforcamento, estrangulamento e sufocação ­ áreas industriais e em
construção
X91.7 Agressão por meio de enforcamento, estrangulamento e sufocação ­ fazenda
X91.8 Agressão por meio de enforcamento, estrangulamento e sufocação ­ outros locais especificados
X91.9 Agressão por meio de enforcamento, estrangulamento e sufocação ­ local não especificado
X92.0 Agressão por meio de afogamento e submersão ­ residência
X92.1 Agressão por meio de afogamento e submersão ­ habitação coletiva
X92.2 Agressão por meio de afogamento e submersão ­ escolas, outras instituições e áreas de
administração pública
X92.3 Agressão por meio de afogamento e submersão ­ área para a prática de esportes e atletismo
X92.4 Agressão por meio de afogamento e submersão ­ rua e estrada
X92.5 Agressão por meio de afogamento e submersão ­ áreas de comércio e de serviços
X92.6 Agressão por meio de afogamento e submersão ­ áreas industriais e em construção
X92.7 Agressão por meio de afogamento e submersão ­ fazenda
X92.8 Agressão por meio de afogamento e submersão ­ outros locais especificados
X92.9 Agressão por meio de afogamento e submersão ­ local não especificado
X93.0 Agressão por meio de disparo de arma de fogo de mão ­ residência
X93.1 Agressão por meio de disparo de arma de fogo de mão ­ habitação coletiva
X93.2 Agressão por meio de disparo de arma de fogo de mão ­ escolas, outras instituições e áreas de
administração pública
X93.3 Agressão por meio de disparo de arma de fogo de mão ­ área para a prática de esportes e
atletismo
X93.4 Agressão por meio de disparo de arma de fogo de mão ­ rua e estrada
X93.5 Agressão por meio de disparo de arma de fogo de mão ­ áreas de comércio e de serviços
X93.6 Agressão por meio de disparo de arma de fogo de mão ­ áreas industriais e em construção
X93.7 Agressão por meio de disparo de arma de fogo de mão ­ fazenda
X93.8 Agressão por meio de disparo de arma de fogo de mão ­ outros locais especificados
X93.9 Agressão por meio de disparo de arma de fogo de mão ­ local não especificado
X94.0 Agressão por meio de disparo de espingarda, carabina ou arma de fogo de maior calibre ­
residência
X94.1 Agressão por meio de disparo de espingarda, carabina ou arma de fogo de maior calibre ­
habitação coletiva
X94.2 Agressão por meio de disparo de espingarda, carabina ou arma de fogo de maior calibre ­
escolas, outras instituições e áreas de administração pública
X94.3 Agressão por meio de disparo de espingarda, carabina ou arma de fogo de maior calibre ­ área
para a prática de esportes e atletismo
X94.4 Agressão por meio de disparo de espingarda, carabina ou arma de fogo de maior calibre ­ rua e
estrada
X94.5 Agressão por meio de disparo de espingarda, carabina ou arma de fogo de maior calibre ­ áreas
de comércio e de serviços
X94.6 Agressão por meio de disparo de espingarda, carabina ou arma de fogo de maior calibre ­ áreas
industriais e em construção
X94.7 Agressão por meio de disparo de espingarda, carabina ou arma de fogo de maior calibre ­
fazenda
X94.8 Agressão por meio de disparo de espingarda, carabina ou arma de fogo de maior calibre ­ outros
locais especificados
X94.9 Agressão por meio de disparo de espingarda, carabina ou arma de fogo de maior calibre ­ local
não especificado
X95.0 Agressão por meio de disparo de outra arma de fogo ou de arma não especificada ­ residência
X95.1 Agressão por meio de disparo de outra arma de fogo ou de arma não especificada ­ habitação
coletiva
X95.2 Agressão por meio de disparo de outra arma de fogo ou de arma não especificada ­ escolas,
outras instituições e áreas de administração pública
X95.3 Agressão por meio de disparo de outra arma de fogo ou de arma não especificada ­ área para a
prática de esportes e atletismo
X95.4 Agressão por meio de disparo de outra arma de fogo ou de arma não especificada ­ rua e
estrada
X95.5 Agressão por meio de disparo de outra arma de fogo ou de arma não especificada ­ áreas de
comércio e de serviços
X95.6 Agressão por meio de disparo de outra arma de fogo ou de arma não especificada ­ áreas
industriais e em construção
X95.7 Agressão por meio de disparo de outra arma de fogo ou de arma não especificada ­ fazenda
X95.8 Agressão por meio de disparo de outra arma de fogo ou de arma não especificada ­ outros
locais especificados
X95.9 Agressão por meio de disparo de outra arma de fogo ou de arma não especificada ­ local não
especificado
X96.0 Agressão por meio de material explosivo ­ residência
X96.1 Agressão por meio de material explosivo ­ habitação coletiva
X96.2 Agressão por meio de material explosivo ­ escolas, outras instituições e áreas de administração
pública
X96.3 Agressão por meio de material explosivo ­ área para a prática de esportes e atletismo
X96.4 Agressão por meio de material explosivo ­ rua e estrada
X96.5 Agressão por meio de material explosivo ­ áreas de comércio e de serviços
X96.6 Agressão por meio de material explosivo ­ áreas industriais e em construção
X96.7 Agressão por meio de material explosivo ­ fazenda
X96.8 Agressão por meio de material explosivo ­ outros locais especificados
X96.9 Agressão por meio de material explosivo ­ local não especificado
X97.0 Agressão por meio de fumaça, fogo e chamas ­ residência
X97.1 Agressão por meio de fumaça, fogo e chamas ­ habitação coletiva
X97.2 Agressão por meio de fumaça, fogo e chamas ­ escolas, outras instituições e áreas de
administração pública
X97.3 Agressão por meio de fumaça, fogo e chamas ­ área para a prática de esportes e atletismo
X97.4 Agressão por meio de fumaça, fogo e chamas ­ rua e estrada
X97.5 Agressão por meio de fumaça, fogo e chamas ­ áreas de comércio e de serviços
X97.6 Agressão por meio de fumaça, fogo e chamas ­ áreas industriais e em construção
X97.7 Agressão por meio de fumaça, fogo e chamas ­ fazenda
X97.8 Agressão por meio de fumaça, fogo e chamas ­ outros locais especificados
X97.9 Agressão por meio de fumaça, fogo e chamas ­ local não especificado
X98.0 Agressão por meio de vapor de água, gases ou objetos quentes ­ residência
X98.1 Agressão por meio de vapor de água, gases ou objetos quentes ­ habitação coletiva
X98.2 Agressão por meio de vapor de água, gases ou objetos quentes ­ escolas, outras instituições e
áreas de administração pública
X98.3 Agressão por meio de vapor de água, gases ou objetos quentes ­ área para a prática de
esportes e atletismo
X98.4 Agressão por meio de vapor de água, gases ou objetos quentes ­ rua e estrada
X98.5 Agressão por meio de vapor de água, gases ou objetos quentes ­ áreas de comércio e de
serviços
X98.6 Agressão por meio de vapor de água, gases ou objetos quentes ­ áreas industriais e em
construção
X98.7 Agressão por meio de vapor de água, gases ou objetos quentes ­ fazenda
X98.8 Agressão por meio de vapor de água, gases ou objetos quentes ­ outros locais especificados
X98.9 Agressão por meio de vapor de água, gases ou objetos quentes ­ local não especificado
X99.0 Agressão por meio de objeto cortante ou penetrante ­ residência
X99.1 Agressão por meio de objeto cortante ou penetrante ­ habitação coletiva
X99.2 Agressão por meio de objeto cortante ou penetrante ­ escolas, outras instituições e áreas de
administração pública
X99.3 Agressão por meio de objeto cortante ou penetrante ­ área para a prática de esportes e atletismo
X99.4 Agressão por meio de objeto cortante ou penetrante ­ rua e estrada
X99.5 Agressão por meio de objeto cortante ou penetrante ­ áreas de comércio e de serviços
X99.6 Agressão por meio de objeto cortante ou penetrante ­ áreas industriais e em construção
X99.7 Agressão por meio de objeto cortante ou penetrante ­ fazenda
X99.8 Agressão por meio de objeto cortante ou penetrante ­ outros locais especificados
X99.9 Agressão por meio de objeto cortante ou penetrante ­ local não especificado
Y00.0 Agressão por meio de um objeto contundente ­ residência
Y00.1 Agressão por meio de um objeto contundente ­ habitação coletiva
Y00.2 Agressão por meio de um objeto contundente ­ escolas, outras instituições e áreas de
administração pública
Y00.3 Agressão por meio de um objeto contundente ­ área para a prática de esportes e atletismo
Y00.4 Agressão por meio de um objeto contundente ­ rua e estrada
Y00.5 Agressão por meio de um objeto contundente ­ áreas de comércio e de serviços
Y00.6 Agressão por meio de um objeto contundente ­ áreas industriais e em construção
Y00.7 Agressão por meio de um objeto contundente ­ fazenda
Y00.8 Agressão por meio de um objeto contundente ­ outros locais especificados
Y00.9 Agressão por meio de um objeto contundente ­ local não especificado
Y01.0 Agressão por meio de projeção de um lugar elevado ­ residência
Y01.1 Agressão por meio de projeção de um lugar elevado ­ habitação coletiva
Y01.2 Agressão por meio de projeção de um lugar elevado ­ escolas, outras instituições e áreas de
administração pública
Y01.3 Agressão por meio de projeção de um lugar elevado ­ área para a prática de esportes e atletismo
Y01.4 Agressão por meio de projeção de um lugar elevado ­ rua e estrada
Y01.5 Agressão por meio de projeção de um lugar elevado ­ áreas de comércio e de serviços
Y01.6 Agressão por meio de projeção de um lugar elevado ­ áreas industriais e em construção
Y01.7 Agressão por meio de projeção de um lugar elevado ­ fazenda
Y01.8 Agressão por meio de projeção de um lugar elevado ­ outros locais especificados
Y01.9 Agressão por meio de projeção de um lugar elevado ­ local não especificado
Y02.0 Agressão por meio de projeção ou colocação da vítima diante de um objeto em movimento ­
residência
Y02.1 Agressão por meio de projeção ou colocação da vítima diante de um objeto em movimento ­
habitação coletiva
Y02.2 Agressão por meio de projeção ou colocação da vítima diante de um objeto em movimento ­
escolas, outras instituições e áreas de administração pública
Y02.3 Agressão por meio de projeção ou colocação da vítima diante de um objeto em movimento ­
área para a prática de esportes e atletismo
Y02.4 Agressão por meio de projeção ou colocação da vítima diante de um objeto em movimento ­ rua
e estrada
Y02.5 Agressão por meio de projeção ou colocação da vítima diante de um objeto em movimento ­
áreas de comércio e de serviços
Y02.6 Agressão por meio de projeção ou colocação da vítima diante de um objeto em movimento ­
áreas industriais e em construção
Y02.7 Agressão por meio de projeção ou colocação da vítima diante de um objeto em movimento ­
fazenda
Y02.8 Agressão por meio de projeção ou colocação da vítima diante de um objeto em movimento ­
outros locais especificados
Y02.9 Agressão por meio de projeção ou colocação da vítima diante de um objeto em movimento ­
local não especificado
Y03.0 Agressão por meio de impacto de um veículo a motor ­ residência
Y03.1 Agressão por meio de impacto de um veículo a motor ­ habitação coletiva
Y03.2 Agressão por meio de impacto de um veículo a motor ­ escolas, outras instituições e áreas de
administração pública
Y03.3 Agressão por meio de impacto de um veículo a motor ­ área para a prática de esportes e
atletismo
Y03.4 Agressão por meio de impacto de um veículo a motor ­ rua e estrada
Y03.5 Agressão por meio de impacto de um veículo a motor ­ áreas de comércio e de serviços
Y03.6 Agressão por meio de impacto de um veículo a motor ­ áreas industriais e em construção
Y03.7 Agressão por meio de impacto de um veículo a motor ­ fazenda
Y03.8 Agressão por meio de impacto de um veículo a motor ­ outros locais especificados
Y03.9 Agressão por meio de impacto de um veículo a motor ­ local não especificado
Y04.0 Agressão por meio de força corporal ­ residência
Y04.1 Agressão por meio de força corporal ­ habitação coletiva
Y04.2 Agressão por meio de força corporal ­ escolas, outras instituições e áreas de administração
pública
Y04.3 Agressão por meio de força corporal ­ área para a prática de esportes e atletismo
Y04.4 Agressão por meio de força corporal ­ rua e estrada
Y04.5 Agressão por meio de força corporal ­ áreas de comércio e de serviços
Y04.6 Agressão por meio de força corporal ­ áreas industriais e em construção
Y04.7 Agressão por meio de força corporal ­ fazenda
Y04.8 Agressão por meio de força corporal ­ outros locais especificados
Y04.9 Agressão por meio de força corporal ­ local não especificado
Y05.0 Agressão sexual por meio de força física ­ residência
Y05.1 Agressão sexual por meio de força física ­ habitação coletiva
Y05.2 Agressão sexual por meio de força física ­ escolas, outras instituições e áreas de administração
pública
Y05.3 Agressão sexual por meio de força física ­ área para a prática de esportes e atletismo
Y05.4 Agressão sexual por meio de força física ­ rua e estrada
Y05.5 Agressão sexual por meio de força física ­ áreas de comércio e de serviços
Y05.6 Agressão sexual por meio de força física ­ áreas industriais e em construção
Y05.7 Agressão sexual por meio de força física ­ fazenda
Y05.8 Agressão sexual por meio de força física ­ outros locais especificados
Y05.9 Agressão sexual por meio de força física ­ local não especificado
Y06.0 Negligência e abandono pelo esposo ou companheiro
Y06.1 Negligência e abandono pelos pais
Y06.2 Negligência e abandono por conhecido ou amigo
Y06.8 Negligência e abandono por outra pessoa especificada
Y06.9 Negligência e abandono por pessoa não especificada
Y07.0 Outras síndromes de maus tratos pelo esposo ou companheiro
Y07.1 Outras síndromes de maus tratos pelos pais
Y07.2 Outras síndromes de maus tratos por conhecido ou amigo
Y07.3 Outras síndromes de maus tratos por autoridades oficiais
Y07.8 Outras síndromes de maus tratos por outra pessoa especificada
Y07.9 Outras síndromes de maus tratos por pessoa não especificada
Y08.0 Agressão por outros meios especificados ­ residência
Y08.1 Agressão por outros meios especificados ­ habitação coletiva
Y08.2 Agressão por outros meios especificados ­ escolas, outras instituições e áreas de administração
pública
Y08.3 Agressão por outros meios especificados ­ área para a prática de esportes e atletismo
Y08.4 Agressão por outros meios especificados ­ rua e estrada
Y08.5 Agressão por outros meios especificados ­ áreas de comércio e de serviços
Y08.6 Agressão por outros meios especificados ­ áreas industriais e em construção
Y08.7 Agressão por outros meios especificados ­ fazenda
Y08.8 Agressão por outros meios especificados ­ outros locais especificados
Y08.9 Agressão por outros meios especificados ­ local não especificado
Y09.0 Agressão por meios não especificados ­ residência
Y09.1 Agressão por meios não especificados ­ habitação coletiva
Y09.2 Agressão por meios não especificados ­ escolas, outras instituições e áreas de administração
pública
Y09.3 Agressão por meios não especificados ­ área para a prática de esportes e atletismo
Y09.4 Agressão por meios não especificados ­ rua e estrada
Y09.5 Agressão por meios não especificados ­ áreas de comércio e de serviços
Y09.6 Agressão por meios não especificados ­ áreas industriais e em construção
Y09.7 Agressão por meios não especificados ­ fazenda
Y09.8 Agressão por meios não especificados ­ outros locais especificados
Y09.9 Agressão por meios não especificados ­ local não especificado
Y10.0 Envenenamento [intoxicação] por e exposição a analgésicos, antipiréticos e anti­reumáticos nãoopiáceos, intenção não determinada ­ residência
Y10.1 Envenenamento [intoxicação] por e exposição a analgésicos, antipiréticos e anti­reumáticos nãoopiáceos, intenção não determinada ­ habitação coletiva
Y10.2 Envenenamento [intoxicação] por e exposição a analgésicos, antipiréticos e anti­reumáticos nãoopiáceos, intenção não determinada ­ escolas, outras instituições e áreas de administração pública
Y10.3 Envenenamento [intoxicação] por e exposição a analgésicos, antipiréticos e anti­reumáticos nãoopiáceos, intenção não determinada ­ área para a prática de esportes e atletismo
Y10.4 Envenenamento [intoxicação] por e exposição a analgésicos, antipiréticos e anti­reumáticos nãoopiáceos, intenção não determinada ­ rua e estrada
Y10.5 Envenenamento [intoxicação] por e exposição a analgésicos, antipiréticos e anti­reumáticos nãoopiáceos, intenção não determinada ­ áreas de comércio e de serviços
Y10.6 Envenenamento [intoxicação] por e exposição a analgésicos, antipiréticos e anti­reumáticos nãoopiáceos, intenção não determinada ­ áreas industriais e em construção
Y10.7 Envenenamento [intoxicação] por e exposição a analgésicos, antipiréticos e anti­reumáticos nãoopiáceos, intenção não determinada ­ fazenda
Y10.8 Envenenamento [intoxicação] por e exposição a analgésicos, antipiréticos e anti­reumáticos nãoopiáceos, intenção não determinada ­ outros locais especificados
Y10.9 Envenenamento [intoxicação] por e exposição a analgésicos, antipiréticos e anti­reumáticos nãoopiáceos, intenção não determinada ­ local não especificado
Y11.0 Envenenamento [intoxicação] por e exposição a anticonvulsivantes [antiepilépticos], sedativos,
hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte, intenção não
determinada ­ residência
Y11.1 Envenenamento [intoxicação] por e exposição a anticonvulsivantes [antiepilépticos], sedativos,
hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte, intenção não
determinada ­ habitação coletiva
Y11.2 Envenenamento [intoxicação] por e exposição a anticonvulsivantes [antiepilépticos], sedativos,
hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte, intenção não
determinada ­ escolas, outras instituições e áreas de administração pública
Y11.3 Envenenamento [intoxicação] por e exposição a anticonvulsivantes [antiepilépticos], sedativos,
hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte, intenção não
determinada ­ área para a prática de esportes e atletismo
Y11.4 Envenenamento [intoxicação] por e exposição a anticonvulsivantes [antiepilépticos], sedativos,
hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte, intenção não
determinada ­ rua e estrada
Y11.5 Envenenamento [intoxicação] por e exposição a anticonvulsivantes [antiepilépticos], sedativos,
hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte, intenção não
determinada ­ áreas de comércio e de serviços
Y11.6 Envenenamento [intoxicação] por e exposição a anticonvulsivantes [antiepilépticos], sedativos,
hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte, intenção não
determinada ­ áreas industriais e em construção
Y11.7 Envenenamento [intoxicação] por e exposição a anticonvulsivantes [antiepilépticos], sedativos,
hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte, intenção não
determinada ­ fazenda
Y11.8 Envenenamento [intoxicação] por e exposição a anticonvulsivantes [antiepilépticos], sedativos,
hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte, intenção não
determinada ­ outros locais especificados
Y11.9 Envenenamento [intoxicação] por e exposição a anticonvulsivantes [antiepilépticos], sedativos,
hipnóticos, antiparkinsonianos e psicotrópicos não classificados em outra parte, intenção não
determinada ­ local não especificado
Y12.0 Envenenamento [intoxicação] por e exposição a narcóticos e a psicodislépticos [alucinógenos]
não classificados em outra parte, intenção não determinada ­ residência
Y12.1 Envenenamento [intoxicação] por e exposição a narcóticos e a psicodislépticos [alucinógenos]
não classificados em outra parte, intenção não determinada ­ habitação coletiva
Y12.2 Envenenamento [intoxicação] por e exposição a narcóticos e a psicodislépticos [alucinógenos]
não classificados em outra parte, intenção não determinada ­ escolas, outras instituições e áreas de
administração pública
Y12.3 Envenenamento [intoxicação] por e exposição a narcóticos e a psicodislépticos [alucinógenos]
não classificados em outra parte, intenção não determinada ­ área para a prática de esportes e
atletismo
Y12.4 Envenenamento [intoxicação] por e exposição a narcóticos e a psicodislépticos [alucinógenos]
não classificados em outra parte, intenção não determinada ­ rua e estrada
Y12.5 Envenenamento [intoxicação] por e exposição a narcóticos e a psicodislépticos [alucinógenos]
não classificados em outra parte, intenção não determinada ­ áreas de comércio e de serviços
Y12.6 Envenenamento [intoxicação] por e exposição a narcóticos e a psicodislépticos [alucinógenos]
não classificados em outra parte, intenção não determinada ­ áreas industriais e em construção
Y12.7 Envenenamento [intoxicação] por e exposição a narcóticos e a psicodislépticos [alucinógenos]
não classificados em outra parte, intenção não determinada ­ fazenda
Y12.8 Envenenamento [intoxicação] por e exposição a narcóticos e a psicodislépticos [alucinógenos]
não classificados em outra parte, intenção não determinada ­ outros locais especificados
Y12.9 Envenenamento [intoxicação] por e exposição a narcóticos e a psicodislépticos [alucinógenos]
não classificados em outra parte, intenção não determinada ­ local não especificado
Y13.0 Envenenamento [intoxicação] por e exposição a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo, intenção não determinada ­ residência
Y13.1 Envenenamento [intoxicação] por e exposição a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo, intenção não determinada ­ habitação coletiva
Y13.2 Envenenamento [intoxicação] por e exposição a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo, intenção não determinada ­ escolas, outras instituições e áreas de
administração pública
Y13.3 Envenenamento [intoxicação] por e exposição a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo, intenção não determinada ­ área para a prática de esportes e
atletismo
Y13.4 Envenenamento [intoxicação] por e exposição a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo, intenção não determinada ­ rua e estrada
Y13.5 Envenenamento [intoxicação] por e exposição a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo, intenção não determinada ­ áreas de comércio e de serviços
Y13.6 Envenenamento [intoxicação] por e exposição a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo, intenção não determinada ­ áreas industriais e em construção
Y13.7 Envenenamento [intoxicação] por e exposição a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo, intenção não determinada ­ fazenda
Y13.8 Envenenamento [intoxicação] por e exposição a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo, intenção não determinada ­ outros locais especificados
Y13.9 Envenenamento [intoxicação] por e exposição a outras substâncias farmacológicas de ação
sobre o sistema nervoso autônomo, intenção não determinada ­ local não especificado
Y14.0 Envenenamento [intoxicação] por e exposição a outras drogas, medicamentos e substâncias
biológicas e as não especificadas, intenção não determinada ­ residência
Y14.1 Envenenamento [intoxicação] por e exposição a outras drogas, medicamentos e substâncias
biológicas e as não especificadas, intenção não determinada ­ habitação coletiva
Y14.2 Envenenamento [intoxicação] por e exposição a outras drogas, medicamentos e substâncias
biológicas e as não especificadas, intenção não determinada ­ escolas, outras instituições e áreas de
administração pública
Y14.3 Envenenamento [intoxicação] por e exposição a outras drogas, medicamentos e substâncias
biológicas e as não especificadas, intenção não determinada ­ área para a prática de esportes e
atletismo
Y14.4 Envenenamento [intoxicação] por e exposição a outras drogas, medicamentos e substâncias
biológicas e as não especificadas, intenção não determinada ­ rua e estrada
Y14.5 Envenenamento [intoxicação] por e exposição a outras drogas, medicamentos e substâncias
biológicas e as não especificadas, intenção não determinada ­ áreas de comércio e de serviços
Y14.6 Envenenamento [intoxicação] por e exposição a outras drogas, medicamentos e substâncias
biológicas e as não especificadas, intenção não determinada ­ áreas industriais e em construção
Y14.7 Envenenamento [intoxicação] por e exposição a outras drogas, medicamentos e substâncias
biológicas e as não especificadas, intenção não determinada ­ fazenda
Y14.8 Envenenamento [intoxicação] por e exposição a outras drogas, medicamentos e substâncias
biológicas e as não especificadas, intenção não determinada ­ outros locais especificados
Y14.9 Envenenamento [intoxicação] por e exposição a outras drogas, medicamentos e substâncias
biológicas e as não especificadas, intenção não determinada ­ local não especificado
Y15.0 Envenenamento [intoxicação] por e exposição ao álcool, intenção não determinada ­ residência
Y15.1 Envenenamento [intoxicação] por e exposição ao álcool, intenção não determinada ­ habitação
coletiva
Y15.2 Envenenamento [intoxicação] por e exposição ao álcool, intenção não determinada ­ escolas,
outras instituições e áreas de administração pública
Y15.3 Envenenamento [intoxicação] por e exposição ao álcool, intenção não determinada ­ área para a
prática de esportes e atletismo
Y15.4 Envenenamento [intoxicação] por e exposição ao álcool, intenção não determinada ­ rua e
estrada
Y15.5 Envenenamento [intoxicação] por e exposição ao álcool, intenção não determinada ­ áreas de
comércio e de serviços
Y15.6 Envenenamento [intoxicação] por e exposição ao álcool, intenção não determinada ­ áreas
industriais e em construção
Y15.7 Envenenamento [intoxicação] por e exposição ao álcool, intenção não determinada ­ fazenda
Y15.8 Envenenamento [intoxicação] por e exposição ao álcool, intenção não determinada ­ outros
locais especificados
Y15.9 Envenenamento [intoxicação] por e exposição ao álcool, intenção não determinada ­ local não
especificado
Y16.0 Envenenamento [intoxicação] por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores, intenção não determinada ­ residência
Y16.1 Envenenamento [intoxicação] por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores, intenção não determinada ­ habitação coletiva
Y16.2 Envenenamento [intoxicação] por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores, intenção não determinada ­ escolas, outras instituições e áreas de
administração pública
Y16.3 Envenenamento [intoxicação] por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores, intenção não determinada ­ área para a prática de esportes e atletismo
Y16.4 Envenenamento [intoxicação] por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores, intenção não determinada ­ rua e estrada
Y16.5 Envenenamento [intoxicação] por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores, intenção não determinada ­ áreas de comércio e de serviços
Y16.6 Envenenamento [intoxicação] por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores, intenção não determinada ­ áreas industriais e em construção
Y16.7 Envenenamento [intoxicação] por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores, intenção não determinada ­ fazenda
Y16.8 Envenenamento [intoxicação] por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores, intenção não determinada ­ outros locais especificados
Y16.9 Envenenamento [intoxicação] por e exposição a solventes orgânicos e hidrocarbonetos
halogenados e seus vapores, intenção não determinada ­ local não especificado
Y17.0 Envenenamento [intoxicação] por e exposição a outros gases e vapores, intenção não
determinada ­ residência
Y17.1 Envenenamento [intoxicação] por e exposição a outros gases e vapores, intenção não
determinada ­ habitação coletiva
Y17.2 Envenenamento [intoxicação] por e exposição a outros gases e vapores, intenção não
determinada ­ escolas, outras instituições e áreas de administração pública
Y17.3 Envenenamento [intoxicação] por e exposição a outros gases e vapores, intenção não
determinada ­ área para a prática de esportes e atletismo
Y17.4 Envenenamento [intoxicação] por e exposição a outros gases e vapores, intenção não
determinada ­ rua e estrada
Y17.5 Envenenamento [intoxicação] por e exposição a outros gases e vapores, intenção não
determinada ­ áreas de comércio e de serviços
Y17.6 Envenenamento [intoxicação] por e exposição a outros gases e vapores, intenção não
determinada ­ áreas industriais e em construção
Y17.7 Envenenamento [intoxicação] por e exposição a outros gases e vapores, intenção não
determinada ­ fazenda
Y17.8 Envenenamento [intoxicação] por e exposição a outros gases e vapores, intenção não
determinada ­ outros locais especificados
Y17.9 Envenenamento [intoxicação] por e exposição a outros gases e vapores, intenção não
determinada ­ local não especificado
Y18.0 Envenenamento [intoxicação] por e exposição a pesticidas, intenção não determinada ­
residência
Y18.1 Envenenamento [intoxicação] por e exposição a pesticidas, intenção não determinada ­
habitação coletiva
Y18.2 Envenenamento [intoxicação] por e exposição a pesticidas, intenção não determinada ­ escolas,
outras instituições e áreas de administração pública
Y18.3 Envenenamento [intoxicação] por e exposição a pesticidas, intenção não determinada ­ área
para a prática de esportes e atletismo
Y18.4 Envenenamento [intoxicação] por e exposição a pesticidas, intenção não determinada ­ rua e
estrada
Y18.5 Envenenamento [intoxicação] por e exposição a pesticidas, intenção não determinada ­ áreas de
comércio e de serviços
Y18.6 Envenenamento [intoxicação] por e exposição a pesticidas, intenção não determinada ­ áreas
industriais e em construção
Y18.7 Envenenamento [intoxicação] por e exposição a pesticidas, intenção não determinada ­ fazenda
Y18.8 Envenenamento [intoxicação] por e exposição a pesticidas, intenção não determinada ­ outros
locais especificados
Y18.9 Envenenamento [intoxicação] por e exposição a pesticidas, intenção não determinada ­ local não
especificado
Y19.0 Envenenamento [intoxicação] por e exposição a outros produtos químicos e substâncias nocivas
e aos não especificados, intenção não determinada ­ residência
Y19.1 Envenenamento [intoxicação] por e exposição a outros produtos químicos e substâncias nocivas
e aos não especificados, intenção não determinada ­ habitação coletiva
Y19.2 Envenenamento [intoxicação] por e exposição a outros produtos químicos e substâncias nocivas
e aos não especificados, intenção não determinada ­ escolas, outras instituições e áreas de
administração pública
Y19.3 Envenenamento [intoxicação] por e exposição a outros produtos químicos e substâncias nocivas
e aos não especificados, intenção não determinada ­ área para a prática de esportes e atletismo
Y19.4 Envenenamento [intoxicação] por e exposição a outros produtos químicos e substâncias nocivas
e aos não especificados, intenção não determinada ­ rua e estrada
Y19.5 Envenenamento [intoxicação] por e exposição a outros produtos químicos e substâncias nocivas
e aos não especificados, intenção não determinada ­ áreas de comércio e de serviços
Y19.6 Envenenamento [intoxicação] por e exposição a outros produtos químicos e substâncias nocivas
e aos não especificados, intenção não determinada ­ áreas industriais e em construção
Y19.7 Envenenamento [intoxicação] por e exposição a outros produtos químicos e substâncias nocivas
e aos não especificados, intenção não determinada ­ fazenda
Y19.8 Envenenamento [intoxicação] por e exposição a outros produtos químicos e substâncias nocivas
e aos não especificados, intenção não determinada ­ outros locais especificados
Y19.9 Envenenamento [intoxicação] por e exposição a outros produtos químicos e substâncias nocivas
e aos não especificados, intenção não determinada ­ local não especificado
Y20.0 Enforcamento, estrangulamento e sufocação, intenção não determinada ­ residência
Y20.1 Enforcamento, estrangulamento e sufocação, intenção não determinada ­ habitação coletiva
Y20.2 Enforcamento, estrangulamento e sufocação, intenção não determinada ­ escolas, outras
instituições e áreas de administração pública
Y20.3 Enforcamento, estrangulamento e sufocação, intenção não determinada ­ área para a prática de
esportes e atletismo
Y20.4 Enforcamento, estrangulamento e sufocação, intenção não determinada ­ rua e estrada
Y20.5 Enforcamento, estrangulamento e sufocação, intenção não determinada ­ áreas de comércio e
de serviços
Y20.6 Enforcamento, estrangulamento e sufocação, intenção não determinada ­ áreas industriais e em
construção
Y20.7 Enforcamento, estrangulamento e sufocação, intenção não determinada ­ fazenda
Y20.8 Enforcamento, estrangulamento e sufocação, intenção não determinada ­ outros locais
especificados
Y20.9 Enforcamento, estrangulamento e sufocação, intenção não determinada ­ local não especificado
Y21.0 Afogamento e submersão, intenção não determinada ­ residência
Y21.1 Afogamento e submersão, intenção não determinada ­ habitação coletiva
Y21.2 Afogamento e submersão, intenção não determinada ­ escolas, outras instituições e áreas de
administração pública
Y21.3 Afogamento e submersão, intenção não determinada ­ área para a prática de esportes e
atletismo
Y21.4 Afogamento e submersão, intenção não determinada ­ rua e estrada
Y21.5 Afogamento e submersão, intenção não determinada ­ áreas de comércio e de serviços
Y21.6 Afogamento e submersão, intenção não determinada ­ áreas industriais e em construção
Y21.7 Afogamento e submersão, intenção não determinada ­ fazenda
Y21.8 Afogamento e submersão, intenção não determinada ­ outros locais especificados
Y21.9 Afogamento e submersão, intenção não determinada ­ local não especificado
Y22.0 Disparo de pistola, intenção não determinada ­ residência
Y22.1 Disparo de pistola, intenção não determinada ­ habitação coletiva
Y22.2 Disparo de pistola, intenção não determinada ­ escolas, outras instituições e áreas de
administração pública
Y22.3 Disparo de pistola, intenção não determinada ­ área para a prática de esportes e atletismo
Y22.4 Disparo de pistola, intenção não determinada ­ rua e estrada
Y22.5 Disparo de pistola, intenção não determinada ­ áreas de comércio e de serviços
Y22.6 Disparo de pistola, intenção não determinada ­ áreas industriais e em construção
Y22.7 Disparo de pistola, intenção não determinada ­ fazenda
Y22.8 Disparo de pistola, intenção não determinada ­ outros locais especificados
Y22.9 Disparo de pistola, intenção não determinada ­ local não especificado
Y23.0 Disparo de fuzil, carabina e arma de fogo de maior calibre, intenção não determinada ­
residência
Y23.1 Disparo de fuzil, carabina e arma de fogo de maior calibre, intenção não determinada ­ habitação
coletiva
Y23.2 Disparo de fuzil, carabina e arma de fogo de maior calibre, intenção não determinada ­ escolas,
outras instituições e áreas de administração pública
Y23.3 Disparo de fuzil, carabina e arma de fogo de maior calibre, intenção não determinada ­ área para
a prática de esportes e atletismo
Y23.4 Disparo de fuzil, carabina e arma de fogo de maior calibre, intenção não determinada ­ rua e
estrada
Y23.5 Disparo de fuzil, carabina e arma de fogo de maior calibre, intenção não determinada ­ áreas de
comércio e de serviços
Y23.6 Disparo de fuzil, carabina e arma de fogo de maior calibre, intenção não determinada ­ áreas
industriais e em construção
Y23.7 Disparo de fuzil, carabina e arma de fogo de maior calibre, intenção não determinada ­ fazenda
Y23.8 Disparo de fuzil, carabina e arma de fogo de maior calibre, intenção não determinada ­ outros
locais especificados
Y23.9 Disparo de fuzil, carabina e arma de fogo de maior calibre, intenção não determinada ­ local não
especificado
Y24.0 Disparo de outra arma de fogo e de arma de fogo não especificada, intenção não determinada ­
residência
Y24.1 Disparo de outra arma de fogo e de arma de fogo não especificada, intenção não determinada ­
habitação coletiva
Y24.2 Disparo de outra arma de fogo e de arma de fogo não especificada, intenção não determinada ­
escolas, outras instituições e áreas de administração pública
Y24.3 Disparo de outra arma de fogo e de arma de fogo não especificada, intenção não determinada ­
área para a prática de esportes e atletismo
Y24.4 Disparo de outra arma de fogo e de arma de fogo não especificada, intenção não determinada ­
rua e estrada
Y24.5 Disparo de outra arma de fogo e de arma de fogo não especificada, intenção não determinada ­
áreas de comércio e de serviços
Y24.6 Disparo de outra arma de fogo e de arma de fogo não especificada, intenção não determinada ­
áreas industriais e em construção
Y24.7 Disparo de outra arma de fogo e de arma de fogo não especificada, intenção não determinada ­
fazenda
Y24.8 Disparo de outra arma de fogo e de arma de fogo não especificada, intenção não determinada ­
outros locais especificados
Y24.9 Disparo de outra arma de fogo e de arma de fogo não especificada, intenção não determinada ­
local não especificado
Y25.0 Contato com material explosivo, intenção não determinada ­ residência
Y25.1 Contato com material explosivo, intenção não determinada ­ habitação coletiva
Y25.2 Contato com material explosivo, intenção não determinada ­ escolas, outras instituições e áreas
de administração pública
Y25.3 Contato com material explosivo, intenção não determinada ­ área para a prática de esportes e
atletismo
Y25.4 Contato com material explosivo, intenção não determinada ­ rua e estrada
Y25.5 Contato com material explosivo, intenção não determinada ­ áreas de comércio e de serviços
Y25.6 Contato com material explosivo, intenção não determinada ­ áreas industriais e em construção
Y25.7 Contato com material explosivo, intenção não determinada ­ fazenda
Y25.8 Contato com material explosivo, intenção não determinada ­ outros locais especificados
Y25.9 Contato com material explosivo, intenção não determinada ­ local não especificado
Y26.0 Exposição a fumaça, fogo e chamas, intenção não determinada ­ residência
Y26.1 Exposição a fumaça, fogo e chamas, intenção não determinada ­ habitação coletiva
Y26.2 Exposição a fumaça, fogo e chamas, intenção não determinada ­ escolas, outras instituições e
áreas de administração pública
Y26.3 Exposição a fumaça, fogo e chamas, intenção não determinada ­ área para a prática de esportes
e atletismo
Y26.4 Exposição a fumaça, fogo e chamas, intenção não determinada ­ rua e estrada
Y26.5 Exposição a fumaça, fogo e chamas, intenção não determinada ­ áreas de comércio e de
serviços
Y26.6 Exposição a fumaça, fogo e chamas, intenção não determinada ­ áreas industriais e em
construção
Y26.7 Exposição a fumaça, fogo e chamas, intenção não determinada ­ fazenda
Y26.8 Exposição a fumaça, fogo e chamas, intenção não determinada ­ outros locais especificados
Y26.9 Exposição a fumaça, fogo e chamas, intenção não determinada ­ local não especificado
Y27.0 Exposição a vapor de água, gases ou objetos quentes, intenção não determinada ­ residência
Y27.1 Exposição a vapor de água, gases ou objetos quentes, intenção não determinada ­ habitação
coletiva
Y27.2 Exposição a vapor de água, gases ou objetos quentes, intenção não determinada ­ escolas,
outras instituições e áreas de administração pública
Y27.3 Exposição a vapor de água, gases ou objetos quentes, intenção não determinada ­ área para a
prática de esportes e atletismo
Y27.4 Exposição a vapor de água, gases ou objetos quentes, intenção não determinada ­ rua e estrada
Y27.5 Exposição a vapor de água, gases ou objetos quentes, intenção não determinada ­ áreas de
comércio e de serviços
Y27.6 Exposição a vapor de água, gases ou objetos quentes, intenção não determinada ­ áreas
industriais e em construção
Y27.7 Exposição a vapor de água, gases ou objetos quentes, intenção não determinada ­ fazenda
Y27.8 Exposição a vapor de água, gases ou objetos quentes, intenção não determinada ­ outros locais
especificados
Y27.9 Exposição a vapor de água, gases ou objetos quentes, intenção não determinada ­ local não
especificado
Y28.0 Contato com objeto cortante ou penetrante, intenção não determinada ­ residência
Y28.1 Contato com objeto cortante ou penetrante, intenção não determinada ­ habitação coletiva
Y28.2 Contato com objeto cortante ou penetrante, intenção não determinada ­ escolas, outras
instituições e áreas de administração pública
Y28.3 Contato com objeto cortante ou penetrante, intenção não determinada ­ área para a prática de
esportes e atletismo
Y28.4 Contato com objeto cortante ou penetrante, intenção não determinada ­ rua e estrada
Y28.5 Contato com objeto cortante ou penetrante, intenção não determinada ­ áreas de comércio e de
serviços
Y28.6 Contato com objeto cortante ou penetrante, intenção não determinada ­ áreas industriais e em
construção
Y28.7 Contato com objeto cortante ou penetrante, intenção não determinada ­ fazenda
Y28.8 Contato com objeto cortante ou penetrante, intenção não determinada ­ outros locais
especificados
Y28.9 Contato com objeto cortante ou penetrante, intenção não determinada ­ local não especificado
Y29.0 Contato com objeto contundente, intenção não determinada ­ residência
Y29.1 Contato com objeto contundente, intenção não determinada ­ habitação coletiva
Y29.2 Contato com objeto contundente, intenção não determinada ­ escolas, outras instituições e áreas
de administração pública
Y29.3 Contato com objeto contundente, intenção não determinada ­ área para a prática de esportes e
atletismo
Y29.4 Contato com objeto contundente, intenção não determinada ­ rua e estrada
Y29.5 Contato com objeto contundente, intenção não determinada ­ áreas de comércio e de serviços
Y29.6 Contato com objeto contundente, intenção não determinada ­ áreas industriais e em construção
Y29.7 Contato com objeto contundente, intenção não determinada ­ fazenda
Y29.8 Contato com objeto contundente, intenção não determinada ­ outros locais especificados
Y29.9 Contato com objeto contundente, intenção não determinada ­ local não especificado
Y30.0 Queda, salto ou empurrado de um lugar elevado, intenção não determinada ­ residência
Y30.1 Queda, salto ou empurrado de um lugar elevado, intenção não determinada ­ habitação coletiva
Y30.2 Queda, salto ou empurrado de um lugar elevado, intenção não determinada ­ escolas, outras
instituições e áreas de administração pública
Y30.3 Queda, salto ou empurrado de um lugar elevado, intenção não determinada ­ área para a prática
de esportes e atletismo
Y30.4 Queda, salto ou empurrado de um lugar elevado, intenção não determinada ­ rua e estrada
Y30.5 Queda, salto ou empurrado de um lugar elevado, intenção não determinada ­ áreas de comércio
e de serviços
Y30.6 Queda, salto ou empurrado de um lugar elevado, intenção não determinada ­ áreas industriais e
em construção
Y30.7 Queda, salto ou empurrado de um lugar elevado, intenção não determinada ­ fazenda
Y30.8 Queda, salto ou empurrado de um lugar elevado, intenção não determinada ­ outros locais
especificados
Y30.9 Queda, salto ou empurrado de um lugar elevado, intenção não determinada ­ local não
especificado
Y31.0 Queda, permanência ou corrida diante de um objeto em movimento, intenção não determinada ­
residência
Y31.1 Queda, permanência ou corrida diante de um objeto em movimento, intenção não determinada ­
habitação coletiva
Y31.2 Queda, permanência ou corrida diante de um objeto em movimento, intenção não determinada ­
escolas, outras instituições e áreas de administração pública
Y31.3 Queda, permanência ou corrida diante de um objeto em movimento, intenção não determinada ­
área para a prática de esportes e atletismo
Y31.4 Queda, permanência ou corrida diante de um objeto em movimento, intenção não determinada ­
rua e estrada
Y31.5 Queda, permanência ou corrida diante de um objeto em movimento, intenção não determinada ­
áreas de comércio e de serviços
Y31.6 Queda, permanência ou corrida diante de um objeto em movimento, intenção não determinada ­
áreas industriais e em construção
Y31.7 Queda, permanência ou corrida diante de um objeto em movimento, intenção não determinada ­
fazenda
Y31.8 Queda, permanência ou corrida diante de um objeto em movimento, intenção não determinada ­
outros locais especificados
Y31.9 Queda, permanência ou corrida diante de um objeto em movimento, intenção não determinada ­
local não especificado
Y32.0 Impacto de um veículo a motor, intenção não determinada ­ residência
Y32.1 Impacto de um veículo a motor, intenção não determinada ­ habitação coletiva
Y32.2 Impacto de um veículo a motor, intenção não determinada ­ escolas, outras instituições e áreas
de administração pública
Y32.3 Impacto de um veículo a motor, intenção não determinada ­ área para a prática de esportes e
atletismo
Y32.4 Impacto de um veículo a motor, intenção não determinada ­ rua e estrada
Y32.5 Impacto de um veículo a motor, intenção não determinada ­ áreas de comércio e de serviços
Y32.6 Impacto de um veículo a motor, intenção não determinada ­ áreas industriais e em construção
Y32.7 Impacto de um veículo a motor, intenção não determinada ­ fazenda
Y32.8 Impacto de um veículo a motor, intenção não determinada ­ outros locais especificados
Y32.9 Impacto de um veículo a motor, intenção não determinada ­ local não especificado
Y33.0 Outros fatos ou eventos especificados, intenção não determinada ­ residência
Y33.1 Outros fatos ou eventos especificados, intenção não determinada ­ habitação coletiva
Y33.2 Outros fatos ou eventos especificados, intenção não determinada ­ escolas, outras instituições e
áreas de administração pública
Y33.3 Outros fatos ou eventos especificados, intenção não determinada ­ área para a prática de
esportes e atletismo
Y33.4 Outros fatos ou eventos especificados, intenção não determinada ­ rua e estrada
Y33.5 Outros fatos ou eventos especificados, intenção não determinada ­ áreas de comércio e de
serviços
Y33.6 Outros fatos ou eventos especificados, intenção não determinada ­ áreas industriais e em
construção
Y33.7 Outros fatos ou eventos especificados, intenção não determinada ­ fazenda
Y33.8 Outros fatos ou eventos especificados, intenção não determinada ­ outros locais especificados
Y33.9 Outros fatos ou eventos especificados, intenção não determinada ­ local não especificado
Y34.0 Fatos ou eventos não especificados e intenção não determinada ­ residência
Y34.1 Fatos ou eventos não especificados e intenção não determinada ­ habitação coletiva
Y34.2 Fatos ou eventos não especificados e intenção não determinada ­ escolas, outras instituições e
áreas de administração pública
Y34.3 Fatos ou eventos não especificados e intenção não determinada ­ área para a prática de
esportes e atletismo
Y34.4 Fatos ou eventos não especificados e intenção não determinada ­ rua e estrada
Y34.5 Fatos ou eventos não especificados e intenção não determinada ­ áreas de comércio e de
serviços
Y34.6 Fatos ou eventos não especificados e intenção não determinada ­ áreas industriais e em
construção
Y34.7 Fatos ou eventos não especificados e intenção não determinada ­ fazenda
Y34.8 Fatos ou eventos não especificados e intenção não determinada ­ outros locais especificados
Y34.9 Fatos ou eventos não especificados e intenção não determinada ­ local não especificado
Y35.0 Intervenção legal envolvendo o uso de armas de fogo
Y35.1 Intervenção legal envolvendo o uso de explosivos
Y35.2 Intervenção legal envolvendo o uso de gás
Y35.3 Intervenção legal envolvendo o uso de objetos contundentes
Y35.4 Intervenção legal envolvendo o uso de objetos cortantes e penetrantes
Y35.5 Execução legal
Y35.6 Intervenção legal envolvendo o uso de outros meios especificados
Y35.7 Intervenção legal, meio não especificado
Y36.0 Operações de guerra envolvendo explosão de armamento naval
Y36.1 Operações de guerra envolvendo destruição de aeronave
Y36.2 Operações de guerra envolvendo outras explosões ou fragmentos
Y36.3 Operações de guerra envolvendo incêndio, fogo e substâncias quentes
Y36.4 Operações de guerra envolvendo disparo de armas de fogo e de outras formas convencionais de
combate
Y36.5 Operações de guerra envolvendo armamento nuclear
Y36.6 Operações de guerra envolvendo armas biológicas
Y36.7 Operações de guerra envolvendo armas químicas e outros meios de combate nãoconvencionais
Y36.8 Operações de guerra ocorridas após a cessação das hostilidades
Y36.9 Operações de guerra não especificadas
Y40.0 Penicilinas
Y40.1 Cefalosporinas e outras betalactaminas
Y40.2 Grupo do cloranfenicol
Y40.3 Macrolídeos
Y40.4 Tetraciclinas
Y40.5 Aminoglicosídeos
Y40.6 Rifamicinas
Y40.7 Antibióticos antifúngicos administrados por via sistêmica
Y40.8 Outros antibióticos administrados por via sistêmica
Y40.9 Antibiótico sistêmico, não especificado
Y41.0 Sulfonamidas
Y41.1 Drogas antimicobacterianas
Y41.2 Antimaláricos e drogas que atuam sobre outros protozoários parasitas do sangue
Y41.3 Outras drogas antiprotozoários
Y41.4 Anti­helmínticos
Y41.5 Drogas antivirais
Y41.8 Outros antiinfecciosos e antiparasitários especificados
Y41.9 Antiinfecciosos e antiparasitários sistêmicos não especificados
Y42.0 Glicocorticóides e análogos sintéticos
Y42.1 Hormônios e substitutos da tireóide
Y42.2 Drogas antitireoidianas
Y42.3 Insulina e hipoglicêmicos orais (antidiabéticos)
Y42.4 Anticoncepcionais [contraceptivos] orais
Y42.5 Outros estrógenos e progestágenos
Y42.6 Antigonadotrofinas, antiestrógenos e antiandrógenos, não classificados em outra parte
Y42.7 Andrógenos e anabolizantes congêneres
Y42.8 Outros hormônios e os não especificados e seus substitutos sintéticos
Y42.9 Outros antagonistas hormonais e os não especificados
Y43.0 Drogas antialérgicas e antieméticas
Y43.1 Antimetabólicos antineoplásicos
Y43.2 Produtos naturais antineoplásicos
Y43.3 Outras drogas antineoplásicas
Y43.4 Agentes imunossupressores
Y43.5 Acidificantes e alcalinizantes
Y43.6 Enzimas, não classificadas em outra parte
Y43.8 Outras substâncias farmacológicas de ação primariamente sistêmica, não classificadas em outra
parte
Y43.9 Substância farmacológica de ação sistêmica, não especificada
Y44.0 Preparações a base de ferro e outros preparações prescritas na anemia hipocrômica
Y44.1 Vitamina B12, ácido fólico e outros preparações prescritas nas anemias megaloblásticas
Y44.2 Anticoagulantes
Y44.3 Antagonistas de anticoagulantes, vitamina K e outros coagulantes
Y44.4 Drogas antitrombóticas [inibidores da agregação de plaquetas]
Y44.5 Trombolíticos
Y44.6 Sangue natural e produtos do sangue
Y44.8 Substitutos do plasma
Y44.9 Outras substâncias farmacológicas que atuam sobre os constituintes do sangue e as não
especificadas
Y45.0 Opiáceos e analgésicos correlatos
Y45.1 Salicilatos
Y45.2 Derivados do ácido propiônico
Y45.3 Outras drogas antiinflamatórias não­esteróides
Y45.4 Anti­reumáticos
Y45.5 Derivados do 4­aminofenol
Y45.8 Outros analgésicos e antipiréticos
Y45.9 Substâncias analgésicas e antipiréticas não especificadas
Y46.0 Succimidas
Y46.1 Oxazolidínas
Y46.2 Derivados da hidantoína
Y46.3 Desoxibarbitúricos
Y46.4 Iminostilbenos
Y46.5 Ácido valpróico
Y46.6 Outros anticonvulsivantes (antiepilépticos) e os não especificados
Y46.7 Drogas antiparkinsonianas
Y46.8 Substâncias miorrelaxantes (anti­espásticas)
Y47.0 Barbitúricos, não classificados em outra parte
Y47.1 Benzodiazepínicos
Y47.2 Derivados do cloral
Y47.3 Paraldeído
Y47.4 Compostos de bromo
Y47.5 Sedativos e hipnóticos em associações não classificados em outra parte
Y47.8 Outros sedativos, hipnóticos e tranquilizantes [ansiolíticos]
Y47.9 Sedativos, hipnóticos e tranquilizantes [ansiolíticos], não especificados
Y48.0 Anestésicos por inalação
Y48.1 Anestésicos por via parenteral
Y48.2 Outros anestésicos gerais e os não especificados
Y48.3 Anestésicos locais
Y48.4 Anestésico, não especificado
Y48.5 Gases terapêuticos
Y49.0 Antidepressivos triciclos e tetracíclicos
Y49.1 Antidepressivos inibidores da mono­amino­oxidase
Y49.2 Outros antidepressivos e os não especificados
Y49.3 Antipsicóticos e neurolépticos fenotiazínicos
Y49.4 Neurolépticos a base da butirofenona e do tioxanteno
Y49.5 Outros antipsicóticos e neurolépticos
Y49.6 Psicodislépticos [alucinógenos]
Y49.7 Psicoestimulantes que podem provocar dependência
Y49.8 Outras substâncias psicotrópicas, não classificados em outra parte
Y49.9 Substância psicotrópica, não especificada
Y50.0 Analépticos
Y50.1 Antagonistas de receptores dos opiáceos
Y50.2 Metilxantinas, não classificadas em outra parte
Y50.8 Outros estimulantes do sistema nervoso central
Y50.9 Estimulante do sistema nervoso central, não especificado
Y51.0 Agentes anticolinesterásicos
Y51.1 Outros parasimpaticomiméticos [colinérgicos]
Y51.2 Ganglioplégicos, não classificados em outra parte
Y51.3 Outros parassimpaticolíticos [anticolinérgicos e antimuscarínicos] e espasmolíticos, não
classificados em outra parte
Y51.4 Agonistas predominantemente alfa­adrenorreceptores, não classificados em outra parte
Y51.5 Agonistas predominantemente beta­adrenorreceptores, não classificados em outra parte
Y51.6 Antagonistas alfa­adrenorreceptores, não classificados em outra parte
Y51.7 Antagonistas beta­adrenorreceptores, não classificados em outra parte
Y51.8 Bloqueadores nervosos de ação central e adrenérgicos, não classificados em outra parte
Y51.9 Outras drogas que atuam primariamente sobre o sistema nervoso autônomo e as não
especificadas
Y52.0 Glicosídeos estimulantes do coração e substâncias de ação semelhante
Y52.1 Antagonistas do cálcio [inibidores do cálcio]
Y52.2 Outras drogas antidisrrítmicas, não classificadas em outra parte
Y52.3 Vasodilatadores coronarianos, não classificados em outra parte
Y52.4 Inibidores da enzima de conversão da angiotensina
Y52.5 Outras drogas anti­hipertensivas, não classificadas em outra parte
Y52.6 Drogas anti­hiperlipidêmicas e antiarterioscleróticas
Y52.7 Vasodilatadores periféricos
Y52.8 Drogas antivaricosas, incluindo os agentes esclerosantes
Y52.9 Outras drogas que atuam primariamente sobre o aparelho cardiovascular e as não especificadas
Y53.0 Antagonistas dos receptores H2 da histamina
Y53.1 Outros medicamentos antiácidos e anti­secreção gástrica
Y53.2 Laxativos estimulantes
Y53.3 Laxativos salinos e osmóticos
Y53.4 Outros laxativos
Y53.5 Medicamentos que facilitam a digestão
Y53.6 Antidiarréicos
Y53.7 Eméticos
Y53.8 Outras substâncias que atuam primariamente sobre o aparelho gastrointestinal
Y53.9 Substâncias que atuam primariamente sobre o aparelho gastrointestinal, não especificadas
Y54.0 Mineralocorticóides
Y54.1 Antagonistas dos mineralocorticóides [antagonistas da aldosterona]
Y54.2 Inibidores da anidrase carbônica
Y54.3 Derivados da benzotiadiazína
Y54.4 Diuréticos de alça
Y54.5 Outros diuréticos
Y54.6 Agentes que atuam sobre o equilíbrio eletrolítico, calórico e hídrico
Y54.7 Medicamentos que atuam sobre o metabolismo de cálcio
Y54.8 Drogas que atuam sobre o metabolismo de ácido úrico
Y54.9 Sais minerais não classificados em outra parte
Y55.0 Ocitócicos
Y55.1 Relaxantes da musculatura esquelética [bloqueadores neuromusculares] [curarizantes]
Y55.2 Outras substâncias que atuam primariamente sobre os músculos e as não especificadas
Y55.3 Antitússicos
Y55.4 Expectorantes
Y55.5 Drogas anti­resfriado comum
Y55.6 Antiasmáticos, não classificados em outra parte
Y55.9 Outras drogas que atuam sobre o aparelho respiratório e as não especificadas
Y56.0 Drogas antifúngicas, antiinfecciosas e antiinflamatórias de uso local, não classificadas em outra
parte
Y56.1 Antipruriginosos
Y56.2 Adstringentes e detergentes locais
Y56.3 Emolientes, suavizantes e protetores da pele
Y56.4 Ceratolíticos, ceratoplásticos e outros medicamentos e preparações capilares
Y56.5 Medicamentos e preparações de uso oftalmológico
Y56.6 Medicamentos e preparações usados em otorrinolaringologia
Y56.7 Drogas de uso dentário aplicadas topicamente
Y56.8 Outras substâncias de uso tópico
Y56.9 Substância não especificada de uso tópico
Y57.0 Depressores do apetite [anoréxicos]
Y57.1 Lipotrópicos
Y57.2 Antídotos e agentes quelantes, não classificados em outra parte
Y57.3 Substâncias para restringir a ingestão de álcool
Y57.4 Excipientes farmacêuticos
Y57.5 Substâncias utilizadas como contraste em radiologia
Y57.6 Outras substâncias para fins diagnósticos
Y57.7 Vitaminas, não classificadas em outra parte
Y57.8 Outras drogas e medicamentos
Y57.9 Droga e medicamento não especificado
Y58.0 Vacina BCG
Y58.1 Vacinas antitifoídica e antiparafoídica
Y58.2 Vacina anticolérica
Y58.3 Vacina antipeste
Y58.4 Vacina antitetânica
Y58.5 Vacina antidiftérica
Y58.6 Vacina antipertussis, incluindo as combinações em que um dos componentes é a antipertussis
Y58.8 Vacinas bacterianas mistas, exceto as combinações em que um dos componentes é a
antipertussis
Y58.9 Outras vacinas bacterianas e as não especificadas
Y59.0 Vacinas antivirais
Y59.1 Vacinas anti­rickettsias
Y59.2 Vacinas antiprotozoários
Y59.3 Imunoglobulina
Y59.8 Outras vacinas e substâncias biológicas especificadas
Y59.9 Vacina ou substância biológica, não especificada
Y60.0 Durante intervenção cirúrgica
Y60.1 Durante infusão ou transfusão
Y60.2 Durante hemodiálise ou outras perfusões
Y60.3 Durante injeção ou vacinação (imunização)
Y60.4 Durante exame endoscópico
Y60.5 Durante cateterismo cardíaco
Y60.6 Durante aspiração, punção ou outro tipo de cateterização
Y60.7 Durante a administração de enema
Y60.8 Durante a prestação de outros cuidados cirúrgicos e médicos
Y60.9 Durante a prestação de cuidado cirúrgico e médico, não especificados
Y61.0 Durante intervenção cirúrgica
Y61.1 Durante infusão ou transfusão
Y61.2 Durante hemodiálise ou outras perfusões
Y61.3 Durante injeção ou vacinação (imunização)
Y61.4 Durante exame endoscópico
Y61.5 Durante cateterismo cardíaco
Y61.6 Durante aspiração, punção ou outro tipo de cateterização
Y61.7 Durante a extração de um cateter ou de compressas
Y61.8 Durante a prestação de outro cuidado cirúrgico e médico
Y61.9 Durante a prestação de cuidado cirúrgico e médico não especificados
Y62.0 Durante intervenção cirúrgica
Y62.1 Durante infusão ou transfusão
Y62.2 Durante hemodiálise ou outras perfusões
Y62.3 Durante injeção ou vacinação (imunização)
Y62.4 Durante exame endoscópico
Y62.5 Durante cateterismo cardíaco
Y62.6 Durante aspiração, punção ou outro tipo de cateterização
Y62.8 Durante a prestação de outro cuidado cirúrgico e médico
Y62.9 Durante a prestação de cuidado cirúrgico e médico não especificados
Y63.0 Administração de quantidade excessiva de sangue ou de um outro líquido durante transfusão ou
infusão
Y63.1 Diluição incorreta de líquido usado durante a infusão
Y63.2 Superdosagem de radiação administrada durante a terapia
Y63.3 Exposição inadvertida de paciente a radiação durante a prestação de cuidado médico
Y63.4 Erro de dosagem na terapia por eletrochoque ou choque insulínico
Y63.5 Temperatura inadequada durante aplicação local ou curativo
Y63.6 Não administração de droga, medicamento ou substância biológica necessária
Y63.8 Erros de dosagem durante a prestação de outro cuidado médico e cirúrgico
Y63.9 Erros de dosagem durante a prestação de cuidados médico e cirúrgico, não especificados
Y64.0 Transfusão ou infusão de medicamento ou substância biológica contaminados
Y64.1 Injeção ou vacinação com medicamento ou substância biológica contaminados
Y64.8 Administração por outros meios de medicamento ou substância biológicas contaminados
Y64.9 Medicamento e substância biológica contaminados, administrada por meios não especificados
Y65.0 Uso de sangue incompatível em transfusão
Y65.1 Uso de líquido errado em infusão
Y65.2 Falha de sutura ou de ligadura durante intervenção cirúrgica
Y65.3 Cânula endotraqueal mal posicionada durante procedimento anestésico
Y65.4 Falha na introdução ou na remoção de outras cânulas ou instrumentos
Y65.5 Realização de uma operação inapropriada
Y65.8 Outros acidentes especificados durante a prestação de cuidado médico e cirúrgico
Y66 Não administração de cuidado médico e cirúrgico
Y69 Acidente não especificado durante a prestação de cuidado médico e cirúrgico
Y70.0 Dispositivos (aparelhos) de anestesiologia, associados a incidentes adversos ­ dispositivos
(aparelhos) para fins diagnósticos ou de monitorização
Y70.1 Dispositivos (aparelhos) de anestesiologia, associados a incidentes adversos ­ dispositivos
(aparelhos) para fins terapêuticos (não­cirúrgicos) e aparelhagem de reabilitação
Y70.2 Dispositivos (aparelhos) de anestesiologia, associados a incidentes adversos ­ próteses e outros
implantes, incluindo materiais e acessórios
Y70.3 Dispositivos (aparelhos) de anestesiologia, associados a incidentes adversos ­ instrumentos,
materiais e aparelhos cirúrgicos (incluindo suturas)
Y70.8 Dispositivos (aparelhos) de anestesiologia, associados a incidentes adversos ­ dispositivos
(aparelhos) diversos, inclusive combinações, não classificada em outra parte
Y71.0 Dispositivos (aparelhos) cardiovasculares, associados a incidentes adversos ­ dispositivos
(aparelhos) para fins diagnósticos ou de monitorização
Y71.1 Dispositivos (aparelhos) cardiovasculares, associados a incidentes adversos ­ dispositivos
(aparelhos) para fins terapêuticos (não­cirúrgicos) e aparelhagem de reabilitação
Y71.2 Dispositivos (aparelhos) cardiovasculares, associados a incidentes adversos ­ próteses e outros
implantes, incluindo materiais e acessórios
Y71.3 Dispositivos (aparelhos) cardiovasculares, associados a incidentes adversos ­ instrumentos,
materiais e aparelhos cirúrgicos (incluindo suturas)
Y71.8 Dispositivos (aparelhos) cardiovasculares, associados a incidentes adversos ­ dispositivos
(aparelhos) diversos, inclusive combinações, não classificada em outra parte
Y72.0 Dispositivos (aparelhos) utilizados em otorrinolaringologia, associados a incidentes adversos ­
dispositivos (aparelhos) para fins diagnósticos ou de monitorização
Y72.1 Dispositivos (aparelhos) utilizados em otorrinolaringologia, associados a incidentes adversos ­
dispositivos (aparelhos) para fins terapêuticos (não­cirúrgicos) e aparelhagem de reabilitação
Y72.2 Dispositivos (aparelhos) utilizados em otorrinolaringologia, associados a incidentes adversos ­
próteses e outros implantes, incluindo materiais e acessórios
Y72.3 Dispositivos (aparelhos) utilizados em otorrinolaringologia, associados a incidentes adversos ­
instrumentos, materiais e aparelhos cirúrgicos (incluindo suturas)
Y72.8 Dispositivos (aparelhos) utilizados em otorrinolaringologia, associados a incidentes adversos ­
dispositivos (aparelhos) diversos, inclusive combinações, não classificada em outra parte
Y73.0 Dispositivos (aparelhos) usados em gastroenterologia e em urologia, associados a incidentes
adversos ­ dispositivos (aparelhos) para fins diagnósticos ou de monitorização
Y73.1 Dispositivos (aparelhos) usados em gastroenterologia e em urologia, associados a incidentes
adversos ­ dispositivos (aparelhos) para fins terapêuticos (não­cirúrgicos) e aparelhagem de
reabilitação
Y73.2 Dispositivos (aparelhos) usados em gastroenterologia e em urologia, associados a incidentes
adversos ­ próteses e outros implantes, incluindo materiais e acessórios
Y73.3 Dispositivos (aparelhos) usados em gastroenterologia e em urologia, associados a incidentes
adversos ­ instrumentos, materiais e aparelhos cirúrgicos (incluindo suturas)
Y73.8 Dispositivos (aparelhos) usados em gastroenterologia e em urologia, associados a incidentes
adversos ­ dispositivos (aparelhos) diversos, inclusive combinações, não classificada em outra parte
Y74.0 Dispositivos (aparelhos) gerais de uso hospitalar ou pessoal, associados a incidentes adversos ­
dispositivos (aparelhos) para fins diagnósticos ou de monitorização
Y74.1 Dispositivos (aparelhos) gerais de uso hospitalar ou pessoal, associados a incidentes adversos ­
dispositivos (aparelhos) para fins terapêuticos (não­cirúrgicos) e aparelhagem de reabilitação
Y74.2 Dispositivos (aparelhos) gerais de uso hospitalar ou pessoal, associados a incidentes adversos ­
próteses e outros implantes, incluindo materiais e acessórios
Y74.3 Dispositivos (aparelhos) gerais de uso hospitalar ou pessoal, associados a incidentes adversos ­
instrumentos, materiais e aparelhos cirúrgicos (incluindo suturas)
Y74.8 Dispositivos (aparelhos) gerais de uso hospitalar ou pessoal, associados a incidentes adversos ­
dispositivos (aparelhos) diversos, inclusive combinações, não classificada em outra parte
Y75.0 Dispositivos (aparelhos) utilizados em neurologia, associados a incidentes adversos ­
dispositivos (aparelhos) para fins diagnósticos ou de monitorização
Y75.1 Dispositivos (aparelhos) utilizados em neurologia, associados a incidentes adversos ­
dispositivos (aparelhos) para fins terapêuticos (não­cirúrgicos) e aparelhagem de reabilitação
Y75.2 Dispositivos (aparelhos) utilizados em neurologia, associados a incidentes adversos ­ próteses e
outros implantes, incluindo materiais e acessórios
Y75.3 Dispositivos (aparelhos) utilizados em neurologia, associados a incidentes adversos ­
instrumentos, materiais e aparelhos cirúrgicos (incluindo suturas)
Y75.8 Dispositivos (aparelhos) utilizados em neurologia, associados a incidentes adversos ­
dispositivos (aparelhos) diversos, inclusive combinações, não classificada em outra parte
Y76.0 Dispositivos (aparelhos) utilizados em obstetrícia e em ginecologia, associados a incidentes
adversos ­ dispositivos (aparelhos) para fins diagnósticos ou de monitorização
Y76.1 Dispositivos (aparelhos) utilizados em obstetrícia e em ginecologia, associados a incidentes
adversos ­ dispositivos (aparelhos) para fins terapêuticos (não­cirúrgicos) e aparelhagem de
reabilitação
Y76.2 Dispositivos (aparelhos) utilizados em obstetrícia e em ginecologia, associados a incidentes
adversos ­ próteses e outros implantes, incluindo materiais e acessórios
Y76.3 Dispositivos (aparelhos) utilizados em obstetrícia e em ginecologia, associados a incidentes
adversos ­ instrumentos, materiais e aparelhos cirúrgicos (incluindo suturas)
Y76.8 Dispositivos (aparelhos) utilizados em obstetrícia e em ginecologia, associados a incidentes
adversos ­ dispositivos (aparelhos) diversos, inclusive combinações, não classificada em outra parte
Y77.0 Dispositivos (aparelhos) utilizados em oftalmologia, associados a incidentes adversos ­
dispositivos (aparelhos) para fins diagnósticos ou de monitorização
Y77.1 Dispositivos (aparelhos) utilizados em oftalmologia, associados a incidentes adversos ­
dispositivos (aparelhos) para fins terapêuticos (não­cirúrgicos) e aparelhagem de reabilitação
Y77.2 Dispositivos (aparelhos) utilizados em oftalmologia, associados a incidentes adversos ­ próteses
e outros implantes, incluindo materiais e acessórios
Y77.3 Dispositivos (aparelhos) utilizados em oftalmologia, associados a incidentes adversos ­
instrumentos, materiais e aparelhos cirúrgicos (incluindo suturas)
Y77.8 Dispositivos (aparelhos) utilizados em oftalmologia, associados a incidentes adversos ­
dispositivos (aparelhos) diversos, inclusive combinações, não classificada em outra parte
Y78.0 Dispositivos (aparelhos) utilizados em radiologia, associados a incidentes adversos ­ dispositivos
(aparelhos) para fins diagnósticos ou de monitorização
Y78.1 Dispositivos (aparelhos) utilizados em radiologia, associados a incidentes adversos ­ dispositivos
(aparelhos) para fins terapêuticos (não­cirúrgicos) e aparelhagem de reabilitação
Y78.2 Dispositivos (aparelhos) utilizados em radiologia, associados a incidentes adversos ­ próteses e
outros implantes, incluindo materiais e acessórios
Y78.3 Dispositivos (aparelhos) utilizados em radiologia, associados a incidentes adversos ­
instrumentos, materiais e aparelhos cirúrgicos (incluindo suturas)
Y78.8 Dispositivos (aparelhos) utilizados em radiologia, associados a incidentes adversos ­ dispositivos
(aparelhos) diversos, inclusive combinações, não classificada em outra parte
Y79.0 Dispositivos (aparelhos) ortopédicos, associado a incidentes adversos ­ dispositivos (aparelhos)
para fins diagnósticos ou de monitorização
Y79.1 Dispositivos (aparelhos) ortopédicos, associado a incidentes adversos ­ dispositivos (aparelhos)
para fins terapêuticos (não­cirúrgicos) e aparelhagem de reabilitação
Y79.2 Dispositivos (aparelhos) ortopédicos, associado a incidentes adversos ­ próteses e outros
implantes, incluindo materiais e acessórios
Y79.3 Dispositivos (aparelhos) ortopédicos, associado a incidentes adversos ­ instrumentos, materiais
e aparelhos cirúrgicos (incluindo suturas)
Y79.8 Dispositivos (aparelhos) ortopédicos, associado a incidentes adversos ­ dispositivos (aparelhos)
diversos, inclusive combinações, não classificada em outra parte
Y80.0 Dispositivos (aparelhos) utilizados em medicina física (fisiatria), associado a incidentes adversos
­ dispositivos (aparelhos) para fins diagnósticos ou de monitorização
Y80.1 Dispositivos (aparelhos) utilizados em medicina física (fisiatria), associado a incidentes adversos
­ dispositivos (aparelhos) para fins terapêuticos (não­cirúrgicos) e aparelhagem de reabilitação
Y80.2 Dispositivos (aparelhos) utilizados em medicina física (fisiatria), associado a incidentes adversos
­ próteses e outros implantes, incluindo materiais e acessórios
Y80.3 Dispositivos (aparelhos) utilizados em medicina física (fisiatria), associado a incidentes adversos
­ instrumentos, materiais e aparelhos cirúrgicos (incluindo suturas)
Y80.8 Dispositivos (aparelhos) utilizados em medicina física (fisiatria), associado a incidentes adversos
­ dispositivos (aparelhos) diversos, inclusive combinações, não classificada em outra parte
Y81.0 Dispositivos (aparelhos) utilizados em cirurgia geral ou cirurgia plástica, associados a incidente
adversos ­ dispositivos (aparelhos) para fins diagnósticos ou de monitorização
Y81.1 Dispositivos (aparelhos) utilizados em cirurgia geral ou cirurgia plástica, associados a incidente
adversos ­ dispositivos (aparelhos) para fins terapêuticos (não­cirúrgicos) e aparelhagem de
reabilitação
Y81.2 Dispositivos (aparelhos) utilizados em cirurgia geral ou cirurgia plástica, associados a incidente
adversos ­ próteses e outros implantes, incluindo materiais e acessórios
Y81.3 Dispositivos (aparelhos) utilizados em cirurgia geral ou cirurgia plástica, associados a incidente
adversos ­ instrumentos, materiais e aparelhos cirúrgicos (incluindo suturas)
Y81.8 Dispositivos (aparelhos) utilizados em cirurgia geral ou cirurgia plástica, associados a incidente
adversos ­ dispositivos (aparelhos) diversos, inclusive combinações, não classificada em outra parte
Y82.0 Outros dispositivos (aparelhos) associados a incidentes adversos e os não especificados ­
dispositivos (aparelhos) para fins diagnósticos ou de monitorização
Y82.1 Outros dispositivos (aparelhos) associados a incidentes adversos e os não especificados ­
dispositivos (aparelhos) para fins terapêuticos (não­cirúrgicos) e aparelhagem de reabilitação
Y82.2 Outros dispositivos (aparelhos) associados a incidentes adversos e os não especificados ­
próteses e outros implantes, incluindo materiais e acessórios
Y82.3 Outros dispositivos (aparelhos) associados a incidentes adversos e os não especificados ­
instrumentos, materiais e aparelhos cirúrgicos (incluindo suturas)
Y82.8 Outros dispositivos (aparelhos) associados a incidentes adversos e os não especificados ­
dispositivos (aparelhos) diversos, inclusive combinações, não classificada em outra parte
Y83.0 Intervenção cirúrgica com transplante de todo o órgão
Y83.1 Intervenção cirúrgica com implante de uma prótese interna
Y83.2 Intervenção cirúrgica com anastomose, derivação ("bypass") ou enxerto
Y83.3 Intervenção cirúrgica com formação de estoma externo
Y83.4 Outras cirurgias reparadoras
Y83.5 Amputação de membro(s)
Y83.6 Remoção de um outro órgão (parcial) (total)
Y83.8 Outras intervenções ou procedimentos cirúrgicos
Y83.9 Intervenção cirúrgica, não especificada
Y84.0 Cateterismo cardíaco
Y84.1 Hemodiálise
Y84.2 Procedimento radiológico e radioterapia
Y84.3 Terapia por choque
Y84.4 Aspiração de líquido
Y84.5 Colocação de sonda gástrica ou duodenal
Y84.6 Cateterismo urinário
Y84.7 Amostra de sangue
Y84.8 Outros procedimentos médicos
Y84.9 Procedimento médico, não especificado
Y85.0 Seqüelas de um acidente de veículo a motor
Y85.9 Seqüelas de outros acidentes de transporte e dos não especificados
Y86 Seqüelas de outros acidentes
Y87.0 Seqüelas de lesões autoprovocadas intencionalmente
Y87.1 Seqüelas de uma agressão
Y87.2 Seqüelas de um fato cuja intenção é indeterminada
Y88.0 Seqüelas de efeitos adversos causados por drogas, medicamentos ou substâncias biológicas
usados com finalidade terapêutica
Y88.1 Seqüelas de acidentes durante a prestação de cuidado médico e cirúrgico
Y88.2 Seqüelas de incidentes adversos associados com o uso de dispositivos (aparelhos) médicos
durante atos diagnósticos ou terapêuticos
Y88.3 Seqüelas de reação anormal em paciente ou complicação tardia causada por procedimento
médico e cirúrgico sem menção de acidente durante o procedimento
Y89.0 Seqüelas de intervenção legal
Y89.1 Seqüelas de operações de guerra
Y89.9 Seqüelas de causa externa não especificada
Y90.0 Alcoolemia inferior a 20 mg/100 ml
Y90.1 Alcoolemia de 20­39 mg/100ml
Y90.2 Alcoolemia de 40­59 mg/100ml
Y90.3 Alcoolemia de 60­79 mg/100ml
Y90.4 Alcoolemia de 80­99 mg/100ml
Y90.5 Alcoolemia de 100­119 mg/100ml
Y90.6 Alcoolemia de 120­199 mg/100ml
Y90.7 Alcoolemia de 200­239 mg/100ml
Y90.8 Alcoolemia igual ou superior a 240 mg/100ml
Y90.9 Presença de álcool no sangue, taxa não especificada
Y91.0 Intoxicação alcoólica leve
Y91.1 Intoxicação alcoólica moderada
Y91.2 Intoxicação alcoólica grave
Y91.3 Intoxicação alcoólica muito grave
Y91.9 Envolvimento com álcool não especificado de outra forma
Y95 Circunstância relativa as condições nosocomiais (hospitalares)
Y96 Circunstância relativa às condições de trabalho
Y97 Circunstâncias relativas a condições de poluição ambiental
Y98 Circunstâncias relativas a condições do modo de vida
Z00.0 Exame médico geral
Z00.1 Exame de rotina de saúde da criança
Z00.2 Exame no período de crescimento rápido na infância
Z00.3 Exame do adolescente durante o crescimento na puberdade
Z00.4 Exame psiquiátrico geral não classificado em outra parte
Z00.5 Exame de doador potencial de órgão e tecido
Z00.6 Exame para comparação ou de controle de normalidade num programa de investigação clínica
Z00.8 Outros exames gerais
Z01.0 Exame dos olhos e da visão
Z01.1 Exame dos ouvidos e da audição
Z01.2 Exame dentário
Z01.3 Exame da pressão arterial
Z01.4 Exame ginecológico (geral) (de rotina)
Z01.5 Testes cutâneos de diagnóstico e sensibilização
Z01.6 Exame radiológico não classificado em outra parte
Z01.7 Exame de laboratório
Z01.8 Outros exames especiais especificados
Z01.9 Exame especial não especificado
Z02.0 Exame para admissão a instituição educacional
Z02.1 Exame pré­emprego (pré­admissional)
Z02.2 Exame para admissão em instituição residencial
Z02.3 Exame para a incorporação nas forças armadas
Z02.4 Exame para licença para a condução de veículos (carteira de motorista)
Z02.5 Exame para participação em esporte
Z02.6 Exame para fins de seguro
Z02.7 Obtenção de atestado médico
Z02.8 Outros exames para propósitos administrativos
Z02.9 Exame não especificado com finalidades administrativas
Z03.0 Observação por suspeita de tuberculose
Z03.1 Observação por suspeita de neoplasia maligna
Z03.2 Observação por suspeita de transtornos mentais e do comportamento
Z03.3 Observação por suspeita de transtorno do sistema nervoso
Z03.4 Observação por suspeita de infarto do miocárdio
Z03.5 Observação por suspeita de outras doenças cardiovasculares
Z03.6 Observação por suspeita de efeito tóxico de substância ingerida
Z03.8 Observação por suspeita de outras doenças e afecções
Z03.9 Observação por suspeita de doença ou afecção não especificada
Z04.0 Teste para álcool e para drogas no sangue
Z04.1 Exame e observação após acidente de transporte
Z04.2 Exame e observação após acidente de trabalho
Z04.3 Exame e observação após outro acidente
Z04.4 Exame e observação após alegação de estupro e sedução
Z04.5 Exame e observação após outros ferimentos infligidos
Z04.6 Exame psiquiátrico geral, requerido por autoridade
Z04.8 Exame e observação por outras razões especificadas
Z04.9 Exame e observação por razão não especificada
Z08.0 Exame de seguimento após tratamento cirúrgico de neoplasia maligna
Z08.1 Exame de seguimento após radioterapia por neoplasia maligna
Z08.2 Exame de seguimento após quimioterapia por neoplasia maligna
Z08.7 Exame de seguimento após tratamento misto por neoplasia maligna
Z08.8 Exame de seguimento após outro tratamento por neoplasia maligna
Z08.9 Exame de seguimento após tratamento não especificado por neoplasia maligna
Z09.0 Exame de seguimento após cirurgia por outras afecções
Z09.1 Exame de seguimento após radioterapia por outras afecções
Z09.2 Exame de seguimento após quimioterapia por outras afecções
Z09.3 Exame de seguimento após psicoterapia
Z09.4 Exame de seguimento após tratamento de fratura
Z09.7 Exame de seguimento após tratamento combinado por outras afecções
Z09.8 Exame de seguimento após outro tratamento por outras afecções
Z09.9 Exame de seguimento após tratamento não especificado por outras afecções
Z10.0 Exame de saúde ocupacional
Z10.1 Exame geral de rotina de residentes de instituições
Z10.2 Exame geral de rotina de pessoas das forças armadas
Z10.3 Exame geral de rotina de equipe esportiva
Z10.8 Exame geral de rotina de outra subpopulação definida
Z11.0 Exame especial de rastreamento de doenças infecciosas intestinais
Z11.1 Exame especial de rastreamento de tuberculose pulmonar
Z11.2 Exame especial de rastreamento de outras doenças bacterianas
Z11.3 Exame especial de rastreamento de infecções de transmissão predominantemente sexual
Z11.4 Exame especial de rastreamento de vírus da imunodeficiência humana [HIV]
Z11.5 Exame especial de rastreamento de outras doenças virais
Z11.6 Exame especial de rastreamento de outras doenças por protozoários e por helmintos
Z11.8 Exame especial de rastreamento de outras doenças infecciosas e parasitárias
Z11.9 Exame especial de rastreamento para doença infecciosa e parasitária não especificada
Z12.0 Exame especial de rastreamento de neoplasia do estômago
Z12.1 Exame especial de rastreamento de neoplasia do trato intestinal
Z12.2 Exame especial de rastreamento de neoplasia de órgãos respiratórios
Z12.3 Exame especial de rastreamento de neoplasia de mama
Z12.4 Exame especial de rastreamento de neoplasia do colo do útero
Z12.5 Exame especial de rastreamento de neoplasia da próstata
Z12.6 Exame especial de rastreamento de neoplasia da bexiga
Z12.8 Exame especial de rastreamento de neoplasias de outras localizações
Z12.9 Exame especial de rastreamento de neoplasia não especificada
Z13.0 Exame especial de rastreamento de doenças do sangue e dos órgãos hematopoéticos de alguns
transtornos imunitários
Z13.1 Exame especial de rastreamento de diabetes mellitus
Z13.2 Exame especial de rastreamento de transtornos nutricionais
Z13.3 Exame especial de rastreamento de transtornos mentais e do comportamento
Z13.4 Exame especial de rastreamento de alguns transtornos do desenvolvimento na infância
Z13.5 Exame especial de rastreamento de doenças dos ouvidos e dos olhos
Z13.6 Exame especial de rastreamento de doenças cardiovasculares
Z13.7 Exame especial de rastreamento de malformações congênitas, deformidades e anomalias
cromossômicas
Z13.8 Exame especial de rastreamento de outras doenças e transtornos especificados
Z13.9 Exame especial de rastreamento não especificado
Z20.0 Contato com e exposição a doenças infecciosas intestinais
Z20.1 Contato com e exposição à tuberculose
Z20.2 Contato com e exposição a infecções de transmissão predominantemente sexual
Z20.3 Contato com e exposição à raiva
Z20.4 Contato com e exposição à rubéola
Z20.5 Contato com e exposição à hepatite viral
Z20.6 Contato com e exposição ao vírus da imunodeficiência humana [HIV]
Z20.7 Contato com e exposição à pediculose, acaríase e outras infestações
Z20.8 Contato com e exposição a outras doenças transmissíveis
Z20.9 Contato com e exposição a doença transmissível não especificada
Z21 Estado de infecção assintomática pelo vírus da imunodeficiência humana [HIV]
Z22.0 Portador de febre tifóide
Z22.1 Portador de outras doenças infecciosas intestinais
Z22.2 Portador de difteria
Z22.3 Portador de outras doenças bacterianas especificadas
Z22.4 Portador de infecções com modo de transmissão predominantemente sexual
Z22.5 Portador de hepatite viral
Z22.6 Portador de infecção pelo vírus T­linfotrópico tipo 1 [HTLV­1]
Z22.8 Portador de outras doenças infecciosas
Z22.9 Portador de doença infecciosa não especificada
Z23.0 Necessidade de imunização somente contra cólera
Z23.1 Necessidade de imunização somente contra febre tifóide e paratifóide [TAB]
Z23.2 Necessidade de imunização contra tuberculose [BCG]
Z23.3 Necessidade de imunização contra a peste
Z23.4 Necessidade de imunização contra a tularemia
Z23.5 Necessidade de imunização somente contra o tétano
Z23.6 Necessidade de imunização somente contra a difteria
Z23.7 Necessidade de imunização somente contra a coqueluche
Z23.8 Vacinação contra outras doenças bacterianas únicas
Z24.0 Necessidade de imunização contra a poliomielite
Z24.1 Necessidade de imunização contra a encefalite viral transmitida por artrópodes
Z24.2 Necessidade de imunização contra a raiva
Z24.3 Necessidade de imunização contra a febre amarela
Z24.4 Necessidade de imunização somente contra o sarampo
Z24.5 Necessidade de imunização somente contra a rubéola
Z24.6 Necessidade de imunização somente contra a hepatite viral
Z25.0 Necessidade de imunização somente contra a caxumba [parotidite epidêmica]
Z25.1 Necessidade de imunização somente contra a influenza [gripe]
Z25.8 Necessidade de imunização contra outras doenças virais únicas especificadas
Z26.0 Necessidade de imunização contra a leishmaniose
Z26.8 Necessidade de imunização contra outras doenças infecciosas especificadas únicas
Z26.9 Necessidade de imunização contra doença infecciosa não especificada
Z27.0 Necessidade de imunização contra a cólera e as febres tifóide e paratifóides [Cólera + TAB]
Z27.1 Necessidade de imunização associada contra a difteria­pertussis­tétano, combinada [DPT]
Z27.2 Necessidade de imunização contra a difteria­pertussis­tétano com febres tifóide e paratifóides
[DPT+TAB]
Z27.3 Necessidade de imunização contra a difteria­pertussis­tétano com poliomielite [DPT + pólio]
Z27.4 Necessidade de imunização contra o sarampo­caxumba­rubéola
Z27.8 Necessidade de imunização contra outras combinações de doenças infecciosas
Z27.9 Necessidade de imunização contra combinações não especificadas de doenças infecciosas
Z28.0 Imunização não realizada por contra­indicação
Z28.1 Imunização não realizada por decisão do paciente devida à crença ou a grupo de pressão
Z28.2 Imunização não realizada por decisão do paciente devida a razões outras e às não
especificadas
Z28.8 Imunização não realizada por outras razões
Z28.9 Imunização não realizada por razões não especificadas
Z29.0 Isolamento
Z29.1 Imunoterapia profilática
Z29.2 Outras quimioterapias profiláticas
Z29.8 Outras medidas profiláticas especificadas
Z29.9 Medida profilática não especificada
Z30.0 Aconselhamento geral sobre contracepção
Z30.1 Inserção de dispositivo anticoncepcional (intra­uterino)
Z30.2 Esterilização
Z30.3 Extração menstrual
Z30.4 Supervisão do uso de medicamentos anticoncepcionais
Z30.5 Supervisão de dispositivo anticoncepcional (intra­uterino)
Z30.8 Outro procedimento anticoncepcional
Z30.9 Procedimento anticoncepcional não especificado
Z31.0 Tuboplastia ou vasoplastia após esterilização prévia
Z31.1 Inseminação artificial
Z31.2 Fecundação "in vitro"
Z31.3 Outros métodos assistidos de fertilização
Z31.4 Investigação e testes com relação à procriação
Z31.5 Aconselhamento genético
Z31.6 Aconselhamento geral sobre a procriação
Z31.8 Outra medida especificada de procriação
Z31.9 Medida procriativa não especificada
Z32.0 Gravidez (ainda) não confirmada
Z32.1 Gravidez confirmada
Z33 Gravidez como achado casual
Z34.0 Supervisão de primeira gravidez normal
Z34.8 Supervisão de outra gravidez normal
Z34.9 Supervisão de gravidez normal, não especificada
Z35.0 Supervisão de gravidez com história de esterilidade
Z35.1 Supervisão de gravidez com história de aborto
Z35.2 Supervisão de gravidez com outros antecedentes de procriação problemática
Z35.3 Supervisão de gravidez com história de assistência pré­natal insuficiente
Z35.4 Supervisão de gravidez com grande multiparidade
Z35.5 Supervisão de primigesta idosa
Z35.6 Supervisão de primigesta muito jovem
Z35.7 Supervisão de gravidez de alto risco devido a problemas sociais
Z35.8 Supervisão de outras gravidezes de alto risco
Z35.9 Supervisão não especificada de gravidez de alto risco
Z36.0 Rastreamento de anomalias cromossômicas
Z36.1 Rastreamento pré­natal de taxa elevada de alfa­fetoproteínas
Z36.2 Outros rastreamentos pré­natais por amniocentese
Z36.3 Rastreamento pré­natal de malformações por ultrassom e outros meios físicos
Z36.4 Rastreamento pré­natal do retardo de crescimento do feto por ultrassom e outros métodos
físicos
Z36.5 Rastreamento pré­natal de isoimunização
Z36.8 Outros rastreamentos pré­natais
Z36.9 Rastreamento pré­natal não especificado
Z37.0 Nascimento único, nativivo [nado­vivo]
Z37.1 Nascimento único, natimorto [feto­morto]
Z37.2 Nascimento gemelar, gêmeos (ambos) nati­vivos [nado­vivos]
Z37.3 Nascimento gemelar, um dos gêmeos, nativivo [nado­vivo], o outro, natimorto [feto­morto]
Z37.4 Nascimento gemelar, gêmeos natimortos [feto­mortos]
Z37.5 Outros nascimentos múltiplos, todos nativivos [nado­vivos]
Z37.6 Outros nascimentos múltiplos, alguns nativivos [nado­vivos]
Z37.7 Outros nascimentos múltiplos, todos natimortos [feto­mortos]
Z37.9 Nascimento não especificado
Z38.0 Criança única, nascida em hospital
Z38.1 Criança única, nascida fora do hospital
Z38.2 Criança única, não especificado quanto ao local de nascimento
Z38.3 Gêmeos (duplos), nascidos em hospital
Z38.4 Gêmeos (duplos), nascidos fora de hospital
Z38.5 Gêmeos, não especificados quanto ao local de nascimento
Z38.6 Outros nascimentos múltiplos, em hospital
Z38.7 Outros nascimentos múltiplos, fora de hospital
Z38.8 Outros nascimentos múltiplos, não especificados quanto ao local de nascimento
Z39.0 Assistência e exame imediatamente após o parto
Z39.1 Assistência e exame da mãe nutriz
Z39.2 Seguimento pós­parto de rotina
Z40.0 Cirurgia profilática para fatores de risco relacionados com neoplasias malignas
Z40.8 Outra cirurgia profilática
Z40.9 Cirurgia profilática não especificada
Z41.0 Transplante de cabelo
Z41.1 Outras intervenções de cirurgia plástica por razões estéticas
Z41.2 Circuncisão ritual e de rotina
Z41.3 Perfuração do lobo da orelha
Z41.8 Outros procedimentos para outros propósitos exceto cuidados de saúde
Z41.9 Procedimentos não especificado para outros propósitos exceto cuidados de saúde
Z42.0 Seguimento envolvendo cirurgia plástica da cabeça e do pescoço
Z42.1 Seguimento envolvendo cirurgia plástica de mama
Z42.2 Seguimento envolvendo cirurgia plástica de outras partes do tronco
Z42.3 Seguimento envolvendo cirurgia plástica das extremidades superiores
Z42.4 Seguimento envolvendo cirurgia plástica das extremidades inferiores
Z42.8 Seguimento envolvendo cirurgia plástica de outras partes do corpo
Z42.9 Seguimento envolvendo cirurgia plástica não especificada
Z43.0 Cuidados à traqueostomia
Z43.1 Cuidados à gastrostomia
Z43.2 Cuidados à ileostomia
Z43.3 Cuidados à colostomia
Z43.4 Cuidados a outros orifícios artificiais do tubo digestivo
Z43.5 Cuidados à cistostomia
Z43.6 Cuidados a outros orifícios artificiais das vias urinárias
Z43.7 Cuidados à vagina artificial
Z43.8 Cuidados a outros orifícios artificiais
Z43.9 Cuidados a orifício artificial não especificado
Z44.0 Colocação e ajustamento de braço artificial (parcial) (total)
Z44.1 Colocação e ajustamento de perna artificial (parcial) (total)
Z44.2 Colocação e ajustamento de olho artificial
Z44.3 Colocação e ajustamento de prótese externa de mama
Z44.8 Colocação e ajustamento de outros aparelhos de prótese externa
Z44.9 Colocação e ajustamento de aparelho de prótese externa não especificado
Z45.0 Ajustamento e manuseio de marca­passo cardíaco
Z45.1 Ajustamento e manuseio de bomba de infusão
Z45.2 Ajustamento e manuseio de dispositivo de acesso vascular
Z45.3 Ajustamento e manuseio de dispositivo implantado de audição
Z45.8 Ajustamento e manuseio de outros dispositivos implantados
Z45.9 Ajustamento e manuseio de dispositivo implantado não especificado
Z46.0 Colocação e ajustamento de óculos e lentes de contato
Z46.1 Colocação e ajustamento de aparelho auditivo
Z46.2 Colocação e ajustamento de outros aparelhos relacionados com o sistema nervoso e órgãos dos
sentidos
Z46.3 Colocação e ajustamento de dispositivo de prótese dentária
Z46.4 Colocação e ajustamento de aparelho ortodôntico
Z46.5 Colocação e ajustamento de ileostomia e de outros dispositivos intestinais
Z46.6 Colocação e ajustamento de prótese urinária
Z46.7 Colocação e ajustamento de aparelho ortopédico
Z46.8 Colocação e ajustamento de outros aparelhos especificados
Z46.9 Colocação e ajustamento de aparelho não especificado
Z47.0 Seguimento envolvendo remoção de placa de fratura e outros dispositivos de fixação interna
Z47.8 Outros seguimentos ortopédicos especificados
Z47.9 Seguimento ortopédico não especificado
Z48.0 Cuidados a curativos e suturas cirúrgicas
Z48.8 Outro seguimento cirúrgico especificado
Z48.9 Seguimento cirúrgico não especificado
Z49.0 Cuidado preparatório para diálise
Z49.1 Diálise extracorpórea
Z49.2 Outras diálises
Z50.0 Reabilitação cardíaca
Z50.1 Outra fisioterapia
Z50.2 Reabilitação de alcoólatra
Z50.3 Reabilitação de toxicodependentes
Z50.4 Psicoterapia, não classificada em outra parte
Z50.5 Reabilitação da linguagem
Z50.6 Treinamento ortóptico
Z50.7 Terapia ocupacional e reabilitação vocacional não classificada em outra parte
Z50.8 Cuidados envolvendo uso de outros procedimentos de reabilitação
Z50.9 Cuidados envolvendo uso de procedimento de reabilitação não especificado
Z51.0 Sessão de radioterapia
Z51.1 Sessão de quimioterapia por neoplasia
Z51.2 Outra quimioterapia
Z51.3 Transfusão de sangue, sem diagnóstico registrado
Z51.4 Cuidado preparatório para tratamento subsequente não classificado em outra parte
Z51.5 Cuidado paliativo
Z51.6 Dessensibilização a alérgenos
Z51.8 Outro cuidado médico especificado
Z51.9 Cuidado médico não especificado
Z52.0 Doador de sangue
Z52.1 Doador de pele
Z52.2 Doador de osso
Z52.3 Doador de medula óssea
Z52.4 Doador de rim
Z52.5 Doador de córnea
Z52.6 Doador de fígado
Z52.7 Doador de coração
Z52.8 Doador de outros órgãos ou tecidos
Z52.9 Doador de órgão ou tecido não especificado
Z53.0 Procedimento não realizado devido à contra­indicação
Z53.1 Procedimento não realizado devido à decisão do paciente por razões de crença ou grupo de
pressão
Z53.2 Procedimento não realizado devido à decisão do paciente por outras razões e as não
especificadas
Z53.8 Procedimento não realizado por outras razões
Z53.9 Procedimento não realizado por razão não especificada
Z54.0 Convalescença após cirurgia
Z54.1 Convalescença após radioterapia
Z54.2 Convalescença após quimioterapia
Z54.3 Convalescença após psicoterapia
Z54.4 Convalescença após tratamento de fratura
Z54.7 Convalescença após tratamento combinado
Z54.8 Convalescença após outro tratamento
Z54.9 Convalescença após tratamento não especificado
Z55.0 Analfabetismo e baixa escolaridade
Z55.1 Escolarização não disponível e impossível
Z55.2 Reprovação em exames
Z55.3 Maus resultados escolares
Z55.4 Má adaptação escolar e dificuldades com professores e colegas
Z55.8 Outros problemas relacionados com a educação e com a alfabetização
Z55.9 Problemas não especificados relacionados com a educação e com a alfabetização
Z56.0 Desemprego não especificado
Z56.1 Mudança de emprego
Z56.2 Ameaça de perda de emprego
Z56.3 Ritmo de trabalho penoso
Z56.4 Desacordo com patrão e colegas de trabalho
Z56.5 Má adaptação ao trabalho
Z56.6 Outras dificuldades físicas e mentais relacionadas ao trabalho
Z56.7 Outros problemas e os não especificados relacionados com o emprego
Z57.0 Exposição ocupacional ao ruído
Z57.1 Exposição ocupacional à radiação
Z57.2 Exposição ocupacional à poeira (pó)
Z57.3 Exposição ocupacional a outros contaminantes do ar
Z57.4 Exposição ocupacional a agentes tóxicos na agricultura
Z57.5 Exposição ocupacional a agentes tóxicos em outras indústrias
Z57.6 Exposição ocupacional a temperaturas extremas
Z57.7 Exposição ocupacional à vibração
Z57.8 Exposição ocupacional a outros fatores de risco
Z57.9 Exposição ocupacional a fator de risco não especificado
Z58.0 Exposição ao ruído
Z58.1 Exposição à poluição atmosférica
Z58.2 Exposição à poluição da água
Z58.3 Exposição à poluição do solo
Z58.4 Exposição à radiação
Z58.5 Exposição a outras poluições
Z58.6 Água potável insuficiente
Z58.8 Outros problemas relacionados com o ambiente físico
Z58.9 Problema não especificado relacionado com o ambiente físico
Z59.0 Falta de domicílio fixo
Z59.1 Habitação inadequada
Z59.2 Desacordo com vizinhos, locatários e proprietários
Z59.3 Problemas relacionados com a vida em instituição residencial
Z59.4 Falta de alimentação adequada
Z59.5 Pobreza extrema
Z59.6 Baixo rendimento
Z59.7 Seguro social e medidas de bem­estar social insuficientes
Z59.8 Outros problemas relacionados com a habitação e com as circunstâncias econômicas
Z59.9 Circunstâncias não especificadas econômicas ou de habitação
Z60.0 Problemas de adaptação às transições do ciclo de vida
Z60.1 Situação parental atípica
Z60.2 Viver só
Z60.3 Dificuldade de aculturação
Z60.4 Exclusão e rejeição sociais
Z60.5 Objeto de discriminação e perseguição percebidas
Z60.8 Outros problemas relacionados com o meio social
Z60.9 Problema não especificado relacionado com o meio social
Z61.0 Perda de relação afetiva na infância
Z61.1 Remoção do lar na infância
Z61.2 Padrão alterado de relações familiares na infância
Z61.3 Eventos que originam a perda de auto­estima na infância
Z61.4 Problemas relacionados com abuso sexual alegado de uma criança por uma pessoa de dentro
de seu grupo
Z61.5 Problemas relacionados com abuso sexual alegado de uma criança por pessoa de fora de seu
grupo
Z61.6 Problemas relacionados com abuso físico alegado da criança
Z61.7 Experiência pessoal amedrontadora na infância
Z61.8 Outros eventos da vida pessoal negativos na infância
Z61.9 Evento pessoal negativo não especificado na infância
Z62.0 Supervisão e controle inadequado por parte dos pais
Z62.1 Superproteção por parte dos pais
Z62.2 Educação numa instituição
Z62.3 Hostilidade com relação a uma criança, transformada em bode expiatório
Z62.4 Negligência emocional da criança
Z62.5 Outros problemas relacionados com negligência na educação dos filhos
Z62.6 Pressões não apropriadas por parte dos pais e outras falhas de educação
Z62.8 Outros problemas especificados relacionados com a educação dos filhos
Z62.9 Problema não especificado relacionado com a educação dos filhos
Z63.0 Problemas nas relações com cônjuge ou parceiro
Z63.1 Problemas nas relações com os pais ou com os sogros
Z63.2 Suporte familiar inadequado
Z63.3 Ausência de um dos membros da família
Z63.4 Desaparecimento ou falecimento de um membro da família
Z63.5 Rompimento da família por separação ou divórcio
Z63.6 Parente dependente de cuidados, residente no domicílio
Z63.7 Outros acontecimentos difíceis com incidência na família ou no lar
Z63.8 Outros problemas especificados relacionados com o grupo primário de suporte
Z63.9 Problema não especificado relacionado com o grupo primário de suporte
Z64.0 Problemas relacionados com uma gravidez não desejada
Z64.1 Problemas relacionados com multiparidade
Z64.2 Procura e aceitação de intervenções físicas, nutricionais, ou químicas conhecidas como
perigosas ou nocivas
Z64.3 Procura e aceitação de intervenções comportamentais ou psicológicas conhecidas como
perigosas ou nocivas
Z64.4 Desacordo com conselheiros
Z65.0 Condenação, sem prisão, por tribunal civil ou criminal
Z65.1 Prisão ou encarceramento
Z65.2 Problemas ligados à libertação de prisão
Z65.3 Problemas ligados à outras circunstâncias legais
Z65.4 Vítima de crime ou de atos terroristas
Z65.5 Exposição a catástrofe, guerra e outras hostilidades
Z65.8 Outros problemas especificados relacionados com circunstâncias psicossociais
Z65.9 Problemas relacionados com circunstâncias psicossociais não especificadas
Z70.0 Acompanhamento relativo às atitudes em matéria de sexualidade
Z70.1 Aconselhamento relativo ao comportamento e à orientação sexual do sujeito
Z70.2 Aconselhamento relativo ao comportamento e à orientação sexual de um terceiro
Z70.3 Aconselhamento relativo a preocupações associadas relacionadas com as atitudes, o
comportamento e orientação em matéria de sexualidade
Z70.8 Outros aconselhamentos em matéria de sexualidade
Z70.9 Aconselhamento não especificado em matéria de sexualidade
Z71.0 Pessoa que consulta no interesse de um terceiro
Z71.1 Pessoa com medo de uma queixa para a qual não foi feito diagnóstico
Z71.2 Pessoa que consulta para explicação de achados de exame
Z71.3 Aconselhamento e supervisão dietéticos
Z71.4 Aconselhamento e supervisão para abuso de álcool
Z71.5 Aconselhamento e supervisão para abuso de drogas
Z71.6 Aconselhamento para o abuso de fumo
Z71.7 Aconselhamento a propósito do vírus da imunodeficiência humana [HIV]
Z71.8 Outros aconselhamentos especificados
Z71.9 Aconselhamento não especificado
Z72.0 Uso do tabaco
Z72.1 Uso de álcool
Z72.2 Uso de droga
Z72.3 Falta de exercício físico
Z72.4 Regime e hábitos alimentares inadequados
Z72.5 Comportamento sexual de alto risco
Z72.6 Mania de jogo e apostas
Z72.8 Outros problemas relacionados com o estilo de vida
Z72.9 Problema não especificado relacionado com o estilo de vida
Z73.0 Esgotamento
Z73.1 Acentuação de traços de personalidade
Z73.2 Falta de repouso e de lazer
Z73.3 "Stress" não classificado em outra parte
Z73.4 Habilidades sociais inadequadas não classificadas em outra parte
Z73.5 Conflito sobre o papel social, não classificado em outra parte
Z73.6 Limites impostos às atividades por invalidez
Z73.8 Outros problemas relacionados com a organização do seu modo de vida
Z73.9 Problema relacionado com a organização de seu modo de vida não especificado
Z74.0 Mobilidade reduzida
Z74.1 Necessidade de assistência com cuidados pessoais
Z74.2 Necessidade de assistência a domicílio, sendo que nenhuma pessoa do lar é capaz de
assegurar os cuidados
Z74.3 Necessidade de supervisão contínua
Z74.8 Outros problemas relacionados com a dependência de pessoa que oferece cuidados de saúde
Z74.9 Problema não especificado relacionado com a dependência de pessoa que oferece cuidados de
saúde
Z75.0 Falta de disponibilidade de serviços médicos no domicílio
Z75.1 Pessoa esperando ser admitida em estabelecimento médico adequado em outra parte
Z75.2 Outro período de espera para investigação e tratamento
Z75.3 Facilidades de saúde não disponíveis ou não acessíveis
Z75.4 Outras organizações de cuidados não disponíveis ou não acessíveis
Z75.5 Cuidados dispensados para ajudar às famílias durante as férias
Z75.8 Outras dificuldades especificadas relacionadas com facilidades médicas e com outros cuidados
de saúde
Z75.9 Problema não especificado relacionado com facilidades médicas e com outros cuidados de
saúde
Z76.0 Emissão de prescrição de repetição
Z76.1 Supervisão e cuidado de saúde de crianças assistidas
Z76.2 Supervisão de cuidado de saúde de outras crianças ou recém­nascidos sadios
Z76.3 Pessoa em boa saúde acompanhando pessoa doente
Z76.4 Outros pensionistas em estabelecimentos de cuidados de saúde
Z76.5 Pessoa fingindo ser doente [simulação consciente]
Z76.8 Contatos com serviços de saúde por outras circunstâncias especificadas
Z76.9 Pessoa em contato com serviços de saúde em circunstâncias não especificadas
Z80.0 História familiar de neoplasia maligna de órgãos digestivos
Z80.1 História familiar de neoplasia maligna de traquéia, brônquio e pulmão
Z80.2 História familiar de neoplasia maligna de outros órgãos respiratórios e intratorácicos
Z80.3 História familiar de neoplasia de mama
Z80.4 História familiar de neoplasia maligna de órgãos genitais
Z80.5 História familiar de neoplasia maligna do trato urinário
Z80.6 História familiar de leucemia
Z80.7 História familiar de outras neoplasias malignas dos tecidos linfático, hematopoético e
correlacionados
Z80.8 História familiar de neoplasia maligna de outros órgãos ou aparelhos
Z80.9 História familiar de neoplasia maligna não especificada
Z81.0 História familiar de retardo mental
Z81.1 História familiar de abuso de álcool
Z81.2 História familiar de abuso de fumo
Z81.3 História familiar de abuso de outra substância psicoativa
Z81.4 História familiar de abuso de outra substância
Z81.8 História familiar de outros transtornos mentais e comportamentais
Z82.0 História familiar de epilepsia e de outras doenças do sistema nervoso
Z82.1 História familiar de cegueira e perda de visão
Z82.2 História familiar de surdez e perda de audição
Z82.3 História familiar de acidente vascular cerebral
Z82.4 História familiar de doença isquêmica do coração e outras doenças do aparelho circulatório
Z82.5 História familiar de asma e outras doenças respiratórias inferiores crônicas
Z82.6 História familiar de artrite e outras doenças do sistema osteomuscular e tecido conjuntivo
Z82.7 História familiar de malformações e deformações congênitas e anomalias cromossômicas
Z82.8 História familiar de outras incapacidades e doenças crônicas que conduzem a incapacitação,
não classificadas em outra parte
Z83.0 História familiar de doença pelo vírus da imunodeficiência humana [HIV]
Z83.1 História familiar de outras doenças infecciosas e parasitárias
Z83.2 História familiar de doenças do sangue e dos órgãos hematopoéticos e alguns transtornos
imunitários
Z83.3 História familiar de diabetes mellitus
Z83.4 História familiar de outras doenças endócrinas, nutricionais e metabólicas
Z83.5 História familiar de outros transtornos dos olhos e dos ouvidos
Z83.6 História familiar de doenças do aparelho respiratório
Z83.7 História familiar das doenças do aparelho digestivo
Z84.0 História familiar de doenças da pele e do tecido subcutâneo
Z84.1 História familiar de transtornos do rim e ureter
Z84.2 História familiar de outras doenças do aparelho geniturinário
Z84.3 História familiar de consangüinidade
Z84.8 História familiar de outras afecções especificadas
Z85.0 História pessoal de neoplasia maligna de órgãos digestivos
Z85.1 História pessoal de neoplasia maligna de traquéia, brônquio e pulmão
Z85.2 História pessoal de neoplasia maligna de outros órgãos respiratórios e intratorácicos
Z85.3 História pessoal de neoplasia maligna de mama
Z85.4 História pessoal de neoplasia maligna de órgãos genitais
Z85.5 História pessoal de neoplasia maligna de trato urinário
Z85.6 História pessoal de leucemia
Z85.7 História pessoal de outras neoplasias malignas do tecido linfático, hematopoético e tecidos
correlatos
Z85.8 História pessoal de neoplasias malignas de outros órgãos ou aparelhos
Z85.9 História pessoal de neoplasia maligna não especificada
Z86.0 História pessoal de outras neoplasias
Z86.1 História pessoal de doenças infecciosas e parasitárias
Z86.2 História pessoal de doenças do sangue e dos órgãos hematopoéticos e alguns transtornos
imunitários
Z86.3 História pessoal de doenças endócrinas, nutricionais e metabólicas
Z86.4 História pessoal de abuso de substâncias psicoativas
Z86.5 História pessoal de outros transtornos mentais e comportamentais
Z86.6 História pessoal de doenças do sistema nervoso e dos órgãos dos sentidos
Z86.7 História pessoal de doenças do aparelho circulatório
Z87.0 História pessoal de doenças do aparelho respiratório
Z87.1 História pessoal de doenças do aparelho digestivo
Z87.2 História pessoal de doenças da pele e tecido subcutâneo
Z87.3 História pessoal de doenças do sistema osteomuscular e tecido conjuntivo
Z87.4 História pessoal de doenças do aparelho geniturinário
Z87.5 História pessoal de complicações da gravidez, parto e puerpério
Z87.6 História pessoal de algumas afecções originadas no período perinatal
Z87.7 História pessoal de malformações e deformidades congênitas e anomalias cromossômicas
Z87.8 História pessoal de outras afecções especificadas
Z88.0 História pessoal de alergia à penicilina
Z88.1 História pessoal de alergia a outro agente antibiótico
Z88.2 História pessoal de alergia às sulfonamidas
Z88.3 História pessoal de alergia a outros agentes antiinfecciosos
Z88.4 História pessoal de alergia a agente anestésico
Z88.5 História pessoal de alergia a agente narcótico
Z88.6 História pessoal de alergia a agente analgésico
Z88.7 História pessoal de alergia a soro e à vacina
Z88.8 História pessoal de alergia a outros drogas, medicamentos e substâncias biológicas
Z88.9 História pessoal de alergia a drogas, medicamentos e substâncias biológicas não especificadas
Z89.0 Ausência adquirida de dedo(s) da mão [inclusive polegar] unilateral
Z89.1 Ausência adquirida de mão e punho
Z89.2 Ausência adquirida de braço acima do punho
Z89.3 Ausência adquirida de ambos membros superiores [qualquer nível]
Z89.4 Ausência adquirida de pé e tornozelo
Z89.5 Ausência adquirida da perna ao nível ou abaixo do joelho
Z89.6 Ausência adquirida da perna acima do joelho
Z89.7 Ausência adquirida de ambos membros inferiores [qualquer nível, exceto somente artelhos]
Z89.8 Ausência adquirida dos membros superiores e inferiores [qualquer nível]
Z89.9 Ausência adquirida de membro não especificado
Z90.0 Ausência adquirida de parte da cabeça e do pescoço
Z90.1 Ausência adquirida da(s) mama(s)
Z90.2 Ausência adquirida [de parte] do pulmão
Z90.3 Ausência adquirida de parte do estômago
Z90.4 Ausência adquirida de outras partes do trato digestivo
Z90.5 Ausência adquirida do rim
Z90.6 Ausência adquirida de outras partes do trato urinário
Z90.7 Ausência adquirida de órgão(s) genital(is)
Z90.8 Ausência adquirida de outros órgãos
Z91.0 História pessoal de alergia exceto a drogas e a substâncias biológicas
Z91.1 História pessoal de não aderência a tratamento ou regime médico
Z91.2 História pessoal de má higiene pessoal
Z91.3 História pessoal de ciclo vigília­sono anormal
Z91.4 História pessoal de trauma psicológico não classificado em outra parte
Z91.5 História pessoal de auto agressão
Z91.6 História pessoal de outros traumas físicos
Z91.8 História pessoal de outros fatores de risco especificados não classificados em outra parte
Z92.0 História pessoal de anticoncepção
Z92.1 História pessoal de uso de longo prazo (atual) de anticoagulantes
Z92.2 História pessoal de uso de longo prazo (atual) de outros medicamentos
Z92.3 História pessoal de irradiação
Z92.4 História pessoal de cirurgia de grande porte não classificada em outra parte
Z92.5 História pessoal de medidas de reabilitação
Z92.8 História pessoal de outros tratamentos médicos
Z92.9 História pessoal de tratamento médico não especificado
Z93.0 Traqueostomia
Z93.1 Gastrostomia
Z93.2 Ileostomia
Z93.3 Colostomia
Z93.4 Outros orifícios artificiais do trato gastrointestinal
Z93.5 Cistostomia
Z93.6 Outros orifícios artificiais do aparelho urinário
Z93.8 Outros orifícios artificiais
Z93.9 Orifício artificial não especificado
Z94.0 Rim transplantado
Z94.1 Coração transplantado
Z94.2 Pulmão transplantado
Z94.3 Coração e pulmões transplantados
Z94.4 Fígado transplantado
Z94.5 Pele transplantada
Z94.6 Osso transplantado
Z94.7 Córnea transplantada
Z94.8 Outros órgãos e tecidos transplantados
Z94.9 Órgão e tecido não especificado transplantado
Z95.0 Presença de marca­passo cardíaco
Z95.1 Presença de enxerto de ponte [bypass] aortocoronária
Z95.2 Presença de prótese de válvula cardíaca
Z95.3 Presença de valva cardíaca xenógena
Z95.4 Presença de outras substituições valvares cardíacas
Z95.5 Presença de implante e enxerto de angioplastia coronária
Z95.8 Presença de outros implantes e enxertos cardíacos e vasculares
Z95.9 Presença de implante e enxerto cardíaco e vascular não especificado
Z96.0 Presença de implantes urogenitais
Z96.1 Presença de lente intra­ocular
Z96.2 Presença de implante otológicos e audiológicos
Z96.3 Presença de laringe artificial
Z96.4 Presença de implantes endócrinos
Z96.5 Presença de raiz dentária e implantes mandibulares
Z96.6 Presença de implantes articulares ortopédicos
Z96.7 Presença de outros implantes de osso e tendão
Z96.8 Presença de outros implantes funcionais especificados
Z96.9 Presença de implante funcional não especificado
Z97.0 Presença de olho artificial
Z97.1 Presença de membro artificial (completo) (parcial)
Z97.2 Presença de dispositivo protético dentário (completo) (parcial)
Z97.3 Presença de óculos e de lentes de contato
Z97.4 Presença de aparelho externo de surdez
Z97.5 Presença de dispositivo anticoncepcional intra­uterino [DIU]
Z97.8 Presença de outros dispositivos especificados
Z98.0 Derivação intestinal ou anastomose intestinal
Z98.1 Artrodese
Z98.2 Presença de dispositivo de drenagem do líquor
Z98.8 Outros estados pós­cirúrgicos especificados
Z99.0 Dependência de aspirador
Z99.1 Dependência de respirador
Z99.2 Dependência de diálise renal
Z99.3 Dependência de cadeira de rodas
 Z99.8 Dependência de outras máquinas e aparelhos capacitantes
 Z99.9 Dependência de máquina e aparelho capacitante não especificado
 `;
 const parseCids = (raw) => {
   const codeRe = /^[A-Z][0-9]{2}(?:\.[0-9])?/;
   const lines = raw.split(/\r?\n/);
   const items = [];
   let current = null;
   for (const lineRaw of lines) {
     const line = String(lineRaw || '').trim();
     if (!line) continue;
     const m = line.match(codeRe);
     if (m && line.startsWith(m[0])) {
       if (current) items.push(current);
       const code = m[0];
       const desc = line.slice(code.length).trim();
       const label = `${code} - ${desc}`;
       current = { value: code, label };
     } else {
       if (current) current.label += ` ${line}`;
     }
   }
   if (current) items.push(current);
   return items;
 };
 export const cids = parseCids(cidsRaw);
 export default cids;
